import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  date: any;
  jsonb: any;
  timestamp: any;
  timestamptz: any;
  vector: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']>;
  _gt?: InputMaybe<Scalars['Float']>;
  _gte?: InputMaybe<Scalars['Float']>;
  _in?: InputMaybe<Array<Scalars['Float']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Float']>;
  _lte?: InputMaybe<Scalars['Float']>;
  _neq?: InputMaybe<Scalars['Float']>;
  _nin?: InputMaybe<Array<Scalars['Float']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "addresses" */
export type Addresses = {
  __typename?: 'addresses';
  addressNetsuite?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  bondedWarehouse?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  /** An array relationship */
  companyAddresses: Array<CompanyAddress>;
  /** An aggregate relationship */
  companyAddresses_aggregate: CompanyAddress_Aggregate;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  excise?: Maybe<Scalars['String']>;
  files?: Maybe<Scalars['jsonb']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  storageCompany?: Maybe<Scalars['String']>;
  street1?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  zipcode?: Maybe<Scalars['String']>;
};


/** columns and relationships of "addresses" */
export type AddressesCompanyAddressesArgs = {
  distinct_on?: InputMaybe<Array<CompanyAddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyAddress_Order_By>>;
  where?: InputMaybe<CompanyAddress_Bool_Exp>;
};


/** columns and relationships of "addresses" */
export type AddressesCompanyAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyAddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyAddress_Order_By>>;
  where?: InputMaybe<CompanyAddress_Bool_Exp>;
};


/** columns and relationships of "addresses" */
export type AddressesFilesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "addresses" */
export type Addresses_Aggregate = {
  __typename?: 'addresses_aggregate';
  aggregate?: Maybe<Addresses_Aggregate_Fields>;
  nodes: Array<Addresses>;
};

/** aggregate fields of "addresses" */
export type Addresses_Aggregate_Fields = {
  __typename?: 'addresses_aggregate_fields';
  avg?: Maybe<Addresses_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Addresses_Max_Fields>;
  min?: Maybe<Addresses_Min_Fields>;
  stddev?: Maybe<Addresses_Stddev_Fields>;
  stddev_pop?: Maybe<Addresses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Addresses_Stddev_Samp_Fields>;
  sum?: Maybe<Addresses_Sum_Fields>;
  var_pop?: Maybe<Addresses_Var_Pop_Fields>;
  var_samp?: Maybe<Addresses_Var_Samp_Fields>;
  variance?: Maybe<Addresses_Variance_Fields>;
};


/** aggregate fields of "addresses" */
export type Addresses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Addresses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Addresses_Append_Input = {
  files?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Addresses_Avg_Fields = {
  __typename?: 'addresses_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "addresses". All fields are combined with a logical 'AND'. */
export type Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<Addresses_Bool_Exp>>;
  _not?: InputMaybe<Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<Addresses_Bool_Exp>>;
  addressNetsuite?: InputMaybe<String_Comparison_Exp>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  bondedWarehouse?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  companyAddresses?: InputMaybe<CompanyAddress_Bool_Exp>;
  companyAddresses_aggregate?: InputMaybe<CompanyAddress_Aggregate_Bool_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  excise?: InputMaybe<String_Comparison_Exp>;
  files?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  storageCompany?: InputMaybe<String_Comparison_Exp>;
  street1?: InputMaybe<String_Comparison_Exp>;
  street2?: InputMaybe<String_Comparison_Exp>;
  streetNumber?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "addresses" */
export enum Addresses_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressesPkey = 'addresses_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Addresses_Delete_At_Path_Input = {
  files?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Addresses_Delete_Elem_Input = {
  files?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Addresses_Delete_Key_Input = {
  files?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "addresses" */
export type Addresses_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "addresses" */
export type Addresses_Insert_Input = {
  addressNetsuite?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  bondedWarehouse?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  companyAddresses?: InputMaybe<CompanyAddress_Arr_Rel_Insert_Input>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  excise?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  storageCompany?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Addresses_Max_Fields = {
  __typename?: 'addresses_max_fields';
  addressNetsuite?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  bondedWarehouse?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  excise?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  storageCompany?: Maybe<Scalars['String']>;
  street1?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Addresses_Min_Fields = {
  __typename?: 'addresses_min_fields';
  addressNetsuite?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  bondedWarehouse?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  excise?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  storageCompany?: Maybe<Scalars['String']>;
  street1?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "addresses" */
export type Addresses_Mutation_Response = {
  __typename?: 'addresses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Addresses>;
};

/** input type for inserting object relation for remote table "addresses" */
export type Addresses_Obj_Rel_Insert_Input = {
  data: Addresses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Addresses_On_Conflict>;
};

/** on_conflict condition type for table "addresses" */
export type Addresses_On_Conflict = {
  constraint: Addresses_Constraint;
  update_columns?: Array<Addresses_Update_Column>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};

/** Ordering options when selecting data from "addresses". */
export type Addresses_Order_By = {
  addressNetsuite?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  bondedWarehouse?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  companyAddresses_aggregate?: InputMaybe<CompanyAddress_Aggregate_Order_By>;
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  excise?: InputMaybe<Order_By>;
  files?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  storageCompany?: InputMaybe<Order_By>;
  street1?: InputMaybe<Order_By>;
  street2?: InputMaybe<Order_By>;
  streetNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: addresses */
export type Addresses_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Addresses_Prepend_Input = {
  files?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "addresses" */
export enum Addresses_Select_Column {
  /** column name */
  AddressNetsuite = 'addressNetsuite',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BondedWarehouse = 'bondedWarehouse',
  /** column name */
  City = 'city',
  /** column name */
  Comments = 'comments',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Excise = 'excise',
  /** column name */
  Files = 'files',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  StorageCompany = 'storageCompany',
  /** column name */
  Street1 = 'street1',
  /** column name */
  Street2 = 'street2',
  /** column name */
  StreetNumber = 'streetNumber',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Zipcode = 'zipcode'
}

/** input type for updating data in table "addresses" */
export type Addresses_Set_Input = {
  addressNetsuite?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  bondedWarehouse?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  excise?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  storageCompany?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Addresses_Stddev_Fields = {
  __typename?: 'addresses_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Addresses_Stddev_Pop_Fields = {
  __typename?: 'addresses_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Addresses_Stddev_Samp_Fields = {
  __typename?: 'addresses_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "addresses" */
export type Addresses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Addresses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Addresses_Stream_Cursor_Value_Input = {
  addressNetsuite?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  bondedWarehouse?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  excise?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  storageCompany?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Addresses_Sum_Fields = {
  __typename?: 'addresses_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "addresses" */
export enum Addresses_Update_Column {
  /** column name */
  AddressNetsuite = 'addressNetsuite',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BondedWarehouse = 'bondedWarehouse',
  /** column name */
  City = 'city',
  /** column name */
  Comments = 'comments',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Excise = 'excise',
  /** column name */
  Files = 'files',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  StorageCompany = 'storageCompany',
  /** column name */
  Street1 = 'street1',
  /** column name */
  Street2 = 'street2',
  /** column name */
  StreetNumber = 'streetNumber',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Zipcode = 'zipcode'
}

export type Addresses_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Addresses_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Addresses_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Addresses_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Addresses_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Addresses_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Addresses_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Addresses_Set_Input>;
  where: Addresses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Addresses_Var_Pop_Fields = {
  __typename?: 'addresses_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Addresses_Var_Samp_Fields = {
  __typename?: 'addresses_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Addresses_Variance_Fields = {
  __typename?: 'addresses_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "addresses_without_company" */
export type Addresses_Without_Company = {
  __typename?: 'addresses_without_company';
  addressNetsuite?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  bondedWarehouse?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  excise?: Maybe<Scalars['String']>;
  files?: Maybe<Scalars['jsonb']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  storageCompany?: Maybe<Scalars['String']>;
  street1?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  zipcode?: Maybe<Scalars['String']>;
};


/** columns and relationships of "addresses_without_company" */
export type Addresses_Without_CompanyFilesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "addresses_without_company" */
export type Addresses_Without_Company_Aggregate = {
  __typename?: 'addresses_without_company_aggregate';
  aggregate?: Maybe<Addresses_Without_Company_Aggregate_Fields>;
  nodes: Array<Addresses_Without_Company>;
};

/** aggregate fields of "addresses_without_company" */
export type Addresses_Without_Company_Aggregate_Fields = {
  __typename?: 'addresses_without_company_aggregate_fields';
  avg?: Maybe<Addresses_Without_Company_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Addresses_Without_Company_Max_Fields>;
  min?: Maybe<Addresses_Without_Company_Min_Fields>;
  stddev?: Maybe<Addresses_Without_Company_Stddev_Fields>;
  stddev_pop?: Maybe<Addresses_Without_Company_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Addresses_Without_Company_Stddev_Samp_Fields>;
  sum?: Maybe<Addresses_Without_Company_Sum_Fields>;
  var_pop?: Maybe<Addresses_Without_Company_Var_Pop_Fields>;
  var_samp?: Maybe<Addresses_Without_Company_Var_Samp_Fields>;
  variance?: Maybe<Addresses_Without_Company_Variance_Fields>;
};


/** aggregate fields of "addresses_without_company" */
export type Addresses_Without_Company_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Addresses_Without_Company_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Addresses_Without_Company_Avg_Fields = {
  __typename?: 'addresses_without_company_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "addresses_without_company". All fields are combined with a logical 'AND'. */
export type Addresses_Without_Company_Bool_Exp = {
  _and?: InputMaybe<Array<Addresses_Without_Company_Bool_Exp>>;
  _not?: InputMaybe<Addresses_Without_Company_Bool_Exp>;
  _or?: InputMaybe<Array<Addresses_Without_Company_Bool_Exp>>;
  addressNetsuite?: InputMaybe<String_Comparison_Exp>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  bondedWarehouse?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  excise?: InputMaybe<String_Comparison_Exp>;
  files?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  storageCompany?: InputMaybe<String_Comparison_Exp>;
  street1?: InputMaybe<String_Comparison_Exp>;
  street2?: InputMaybe<String_Comparison_Exp>;
  streetNumber?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  zipcode?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Addresses_Without_Company_Max_Fields = {
  __typename?: 'addresses_without_company_max_fields';
  addressNetsuite?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  bondedWarehouse?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  excise?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  storageCompany?: Maybe<Scalars['String']>;
  street1?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Addresses_Without_Company_Min_Fields = {
  __typename?: 'addresses_without_company_min_fields';
  addressNetsuite?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  bondedWarehouse?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  excise?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  storageCompany?: Maybe<Scalars['String']>;
  street1?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  zipcode?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "addresses_without_company". */
export type Addresses_Without_Company_Order_By = {
  addressNetsuite?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  bondedWarehouse?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  excise?: InputMaybe<Order_By>;
  files?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  storageCompany?: InputMaybe<Order_By>;
  street1?: InputMaybe<Order_By>;
  street2?: InputMaybe<Order_By>;
  streetNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  zipcode?: InputMaybe<Order_By>;
};

/** select columns of table "addresses_without_company" */
export enum Addresses_Without_Company_Select_Column {
  /** column name */
  AddressNetsuite = 'addressNetsuite',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BondedWarehouse = 'bondedWarehouse',
  /** column name */
  City = 'city',
  /** column name */
  Comments = 'comments',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Excise = 'excise',
  /** column name */
  Files = 'files',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  State = 'state',
  /** column name */
  StorageCompany = 'storageCompany',
  /** column name */
  Street1 = 'street1',
  /** column name */
  Street2 = 'street2',
  /** column name */
  StreetNumber = 'streetNumber',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Zipcode = 'zipcode'
}

/** aggregate stddev on columns */
export type Addresses_Without_Company_Stddev_Fields = {
  __typename?: 'addresses_without_company_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Addresses_Without_Company_Stddev_Pop_Fields = {
  __typename?: 'addresses_without_company_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Addresses_Without_Company_Stddev_Samp_Fields = {
  __typename?: 'addresses_without_company_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "addresses_without_company" */
export type Addresses_Without_Company_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Addresses_Without_Company_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Addresses_Without_Company_Stream_Cursor_Value_Input = {
  addressNetsuite?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  bondedWarehouse?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  excise?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  storageCompany?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  streetNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Addresses_Without_Company_Sum_Fields = {
  __typename?: 'addresses_without_company_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Addresses_Without_Company_Var_Pop_Fields = {
  __typename?: 'addresses_without_company_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Addresses_Without_Company_Var_Samp_Fields = {
  __typename?: 'addresses_without_company_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Addresses_Without_Company_Variance_Fields = {
  __typename?: 'addresses_without_company_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "agreementTerms" */
export type AgreementTerms = {
  __typename?: 'agreementTerms';
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  title: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "agreementTerms" */
export type AgreementTerms_Aggregate = {
  __typename?: 'agreementTerms_aggregate';
  aggregate?: Maybe<AgreementTerms_Aggregate_Fields>;
  nodes: Array<AgreementTerms>;
};

/** aggregate fields of "agreementTerms" */
export type AgreementTerms_Aggregate_Fields = {
  __typename?: 'agreementTerms_aggregate_fields';
  avg?: Maybe<AgreementTerms_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AgreementTerms_Max_Fields>;
  min?: Maybe<AgreementTerms_Min_Fields>;
  stddev?: Maybe<AgreementTerms_Stddev_Fields>;
  stddev_pop?: Maybe<AgreementTerms_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AgreementTerms_Stddev_Samp_Fields>;
  sum?: Maybe<AgreementTerms_Sum_Fields>;
  var_pop?: Maybe<AgreementTerms_Var_Pop_Fields>;
  var_samp?: Maybe<AgreementTerms_Var_Samp_Fields>;
  variance?: Maybe<AgreementTerms_Variance_Fields>;
};


/** aggregate fields of "agreementTerms" */
export type AgreementTerms_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AgreementTerms_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AgreementTerms_Avg_Fields = {
  __typename?: 'agreementTerms_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "agreementTerms". All fields are combined with a logical 'AND'. */
export type AgreementTerms_Bool_Exp = {
  _and?: InputMaybe<Array<AgreementTerms_Bool_Exp>>;
  _not?: InputMaybe<AgreementTerms_Bool_Exp>;
  _or?: InputMaybe<Array<AgreementTerms_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "agreementTerms" */
export enum AgreementTerms_Constraint {
  /** unique or primary key constraint on columns "id" */
  AgreementTermsPkey = 'agreementTerms_pkey'
}

/** input type for incrementing numeric columns in table "agreementTerms" */
export type AgreementTerms_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "agreementTerms" */
export type AgreementTerms_Insert_Input = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type AgreementTerms_Max_Fields = {
  __typename?: 'agreementTerms_max_fields';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type AgreementTerms_Min_Fields = {
  __typename?: 'agreementTerms_min_fields';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "agreementTerms" */
export type AgreementTerms_Mutation_Response = {
  __typename?: 'agreementTerms_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AgreementTerms>;
};

/** on_conflict condition type for table "agreementTerms" */
export type AgreementTerms_On_Conflict = {
  constraint: AgreementTerms_Constraint;
  update_columns?: Array<AgreementTerms_Update_Column>;
  where?: InputMaybe<AgreementTerms_Bool_Exp>;
};

/** Ordering options when selecting data from "agreementTerms". */
export type AgreementTerms_Order_By = {
  content?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agreementTerms */
export type AgreementTerms_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "agreementTerms" */
export enum AgreementTerms_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "agreementTerms" */
export type AgreementTerms_Set_Input = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type AgreementTerms_Stddev_Fields = {
  __typename?: 'agreementTerms_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AgreementTerms_Stddev_Pop_Fields = {
  __typename?: 'agreementTerms_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AgreementTerms_Stddev_Samp_Fields = {
  __typename?: 'agreementTerms_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "agreementTerms" */
export type AgreementTerms_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AgreementTerms_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AgreementTerms_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type AgreementTerms_Sum_Fields = {
  __typename?: 'agreementTerms_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "agreementTerms" */
export enum AgreementTerms_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type AgreementTerms_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AgreementTerms_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AgreementTerms_Set_Input>;
  where: AgreementTerms_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AgreementTerms_Var_Pop_Fields = {
  __typename?: 'agreementTerms_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AgreementTerms_Var_Samp_Fields = {
  __typename?: 'agreementTerms_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AgreementTerms_Variance_Fields = {
  __typename?: 'agreementTerms_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "agreements" */
export type Agreements = {
  __typename?: 'agreements';
  additionalInformations?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  buyerBillingAddress?: Maybe<Addresses>;
  buyerBillingAddressId?: Maybe<Scalars['Int']>;
  buyerBondedWarehouse?: Maybe<Scalars['String']>;
  buyerCiattiCommission?: Maybe<Scalars['Float']>;
  /** An object relationship */
  buyerCompany?: Maybe<Companies>;
  buyerCompanyId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  buyerContact?: Maybe<Contacts>;
  buyerContactId?: Maybe<Scalars['Int']>;
  buyerContractRef?: Maybe<Scalars['String']>;
  buyerCvi?: Maybe<Scalars['String']>;
  /** An object relationship */
  buyerDeliveryAddress?: Maybe<Addresses>;
  buyerDeliveryAddressId?: Maybe<Scalars['Int']>;
  buyerEori?: Maybe<Scalars['String']>;
  buyerExcise?: Maybe<Scalars['String']>;
  buyerFda?: Maybe<Scalars['String']>;
  /** An object relationship */
  buyerOffice?: Maybe<Offices>;
  buyerOfficeId?: Maybe<Scalars['Int']>;
  buyerSpecsId?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  buyerUser?: Maybe<Users>;
  buyerUserId?: Maybe<Scalars['String']>;
  buyerUserName?: Maybe<Scalars['String']>;
  buyerVat?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  commisionFees?: Maybe<Scalars['Float']>;
  commissionBuyer?: Maybe<Scalars['Float']>;
  commissionCostBase?: Maybe<Scalars['Float']>;
  commissionCurrency?: Maybe<Scalars['String']>;
  commissionFeesPerUom?: Maybe<Scalars['Float']>;
  commissionFlatFees?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  commissionQuantityBase?: Maybe<Scalars['Float']>;
  commissionSeller?: Maybe<Scalars['Float']>;
  commissionThirdParty?: Maybe<Scalars['Float']>;
  commissionTotalFees?: Maybe<Scalars['Float']>;
  commissionType?: Maybe<Scalars['String']>;
  commissionUom?: Maybe<Scalars['String']>;
  commodityType: Scalars['String'];
  /** An object relationship */
  contractOffice?: Maybe<Offices>;
  contractOfficeId?: Maybe<Scalars['Int']>;
  contractRevision?: Maybe<Scalars['String']>;
  contractStatus?: Maybe<Scalars['String']>;
  /** An object relationship */
  contractUser?: Maybe<Users>;
  contractUserId?: Maybe<Scalars['String']>;
  costArray?: Maybe<Scalars['jsonb']>;
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endDate?: Maybe<Scalars['date']>;
  evergreenAgreementId?: Maybe<Scalars['Int']>;
  evergreenContract?: Maybe<Scalars['Boolean']>;
  evergreenDates?: Maybe<Scalars['jsonb']>;
  files?: Maybe<Scalars['jsonb']>;
  fulfillmentsStatus?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  incoterms?: Maybe<Scalars['String']>;
  /** An array relationship */
  invoices: Array<Invoices>;
  invoicesStatus?: Maybe<Scalars['String']>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  isMultiYearContract?: Maybe<Scalars['Boolean']>;
  itemsId: Scalars['jsonb'];
  legacyContractStatus?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  quantityOrdered?: Maybe<Scalars['Float']>;
  quantityShipped?: Maybe<Scalars['Float']>;
  reminders?: Maybe<Scalars['jsonb']>;
  salesOrderNetsuite?: Maybe<Scalars['String']>;
  /** An object relationship */
  sellerBillingAddress?: Maybe<Addresses>;
  sellerBillingAddressId?: Maybe<Scalars['Int']>;
  sellerBondedWarehouse?: Maybe<Scalars['String']>;
  sellerCiattiCommission?: Maybe<Scalars['Float']>;
  /** An object relationship */
  sellerCompany?: Maybe<Companies>;
  sellerCompanyId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  sellerContact?: Maybe<Contacts>;
  sellerContactId?: Maybe<Scalars['Int']>;
  sellerContractRef?: Maybe<Scalars['String']>;
  sellerCvi?: Maybe<Scalars['String']>;
  /** An object relationship */
  sellerDeliveryAddress?: Maybe<Addresses>;
  sellerDeliveryAddressId?: Maybe<Scalars['Int']>;
  sellerEori?: Maybe<Scalars['String']>;
  sellerExcise?: Maybe<Scalars['String']>;
  sellerFda?: Maybe<Scalars['String']>;
  /** An object relationship */
  sellerOffice?: Maybe<Offices>;
  sellerOfficeId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  sellerUser?: Maybe<Users>;
  sellerUserId?: Maybe<Scalars['String']>;
  sellerUserName?: Maybe<Scalars['String']>;
  sellerVat?: Maybe<Scalars['String']>;
  /** An array relationship */
  shipmentFulfillments: Array<ShipmentFulfillments>;
  /** An aggregate relationship */
  shipmentFulfillments_aggregate: ShipmentFulfillments_Aggregate;
  signaturesRequired?: Maybe<Scalars['jsonb']>;
  startDate?: Maybe<Scalars['date']>;
  terms?: Maybe<Scalars['String']>;
  termsAddContract?: Maybe<Scalars['String']>;
  termsAddContractViewer?: Maybe<Scalars['jsonb']>;
  termsCommission?: Maybe<Scalars['String']>;
  termsCommissionViewer?: Maybe<Scalars['jsonb']>;
  termsPayment?: Maybe<Scalars['String']>;
  termsPaymentViewer?: Maybe<Scalars['jsonb']>;
  termsShipping?: Maybe<Scalars['String']>;
  termsShippingViewer?: Maybe<Scalars['jsonb']>;
  termsViewer?: Maybe<Scalars['jsonb']>;
  thirdPartyCommission?: Maybe<Scalars['Float']>;
  /** An object relationship */
  thirdPartyCompany?: Maybe<Companies>;
  thirdPartyCompanyId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  thirdPartyContact?: Maybe<Contacts>;
  thirdPartyContactId?: Maybe<Scalars['Int']>;
  thirdPartyContractRef?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['timestamptz'];
  usdaGcr?: Maybe<Scalars['Boolean']>;
};


/** columns and relationships of "agreements" */
export type AgreementsBuyerSpecsIdArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "agreements" */
export type AgreementsCostArrayArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "agreements" */
export type AgreementsEvergreenDatesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "agreements" */
export type AgreementsFilesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "agreements" */
export type AgreementsInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "agreements" */
export type AgreementsInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "agreements" */
export type AgreementsItemsIdArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "agreements" */
export type AgreementsRemindersArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "agreements" */
export type AgreementsShipmentFulfillmentsArgs = {
  distinct_on?: InputMaybe<Array<ShipmentFulfillments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShipmentFulfillments_Order_By>>;
  where?: InputMaybe<ShipmentFulfillments_Bool_Exp>;
};


/** columns and relationships of "agreements" */
export type AgreementsShipmentFulfillments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ShipmentFulfillments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShipmentFulfillments_Order_By>>;
  where?: InputMaybe<ShipmentFulfillments_Bool_Exp>;
};


/** columns and relationships of "agreements" */
export type AgreementsSignaturesRequiredArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "agreements" */
export type AgreementsTermsAddContractViewerArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "agreements" */
export type AgreementsTermsCommissionViewerArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "agreements" */
export type AgreementsTermsPaymentViewerArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "agreements" */
export type AgreementsTermsShippingViewerArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "agreements" */
export type AgreementsTermsViewerArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "agreements" */
export type Agreements_Aggregate = {
  __typename?: 'agreements_aggregate';
  aggregate?: Maybe<Agreements_Aggregate_Fields>;
  nodes: Array<Agreements>;
};

export type Agreements_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Agreements_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Agreements_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Agreements_Aggregate_Bool_Exp_Count>;
};

export type Agreements_Aggregate_Bool_Exp_Bool_And = {
  arguments: Agreements_Select_Column_Agreements_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Agreements_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Agreements_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Agreements_Select_Column_Agreements_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Agreements_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Agreements_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Agreements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Agreements_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "agreements" */
export type Agreements_Aggregate_Fields = {
  __typename?: 'agreements_aggregate_fields';
  avg?: Maybe<Agreements_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Agreements_Max_Fields>;
  min?: Maybe<Agreements_Min_Fields>;
  stddev?: Maybe<Agreements_Stddev_Fields>;
  stddev_pop?: Maybe<Agreements_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agreements_Stddev_Samp_Fields>;
  sum?: Maybe<Agreements_Sum_Fields>;
  var_pop?: Maybe<Agreements_Var_Pop_Fields>;
  var_samp?: Maybe<Agreements_Var_Samp_Fields>;
  variance?: Maybe<Agreements_Variance_Fields>;
};


/** aggregate fields of "agreements" */
export type Agreements_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agreements_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "agreements" */
export type Agreements_Aggregate_Order_By = {
  avg?: InputMaybe<Agreements_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Agreements_Max_Order_By>;
  min?: InputMaybe<Agreements_Min_Order_By>;
  stddev?: InputMaybe<Agreements_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Agreements_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Agreements_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Agreements_Sum_Order_By>;
  var_pop?: InputMaybe<Agreements_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Agreements_Var_Samp_Order_By>;
  variance?: InputMaybe<Agreements_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Agreements_Append_Input = {
  buyerSpecsId?: InputMaybe<Scalars['jsonb']>;
  costArray?: InputMaybe<Scalars['jsonb']>;
  evergreenDates?: InputMaybe<Scalars['jsonb']>;
  files?: InputMaybe<Scalars['jsonb']>;
  itemsId?: InputMaybe<Scalars['jsonb']>;
  reminders?: InputMaybe<Scalars['jsonb']>;
  signaturesRequired?: InputMaybe<Scalars['jsonb']>;
  termsAddContractViewer?: InputMaybe<Scalars['jsonb']>;
  termsCommissionViewer?: InputMaybe<Scalars['jsonb']>;
  termsPaymentViewer?: InputMaybe<Scalars['jsonb']>;
  termsShippingViewer?: InputMaybe<Scalars['jsonb']>;
  termsViewer?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "agreements" */
export type Agreements_Arr_Rel_Insert_Input = {
  data: Array<Agreements_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Agreements_On_Conflict>;
};

/** aggregate avg on columns */
export type Agreements_Avg_Fields = {
  __typename?: 'agreements_avg_fields';
  buyerBillingAddressId?: Maybe<Scalars['Float']>;
  buyerCiattiCommission?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Float']>;
  buyerContactId?: Maybe<Scalars['Float']>;
  buyerDeliveryAddressId?: Maybe<Scalars['Float']>;
  buyerOfficeId?: Maybe<Scalars['Float']>;
  commisionFees?: Maybe<Scalars['Float']>;
  commissionBuyer?: Maybe<Scalars['Float']>;
  commissionCostBase?: Maybe<Scalars['Float']>;
  commissionFeesPerUom?: Maybe<Scalars['Float']>;
  commissionFlatFees?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  commissionQuantityBase?: Maybe<Scalars['Float']>;
  commissionSeller?: Maybe<Scalars['Float']>;
  commissionThirdParty?: Maybe<Scalars['Float']>;
  commissionTotalFees?: Maybe<Scalars['Float']>;
  contractOfficeId?: Maybe<Scalars['Float']>;
  evergreenAgreementId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  quantityOrdered?: Maybe<Scalars['Float']>;
  quantityShipped?: Maybe<Scalars['Float']>;
  sellerBillingAddressId?: Maybe<Scalars['Float']>;
  sellerCiattiCommission?: Maybe<Scalars['Float']>;
  sellerCompanyId?: Maybe<Scalars['Float']>;
  sellerContactId?: Maybe<Scalars['Float']>;
  sellerDeliveryAddressId?: Maybe<Scalars['Float']>;
  sellerOfficeId?: Maybe<Scalars['Float']>;
  thirdPartyCommission?: Maybe<Scalars['Float']>;
  thirdPartyCompanyId?: Maybe<Scalars['Float']>;
  thirdPartyContactId?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "agreements" */
export type Agreements_Avg_Order_By = {
  buyerBillingAddressId?: InputMaybe<Order_By>;
  buyerCiattiCommission?: InputMaybe<Order_By>;
  buyerCompanyId?: InputMaybe<Order_By>;
  buyerContactId?: InputMaybe<Order_By>;
  buyerDeliveryAddressId?: InputMaybe<Order_By>;
  buyerOfficeId?: InputMaybe<Order_By>;
  commisionFees?: InputMaybe<Order_By>;
  commissionBuyer?: InputMaybe<Order_By>;
  commissionCostBase?: InputMaybe<Order_By>;
  commissionFeesPerUom?: InputMaybe<Order_By>;
  commissionFlatFees?: InputMaybe<Order_By>;
  commissionPercentage?: InputMaybe<Order_By>;
  commissionQuantityBase?: InputMaybe<Order_By>;
  commissionSeller?: InputMaybe<Order_By>;
  commissionThirdParty?: InputMaybe<Order_By>;
  commissionTotalFees?: InputMaybe<Order_By>;
  contractOfficeId?: InputMaybe<Order_By>;
  evergreenAgreementId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantityOrdered?: InputMaybe<Order_By>;
  quantityShipped?: InputMaybe<Order_By>;
  sellerBillingAddressId?: InputMaybe<Order_By>;
  sellerCiattiCommission?: InputMaybe<Order_By>;
  sellerCompanyId?: InputMaybe<Order_By>;
  sellerContactId?: InputMaybe<Order_By>;
  sellerDeliveryAddressId?: InputMaybe<Order_By>;
  sellerOfficeId?: InputMaybe<Order_By>;
  thirdPartyCommission?: InputMaybe<Order_By>;
  thirdPartyCompanyId?: InputMaybe<Order_By>;
  thirdPartyContactId?: InputMaybe<Order_By>;
  totalCost?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "agreements". All fields are combined with a logical 'AND'. */
export type Agreements_Bool_Exp = {
  _and?: InputMaybe<Array<Agreements_Bool_Exp>>;
  _not?: InputMaybe<Agreements_Bool_Exp>;
  _or?: InputMaybe<Array<Agreements_Bool_Exp>>;
  additionalInformations?: InputMaybe<String_Comparison_Exp>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  buyerBillingAddress?: InputMaybe<Addresses_Bool_Exp>;
  buyerBillingAddressId?: InputMaybe<Int_Comparison_Exp>;
  buyerBondedWarehouse?: InputMaybe<String_Comparison_Exp>;
  buyerCiattiCommission?: InputMaybe<Float_Comparison_Exp>;
  buyerCompany?: InputMaybe<Companies_Bool_Exp>;
  buyerCompanyId?: InputMaybe<Int_Comparison_Exp>;
  buyerContact?: InputMaybe<Contacts_Bool_Exp>;
  buyerContactId?: InputMaybe<Int_Comparison_Exp>;
  buyerContractRef?: InputMaybe<String_Comparison_Exp>;
  buyerCvi?: InputMaybe<String_Comparison_Exp>;
  buyerDeliveryAddress?: InputMaybe<Addresses_Bool_Exp>;
  buyerDeliveryAddressId?: InputMaybe<Int_Comparison_Exp>;
  buyerEori?: InputMaybe<String_Comparison_Exp>;
  buyerExcise?: InputMaybe<String_Comparison_Exp>;
  buyerFda?: InputMaybe<String_Comparison_Exp>;
  buyerOffice?: InputMaybe<Offices_Bool_Exp>;
  buyerOfficeId?: InputMaybe<Int_Comparison_Exp>;
  buyerSpecsId?: InputMaybe<Jsonb_Comparison_Exp>;
  buyerUser?: InputMaybe<Users_Bool_Exp>;
  buyerUserId?: InputMaybe<String_Comparison_Exp>;
  buyerUserName?: InputMaybe<String_Comparison_Exp>;
  buyerVat?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  commisionFees?: InputMaybe<Float_Comparison_Exp>;
  commissionBuyer?: InputMaybe<Float_Comparison_Exp>;
  commissionCostBase?: InputMaybe<Float_Comparison_Exp>;
  commissionCurrency?: InputMaybe<String_Comparison_Exp>;
  commissionFeesPerUom?: InputMaybe<Float_Comparison_Exp>;
  commissionFlatFees?: InputMaybe<Float_Comparison_Exp>;
  commissionPercentage?: InputMaybe<Float_Comparison_Exp>;
  commissionQuantityBase?: InputMaybe<Float_Comparison_Exp>;
  commissionSeller?: InputMaybe<Float_Comparison_Exp>;
  commissionThirdParty?: InputMaybe<Float_Comparison_Exp>;
  commissionTotalFees?: InputMaybe<Float_Comparison_Exp>;
  commissionType?: InputMaybe<String_Comparison_Exp>;
  commissionUom?: InputMaybe<String_Comparison_Exp>;
  commodityType?: InputMaybe<String_Comparison_Exp>;
  contractOffice?: InputMaybe<Offices_Bool_Exp>;
  contractOfficeId?: InputMaybe<Int_Comparison_Exp>;
  contractRevision?: InputMaybe<String_Comparison_Exp>;
  contractStatus?: InputMaybe<String_Comparison_Exp>;
  contractUser?: InputMaybe<Users_Bool_Exp>;
  contractUserId?: InputMaybe<String_Comparison_Exp>;
  costArray?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  endDate?: InputMaybe<Date_Comparison_Exp>;
  evergreenAgreementId?: InputMaybe<Int_Comparison_Exp>;
  evergreenContract?: InputMaybe<Boolean_Comparison_Exp>;
  evergreenDates?: InputMaybe<Jsonb_Comparison_Exp>;
  files?: InputMaybe<Jsonb_Comparison_Exp>;
  fulfillmentsStatus?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  incoterms?: InputMaybe<String_Comparison_Exp>;
  invoices?: InputMaybe<Invoices_Bool_Exp>;
  invoicesStatus?: InputMaybe<String_Comparison_Exp>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Bool_Exp>;
  isMultiYearContract?: InputMaybe<Boolean_Comparison_Exp>;
  itemsId?: InputMaybe<Jsonb_Comparison_Exp>;
  legacyContractStatus?: InputMaybe<String_Comparison_Exp>;
  place?: InputMaybe<String_Comparison_Exp>;
  quantityOrdered?: InputMaybe<Float_Comparison_Exp>;
  quantityShipped?: InputMaybe<Float_Comparison_Exp>;
  reminders?: InputMaybe<Jsonb_Comparison_Exp>;
  salesOrderNetsuite?: InputMaybe<String_Comparison_Exp>;
  sellerBillingAddress?: InputMaybe<Addresses_Bool_Exp>;
  sellerBillingAddressId?: InputMaybe<Int_Comparison_Exp>;
  sellerBondedWarehouse?: InputMaybe<String_Comparison_Exp>;
  sellerCiattiCommission?: InputMaybe<Float_Comparison_Exp>;
  sellerCompany?: InputMaybe<Companies_Bool_Exp>;
  sellerCompanyId?: InputMaybe<Int_Comparison_Exp>;
  sellerContact?: InputMaybe<Contacts_Bool_Exp>;
  sellerContactId?: InputMaybe<Int_Comparison_Exp>;
  sellerContractRef?: InputMaybe<String_Comparison_Exp>;
  sellerCvi?: InputMaybe<String_Comparison_Exp>;
  sellerDeliveryAddress?: InputMaybe<Addresses_Bool_Exp>;
  sellerDeliveryAddressId?: InputMaybe<Int_Comparison_Exp>;
  sellerEori?: InputMaybe<String_Comparison_Exp>;
  sellerExcise?: InputMaybe<String_Comparison_Exp>;
  sellerFda?: InputMaybe<String_Comparison_Exp>;
  sellerOffice?: InputMaybe<Offices_Bool_Exp>;
  sellerOfficeId?: InputMaybe<Int_Comparison_Exp>;
  sellerUser?: InputMaybe<Users_Bool_Exp>;
  sellerUserId?: InputMaybe<String_Comparison_Exp>;
  sellerUserName?: InputMaybe<String_Comparison_Exp>;
  sellerVat?: InputMaybe<String_Comparison_Exp>;
  shipmentFulfillments?: InputMaybe<ShipmentFulfillments_Bool_Exp>;
  shipmentFulfillments_aggregate?: InputMaybe<ShipmentFulfillments_Aggregate_Bool_Exp>;
  signaturesRequired?: InputMaybe<Jsonb_Comparison_Exp>;
  startDate?: InputMaybe<Date_Comparison_Exp>;
  terms?: InputMaybe<String_Comparison_Exp>;
  termsAddContract?: InputMaybe<String_Comparison_Exp>;
  termsAddContractViewer?: InputMaybe<Jsonb_Comparison_Exp>;
  termsCommission?: InputMaybe<String_Comparison_Exp>;
  termsCommissionViewer?: InputMaybe<Jsonb_Comparison_Exp>;
  termsPayment?: InputMaybe<String_Comparison_Exp>;
  termsPaymentViewer?: InputMaybe<Jsonb_Comparison_Exp>;
  termsShipping?: InputMaybe<String_Comparison_Exp>;
  termsShippingViewer?: InputMaybe<Jsonb_Comparison_Exp>;
  termsViewer?: InputMaybe<Jsonb_Comparison_Exp>;
  thirdPartyCommission?: InputMaybe<Float_Comparison_Exp>;
  thirdPartyCompany?: InputMaybe<Companies_Bool_Exp>;
  thirdPartyCompanyId?: InputMaybe<Int_Comparison_Exp>;
  thirdPartyContact?: InputMaybe<Contacts_Bool_Exp>;
  thirdPartyContactId?: InputMaybe<Int_Comparison_Exp>;
  thirdPartyContractRef?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  totalCost?: InputMaybe<Float_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  usdaGcr?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "agreements" */
export enum Agreements_Constraint {
  /** unique or primary key constraint on columns "id" */
  AgreementsPkey = 'agreements_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Agreements_Delete_At_Path_Input = {
  buyerSpecsId?: InputMaybe<Array<Scalars['String']>>;
  costArray?: InputMaybe<Array<Scalars['String']>>;
  evergreenDates?: InputMaybe<Array<Scalars['String']>>;
  files?: InputMaybe<Array<Scalars['String']>>;
  itemsId?: InputMaybe<Array<Scalars['String']>>;
  reminders?: InputMaybe<Array<Scalars['String']>>;
  signaturesRequired?: InputMaybe<Array<Scalars['String']>>;
  termsAddContractViewer?: InputMaybe<Array<Scalars['String']>>;
  termsCommissionViewer?: InputMaybe<Array<Scalars['String']>>;
  termsPaymentViewer?: InputMaybe<Array<Scalars['String']>>;
  termsShippingViewer?: InputMaybe<Array<Scalars['String']>>;
  termsViewer?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Agreements_Delete_Elem_Input = {
  buyerSpecsId?: InputMaybe<Scalars['Int']>;
  costArray?: InputMaybe<Scalars['Int']>;
  evergreenDates?: InputMaybe<Scalars['Int']>;
  files?: InputMaybe<Scalars['Int']>;
  itemsId?: InputMaybe<Scalars['Int']>;
  reminders?: InputMaybe<Scalars['Int']>;
  signaturesRequired?: InputMaybe<Scalars['Int']>;
  termsAddContractViewer?: InputMaybe<Scalars['Int']>;
  termsCommissionViewer?: InputMaybe<Scalars['Int']>;
  termsPaymentViewer?: InputMaybe<Scalars['Int']>;
  termsShippingViewer?: InputMaybe<Scalars['Int']>;
  termsViewer?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Agreements_Delete_Key_Input = {
  buyerSpecsId?: InputMaybe<Scalars['String']>;
  costArray?: InputMaybe<Scalars['String']>;
  evergreenDates?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['String']>;
  itemsId?: InputMaybe<Scalars['String']>;
  reminders?: InputMaybe<Scalars['String']>;
  signaturesRequired?: InputMaybe<Scalars['String']>;
  termsAddContractViewer?: InputMaybe<Scalars['String']>;
  termsCommissionViewer?: InputMaybe<Scalars['String']>;
  termsPaymentViewer?: InputMaybe<Scalars['String']>;
  termsShippingViewer?: InputMaybe<Scalars['String']>;
  termsViewer?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "agreements" */
export type Agreements_Inc_Input = {
  buyerBillingAddressId?: InputMaybe<Scalars['Int']>;
  buyerCiattiCommission?: InputMaybe<Scalars['Float']>;
  buyerCompanyId?: InputMaybe<Scalars['Int']>;
  buyerContactId?: InputMaybe<Scalars['Int']>;
  buyerDeliveryAddressId?: InputMaybe<Scalars['Int']>;
  buyerOfficeId?: InputMaybe<Scalars['Int']>;
  commisionFees?: InputMaybe<Scalars['Float']>;
  commissionBuyer?: InputMaybe<Scalars['Float']>;
  commissionCostBase?: InputMaybe<Scalars['Float']>;
  commissionFeesPerUom?: InputMaybe<Scalars['Float']>;
  commissionFlatFees?: InputMaybe<Scalars['Float']>;
  commissionPercentage?: InputMaybe<Scalars['Float']>;
  commissionQuantityBase?: InputMaybe<Scalars['Float']>;
  commissionSeller?: InputMaybe<Scalars['Float']>;
  commissionThirdParty?: InputMaybe<Scalars['Float']>;
  commissionTotalFees?: InputMaybe<Scalars['Float']>;
  contractOfficeId?: InputMaybe<Scalars['Int']>;
  evergreenAgreementId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  quantityOrdered?: InputMaybe<Scalars['Float']>;
  quantityShipped?: InputMaybe<Scalars['Float']>;
  sellerBillingAddressId?: InputMaybe<Scalars['Int']>;
  sellerCiattiCommission?: InputMaybe<Scalars['Float']>;
  sellerCompanyId?: InputMaybe<Scalars['Int']>;
  sellerContactId?: InputMaybe<Scalars['Int']>;
  sellerDeliveryAddressId?: InputMaybe<Scalars['Int']>;
  sellerOfficeId?: InputMaybe<Scalars['Int']>;
  thirdPartyCommission?: InputMaybe<Scalars['Float']>;
  thirdPartyCompanyId?: InputMaybe<Scalars['Int']>;
  thirdPartyContactId?: InputMaybe<Scalars['Int']>;
  totalCost?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "agreements" */
export type Agreements_Insert_Input = {
  additionalInformations?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  buyerBillingAddress?: InputMaybe<Addresses_Obj_Rel_Insert_Input>;
  buyerBillingAddressId?: InputMaybe<Scalars['Int']>;
  buyerBondedWarehouse?: InputMaybe<Scalars['String']>;
  buyerCiattiCommission?: InputMaybe<Scalars['Float']>;
  buyerCompany?: InputMaybe<Companies_Obj_Rel_Insert_Input>;
  buyerCompanyId?: InputMaybe<Scalars['Int']>;
  buyerContact?: InputMaybe<Contacts_Obj_Rel_Insert_Input>;
  buyerContactId?: InputMaybe<Scalars['Int']>;
  buyerContractRef?: InputMaybe<Scalars['String']>;
  buyerCvi?: InputMaybe<Scalars['String']>;
  buyerDeliveryAddress?: InputMaybe<Addresses_Obj_Rel_Insert_Input>;
  buyerDeliveryAddressId?: InputMaybe<Scalars['Int']>;
  buyerEori?: InputMaybe<Scalars['String']>;
  buyerExcise?: InputMaybe<Scalars['String']>;
  buyerFda?: InputMaybe<Scalars['String']>;
  buyerOffice?: InputMaybe<Offices_Obj_Rel_Insert_Input>;
  buyerOfficeId?: InputMaybe<Scalars['Int']>;
  buyerSpecsId?: InputMaybe<Scalars['jsonb']>;
  buyerUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  buyerUserId?: InputMaybe<Scalars['String']>;
  buyerUserName?: InputMaybe<Scalars['String']>;
  buyerVat?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  commisionFees?: InputMaybe<Scalars['Float']>;
  commissionBuyer?: InputMaybe<Scalars['Float']>;
  commissionCostBase?: InputMaybe<Scalars['Float']>;
  commissionCurrency?: InputMaybe<Scalars['String']>;
  commissionFeesPerUom?: InputMaybe<Scalars['Float']>;
  commissionFlatFees?: InputMaybe<Scalars['Float']>;
  commissionPercentage?: InputMaybe<Scalars['Float']>;
  commissionQuantityBase?: InputMaybe<Scalars['Float']>;
  commissionSeller?: InputMaybe<Scalars['Float']>;
  commissionThirdParty?: InputMaybe<Scalars['Float']>;
  commissionTotalFees?: InputMaybe<Scalars['Float']>;
  commissionType?: InputMaybe<Scalars['String']>;
  commissionUom?: InputMaybe<Scalars['String']>;
  commodityType?: InputMaybe<Scalars['String']>;
  contractOffice?: InputMaybe<Offices_Obj_Rel_Insert_Input>;
  contractOfficeId?: InputMaybe<Scalars['Int']>;
  contractRevision?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Scalars['String']>;
  contractUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  contractUserId?: InputMaybe<Scalars['String']>;
  costArray?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endDate?: InputMaybe<Scalars['date']>;
  evergreenAgreementId?: InputMaybe<Scalars['Int']>;
  evergreenContract?: InputMaybe<Scalars['Boolean']>;
  evergreenDates?: InputMaybe<Scalars['jsonb']>;
  files?: InputMaybe<Scalars['jsonb']>;
  fulfillmentsStatus?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  incoterms?: InputMaybe<Scalars['String']>;
  invoices?: InputMaybe<Invoices_Arr_Rel_Insert_Input>;
  invoicesStatus?: InputMaybe<Scalars['String']>;
  isMultiYearContract?: InputMaybe<Scalars['Boolean']>;
  itemsId?: InputMaybe<Scalars['jsonb']>;
  legacyContractStatus?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  quantityOrdered?: InputMaybe<Scalars['Float']>;
  quantityShipped?: InputMaybe<Scalars['Float']>;
  reminders?: InputMaybe<Scalars['jsonb']>;
  salesOrderNetsuite?: InputMaybe<Scalars['String']>;
  sellerBillingAddress?: InputMaybe<Addresses_Obj_Rel_Insert_Input>;
  sellerBillingAddressId?: InputMaybe<Scalars['Int']>;
  sellerBondedWarehouse?: InputMaybe<Scalars['String']>;
  sellerCiattiCommission?: InputMaybe<Scalars['Float']>;
  sellerCompany?: InputMaybe<Companies_Obj_Rel_Insert_Input>;
  sellerCompanyId?: InputMaybe<Scalars['Int']>;
  sellerContact?: InputMaybe<Contacts_Obj_Rel_Insert_Input>;
  sellerContactId?: InputMaybe<Scalars['Int']>;
  sellerContractRef?: InputMaybe<Scalars['String']>;
  sellerCvi?: InputMaybe<Scalars['String']>;
  sellerDeliveryAddress?: InputMaybe<Addresses_Obj_Rel_Insert_Input>;
  sellerDeliveryAddressId?: InputMaybe<Scalars['Int']>;
  sellerEori?: InputMaybe<Scalars['String']>;
  sellerExcise?: InputMaybe<Scalars['String']>;
  sellerFda?: InputMaybe<Scalars['String']>;
  sellerOffice?: InputMaybe<Offices_Obj_Rel_Insert_Input>;
  sellerOfficeId?: InputMaybe<Scalars['Int']>;
  sellerUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  sellerUserId?: InputMaybe<Scalars['String']>;
  sellerUserName?: InputMaybe<Scalars['String']>;
  sellerVat?: InputMaybe<Scalars['String']>;
  shipmentFulfillments?: InputMaybe<ShipmentFulfillments_Arr_Rel_Insert_Input>;
  signaturesRequired?: InputMaybe<Scalars['jsonb']>;
  startDate?: InputMaybe<Scalars['date']>;
  terms?: InputMaybe<Scalars['String']>;
  termsAddContract?: InputMaybe<Scalars['String']>;
  termsAddContractViewer?: InputMaybe<Scalars['jsonb']>;
  termsCommission?: InputMaybe<Scalars['String']>;
  termsCommissionViewer?: InputMaybe<Scalars['jsonb']>;
  termsPayment?: InputMaybe<Scalars['String']>;
  termsPaymentViewer?: InputMaybe<Scalars['jsonb']>;
  termsShipping?: InputMaybe<Scalars['String']>;
  termsShippingViewer?: InputMaybe<Scalars['jsonb']>;
  termsViewer?: InputMaybe<Scalars['jsonb']>;
  thirdPartyCommission?: InputMaybe<Scalars['Float']>;
  thirdPartyCompany?: InputMaybe<Companies_Obj_Rel_Insert_Input>;
  thirdPartyCompanyId?: InputMaybe<Scalars['Int']>;
  thirdPartyContact?: InputMaybe<Contacts_Obj_Rel_Insert_Input>;
  thirdPartyContactId?: InputMaybe<Scalars['Int']>;
  thirdPartyContractRef?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalCost?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usdaGcr?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Agreements_Max_Fields = {
  __typename?: 'agreements_max_fields';
  additionalInformations?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  buyerBillingAddressId?: Maybe<Scalars['Int']>;
  buyerBondedWarehouse?: Maybe<Scalars['String']>;
  buyerCiattiCommission?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Int']>;
  buyerContactId?: Maybe<Scalars['Int']>;
  buyerContractRef?: Maybe<Scalars['String']>;
  buyerCvi?: Maybe<Scalars['String']>;
  buyerDeliveryAddressId?: Maybe<Scalars['Int']>;
  buyerEori?: Maybe<Scalars['String']>;
  buyerExcise?: Maybe<Scalars['String']>;
  buyerFda?: Maybe<Scalars['String']>;
  buyerOfficeId?: Maybe<Scalars['Int']>;
  buyerUserId?: Maybe<Scalars['String']>;
  buyerUserName?: Maybe<Scalars['String']>;
  buyerVat?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  commisionFees?: Maybe<Scalars['Float']>;
  commissionBuyer?: Maybe<Scalars['Float']>;
  commissionCostBase?: Maybe<Scalars['Float']>;
  commissionCurrency?: Maybe<Scalars['String']>;
  commissionFeesPerUom?: Maybe<Scalars['Float']>;
  commissionFlatFees?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  commissionQuantityBase?: Maybe<Scalars['Float']>;
  commissionSeller?: Maybe<Scalars['Float']>;
  commissionThirdParty?: Maybe<Scalars['Float']>;
  commissionTotalFees?: Maybe<Scalars['Float']>;
  commissionType?: Maybe<Scalars['String']>;
  commissionUom?: Maybe<Scalars['String']>;
  commodityType?: Maybe<Scalars['String']>;
  contractOfficeId?: Maybe<Scalars['Int']>;
  contractRevision?: Maybe<Scalars['String']>;
  contractStatus?: Maybe<Scalars['String']>;
  contractUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endDate?: Maybe<Scalars['date']>;
  evergreenAgreementId?: Maybe<Scalars['Int']>;
  fulfillmentsStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  incoterms?: Maybe<Scalars['String']>;
  invoicesStatus?: Maybe<Scalars['String']>;
  legacyContractStatus?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  quantityOrdered?: Maybe<Scalars['Float']>;
  quantityShipped?: Maybe<Scalars['Float']>;
  salesOrderNetsuite?: Maybe<Scalars['String']>;
  sellerBillingAddressId?: Maybe<Scalars['Int']>;
  sellerBondedWarehouse?: Maybe<Scalars['String']>;
  sellerCiattiCommission?: Maybe<Scalars['Float']>;
  sellerCompanyId?: Maybe<Scalars['Int']>;
  sellerContactId?: Maybe<Scalars['Int']>;
  sellerContractRef?: Maybe<Scalars['String']>;
  sellerCvi?: Maybe<Scalars['String']>;
  sellerDeliveryAddressId?: Maybe<Scalars['Int']>;
  sellerEori?: Maybe<Scalars['String']>;
  sellerExcise?: Maybe<Scalars['String']>;
  sellerFda?: Maybe<Scalars['String']>;
  sellerOfficeId?: Maybe<Scalars['Int']>;
  sellerUserId?: Maybe<Scalars['String']>;
  sellerUserName?: Maybe<Scalars['String']>;
  sellerVat?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['date']>;
  terms?: Maybe<Scalars['String']>;
  termsAddContract?: Maybe<Scalars['String']>;
  termsCommission?: Maybe<Scalars['String']>;
  termsPayment?: Maybe<Scalars['String']>;
  termsShipping?: Maybe<Scalars['String']>;
  thirdPartyCommission?: Maybe<Scalars['Float']>;
  thirdPartyCompanyId?: Maybe<Scalars['Int']>;
  thirdPartyContactId?: Maybe<Scalars['Int']>;
  thirdPartyContractRef?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "agreements" */
export type Agreements_Max_Order_By = {
  additionalInformations?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  buyerBillingAddressId?: InputMaybe<Order_By>;
  buyerBondedWarehouse?: InputMaybe<Order_By>;
  buyerCiattiCommission?: InputMaybe<Order_By>;
  buyerCompanyId?: InputMaybe<Order_By>;
  buyerContactId?: InputMaybe<Order_By>;
  buyerContractRef?: InputMaybe<Order_By>;
  buyerCvi?: InputMaybe<Order_By>;
  buyerDeliveryAddressId?: InputMaybe<Order_By>;
  buyerEori?: InputMaybe<Order_By>;
  buyerExcise?: InputMaybe<Order_By>;
  buyerFda?: InputMaybe<Order_By>;
  buyerOfficeId?: InputMaybe<Order_By>;
  buyerUserId?: InputMaybe<Order_By>;
  buyerUserName?: InputMaybe<Order_By>;
  buyerVat?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  commisionFees?: InputMaybe<Order_By>;
  commissionBuyer?: InputMaybe<Order_By>;
  commissionCostBase?: InputMaybe<Order_By>;
  commissionCurrency?: InputMaybe<Order_By>;
  commissionFeesPerUom?: InputMaybe<Order_By>;
  commissionFlatFees?: InputMaybe<Order_By>;
  commissionPercentage?: InputMaybe<Order_By>;
  commissionQuantityBase?: InputMaybe<Order_By>;
  commissionSeller?: InputMaybe<Order_By>;
  commissionThirdParty?: InputMaybe<Order_By>;
  commissionTotalFees?: InputMaybe<Order_By>;
  commissionType?: InputMaybe<Order_By>;
  commissionUom?: InputMaybe<Order_By>;
  commodityType?: InputMaybe<Order_By>;
  contractOfficeId?: InputMaybe<Order_By>;
  contractRevision?: InputMaybe<Order_By>;
  contractStatus?: InputMaybe<Order_By>;
  contractUserId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  evergreenAgreementId?: InputMaybe<Order_By>;
  fulfillmentsStatus?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incoterms?: InputMaybe<Order_By>;
  invoicesStatus?: InputMaybe<Order_By>;
  legacyContractStatus?: InputMaybe<Order_By>;
  place?: InputMaybe<Order_By>;
  quantityOrdered?: InputMaybe<Order_By>;
  quantityShipped?: InputMaybe<Order_By>;
  salesOrderNetsuite?: InputMaybe<Order_By>;
  sellerBillingAddressId?: InputMaybe<Order_By>;
  sellerBondedWarehouse?: InputMaybe<Order_By>;
  sellerCiattiCommission?: InputMaybe<Order_By>;
  sellerCompanyId?: InputMaybe<Order_By>;
  sellerContactId?: InputMaybe<Order_By>;
  sellerContractRef?: InputMaybe<Order_By>;
  sellerCvi?: InputMaybe<Order_By>;
  sellerDeliveryAddressId?: InputMaybe<Order_By>;
  sellerEori?: InputMaybe<Order_By>;
  sellerExcise?: InputMaybe<Order_By>;
  sellerFda?: InputMaybe<Order_By>;
  sellerOfficeId?: InputMaybe<Order_By>;
  sellerUserId?: InputMaybe<Order_By>;
  sellerUserName?: InputMaybe<Order_By>;
  sellerVat?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  terms?: InputMaybe<Order_By>;
  termsAddContract?: InputMaybe<Order_By>;
  termsCommission?: InputMaybe<Order_By>;
  termsPayment?: InputMaybe<Order_By>;
  termsShipping?: InputMaybe<Order_By>;
  thirdPartyCommission?: InputMaybe<Order_By>;
  thirdPartyCompanyId?: InputMaybe<Order_By>;
  thirdPartyContactId?: InputMaybe<Order_By>;
  thirdPartyContractRef?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  totalCost?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Agreements_Min_Fields = {
  __typename?: 'agreements_min_fields';
  additionalInformations?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  buyerBillingAddressId?: Maybe<Scalars['Int']>;
  buyerBondedWarehouse?: Maybe<Scalars['String']>;
  buyerCiattiCommission?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Int']>;
  buyerContactId?: Maybe<Scalars['Int']>;
  buyerContractRef?: Maybe<Scalars['String']>;
  buyerCvi?: Maybe<Scalars['String']>;
  buyerDeliveryAddressId?: Maybe<Scalars['Int']>;
  buyerEori?: Maybe<Scalars['String']>;
  buyerExcise?: Maybe<Scalars['String']>;
  buyerFda?: Maybe<Scalars['String']>;
  buyerOfficeId?: Maybe<Scalars['Int']>;
  buyerUserId?: Maybe<Scalars['String']>;
  buyerUserName?: Maybe<Scalars['String']>;
  buyerVat?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  commisionFees?: Maybe<Scalars['Float']>;
  commissionBuyer?: Maybe<Scalars['Float']>;
  commissionCostBase?: Maybe<Scalars['Float']>;
  commissionCurrency?: Maybe<Scalars['String']>;
  commissionFeesPerUom?: Maybe<Scalars['Float']>;
  commissionFlatFees?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  commissionQuantityBase?: Maybe<Scalars['Float']>;
  commissionSeller?: Maybe<Scalars['Float']>;
  commissionThirdParty?: Maybe<Scalars['Float']>;
  commissionTotalFees?: Maybe<Scalars['Float']>;
  commissionType?: Maybe<Scalars['String']>;
  commissionUom?: Maybe<Scalars['String']>;
  commodityType?: Maybe<Scalars['String']>;
  contractOfficeId?: Maybe<Scalars['Int']>;
  contractRevision?: Maybe<Scalars['String']>;
  contractStatus?: Maybe<Scalars['String']>;
  contractUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  endDate?: Maybe<Scalars['date']>;
  evergreenAgreementId?: Maybe<Scalars['Int']>;
  fulfillmentsStatus?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  incoterms?: Maybe<Scalars['String']>;
  invoicesStatus?: Maybe<Scalars['String']>;
  legacyContractStatus?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  quantityOrdered?: Maybe<Scalars['Float']>;
  quantityShipped?: Maybe<Scalars['Float']>;
  salesOrderNetsuite?: Maybe<Scalars['String']>;
  sellerBillingAddressId?: Maybe<Scalars['Int']>;
  sellerBondedWarehouse?: Maybe<Scalars['String']>;
  sellerCiattiCommission?: Maybe<Scalars['Float']>;
  sellerCompanyId?: Maybe<Scalars['Int']>;
  sellerContactId?: Maybe<Scalars['Int']>;
  sellerContractRef?: Maybe<Scalars['String']>;
  sellerCvi?: Maybe<Scalars['String']>;
  sellerDeliveryAddressId?: Maybe<Scalars['Int']>;
  sellerEori?: Maybe<Scalars['String']>;
  sellerExcise?: Maybe<Scalars['String']>;
  sellerFda?: Maybe<Scalars['String']>;
  sellerOfficeId?: Maybe<Scalars['Int']>;
  sellerUserId?: Maybe<Scalars['String']>;
  sellerUserName?: Maybe<Scalars['String']>;
  sellerVat?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['date']>;
  terms?: Maybe<Scalars['String']>;
  termsAddContract?: Maybe<Scalars['String']>;
  termsCommission?: Maybe<Scalars['String']>;
  termsPayment?: Maybe<Scalars['String']>;
  termsShipping?: Maybe<Scalars['String']>;
  thirdPartyCommission?: Maybe<Scalars['Float']>;
  thirdPartyCompanyId?: Maybe<Scalars['Int']>;
  thirdPartyContactId?: Maybe<Scalars['Int']>;
  thirdPartyContractRef?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "agreements" */
export type Agreements_Min_Order_By = {
  additionalInformations?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  buyerBillingAddressId?: InputMaybe<Order_By>;
  buyerBondedWarehouse?: InputMaybe<Order_By>;
  buyerCiattiCommission?: InputMaybe<Order_By>;
  buyerCompanyId?: InputMaybe<Order_By>;
  buyerContactId?: InputMaybe<Order_By>;
  buyerContractRef?: InputMaybe<Order_By>;
  buyerCvi?: InputMaybe<Order_By>;
  buyerDeliveryAddressId?: InputMaybe<Order_By>;
  buyerEori?: InputMaybe<Order_By>;
  buyerExcise?: InputMaybe<Order_By>;
  buyerFda?: InputMaybe<Order_By>;
  buyerOfficeId?: InputMaybe<Order_By>;
  buyerUserId?: InputMaybe<Order_By>;
  buyerUserName?: InputMaybe<Order_By>;
  buyerVat?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  commisionFees?: InputMaybe<Order_By>;
  commissionBuyer?: InputMaybe<Order_By>;
  commissionCostBase?: InputMaybe<Order_By>;
  commissionCurrency?: InputMaybe<Order_By>;
  commissionFeesPerUom?: InputMaybe<Order_By>;
  commissionFlatFees?: InputMaybe<Order_By>;
  commissionPercentage?: InputMaybe<Order_By>;
  commissionQuantityBase?: InputMaybe<Order_By>;
  commissionSeller?: InputMaybe<Order_By>;
  commissionThirdParty?: InputMaybe<Order_By>;
  commissionTotalFees?: InputMaybe<Order_By>;
  commissionType?: InputMaybe<Order_By>;
  commissionUom?: InputMaybe<Order_By>;
  commodityType?: InputMaybe<Order_By>;
  contractOfficeId?: InputMaybe<Order_By>;
  contractRevision?: InputMaybe<Order_By>;
  contractStatus?: InputMaybe<Order_By>;
  contractUserId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  evergreenAgreementId?: InputMaybe<Order_By>;
  fulfillmentsStatus?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incoterms?: InputMaybe<Order_By>;
  invoicesStatus?: InputMaybe<Order_By>;
  legacyContractStatus?: InputMaybe<Order_By>;
  place?: InputMaybe<Order_By>;
  quantityOrdered?: InputMaybe<Order_By>;
  quantityShipped?: InputMaybe<Order_By>;
  salesOrderNetsuite?: InputMaybe<Order_By>;
  sellerBillingAddressId?: InputMaybe<Order_By>;
  sellerBondedWarehouse?: InputMaybe<Order_By>;
  sellerCiattiCommission?: InputMaybe<Order_By>;
  sellerCompanyId?: InputMaybe<Order_By>;
  sellerContactId?: InputMaybe<Order_By>;
  sellerContractRef?: InputMaybe<Order_By>;
  sellerCvi?: InputMaybe<Order_By>;
  sellerDeliveryAddressId?: InputMaybe<Order_By>;
  sellerEori?: InputMaybe<Order_By>;
  sellerExcise?: InputMaybe<Order_By>;
  sellerFda?: InputMaybe<Order_By>;
  sellerOfficeId?: InputMaybe<Order_By>;
  sellerUserId?: InputMaybe<Order_By>;
  sellerUserName?: InputMaybe<Order_By>;
  sellerVat?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  terms?: InputMaybe<Order_By>;
  termsAddContract?: InputMaybe<Order_By>;
  termsCommission?: InputMaybe<Order_By>;
  termsPayment?: InputMaybe<Order_By>;
  termsShipping?: InputMaybe<Order_By>;
  thirdPartyCommission?: InputMaybe<Order_By>;
  thirdPartyCompanyId?: InputMaybe<Order_By>;
  thirdPartyContactId?: InputMaybe<Order_By>;
  thirdPartyContractRef?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  totalCost?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "agreements" */
export type Agreements_Mutation_Response = {
  __typename?: 'agreements_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Agreements>;
};

/** input type for inserting object relation for remote table "agreements" */
export type Agreements_Obj_Rel_Insert_Input = {
  data: Agreements_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Agreements_On_Conflict>;
};

/** on_conflict condition type for table "agreements" */
export type Agreements_On_Conflict = {
  constraint: Agreements_Constraint;
  update_columns?: Array<Agreements_Update_Column>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};

/** Ordering options when selecting data from "agreements". */
export type Agreements_Order_By = {
  additionalInformations?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  buyerBillingAddress?: InputMaybe<Addresses_Order_By>;
  buyerBillingAddressId?: InputMaybe<Order_By>;
  buyerBondedWarehouse?: InputMaybe<Order_By>;
  buyerCiattiCommission?: InputMaybe<Order_By>;
  buyerCompany?: InputMaybe<Companies_Order_By>;
  buyerCompanyId?: InputMaybe<Order_By>;
  buyerContact?: InputMaybe<Contacts_Order_By>;
  buyerContactId?: InputMaybe<Order_By>;
  buyerContractRef?: InputMaybe<Order_By>;
  buyerCvi?: InputMaybe<Order_By>;
  buyerDeliveryAddress?: InputMaybe<Addresses_Order_By>;
  buyerDeliveryAddressId?: InputMaybe<Order_By>;
  buyerEori?: InputMaybe<Order_By>;
  buyerExcise?: InputMaybe<Order_By>;
  buyerFda?: InputMaybe<Order_By>;
  buyerOffice?: InputMaybe<Offices_Order_By>;
  buyerOfficeId?: InputMaybe<Order_By>;
  buyerSpecsId?: InputMaybe<Order_By>;
  buyerUser?: InputMaybe<Users_Order_By>;
  buyerUserId?: InputMaybe<Order_By>;
  buyerUserName?: InputMaybe<Order_By>;
  buyerVat?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  commisionFees?: InputMaybe<Order_By>;
  commissionBuyer?: InputMaybe<Order_By>;
  commissionCostBase?: InputMaybe<Order_By>;
  commissionCurrency?: InputMaybe<Order_By>;
  commissionFeesPerUom?: InputMaybe<Order_By>;
  commissionFlatFees?: InputMaybe<Order_By>;
  commissionPercentage?: InputMaybe<Order_By>;
  commissionQuantityBase?: InputMaybe<Order_By>;
  commissionSeller?: InputMaybe<Order_By>;
  commissionThirdParty?: InputMaybe<Order_By>;
  commissionTotalFees?: InputMaybe<Order_By>;
  commissionType?: InputMaybe<Order_By>;
  commissionUom?: InputMaybe<Order_By>;
  commodityType?: InputMaybe<Order_By>;
  contractOffice?: InputMaybe<Offices_Order_By>;
  contractOfficeId?: InputMaybe<Order_By>;
  contractRevision?: InputMaybe<Order_By>;
  contractStatus?: InputMaybe<Order_By>;
  contractUser?: InputMaybe<Users_Order_By>;
  contractUserId?: InputMaybe<Order_By>;
  costArray?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  endDate?: InputMaybe<Order_By>;
  evergreenAgreementId?: InputMaybe<Order_By>;
  evergreenContract?: InputMaybe<Order_By>;
  evergreenDates?: InputMaybe<Order_By>;
  files?: InputMaybe<Order_By>;
  fulfillmentsStatus?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  incoterms?: InputMaybe<Order_By>;
  invoicesStatus?: InputMaybe<Order_By>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Order_By>;
  isMultiYearContract?: InputMaybe<Order_By>;
  itemsId?: InputMaybe<Order_By>;
  legacyContractStatus?: InputMaybe<Order_By>;
  place?: InputMaybe<Order_By>;
  quantityOrdered?: InputMaybe<Order_By>;
  quantityShipped?: InputMaybe<Order_By>;
  reminders?: InputMaybe<Order_By>;
  salesOrderNetsuite?: InputMaybe<Order_By>;
  sellerBillingAddress?: InputMaybe<Addresses_Order_By>;
  sellerBillingAddressId?: InputMaybe<Order_By>;
  sellerBondedWarehouse?: InputMaybe<Order_By>;
  sellerCiattiCommission?: InputMaybe<Order_By>;
  sellerCompany?: InputMaybe<Companies_Order_By>;
  sellerCompanyId?: InputMaybe<Order_By>;
  sellerContact?: InputMaybe<Contacts_Order_By>;
  sellerContactId?: InputMaybe<Order_By>;
  sellerContractRef?: InputMaybe<Order_By>;
  sellerCvi?: InputMaybe<Order_By>;
  sellerDeliveryAddress?: InputMaybe<Addresses_Order_By>;
  sellerDeliveryAddressId?: InputMaybe<Order_By>;
  sellerEori?: InputMaybe<Order_By>;
  sellerExcise?: InputMaybe<Order_By>;
  sellerFda?: InputMaybe<Order_By>;
  sellerOffice?: InputMaybe<Offices_Order_By>;
  sellerOfficeId?: InputMaybe<Order_By>;
  sellerUser?: InputMaybe<Users_Order_By>;
  sellerUserId?: InputMaybe<Order_By>;
  sellerUserName?: InputMaybe<Order_By>;
  sellerVat?: InputMaybe<Order_By>;
  shipmentFulfillments_aggregate?: InputMaybe<ShipmentFulfillments_Aggregate_Order_By>;
  signaturesRequired?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  terms?: InputMaybe<Order_By>;
  termsAddContract?: InputMaybe<Order_By>;
  termsAddContractViewer?: InputMaybe<Order_By>;
  termsCommission?: InputMaybe<Order_By>;
  termsCommissionViewer?: InputMaybe<Order_By>;
  termsPayment?: InputMaybe<Order_By>;
  termsPaymentViewer?: InputMaybe<Order_By>;
  termsShipping?: InputMaybe<Order_By>;
  termsShippingViewer?: InputMaybe<Order_By>;
  termsViewer?: InputMaybe<Order_By>;
  thirdPartyCommission?: InputMaybe<Order_By>;
  thirdPartyCompany?: InputMaybe<Companies_Order_By>;
  thirdPartyCompanyId?: InputMaybe<Order_By>;
  thirdPartyContact?: InputMaybe<Contacts_Order_By>;
  thirdPartyContactId?: InputMaybe<Order_By>;
  thirdPartyContractRef?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  totalCost?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  usdaGcr?: InputMaybe<Order_By>;
};

/** primary key columns input for table: agreements */
export type Agreements_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Agreements_Prepend_Input = {
  buyerSpecsId?: InputMaybe<Scalars['jsonb']>;
  costArray?: InputMaybe<Scalars['jsonb']>;
  evergreenDates?: InputMaybe<Scalars['jsonb']>;
  files?: InputMaybe<Scalars['jsonb']>;
  itemsId?: InputMaybe<Scalars['jsonb']>;
  reminders?: InputMaybe<Scalars['jsonb']>;
  signaturesRequired?: InputMaybe<Scalars['jsonb']>;
  termsAddContractViewer?: InputMaybe<Scalars['jsonb']>;
  termsCommissionViewer?: InputMaybe<Scalars['jsonb']>;
  termsPaymentViewer?: InputMaybe<Scalars['jsonb']>;
  termsShippingViewer?: InputMaybe<Scalars['jsonb']>;
  termsViewer?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "agreements" */
export enum Agreements_Select_Column {
  /** column name */
  AdditionalInformations = 'additionalInformations',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BuyerBillingAddressId = 'buyerBillingAddressId',
  /** column name */
  BuyerBondedWarehouse = 'buyerBondedWarehouse',
  /** column name */
  BuyerCiattiCommission = 'buyerCiattiCommission',
  /** column name */
  BuyerCompanyId = 'buyerCompanyId',
  /** column name */
  BuyerContactId = 'buyerContactId',
  /** column name */
  BuyerContractRef = 'buyerContractRef',
  /** column name */
  BuyerCvi = 'buyerCvi',
  /** column name */
  BuyerDeliveryAddressId = 'buyerDeliveryAddressId',
  /** column name */
  BuyerEori = 'buyerEori',
  /** column name */
  BuyerExcise = 'buyerExcise',
  /** column name */
  BuyerFda = 'buyerFda',
  /** column name */
  BuyerOfficeId = 'buyerOfficeId',
  /** column name */
  BuyerSpecsId = 'buyerSpecsId',
  /** column name */
  BuyerUserId = 'buyerUserId',
  /** column name */
  BuyerUserName = 'buyerUserName',
  /** column name */
  BuyerVat = 'buyerVat',
  /** column name */
  Comments = 'comments',
  /** column name */
  CommisionFees = 'commisionFees',
  /** column name */
  CommissionBuyer = 'commissionBuyer',
  /** column name */
  CommissionCostBase = 'commissionCostBase',
  /** column name */
  CommissionCurrency = 'commissionCurrency',
  /** column name */
  CommissionFeesPerUom = 'commissionFeesPerUom',
  /** column name */
  CommissionFlatFees = 'commissionFlatFees',
  /** column name */
  CommissionPercentage = 'commissionPercentage',
  /** column name */
  CommissionQuantityBase = 'commissionQuantityBase',
  /** column name */
  CommissionSeller = 'commissionSeller',
  /** column name */
  CommissionThirdParty = 'commissionThirdParty',
  /** column name */
  CommissionTotalFees = 'commissionTotalFees',
  /** column name */
  CommissionType = 'commissionType',
  /** column name */
  CommissionUom = 'commissionUom',
  /** column name */
  CommodityType = 'commodityType',
  /** column name */
  ContractOfficeId = 'contractOfficeId',
  /** column name */
  ContractRevision = 'contractRevision',
  /** column name */
  ContractStatus = 'contractStatus',
  /** column name */
  ContractUserId = 'contractUserId',
  /** column name */
  CostArray = 'costArray',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EvergreenAgreementId = 'evergreenAgreementId',
  /** column name */
  EvergreenContract = 'evergreenContract',
  /** column name */
  EvergreenDates = 'evergreenDates',
  /** column name */
  Files = 'files',
  /** column name */
  FulfillmentsStatus = 'fulfillmentsStatus',
  /** column name */
  Id = 'id',
  /** column name */
  Incoterms = 'incoterms',
  /** column name */
  InvoicesStatus = 'invoicesStatus',
  /** column name */
  IsMultiYearContract = 'isMultiYearContract',
  /** column name */
  ItemsId = 'itemsId',
  /** column name */
  LegacyContractStatus = 'legacyContractStatus',
  /** column name */
  Place = 'place',
  /** column name */
  QuantityOrdered = 'quantityOrdered',
  /** column name */
  QuantityShipped = 'quantityShipped',
  /** column name */
  Reminders = 'reminders',
  /** column name */
  SalesOrderNetsuite = 'salesOrderNetsuite',
  /** column name */
  SellerBillingAddressId = 'sellerBillingAddressId',
  /** column name */
  SellerBondedWarehouse = 'sellerBondedWarehouse',
  /** column name */
  SellerCiattiCommission = 'sellerCiattiCommission',
  /** column name */
  SellerCompanyId = 'sellerCompanyId',
  /** column name */
  SellerContactId = 'sellerContactId',
  /** column name */
  SellerContractRef = 'sellerContractRef',
  /** column name */
  SellerCvi = 'sellerCvi',
  /** column name */
  SellerDeliveryAddressId = 'sellerDeliveryAddressId',
  /** column name */
  SellerEori = 'sellerEori',
  /** column name */
  SellerExcise = 'sellerExcise',
  /** column name */
  SellerFda = 'sellerFda',
  /** column name */
  SellerOfficeId = 'sellerOfficeId',
  /** column name */
  SellerUserId = 'sellerUserId',
  /** column name */
  SellerUserName = 'sellerUserName',
  /** column name */
  SellerVat = 'sellerVat',
  /** column name */
  SignaturesRequired = 'signaturesRequired',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Terms = 'terms',
  /** column name */
  TermsAddContract = 'termsAddContract',
  /** column name */
  TermsAddContractViewer = 'termsAddContractViewer',
  /** column name */
  TermsCommission = 'termsCommission',
  /** column name */
  TermsCommissionViewer = 'termsCommissionViewer',
  /** column name */
  TermsPayment = 'termsPayment',
  /** column name */
  TermsPaymentViewer = 'termsPaymentViewer',
  /** column name */
  TermsShipping = 'termsShipping',
  /** column name */
  TermsShippingViewer = 'termsShippingViewer',
  /** column name */
  TermsViewer = 'termsViewer',
  /** column name */
  ThirdPartyCommission = 'thirdPartyCommission',
  /** column name */
  ThirdPartyCompanyId = 'thirdPartyCompanyId',
  /** column name */
  ThirdPartyContactId = 'thirdPartyContactId',
  /** column name */
  ThirdPartyContractRef = 'thirdPartyContractRef',
  /** column name */
  Title = 'title',
  /** column name */
  TotalCost = 'totalCost',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsdaGcr = 'usdaGcr'
}

/** select "agreements_aggregate_bool_exp_bool_and_arguments_columns" columns of table "agreements" */
export enum Agreements_Select_Column_Agreements_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  EvergreenContract = 'evergreenContract',
  /** column name */
  IsMultiYearContract = 'isMultiYearContract',
  /** column name */
  UsdaGcr = 'usdaGcr'
}

/** select "agreements_aggregate_bool_exp_bool_or_arguments_columns" columns of table "agreements" */
export enum Agreements_Select_Column_Agreements_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  EvergreenContract = 'evergreenContract',
  /** column name */
  IsMultiYearContract = 'isMultiYearContract',
  /** column name */
  UsdaGcr = 'usdaGcr'
}

/** input type for updating data in table "agreements" */
export type Agreements_Set_Input = {
  additionalInformations?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  buyerBillingAddressId?: InputMaybe<Scalars['Int']>;
  buyerBondedWarehouse?: InputMaybe<Scalars['String']>;
  buyerCiattiCommission?: InputMaybe<Scalars['Float']>;
  buyerCompanyId?: InputMaybe<Scalars['Int']>;
  buyerContactId?: InputMaybe<Scalars['Int']>;
  buyerContractRef?: InputMaybe<Scalars['String']>;
  buyerCvi?: InputMaybe<Scalars['String']>;
  buyerDeliveryAddressId?: InputMaybe<Scalars['Int']>;
  buyerEori?: InputMaybe<Scalars['String']>;
  buyerExcise?: InputMaybe<Scalars['String']>;
  buyerFda?: InputMaybe<Scalars['String']>;
  buyerOfficeId?: InputMaybe<Scalars['Int']>;
  buyerSpecsId?: InputMaybe<Scalars['jsonb']>;
  buyerUserId?: InputMaybe<Scalars['String']>;
  buyerUserName?: InputMaybe<Scalars['String']>;
  buyerVat?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  commisionFees?: InputMaybe<Scalars['Float']>;
  commissionBuyer?: InputMaybe<Scalars['Float']>;
  commissionCostBase?: InputMaybe<Scalars['Float']>;
  commissionCurrency?: InputMaybe<Scalars['String']>;
  commissionFeesPerUom?: InputMaybe<Scalars['Float']>;
  commissionFlatFees?: InputMaybe<Scalars['Float']>;
  commissionPercentage?: InputMaybe<Scalars['Float']>;
  commissionQuantityBase?: InputMaybe<Scalars['Float']>;
  commissionSeller?: InputMaybe<Scalars['Float']>;
  commissionThirdParty?: InputMaybe<Scalars['Float']>;
  commissionTotalFees?: InputMaybe<Scalars['Float']>;
  commissionType?: InputMaybe<Scalars['String']>;
  commissionUom?: InputMaybe<Scalars['String']>;
  commodityType?: InputMaybe<Scalars['String']>;
  contractOfficeId?: InputMaybe<Scalars['Int']>;
  contractRevision?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Scalars['String']>;
  contractUserId?: InputMaybe<Scalars['String']>;
  costArray?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endDate?: InputMaybe<Scalars['date']>;
  evergreenAgreementId?: InputMaybe<Scalars['Int']>;
  evergreenContract?: InputMaybe<Scalars['Boolean']>;
  evergreenDates?: InputMaybe<Scalars['jsonb']>;
  files?: InputMaybe<Scalars['jsonb']>;
  fulfillmentsStatus?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  incoterms?: InputMaybe<Scalars['String']>;
  invoicesStatus?: InputMaybe<Scalars['String']>;
  isMultiYearContract?: InputMaybe<Scalars['Boolean']>;
  itemsId?: InputMaybe<Scalars['jsonb']>;
  legacyContractStatus?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  quantityOrdered?: InputMaybe<Scalars['Float']>;
  quantityShipped?: InputMaybe<Scalars['Float']>;
  reminders?: InputMaybe<Scalars['jsonb']>;
  salesOrderNetsuite?: InputMaybe<Scalars['String']>;
  sellerBillingAddressId?: InputMaybe<Scalars['Int']>;
  sellerBondedWarehouse?: InputMaybe<Scalars['String']>;
  sellerCiattiCommission?: InputMaybe<Scalars['Float']>;
  sellerCompanyId?: InputMaybe<Scalars['Int']>;
  sellerContactId?: InputMaybe<Scalars['Int']>;
  sellerContractRef?: InputMaybe<Scalars['String']>;
  sellerCvi?: InputMaybe<Scalars['String']>;
  sellerDeliveryAddressId?: InputMaybe<Scalars['Int']>;
  sellerEori?: InputMaybe<Scalars['String']>;
  sellerExcise?: InputMaybe<Scalars['String']>;
  sellerFda?: InputMaybe<Scalars['String']>;
  sellerOfficeId?: InputMaybe<Scalars['Int']>;
  sellerUserId?: InputMaybe<Scalars['String']>;
  sellerUserName?: InputMaybe<Scalars['String']>;
  sellerVat?: InputMaybe<Scalars['String']>;
  signaturesRequired?: InputMaybe<Scalars['jsonb']>;
  startDate?: InputMaybe<Scalars['date']>;
  terms?: InputMaybe<Scalars['String']>;
  termsAddContract?: InputMaybe<Scalars['String']>;
  termsAddContractViewer?: InputMaybe<Scalars['jsonb']>;
  termsCommission?: InputMaybe<Scalars['String']>;
  termsCommissionViewer?: InputMaybe<Scalars['jsonb']>;
  termsPayment?: InputMaybe<Scalars['String']>;
  termsPaymentViewer?: InputMaybe<Scalars['jsonb']>;
  termsShipping?: InputMaybe<Scalars['String']>;
  termsShippingViewer?: InputMaybe<Scalars['jsonb']>;
  termsViewer?: InputMaybe<Scalars['jsonb']>;
  thirdPartyCommission?: InputMaybe<Scalars['Float']>;
  thirdPartyCompanyId?: InputMaybe<Scalars['Int']>;
  thirdPartyContactId?: InputMaybe<Scalars['Int']>;
  thirdPartyContractRef?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalCost?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usdaGcr?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Agreements_Stddev_Fields = {
  __typename?: 'agreements_stddev_fields';
  buyerBillingAddressId?: Maybe<Scalars['Float']>;
  buyerCiattiCommission?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Float']>;
  buyerContactId?: Maybe<Scalars['Float']>;
  buyerDeliveryAddressId?: Maybe<Scalars['Float']>;
  buyerOfficeId?: Maybe<Scalars['Float']>;
  commisionFees?: Maybe<Scalars['Float']>;
  commissionBuyer?: Maybe<Scalars['Float']>;
  commissionCostBase?: Maybe<Scalars['Float']>;
  commissionFeesPerUom?: Maybe<Scalars['Float']>;
  commissionFlatFees?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  commissionQuantityBase?: Maybe<Scalars['Float']>;
  commissionSeller?: Maybe<Scalars['Float']>;
  commissionThirdParty?: Maybe<Scalars['Float']>;
  commissionTotalFees?: Maybe<Scalars['Float']>;
  contractOfficeId?: Maybe<Scalars['Float']>;
  evergreenAgreementId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  quantityOrdered?: Maybe<Scalars['Float']>;
  quantityShipped?: Maybe<Scalars['Float']>;
  sellerBillingAddressId?: Maybe<Scalars['Float']>;
  sellerCiattiCommission?: Maybe<Scalars['Float']>;
  sellerCompanyId?: Maybe<Scalars['Float']>;
  sellerContactId?: Maybe<Scalars['Float']>;
  sellerDeliveryAddressId?: Maybe<Scalars['Float']>;
  sellerOfficeId?: Maybe<Scalars['Float']>;
  thirdPartyCommission?: Maybe<Scalars['Float']>;
  thirdPartyCompanyId?: Maybe<Scalars['Float']>;
  thirdPartyContactId?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "agreements" */
export type Agreements_Stddev_Order_By = {
  buyerBillingAddressId?: InputMaybe<Order_By>;
  buyerCiattiCommission?: InputMaybe<Order_By>;
  buyerCompanyId?: InputMaybe<Order_By>;
  buyerContactId?: InputMaybe<Order_By>;
  buyerDeliveryAddressId?: InputMaybe<Order_By>;
  buyerOfficeId?: InputMaybe<Order_By>;
  commisionFees?: InputMaybe<Order_By>;
  commissionBuyer?: InputMaybe<Order_By>;
  commissionCostBase?: InputMaybe<Order_By>;
  commissionFeesPerUom?: InputMaybe<Order_By>;
  commissionFlatFees?: InputMaybe<Order_By>;
  commissionPercentage?: InputMaybe<Order_By>;
  commissionQuantityBase?: InputMaybe<Order_By>;
  commissionSeller?: InputMaybe<Order_By>;
  commissionThirdParty?: InputMaybe<Order_By>;
  commissionTotalFees?: InputMaybe<Order_By>;
  contractOfficeId?: InputMaybe<Order_By>;
  evergreenAgreementId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantityOrdered?: InputMaybe<Order_By>;
  quantityShipped?: InputMaybe<Order_By>;
  sellerBillingAddressId?: InputMaybe<Order_By>;
  sellerCiattiCommission?: InputMaybe<Order_By>;
  sellerCompanyId?: InputMaybe<Order_By>;
  sellerContactId?: InputMaybe<Order_By>;
  sellerDeliveryAddressId?: InputMaybe<Order_By>;
  sellerOfficeId?: InputMaybe<Order_By>;
  thirdPartyCommission?: InputMaybe<Order_By>;
  thirdPartyCompanyId?: InputMaybe<Order_By>;
  thirdPartyContactId?: InputMaybe<Order_By>;
  totalCost?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Agreements_Stddev_Pop_Fields = {
  __typename?: 'agreements_stddev_pop_fields';
  buyerBillingAddressId?: Maybe<Scalars['Float']>;
  buyerCiattiCommission?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Float']>;
  buyerContactId?: Maybe<Scalars['Float']>;
  buyerDeliveryAddressId?: Maybe<Scalars['Float']>;
  buyerOfficeId?: Maybe<Scalars['Float']>;
  commisionFees?: Maybe<Scalars['Float']>;
  commissionBuyer?: Maybe<Scalars['Float']>;
  commissionCostBase?: Maybe<Scalars['Float']>;
  commissionFeesPerUom?: Maybe<Scalars['Float']>;
  commissionFlatFees?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  commissionQuantityBase?: Maybe<Scalars['Float']>;
  commissionSeller?: Maybe<Scalars['Float']>;
  commissionThirdParty?: Maybe<Scalars['Float']>;
  commissionTotalFees?: Maybe<Scalars['Float']>;
  contractOfficeId?: Maybe<Scalars['Float']>;
  evergreenAgreementId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  quantityOrdered?: Maybe<Scalars['Float']>;
  quantityShipped?: Maybe<Scalars['Float']>;
  sellerBillingAddressId?: Maybe<Scalars['Float']>;
  sellerCiattiCommission?: Maybe<Scalars['Float']>;
  sellerCompanyId?: Maybe<Scalars['Float']>;
  sellerContactId?: Maybe<Scalars['Float']>;
  sellerDeliveryAddressId?: Maybe<Scalars['Float']>;
  sellerOfficeId?: Maybe<Scalars['Float']>;
  thirdPartyCommission?: Maybe<Scalars['Float']>;
  thirdPartyCompanyId?: Maybe<Scalars['Float']>;
  thirdPartyContactId?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "agreements" */
export type Agreements_Stddev_Pop_Order_By = {
  buyerBillingAddressId?: InputMaybe<Order_By>;
  buyerCiattiCommission?: InputMaybe<Order_By>;
  buyerCompanyId?: InputMaybe<Order_By>;
  buyerContactId?: InputMaybe<Order_By>;
  buyerDeliveryAddressId?: InputMaybe<Order_By>;
  buyerOfficeId?: InputMaybe<Order_By>;
  commisionFees?: InputMaybe<Order_By>;
  commissionBuyer?: InputMaybe<Order_By>;
  commissionCostBase?: InputMaybe<Order_By>;
  commissionFeesPerUom?: InputMaybe<Order_By>;
  commissionFlatFees?: InputMaybe<Order_By>;
  commissionPercentage?: InputMaybe<Order_By>;
  commissionQuantityBase?: InputMaybe<Order_By>;
  commissionSeller?: InputMaybe<Order_By>;
  commissionThirdParty?: InputMaybe<Order_By>;
  commissionTotalFees?: InputMaybe<Order_By>;
  contractOfficeId?: InputMaybe<Order_By>;
  evergreenAgreementId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantityOrdered?: InputMaybe<Order_By>;
  quantityShipped?: InputMaybe<Order_By>;
  sellerBillingAddressId?: InputMaybe<Order_By>;
  sellerCiattiCommission?: InputMaybe<Order_By>;
  sellerCompanyId?: InputMaybe<Order_By>;
  sellerContactId?: InputMaybe<Order_By>;
  sellerDeliveryAddressId?: InputMaybe<Order_By>;
  sellerOfficeId?: InputMaybe<Order_By>;
  thirdPartyCommission?: InputMaybe<Order_By>;
  thirdPartyCompanyId?: InputMaybe<Order_By>;
  thirdPartyContactId?: InputMaybe<Order_By>;
  totalCost?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Agreements_Stddev_Samp_Fields = {
  __typename?: 'agreements_stddev_samp_fields';
  buyerBillingAddressId?: Maybe<Scalars['Float']>;
  buyerCiattiCommission?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Float']>;
  buyerContactId?: Maybe<Scalars['Float']>;
  buyerDeliveryAddressId?: Maybe<Scalars['Float']>;
  buyerOfficeId?: Maybe<Scalars['Float']>;
  commisionFees?: Maybe<Scalars['Float']>;
  commissionBuyer?: Maybe<Scalars['Float']>;
  commissionCostBase?: Maybe<Scalars['Float']>;
  commissionFeesPerUom?: Maybe<Scalars['Float']>;
  commissionFlatFees?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  commissionQuantityBase?: Maybe<Scalars['Float']>;
  commissionSeller?: Maybe<Scalars['Float']>;
  commissionThirdParty?: Maybe<Scalars['Float']>;
  commissionTotalFees?: Maybe<Scalars['Float']>;
  contractOfficeId?: Maybe<Scalars['Float']>;
  evergreenAgreementId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  quantityOrdered?: Maybe<Scalars['Float']>;
  quantityShipped?: Maybe<Scalars['Float']>;
  sellerBillingAddressId?: Maybe<Scalars['Float']>;
  sellerCiattiCommission?: Maybe<Scalars['Float']>;
  sellerCompanyId?: Maybe<Scalars['Float']>;
  sellerContactId?: Maybe<Scalars['Float']>;
  sellerDeliveryAddressId?: Maybe<Scalars['Float']>;
  sellerOfficeId?: Maybe<Scalars['Float']>;
  thirdPartyCommission?: Maybe<Scalars['Float']>;
  thirdPartyCompanyId?: Maybe<Scalars['Float']>;
  thirdPartyContactId?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "agreements" */
export type Agreements_Stddev_Samp_Order_By = {
  buyerBillingAddressId?: InputMaybe<Order_By>;
  buyerCiattiCommission?: InputMaybe<Order_By>;
  buyerCompanyId?: InputMaybe<Order_By>;
  buyerContactId?: InputMaybe<Order_By>;
  buyerDeliveryAddressId?: InputMaybe<Order_By>;
  buyerOfficeId?: InputMaybe<Order_By>;
  commisionFees?: InputMaybe<Order_By>;
  commissionBuyer?: InputMaybe<Order_By>;
  commissionCostBase?: InputMaybe<Order_By>;
  commissionFeesPerUom?: InputMaybe<Order_By>;
  commissionFlatFees?: InputMaybe<Order_By>;
  commissionPercentage?: InputMaybe<Order_By>;
  commissionQuantityBase?: InputMaybe<Order_By>;
  commissionSeller?: InputMaybe<Order_By>;
  commissionThirdParty?: InputMaybe<Order_By>;
  commissionTotalFees?: InputMaybe<Order_By>;
  contractOfficeId?: InputMaybe<Order_By>;
  evergreenAgreementId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantityOrdered?: InputMaybe<Order_By>;
  quantityShipped?: InputMaybe<Order_By>;
  sellerBillingAddressId?: InputMaybe<Order_By>;
  sellerCiattiCommission?: InputMaybe<Order_By>;
  sellerCompanyId?: InputMaybe<Order_By>;
  sellerContactId?: InputMaybe<Order_By>;
  sellerDeliveryAddressId?: InputMaybe<Order_By>;
  sellerOfficeId?: InputMaybe<Order_By>;
  thirdPartyCommission?: InputMaybe<Order_By>;
  thirdPartyCompanyId?: InputMaybe<Order_By>;
  thirdPartyContactId?: InputMaybe<Order_By>;
  totalCost?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "agreements" */
export type Agreements_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agreements_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agreements_Stream_Cursor_Value_Input = {
  additionalInformations?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  buyerBillingAddressId?: InputMaybe<Scalars['Int']>;
  buyerBondedWarehouse?: InputMaybe<Scalars['String']>;
  buyerCiattiCommission?: InputMaybe<Scalars['Float']>;
  buyerCompanyId?: InputMaybe<Scalars['Int']>;
  buyerContactId?: InputMaybe<Scalars['Int']>;
  buyerContractRef?: InputMaybe<Scalars['String']>;
  buyerCvi?: InputMaybe<Scalars['String']>;
  buyerDeliveryAddressId?: InputMaybe<Scalars['Int']>;
  buyerEori?: InputMaybe<Scalars['String']>;
  buyerExcise?: InputMaybe<Scalars['String']>;
  buyerFda?: InputMaybe<Scalars['String']>;
  buyerOfficeId?: InputMaybe<Scalars['Int']>;
  buyerSpecsId?: InputMaybe<Scalars['jsonb']>;
  buyerUserId?: InputMaybe<Scalars['String']>;
  buyerUserName?: InputMaybe<Scalars['String']>;
  buyerVat?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  commisionFees?: InputMaybe<Scalars['Float']>;
  commissionBuyer?: InputMaybe<Scalars['Float']>;
  commissionCostBase?: InputMaybe<Scalars['Float']>;
  commissionCurrency?: InputMaybe<Scalars['String']>;
  commissionFeesPerUom?: InputMaybe<Scalars['Float']>;
  commissionFlatFees?: InputMaybe<Scalars['Float']>;
  commissionPercentage?: InputMaybe<Scalars['Float']>;
  commissionQuantityBase?: InputMaybe<Scalars['Float']>;
  commissionSeller?: InputMaybe<Scalars['Float']>;
  commissionThirdParty?: InputMaybe<Scalars['Float']>;
  commissionTotalFees?: InputMaybe<Scalars['Float']>;
  commissionType?: InputMaybe<Scalars['String']>;
  commissionUom?: InputMaybe<Scalars['String']>;
  commodityType?: InputMaybe<Scalars['String']>;
  contractOfficeId?: InputMaybe<Scalars['Int']>;
  contractRevision?: InputMaybe<Scalars['String']>;
  contractStatus?: InputMaybe<Scalars['String']>;
  contractUserId?: InputMaybe<Scalars['String']>;
  costArray?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  endDate?: InputMaybe<Scalars['date']>;
  evergreenAgreementId?: InputMaybe<Scalars['Int']>;
  evergreenContract?: InputMaybe<Scalars['Boolean']>;
  evergreenDates?: InputMaybe<Scalars['jsonb']>;
  files?: InputMaybe<Scalars['jsonb']>;
  fulfillmentsStatus?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  incoterms?: InputMaybe<Scalars['String']>;
  invoicesStatus?: InputMaybe<Scalars['String']>;
  isMultiYearContract?: InputMaybe<Scalars['Boolean']>;
  itemsId?: InputMaybe<Scalars['jsonb']>;
  legacyContractStatus?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  quantityOrdered?: InputMaybe<Scalars['Float']>;
  quantityShipped?: InputMaybe<Scalars['Float']>;
  reminders?: InputMaybe<Scalars['jsonb']>;
  salesOrderNetsuite?: InputMaybe<Scalars['String']>;
  sellerBillingAddressId?: InputMaybe<Scalars['Int']>;
  sellerBondedWarehouse?: InputMaybe<Scalars['String']>;
  sellerCiattiCommission?: InputMaybe<Scalars['Float']>;
  sellerCompanyId?: InputMaybe<Scalars['Int']>;
  sellerContactId?: InputMaybe<Scalars['Int']>;
  sellerContractRef?: InputMaybe<Scalars['String']>;
  sellerCvi?: InputMaybe<Scalars['String']>;
  sellerDeliveryAddressId?: InputMaybe<Scalars['Int']>;
  sellerEori?: InputMaybe<Scalars['String']>;
  sellerExcise?: InputMaybe<Scalars['String']>;
  sellerFda?: InputMaybe<Scalars['String']>;
  sellerOfficeId?: InputMaybe<Scalars['Int']>;
  sellerUserId?: InputMaybe<Scalars['String']>;
  sellerUserName?: InputMaybe<Scalars['String']>;
  sellerVat?: InputMaybe<Scalars['String']>;
  signaturesRequired?: InputMaybe<Scalars['jsonb']>;
  startDate?: InputMaybe<Scalars['date']>;
  terms?: InputMaybe<Scalars['String']>;
  termsAddContract?: InputMaybe<Scalars['String']>;
  termsAddContractViewer?: InputMaybe<Scalars['jsonb']>;
  termsCommission?: InputMaybe<Scalars['String']>;
  termsCommissionViewer?: InputMaybe<Scalars['jsonb']>;
  termsPayment?: InputMaybe<Scalars['String']>;
  termsPaymentViewer?: InputMaybe<Scalars['jsonb']>;
  termsShipping?: InputMaybe<Scalars['String']>;
  termsShippingViewer?: InputMaybe<Scalars['jsonb']>;
  termsViewer?: InputMaybe<Scalars['jsonb']>;
  thirdPartyCommission?: InputMaybe<Scalars['Float']>;
  thirdPartyCompanyId?: InputMaybe<Scalars['Int']>;
  thirdPartyContactId?: InputMaybe<Scalars['Int']>;
  thirdPartyContractRef?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalCost?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usdaGcr?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Agreements_Sum_Fields = {
  __typename?: 'agreements_sum_fields';
  buyerBillingAddressId?: Maybe<Scalars['Int']>;
  buyerCiattiCommission?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Int']>;
  buyerContactId?: Maybe<Scalars['Int']>;
  buyerDeliveryAddressId?: Maybe<Scalars['Int']>;
  buyerOfficeId?: Maybe<Scalars['Int']>;
  commisionFees?: Maybe<Scalars['Float']>;
  commissionBuyer?: Maybe<Scalars['Float']>;
  commissionCostBase?: Maybe<Scalars['Float']>;
  commissionFeesPerUom?: Maybe<Scalars['Float']>;
  commissionFlatFees?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  commissionQuantityBase?: Maybe<Scalars['Float']>;
  commissionSeller?: Maybe<Scalars['Float']>;
  commissionThirdParty?: Maybe<Scalars['Float']>;
  commissionTotalFees?: Maybe<Scalars['Float']>;
  contractOfficeId?: Maybe<Scalars['Int']>;
  evergreenAgreementId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  quantityOrdered?: Maybe<Scalars['Float']>;
  quantityShipped?: Maybe<Scalars['Float']>;
  sellerBillingAddressId?: Maybe<Scalars['Int']>;
  sellerCiattiCommission?: Maybe<Scalars['Float']>;
  sellerCompanyId?: Maybe<Scalars['Int']>;
  sellerContactId?: Maybe<Scalars['Int']>;
  sellerDeliveryAddressId?: Maybe<Scalars['Int']>;
  sellerOfficeId?: Maybe<Scalars['Int']>;
  thirdPartyCommission?: Maybe<Scalars['Float']>;
  thirdPartyCompanyId?: Maybe<Scalars['Int']>;
  thirdPartyContactId?: Maybe<Scalars['Int']>;
  totalCost?: Maybe<Scalars['Float']>;
};

/** order by sum() on columns of table "agreements" */
export type Agreements_Sum_Order_By = {
  buyerBillingAddressId?: InputMaybe<Order_By>;
  buyerCiattiCommission?: InputMaybe<Order_By>;
  buyerCompanyId?: InputMaybe<Order_By>;
  buyerContactId?: InputMaybe<Order_By>;
  buyerDeliveryAddressId?: InputMaybe<Order_By>;
  buyerOfficeId?: InputMaybe<Order_By>;
  commisionFees?: InputMaybe<Order_By>;
  commissionBuyer?: InputMaybe<Order_By>;
  commissionCostBase?: InputMaybe<Order_By>;
  commissionFeesPerUom?: InputMaybe<Order_By>;
  commissionFlatFees?: InputMaybe<Order_By>;
  commissionPercentage?: InputMaybe<Order_By>;
  commissionQuantityBase?: InputMaybe<Order_By>;
  commissionSeller?: InputMaybe<Order_By>;
  commissionThirdParty?: InputMaybe<Order_By>;
  commissionTotalFees?: InputMaybe<Order_By>;
  contractOfficeId?: InputMaybe<Order_By>;
  evergreenAgreementId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantityOrdered?: InputMaybe<Order_By>;
  quantityShipped?: InputMaybe<Order_By>;
  sellerBillingAddressId?: InputMaybe<Order_By>;
  sellerCiattiCommission?: InputMaybe<Order_By>;
  sellerCompanyId?: InputMaybe<Order_By>;
  sellerContactId?: InputMaybe<Order_By>;
  sellerDeliveryAddressId?: InputMaybe<Order_By>;
  sellerOfficeId?: InputMaybe<Order_By>;
  thirdPartyCommission?: InputMaybe<Order_By>;
  thirdPartyCompanyId?: InputMaybe<Order_By>;
  thirdPartyContactId?: InputMaybe<Order_By>;
  totalCost?: InputMaybe<Order_By>;
};

/** update columns of table "agreements" */
export enum Agreements_Update_Column {
  /** column name */
  AdditionalInformations = 'additionalInformations',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BuyerBillingAddressId = 'buyerBillingAddressId',
  /** column name */
  BuyerBondedWarehouse = 'buyerBondedWarehouse',
  /** column name */
  BuyerCiattiCommission = 'buyerCiattiCommission',
  /** column name */
  BuyerCompanyId = 'buyerCompanyId',
  /** column name */
  BuyerContactId = 'buyerContactId',
  /** column name */
  BuyerContractRef = 'buyerContractRef',
  /** column name */
  BuyerCvi = 'buyerCvi',
  /** column name */
  BuyerDeliveryAddressId = 'buyerDeliveryAddressId',
  /** column name */
  BuyerEori = 'buyerEori',
  /** column name */
  BuyerExcise = 'buyerExcise',
  /** column name */
  BuyerFda = 'buyerFda',
  /** column name */
  BuyerOfficeId = 'buyerOfficeId',
  /** column name */
  BuyerSpecsId = 'buyerSpecsId',
  /** column name */
  BuyerUserId = 'buyerUserId',
  /** column name */
  BuyerUserName = 'buyerUserName',
  /** column name */
  BuyerVat = 'buyerVat',
  /** column name */
  Comments = 'comments',
  /** column name */
  CommisionFees = 'commisionFees',
  /** column name */
  CommissionBuyer = 'commissionBuyer',
  /** column name */
  CommissionCostBase = 'commissionCostBase',
  /** column name */
  CommissionCurrency = 'commissionCurrency',
  /** column name */
  CommissionFeesPerUom = 'commissionFeesPerUom',
  /** column name */
  CommissionFlatFees = 'commissionFlatFees',
  /** column name */
  CommissionPercentage = 'commissionPercentage',
  /** column name */
  CommissionQuantityBase = 'commissionQuantityBase',
  /** column name */
  CommissionSeller = 'commissionSeller',
  /** column name */
  CommissionThirdParty = 'commissionThirdParty',
  /** column name */
  CommissionTotalFees = 'commissionTotalFees',
  /** column name */
  CommissionType = 'commissionType',
  /** column name */
  CommissionUom = 'commissionUom',
  /** column name */
  CommodityType = 'commodityType',
  /** column name */
  ContractOfficeId = 'contractOfficeId',
  /** column name */
  ContractRevision = 'contractRevision',
  /** column name */
  ContractStatus = 'contractStatus',
  /** column name */
  ContractUserId = 'contractUserId',
  /** column name */
  CostArray = 'costArray',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  EndDate = 'endDate',
  /** column name */
  EvergreenAgreementId = 'evergreenAgreementId',
  /** column name */
  EvergreenContract = 'evergreenContract',
  /** column name */
  EvergreenDates = 'evergreenDates',
  /** column name */
  Files = 'files',
  /** column name */
  FulfillmentsStatus = 'fulfillmentsStatus',
  /** column name */
  Id = 'id',
  /** column name */
  Incoterms = 'incoterms',
  /** column name */
  InvoicesStatus = 'invoicesStatus',
  /** column name */
  IsMultiYearContract = 'isMultiYearContract',
  /** column name */
  ItemsId = 'itemsId',
  /** column name */
  LegacyContractStatus = 'legacyContractStatus',
  /** column name */
  Place = 'place',
  /** column name */
  QuantityOrdered = 'quantityOrdered',
  /** column name */
  QuantityShipped = 'quantityShipped',
  /** column name */
  Reminders = 'reminders',
  /** column name */
  SalesOrderNetsuite = 'salesOrderNetsuite',
  /** column name */
  SellerBillingAddressId = 'sellerBillingAddressId',
  /** column name */
  SellerBondedWarehouse = 'sellerBondedWarehouse',
  /** column name */
  SellerCiattiCommission = 'sellerCiattiCommission',
  /** column name */
  SellerCompanyId = 'sellerCompanyId',
  /** column name */
  SellerContactId = 'sellerContactId',
  /** column name */
  SellerContractRef = 'sellerContractRef',
  /** column name */
  SellerCvi = 'sellerCvi',
  /** column name */
  SellerDeliveryAddressId = 'sellerDeliveryAddressId',
  /** column name */
  SellerEori = 'sellerEori',
  /** column name */
  SellerExcise = 'sellerExcise',
  /** column name */
  SellerFda = 'sellerFda',
  /** column name */
  SellerOfficeId = 'sellerOfficeId',
  /** column name */
  SellerUserId = 'sellerUserId',
  /** column name */
  SellerUserName = 'sellerUserName',
  /** column name */
  SellerVat = 'sellerVat',
  /** column name */
  SignaturesRequired = 'signaturesRequired',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Terms = 'terms',
  /** column name */
  TermsAddContract = 'termsAddContract',
  /** column name */
  TermsAddContractViewer = 'termsAddContractViewer',
  /** column name */
  TermsCommission = 'termsCommission',
  /** column name */
  TermsCommissionViewer = 'termsCommissionViewer',
  /** column name */
  TermsPayment = 'termsPayment',
  /** column name */
  TermsPaymentViewer = 'termsPaymentViewer',
  /** column name */
  TermsShipping = 'termsShipping',
  /** column name */
  TermsShippingViewer = 'termsShippingViewer',
  /** column name */
  TermsViewer = 'termsViewer',
  /** column name */
  ThirdPartyCommission = 'thirdPartyCommission',
  /** column name */
  ThirdPartyCompanyId = 'thirdPartyCompanyId',
  /** column name */
  ThirdPartyContactId = 'thirdPartyContactId',
  /** column name */
  ThirdPartyContractRef = 'thirdPartyContractRef',
  /** column name */
  Title = 'title',
  /** column name */
  TotalCost = 'totalCost',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsdaGcr = 'usdaGcr'
}

export type Agreements_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Agreements_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Agreements_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Agreements_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Agreements_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Agreements_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Agreements_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Agreements_Set_Input>;
  where: Agreements_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Agreements_Var_Pop_Fields = {
  __typename?: 'agreements_var_pop_fields';
  buyerBillingAddressId?: Maybe<Scalars['Float']>;
  buyerCiattiCommission?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Float']>;
  buyerContactId?: Maybe<Scalars['Float']>;
  buyerDeliveryAddressId?: Maybe<Scalars['Float']>;
  buyerOfficeId?: Maybe<Scalars['Float']>;
  commisionFees?: Maybe<Scalars['Float']>;
  commissionBuyer?: Maybe<Scalars['Float']>;
  commissionCostBase?: Maybe<Scalars['Float']>;
  commissionFeesPerUom?: Maybe<Scalars['Float']>;
  commissionFlatFees?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  commissionQuantityBase?: Maybe<Scalars['Float']>;
  commissionSeller?: Maybe<Scalars['Float']>;
  commissionThirdParty?: Maybe<Scalars['Float']>;
  commissionTotalFees?: Maybe<Scalars['Float']>;
  contractOfficeId?: Maybe<Scalars['Float']>;
  evergreenAgreementId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  quantityOrdered?: Maybe<Scalars['Float']>;
  quantityShipped?: Maybe<Scalars['Float']>;
  sellerBillingAddressId?: Maybe<Scalars['Float']>;
  sellerCiattiCommission?: Maybe<Scalars['Float']>;
  sellerCompanyId?: Maybe<Scalars['Float']>;
  sellerContactId?: Maybe<Scalars['Float']>;
  sellerDeliveryAddressId?: Maybe<Scalars['Float']>;
  sellerOfficeId?: Maybe<Scalars['Float']>;
  thirdPartyCommission?: Maybe<Scalars['Float']>;
  thirdPartyCompanyId?: Maybe<Scalars['Float']>;
  thirdPartyContactId?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "agreements" */
export type Agreements_Var_Pop_Order_By = {
  buyerBillingAddressId?: InputMaybe<Order_By>;
  buyerCiattiCommission?: InputMaybe<Order_By>;
  buyerCompanyId?: InputMaybe<Order_By>;
  buyerContactId?: InputMaybe<Order_By>;
  buyerDeliveryAddressId?: InputMaybe<Order_By>;
  buyerOfficeId?: InputMaybe<Order_By>;
  commisionFees?: InputMaybe<Order_By>;
  commissionBuyer?: InputMaybe<Order_By>;
  commissionCostBase?: InputMaybe<Order_By>;
  commissionFeesPerUom?: InputMaybe<Order_By>;
  commissionFlatFees?: InputMaybe<Order_By>;
  commissionPercentage?: InputMaybe<Order_By>;
  commissionQuantityBase?: InputMaybe<Order_By>;
  commissionSeller?: InputMaybe<Order_By>;
  commissionThirdParty?: InputMaybe<Order_By>;
  commissionTotalFees?: InputMaybe<Order_By>;
  contractOfficeId?: InputMaybe<Order_By>;
  evergreenAgreementId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantityOrdered?: InputMaybe<Order_By>;
  quantityShipped?: InputMaybe<Order_By>;
  sellerBillingAddressId?: InputMaybe<Order_By>;
  sellerCiattiCommission?: InputMaybe<Order_By>;
  sellerCompanyId?: InputMaybe<Order_By>;
  sellerContactId?: InputMaybe<Order_By>;
  sellerDeliveryAddressId?: InputMaybe<Order_By>;
  sellerOfficeId?: InputMaybe<Order_By>;
  thirdPartyCommission?: InputMaybe<Order_By>;
  thirdPartyCompanyId?: InputMaybe<Order_By>;
  thirdPartyContactId?: InputMaybe<Order_By>;
  totalCost?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Agreements_Var_Samp_Fields = {
  __typename?: 'agreements_var_samp_fields';
  buyerBillingAddressId?: Maybe<Scalars['Float']>;
  buyerCiattiCommission?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Float']>;
  buyerContactId?: Maybe<Scalars['Float']>;
  buyerDeliveryAddressId?: Maybe<Scalars['Float']>;
  buyerOfficeId?: Maybe<Scalars['Float']>;
  commisionFees?: Maybe<Scalars['Float']>;
  commissionBuyer?: Maybe<Scalars['Float']>;
  commissionCostBase?: Maybe<Scalars['Float']>;
  commissionFeesPerUom?: Maybe<Scalars['Float']>;
  commissionFlatFees?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  commissionQuantityBase?: Maybe<Scalars['Float']>;
  commissionSeller?: Maybe<Scalars['Float']>;
  commissionThirdParty?: Maybe<Scalars['Float']>;
  commissionTotalFees?: Maybe<Scalars['Float']>;
  contractOfficeId?: Maybe<Scalars['Float']>;
  evergreenAgreementId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  quantityOrdered?: Maybe<Scalars['Float']>;
  quantityShipped?: Maybe<Scalars['Float']>;
  sellerBillingAddressId?: Maybe<Scalars['Float']>;
  sellerCiattiCommission?: Maybe<Scalars['Float']>;
  sellerCompanyId?: Maybe<Scalars['Float']>;
  sellerContactId?: Maybe<Scalars['Float']>;
  sellerDeliveryAddressId?: Maybe<Scalars['Float']>;
  sellerOfficeId?: Maybe<Scalars['Float']>;
  thirdPartyCommission?: Maybe<Scalars['Float']>;
  thirdPartyCompanyId?: Maybe<Scalars['Float']>;
  thirdPartyContactId?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "agreements" */
export type Agreements_Var_Samp_Order_By = {
  buyerBillingAddressId?: InputMaybe<Order_By>;
  buyerCiattiCommission?: InputMaybe<Order_By>;
  buyerCompanyId?: InputMaybe<Order_By>;
  buyerContactId?: InputMaybe<Order_By>;
  buyerDeliveryAddressId?: InputMaybe<Order_By>;
  buyerOfficeId?: InputMaybe<Order_By>;
  commisionFees?: InputMaybe<Order_By>;
  commissionBuyer?: InputMaybe<Order_By>;
  commissionCostBase?: InputMaybe<Order_By>;
  commissionFeesPerUom?: InputMaybe<Order_By>;
  commissionFlatFees?: InputMaybe<Order_By>;
  commissionPercentage?: InputMaybe<Order_By>;
  commissionQuantityBase?: InputMaybe<Order_By>;
  commissionSeller?: InputMaybe<Order_By>;
  commissionThirdParty?: InputMaybe<Order_By>;
  commissionTotalFees?: InputMaybe<Order_By>;
  contractOfficeId?: InputMaybe<Order_By>;
  evergreenAgreementId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantityOrdered?: InputMaybe<Order_By>;
  quantityShipped?: InputMaybe<Order_By>;
  sellerBillingAddressId?: InputMaybe<Order_By>;
  sellerCiattiCommission?: InputMaybe<Order_By>;
  sellerCompanyId?: InputMaybe<Order_By>;
  sellerContactId?: InputMaybe<Order_By>;
  sellerDeliveryAddressId?: InputMaybe<Order_By>;
  sellerOfficeId?: InputMaybe<Order_By>;
  thirdPartyCommission?: InputMaybe<Order_By>;
  thirdPartyCompanyId?: InputMaybe<Order_By>;
  thirdPartyContactId?: InputMaybe<Order_By>;
  totalCost?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Agreements_Variance_Fields = {
  __typename?: 'agreements_variance_fields';
  buyerBillingAddressId?: Maybe<Scalars['Float']>;
  buyerCiattiCommission?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Float']>;
  buyerContactId?: Maybe<Scalars['Float']>;
  buyerDeliveryAddressId?: Maybe<Scalars['Float']>;
  buyerOfficeId?: Maybe<Scalars['Float']>;
  commisionFees?: Maybe<Scalars['Float']>;
  commissionBuyer?: Maybe<Scalars['Float']>;
  commissionCostBase?: Maybe<Scalars['Float']>;
  commissionFeesPerUom?: Maybe<Scalars['Float']>;
  commissionFlatFees?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  commissionQuantityBase?: Maybe<Scalars['Float']>;
  commissionSeller?: Maybe<Scalars['Float']>;
  commissionThirdParty?: Maybe<Scalars['Float']>;
  commissionTotalFees?: Maybe<Scalars['Float']>;
  contractOfficeId?: Maybe<Scalars['Float']>;
  evergreenAgreementId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  quantityOrdered?: Maybe<Scalars['Float']>;
  quantityShipped?: Maybe<Scalars['Float']>;
  sellerBillingAddressId?: Maybe<Scalars['Float']>;
  sellerCiattiCommission?: Maybe<Scalars['Float']>;
  sellerCompanyId?: Maybe<Scalars['Float']>;
  sellerContactId?: Maybe<Scalars['Float']>;
  sellerDeliveryAddressId?: Maybe<Scalars['Float']>;
  sellerOfficeId?: Maybe<Scalars['Float']>;
  thirdPartyCommission?: Maybe<Scalars['Float']>;
  thirdPartyCompanyId?: Maybe<Scalars['Float']>;
  thirdPartyContactId?: Maybe<Scalars['Float']>;
  totalCost?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "agreements" */
export type Agreements_Variance_Order_By = {
  buyerBillingAddressId?: InputMaybe<Order_By>;
  buyerCiattiCommission?: InputMaybe<Order_By>;
  buyerCompanyId?: InputMaybe<Order_By>;
  buyerContactId?: InputMaybe<Order_By>;
  buyerDeliveryAddressId?: InputMaybe<Order_By>;
  buyerOfficeId?: InputMaybe<Order_By>;
  commisionFees?: InputMaybe<Order_By>;
  commissionBuyer?: InputMaybe<Order_By>;
  commissionCostBase?: InputMaybe<Order_By>;
  commissionFeesPerUom?: InputMaybe<Order_By>;
  commissionFlatFees?: InputMaybe<Order_By>;
  commissionPercentage?: InputMaybe<Order_By>;
  commissionQuantityBase?: InputMaybe<Order_By>;
  commissionSeller?: InputMaybe<Order_By>;
  commissionThirdParty?: InputMaybe<Order_By>;
  commissionTotalFees?: InputMaybe<Order_By>;
  contractOfficeId?: InputMaybe<Order_By>;
  evergreenAgreementId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  quantityOrdered?: InputMaybe<Order_By>;
  quantityShipped?: InputMaybe<Order_By>;
  sellerBillingAddressId?: InputMaybe<Order_By>;
  sellerCiattiCommission?: InputMaybe<Order_By>;
  sellerCompanyId?: InputMaybe<Order_By>;
  sellerContactId?: InputMaybe<Order_By>;
  sellerDeliveryAddressId?: InputMaybe<Order_By>;
  sellerOfficeId?: InputMaybe<Order_By>;
  thirdPartyCommission?: InputMaybe<Order_By>;
  thirdPartyCompanyId?: InputMaybe<Order_By>;
  thirdPartyContactId?: InputMaybe<Order_By>;
  totalCost?: InputMaybe<Order_By>;
};

/** columns and relationships of "appellations" */
export type Appellations = {
  __typename?: 'appellations';
  appellation?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  embedding?: Maybe<Scalars['vector']>;
  id: Scalars['Int'];
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subAppellation?: Maybe<Scalars['String']>;
  subRegion?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  vectorText?: Maybe<Scalars['String']>;
};

/** aggregated selection of "appellations" */
export type Appellations_Aggregate = {
  __typename?: 'appellations_aggregate';
  aggregate?: Maybe<Appellations_Aggregate_Fields>;
  nodes: Array<Appellations>;
};

/** aggregate fields of "appellations" */
export type Appellations_Aggregate_Fields = {
  __typename?: 'appellations_aggregate_fields';
  avg?: Maybe<Appellations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Appellations_Max_Fields>;
  min?: Maybe<Appellations_Min_Fields>;
  stddev?: Maybe<Appellations_Stddev_Fields>;
  stddev_pop?: Maybe<Appellations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Appellations_Stddev_Samp_Fields>;
  sum?: Maybe<Appellations_Sum_Fields>;
  var_pop?: Maybe<Appellations_Var_Pop_Fields>;
  var_samp?: Maybe<Appellations_Var_Samp_Fields>;
  variance?: Maybe<Appellations_Variance_Fields>;
};


/** aggregate fields of "appellations" */
export type Appellations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Appellations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Appellations_Avg_Fields = {
  __typename?: 'appellations_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "appellations". All fields are combined with a logical 'AND'. */
export type Appellations_Bool_Exp = {
  _and?: InputMaybe<Array<Appellations_Bool_Exp>>;
  _not?: InputMaybe<Appellations_Bool_Exp>;
  _or?: InputMaybe<Array<Appellations_Bool_Exp>>;
  appellation?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  county?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  embedding?: InputMaybe<Vector_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  subAppellation?: InputMaybe<String_Comparison_Exp>;
  subRegion?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vectorText?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "appellations" */
export enum Appellations_Constraint {
  /** unique or primary key constraint on columns "id" */
  AppellationsPkey = 'appellations_pkey'
}

/** input type for incrementing numeric columns in table "appellations" */
export type Appellations_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "appellations" */
export type Appellations_Insert_Input = {
  appellation?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  embedding?: InputMaybe<Scalars['vector']>;
  id?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subAppellation?: InputMaybe<Scalars['String']>;
  subRegion?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vectorText?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Appellations_Max_Fields = {
  __typename?: 'appellations_max_fields';
  appellation?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subAppellation?: Maybe<Scalars['String']>;
  subRegion?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vectorText?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Appellations_Min_Fields = {
  __typename?: 'appellations_min_fields';
  appellation?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  subAppellation?: Maybe<Scalars['String']>;
  subRegion?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vectorText?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "appellations" */
export type Appellations_Mutation_Response = {
  __typename?: 'appellations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Appellations>;
};

/** on_conflict condition type for table "appellations" */
export type Appellations_On_Conflict = {
  constraint: Appellations_Constraint;
  update_columns?: Array<Appellations_Update_Column>;
  where?: InputMaybe<Appellations_Bool_Exp>;
};

/** Ordering options when selecting data from "appellations". */
export type Appellations_Order_By = {
  appellation?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  county?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  embedding?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  subAppellation?: InputMaybe<Order_By>;
  subRegion?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vectorText?: InputMaybe<Order_By>;
};

/** primary key columns input for table: appellations */
export type Appellations_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "appellations" */
export enum Appellations_Select_Column {
  /** column name */
  Appellation = 'appellation',
  /** column name */
  Country = 'country',
  /** column name */
  County = 'county',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  District = 'district',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Id = 'id',
  /** column name */
  Region = 'region',
  /** column name */
  State = 'state',
  /** column name */
  SubAppellation = 'subAppellation',
  /** column name */
  SubRegion = 'subRegion',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VectorText = 'vectorText'
}

/** input type for updating data in table "appellations" */
export type Appellations_Set_Input = {
  appellation?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  embedding?: InputMaybe<Scalars['vector']>;
  id?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subAppellation?: InputMaybe<Scalars['String']>;
  subRegion?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vectorText?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Appellations_Stddev_Fields = {
  __typename?: 'appellations_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Appellations_Stddev_Pop_Fields = {
  __typename?: 'appellations_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Appellations_Stddev_Samp_Fields = {
  __typename?: 'appellations_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "appellations" */
export type Appellations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Appellations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Appellations_Stream_Cursor_Value_Input = {
  appellation?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  embedding?: InputMaybe<Scalars['vector']>;
  id?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  subAppellation?: InputMaybe<Scalars['String']>;
  subRegion?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vectorText?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Appellations_Sum_Fields = {
  __typename?: 'appellations_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "appellations" */
export enum Appellations_Update_Column {
  /** column name */
  Appellation = 'appellation',
  /** column name */
  Country = 'country',
  /** column name */
  County = 'county',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  District = 'district',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Id = 'id',
  /** column name */
  Region = 'region',
  /** column name */
  State = 'state',
  /** column name */
  SubAppellation = 'subAppellation',
  /** column name */
  SubRegion = 'subRegion',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VectorText = 'vectorText'
}

export type Appellations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Appellations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Appellations_Set_Input>;
  where: Appellations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Appellations_Var_Pop_Fields = {
  __typename?: 'appellations_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Appellations_Var_Samp_Fields = {
  __typename?: 'appellations_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Appellations_Variance_Fields = {
  __typename?: 'appellations_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "authorizedDomains" */
export type AuthorizedDomains = {
  __typename?: 'authorizedDomains';
  deletedAt?: Maybe<Scalars['timestamp']>;
  domain: Scalars['String'];
  id: Scalars['Int'];
};

/** aggregated selection of "authorizedDomains" */
export type AuthorizedDomains_Aggregate = {
  __typename?: 'authorizedDomains_aggregate';
  aggregate?: Maybe<AuthorizedDomains_Aggregate_Fields>;
  nodes: Array<AuthorizedDomains>;
};

/** aggregate fields of "authorizedDomains" */
export type AuthorizedDomains_Aggregate_Fields = {
  __typename?: 'authorizedDomains_aggregate_fields';
  avg?: Maybe<AuthorizedDomains_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AuthorizedDomains_Max_Fields>;
  min?: Maybe<AuthorizedDomains_Min_Fields>;
  stddev?: Maybe<AuthorizedDomains_Stddev_Fields>;
  stddev_pop?: Maybe<AuthorizedDomains_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AuthorizedDomains_Stddev_Samp_Fields>;
  sum?: Maybe<AuthorizedDomains_Sum_Fields>;
  var_pop?: Maybe<AuthorizedDomains_Var_Pop_Fields>;
  var_samp?: Maybe<AuthorizedDomains_Var_Samp_Fields>;
  variance?: Maybe<AuthorizedDomains_Variance_Fields>;
};


/** aggregate fields of "authorizedDomains" */
export type AuthorizedDomains_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthorizedDomains_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type AuthorizedDomains_Avg_Fields = {
  __typename?: 'authorizedDomains_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "authorizedDomains". All fields are combined with a logical 'AND'. */
export type AuthorizedDomains_Bool_Exp = {
  _and?: InputMaybe<Array<AuthorizedDomains_Bool_Exp>>;
  _not?: InputMaybe<AuthorizedDomains_Bool_Exp>;
  _or?: InputMaybe<Array<AuthorizedDomains_Bool_Exp>>;
  deletedAt?: InputMaybe<Timestamp_Comparison_Exp>;
  domain?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "authorizedDomains" */
export enum AuthorizedDomains_Constraint {
  /** unique or primary key constraint on columns "domain" */
  AuhtorizedDomainsDomainKey = 'auhtorizedDomains_domain_key',
  /** unique or primary key constraint on columns "id" */
  AuhtorizedDomainsPkey = 'auhtorizedDomains_pkey'
}

/** input type for incrementing numeric columns in table "authorizedDomains" */
export type AuthorizedDomains_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "authorizedDomains" */
export type AuthorizedDomains_Insert_Input = {
  deletedAt?: InputMaybe<Scalars['timestamp']>;
  domain?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type AuthorizedDomains_Max_Fields = {
  __typename?: 'authorizedDomains_max_fields';
  deletedAt?: Maybe<Scalars['timestamp']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type AuthorizedDomains_Min_Fields = {
  __typename?: 'authorizedDomains_min_fields';
  deletedAt?: Maybe<Scalars['timestamp']>;
  domain?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "authorizedDomains" */
export type AuthorizedDomains_Mutation_Response = {
  __typename?: 'authorizedDomains_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthorizedDomains>;
};

/** on_conflict condition type for table "authorizedDomains" */
export type AuthorizedDomains_On_Conflict = {
  constraint: AuthorizedDomains_Constraint;
  update_columns?: Array<AuthorizedDomains_Update_Column>;
  where?: InputMaybe<AuthorizedDomains_Bool_Exp>;
};

/** Ordering options when selecting data from "authorizedDomains". */
export type AuthorizedDomains_Order_By = {
  deletedAt?: InputMaybe<Order_By>;
  domain?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: authorizedDomains */
export type AuthorizedDomains_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "authorizedDomains" */
export enum AuthorizedDomains_Select_Column {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Domain = 'domain',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "authorizedDomains" */
export type AuthorizedDomains_Set_Input = {
  deletedAt?: InputMaybe<Scalars['timestamp']>;
  domain?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type AuthorizedDomains_Stddev_Fields = {
  __typename?: 'authorizedDomains_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AuthorizedDomains_Stddev_Pop_Fields = {
  __typename?: 'authorizedDomains_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AuthorizedDomains_Stddev_Samp_Fields = {
  __typename?: 'authorizedDomains_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "authorizedDomains" */
export type AuthorizedDomains_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthorizedDomains_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthorizedDomains_Stream_Cursor_Value_Input = {
  deletedAt?: InputMaybe<Scalars['timestamp']>;
  domain?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type AuthorizedDomains_Sum_Fields = {
  __typename?: 'authorizedDomains_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "authorizedDomains" */
export enum AuthorizedDomains_Update_Column {
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Domain = 'domain',
  /** column name */
  Id = 'id'
}

export type AuthorizedDomains_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AuthorizedDomains_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthorizedDomains_Set_Input>;
  where: AuthorizedDomains_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AuthorizedDomains_Var_Pop_Fields = {
  __typename?: 'authorizedDomains_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AuthorizedDomains_Var_Samp_Fields = {
  __typename?: 'authorizedDomains_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AuthorizedDomains_Variance_Fields = {
  __typename?: 'authorizedDomains_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "buySpecs" */
export type BuySpecs = {
  __typename?: 'buySpecs';
  alcohol?: Maybe<Scalars['Float']>;
  appellations?: Maybe<Scalars['jsonb']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  askPrice?: Maybe<Scalars['Float']>;
  brokerId?: Maybe<Scalars['String']>;
  buyerAddressId?: Maybe<Scalars['Int']>;
  buyerCompanyId: Scalars['Int'];
  buyerContactId?: Maybe<Scalars['Int']>;
  certifications?: Maybe<Scalars['jsonb']>;
  comments?: Maybe<Scalars['String']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  commissionPercentage: Scalars['Float'];
  commodityType: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  deadline?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  files?: Maybe<Scalars['jsonb']>;
  generic?: Maybe<Scalars['String']>;
  harvestMethod?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isOpportunistic: Scalars['Boolean'];
  /** An array relationship */
  matchingItemsBuySpecs: Array<MatchingItemsBuySpecs>;
  /** An aggregate relationship */
  matchingItemsBuySpecs_aggregate: MatchingItemsBuySpecs_Aggregate;
  officeId?: Maybe<Scalars['Int']>;
  qualities?: Maybe<Scalars['jsonb']>;
  quantityNeeded?: Maybe<Scalars['Float']>;
  region?: Maybe<Scalars['String']>;
  /** An array relationship */
  sampleShipmentRequests: Array<SampleShipmentRequests>;
  /** An aggregate relationship */
  sampleShipmentRequests_aggregate: SampleShipmentRequests_Aggregate;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subAppellation?: Maybe<Scalars['String']>;
  subGeneric?: Maybe<Scalars['String']>;
  subRegion?: Maybe<Scalars['String']>;
  uom?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  varietals?: Maybe<Scalars['jsonb']>;
  vintages?: Maybe<Scalars['jsonb']>;
};


/** columns and relationships of "buySpecs" */
export type BuySpecsAppellationsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "buySpecs" */
export type BuySpecsCertificationsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "buySpecs" */
export type BuySpecsFilesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "buySpecs" */
export type BuySpecsMatchingItemsBuySpecsArgs = {
  distinct_on?: InputMaybe<Array<MatchingItemsBuySpecs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MatchingItemsBuySpecs_Order_By>>;
  where?: InputMaybe<MatchingItemsBuySpecs_Bool_Exp>;
};


/** columns and relationships of "buySpecs" */
export type BuySpecsMatchingItemsBuySpecs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MatchingItemsBuySpecs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MatchingItemsBuySpecs_Order_By>>;
  where?: InputMaybe<MatchingItemsBuySpecs_Bool_Exp>;
};


/** columns and relationships of "buySpecs" */
export type BuySpecsQualitiesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "buySpecs" */
export type BuySpecsSampleShipmentRequestsArgs = {
  distinct_on?: InputMaybe<Array<SampleShipmentRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleShipmentRequests_Order_By>>;
  where?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
};


/** columns and relationships of "buySpecs" */
export type BuySpecsSampleShipmentRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SampleShipmentRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleShipmentRequests_Order_By>>;
  where?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
};


/** columns and relationships of "buySpecs" */
export type BuySpecsVarietalsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "buySpecs" */
export type BuySpecsVintagesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "buySpecs" */
export type BuySpecs_Aggregate = {
  __typename?: 'buySpecs_aggregate';
  aggregate?: Maybe<BuySpecs_Aggregate_Fields>;
  nodes: Array<BuySpecs>;
};

/** aggregate fields of "buySpecs" */
export type BuySpecs_Aggregate_Fields = {
  __typename?: 'buySpecs_aggregate_fields';
  avg?: Maybe<BuySpecs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<BuySpecs_Max_Fields>;
  min?: Maybe<BuySpecs_Min_Fields>;
  stddev?: Maybe<BuySpecs_Stddev_Fields>;
  stddev_pop?: Maybe<BuySpecs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<BuySpecs_Stddev_Samp_Fields>;
  sum?: Maybe<BuySpecs_Sum_Fields>;
  var_pop?: Maybe<BuySpecs_Var_Pop_Fields>;
  var_samp?: Maybe<BuySpecs_Var_Samp_Fields>;
  variance?: Maybe<BuySpecs_Variance_Fields>;
};


/** aggregate fields of "buySpecs" */
export type BuySpecs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<BuySpecs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BuySpecs_Append_Input = {
  appellations?: InputMaybe<Scalars['jsonb']>;
  certifications?: InputMaybe<Scalars['jsonb']>;
  files?: InputMaybe<Scalars['jsonb']>;
  qualities?: InputMaybe<Scalars['jsonb']>;
  varietals?: InputMaybe<Scalars['jsonb']>;
  vintages?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type BuySpecs_Avg_Fields = {
  __typename?: 'buySpecs_avg_fields';
  alcohol?: Maybe<Scalars['Float']>;
  askPrice?: Maybe<Scalars['Float']>;
  buyerAddressId?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Float']>;
  buyerContactId?: Maybe<Scalars['Float']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quantityNeeded?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "buySpecs". All fields are combined with a logical 'AND'. */
export type BuySpecs_Bool_Exp = {
  _and?: InputMaybe<Array<BuySpecs_Bool_Exp>>;
  _not?: InputMaybe<BuySpecs_Bool_Exp>;
  _or?: InputMaybe<Array<BuySpecs_Bool_Exp>>;
  alcohol?: InputMaybe<Float_Comparison_Exp>;
  appellations?: InputMaybe<Jsonb_Comparison_Exp>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  askPrice?: InputMaybe<Float_Comparison_Exp>;
  brokerId?: InputMaybe<String_Comparison_Exp>;
  buyerAddressId?: InputMaybe<Int_Comparison_Exp>;
  buyerCompanyId?: InputMaybe<Int_Comparison_Exp>;
  buyerContactId?: InputMaybe<Int_Comparison_Exp>;
  certifications?: InputMaybe<Jsonb_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  commissionAmount?: InputMaybe<Float_Comparison_Exp>;
  commissionPercentage?: InputMaybe<Float_Comparison_Exp>;
  commodityType?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  county?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  deadline?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  files?: InputMaybe<Jsonb_Comparison_Exp>;
  generic?: InputMaybe<String_Comparison_Exp>;
  harvestMethod?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isOpportunistic?: InputMaybe<Boolean_Comparison_Exp>;
  matchingItemsBuySpecs?: InputMaybe<MatchingItemsBuySpecs_Bool_Exp>;
  matchingItemsBuySpecs_aggregate?: InputMaybe<MatchingItemsBuySpecs_Aggregate_Bool_Exp>;
  officeId?: InputMaybe<Int_Comparison_Exp>;
  qualities?: InputMaybe<Jsonb_Comparison_Exp>;
  quantityNeeded?: InputMaybe<Float_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  sampleShipmentRequests?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
  sampleShipmentRequests_aggregate?: InputMaybe<SampleShipmentRequests_Aggregate_Bool_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subAppellation?: InputMaybe<String_Comparison_Exp>;
  subGeneric?: InputMaybe<String_Comparison_Exp>;
  subRegion?: InputMaybe<String_Comparison_Exp>;
  uom?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  varietals?: InputMaybe<Jsonb_Comparison_Exp>;
  vintages?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "buySpecs" */
export enum BuySpecs_Constraint {
  /** unique or primary key constraint on columns "id" */
  BuySpecsPkey = 'buySpecs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BuySpecs_Delete_At_Path_Input = {
  appellations?: InputMaybe<Array<Scalars['String']>>;
  certifications?: InputMaybe<Array<Scalars['String']>>;
  files?: InputMaybe<Array<Scalars['String']>>;
  qualities?: InputMaybe<Array<Scalars['String']>>;
  varietals?: InputMaybe<Array<Scalars['String']>>;
  vintages?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BuySpecs_Delete_Elem_Input = {
  appellations?: InputMaybe<Scalars['Int']>;
  certifications?: InputMaybe<Scalars['Int']>;
  files?: InputMaybe<Scalars['Int']>;
  qualities?: InputMaybe<Scalars['Int']>;
  varietals?: InputMaybe<Scalars['Int']>;
  vintages?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BuySpecs_Delete_Key_Input = {
  appellations?: InputMaybe<Scalars['String']>;
  certifications?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['String']>;
  qualities?: InputMaybe<Scalars['String']>;
  varietals?: InputMaybe<Scalars['String']>;
  vintages?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "buySpecs" */
export type BuySpecs_Inc_Input = {
  alcohol?: InputMaybe<Scalars['Float']>;
  askPrice?: InputMaybe<Scalars['Float']>;
  buyerAddressId?: InputMaybe<Scalars['Int']>;
  buyerCompanyId?: InputMaybe<Scalars['Int']>;
  buyerContactId?: InputMaybe<Scalars['Int']>;
  commissionAmount?: InputMaybe<Scalars['Float']>;
  commissionPercentage?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Int']>;
  officeId?: InputMaybe<Scalars['Int']>;
  quantityNeeded?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "buySpecs" */
export type BuySpecs_Insert_Input = {
  alcohol?: InputMaybe<Scalars['Float']>;
  appellations?: InputMaybe<Scalars['jsonb']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  askPrice?: InputMaybe<Scalars['Float']>;
  brokerId?: InputMaybe<Scalars['String']>;
  buyerAddressId?: InputMaybe<Scalars['Int']>;
  buyerCompanyId?: InputMaybe<Scalars['Int']>;
  buyerContactId?: InputMaybe<Scalars['Int']>;
  certifications?: InputMaybe<Scalars['jsonb']>;
  comments?: InputMaybe<Scalars['String']>;
  commissionAmount?: InputMaybe<Scalars['Float']>;
  commissionPercentage?: InputMaybe<Scalars['Float']>;
  commodityType?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  generic?: InputMaybe<Scalars['String']>;
  harvestMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isOpportunistic?: InputMaybe<Scalars['Boolean']>;
  matchingItemsBuySpecs?: InputMaybe<MatchingItemsBuySpecs_Arr_Rel_Insert_Input>;
  officeId?: InputMaybe<Scalars['Int']>;
  qualities?: InputMaybe<Scalars['jsonb']>;
  quantityNeeded?: InputMaybe<Scalars['Float']>;
  region?: InputMaybe<Scalars['String']>;
  sampleShipmentRequests?: InputMaybe<SampleShipmentRequests_Arr_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subAppellation?: InputMaybe<Scalars['String']>;
  subGeneric?: InputMaybe<Scalars['String']>;
  subRegion?: InputMaybe<Scalars['String']>;
  uom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  varietals?: InputMaybe<Scalars['jsonb']>;
  vintages?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type BuySpecs_Max_Fields = {
  __typename?: 'buySpecs_max_fields';
  alcohol?: Maybe<Scalars['Float']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  askPrice?: Maybe<Scalars['Float']>;
  brokerId?: Maybe<Scalars['String']>;
  buyerAddressId?: Maybe<Scalars['Int']>;
  buyerCompanyId?: Maybe<Scalars['Int']>;
  buyerContactId?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['String']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  commodityType?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  deadline?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  generic?: Maybe<Scalars['String']>;
  harvestMethod?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  officeId?: Maybe<Scalars['Int']>;
  quantityNeeded?: Maybe<Scalars['Float']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subAppellation?: Maybe<Scalars['String']>;
  subGeneric?: Maybe<Scalars['String']>;
  subRegion?: Maybe<Scalars['String']>;
  uom?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type BuySpecs_Min_Fields = {
  __typename?: 'buySpecs_min_fields';
  alcohol?: Maybe<Scalars['Float']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  askPrice?: Maybe<Scalars['Float']>;
  brokerId?: Maybe<Scalars['String']>;
  buyerAddressId?: Maybe<Scalars['Int']>;
  buyerCompanyId?: Maybe<Scalars['Int']>;
  buyerContactId?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['String']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  commodityType?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  deadline?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  generic?: Maybe<Scalars['String']>;
  harvestMethod?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  officeId?: Maybe<Scalars['Int']>;
  quantityNeeded?: Maybe<Scalars['Float']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subAppellation?: Maybe<Scalars['String']>;
  subGeneric?: Maybe<Scalars['String']>;
  subRegion?: Maybe<Scalars['String']>;
  uom?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "buySpecs" */
export type BuySpecs_Mutation_Response = {
  __typename?: 'buySpecs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<BuySpecs>;
};

/** input type for inserting object relation for remote table "buySpecs" */
export type BuySpecs_Obj_Rel_Insert_Input = {
  data: BuySpecs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<BuySpecs_On_Conflict>;
};

/** on_conflict condition type for table "buySpecs" */
export type BuySpecs_On_Conflict = {
  constraint: BuySpecs_Constraint;
  update_columns?: Array<BuySpecs_Update_Column>;
  where?: InputMaybe<BuySpecs_Bool_Exp>;
};

/** Ordering options when selecting data from "buySpecs". */
export type BuySpecs_Order_By = {
  alcohol?: InputMaybe<Order_By>;
  appellations?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  askPrice?: InputMaybe<Order_By>;
  brokerId?: InputMaybe<Order_By>;
  buyerAddressId?: InputMaybe<Order_By>;
  buyerCompanyId?: InputMaybe<Order_By>;
  buyerContactId?: InputMaybe<Order_By>;
  certifications?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  commissionAmount?: InputMaybe<Order_By>;
  commissionPercentage?: InputMaybe<Order_By>;
  commodityType?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  county?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  files?: InputMaybe<Order_By>;
  generic?: InputMaybe<Order_By>;
  harvestMethod?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isOpportunistic?: InputMaybe<Order_By>;
  matchingItemsBuySpecs_aggregate?: InputMaybe<MatchingItemsBuySpecs_Aggregate_Order_By>;
  officeId?: InputMaybe<Order_By>;
  qualities?: InputMaybe<Order_By>;
  quantityNeeded?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  sampleShipmentRequests_aggregate?: InputMaybe<SampleShipmentRequests_Aggregate_Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subAppellation?: InputMaybe<Order_By>;
  subGeneric?: InputMaybe<Order_By>;
  subRegion?: InputMaybe<Order_By>;
  uom?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  varietals?: InputMaybe<Order_By>;
  vintages?: InputMaybe<Order_By>;
};

/** primary key columns input for table: buySpecs */
export type BuySpecs_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BuySpecs_Prepend_Input = {
  appellations?: InputMaybe<Scalars['jsonb']>;
  certifications?: InputMaybe<Scalars['jsonb']>;
  files?: InputMaybe<Scalars['jsonb']>;
  qualities?: InputMaybe<Scalars['jsonb']>;
  varietals?: InputMaybe<Scalars['jsonb']>;
  vintages?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "buySpecs" */
export enum BuySpecs_Select_Column {
  /** column name */
  Alcohol = 'alcohol',
  /** column name */
  Appellations = 'appellations',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  AskPrice = 'askPrice',
  /** column name */
  BrokerId = 'brokerId',
  /** column name */
  BuyerAddressId = 'buyerAddressId',
  /** column name */
  BuyerCompanyId = 'buyerCompanyId',
  /** column name */
  BuyerContactId = 'buyerContactId',
  /** column name */
  Certifications = 'certifications',
  /** column name */
  Comments = 'comments',
  /** column name */
  CommissionAmount = 'commissionAmount',
  /** column name */
  CommissionPercentage = 'commissionPercentage',
  /** column name */
  CommodityType = 'commodityType',
  /** column name */
  Country = 'country',
  /** column name */
  County = 'county',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Currency = 'currency',
  /** column name */
  Deadline = 'deadline',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  District = 'district',
  /** column name */
  Files = 'files',
  /** column name */
  Generic = 'generic',
  /** column name */
  HarvestMethod = 'harvestMethod',
  /** column name */
  Id = 'id',
  /** column name */
  IsOpportunistic = 'isOpportunistic',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  Qualities = 'qualities',
  /** column name */
  QuantityNeeded = 'quantityNeeded',
  /** column name */
  Region = 'region',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  SubAppellation = 'subAppellation',
  /** column name */
  SubGeneric = 'subGeneric',
  /** column name */
  SubRegion = 'subRegion',
  /** column name */
  Uom = 'uom',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Varietals = 'varietals',
  /** column name */
  Vintages = 'vintages'
}

/** input type for updating data in table "buySpecs" */
export type BuySpecs_Set_Input = {
  alcohol?: InputMaybe<Scalars['Float']>;
  appellations?: InputMaybe<Scalars['jsonb']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  askPrice?: InputMaybe<Scalars['Float']>;
  brokerId?: InputMaybe<Scalars['String']>;
  buyerAddressId?: InputMaybe<Scalars['Int']>;
  buyerCompanyId?: InputMaybe<Scalars['Int']>;
  buyerContactId?: InputMaybe<Scalars['Int']>;
  certifications?: InputMaybe<Scalars['jsonb']>;
  comments?: InputMaybe<Scalars['String']>;
  commissionAmount?: InputMaybe<Scalars['Float']>;
  commissionPercentage?: InputMaybe<Scalars['Float']>;
  commodityType?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  generic?: InputMaybe<Scalars['String']>;
  harvestMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isOpportunistic?: InputMaybe<Scalars['Boolean']>;
  officeId?: InputMaybe<Scalars['Int']>;
  qualities?: InputMaybe<Scalars['jsonb']>;
  quantityNeeded?: InputMaybe<Scalars['Float']>;
  region?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subAppellation?: InputMaybe<Scalars['String']>;
  subGeneric?: InputMaybe<Scalars['String']>;
  subRegion?: InputMaybe<Scalars['String']>;
  uom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  varietals?: InputMaybe<Scalars['jsonb']>;
  vintages?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type BuySpecs_Stddev_Fields = {
  __typename?: 'buySpecs_stddev_fields';
  alcohol?: Maybe<Scalars['Float']>;
  askPrice?: Maybe<Scalars['Float']>;
  buyerAddressId?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Float']>;
  buyerContactId?: Maybe<Scalars['Float']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quantityNeeded?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type BuySpecs_Stddev_Pop_Fields = {
  __typename?: 'buySpecs_stddev_pop_fields';
  alcohol?: Maybe<Scalars['Float']>;
  askPrice?: Maybe<Scalars['Float']>;
  buyerAddressId?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Float']>;
  buyerContactId?: Maybe<Scalars['Float']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quantityNeeded?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type BuySpecs_Stddev_Samp_Fields = {
  __typename?: 'buySpecs_stddev_samp_fields';
  alcohol?: Maybe<Scalars['Float']>;
  askPrice?: Maybe<Scalars['Float']>;
  buyerAddressId?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Float']>;
  buyerContactId?: Maybe<Scalars['Float']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quantityNeeded?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "buySpecs" */
export type BuySpecs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: BuySpecs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type BuySpecs_Stream_Cursor_Value_Input = {
  alcohol?: InputMaybe<Scalars['Float']>;
  appellations?: InputMaybe<Scalars['jsonb']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  askPrice?: InputMaybe<Scalars['Float']>;
  brokerId?: InputMaybe<Scalars['String']>;
  buyerAddressId?: InputMaybe<Scalars['Int']>;
  buyerCompanyId?: InputMaybe<Scalars['Int']>;
  buyerContactId?: InputMaybe<Scalars['Int']>;
  certifications?: InputMaybe<Scalars['jsonb']>;
  comments?: InputMaybe<Scalars['String']>;
  commissionAmount?: InputMaybe<Scalars['Float']>;
  commissionPercentage?: InputMaybe<Scalars['Float']>;
  commodityType?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  generic?: InputMaybe<Scalars['String']>;
  harvestMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isOpportunistic?: InputMaybe<Scalars['Boolean']>;
  officeId?: InputMaybe<Scalars['Int']>;
  qualities?: InputMaybe<Scalars['jsonb']>;
  quantityNeeded?: InputMaybe<Scalars['Float']>;
  region?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  subAppellation?: InputMaybe<Scalars['String']>;
  subGeneric?: InputMaybe<Scalars['String']>;
  subRegion?: InputMaybe<Scalars['String']>;
  uom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  varietals?: InputMaybe<Scalars['jsonb']>;
  vintages?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type BuySpecs_Sum_Fields = {
  __typename?: 'buySpecs_sum_fields';
  alcohol?: Maybe<Scalars['Float']>;
  askPrice?: Maybe<Scalars['Float']>;
  buyerAddressId?: Maybe<Scalars['Int']>;
  buyerCompanyId?: Maybe<Scalars['Int']>;
  buyerContactId?: Maybe<Scalars['Int']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  officeId?: Maybe<Scalars['Int']>;
  quantityNeeded?: Maybe<Scalars['Float']>;
};

/** update columns of table "buySpecs" */
export enum BuySpecs_Update_Column {
  /** column name */
  Alcohol = 'alcohol',
  /** column name */
  Appellations = 'appellations',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  AskPrice = 'askPrice',
  /** column name */
  BrokerId = 'brokerId',
  /** column name */
  BuyerAddressId = 'buyerAddressId',
  /** column name */
  BuyerCompanyId = 'buyerCompanyId',
  /** column name */
  BuyerContactId = 'buyerContactId',
  /** column name */
  Certifications = 'certifications',
  /** column name */
  Comments = 'comments',
  /** column name */
  CommissionAmount = 'commissionAmount',
  /** column name */
  CommissionPercentage = 'commissionPercentage',
  /** column name */
  CommodityType = 'commodityType',
  /** column name */
  Country = 'country',
  /** column name */
  County = 'county',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Currency = 'currency',
  /** column name */
  Deadline = 'deadline',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  District = 'district',
  /** column name */
  Files = 'files',
  /** column name */
  Generic = 'generic',
  /** column name */
  HarvestMethod = 'harvestMethod',
  /** column name */
  Id = 'id',
  /** column name */
  IsOpportunistic = 'isOpportunistic',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  Qualities = 'qualities',
  /** column name */
  QuantityNeeded = 'quantityNeeded',
  /** column name */
  Region = 'region',
  /** column name */
  State = 'state',
  /** column name */
  Status = 'status',
  /** column name */
  SubAppellation = 'subAppellation',
  /** column name */
  SubGeneric = 'subGeneric',
  /** column name */
  SubRegion = 'subRegion',
  /** column name */
  Uom = 'uom',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Varietals = 'varietals',
  /** column name */
  Vintages = 'vintages'
}

export type BuySpecs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BuySpecs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<BuySpecs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<BuySpecs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<BuySpecs_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BuySpecs_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BuySpecs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BuySpecs_Set_Input>;
  where: BuySpecs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type BuySpecs_Var_Pop_Fields = {
  __typename?: 'buySpecs_var_pop_fields';
  alcohol?: Maybe<Scalars['Float']>;
  askPrice?: Maybe<Scalars['Float']>;
  buyerAddressId?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Float']>;
  buyerContactId?: Maybe<Scalars['Float']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quantityNeeded?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type BuySpecs_Var_Samp_Fields = {
  __typename?: 'buySpecs_var_samp_fields';
  alcohol?: Maybe<Scalars['Float']>;
  askPrice?: Maybe<Scalars['Float']>;
  buyerAddressId?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Float']>;
  buyerContactId?: Maybe<Scalars['Float']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quantityNeeded?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type BuySpecs_Variance_Fields = {
  __typename?: 'buySpecs_variance_fields';
  alcohol?: Maybe<Scalars['Float']>;
  askPrice?: Maybe<Scalars['Float']>;
  buyerAddressId?: Maybe<Scalars['Float']>;
  buyerCompanyId?: Maybe<Scalars['Float']>;
  buyerContactId?: Maybe<Scalars['Float']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  commissionPercentage?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quantityNeeded?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "companies" */
export type Companies = {
  __typename?: 'companies';
  /** An array relationship */
  agreementsBuyerCompany: Array<Agreements>;
  /** An aggregate relationship */
  agreementsBuyerCompany_aggregate: Agreements_Aggregate;
  /** An array relationship */
  agreementsSellerCompany: Array<Agreements>;
  /** An aggregate relationship */
  agreementsSellerCompany_aggregate: Agreements_Aggregate;
  /** An array relationship */
  agreementsThirdPartyCompany: Array<Agreements>;
  /** An aggregate relationship */
  agreementsThirdPartyCompany_aggregate: Agreements_Aggregate;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  broker?: Maybe<Users>;
  brokerId?: Maybe<Scalars['String']>;
  brokerName?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  certifications: Scalars['jsonb'];
  comments?: Maybe<Scalars['String']>;
  /** An array relationship */
  companyAddresses: Array<CompanyAddress>;
  /** An aggregate relationship */
  companyAddresses_aggregate: CompanyAddress_Aggregate;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy: Scalars['String'];
  cvi?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  dun?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  embedding?: Maybe<Scalars['vector']>;
  eori?: Maybe<Scalars['String']>;
  excise?: Maybe<Scalars['String']>;
  fda?: Maybe<Scalars['String']>;
  files?: Maybe<Scalars['jsonb']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  officeId?: Maybe<Scalars['Int']>;
  officialId?: Maybe<Scalars['String']>;
  parentCompany?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  scoring?: Maybe<Scalars['String']>;
  targetObjective?: Maybe<Scalars['Float']>;
  targetObjectiveCurrency?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vat?: Maybe<Scalars['String']>;
  vectorText?: Maybe<Scalars['String']>;
};


/** columns and relationships of "companies" */
export type CompaniesAgreementsBuyerCompanyArgs = {
  distinct_on?: InputMaybe<Array<Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreements_Order_By>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesAgreementsBuyerCompany_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreements_Order_By>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesAgreementsSellerCompanyArgs = {
  distinct_on?: InputMaybe<Array<Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreements_Order_By>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesAgreementsSellerCompany_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreements_Order_By>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesAgreementsThirdPartyCompanyArgs = {
  distinct_on?: InputMaybe<Array<Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreements_Order_By>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesAgreementsThirdPartyCompany_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreements_Order_By>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesCertificationsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "companies" */
export type CompaniesCompanyAddressesArgs = {
  distinct_on?: InputMaybe<Array<CompanyAddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyAddress_Order_By>>;
  where?: InputMaybe<CompanyAddress_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesCompanyAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyAddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyAddress_Order_By>>;
  where?: InputMaybe<CompanyAddress_Bool_Exp>;
};


/** columns and relationships of "companies" */
export type CompaniesFilesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "companies" */
export type Companies_Aggregate = {
  __typename?: 'companies_aggregate';
  aggregate?: Maybe<Companies_Aggregate_Fields>;
  nodes: Array<Companies>;
};

/** aggregate fields of "companies" */
export type Companies_Aggregate_Fields = {
  __typename?: 'companies_aggregate_fields';
  avg?: Maybe<Companies_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Companies_Max_Fields>;
  min?: Maybe<Companies_Min_Fields>;
  stddev?: Maybe<Companies_Stddev_Fields>;
  stddev_pop?: Maybe<Companies_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Companies_Stddev_Samp_Fields>;
  sum?: Maybe<Companies_Sum_Fields>;
  var_pop?: Maybe<Companies_Var_Pop_Fields>;
  var_samp?: Maybe<Companies_Var_Samp_Fields>;
  variance?: Maybe<Companies_Variance_Fields>;
};


/** aggregate fields of "companies" */
export type Companies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Companies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Companies_Append_Input = {
  certifications?: InputMaybe<Scalars['jsonb']>;
  files?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Companies_Avg_Fields = {
  __typename?: 'companies_avg_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  targetObjective?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "companies". All fields are combined with a logical 'AND'. */
export type Companies_Bool_Exp = {
  _and?: InputMaybe<Array<Companies_Bool_Exp>>;
  _not?: InputMaybe<Companies_Bool_Exp>;
  _or?: InputMaybe<Array<Companies_Bool_Exp>>;
  agreementsBuyerCompany?: InputMaybe<Agreements_Bool_Exp>;
  agreementsBuyerCompany_aggregate?: InputMaybe<Agreements_Aggregate_Bool_Exp>;
  agreementsSellerCompany?: InputMaybe<Agreements_Bool_Exp>;
  agreementsSellerCompany_aggregate?: InputMaybe<Agreements_Aggregate_Bool_Exp>;
  agreementsThirdPartyCompany?: InputMaybe<Agreements_Bool_Exp>;
  agreementsThirdPartyCompany_aggregate?: InputMaybe<Agreements_Aggregate_Bool_Exp>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  broker?: InputMaybe<Users_Bool_Exp>;
  brokerId?: InputMaybe<String_Comparison_Exp>;
  brokerName?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  certifications?: InputMaybe<Jsonb_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  companyAddresses?: InputMaybe<CompanyAddress_Bool_Exp>;
  companyAddresses_aggregate?: InputMaybe<CompanyAddress_Aggregate_Bool_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  cvi?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dun?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  embedding?: InputMaybe<Vector_Comparison_Exp>;
  eori?: InputMaybe<String_Comparison_Exp>;
  excise?: InputMaybe<String_Comparison_Exp>;
  fda?: InputMaybe<String_Comparison_Exp>;
  files?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  officeId?: InputMaybe<Int_Comparison_Exp>;
  officialId?: InputMaybe<String_Comparison_Exp>;
  parentCompany?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  scoring?: InputMaybe<String_Comparison_Exp>;
  targetObjective?: InputMaybe<Float_Comparison_Exp>;
  targetObjectiveCurrency?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  vat?: InputMaybe<String_Comparison_Exp>;
  vectorText?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "companies" */
export enum Companies_Constraint {
  /** unique or primary key constraint on columns "name" */
  CompaniesNameKey = 'companies_name_key',
  /** unique or primary key constraint on columns "id" */
  CompaniesPkey = 'companies_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Companies_Delete_At_Path_Input = {
  certifications?: InputMaybe<Array<Scalars['String']>>;
  files?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Companies_Delete_Elem_Input = {
  certifications?: InputMaybe<Scalars['Int']>;
  files?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Companies_Delete_Key_Input = {
  certifications?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "companies" */
export type Companies_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  officeId?: InputMaybe<Scalars['Int']>;
  targetObjective?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "companies" */
export type Companies_Insert_Input = {
  agreementsBuyerCompany?: InputMaybe<Agreements_Arr_Rel_Insert_Input>;
  agreementsSellerCompany?: InputMaybe<Agreements_Arr_Rel_Insert_Input>;
  agreementsThirdPartyCompany?: InputMaybe<Agreements_Arr_Rel_Insert_Input>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  brokerId?: InputMaybe<Scalars['String']>;
  brokerName?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  certifications?: InputMaybe<Scalars['jsonb']>;
  comments?: InputMaybe<Scalars['String']>;
  companyAddresses?: InputMaybe<CompanyAddress_Arr_Rel_Insert_Input>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  cvi?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  dun?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  embedding?: InputMaybe<Scalars['vector']>;
  eori?: InputMaybe<Scalars['String']>;
  excise?: InputMaybe<Scalars['String']>;
  fda?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Int']>;
  officialId?: InputMaybe<Scalars['String']>;
  parentCompany?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  scoring?: InputMaybe<Scalars['String']>;
  targetObjective?: InputMaybe<Scalars['Float']>;
  targetObjectiveCurrency?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vat?: InputMaybe<Scalars['String']>;
  vectorText?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Companies_Max_Fields = {
  __typename?: 'companies_max_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId?: Maybe<Scalars['String']>;
  brokerName?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  cvi?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  dun?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  eori?: Maybe<Scalars['String']>;
  excise?: Maybe<Scalars['String']>;
  fda?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  officeId?: Maybe<Scalars['Int']>;
  officialId?: Maybe<Scalars['String']>;
  parentCompany?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  scoring?: Maybe<Scalars['String']>;
  targetObjective?: Maybe<Scalars['Float']>;
  targetObjectiveCurrency?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vat?: Maybe<Scalars['String']>;
  vectorText?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Companies_Min_Fields = {
  __typename?: 'companies_min_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId?: Maybe<Scalars['String']>;
  brokerName?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  cvi?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  dun?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  eori?: Maybe<Scalars['String']>;
  excise?: Maybe<Scalars['String']>;
  fda?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  officeId?: Maybe<Scalars['Int']>;
  officialId?: Maybe<Scalars['String']>;
  parentCompany?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  scoring?: Maybe<Scalars['String']>;
  targetObjective?: Maybe<Scalars['Float']>;
  targetObjectiveCurrency?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vat?: Maybe<Scalars['String']>;
  vectorText?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "companies" */
export type Companies_Mutation_Response = {
  __typename?: 'companies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Companies>;
};

/** input type for inserting object relation for remote table "companies" */
export type Companies_Obj_Rel_Insert_Input = {
  data: Companies_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Companies_On_Conflict>;
};

/** on_conflict condition type for table "companies" */
export type Companies_On_Conflict = {
  constraint: Companies_Constraint;
  update_columns?: Array<Companies_Update_Column>;
  where?: InputMaybe<Companies_Bool_Exp>;
};

/** Ordering options when selecting data from "companies". */
export type Companies_Order_By = {
  agreementsBuyerCompany_aggregate?: InputMaybe<Agreements_Aggregate_Order_By>;
  agreementsSellerCompany_aggregate?: InputMaybe<Agreements_Aggregate_Order_By>;
  agreementsThirdPartyCompany_aggregate?: InputMaybe<Agreements_Aggregate_Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  broker?: InputMaybe<Users_Order_By>;
  brokerId?: InputMaybe<Order_By>;
  brokerName?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  certifications?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  companyAddresses_aggregate?: InputMaybe<CompanyAddress_Aggregate_Order_By>;
  country?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  cvi?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  dun?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  embedding?: InputMaybe<Order_By>;
  eori?: InputMaybe<Order_By>;
  excise?: InputMaybe<Order_By>;
  fda?: InputMaybe<Order_By>;
  files?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  officialId?: InputMaybe<Order_By>;
  parentCompany?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  scoring?: InputMaybe<Order_By>;
  targetObjective?: InputMaybe<Order_By>;
  targetObjectiveCurrency?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
  vectorText?: InputMaybe<Order_By>;
};

/** primary key columns input for table: companies */
export type Companies_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Companies_Prepend_Input = {
  certifications?: InputMaybe<Scalars['jsonb']>;
  files?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "companies" */
export enum Companies_Select_Column {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BrokerId = 'brokerId',
  /** column name */
  BrokerName = 'brokerName',
  /** column name */
  Category = 'category',
  /** column name */
  Certifications = 'certifications',
  /** column name */
  Comments = 'comments',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Cvi = 'cvi',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Dun = 'dun',
  /** column name */
  Email = 'email',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Eori = 'eori',
  /** column name */
  Excise = 'excise',
  /** column name */
  Fda = 'fda',
  /** column name */
  Files = 'files',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  OfficialId = 'officialId',
  /** column name */
  ParentCompany = 'parentCompany',
  /** column name */
  Phone = 'phone',
  /** column name */
  Scoring = 'scoring',
  /** column name */
  TargetObjective = 'targetObjective',
  /** column name */
  TargetObjectiveCurrency = 'targetObjectiveCurrency',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Vat = 'vat',
  /** column name */
  VectorText = 'vectorText'
}

/** input type for updating data in table "companies" */
export type Companies_Set_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  brokerId?: InputMaybe<Scalars['String']>;
  brokerName?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  certifications?: InputMaybe<Scalars['jsonb']>;
  comments?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  cvi?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  dun?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  embedding?: InputMaybe<Scalars['vector']>;
  eori?: InputMaybe<Scalars['String']>;
  excise?: InputMaybe<Scalars['String']>;
  fda?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Int']>;
  officialId?: InputMaybe<Scalars['String']>;
  parentCompany?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  scoring?: InputMaybe<Scalars['String']>;
  targetObjective?: InputMaybe<Scalars['Float']>;
  targetObjectiveCurrency?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vat?: InputMaybe<Scalars['String']>;
  vectorText?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Companies_Stddev_Fields = {
  __typename?: 'companies_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  targetObjective?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Companies_Stddev_Pop_Fields = {
  __typename?: 'companies_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  targetObjective?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Companies_Stddev_Samp_Fields = {
  __typename?: 'companies_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  targetObjective?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "companies" */
export type Companies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Companies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Companies_Stream_Cursor_Value_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  brokerId?: InputMaybe<Scalars['String']>;
  brokerName?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  certifications?: InputMaybe<Scalars['jsonb']>;
  comments?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  cvi?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  dun?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  embedding?: InputMaybe<Scalars['vector']>;
  eori?: InputMaybe<Scalars['String']>;
  excise?: InputMaybe<Scalars['String']>;
  fda?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Int']>;
  officialId?: InputMaybe<Scalars['String']>;
  parentCompany?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  scoring?: InputMaybe<Scalars['String']>;
  targetObjective?: InputMaybe<Scalars['Float']>;
  targetObjectiveCurrency?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vat?: InputMaybe<Scalars['String']>;
  vectorText?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Companies_Sum_Fields = {
  __typename?: 'companies_sum_fields';
  id?: Maybe<Scalars['Int']>;
  officeId?: Maybe<Scalars['Int']>;
  targetObjective?: Maybe<Scalars['Float']>;
};

/** update columns of table "companies" */
export enum Companies_Update_Column {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BrokerId = 'brokerId',
  /** column name */
  BrokerName = 'brokerName',
  /** column name */
  Category = 'category',
  /** column name */
  Certifications = 'certifications',
  /** column name */
  Comments = 'comments',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Cvi = 'cvi',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Dun = 'dun',
  /** column name */
  Email = 'email',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Eori = 'eori',
  /** column name */
  Excise = 'excise',
  /** column name */
  Fda = 'fda',
  /** column name */
  Files = 'files',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  OfficialId = 'officialId',
  /** column name */
  ParentCompany = 'parentCompany',
  /** column name */
  Phone = 'phone',
  /** column name */
  Scoring = 'scoring',
  /** column name */
  TargetObjective = 'targetObjective',
  /** column name */
  TargetObjectiveCurrency = 'targetObjectiveCurrency',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Vat = 'vat',
  /** column name */
  VectorText = 'vectorText'
}

export type Companies_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Companies_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Companies_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Companies_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Companies_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Companies_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Companies_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Companies_Set_Input>;
  where: Companies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Companies_Var_Pop_Fields = {
  __typename?: 'companies_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  targetObjective?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Companies_Var_Samp_Fields = {
  __typename?: 'companies_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  targetObjective?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Companies_Variance_Fields = {
  __typename?: 'companies_variance_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  targetObjective?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "companyAddress" */
export type CompanyAddress = {
  __typename?: 'companyAddress';
  /** An object relationship */
  address: Addresses;
  addressId: Scalars['Int'];
  /** An object relationship */
  company: Companies;
  companyId: Scalars['Int'];
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['String'];
  id: Scalars['Int'];
  updatedAt: Scalars['timestamp'];
};

/** aggregated selection of "companyAddress" */
export type CompanyAddress_Aggregate = {
  __typename?: 'companyAddress_aggregate';
  aggregate?: Maybe<CompanyAddress_Aggregate_Fields>;
  nodes: Array<CompanyAddress>;
};

export type CompanyAddress_Aggregate_Bool_Exp = {
  count?: InputMaybe<CompanyAddress_Aggregate_Bool_Exp_Count>;
};

export type CompanyAddress_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<CompanyAddress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<CompanyAddress_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "companyAddress" */
export type CompanyAddress_Aggregate_Fields = {
  __typename?: 'companyAddress_aggregate_fields';
  avg?: Maybe<CompanyAddress_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CompanyAddress_Max_Fields>;
  min?: Maybe<CompanyAddress_Min_Fields>;
  stddev?: Maybe<CompanyAddress_Stddev_Fields>;
  stddev_pop?: Maybe<CompanyAddress_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CompanyAddress_Stddev_Samp_Fields>;
  sum?: Maybe<CompanyAddress_Sum_Fields>;
  var_pop?: Maybe<CompanyAddress_Var_Pop_Fields>;
  var_samp?: Maybe<CompanyAddress_Var_Samp_Fields>;
  variance?: Maybe<CompanyAddress_Variance_Fields>;
};


/** aggregate fields of "companyAddress" */
export type CompanyAddress_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CompanyAddress_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "companyAddress" */
export type CompanyAddress_Aggregate_Order_By = {
  avg?: InputMaybe<CompanyAddress_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<CompanyAddress_Max_Order_By>;
  min?: InputMaybe<CompanyAddress_Min_Order_By>;
  stddev?: InputMaybe<CompanyAddress_Stddev_Order_By>;
  stddev_pop?: InputMaybe<CompanyAddress_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<CompanyAddress_Stddev_Samp_Order_By>;
  sum?: InputMaybe<CompanyAddress_Sum_Order_By>;
  var_pop?: InputMaybe<CompanyAddress_Var_Pop_Order_By>;
  var_samp?: InputMaybe<CompanyAddress_Var_Samp_Order_By>;
  variance?: InputMaybe<CompanyAddress_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "companyAddress" */
export type CompanyAddress_Arr_Rel_Insert_Input = {
  data: Array<CompanyAddress_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<CompanyAddress_On_Conflict>;
};

/** aggregate avg on columns */
export type CompanyAddress_Avg_Fields = {
  __typename?: 'companyAddress_avg_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "companyAddress" */
export type CompanyAddress_Avg_Order_By = {
  addressId?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "companyAddress". All fields are combined with a logical 'AND'. */
export type CompanyAddress_Bool_Exp = {
  _and?: InputMaybe<Array<CompanyAddress_Bool_Exp>>;
  _not?: InputMaybe<CompanyAddress_Bool_Exp>;
  _or?: InputMaybe<Array<CompanyAddress_Bool_Exp>>;
  address?: InputMaybe<Addresses_Bool_Exp>;
  addressId?: InputMaybe<Int_Comparison_Exp>;
  company?: InputMaybe<Companies_Bool_Exp>;
  companyId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "companyAddress" */
export enum CompanyAddress_Constraint {
  /** unique or primary key constraint on columns "companyId", "addressId" */
  CompanyAddressCompanyIdAddressIdKey = 'companyAddress_companyId_addressId_key',
  /** unique or primary key constraint on columns "id" */
  CompanyAddressPkey = 'companyAddress_pkey'
}

/** input type for incrementing numeric columns in table "companyAddress" */
export type CompanyAddress_Inc_Input = {
  addressId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "companyAddress" */
export type CompanyAddress_Insert_Input = {
  address?: InputMaybe<Addresses_Obj_Rel_Insert_Input>;
  addressId?: InputMaybe<Scalars['Int']>;
  company?: InputMaybe<Companies_Obj_Rel_Insert_Input>;
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type CompanyAddress_Max_Fields = {
  __typename?: 'companyAddress_max_fields';
  addressId?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "companyAddress" */
export type CompanyAddress_Max_Order_By = {
  addressId?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type CompanyAddress_Min_Fields = {
  __typename?: 'companyAddress_min_fields';
  addressId?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "companyAddress" */
export type CompanyAddress_Min_Order_By = {
  addressId?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "companyAddress" */
export type CompanyAddress_Mutation_Response = {
  __typename?: 'companyAddress_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyAddress>;
};

/** on_conflict condition type for table "companyAddress" */
export type CompanyAddress_On_Conflict = {
  constraint: CompanyAddress_Constraint;
  update_columns?: Array<CompanyAddress_Update_Column>;
  where?: InputMaybe<CompanyAddress_Bool_Exp>;
};

/** Ordering options when selecting data from "companyAddress". */
export type CompanyAddress_Order_By = {
  address?: InputMaybe<Addresses_Order_By>;
  addressId?: InputMaybe<Order_By>;
  company?: InputMaybe<Companies_Order_By>;
  companyId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: companyAddress */
export type CompanyAddress_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "companyAddress" */
export enum CompanyAddress_Select_Column {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "companyAddress" */
export type CompanyAddress_Set_Input = {
  addressId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type CompanyAddress_Stddev_Fields = {
  __typename?: 'companyAddress_stddev_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "companyAddress" */
export type CompanyAddress_Stddev_Order_By = {
  addressId?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type CompanyAddress_Stddev_Pop_Fields = {
  __typename?: 'companyAddress_stddev_pop_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "companyAddress" */
export type CompanyAddress_Stddev_Pop_Order_By = {
  addressId?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type CompanyAddress_Stddev_Samp_Fields = {
  __typename?: 'companyAddress_stddev_samp_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "companyAddress" */
export type CompanyAddress_Stddev_Samp_Order_By = {
  addressId?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "companyAddress" */
export type CompanyAddress_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CompanyAddress_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyAddress_Stream_Cursor_Value_Input = {
  addressId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type CompanyAddress_Sum_Fields = {
  __typename?: 'companyAddress_sum_fields';
  addressId?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "companyAddress" */
export type CompanyAddress_Sum_Order_By = {
  addressId?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** update columns of table "companyAddress" */
export enum CompanyAddress_Update_Column {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CompanyAddress_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CompanyAddress_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyAddress_Set_Input>;
  where: CompanyAddress_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CompanyAddress_Var_Pop_Fields = {
  __typename?: 'companyAddress_var_pop_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "companyAddress" */
export type CompanyAddress_Var_Pop_Order_By = {
  addressId?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type CompanyAddress_Var_Samp_Fields = {
  __typename?: 'companyAddress_var_samp_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "companyAddress" */
export type CompanyAddress_Var_Samp_Order_By = {
  addressId?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type CompanyAddress_Variance_Fields = {
  __typename?: 'companyAddress_variance_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "companyAddress" */
export type CompanyAddress_Variance_Order_By = {
  addressId?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** columns and relationships of "contacts" */
export type Contacts = {
  __typename?: 'contacts';
  addressId?: Maybe<Scalars['Int']>;
  altEmail?: Maybe<Scalars['String']>;
  altPhone?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  broker?: Maybe<Users>;
  brokerId?: Maybe<Scalars['String']>;
  categories?: Maybe<Scalars['jsonb']>;
  comments?: Maybe<Scalars['String']>;
  /** An object relationship */
  company?: Maybe<Companies>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  embedding?: Maybe<Scalars['vector']>;
  fax?: Maybe<Scalars['String']>;
  files?: Maybe<Scalars['jsonb']>;
  firstname: Scalars['String'];
  id: Scalars['Int'];
  jobTitle?: Maybe<Scalars['String']>;
  lastname: Scalars['String'];
  mobile?: Maybe<Scalars['String']>;
  officePhone?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  vectorText?: Maybe<Scalars['String']>;
};


/** columns and relationships of "contacts" */
export type ContactsCategoriesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "contacts" */
export type ContactsFilesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "contacts" */
export type ContactsUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "contacts" */
export type ContactsUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "contacts" */
export type Contacts_Aggregate = {
  __typename?: 'contacts_aggregate';
  aggregate?: Maybe<Contacts_Aggregate_Fields>;
  nodes: Array<Contacts>;
};

/** aggregate fields of "contacts" */
export type Contacts_Aggregate_Fields = {
  __typename?: 'contacts_aggregate_fields';
  avg?: Maybe<Contacts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Contacts_Max_Fields>;
  min?: Maybe<Contacts_Min_Fields>;
  stddev?: Maybe<Contacts_Stddev_Fields>;
  stddev_pop?: Maybe<Contacts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Contacts_Stddev_Samp_Fields>;
  sum?: Maybe<Contacts_Sum_Fields>;
  var_pop?: Maybe<Contacts_Var_Pop_Fields>;
  var_samp?: Maybe<Contacts_Var_Samp_Fields>;
  variance?: Maybe<Contacts_Variance_Fields>;
};


/** aggregate fields of "contacts" */
export type Contacts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contacts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Contacts_Append_Input = {
  categories?: InputMaybe<Scalars['jsonb']>;
  files?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Contacts_Avg_Fields = {
  __typename?: 'contacts_avg_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "contacts". All fields are combined with a logical 'AND'. */
export type Contacts_Bool_Exp = {
  _and?: InputMaybe<Array<Contacts_Bool_Exp>>;
  _not?: InputMaybe<Contacts_Bool_Exp>;
  _or?: InputMaybe<Array<Contacts_Bool_Exp>>;
  addressId?: InputMaybe<Int_Comparison_Exp>;
  altEmail?: InputMaybe<String_Comparison_Exp>;
  altPhone?: InputMaybe<String_Comparison_Exp>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  broker?: InputMaybe<Users_Bool_Exp>;
  brokerId?: InputMaybe<String_Comparison_Exp>;
  categories?: InputMaybe<Jsonb_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  company?: InputMaybe<Companies_Bool_Exp>;
  companyId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  embedding?: InputMaybe<Vector_Comparison_Exp>;
  fax?: InputMaybe<String_Comparison_Exp>;
  files?: InputMaybe<Jsonb_Comparison_Exp>;
  firstname?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  jobTitle?: InputMaybe<String_Comparison_Exp>;
  lastname?: InputMaybe<String_Comparison_Exp>;
  mobile?: InputMaybe<String_Comparison_Exp>;
  officePhone?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
  users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
  vectorText?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "contacts" */
export enum Contacts_Constraint {
  /** unique or primary key constraint on columns "email" */
  ContactsEmailKey = 'contacts_email_key',
  /** unique or primary key constraint on columns "id" */
  ContactsPkey = 'contacts_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Contacts_Delete_At_Path_Input = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  files?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Contacts_Delete_Elem_Input = {
  categories?: InputMaybe<Scalars['Int']>;
  files?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Contacts_Delete_Key_Input = {
  categories?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "contacts" */
export type Contacts_Inc_Input = {
  addressId?: InputMaybe<Scalars['Int']>;
  companyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "contacts" */
export type Contacts_Insert_Input = {
  addressId?: InputMaybe<Scalars['Int']>;
  altEmail?: InputMaybe<Scalars['String']>;
  altPhone?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  brokerId?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Scalars['jsonb']>;
  comments?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Companies_Obj_Rel_Insert_Input>;
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  embedding?: InputMaybe<Scalars['vector']>;
  fax?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  firstname?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  officePhone?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
  vectorText?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Contacts_Max_Fields = {
  __typename?: 'contacts_max_fields';
  addressId?: Maybe<Scalars['Int']>;
  altEmail?: Maybe<Scalars['String']>;
  altPhone?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  officePhone?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vectorText?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Contacts_Min_Fields = {
  __typename?: 'contacts_min_fields';
  addressId?: Maybe<Scalars['Int']>;
  altEmail?: Maybe<Scalars['String']>;
  altPhone?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  officePhone?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  vectorText?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "contacts" */
export type Contacts_Mutation_Response = {
  __typename?: 'contacts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Contacts>;
};

/** input type for inserting object relation for remote table "contacts" */
export type Contacts_Obj_Rel_Insert_Input = {
  data: Contacts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Contacts_On_Conflict>;
};

/** on_conflict condition type for table "contacts" */
export type Contacts_On_Conflict = {
  constraint: Contacts_Constraint;
  update_columns?: Array<Contacts_Update_Column>;
  where?: InputMaybe<Contacts_Bool_Exp>;
};

/** Ordering options when selecting data from "contacts". */
export type Contacts_Order_By = {
  addressId?: InputMaybe<Order_By>;
  altEmail?: InputMaybe<Order_By>;
  altPhone?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  broker?: InputMaybe<Users_Order_By>;
  brokerId?: InputMaybe<Order_By>;
  categories?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  company?: InputMaybe<Companies_Order_By>;
  companyId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  embedding?: InputMaybe<Order_By>;
  fax?: InputMaybe<Order_By>;
  files?: InputMaybe<Order_By>;
  firstname?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobTitle?: InputMaybe<Order_By>;
  lastname?: InputMaybe<Order_By>;
  mobile?: InputMaybe<Order_By>;
  officePhone?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  vectorText?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contacts */
export type Contacts_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Contacts_Prepend_Input = {
  categories?: InputMaybe<Scalars['jsonb']>;
  files?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "contacts" */
export enum Contacts_Select_Column {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  AltEmail = 'altEmail',
  /** column name */
  AltPhone = 'altPhone',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BrokerId = 'brokerId',
  /** column name */
  Categories = 'categories',
  /** column name */
  Comments = 'comments',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Fax = 'fax',
  /** column name */
  Files = 'files',
  /** column name */
  Firstname = 'firstname',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitle = 'jobTitle',
  /** column name */
  Lastname = 'lastname',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  OfficePhone = 'officePhone',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VectorText = 'vectorText'
}

/** input type for updating data in table "contacts" */
export type Contacts_Set_Input = {
  addressId?: InputMaybe<Scalars['Int']>;
  altEmail?: InputMaybe<Scalars['String']>;
  altPhone?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  brokerId?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Scalars['jsonb']>;
  comments?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  embedding?: InputMaybe<Scalars['vector']>;
  fax?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  firstname?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  officePhone?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vectorText?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Contacts_Stddev_Fields = {
  __typename?: 'contacts_stddev_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Contacts_Stddev_Pop_Fields = {
  __typename?: 'contacts_stddev_pop_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Contacts_Stddev_Samp_Fields = {
  __typename?: 'contacts_stddev_samp_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "contacts" */
export type Contacts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contacts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contacts_Stream_Cursor_Value_Input = {
  addressId?: InputMaybe<Scalars['Int']>;
  altEmail?: InputMaybe<Scalars['String']>;
  altPhone?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  brokerId?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Scalars['jsonb']>;
  comments?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  embedding?: InputMaybe<Scalars['vector']>;
  fax?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  firstname?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  officePhone?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  vectorText?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Contacts_Sum_Fields = {
  __typename?: 'contacts_sum_fields';
  addressId?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "contacts" */
export enum Contacts_Update_Column {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  AltEmail = 'altEmail',
  /** column name */
  AltPhone = 'altPhone',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BrokerId = 'brokerId',
  /** column name */
  Categories = 'categories',
  /** column name */
  Comments = 'comments',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Fax = 'fax',
  /** column name */
  Files = 'files',
  /** column name */
  Firstname = 'firstname',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitle = 'jobTitle',
  /** column name */
  Lastname = 'lastname',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  OfficePhone = 'officePhone',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VectorText = 'vectorText'
}

export type Contacts_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Contacts_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Contacts_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Contacts_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Contacts_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Contacts_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Contacts_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contacts_Set_Input>;
  where: Contacts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Contacts_Var_Pop_Fields = {
  __typename?: 'contacts_var_pop_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Contacts_Var_Samp_Fields = {
  __typename?: 'contacts_var_samp_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Contacts_Variance_Fields = {
  __typename?: 'contacts_variance_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "contacts_without_company" */
export type Contacts_Without_Company = {
  __typename?: 'contacts_without_company';
  addressId?: Maybe<Scalars['Int']>;
  altEmail?: Maybe<Scalars['String']>;
  altPhone?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId?: Maybe<Scalars['String']>;
  categories?: Maybe<Scalars['jsonb']>;
  comments?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  files?: Maybe<Scalars['jsonb']>;
  firstname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  officePhone?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "contacts_without_company" */
export type Contacts_Without_CompanyCategoriesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "contacts_without_company" */
export type Contacts_Without_CompanyFilesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "contacts_without_company" */
export type Contacts_Without_Company_Aggregate = {
  __typename?: 'contacts_without_company_aggregate';
  aggregate?: Maybe<Contacts_Without_Company_Aggregate_Fields>;
  nodes: Array<Contacts_Without_Company>;
};

/** aggregate fields of "contacts_without_company" */
export type Contacts_Without_Company_Aggregate_Fields = {
  __typename?: 'contacts_without_company_aggregate_fields';
  avg?: Maybe<Contacts_Without_Company_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Contacts_Without_Company_Max_Fields>;
  min?: Maybe<Contacts_Without_Company_Min_Fields>;
  stddev?: Maybe<Contacts_Without_Company_Stddev_Fields>;
  stddev_pop?: Maybe<Contacts_Without_Company_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Contacts_Without_Company_Stddev_Samp_Fields>;
  sum?: Maybe<Contacts_Without_Company_Sum_Fields>;
  var_pop?: Maybe<Contacts_Without_Company_Var_Pop_Fields>;
  var_samp?: Maybe<Contacts_Without_Company_Var_Samp_Fields>;
  variance?: Maybe<Contacts_Without_Company_Variance_Fields>;
};


/** aggregate fields of "contacts_without_company" */
export type Contacts_Without_Company_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contacts_Without_Company_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Contacts_Without_Company_Avg_Fields = {
  __typename?: 'contacts_without_company_avg_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "contacts_without_company". All fields are combined with a logical 'AND'. */
export type Contacts_Without_Company_Bool_Exp = {
  _and?: InputMaybe<Array<Contacts_Without_Company_Bool_Exp>>;
  _not?: InputMaybe<Contacts_Without_Company_Bool_Exp>;
  _or?: InputMaybe<Array<Contacts_Without_Company_Bool_Exp>>;
  addressId?: InputMaybe<Int_Comparison_Exp>;
  altEmail?: InputMaybe<String_Comparison_Exp>;
  altPhone?: InputMaybe<String_Comparison_Exp>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  brokerId?: InputMaybe<String_Comparison_Exp>;
  categories?: InputMaybe<Jsonb_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  companyId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  fax?: InputMaybe<String_Comparison_Exp>;
  files?: InputMaybe<Jsonb_Comparison_Exp>;
  firstname?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  jobTitle?: InputMaybe<String_Comparison_Exp>;
  lastname?: InputMaybe<String_Comparison_Exp>;
  mobile?: InputMaybe<String_Comparison_Exp>;
  officePhone?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Contacts_Without_Company_Max_Fields = {
  __typename?: 'contacts_without_company_max_fields';
  addressId?: Maybe<Scalars['Int']>;
  altEmail?: Maybe<Scalars['String']>;
  altPhone?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  officePhone?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Contacts_Without_Company_Min_Fields = {
  __typename?: 'contacts_without_company_min_fields';
  addressId?: Maybe<Scalars['Int']>;
  altEmail?: Maybe<Scalars['String']>;
  altPhone?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  officePhone?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** Ordering options when selecting data from "contacts_without_company". */
export type Contacts_Without_Company_Order_By = {
  addressId?: InputMaybe<Order_By>;
  altEmail?: InputMaybe<Order_By>;
  altPhone?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  brokerId?: InputMaybe<Order_By>;
  categories?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  fax?: InputMaybe<Order_By>;
  files?: InputMaybe<Order_By>;
  firstname?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobTitle?: InputMaybe<Order_By>;
  lastname?: InputMaybe<Order_By>;
  mobile?: InputMaybe<Order_By>;
  officePhone?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** select columns of table "contacts_without_company" */
export enum Contacts_Without_Company_Select_Column {
  /** column name */
  AddressId = 'addressId',
  /** column name */
  AltEmail = 'altEmail',
  /** column name */
  AltPhone = 'altPhone',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BrokerId = 'brokerId',
  /** column name */
  Categories = 'categories',
  /** column name */
  Comments = 'comments',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Email = 'email',
  /** column name */
  Fax = 'fax',
  /** column name */
  Files = 'files',
  /** column name */
  Firstname = 'firstname',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitle = 'jobTitle',
  /** column name */
  Lastname = 'lastname',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  OfficePhone = 'officePhone',
  /** column name */
  Phone = 'phone',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** aggregate stddev on columns */
export type Contacts_Without_Company_Stddev_Fields = {
  __typename?: 'contacts_without_company_stddev_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Contacts_Without_Company_Stddev_Pop_Fields = {
  __typename?: 'contacts_without_company_stddev_pop_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Contacts_Without_Company_Stddev_Samp_Fields = {
  __typename?: 'contacts_without_company_stddev_samp_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "contacts_without_company" */
export type Contacts_Without_Company_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contacts_Without_Company_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contacts_Without_Company_Stream_Cursor_Value_Input = {
  addressId?: InputMaybe<Scalars['Int']>;
  altEmail?: InputMaybe<Scalars['String']>;
  altPhone?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  brokerId?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Scalars['jsonb']>;
  comments?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  firstname?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  officePhone?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Contacts_Without_Company_Sum_Fields = {
  __typename?: 'contacts_without_company_sum_fields';
  addressId?: Maybe<Scalars['Int']>;
  companyId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Contacts_Without_Company_Var_Pop_Fields = {
  __typename?: 'contacts_without_company_var_pop_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Contacts_Without_Company_Var_Samp_Fields = {
  __typename?: 'contacts_without_company_var_samp_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Contacts_Without_Company_Variance_Fields = {
  __typename?: 'contacts_without_company_variance_fields';
  addressId?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "contracts" */
export type Contracts = {
  __typename?: 'contracts';
  /** An object relationship */
  agreement: Agreements;
  agreementId: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['String'];
  fileUrl: Scalars['String'];
  fileUrlWithSignatures?: Maybe<Scalars['String']>;
  format: Scalars['String'];
  id: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  validationsContracts: Array<ValidationsContracts>;
  /** An aggregate relationship */
  validationsContracts_aggregate: ValidationsContracts_Aggregate;
  version?: Maybe<Scalars['String']>;
};


/** columns and relationships of "contracts" */
export type ContractsValidationsContractsArgs = {
  distinct_on?: InputMaybe<Array<ValidationsContracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationsContracts_Order_By>>;
  where?: InputMaybe<ValidationsContracts_Bool_Exp>;
};


/** columns and relationships of "contracts" */
export type ContractsValidationsContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationsContracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationsContracts_Order_By>>;
  where?: InputMaybe<ValidationsContracts_Bool_Exp>;
};

/** aggregated selection of "contracts" */
export type Contracts_Aggregate = {
  __typename?: 'contracts_aggregate';
  aggregate?: Maybe<Contracts_Aggregate_Fields>;
  nodes: Array<Contracts>;
};

/** aggregate fields of "contracts" */
export type Contracts_Aggregate_Fields = {
  __typename?: 'contracts_aggregate_fields';
  avg?: Maybe<Contracts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Contracts_Max_Fields>;
  min?: Maybe<Contracts_Min_Fields>;
  stddev?: Maybe<Contracts_Stddev_Fields>;
  stddev_pop?: Maybe<Contracts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Contracts_Stddev_Samp_Fields>;
  sum?: Maybe<Contracts_Sum_Fields>;
  var_pop?: Maybe<Contracts_Var_Pop_Fields>;
  var_samp?: Maybe<Contracts_Var_Samp_Fields>;
  variance?: Maybe<Contracts_Variance_Fields>;
};


/** aggregate fields of "contracts" */
export type Contracts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Contracts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Contracts_Avg_Fields = {
  __typename?: 'contracts_avg_fields';
  agreementId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "contracts". All fields are combined with a logical 'AND'. */
export type Contracts_Bool_Exp = {
  _and?: InputMaybe<Array<Contracts_Bool_Exp>>;
  _not?: InputMaybe<Contracts_Bool_Exp>;
  _or?: InputMaybe<Array<Contracts_Bool_Exp>>;
  agreement?: InputMaybe<Agreements_Bool_Exp>;
  agreementId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  fileUrl?: InputMaybe<String_Comparison_Exp>;
  fileUrlWithSignatures?: InputMaybe<String_Comparison_Exp>;
  format?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  validationsContracts?: InputMaybe<ValidationsContracts_Bool_Exp>;
  validationsContracts_aggregate?: InputMaybe<ValidationsContracts_Aggregate_Bool_Exp>;
  version?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "contracts" */
export enum Contracts_Constraint {
  /** unique or primary key constraint on columns "id" */
  ContractsPkey = 'contracts_pkey'
}

/** input type for incrementing numeric columns in table "contracts" */
export type Contracts_Inc_Input = {
  agreementId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "contracts" */
export type Contracts_Insert_Input = {
  agreement?: InputMaybe<Agreements_Obj_Rel_Insert_Input>;
  agreementId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  fileUrl?: InputMaybe<Scalars['String']>;
  fileUrlWithSignatures?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  validationsContracts?: InputMaybe<ValidationsContracts_Arr_Rel_Insert_Input>;
  version?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Contracts_Max_Fields = {
  __typename?: 'contracts_max_fields';
  agreementId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  fileUrlWithSignatures?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Contracts_Min_Fields = {
  __typename?: 'contracts_min_fields';
  agreementId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  fileUrlWithSignatures?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  version?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "contracts" */
export type Contracts_Mutation_Response = {
  __typename?: 'contracts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Contracts>;
};

/** input type for inserting object relation for remote table "contracts" */
export type Contracts_Obj_Rel_Insert_Input = {
  data: Contracts_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Contracts_On_Conflict>;
};

/** on_conflict condition type for table "contracts" */
export type Contracts_On_Conflict = {
  constraint: Contracts_Constraint;
  update_columns?: Array<Contracts_Update_Column>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};

/** Ordering options when selecting data from "contracts". */
export type Contracts_Order_By = {
  agreement?: InputMaybe<Agreements_Order_By>;
  agreementId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  fileUrl?: InputMaybe<Order_By>;
  fileUrlWithSignatures?: InputMaybe<Order_By>;
  format?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  validationsContracts_aggregate?: InputMaybe<ValidationsContracts_Aggregate_Order_By>;
  version?: InputMaybe<Order_By>;
};

/** primary key columns input for table: contracts */
export type Contracts_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "contracts" */
export enum Contracts_Select_Column {
  /** column name */
  AgreementId = 'agreementId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FileUrl = 'fileUrl',
  /** column name */
  FileUrlWithSignatures = 'fileUrlWithSignatures',
  /** column name */
  Format = 'format',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Version = 'version'
}

/** input type for updating data in table "contracts" */
export type Contracts_Set_Input = {
  agreementId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  fileUrl?: InputMaybe<Scalars['String']>;
  fileUrlWithSignatures?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Contracts_Stddev_Fields = {
  __typename?: 'contracts_stddev_fields';
  agreementId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Contracts_Stddev_Pop_Fields = {
  __typename?: 'contracts_stddev_pop_fields';
  agreementId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Contracts_Stddev_Samp_Fields = {
  __typename?: 'contracts_stddev_samp_fields';
  agreementId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "contracts" */
export type Contracts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Contracts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Contracts_Stream_Cursor_Value_Input = {
  agreementId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  fileUrl?: InputMaybe<Scalars['String']>;
  fileUrlWithSignatures?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  version?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Contracts_Sum_Fields = {
  __typename?: 'contracts_sum_fields';
  agreementId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "contracts" */
export enum Contracts_Update_Column {
  /** column name */
  AgreementId = 'agreementId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  FileUrl = 'fileUrl',
  /** column name */
  FileUrlWithSignatures = 'fileUrlWithSignatures',
  /** column name */
  Format = 'format',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Version = 'version'
}

export type Contracts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Contracts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Contracts_Set_Input>;
  where: Contracts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Contracts_Var_Pop_Fields = {
  __typename?: 'contracts_var_pop_fields';
  agreementId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Contracts_Var_Samp_Fields = {
  __typename?: 'contracts_var_samp_fields';
  agreementId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Contracts_Variance_Fields = {
  __typename?: 'contracts_variance_fields';
  agreementId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "currenciesConversions" */
export type CurrenciesConversions = {
  __typename?: 'currenciesConversions';
  created_at: Scalars['timestamptz'];
  currencies: Scalars['jsonb'];
  currency: Scalars['String'];
  date: Scalars['date'];
  day: Scalars['Int'];
  id: Scalars['Int'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};


/** columns and relationships of "currenciesConversions" */
export type CurrenciesConversionsCurrenciesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "currenciesConversions" */
export type CurrenciesConversions_Aggregate = {
  __typename?: 'currenciesConversions_aggregate';
  aggregate?: Maybe<CurrenciesConversions_Aggregate_Fields>;
  nodes: Array<CurrenciesConversions>;
};

/** aggregate fields of "currenciesConversions" */
export type CurrenciesConversions_Aggregate_Fields = {
  __typename?: 'currenciesConversions_aggregate_fields';
  avg?: Maybe<CurrenciesConversions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CurrenciesConversions_Max_Fields>;
  min?: Maybe<CurrenciesConversions_Min_Fields>;
  stddev?: Maybe<CurrenciesConversions_Stddev_Fields>;
  stddev_pop?: Maybe<CurrenciesConversions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CurrenciesConversions_Stddev_Samp_Fields>;
  sum?: Maybe<CurrenciesConversions_Sum_Fields>;
  var_pop?: Maybe<CurrenciesConversions_Var_Pop_Fields>;
  var_samp?: Maybe<CurrenciesConversions_Var_Samp_Fields>;
  variance?: Maybe<CurrenciesConversions_Variance_Fields>;
};


/** aggregate fields of "currenciesConversions" */
export type CurrenciesConversions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CurrenciesConversions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CurrenciesConversions_Append_Input = {
  currencies?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type CurrenciesConversions_Avg_Fields = {
  __typename?: 'currenciesConversions_avg_fields';
  day?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "currenciesConversions". All fields are combined with a logical 'AND'. */
export type CurrenciesConversions_Bool_Exp = {
  _and?: InputMaybe<Array<CurrenciesConversions_Bool_Exp>>;
  _not?: InputMaybe<CurrenciesConversions_Bool_Exp>;
  _or?: InputMaybe<Array<CurrenciesConversions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currencies?: InputMaybe<Jsonb_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  day?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  month?: InputMaybe<Int_Comparison_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "currenciesConversions" */
export enum CurrenciesConversions_Constraint {
  /** unique or primary key constraint on columns "date", "currency" */
  CurrenciesConversionsDateCurrencyKey = 'currenciesConversions_date_currency_key',
  /** unique or primary key constraint on columns "id" */
  CurrenciesConversionsPkey = 'currenciesConversions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CurrenciesConversions_Delete_At_Path_Input = {
  currencies?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CurrenciesConversions_Delete_Elem_Input = {
  currencies?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CurrenciesConversions_Delete_Key_Input = {
  currencies?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "currenciesConversions" */
export type CurrenciesConversions_Inc_Input = {
  day?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "currenciesConversions" */
export type CurrenciesConversions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currencies?: InputMaybe<Scalars['jsonb']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  day?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type CurrenciesConversions_Max_Fields = {
  __typename?: 'currenciesConversions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  day?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type CurrenciesConversions_Min_Fields = {
  __typename?: 'currenciesConversions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['date']>;
  day?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "currenciesConversions" */
export type CurrenciesConversions_Mutation_Response = {
  __typename?: 'currenciesConversions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CurrenciesConversions>;
};

/** on_conflict condition type for table "currenciesConversions" */
export type CurrenciesConversions_On_Conflict = {
  constraint: CurrenciesConversions_Constraint;
  update_columns?: Array<CurrenciesConversions_Update_Column>;
  where?: InputMaybe<CurrenciesConversions_Bool_Exp>;
};

/** Ordering options when selecting data from "currenciesConversions". */
export type CurrenciesConversions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  currencies?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  day?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** primary key columns input for table: currenciesConversions */
export type CurrenciesConversions_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CurrenciesConversions_Prepend_Input = {
  currencies?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "currenciesConversions" */
export enum CurrenciesConversions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currencies = 'currencies',
  /** column name */
  Currency = 'currency',
  /** column name */
  Date = 'date',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  Month = 'month',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "currenciesConversions" */
export type CurrenciesConversions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currencies?: InputMaybe<Scalars['jsonb']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  day?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type CurrenciesConversions_Stddev_Fields = {
  __typename?: 'currenciesConversions_stddev_fields';
  day?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CurrenciesConversions_Stddev_Pop_Fields = {
  __typename?: 'currenciesConversions_stddev_pop_fields';
  day?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CurrenciesConversions_Stddev_Samp_Fields = {
  __typename?: 'currenciesConversions_stddev_samp_fields';
  day?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "currenciesConversions" */
export type CurrenciesConversions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CurrenciesConversions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CurrenciesConversions_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  currencies?: InputMaybe<Scalars['jsonb']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['date']>;
  day?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type CurrenciesConversions_Sum_Fields = {
  __typename?: 'currenciesConversions_sum_fields';
  day?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** update columns of table "currenciesConversions" */
export enum CurrenciesConversions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currencies = 'currencies',
  /** column name */
  Currency = 'currency',
  /** column name */
  Date = 'date',
  /** column name */
  Day = 'day',
  /** column name */
  Id = 'id',
  /** column name */
  Month = 'month',
  /** column name */
  Year = 'year'
}

export type CurrenciesConversions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CurrenciesConversions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CurrenciesConversions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CurrenciesConversions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CurrenciesConversions_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CurrenciesConversions_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CurrenciesConversions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CurrenciesConversions_Set_Input>;
  where: CurrenciesConversions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CurrenciesConversions_Var_Pop_Fields = {
  __typename?: 'currenciesConversions_var_pop_fields';
  day?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CurrenciesConversions_Var_Samp_Fields = {
  __typename?: 'currenciesConversions_var_samp_fields';
  day?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CurrenciesConversions_Variance_Fields = {
  __typename?: 'currenciesConversions_variance_fields';
  day?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "history" */
export type History = {
  __typename?: 'history';
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['String'];
  /** An object relationship */
  creator: Users;
  data: Scalars['jsonb'];
  id: Scalars['Int'];
  objectId: Scalars['Int'];
  operation: Scalars['String'];
  table: Scalars['String'];
};


/** columns and relationships of "history" */
export type HistoryDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "history" */
export type History_Aggregate = {
  __typename?: 'history_aggregate';
  aggregate?: Maybe<History_Aggregate_Fields>;
  nodes: Array<History>;
};

/** aggregate fields of "history" */
export type History_Aggregate_Fields = {
  __typename?: 'history_aggregate_fields';
  avg?: Maybe<History_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<History_Max_Fields>;
  min?: Maybe<History_Min_Fields>;
  stddev?: Maybe<History_Stddev_Fields>;
  stddev_pop?: Maybe<History_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<History_Stddev_Samp_Fields>;
  sum?: Maybe<History_Sum_Fields>;
  var_pop?: Maybe<History_Var_Pop_Fields>;
  var_samp?: Maybe<History_Var_Samp_Fields>;
  variance?: Maybe<History_Variance_Fields>;
};


/** aggregate fields of "history" */
export type History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type History_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type History_Avg_Fields = {
  __typename?: 'history_avg_fields';
  id?: Maybe<Scalars['Float']>;
  objectId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "history". All fields are combined with a logical 'AND'. */
export type History_Bool_Exp = {
  _and?: InputMaybe<Array<History_Bool_Exp>>;
  _not?: InputMaybe<History_Bool_Exp>;
  _or?: InputMaybe<Array<History_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  objectId?: InputMaybe<Int_Comparison_Exp>;
  operation?: InputMaybe<String_Comparison_Exp>;
  table?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "history" */
export enum History_Constraint {
  /** unique or primary key constraint on columns "id" */
  HistoryPkey = 'history_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type History_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type History_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type History_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "history" */
export type History_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  objectId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "history" */
export type History_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  objectId?: InputMaybe<Scalars['Int']>;
  operation?: InputMaybe<Scalars['String']>;
  table?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type History_Max_Fields = {
  __typename?: 'history_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  objectId?: Maybe<Scalars['Int']>;
  operation?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type History_Min_Fields = {
  __typename?: 'history_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  objectId?: Maybe<Scalars['Int']>;
  operation?: Maybe<Scalars['String']>;
  table?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "history" */
export type History_Mutation_Response = {
  __typename?: 'history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<History>;
};

/** input type for inserting object relation for remote table "history" */
export type History_Obj_Rel_Insert_Input = {
  data: History_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<History_On_Conflict>;
};

/** on_conflict condition type for table "history" */
export type History_On_Conflict = {
  constraint: History_Constraint;
  update_columns?: Array<History_Update_Column>;
  where?: InputMaybe<History_Bool_Exp>;
};

/** Ordering options when selecting data from "history". */
export type History_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  objectId?: InputMaybe<Order_By>;
  operation?: InputMaybe<Order_By>;
  table?: InputMaybe<Order_By>;
};

/** primary key columns input for table: history */
export type History_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type History_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "history" */
export enum History_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'objectId',
  /** column name */
  Operation = 'operation',
  /** column name */
  Table = 'table'
}

/** input type for updating data in table "history" */
export type History_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  objectId?: InputMaybe<Scalars['Int']>;
  operation?: InputMaybe<Scalars['String']>;
  table?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type History_Stddev_Fields = {
  __typename?: 'history_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  objectId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type History_Stddev_Pop_Fields = {
  __typename?: 'history_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  objectId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type History_Stddev_Samp_Fields = {
  __typename?: 'history_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  objectId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "history" */
export type History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type History_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  objectId?: InputMaybe<Scalars['Int']>;
  operation?: InputMaybe<Scalars['String']>;
  table?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type History_Sum_Fields = {
  __typename?: 'history_sum_fields';
  id?: Maybe<Scalars['Int']>;
  objectId?: Maybe<Scalars['Int']>;
};

/** update columns of table "history" */
export enum History_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'objectId',
  /** column name */
  Operation = 'operation',
  /** column name */
  Table = 'table'
}

export type History_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<History_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<History_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<History_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<History_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<History_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<History_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<History_Set_Input>;
  where: History_Bool_Exp;
};

/** aggregate var_pop on columns */
export type History_Var_Pop_Fields = {
  __typename?: 'history_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  objectId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type History_Var_Samp_Fields = {
  __typename?: 'history_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  objectId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type History_Variance_Fields = {
  __typename?: 'history_variance_fields';
  id?: Maybe<Scalars['Float']>;
  objectId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "invoices" */
export type Invoices = {
  __typename?: 'invoices';
  USDconversion?: Maybe<Scalars['Float']>;
  /** An object relationship */
  agreement?: Maybe<Agreements>;
  agreementId?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Float']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId?: Maybe<Scalars['String']>;
  buyerPoRef?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  /** An object relationship */
  company?: Maybe<Companies>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  dueDate?: Maybe<Scalars['date']>;
  externalId?: Maybe<Scalars['String']>;
  files?: Maybe<Scalars['jsonb']>;
  id: Scalars['Int'];
  /** DEPRECATED - use of the createdAt field instead */
  invoiceDate?: Maybe<Scalars['date']>;
  officeId?: Maybe<Scalars['Int']>;
  paymentDate?: Maybe<Scalars['date']>;
  quickbookId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  shipmentFulfillment?: Maybe<ShipmentFulfillments>;
  shipmentFulfillmentId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  supplierInvoice?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "invoices" */
export type InvoicesFilesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "invoices" */
export type Invoices_Aggregate = {
  __typename?: 'invoices_aggregate';
  aggregate?: Maybe<Invoices_Aggregate_Fields>;
  nodes: Array<Invoices>;
};

export type Invoices_Aggregate_Bool_Exp = {
  count?: InputMaybe<Invoices_Aggregate_Bool_Exp_Count>;
};

export type Invoices_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invoices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Invoices_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invoices" */
export type Invoices_Aggregate_Fields = {
  __typename?: 'invoices_aggregate_fields';
  avg?: Maybe<Invoices_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Invoices_Max_Fields>;
  min?: Maybe<Invoices_Min_Fields>;
  stddev?: Maybe<Invoices_Stddev_Fields>;
  stddev_pop?: Maybe<Invoices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoices_Stddev_Samp_Fields>;
  sum?: Maybe<Invoices_Sum_Fields>;
  var_pop?: Maybe<Invoices_Var_Pop_Fields>;
  var_samp?: Maybe<Invoices_Var_Samp_Fields>;
  variance?: Maybe<Invoices_Variance_Fields>;
};


/** aggregate fields of "invoices" */
export type Invoices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invoices" */
export type Invoices_Aggregate_Order_By = {
  avg?: InputMaybe<Invoices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invoices_Max_Order_By>;
  min?: InputMaybe<Invoices_Min_Order_By>;
  stddev?: InputMaybe<Invoices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Invoices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Invoices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Invoices_Sum_Order_By>;
  var_pop?: InputMaybe<Invoices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Invoices_Var_Samp_Order_By>;
  variance?: InputMaybe<Invoices_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Invoices_Append_Input = {
  files?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "invoices" */
export type Invoices_Arr_Rel_Insert_Input = {
  data: Array<Invoices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invoices_On_Conflict>;
};

/** aggregate avg on columns */
export type Invoices_Avg_Fields = {
  __typename?: 'invoices_avg_fields';
  USDconversion?: Maybe<Scalars['Float']>;
  agreementId?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quickbookId?: Maybe<Scalars['Float']>;
  shipmentFulfillmentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "invoices" */
export type Invoices_Avg_Order_By = {
  USDconversion?: InputMaybe<Order_By>;
  agreementId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  quickbookId?: InputMaybe<Order_By>;
  shipmentFulfillmentId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoices". All fields are combined with a logical 'AND'. */
export type Invoices_Bool_Exp = {
  USDconversion?: InputMaybe<Float_Comparison_Exp>;
  _and?: InputMaybe<Array<Invoices_Bool_Exp>>;
  _not?: InputMaybe<Invoices_Bool_Exp>;
  _or?: InputMaybe<Array<Invoices_Bool_Exp>>;
  agreement?: InputMaybe<Agreements_Bool_Exp>;
  agreementId?: InputMaybe<Int_Comparison_Exp>;
  amount?: InputMaybe<Float_Comparison_Exp>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  brokerId?: InputMaybe<String_Comparison_Exp>;
  buyerPoRef?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  company?: InputMaybe<Companies_Bool_Exp>;
  companyId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dueDate?: InputMaybe<Date_Comparison_Exp>;
  externalId?: InputMaybe<String_Comparison_Exp>;
  files?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invoiceDate?: InputMaybe<Date_Comparison_Exp>;
  officeId?: InputMaybe<Int_Comparison_Exp>;
  paymentDate?: InputMaybe<Date_Comparison_Exp>;
  quickbookId?: InputMaybe<Int_Comparison_Exp>;
  shipmentFulfillment?: InputMaybe<ShipmentFulfillments_Bool_Exp>;
  shipmentFulfillmentId?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  supplierInvoice?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "invoices" */
export enum Invoices_Constraint {
  /** unique or primary key constraint on columns "id" */
  InvoicesPkey = 'invoices_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Invoices_Delete_At_Path_Input = {
  files?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Invoices_Delete_Elem_Input = {
  files?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Invoices_Delete_Key_Input = {
  files?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "invoices" */
export type Invoices_Inc_Input = {
  USDconversion?: InputMaybe<Scalars['Float']>;
  agreementId?: InputMaybe<Scalars['Int']>;
  amount?: InputMaybe<Scalars['Float']>;
  companyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  officeId?: InputMaybe<Scalars['Int']>;
  quickbookId?: InputMaybe<Scalars['Int']>;
  shipmentFulfillmentId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "invoices" */
export type Invoices_Insert_Input = {
  USDconversion?: InputMaybe<Scalars['Float']>;
  agreement?: InputMaybe<Agreements_Obj_Rel_Insert_Input>;
  agreementId?: InputMaybe<Scalars['Int']>;
  amount?: InputMaybe<Scalars['Float']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  brokerId?: InputMaybe<Scalars['String']>;
  buyerPoRef?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Companies_Obj_Rel_Insert_Input>;
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  dueDate?: InputMaybe<Scalars['date']>;
  externalId?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  /** DEPRECATED - use of the createdAt field instead */
  invoiceDate?: InputMaybe<Scalars['date']>;
  officeId?: InputMaybe<Scalars['Int']>;
  paymentDate?: InputMaybe<Scalars['date']>;
  quickbookId?: InputMaybe<Scalars['Int']>;
  shipmentFulfillment?: InputMaybe<ShipmentFulfillments_Obj_Rel_Insert_Input>;
  shipmentFulfillmentId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  supplierInvoice?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Invoices_Max_Fields = {
  __typename?: 'invoices_max_fields';
  USDconversion?: Maybe<Scalars['Float']>;
  agreementId?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Float']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId?: Maybe<Scalars['String']>;
  buyerPoRef?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  dueDate?: Maybe<Scalars['date']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** DEPRECATED - use of the createdAt field instead */
  invoiceDate?: Maybe<Scalars['date']>;
  officeId?: Maybe<Scalars['Int']>;
  paymentDate?: Maybe<Scalars['date']>;
  quickbookId?: Maybe<Scalars['Int']>;
  shipmentFulfillmentId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  supplierInvoice?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "invoices" */
export type Invoices_Max_Order_By = {
  USDconversion?: InputMaybe<Order_By>;
  agreementId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  brokerId?: InputMaybe<Order_By>;
  buyerPoRef?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  dueDate?: InputMaybe<Order_By>;
  externalId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** DEPRECATED - use of the createdAt field instead */
  invoiceDate?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  paymentDate?: InputMaybe<Order_By>;
  quickbookId?: InputMaybe<Order_By>;
  shipmentFulfillmentId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplierInvoice?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invoices_Min_Fields = {
  __typename?: 'invoices_min_fields';
  USDconversion?: Maybe<Scalars['Float']>;
  agreementId?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Float']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId?: Maybe<Scalars['String']>;
  buyerPoRef?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  dueDate?: Maybe<Scalars['date']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  /** DEPRECATED - use of the createdAt field instead */
  invoiceDate?: Maybe<Scalars['date']>;
  officeId?: Maybe<Scalars['Int']>;
  paymentDate?: Maybe<Scalars['date']>;
  quickbookId?: Maybe<Scalars['Int']>;
  shipmentFulfillmentId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  supplierInvoice?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "invoices" */
export type Invoices_Min_Order_By = {
  USDconversion?: InputMaybe<Order_By>;
  agreementId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  brokerId?: InputMaybe<Order_By>;
  buyerPoRef?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  dueDate?: InputMaybe<Order_By>;
  externalId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** DEPRECATED - use of the createdAt field instead */
  invoiceDate?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  paymentDate?: InputMaybe<Order_By>;
  quickbookId?: InputMaybe<Order_By>;
  shipmentFulfillmentId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplierInvoice?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invoices" */
export type Invoices_Mutation_Response = {
  __typename?: 'invoices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invoices>;
};

/** on_conflict condition type for table "invoices" */
export type Invoices_On_Conflict = {
  constraint: Invoices_Constraint;
  update_columns?: Array<Invoices_Update_Column>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};

/** Ordering options when selecting data from "invoices". */
export type Invoices_Order_By = {
  USDconversion?: InputMaybe<Order_By>;
  agreement?: InputMaybe<Agreements_Order_By>;
  agreementId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  brokerId?: InputMaybe<Order_By>;
  buyerPoRef?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  company?: InputMaybe<Companies_Order_By>;
  companyId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  dueDate?: InputMaybe<Order_By>;
  externalId?: InputMaybe<Order_By>;
  files?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiceDate?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  paymentDate?: InputMaybe<Order_By>;
  quickbookId?: InputMaybe<Order_By>;
  shipmentFulfillment?: InputMaybe<ShipmentFulfillments_Order_By>;
  shipmentFulfillmentId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  supplierInvoice?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invoices */
export type Invoices_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Invoices_Prepend_Input = {
  files?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "invoices" */
export enum Invoices_Select_Column {
  /** column name */
  UsDconversion = 'USDconversion',
  /** column name */
  AgreementId = 'agreementId',
  /** column name */
  Amount = 'amount',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BrokerId = 'brokerId',
  /** column name */
  BuyerPoRef = 'buyerPoRef',
  /** column name */
  Comments = 'comments',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DueDate = 'dueDate',
  /** column name */
  ExternalId = 'externalId',
  /** column name */
  Files = 'files',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceDate = 'invoiceDate',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  PaymentDate = 'paymentDate',
  /** column name */
  QuickbookId = 'quickbookId',
  /** column name */
  ShipmentFulfillmentId = 'shipmentFulfillmentId',
  /** column name */
  Status = 'status',
  /** column name */
  SupplierInvoice = 'supplierInvoice',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "invoices" */
export type Invoices_Set_Input = {
  USDconversion?: InputMaybe<Scalars['Float']>;
  agreementId?: InputMaybe<Scalars['Int']>;
  amount?: InputMaybe<Scalars['Float']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  brokerId?: InputMaybe<Scalars['String']>;
  buyerPoRef?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  dueDate?: InputMaybe<Scalars['date']>;
  externalId?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  /** DEPRECATED - use of the createdAt field instead */
  invoiceDate?: InputMaybe<Scalars['date']>;
  officeId?: InputMaybe<Scalars['Int']>;
  paymentDate?: InputMaybe<Scalars['date']>;
  quickbookId?: InputMaybe<Scalars['Int']>;
  shipmentFulfillmentId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  supplierInvoice?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Invoices_Stddev_Fields = {
  __typename?: 'invoices_stddev_fields';
  USDconversion?: Maybe<Scalars['Float']>;
  agreementId?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quickbookId?: Maybe<Scalars['Float']>;
  shipmentFulfillmentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "invoices" */
export type Invoices_Stddev_Order_By = {
  USDconversion?: InputMaybe<Order_By>;
  agreementId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  quickbookId?: InputMaybe<Order_By>;
  shipmentFulfillmentId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoices_Stddev_Pop_Fields = {
  __typename?: 'invoices_stddev_pop_fields';
  USDconversion?: Maybe<Scalars['Float']>;
  agreementId?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quickbookId?: Maybe<Scalars['Float']>;
  shipmentFulfillmentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "invoices" */
export type Invoices_Stddev_Pop_Order_By = {
  USDconversion?: InputMaybe<Order_By>;
  agreementId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  quickbookId?: InputMaybe<Order_By>;
  shipmentFulfillmentId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoices_Stddev_Samp_Fields = {
  __typename?: 'invoices_stddev_samp_fields';
  USDconversion?: Maybe<Scalars['Float']>;
  agreementId?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quickbookId?: Maybe<Scalars['Float']>;
  shipmentFulfillmentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "invoices" */
export type Invoices_Stddev_Samp_Order_By = {
  USDconversion?: InputMaybe<Order_By>;
  agreementId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  quickbookId?: InputMaybe<Order_By>;
  shipmentFulfillmentId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "invoices" */
export type Invoices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoices_Stream_Cursor_Value_Input = {
  USDconversion?: InputMaybe<Scalars['Float']>;
  agreementId?: InputMaybe<Scalars['Int']>;
  amount?: InputMaybe<Scalars['Float']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  brokerId?: InputMaybe<Scalars['String']>;
  buyerPoRef?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  dueDate?: InputMaybe<Scalars['date']>;
  externalId?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  /** DEPRECATED - use of the createdAt field instead */
  invoiceDate?: InputMaybe<Scalars['date']>;
  officeId?: InputMaybe<Scalars['Int']>;
  paymentDate?: InputMaybe<Scalars['date']>;
  quickbookId?: InputMaybe<Scalars['Int']>;
  shipmentFulfillmentId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  supplierInvoice?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Invoices_Sum_Fields = {
  __typename?: 'invoices_sum_fields';
  USDconversion?: Maybe<Scalars['Float']>;
  agreementId?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  officeId?: Maybe<Scalars['Int']>;
  quickbookId?: Maybe<Scalars['Int']>;
  shipmentFulfillmentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "invoices" */
export type Invoices_Sum_Order_By = {
  USDconversion?: InputMaybe<Order_By>;
  agreementId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  quickbookId?: InputMaybe<Order_By>;
  shipmentFulfillmentId?: InputMaybe<Order_By>;
};

/** update columns of table "invoices" */
export enum Invoices_Update_Column {
  /** column name */
  UsDconversion = 'USDconversion',
  /** column name */
  AgreementId = 'agreementId',
  /** column name */
  Amount = 'amount',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BrokerId = 'brokerId',
  /** column name */
  BuyerPoRef = 'buyerPoRef',
  /** column name */
  Comments = 'comments',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DueDate = 'dueDate',
  /** column name */
  ExternalId = 'externalId',
  /** column name */
  Files = 'files',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceDate = 'invoiceDate',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  PaymentDate = 'paymentDate',
  /** column name */
  QuickbookId = 'quickbookId',
  /** column name */
  ShipmentFulfillmentId = 'shipmentFulfillmentId',
  /** column name */
  Status = 'status',
  /** column name */
  SupplierInvoice = 'supplierInvoice',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Invoices_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Invoices_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Invoices_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Invoices_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Invoices_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Invoices_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Invoices_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invoices_Set_Input>;
  where: Invoices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Invoices_Var_Pop_Fields = {
  __typename?: 'invoices_var_pop_fields';
  USDconversion?: Maybe<Scalars['Float']>;
  agreementId?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quickbookId?: Maybe<Scalars['Float']>;
  shipmentFulfillmentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "invoices" */
export type Invoices_Var_Pop_Order_By = {
  USDconversion?: InputMaybe<Order_By>;
  agreementId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  quickbookId?: InputMaybe<Order_By>;
  shipmentFulfillmentId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoices_Var_Samp_Fields = {
  __typename?: 'invoices_var_samp_fields';
  USDconversion?: Maybe<Scalars['Float']>;
  agreementId?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quickbookId?: Maybe<Scalars['Float']>;
  shipmentFulfillmentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "invoices" */
export type Invoices_Var_Samp_Order_By = {
  USDconversion?: InputMaybe<Order_By>;
  agreementId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  quickbookId?: InputMaybe<Order_By>;
  shipmentFulfillmentId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoices_Variance_Fields = {
  __typename?: 'invoices_variance_fields';
  USDconversion?: Maybe<Scalars['Float']>;
  agreementId?: Maybe<Scalars['Float']>;
  amount?: Maybe<Scalars['Float']>;
  companyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quickbookId?: Maybe<Scalars['Float']>;
  shipmentFulfillmentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "invoices" */
export type Invoices_Variance_Order_By = {
  USDconversion?: InputMaybe<Order_By>;
  agreementId?: InputMaybe<Order_By>;
  amount?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  quickbookId?: InputMaybe<Order_By>;
  shipmentFulfillmentId?: InputMaybe<Order_By>;
};

/** columns and relationships of "items" */
export type Items = {
  __typename?: 'items';
  additionalInformations?: Maybe<Scalars['String']>;
  alcohol?: Maybe<Scalars['Float']>;
  appellations: Scalars['jsonb'];
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId?: Maybe<Scalars['String']>;
  certifications: Scalars['jsonb'];
  comments?: Maybe<Scalars['String']>;
  commodityType: Scalars['String'];
  conditioning?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  exportIncoterms?: Maybe<Scalars['String']>;
  exportIncotermsType?: Maybe<Scalars['String']>;
  exportPrice?: Maybe<Scalars['Float']>;
  files?: Maybe<Scalars['jsonb']>;
  generic?: Maybe<Scalars['String']>;
  harvestMethod?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isOpportunistic?: Maybe<Scalars['Boolean']>;
  localPrice?: Maybe<Scalars['Float']>;
  lotNo?: Maybe<Scalars['String']>;
  /** An array relationship */
  matchingItemsBuySpecs: Array<MatchingItemsBuySpecs>;
  /** An aggregate relationship */
  matchingItemsBuySpecs_aggregate: MatchingItemsBuySpecs_Aggregate;
  netsuiteId?: Maybe<Scalars['String']>;
  officeId?: Maybe<Scalars['Int']>;
  qualities: Scalars['jsonb'];
  quantity?: Maybe<Scalars['Float']>;
  /** Not used for now */
  quantityAvailable?: Maybe<Scalars['Float']>;
  queryEmbedding?: Maybe<Scalars['vector']>;
  region?: Maybe<Scalars['String']>;
  /** An array relationship */
  sampleShipmentRequests: Array<SampleShipmentRequests>;
  /** An aggregate relationship */
  sampleShipmentRequests_aggregate: SampleShipmentRequests_Aggregate;
  /** An array relationship */
  samples: Array<Samples>;
  /** An aggregate relationship */
  samples_aggregate: Samples_Aggregate;
  /** An array relationship */
  shipmentFulfillments: Array<ShipmentFulfillments>;
  /** An aggregate relationship */
  shipmentFulfillments_aggregate: ShipmentFulfillments_Aggregate;
  state?: Maybe<Scalars['String']>;
  storageLocationId?: Maybe<Scalars['Int']>;
  subAppellation?: Maybe<Scalars['String']>;
  subGeneric?: Maybe<Scalars['String']>;
  subRegion?: Maybe<Scalars['String']>;
  /** An object relationship */
  supplierCompany: Companies;
  supplierCompanyId: Scalars['Int'];
  supplierContactId?: Maybe<Scalars['Int']>;
  tankNo?: Maybe<Scalars['String']>;
  uom?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  varietals: Scalars['jsonb'];
  vintages: Scalars['jsonb'];
};


/** columns and relationships of "items" */
export type ItemsAppellationsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "items" */
export type ItemsCertificationsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "items" */
export type ItemsFilesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "items" */
export type ItemsMatchingItemsBuySpecsArgs = {
  distinct_on?: InputMaybe<Array<MatchingItemsBuySpecs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MatchingItemsBuySpecs_Order_By>>;
  where?: InputMaybe<MatchingItemsBuySpecs_Bool_Exp>;
};


/** columns and relationships of "items" */
export type ItemsMatchingItemsBuySpecs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MatchingItemsBuySpecs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MatchingItemsBuySpecs_Order_By>>;
  where?: InputMaybe<MatchingItemsBuySpecs_Bool_Exp>;
};


/** columns and relationships of "items" */
export type ItemsQualitiesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "items" */
export type ItemsSampleShipmentRequestsArgs = {
  distinct_on?: InputMaybe<Array<SampleShipmentRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleShipmentRequests_Order_By>>;
  where?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
};


/** columns and relationships of "items" */
export type ItemsSampleShipmentRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SampleShipmentRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleShipmentRequests_Order_By>>;
  where?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
};


/** columns and relationships of "items" */
export type ItemsSamplesArgs = {
  distinct_on?: InputMaybe<Array<Samples_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Samples_Order_By>>;
  where?: InputMaybe<Samples_Bool_Exp>;
};


/** columns and relationships of "items" */
export type ItemsSamples_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Samples_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Samples_Order_By>>;
  where?: InputMaybe<Samples_Bool_Exp>;
};


/** columns and relationships of "items" */
export type ItemsShipmentFulfillmentsArgs = {
  distinct_on?: InputMaybe<Array<ShipmentFulfillments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShipmentFulfillments_Order_By>>;
  where?: InputMaybe<ShipmentFulfillments_Bool_Exp>;
};


/** columns and relationships of "items" */
export type ItemsShipmentFulfillments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ShipmentFulfillments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShipmentFulfillments_Order_By>>;
  where?: InputMaybe<ShipmentFulfillments_Bool_Exp>;
};


/** columns and relationships of "items" */
export type ItemsVarietalsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "items" */
export type ItemsVintagesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "items" */
export type Items_Aggregate = {
  __typename?: 'items_aggregate';
  aggregate?: Maybe<Items_Aggregate_Fields>;
  nodes: Array<Items>;
};

/** aggregate fields of "items" */
export type Items_Aggregate_Fields = {
  __typename?: 'items_aggregate_fields';
  avg?: Maybe<Items_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Items_Max_Fields>;
  min?: Maybe<Items_Min_Fields>;
  stddev?: Maybe<Items_Stddev_Fields>;
  stddev_pop?: Maybe<Items_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Items_Stddev_Samp_Fields>;
  sum?: Maybe<Items_Sum_Fields>;
  var_pop?: Maybe<Items_Var_Pop_Fields>;
  var_samp?: Maybe<Items_Var_Samp_Fields>;
  variance?: Maybe<Items_Variance_Fields>;
};


/** aggregate fields of "items" */
export type Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Items_Append_Input = {
  appellations?: InputMaybe<Scalars['jsonb']>;
  certifications?: InputMaybe<Scalars['jsonb']>;
  files?: InputMaybe<Scalars['jsonb']>;
  qualities?: InputMaybe<Scalars['jsonb']>;
  varietals?: InputMaybe<Scalars['jsonb']>;
  vintages?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Items_Avg_Fields = {
  __typename?: 'items_avg_fields';
  alcohol?: Maybe<Scalars['Float']>;
  exportPrice?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  localPrice?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Not used for now */
  quantityAvailable?: Maybe<Scalars['Float']>;
  storageLocationId?: Maybe<Scalars['Float']>;
  supplierCompanyId?: Maybe<Scalars['Float']>;
  supplierContactId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "items". All fields are combined with a logical 'AND'. */
export type Items_Bool_Exp = {
  _and?: InputMaybe<Array<Items_Bool_Exp>>;
  _not?: InputMaybe<Items_Bool_Exp>;
  _or?: InputMaybe<Array<Items_Bool_Exp>>;
  additionalInformations?: InputMaybe<String_Comparison_Exp>;
  alcohol?: InputMaybe<Float_Comparison_Exp>;
  appellations?: InputMaybe<Jsonb_Comparison_Exp>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  brokerId?: InputMaybe<String_Comparison_Exp>;
  certifications?: InputMaybe<Jsonb_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  commodityType?: InputMaybe<String_Comparison_Exp>;
  conditioning?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  county?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  exportIncoterms?: InputMaybe<String_Comparison_Exp>;
  exportIncotermsType?: InputMaybe<String_Comparison_Exp>;
  exportPrice?: InputMaybe<Float_Comparison_Exp>;
  files?: InputMaybe<Jsonb_Comparison_Exp>;
  generic?: InputMaybe<String_Comparison_Exp>;
  harvestMethod?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isOpportunistic?: InputMaybe<Boolean_Comparison_Exp>;
  localPrice?: InputMaybe<Float_Comparison_Exp>;
  lotNo?: InputMaybe<String_Comparison_Exp>;
  matchingItemsBuySpecs?: InputMaybe<MatchingItemsBuySpecs_Bool_Exp>;
  matchingItemsBuySpecs_aggregate?: InputMaybe<MatchingItemsBuySpecs_Aggregate_Bool_Exp>;
  netsuiteId?: InputMaybe<String_Comparison_Exp>;
  officeId?: InputMaybe<Int_Comparison_Exp>;
  qualities?: InputMaybe<Jsonb_Comparison_Exp>;
  quantity?: InputMaybe<Float_Comparison_Exp>;
  quantityAvailable?: InputMaybe<Float_Comparison_Exp>;
  queryEmbedding?: InputMaybe<Vector_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  sampleShipmentRequests?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
  sampleShipmentRequests_aggregate?: InputMaybe<SampleShipmentRequests_Aggregate_Bool_Exp>;
  samples?: InputMaybe<Samples_Bool_Exp>;
  samples_aggregate?: InputMaybe<Samples_Aggregate_Bool_Exp>;
  shipmentFulfillments?: InputMaybe<ShipmentFulfillments_Bool_Exp>;
  shipmentFulfillments_aggregate?: InputMaybe<ShipmentFulfillments_Aggregate_Bool_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  storageLocationId?: InputMaybe<Int_Comparison_Exp>;
  subAppellation?: InputMaybe<String_Comparison_Exp>;
  subGeneric?: InputMaybe<String_Comparison_Exp>;
  subRegion?: InputMaybe<String_Comparison_Exp>;
  supplierCompany?: InputMaybe<Companies_Bool_Exp>;
  supplierCompanyId?: InputMaybe<Int_Comparison_Exp>;
  supplierContactId?: InputMaybe<Int_Comparison_Exp>;
  tankNo?: InputMaybe<String_Comparison_Exp>;
  uom?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  varietals?: InputMaybe<Jsonb_Comparison_Exp>;
  vintages?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "items" */
export enum Items_Constraint {
  /** unique or primary key constraint on columns "id" */
  ItemsPkey = 'items_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Items_Delete_At_Path_Input = {
  appellations?: InputMaybe<Array<Scalars['String']>>;
  certifications?: InputMaybe<Array<Scalars['String']>>;
  files?: InputMaybe<Array<Scalars['String']>>;
  qualities?: InputMaybe<Array<Scalars['String']>>;
  varietals?: InputMaybe<Array<Scalars['String']>>;
  vintages?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Items_Delete_Elem_Input = {
  appellations?: InputMaybe<Scalars['Int']>;
  certifications?: InputMaybe<Scalars['Int']>;
  files?: InputMaybe<Scalars['Int']>;
  qualities?: InputMaybe<Scalars['Int']>;
  varietals?: InputMaybe<Scalars['Int']>;
  vintages?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Items_Delete_Key_Input = {
  appellations?: InputMaybe<Scalars['String']>;
  certifications?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['String']>;
  qualities?: InputMaybe<Scalars['String']>;
  varietals?: InputMaybe<Scalars['String']>;
  vintages?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "items" */
export type Items_Inc_Input = {
  alcohol?: InputMaybe<Scalars['Float']>;
  exportPrice?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Int']>;
  localPrice?: InputMaybe<Scalars['Float']>;
  officeId?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Float']>;
  /** Not used for now */
  quantityAvailable?: InputMaybe<Scalars['Float']>;
  storageLocationId?: InputMaybe<Scalars['Int']>;
  supplierCompanyId?: InputMaybe<Scalars['Int']>;
  supplierContactId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "items" */
export type Items_Insert_Input = {
  additionalInformations?: InputMaybe<Scalars['String']>;
  alcohol?: InputMaybe<Scalars['Float']>;
  appellations?: InputMaybe<Scalars['jsonb']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  brokerId?: InputMaybe<Scalars['String']>;
  certifications?: InputMaybe<Scalars['jsonb']>;
  comments?: InputMaybe<Scalars['String']>;
  commodityType?: InputMaybe<Scalars['String']>;
  conditioning?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  exportIncoterms?: InputMaybe<Scalars['String']>;
  exportIncotermsType?: InputMaybe<Scalars['String']>;
  exportPrice?: InputMaybe<Scalars['Float']>;
  files?: InputMaybe<Scalars['jsonb']>;
  generic?: InputMaybe<Scalars['String']>;
  harvestMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isOpportunistic?: InputMaybe<Scalars['Boolean']>;
  localPrice?: InputMaybe<Scalars['Float']>;
  lotNo?: InputMaybe<Scalars['String']>;
  matchingItemsBuySpecs?: InputMaybe<MatchingItemsBuySpecs_Arr_Rel_Insert_Input>;
  netsuiteId?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Int']>;
  qualities?: InputMaybe<Scalars['jsonb']>;
  quantity?: InputMaybe<Scalars['Float']>;
  /** Not used for now */
  quantityAvailable?: InputMaybe<Scalars['Float']>;
  queryEmbedding?: InputMaybe<Scalars['vector']>;
  region?: InputMaybe<Scalars['String']>;
  sampleShipmentRequests?: InputMaybe<SampleShipmentRequests_Arr_Rel_Insert_Input>;
  samples?: InputMaybe<Samples_Arr_Rel_Insert_Input>;
  shipmentFulfillments?: InputMaybe<ShipmentFulfillments_Arr_Rel_Insert_Input>;
  state?: InputMaybe<Scalars['String']>;
  storageLocationId?: InputMaybe<Scalars['Int']>;
  subAppellation?: InputMaybe<Scalars['String']>;
  subGeneric?: InputMaybe<Scalars['String']>;
  subRegion?: InputMaybe<Scalars['String']>;
  supplierCompany?: InputMaybe<Companies_Obj_Rel_Insert_Input>;
  supplierCompanyId?: InputMaybe<Scalars['Int']>;
  supplierContactId?: InputMaybe<Scalars['Int']>;
  tankNo?: InputMaybe<Scalars['String']>;
  uom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  varietals?: InputMaybe<Scalars['jsonb']>;
  vintages?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Items_Max_Fields = {
  __typename?: 'items_max_fields';
  additionalInformations?: Maybe<Scalars['String']>;
  alcohol?: Maybe<Scalars['Float']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  commodityType?: Maybe<Scalars['String']>;
  conditioning?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  exportIncoterms?: Maybe<Scalars['String']>;
  exportIncotermsType?: Maybe<Scalars['String']>;
  exportPrice?: Maybe<Scalars['Float']>;
  generic?: Maybe<Scalars['String']>;
  harvestMethod?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  localPrice?: Maybe<Scalars['Float']>;
  lotNo?: Maybe<Scalars['String']>;
  netsuiteId?: Maybe<Scalars['String']>;
  officeId?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Not used for now */
  quantityAvailable?: Maybe<Scalars['Float']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  storageLocationId?: Maybe<Scalars['Int']>;
  subAppellation?: Maybe<Scalars['String']>;
  subGeneric?: Maybe<Scalars['String']>;
  subRegion?: Maybe<Scalars['String']>;
  supplierCompanyId?: Maybe<Scalars['Int']>;
  supplierContactId?: Maybe<Scalars['Int']>;
  tankNo?: Maybe<Scalars['String']>;
  uom?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Items_Min_Fields = {
  __typename?: 'items_min_fields';
  additionalInformations?: Maybe<Scalars['String']>;
  alcohol?: Maybe<Scalars['Float']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  commodityType?: Maybe<Scalars['String']>;
  conditioning?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  exportIncoterms?: Maybe<Scalars['String']>;
  exportIncotermsType?: Maybe<Scalars['String']>;
  exportPrice?: Maybe<Scalars['Float']>;
  generic?: Maybe<Scalars['String']>;
  harvestMethod?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  localPrice?: Maybe<Scalars['Float']>;
  lotNo?: Maybe<Scalars['String']>;
  netsuiteId?: Maybe<Scalars['String']>;
  officeId?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Not used for now */
  quantityAvailable?: Maybe<Scalars['Float']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  storageLocationId?: Maybe<Scalars['Int']>;
  subAppellation?: Maybe<Scalars['String']>;
  subGeneric?: Maybe<Scalars['String']>;
  subRegion?: Maybe<Scalars['String']>;
  supplierCompanyId?: Maybe<Scalars['Int']>;
  supplierContactId?: Maybe<Scalars['Int']>;
  tankNo?: Maybe<Scalars['String']>;
  uom?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "items" */
export type Items_Mutation_Response = {
  __typename?: 'items_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Items>;
};

/** input type for inserting object relation for remote table "items" */
export type Items_Obj_Rel_Insert_Input = {
  data: Items_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Items_On_Conflict>;
};

/** on_conflict condition type for table "items" */
export type Items_On_Conflict = {
  constraint: Items_Constraint;
  update_columns?: Array<Items_Update_Column>;
  where?: InputMaybe<Items_Bool_Exp>;
};

/** Ordering options when selecting data from "items". */
export type Items_Order_By = {
  additionalInformations?: InputMaybe<Order_By>;
  alcohol?: InputMaybe<Order_By>;
  appellations?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  brokerId?: InputMaybe<Order_By>;
  certifications?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  commodityType?: InputMaybe<Order_By>;
  conditioning?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  county?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  exportIncoterms?: InputMaybe<Order_By>;
  exportIncotermsType?: InputMaybe<Order_By>;
  exportPrice?: InputMaybe<Order_By>;
  files?: InputMaybe<Order_By>;
  generic?: InputMaybe<Order_By>;
  harvestMethod?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isOpportunistic?: InputMaybe<Order_By>;
  localPrice?: InputMaybe<Order_By>;
  lotNo?: InputMaybe<Order_By>;
  matchingItemsBuySpecs_aggregate?: InputMaybe<MatchingItemsBuySpecs_Aggregate_Order_By>;
  netsuiteId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  qualities?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  quantityAvailable?: InputMaybe<Order_By>;
  queryEmbedding?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  sampleShipmentRequests_aggregate?: InputMaybe<SampleShipmentRequests_Aggregate_Order_By>;
  samples_aggregate?: InputMaybe<Samples_Aggregate_Order_By>;
  shipmentFulfillments_aggregate?: InputMaybe<ShipmentFulfillments_Aggregate_Order_By>;
  state?: InputMaybe<Order_By>;
  storageLocationId?: InputMaybe<Order_By>;
  subAppellation?: InputMaybe<Order_By>;
  subGeneric?: InputMaybe<Order_By>;
  subRegion?: InputMaybe<Order_By>;
  supplierCompany?: InputMaybe<Companies_Order_By>;
  supplierCompanyId?: InputMaybe<Order_By>;
  supplierContactId?: InputMaybe<Order_By>;
  tankNo?: InputMaybe<Order_By>;
  uom?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  varietals?: InputMaybe<Order_By>;
  vintages?: InputMaybe<Order_By>;
};

/** primary key columns input for table: items */
export type Items_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Items_Prepend_Input = {
  appellations?: InputMaybe<Scalars['jsonb']>;
  certifications?: InputMaybe<Scalars['jsonb']>;
  files?: InputMaybe<Scalars['jsonb']>;
  qualities?: InputMaybe<Scalars['jsonb']>;
  varietals?: InputMaybe<Scalars['jsonb']>;
  vintages?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "items" */
export enum Items_Select_Column {
  /** column name */
  AdditionalInformations = 'additionalInformations',
  /** column name */
  Alcohol = 'alcohol',
  /** column name */
  Appellations = 'appellations',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BrokerId = 'brokerId',
  /** column name */
  Certifications = 'certifications',
  /** column name */
  Comments = 'comments',
  /** column name */
  CommodityType = 'commodityType',
  /** column name */
  Conditioning = 'conditioning',
  /** column name */
  Country = 'country',
  /** column name */
  County = 'county',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  District = 'district',
  /** column name */
  ExportIncoterms = 'exportIncoterms',
  /** column name */
  ExportIncotermsType = 'exportIncotermsType',
  /** column name */
  ExportPrice = 'exportPrice',
  /** column name */
  Files = 'files',
  /** column name */
  Generic = 'generic',
  /** column name */
  HarvestMethod = 'harvestMethod',
  /** column name */
  Id = 'id',
  /** column name */
  IsOpportunistic = 'isOpportunistic',
  /** column name */
  LocalPrice = 'localPrice',
  /** column name */
  LotNo = 'lotNo',
  /** column name */
  NetsuiteId = 'netsuiteId',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  Qualities = 'qualities',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityAvailable = 'quantityAvailable',
  /** column name */
  QueryEmbedding = 'queryEmbedding',
  /** column name */
  Region = 'region',
  /** column name */
  State = 'state',
  /** column name */
  StorageLocationId = 'storageLocationId',
  /** column name */
  SubAppellation = 'subAppellation',
  /** column name */
  SubGeneric = 'subGeneric',
  /** column name */
  SubRegion = 'subRegion',
  /** column name */
  SupplierCompanyId = 'supplierCompanyId',
  /** column name */
  SupplierContactId = 'supplierContactId',
  /** column name */
  TankNo = 'tankNo',
  /** column name */
  Uom = 'uom',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Varietals = 'varietals',
  /** column name */
  Vintages = 'vintages'
}

/** input type for updating data in table "items" */
export type Items_Set_Input = {
  additionalInformations?: InputMaybe<Scalars['String']>;
  alcohol?: InputMaybe<Scalars['Float']>;
  appellations?: InputMaybe<Scalars['jsonb']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  brokerId?: InputMaybe<Scalars['String']>;
  certifications?: InputMaybe<Scalars['jsonb']>;
  comments?: InputMaybe<Scalars['String']>;
  commodityType?: InputMaybe<Scalars['String']>;
  conditioning?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  exportIncoterms?: InputMaybe<Scalars['String']>;
  exportIncotermsType?: InputMaybe<Scalars['String']>;
  exportPrice?: InputMaybe<Scalars['Float']>;
  files?: InputMaybe<Scalars['jsonb']>;
  generic?: InputMaybe<Scalars['String']>;
  harvestMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isOpportunistic?: InputMaybe<Scalars['Boolean']>;
  localPrice?: InputMaybe<Scalars['Float']>;
  lotNo?: InputMaybe<Scalars['String']>;
  netsuiteId?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Int']>;
  qualities?: InputMaybe<Scalars['jsonb']>;
  quantity?: InputMaybe<Scalars['Float']>;
  /** Not used for now */
  quantityAvailable?: InputMaybe<Scalars['Float']>;
  queryEmbedding?: InputMaybe<Scalars['vector']>;
  region?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  storageLocationId?: InputMaybe<Scalars['Int']>;
  subAppellation?: InputMaybe<Scalars['String']>;
  subGeneric?: InputMaybe<Scalars['String']>;
  subRegion?: InputMaybe<Scalars['String']>;
  supplierCompanyId?: InputMaybe<Scalars['Int']>;
  supplierContactId?: InputMaybe<Scalars['Int']>;
  tankNo?: InputMaybe<Scalars['String']>;
  uom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  varietals?: InputMaybe<Scalars['jsonb']>;
  vintages?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type Items_Stddev_Fields = {
  __typename?: 'items_stddev_fields';
  alcohol?: Maybe<Scalars['Float']>;
  exportPrice?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  localPrice?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Not used for now */
  quantityAvailable?: Maybe<Scalars['Float']>;
  storageLocationId?: Maybe<Scalars['Float']>;
  supplierCompanyId?: Maybe<Scalars['Float']>;
  supplierContactId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Items_Stddev_Pop_Fields = {
  __typename?: 'items_stddev_pop_fields';
  alcohol?: Maybe<Scalars['Float']>;
  exportPrice?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  localPrice?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Not used for now */
  quantityAvailable?: Maybe<Scalars['Float']>;
  storageLocationId?: Maybe<Scalars['Float']>;
  supplierCompanyId?: Maybe<Scalars['Float']>;
  supplierContactId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Items_Stddev_Samp_Fields = {
  __typename?: 'items_stddev_samp_fields';
  alcohol?: Maybe<Scalars['Float']>;
  exportPrice?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  localPrice?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Not used for now */
  quantityAvailable?: Maybe<Scalars['Float']>;
  storageLocationId?: Maybe<Scalars['Float']>;
  supplierCompanyId?: Maybe<Scalars['Float']>;
  supplierContactId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "items" */
export type Items_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Items_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Items_Stream_Cursor_Value_Input = {
  additionalInformations?: InputMaybe<Scalars['String']>;
  alcohol?: InputMaybe<Scalars['Float']>;
  appellations?: InputMaybe<Scalars['jsonb']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  brokerId?: InputMaybe<Scalars['String']>;
  certifications?: InputMaybe<Scalars['jsonb']>;
  comments?: InputMaybe<Scalars['String']>;
  commodityType?: InputMaybe<Scalars['String']>;
  conditioning?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  exportIncoterms?: InputMaybe<Scalars['String']>;
  exportIncotermsType?: InputMaybe<Scalars['String']>;
  exportPrice?: InputMaybe<Scalars['Float']>;
  files?: InputMaybe<Scalars['jsonb']>;
  generic?: InputMaybe<Scalars['String']>;
  harvestMethod?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isOpportunistic?: InputMaybe<Scalars['Boolean']>;
  localPrice?: InputMaybe<Scalars['Float']>;
  lotNo?: InputMaybe<Scalars['String']>;
  netsuiteId?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Int']>;
  qualities?: InputMaybe<Scalars['jsonb']>;
  quantity?: InputMaybe<Scalars['Float']>;
  /** Not used for now */
  quantityAvailable?: InputMaybe<Scalars['Float']>;
  queryEmbedding?: InputMaybe<Scalars['vector']>;
  region?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  storageLocationId?: InputMaybe<Scalars['Int']>;
  subAppellation?: InputMaybe<Scalars['String']>;
  subGeneric?: InputMaybe<Scalars['String']>;
  subRegion?: InputMaybe<Scalars['String']>;
  supplierCompanyId?: InputMaybe<Scalars['Int']>;
  supplierContactId?: InputMaybe<Scalars['Int']>;
  tankNo?: InputMaybe<Scalars['String']>;
  uom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  varietals?: InputMaybe<Scalars['jsonb']>;
  vintages?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type Items_Sum_Fields = {
  __typename?: 'items_sum_fields';
  alcohol?: Maybe<Scalars['Float']>;
  exportPrice?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  localPrice?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Not used for now */
  quantityAvailable?: Maybe<Scalars['Float']>;
  storageLocationId?: Maybe<Scalars['Int']>;
  supplierCompanyId?: Maybe<Scalars['Int']>;
  supplierContactId?: Maybe<Scalars['Int']>;
};

/** update columns of table "items" */
export enum Items_Update_Column {
  /** column name */
  AdditionalInformations = 'additionalInformations',
  /** column name */
  Alcohol = 'alcohol',
  /** column name */
  Appellations = 'appellations',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BrokerId = 'brokerId',
  /** column name */
  Certifications = 'certifications',
  /** column name */
  Comments = 'comments',
  /** column name */
  CommodityType = 'commodityType',
  /** column name */
  Conditioning = 'conditioning',
  /** column name */
  Country = 'country',
  /** column name */
  County = 'county',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  District = 'district',
  /** column name */
  ExportIncoterms = 'exportIncoterms',
  /** column name */
  ExportIncotermsType = 'exportIncotermsType',
  /** column name */
  ExportPrice = 'exportPrice',
  /** column name */
  Files = 'files',
  /** column name */
  Generic = 'generic',
  /** column name */
  HarvestMethod = 'harvestMethod',
  /** column name */
  Id = 'id',
  /** column name */
  IsOpportunistic = 'isOpportunistic',
  /** column name */
  LocalPrice = 'localPrice',
  /** column name */
  LotNo = 'lotNo',
  /** column name */
  NetsuiteId = 'netsuiteId',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  Qualities = 'qualities',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  QuantityAvailable = 'quantityAvailable',
  /** column name */
  QueryEmbedding = 'queryEmbedding',
  /** column name */
  Region = 'region',
  /** column name */
  State = 'state',
  /** column name */
  StorageLocationId = 'storageLocationId',
  /** column name */
  SubAppellation = 'subAppellation',
  /** column name */
  SubGeneric = 'subGeneric',
  /** column name */
  SubRegion = 'subRegion',
  /** column name */
  SupplierCompanyId = 'supplierCompanyId',
  /** column name */
  SupplierContactId = 'supplierContactId',
  /** column name */
  TankNo = 'tankNo',
  /** column name */
  Uom = 'uom',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Varietals = 'varietals',
  /** column name */
  Vintages = 'vintages'
}

export type Items_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Items_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Items_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Items_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Items_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Items_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Items_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Items_Set_Input>;
  where: Items_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Items_Var_Pop_Fields = {
  __typename?: 'items_var_pop_fields';
  alcohol?: Maybe<Scalars['Float']>;
  exportPrice?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  localPrice?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Not used for now */
  quantityAvailable?: Maybe<Scalars['Float']>;
  storageLocationId?: Maybe<Scalars['Float']>;
  supplierCompanyId?: Maybe<Scalars['Float']>;
  supplierContactId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Items_Var_Samp_Fields = {
  __typename?: 'items_var_samp_fields';
  alcohol?: Maybe<Scalars['Float']>;
  exportPrice?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  localPrice?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Not used for now */
  quantityAvailable?: Maybe<Scalars['Float']>;
  storageLocationId?: Maybe<Scalars['Float']>;
  supplierCompanyId?: Maybe<Scalars['Float']>;
  supplierContactId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Items_Variance_Fields = {
  __typename?: 'items_variance_fields';
  alcohol?: Maybe<Scalars['Float']>;
  exportPrice?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  localPrice?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  /** Not used for now */
  quantityAvailable?: Maybe<Scalars['Float']>;
  storageLocationId?: Maybe<Scalars['Float']>;
  supplierCompanyId?: Maybe<Scalars['Float']>;
  supplierContactId?: Maybe<Scalars['Float']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "logs" */
export type Logs = {
  __typename?: 'logs';
  action?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['String'];
  id: Scalars['Int'];
  payload?: Maybe<Scalars['jsonb']>;
  url: Scalars['String'];
};


/** columns and relationships of "logs" */
export type LogsPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "logs" */
export type Logs_Aggregate = {
  __typename?: 'logs_aggregate';
  aggregate?: Maybe<Logs_Aggregate_Fields>;
  nodes: Array<Logs>;
};

/** aggregate fields of "logs" */
export type Logs_Aggregate_Fields = {
  __typename?: 'logs_aggregate_fields';
  avg?: Maybe<Logs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Logs_Max_Fields>;
  min?: Maybe<Logs_Min_Fields>;
  stddev?: Maybe<Logs_Stddev_Fields>;
  stddev_pop?: Maybe<Logs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Logs_Stddev_Samp_Fields>;
  sum?: Maybe<Logs_Sum_Fields>;
  var_pop?: Maybe<Logs_Var_Pop_Fields>;
  var_samp?: Maybe<Logs_Var_Samp_Fields>;
  variance?: Maybe<Logs_Variance_Fields>;
};


/** aggregate fields of "logs" */
export type Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Logs_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Logs_Avg_Fields = {
  __typename?: 'logs_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "logs". All fields are combined with a logical 'AND'. */
export type Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Logs_Bool_Exp>>;
  _not?: InputMaybe<Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Logs_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "logs" */
export enum Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  LogsPkey = 'logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Logs_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Logs_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Logs_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "logs" */
export type Logs_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "logs" */
export type Logs_Insert_Input = {
  action?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Logs_Max_Fields = {
  __typename?: 'logs_max_fields';
  action?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Logs_Min_Fields = {
  __typename?: 'logs_min_fields';
  action?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "logs" */
export type Logs_Mutation_Response = {
  __typename?: 'logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Logs>;
};

/** on_conflict condition type for table "logs" */
export type Logs_On_Conflict = {
  constraint: Logs_Constraint;
  update_columns?: Array<Logs_Update_Column>;
  where?: InputMaybe<Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "logs". */
export type Logs_Order_By = {
  action?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: logs */
export type Logs_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Logs_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "logs" */
export enum Logs_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "logs" */
export type Logs_Set_Input = {
  action?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Logs_Stddev_Fields = {
  __typename?: 'logs_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Logs_Stddev_Pop_Fields = {
  __typename?: 'logs_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Logs_Stddev_Samp_Fields = {
  __typename?: 'logs_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "logs" */
export type Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Logs_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Logs_Sum_Fields = {
  __typename?: 'logs_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "logs" */
export enum Logs_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Url = 'url'
}

export type Logs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Logs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Logs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Logs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Logs_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Logs_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Logs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Logs_Set_Input>;
  where: Logs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Logs_Var_Pop_Fields = {
  __typename?: 'logs_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Logs_Var_Samp_Fields = {
  __typename?: 'logs_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Logs_Variance_Fields = {
  __typename?: 'logs_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs = {
  __typename?: 'matchingItemsBuySpecs';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  buySpec: BuySpecs;
  buySpecId: Scalars['Int'];
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  /** An object relationship */
  item: Items;
  itemId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Aggregate = {
  __typename?: 'matchingItemsBuySpecs_aggregate';
  aggregate?: Maybe<MatchingItemsBuySpecs_Aggregate_Fields>;
  nodes: Array<MatchingItemsBuySpecs>;
};

export type MatchingItemsBuySpecs_Aggregate_Bool_Exp = {
  count?: InputMaybe<MatchingItemsBuySpecs_Aggregate_Bool_Exp_Count>;
};

export type MatchingItemsBuySpecs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<MatchingItemsBuySpecs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<MatchingItemsBuySpecs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Aggregate_Fields = {
  __typename?: 'matchingItemsBuySpecs_aggregate_fields';
  avg?: Maybe<MatchingItemsBuySpecs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<MatchingItemsBuySpecs_Max_Fields>;
  min?: Maybe<MatchingItemsBuySpecs_Min_Fields>;
  stddev?: Maybe<MatchingItemsBuySpecs_Stddev_Fields>;
  stddev_pop?: Maybe<MatchingItemsBuySpecs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MatchingItemsBuySpecs_Stddev_Samp_Fields>;
  sum?: Maybe<MatchingItemsBuySpecs_Sum_Fields>;
  var_pop?: Maybe<MatchingItemsBuySpecs_Var_Pop_Fields>;
  var_samp?: Maybe<MatchingItemsBuySpecs_Var_Samp_Fields>;
  variance?: Maybe<MatchingItemsBuySpecs_Variance_Fields>;
};


/** aggregate fields of "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MatchingItemsBuySpecs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Aggregate_Order_By = {
  avg?: InputMaybe<MatchingItemsBuySpecs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<MatchingItemsBuySpecs_Max_Order_By>;
  min?: InputMaybe<MatchingItemsBuySpecs_Min_Order_By>;
  stddev?: InputMaybe<MatchingItemsBuySpecs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<MatchingItemsBuySpecs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<MatchingItemsBuySpecs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<MatchingItemsBuySpecs_Sum_Order_By>;
  var_pop?: InputMaybe<MatchingItemsBuySpecs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<MatchingItemsBuySpecs_Var_Samp_Order_By>;
  variance?: InputMaybe<MatchingItemsBuySpecs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Arr_Rel_Insert_Input = {
  data: Array<MatchingItemsBuySpecs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<MatchingItemsBuySpecs_On_Conflict>;
};

/** aggregate avg on columns */
export type MatchingItemsBuySpecs_Avg_Fields = {
  __typename?: 'matchingItemsBuySpecs_avg_fields';
  buySpecId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Avg_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "matchingItemsBuySpecs". All fields are combined with a logical 'AND'. */
export type MatchingItemsBuySpecs_Bool_Exp = {
  _and?: InputMaybe<Array<MatchingItemsBuySpecs_Bool_Exp>>;
  _not?: InputMaybe<MatchingItemsBuySpecs_Bool_Exp>;
  _or?: InputMaybe<Array<MatchingItemsBuySpecs_Bool_Exp>>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  buySpec?: InputMaybe<BuySpecs_Bool_Exp>;
  buySpecId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  item?: InputMaybe<Items_Bool_Exp>;
  itemId?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "matchingItemsBuySpecs" */
export enum MatchingItemsBuySpecs_Constraint {
  /** unique or primary key constraint on columns "buySpecId", "itemId" */
  MatchingItemsBuySpecsBuySpecIdItemIdKey = 'matchingItemsBuySpecs_buySpecId_itemId_key',
  /** unique or primary key constraint on columns "id" */
  MatchingItemsBuySpecsPkey = 'matchingItemsBuySpecs_pkey'
}

/** input type for incrementing numeric columns in table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Inc_Input = {
  buySpecId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Insert_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  buySpec?: InputMaybe<BuySpecs_Obj_Rel_Insert_Input>;
  buySpecId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  item?: InputMaybe<Items_Obj_Rel_Insert_Input>;
  itemId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type MatchingItemsBuySpecs_Max_Fields = {
  __typename?: 'matchingItemsBuySpecs_max_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  buySpecId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Max_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  buySpecId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type MatchingItemsBuySpecs_Min_Fields = {
  __typename?: 'matchingItemsBuySpecs_min_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  buySpecId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Min_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  buySpecId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Mutation_Response = {
  __typename?: 'matchingItemsBuySpecs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MatchingItemsBuySpecs>;
};

/** on_conflict condition type for table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_On_Conflict = {
  constraint: MatchingItemsBuySpecs_Constraint;
  update_columns?: Array<MatchingItemsBuySpecs_Update_Column>;
  where?: InputMaybe<MatchingItemsBuySpecs_Bool_Exp>;
};

/** Ordering options when selecting data from "matchingItemsBuySpecs". */
export type MatchingItemsBuySpecs_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  buySpec?: InputMaybe<BuySpecs_Order_By>;
  buySpecId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  item?: InputMaybe<Items_Order_By>;
  itemId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: matchingItemsBuySpecs */
export type MatchingItemsBuySpecs_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "matchingItemsBuySpecs" */
export enum MatchingItemsBuySpecs_Select_Column {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BuySpecId = 'buySpecId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  ItemId = 'itemId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Set_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  buySpecId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type MatchingItemsBuySpecs_Stddev_Fields = {
  __typename?: 'matchingItemsBuySpecs_stddev_fields';
  buySpecId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Stddev_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type MatchingItemsBuySpecs_Stddev_Pop_Fields = {
  __typename?: 'matchingItemsBuySpecs_stddev_pop_fields';
  buySpecId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Stddev_Pop_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type MatchingItemsBuySpecs_Stddev_Samp_Fields = {
  __typename?: 'matchingItemsBuySpecs_stddev_samp_fields';
  buySpecId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Stddev_Samp_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MatchingItemsBuySpecs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MatchingItemsBuySpecs_Stream_Cursor_Value_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  buySpecId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type MatchingItemsBuySpecs_Sum_Fields = {
  __typename?: 'matchingItemsBuySpecs_sum_fields';
  buySpecId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Sum_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
};

/** update columns of table "matchingItemsBuySpecs" */
export enum MatchingItemsBuySpecs_Update_Column {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BuySpecId = 'buySpecId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  ItemId = 'itemId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type MatchingItemsBuySpecs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MatchingItemsBuySpecs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MatchingItemsBuySpecs_Set_Input>;
  where: MatchingItemsBuySpecs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MatchingItemsBuySpecs_Var_Pop_Fields = {
  __typename?: 'matchingItemsBuySpecs_var_pop_fields';
  buySpecId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Var_Pop_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type MatchingItemsBuySpecs_Var_Samp_Fields = {
  __typename?: 'matchingItemsBuySpecs_var_samp_fields';
  buySpecId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Var_Samp_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type MatchingItemsBuySpecs_Variance_Fields = {
  __typename?: 'matchingItemsBuySpecs_variance_fields';
  buySpecId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "matchingItemsBuySpecs" */
export type MatchingItemsBuySpecs_Variance_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** delete data from the table: "addresses" */
  delete_addresses?: Maybe<Addresses_Mutation_Response>;
  /** delete single row from the table: "addresses" */
  delete_addresses_by_pk?: Maybe<Addresses>;
  /** delete data from the table: "agreementTerms" */
  delete_agreementTerms?: Maybe<AgreementTerms_Mutation_Response>;
  /** delete single row from the table: "agreementTerms" */
  delete_agreementTerms_by_pk?: Maybe<AgreementTerms>;
  /** delete data from the table: "agreements" */
  delete_agreements?: Maybe<Agreements_Mutation_Response>;
  /** delete single row from the table: "agreements" */
  delete_agreements_by_pk?: Maybe<Agreements>;
  /** delete data from the table: "appellations" */
  delete_appellations?: Maybe<Appellations_Mutation_Response>;
  /** delete single row from the table: "appellations" */
  delete_appellations_by_pk?: Maybe<Appellations>;
  /** delete data from the table: "authorizedDomains" */
  delete_authorizedDomains?: Maybe<AuthorizedDomains_Mutation_Response>;
  /** delete single row from the table: "authorizedDomains" */
  delete_authorizedDomains_by_pk?: Maybe<AuthorizedDomains>;
  /** delete data from the table: "buySpecs" */
  delete_buySpecs?: Maybe<BuySpecs_Mutation_Response>;
  /** delete single row from the table: "buySpecs" */
  delete_buySpecs_by_pk?: Maybe<BuySpecs>;
  /** delete data from the table: "companies" */
  delete_companies?: Maybe<Companies_Mutation_Response>;
  /** delete single row from the table: "companies" */
  delete_companies_by_pk?: Maybe<Companies>;
  /** delete data from the table: "companyAddress" */
  delete_companyAddress?: Maybe<CompanyAddress_Mutation_Response>;
  /** delete single row from the table: "companyAddress" */
  delete_companyAddress_by_pk?: Maybe<CompanyAddress>;
  /** delete data from the table: "contacts" */
  delete_contacts?: Maybe<Contacts_Mutation_Response>;
  /** delete single row from the table: "contacts" */
  delete_contacts_by_pk?: Maybe<Contacts>;
  /** delete data from the table: "contracts" */
  delete_contracts?: Maybe<Contracts_Mutation_Response>;
  /** delete single row from the table: "contracts" */
  delete_contracts_by_pk?: Maybe<Contracts>;
  /** delete data from the table: "currenciesConversions" */
  delete_currenciesConversions?: Maybe<CurrenciesConversions_Mutation_Response>;
  /** delete single row from the table: "currenciesConversions" */
  delete_currenciesConversions_by_pk?: Maybe<CurrenciesConversions>;
  /** delete data from the table: "history" */
  delete_history?: Maybe<History_Mutation_Response>;
  /** delete single row from the table: "history" */
  delete_history_by_pk?: Maybe<History>;
  /** delete data from the table: "invoices" */
  delete_invoices?: Maybe<Invoices_Mutation_Response>;
  /** delete single row from the table: "invoices" */
  delete_invoices_by_pk?: Maybe<Invoices>;
  /** delete data from the table: "items" */
  delete_items?: Maybe<Items_Mutation_Response>;
  /** delete single row from the table: "items" */
  delete_items_by_pk?: Maybe<Items>;
  /** delete data from the table: "logs" */
  delete_logs?: Maybe<Logs_Mutation_Response>;
  /** delete single row from the table: "logs" */
  delete_logs_by_pk?: Maybe<Logs>;
  /** delete data from the table: "matchingItemsBuySpecs" */
  delete_matchingItemsBuySpecs?: Maybe<MatchingItemsBuySpecs_Mutation_Response>;
  /** delete single row from the table: "matchingItemsBuySpecs" */
  delete_matchingItemsBuySpecs_by_pk?: Maybe<MatchingItemsBuySpecs>;
  /** delete data from the table: "notifications" */
  delete_notifications?: Maybe<Notifications_Mutation_Response>;
  /** delete single row from the table: "notifications" */
  delete_notifications_by_pk?: Maybe<Notifications>;
  /** delete data from the table: "offices" */
  delete_offices?: Maybe<Offices_Mutation_Response>;
  /** delete single row from the table: "offices" */
  delete_offices_by_pk?: Maybe<Offices>;
  /** delete data from the table: "releases" */
  delete_releases?: Maybe<Releases_Mutation_Response>;
  /** delete single row from the table: "releases" */
  delete_releases_by_pk?: Maybe<Releases>;
  /** delete data from the table: "reminders" */
  delete_reminders?: Maybe<Reminders_Mutation_Response>;
  /** delete single row from the table: "reminders" */
  delete_reminders_by_pk?: Maybe<Reminders>;
  /** delete data from the table: "sampleLabels" */
  delete_sampleLabels?: Maybe<SampleLabels_Mutation_Response>;
  /** delete single row from the table: "sampleLabels" */
  delete_sampleLabels_by_pk?: Maybe<SampleLabels>;
  /** delete data from the table: "sampleShipmentRequests" */
  delete_sampleShipmentRequests?: Maybe<SampleShipmentRequests_Mutation_Response>;
  /** delete single row from the table: "sampleShipmentRequests" */
  delete_sampleShipmentRequests_by_pk?: Maybe<SampleShipmentRequests>;
  /** delete data from the table: "sampleShipments" */
  delete_sampleShipments?: Maybe<SampleShipments_Mutation_Response>;
  /** delete single row from the table: "sampleShipments" */
  delete_sampleShipments_by_pk?: Maybe<SampleShipments>;
  /** delete data from the table: "samples" */
  delete_samples?: Maybe<Samples_Mutation_Response>;
  /** delete single row from the table: "samples" */
  delete_samples_by_pk?: Maybe<Samples>;
  /** delete data from the table: "shipmentFulfillments" */
  delete_shipmentFulfillments?: Maybe<ShipmentFulfillments_Mutation_Response>;
  /** delete single row from the table: "shipmentFulfillments" */
  delete_shipmentFulfillments_by_pk?: Maybe<ShipmentFulfillments>;
  /** delete data from the table: "trackings" */
  delete_trackings?: Maybe<Trackings_Mutation_Response>;
  /** delete single row from the table: "trackings" */
  delete_trackings_by_pk?: Maybe<Trackings>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete data from the table: "usersBonus" */
  delete_usersBonus?: Maybe<UsersBonus_Mutation_Response>;
  /** delete single row from the table: "usersBonus" */
  delete_usersBonus_by_pk?: Maybe<UsersBonus>;
  /** delete data from the table: "usersCosts" */
  delete_usersCosts?: Maybe<UsersCosts_Mutation_Response>;
  /** delete single row from the table: "usersCosts" */
  delete_usersCosts_by_pk?: Maybe<UsersCosts>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "validationsContracts" */
  delete_validationsContracts?: Maybe<ValidationsContracts_Mutation_Response>;
  /** delete single row from the table: "validationsContracts" */
  delete_validationsContracts_by_pk?: Maybe<ValidationsContracts>;
  /** delete data from the table: "varietals" */
  delete_varietals?: Maybe<Varietals_Mutation_Response>;
  /** delete single row from the table: "varietals" */
  delete_varietals_by_pk?: Maybe<Varietals>;
  /** insert data into the table: "addresses" */
  insert_addresses?: Maybe<Addresses_Mutation_Response>;
  /** insert a single row into the table: "addresses" */
  insert_addresses_one?: Maybe<Addresses>;
  /** insert data into the table: "agreementTerms" */
  insert_agreementTerms?: Maybe<AgreementTerms_Mutation_Response>;
  /** insert a single row into the table: "agreementTerms" */
  insert_agreementTerms_one?: Maybe<AgreementTerms>;
  /** insert data into the table: "agreements" */
  insert_agreements?: Maybe<Agreements_Mutation_Response>;
  /** insert a single row into the table: "agreements" */
  insert_agreements_one?: Maybe<Agreements>;
  /** insert data into the table: "appellations" */
  insert_appellations?: Maybe<Appellations_Mutation_Response>;
  /** insert a single row into the table: "appellations" */
  insert_appellations_one?: Maybe<Appellations>;
  /** insert data into the table: "authorizedDomains" */
  insert_authorizedDomains?: Maybe<AuthorizedDomains_Mutation_Response>;
  /** insert a single row into the table: "authorizedDomains" */
  insert_authorizedDomains_one?: Maybe<AuthorizedDomains>;
  /** insert data into the table: "buySpecs" */
  insert_buySpecs?: Maybe<BuySpecs_Mutation_Response>;
  /** insert a single row into the table: "buySpecs" */
  insert_buySpecs_one?: Maybe<BuySpecs>;
  /** insert data into the table: "companies" */
  insert_companies?: Maybe<Companies_Mutation_Response>;
  /** insert a single row into the table: "companies" */
  insert_companies_one?: Maybe<Companies>;
  /** insert data into the table: "companyAddress" */
  insert_companyAddress?: Maybe<CompanyAddress_Mutation_Response>;
  /** insert a single row into the table: "companyAddress" */
  insert_companyAddress_one?: Maybe<CompanyAddress>;
  /** insert data into the table: "contacts" */
  insert_contacts?: Maybe<Contacts_Mutation_Response>;
  /** insert a single row into the table: "contacts" */
  insert_contacts_one?: Maybe<Contacts>;
  /** insert data into the table: "contracts" */
  insert_contracts?: Maybe<Contracts_Mutation_Response>;
  /** insert a single row into the table: "contracts" */
  insert_contracts_one?: Maybe<Contracts>;
  /** insert data into the table: "currenciesConversions" */
  insert_currenciesConversions?: Maybe<CurrenciesConversions_Mutation_Response>;
  /** insert a single row into the table: "currenciesConversions" */
  insert_currenciesConversions_one?: Maybe<CurrenciesConversions>;
  /** insert data into the table: "history" */
  insert_history?: Maybe<History_Mutation_Response>;
  /** insert a single row into the table: "history" */
  insert_history_one?: Maybe<History>;
  /** insert data into the table: "invoices" */
  insert_invoices?: Maybe<Invoices_Mutation_Response>;
  /** insert a single row into the table: "invoices" */
  insert_invoices_one?: Maybe<Invoices>;
  /** insert data into the table: "items" */
  insert_items?: Maybe<Items_Mutation_Response>;
  /** insert a single row into the table: "items" */
  insert_items_one?: Maybe<Items>;
  /** insert data into the table: "logs" */
  insert_logs?: Maybe<Logs_Mutation_Response>;
  /** insert a single row into the table: "logs" */
  insert_logs_one?: Maybe<Logs>;
  /** insert data into the table: "matchingItemsBuySpecs" */
  insert_matchingItemsBuySpecs?: Maybe<MatchingItemsBuySpecs_Mutation_Response>;
  /** insert a single row into the table: "matchingItemsBuySpecs" */
  insert_matchingItemsBuySpecs_one?: Maybe<MatchingItemsBuySpecs>;
  /** insert data into the table: "notifications" */
  insert_notifications?: Maybe<Notifications_Mutation_Response>;
  /** insert a single row into the table: "notifications" */
  insert_notifications_one?: Maybe<Notifications>;
  /** insert data into the table: "offices" */
  insert_offices?: Maybe<Offices_Mutation_Response>;
  /** insert a single row into the table: "offices" */
  insert_offices_one?: Maybe<Offices>;
  /** insert data into the table: "releases" */
  insert_releases?: Maybe<Releases_Mutation_Response>;
  /** insert a single row into the table: "releases" */
  insert_releases_one?: Maybe<Releases>;
  /** insert data into the table: "reminders" */
  insert_reminders?: Maybe<Reminders_Mutation_Response>;
  /** insert a single row into the table: "reminders" */
  insert_reminders_one?: Maybe<Reminders>;
  /** insert data into the table: "sampleLabels" */
  insert_sampleLabels?: Maybe<SampleLabels_Mutation_Response>;
  /** insert a single row into the table: "sampleLabels" */
  insert_sampleLabels_one?: Maybe<SampleLabels>;
  /** insert data into the table: "sampleShipmentRequests" */
  insert_sampleShipmentRequests?: Maybe<SampleShipmentRequests_Mutation_Response>;
  /** insert a single row into the table: "sampleShipmentRequests" */
  insert_sampleShipmentRequests_one?: Maybe<SampleShipmentRequests>;
  /** insert data into the table: "sampleShipments" */
  insert_sampleShipments?: Maybe<SampleShipments_Mutation_Response>;
  /** insert a single row into the table: "sampleShipments" */
  insert_sampleShipments_one?: Maybe<SampleShipments>;
  /** insert data into the table: "samples" */
  insert_samples?: Maybe<Samples_Mutation_Response>;
  /** insert a single row into the table: "samples" */
  insert_samples_one?: Maybe<Samples>;
  /** insert data into the table: "shipmentFulfillments" */
  insert_shipmentFulfillments?: Maybe<ShipmentFulfillments_Mutation_Response>;
  /** insert a single row into the table: "shipmentFulfillments" */
  insert_shipmentFulfillments_one?: Maybe<ShipmentFulfillments>;
  /** insert data into the table: "trackings" */
  insert_trackings?: Maybe<Trackings_Mutation_Response>;
  /** insert a single row into the table: "trackings" */
  insert_trackings_one?: Maybe<Trackings>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert data into the table: "usersBonus" */
  insert_usersBonus?: Maybe<UsersBonus_Mutation_Response>;
  /** insert a single row into the table: "usersBonus" */
  insert_usersBonus_one?: Maybe<UsersBonus>;
  /** insert data into the table: "usersCosts" */
  insert_usersCosts?: Maybe<UsersCosts_Mutation_Response>;
  /** insert a single row into the table: "usersCosts" */
  insert_usersCosts_one?: Maybe<UsersCosts>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "validationsContracts" */
  insert_validationsContracts?: Maybe<ValidationsContracts_Mutation_Response>;
  /** insert a single row into the table: "validationsContracts" */
  insert_validationsContracts_one?: Maybe<ValidationsContracts>;
  /** insert data into the table: "varietals" */
  insert_varietals?: Maybe<Varietals_Mutation_Response>;
  /** insert a single row into the table: "varietals" */
  insert_varietals_one?: Maybe<Varietals>;
  /** update data of the table: "addresses" */
  update_addresses?: Maybe<Addresses_Mutation_Response>;
  /** update single row of the table: "addresses" */
  update_addresses_by_pk?: Maybe<Addresses>;
  /** update multiples rows of table: "addresses" */
  update_addresses_many?: Maybe<Array<Maybe<Addresses_Mutation_Response>>>;
  /** update data of the table: "agreementTerms" */
  update_agreementTerms?: Maybe<AgreementTerms_Mutation_Response>;
  /** update single row of the table: "agreementTerms" */
  update_agreementTerms_by_pk?: Maybe<AgreementTerms>;
  /** update multiples rows of table: "agreementTerms" */
  update_agreementTerms_many?: Maybe<Array<Maybe<AgreementTerms_Mutation_Response>>>;
  /** update data of the table: "agreements" */
  update_agreements?: Maybe<Agreements_Mutation_Response>;
  /** update single row of the table: "agreements" */
  update_agreements_by_pk?: Maybe<Agreements>;
  /** update multiples rows of table: "agreements" */
  update_agreements_many?: Maybe<Array<Maybe<Agreements_Mutation_Response>>>;
  /** update data of the table: "appellations" */
  update_appellations?: Maybe<Appellations_Mutation_Response>;
  /** update single row of the table: "appellations" */
  update_appellations_by_pk?: Maybe<Appellations>;
  /** update multiples rows of table: "appellations" */
  update_appellations_many?: Maybe<Array<Maybe<Appellations_Mutation_Response>>>;
  /** update data of the table: "authorizedDomains" */
  update_authorizedDomains?: Maybe<AuthorizedDomains_Mutation_Response>;
  /** update single row of the table: "authorizedDomains" */
  update_authorizedDomains_by_pk?: Maybe<AuthorizedDomains>;
  /** update multiples rows of table: "authorizedDomains" */
  update_authorizedDomains_many?: Maybe<Array<Maybe<AuthorizedDomains_Mutation_Response>>>;
  /** update data of the table: "buySpecs" */
  update_buySpecs?: Maybe<BuySpecs_Mutation_Response>;
  /** update single row of the table: "buySpecs" */
  update_buySpecs_by_pk?: Maybe<BuySpecs>;
  /** update multiples rows of table: "buySpecs" */
  update_buySpecs_many?: Maybe<Array<Maybe<BuySpecs_Mutation_Response>>>;
  /** update data of the table: "companies" */
  update_companies?: Maybe<Companies_Mutation_Response>;
  /** update single row of the table: "companies" */
  update_companies_by_pk?: Maybe<Companies>;
  /** update multiples rows of table: "companies" */
  update_companies_many?: Maybe<Array<Maybe<Companies_Mutation_Response>>>;
  /** update data of the table: "companyAddress" */
  update_companyAddress?: Maybe<CompanyAddress_Mutation_Response>;
  /** update single row of the table: "companyAddress" */
  update_companyAddress_by_pk?: Maybe<CompanyAddress>;
  /** update multiples rows of table: "companyAddress" */
  update_companyAddress_many?: Maybe<Array<Maybe<CompanyAddress_Mutation_Response>>>;
  /** update data of the table: "contacts" */
  update_contacts?: Maybe<Contacts_Mutation_Response>;
  /** update single row of the table: "contacts" */
  update_contacts_by_pk?: Maybe<Contacts>;
  /** update multiples rows of table: "contacts" */
  update_contacts_many?: Maybe<Array<Maybe<Contacts_Mutation_Response>>>;
  /** update data of the table: "contracts" */
  update_contracts?: Maybe<Contracts_Mutation_Response>;
  /** update single row of the table: "contracts" */
  update_contracts_by_pk?: Maybe<Contracts>;
  /** update multiples rows of table: "contracts" */
  update_contracts_many?: Maybe<Array<Maybe<Contracts_Mutation_Response>>>;
  /** update data of the table: "currenciesConversions" */
  update_currenciesConversions?: Maybe<CurrenciesConversions_Mutation_Response>;
  /** update single row of the table: "currenciesConversions" */
  update_currenciesConversions_by_pk?: Maybe<CurrenciesConversions>;
  /** update multiples rows of table: "currenciesConversions" */
  update_currenciesConversions_many?: Maybe<Array<Maybe<CurrenciesConversions_Mutation_Response>>>;
  /** update data of the table: "history" */
  update_history?: Maybe<History_Mutation_Response>;
  /** update single row of the table: "history" */
  update_history_by_pk?: Maybe<History>;
  /** update multiples rows of table: "history" */
  update_history_many?: Maybe<Array<Maybe<History_Mutation_Response>>>;
  /** update data of the table: "invoices" */
  update_invoices?: Maybe<Invoices_Mutation_Response>;
  /** update single row of the table: "invoices" */
  update_invoices_by_pk?: Maybe<Invoices>;
  /** update multiples rows of table: "invoices" */
  update_invoices_many?: Maybe<Array<Maybe<Invoices_Mutation_Response>>>;
  /** update data of the table: "items" */
  update_items?: Maybe<Items_Mutation_Response>;
  /** update single row of the table: "items" */
  update_items_by_pk?: Maybe<Items>;
  /** update multiples rows of table: "items" */
  update_items_many?: Maybe<Array<Maybe<Items_Mutation_Response>>>;
  /** update data of the table: "logs" */
  update_logs?: Maybe<Logs_Mutation_Response>;
  /** update single row of the table: "logs" */
  update_logs_by_pk?: Maybe<Logs>;
  /** update multiples rows of table: "logs" */
  update_logs_many?: Maybe<Array<Maybe<Logs_Mutation_Response>>>;
  /** update data of the table: "matchingItemsBuySpecs" */
  update_matchingItemsBuySpecs?: Maybe<MatchingItemsBuySpecs_Mutation_Response>;
  /** update single row of the table: "matchingItemsBuySpecs" */
  update_matchingItemsBuySpecs_by_pk?: Maybe<MatchingItemsBuySpecs>;
  /** update multiples rows of table: "matchingItemsBuySpecs" */
  update_matchingItemsBuySpecs_many?: Maybe<Array<Maybe<MatchingItemsBuySpecs_Mutation_Response>>>;
  /** update data of the table: "notifications" */
  update_notifications?: Maybe<Notifications_Mutation_Response>;
  /** update single row of the table: "notifications" */
  update_notifications_by_pk?: Maybe<Notifications>;
  /** update multiples rows of table: "notifications" */
  update_notifications_many?: Maybe<Array<Maybe<Notifications_Mutation_Response>>>;
  /** update data of the table: "offices" */
  update_offices?: Maybe<Offices_Mutation_Response>;
  /** update single row of the table: "offices" */
  update_offices_by_pk?: Maybe<Offices>;
  /** update multiples rows of table: "offices" */
  update_offices_many?: Maybe<Array<Maybe<Offices_Mutation_Response>>>;
  /** update data of the table: "releases" */
  update_releases?: Maybe<Releases_Mutation_Response>;
  /** update single row of the table: "releases" */
  update_releases_by_pk?: Maybe<Releases>;
  /** update multiples rows of table: "releases" */
  update_releases_many?: Maybe<Array<Maybe<Releases_Mutation_Response>>>;
  /** update data of the table: "reminders" */
  update_reminders?: Maybe<Reminders_Mutation_Response>;
  /** update single row of the table: "reminders" */
  update_reminders_by_pk?: Maybe<Reminders>;
  /** update multiples rows of table: "reminders" */
  update_reminders_many?: Maybe<Array<Maybe<Reminders_Mutation_Response>>>;
  /** update data of the table: "sampleLabels" */
  update_sampleLabels?: Maybe<SampleLabels_Mutation_Response>;
  /** update single row of the table: "sampleLabels" */
  update_sampleLabels_by_pk?: Maybe<SampleLabels>;
  /** update multiples rows of table: "sampleLabels" */
  update_sampleLabels_many?: Maybe<Array<Maybe<SampleLabels_Mutation_Response>>>;
  /** update data of the table: "sampleShipmentRequests" */
  update_sampleShipmentRequests?: Maybe<SampleShipmentRequests_Mutation_Response>;
  /** update single row of the table: "sampleShipmentRequests" */
  update_sampleShipmentRequests_by_pk?: Maybe<SampleShipmentRequests>;
  /** update multiples rows of table: "sampleShipmentRequests" */
  update_sampleShipmentRequests_many?: Maybe<Array<Maybe<SampleShipmentRequests_Mutation_Response>>>;
  /** update data of the table: "sampleShipments" */
  update_sampleShipments?: Maybe<SampleShipments_Mutation_Response>;
  /** update single row of the table: "sampleShipments" */
  update_sampleShipments_by_pk?: Maybe<SampleShipments>;
  /** update multiples rows of table: "sampleShipments" */
  update_sampleShipments_many?: Maybe<Array<Maybe<SampleShipments_Mutation_Response>>>;
  /** update data of the table: "samples" */
  update_samples?: Maybe<Samples_Mutation_Response>;
  /** update single row of the table: "samples" */
  update_samples_by_pk?: Maybe<Samples>;
  /** update multiples rows of table: "samples" */
  update_samples_many?: Maybe<Array<Maybe<Samples_Mutation_Response>>>;
  /** update data of the table: "shipmentFulfillments" */
  update_shipmentFulfillments?: Maybe<ShipmentFulfillments_Mutation_Response>;
  /** update single row of the table: "shipmentFulfillments" */
  update_shipmentFulfillments_by_pk?: Maybe<ShipmentFulfillments>;
  /** update multiples rows of table: "shipmentFulfillments" */
  update_shipmentFulfillments_many?: Maybe<Array<Maybe<ShipmentFulfillments_Mutation_Response>>>;
  /** update data of the table: "trackings" */
  update_trackings?: Maybe<Trackings_Mutation_Response>;
  /** update single row of the table: "trackings" */
  update_trackings_by_pk?: Maybe<Trackings>;
  /** update multiples rows of table: "trackings" */
  update_trackings_many?: Maybe<Array<Maybe<Trackings_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update data of the table: "usersBonus" */
  update_usersBonus?: Maybe<UsersBonus_Mutation_Response>;
  /** update single row of the table: "usersBonus" */
  update_usersBonus_by_pk?: Maybe<UsersBonus>;
  /** update multiples rows of table: "usersBonus" */
  update_usersBonus_many?: Maybe<Array<Maybe<UsersBonus_Mutation_Response>>>;
  /** update data of the table: "usersCosts" */
  update_usersCosts?: Maybe<UsersCosts_Mutation_Response>;
  /** update single row of the table: "usersCosts" */
  update_usersCosts_by_pk?: Maybe<UsersCosts>;
  /** update multiples rows of table: "usersCosts" */
  update_usersCosts_many?: Maybe<Array<Maybe<UsersCosts_Mutation_Response>>>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "validationsContracts" */
  update_validationsContracts?: Maybe<ValidationsContracts_Mutation_Response>;
  /** update single row of the table: "validationsContracts" */
  update_validationsContracts_by_pk?: Maybe<ValidationsContracts>;
  /** update multiples rows of table: "validationsContracts" */
  update_validationsContracts_many?: Maybe<Array<Maybe<ValidationsContracts_Mutation_Response>>>;
  /** update data of the table: "varietals" */
  update_varietals?: Maybe<Varietals_Mutation_Response>;
  /** update single row of the table: "varietals" */
  update_varietals_by_pk?: Maybe<Varietals>;
  /** update multiples rows of table: "varietals" */
  update_varietals_many?: Maybe<Array<Maybe<Varietals_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootDelete_AddressesArgs = {
  where: Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Addresses_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AgreementTermsArgs = {
  where: AgreementTerms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AgreementTerms_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AgreementsArgs = {
  where: Agreements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Agreements_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AppellationsArgs = {
  where: Appellations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Appellations_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_AuthorizedDomainsArgs = {
  where: AuthorizedDomains_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_AuthorizedDomains_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_BuySpecsArgs = {
  where: BuySpecs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_BuySpecs_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CompaniesArgs = {
  where: Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Companies_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CompanyAddressArgs = {
  where: CompanyAddress_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CompanyAddress_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ContactsArgs = {
  where: Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contacts_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ContractsArgs = {
  where: Contracts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Contracts_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_CurrenciesConversionsArgs = {
  where: CurrenciesConversions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_CurrenciesConversions_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_HistoryArgs = {
  where: History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_History_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_InvoicesArgs = {
  where: Invoices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Invoices_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ItemsArgs = {
  where: Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Items_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_LogsArgs = {
  where: Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Logs_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_MatchingItemsBuySpecsArgs = {
  where: MatchingItemsBuySpecs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_MatchingItemsBuySpecs_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_NotificationsArgs = {
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notifications_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_OfficesArgs = {
  where: Offices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Offices_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ReleasesArgs = {
  where: Releases_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Releases_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_RemindersArgs = {
  where: Reminders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reminders_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SampleLabelsArgs = {
  where: SampleLabels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SampleLabels_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SampleShipmentRequestsArgs = {
  where: SampleShipmentRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SampleShipmentRequests_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SampleShipmentsArgs = {
  where: SampleShipments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_SampleShipments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_SamplesArgs = {
  where: Samples_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Samples_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_ShipmentFulfillmentsArgs = {
  where: ShipmentFulfillments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ShipmentFulfillments_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_TrackingsArgs = {
  where: Trackings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trackings_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UsersBonusArgs = {
  where: UsersBonus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UsersBonus_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_UsersCostsArgs = {
  where: UsersCosts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_UsersCosts_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ValidationsContractsArgs = {
  where: ValidationsContracts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_ValidationsContracts_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_VarietalsArgs = {
  where: Varietals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Varietals_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootInsert_AddressesArgs = {
  objects: Array<Addresses_Insert_Input>;
  on_conflict?: InputMaybe<Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Addresses_OneArgs = {
  object: Addresses_Insert_Input;
  on_conflict?: InputMaybe<Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AgreementTermsArgs = {
  objects: Array<AgreementTerms_Insert_Input>;
  on_conflict?: InputMaybe<AgreementTerms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AgreementTerms_OneArgs = {
  object: AgreementTerms_Insert_Input;
  on_conflict?: InputMaybe<AgreementTerms_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AgreementsArgs = {
  objects: Array<Agreements_Insert_Input>;
  on_conflict?: InputMaybe<Agreements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Agreements_OneArgs = {
  object: Agreements_Insert_Input;
  on_conflict?: InputMaybe<Agreements_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AppellationsArgs = {
  objects: Array<Appellations_Insert_Input>;
  on_conflict?: InputMaybe<Appellations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Appellations_OneArgs = {
  object: Appellations_Insert_Input;
  on_conflict?: InputMaybe<Appellations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AuthorizedDomainsArgs = {
  objects: Array<AuthorizedDomains_Insert_Input>;
  on_conflict?: InputMaybe<AuthorizedDomains_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AuthorizedDomains_OneArgs = {
  object: AuthorizedDomains_Insert_Input;
  on_conflict?: InputMaybe<AuthorizedDomains_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuySpecsArgs = {
  objects: Array<BuySpecs_Insert_Input>;
  on_conflict?: InputMaybe<BuySpecs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_BuySpecs_OneArgs = {
  object: BuySpecs_Insert_Input;
  on_conflict?: InputMaybe<BuySpecs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CompaniesArgs = {
  objects: Array<Companies_Insert_Input>;
  on_conflict?: InputMaybe<Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Companies_OneArgs = {
  object: Companies_Insert_Input;
  on_conflict?: InputMaybe<Companies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyAddressArgs = {
  objects: Array<CompanyAddress_Insert_Input>;
  on_conflict?: InputMaybe<CompanyAddress_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyAddress_OneArgs = {
  object: CompanyAddress_Insert_Input;
  on_conflict?: InputMaybe<CompanyAddress_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ContactsArgs = {
  objects: Array<Contacts_Insert_Input>;
  on_conflict?: InputMaybe<Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contacts_OneArgs = {
  object: Contacts_Insert_Input;
  on_conflict?: InputMaybe<Contacts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ContractsArgs = {
  objects: Array<Contracts_Insert_Input>;
  on_conflict?: InputMaybe<Contracts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Contracts_OneArgs = {
  object: Contracts_Insert_Input;
  on_conflict?: InputMaybe<Contracts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CurrenciesConversionsArgs = {
  objects: Array<CurrenciesConversions_Insert_Input>;
  on_conflict?: InputMaybe<CurrenciesConversions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CurrenciesConversions_OneArgs = {
  object: CurrenciesConversions_Insert_Input;
  on_conflict?: InputMaybe<CurrenciesConversions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_HistoryArgs = {
  objects: Array<History_Insert_Input>;
  on_conflict?: InputMaybe<History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_History_OneArgs = {
  object: History_Insert_Input;
  on_conflict?: InputMaybe<History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvoicesArgs = {
  objects: Array<Invoices_Insert_Input>;
  on_conflict?: InputMaybe<Invoices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invoices_OneArgs = {
  object: Invoices_Insert_Input;
  on_conflict?: InputMaybe<Invoices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ItemsArgs = {
  objects: Array<Items_Insert_Input>;
  on_conflict?: InputMaybe<Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Items_OneArgs = {
  object: Items_Insert_Input;
  on_conflict?: InputMaybe<Items_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LogsArgs = {
  objects: Array<Logs_Insert_Input>;
  on_conflict?: InputMaybe<Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Logs_OneArgs = {
  object: Logs_Insert_Input;
  on_conflict?: InputMaybe<Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MatchingItemsBuySpecsArgs = {
  objects: Array<MatchingItemsBuySpecs_Insert_Input>;
  on_conflict?: InputMaybe<MatchingItemsBuySpecs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_MatchingItemsBuySpecs_OneArgs = {
  object: MatchingItemsBuySpecs_Insert_Input;
  on_conflict?: InputMaybe<MatchingItemsBuySpecs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_NotificationsArgs = {
  objects: Array<Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notifications_OneArgs = {
  object: Notifications_Insert_Input;
  on_conflict?: InputMaybe<Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OfficesArgs = {
  objects: Array<Offices_Insert_Input>;
  on_conflict?: InputMaybe<Offices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Offices_OneArgs = {
  object: Offices_Insert_Input;
  on_conflict?: InputMaybe<Offices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReleasesArgs = {
  objects: Array<Releases_Insert_Input>;
  on_conflict?: InputMaybe<Releases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Releases_OneArgs = {
  object: Releases_Insert_Input;
  on_conflict?: InputMaybe<Releases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RemindersArgs = {
  objects: Array<Reminders_Insert_Input>;
  on_conflict?: InputMaybe<Reminders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reminders_OneArgs = {
  object: Reminders_Insert_Input;
  on_conflict?: InputMaybe<Reminders_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SampleLabelsArgs = {
  objects: Array<SampleLabels_Insert_Input>;
  on_conflict?: InputMaybe<SampleLabels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SampleLabels_OneArgs = {
  object: SampleLabels_Insert_Input;
  on_conflict?: InputMaybe<SampleLabels_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SampleShipmentRequestsArgs = {
  objects: Array<SampleShipmentRequests_Insert_Input>;
  on_conflict?: InputMaybe<SampleShipmentRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SampleShipmentRequests_OneArgs = {
  object: SampleShipmentRequests_Insert_Input;
  on_conflict?: InputMaybe<SampleShipmentRequests_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SampleShipmentsArgs = {
  objects: Array<SampleShipments_Insert_Input>;
  on_conflict?: InputMaybe<SampleShipments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SampleShipments_OneArgs = {
  object: SampleShipments_Insert_Input;
  on_conflict?: InputMaybe<SampleShipments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SamplesArgs = {
  objects: Array<Samples_Insert_Input>;
  on_conflict?: InputMaybe<Samples_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Samples_OneArgs = {
  object: Samples_Insert_Input;
  on_conflict?: InputMaybe<Samples_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ShipmentFulfillmentsArgs = {
  objects: Array<ShipmentFulfillments_Insert_Input>;
  on_conflict?: InputMaybe<ShipmentFulfillments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ShipmentFulfillments_OneArgs = {
  object: ShipmentFulfillments_Insert_Input;
  on_conflict?: InputMaybe<ShipmentFulfillments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TrackingsArgs = {
  objects: Array<Trackings_Insert_Input>;
  on_conflict?: InputMaybe<Trackings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trackings_OneArgs = {
  object: Trackings_Insert_Input;
  on_conflict?: InputMaybe<Trackings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersBonusArgs = {
  objects: Array<UsersBonus_Insert_Input>;
  on_conflict?: InputMaybe<UsersBonus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersBonus_OneArgs = {
  object: UsersBonus_Insert_Input;
  on_conflict?: InputMaybe<UsersBonus_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersCostsArgs = {
  objects: Array<UsersCosts_Insert_Input>;
  on_conflict?: InputMaybe<UsersCosts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersCosts_OneArgs = {
  object: UsersCosts_Insert_Input;
  on_conflict?: InputMaybe<UsersCosts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ValidationsContractsArgs = {
  objects: Array<ValidationsContracts_Insert_Input>;
  on_conflict?: InputMaybe<ValidationsContracts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ValidationsContracts_OneArgs = {
  object: ValidationsContracts_Insert_Input;
  on_conflict?: InputMaybe<ValidationsContracts_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VarietalsArgs = {
  objects: Array<Varietals_Insert_Input>;
  on_conflict?: InputMaybe<Varietals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Varietals_OneArgs = {
  object: Varietals_Insert_Input;
  on_conflict?: InputMaybe<Varietals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_AddressesArgs = {
  _append?: InputMaybe<Addresses_Append_Input>;
  _delete_at_path?: InputMaybe<Addresses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Addresses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Addresses_Delete_Key_Input>;
  _inc?: InputMaybe<Addresses_Inc_Input>;
  _prepend?: InputMaybe<Addresses_Prepend_Input>;
  _set?: InputMaybe<Addresses_Set_Input>;
  where: Addresses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Addresses_By_PkArgs = {
  _append?: InputMaybe<Addresses_Append_Input>;
  _delete_at_path?: InputMaybe<Addresses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Addresses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Addresses_Delete_Key_Input>;
  _inc?: InputMaybe<Addresses_Inc_Input>;
  _prepend?: InputMaybe<Addresses_Prepend_Input>;
  _set?: InputMaybe<Addresses_Set_Input>;
  pk_columns: Addresses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Addresses_ManyArgs = {
  updates: Array<Addresses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AgreementTermsArgs = {
  _inc?: InputMaybe<AgreementTerms_Inc_Input>;
  _set?: InputMaybe<AgreementTerms_Set_Input>;
  where: AgreementTerms_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AgreementTerms_By_PkArgs = {
  _inc?: InputMaybe<AgreementTerms_Inc_Input>;
  _set?: InputMaybe<AgreementTerms_Set_Input>;
  pk_columns: AgreementTerms_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_AgreementTerms_ManyArgs = {
  updates: Array<AgreementTerms_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AgreementsArgs = {
  _append?: InputMaybe<Agreements_Append_Input>;
  _delete_at_path?: InputMaybe<Agreements_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Agreements_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Agreements_Delete_Key_Input>;
  _inc?: InputMaybe<Agreements_Inc_Input>;
  _prepend?: InputMaybe<Agreements_Prepend_Input>;
  _set?: InputMaybe<Agreements_Set_Input>;
  where: Agreements_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Agreements_By_PkArgs = {
  _append?: InputMaybe<Agreements_Append_Input>;
  _delete_at_path?: InputMaybe<Agreements_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Agreements_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Agreements_Delete_Key_Input>;
  _inc?: InputMaybe<Agreements_Inc_Input>;
  _prepend?: InputMaybe<Agreements_Prepend_Input>;
  _set?: InputMaybe<Agreements_Set_Input>;
  pk_columns: Agreements_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Agreements_ManyArgs = {
  updates: Array<Agreements_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AppellationsArgs = {
  _inc?: InputMaybe<Appellations_Inc_Input>;
  _set?: InputMaybe<Appellations_Set_Input>;
  where: Appellations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Appellations_By_PkArgs = {
  _inc?: InputMaybe<Appellations_Inc_Input>;
  _set?: InputMaybe<Appellations_Set_Input>;
  pk_columns: Appellations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Appellations_ManyArgs = {
  updates: Array<Appellations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthorizedDomainsArgs = {
  _inc?: InputMaybe<AuthorizedDomains_Inc_Input>;
  _set?: InputMaybe<AuthorizedDomains_Set_Input>;
  where: AuthorizedDomains_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AuthorizedDomains_By_PkArgs = {
  _inc?: InputMaybe<AuthorizedDomains_Inc_Input>;
  _set?: InputMaybe<AuthorizedDomains_Set_Input>;
  pk_columns: AuthorizedDomains_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_AuthorizedDomains_ManyArgs = {
  updates: Array<AuthorizedDomains_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_BuySpecsArgs = {
  _append?: InputMaybe<BuySpecs_Append_Input>;
  _delete_at_path?: InputMaybe<BuySpecs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<BuySpecs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<BuySpecs_Delete_Key_Input>;
  _inc?: InputMaybe<BuySpecs_Inc_Input>;
  _prepend?: InputMaybe<BuySpecs_Prepend_Input>;
  _set?: InputMaybe<BuySpecs_Set_Input>;
  where: BuySpecs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_BuySpecs_By_PkArgs = {
  _append?: InputMaybe<BuySpecs_Append_Input>;
  _delete_at_path?: InputMaybe<BuySpecs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<BuySpecs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<BuySpecs_Delete_Key_Input>;
  _inc?: InputMaybe<BuySpecs_Inc_Input>;
  _prepend?: InputMaybe<BuySpecs_Prepend_Input>;
  _set?: InputMaybe<BuySpecs_Set_Input>;
  pk_columns: BuySpecs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_BuySpecs_ManyArgs = {
  updates: Array<BuySpecs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CompaniesArgs = {
  _append?: InputMaybe<Companies_Append_Input>;
  _delete_at_path?: InputMaybe<Companies_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Companies_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Companies_Delete_Key_Input>;
  _inc?: InputMaybe<Companies_Inc_Input>;
  _prepend?: InputMaybe<Companies_Prepend_Input>;
  _set?: InputMaybe<Companies_Set_Input>;
  where: Companies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Companies_By_PkArgs = {
  _append?: InputMaybe<Companies_Append_Input>;
  _delete_at_path?: InputMaybe<Companies_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Companies_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Companies_Delete_Key_Input>;
  _inc?: InputMaybe<Companies_Inc_Input>;
  _prepend?: InputMaybe<Companies_Prepend_Input>;
  _set?: InputMaybe<Companies_Set_Input>;
  pk_columns: Companies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Companies_ManyArgs = {
  updates: Array<Companies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyAddressArgs = {
  _inc?: InputMaybe<CompanyAddress_Inc_Input>;
  _set?: InputMaybe<CompanyAddress_Set_Input>;
  where: CompanyAddress_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyAddress_By_PkArgs = {
  _inc?: InputMaybe<CompanyAddress_Inc_Input>;
  _set?: InputMaybe<CompanyAddress_Set_Input>;
  pk_columns: CompanyAddress_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyAddress_ManyArgs = {
  updates: Array<CompanyAddress_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ContactsArgs = {
  _append?: InputMaybe<Contacts_Append_Input>;
  _delete_at_path?: InputMaybe<Contacts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Contacts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Contacts_Delete_Key_Input>;
  _inc?: InputMaybe<Contacts_Inc_Input>;
  _prepend?: InputMaybe<Contacts_Prepend_Input>;
  _set?: InputMaybe<Contacts_Set_Input>;
  where: Contacts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contacts_By_PkArgs = {
  _append?: InputMaybe<Contacts_Append_Input>;
  _delete_at_path?: InputMaybe<Contacts_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Contacts_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Contacts_Delete_Key_Input>;
  _inc?: InputMaybe<Contacts_Inc_Input>;
  _prepend?: InputMaybe<Contacts_Prepend_Input>;
  _set?: InputMaybe<Contacts_Set_Input>;
  pk_columns: Contacts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contacts_ManyArgs = {
  updates: Array<Contacts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ContractsArgs = {
  _inc?: InputMaybe<Contracts_Inc_Input>;
  _set?: InputMaybe<Contracts_Set_Input>;
  where: Contracts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Contracts_By_PkArgs = {
  _inc?: InputMaybe<Contracts_Inc_Input>;
  _set?: InputMaybe<Contracts_Set_Input>;
  pk_columns: Contracts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Contracts_ManyArgs = {
  updates: Array<Contracts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CurrenciesConversionsArgs = {
  _append?: InputMaybe<CurrenciesConversions_Append_Input>;
  _delete_at_path?: InputMaybe<CurrenciesConversions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<CurrenciesConversions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<CurrenciesConversions_Delete_Key_Input>;
  _inc?: InputMaybe<CurrenciesConversions_Inc_Input>;
  _prepend?: InputMaybe<CurrenciesConversions_Prepend_Input>;
  _set?: InputMaybe<CurrenciesConversions_Set_Input>;
  where: CurrenciesConversions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_CurrenciesConversions_By_PkArgs = {
  _append?: InputMaybe<CurrenciesConversions_Append_Input>;
  _delete_at_path?: InputMaybe<CurrenciesConversions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<CurrenciesConversions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<CurrenciesConversions_Delete_Key_Input>;
  _inc?: InputMaybe<CurrenciesConversions_Inc_Input>;
  _prepend?: InputMaybe<CurrenciesConversions_Prepend_Input>;
  _set?: InputMaybe<CurrenciesConversions_Set_Input>;
  pk_columns: CurrenciesConversions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_CurrenciesConversions_ManyArgs = {
  updates: Array<CurrenciesConversions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_HistoryArgs = {
  _append?: InputMaybe<History_Append_Input>;
  _delete_at_path?: InputMaybe<History_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<History_Delete_Elem_Input>;
  _delete_key?: InputMaybe<History_Delete_Key_Input>;
  _inc?: InputMaybe<History_Inc_Input>;
  _prepend?: InputMaybe<History_Prepend_Input>;
  _set?: InputMaybe<History_Set_Input>;
  where: History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_History_By_PkArgs = {
  _append?: InputMaybe<History_Append_Input>;
  _delete_at_path?: InputMaybe<History_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<History_Delete_Elem_Input>;
  _delete_key?: InputMaybe<History_Delete_Key_Input>;
  _inc?: InputMaybe<History_Inc_Input>;
  _prepend?: InputMaybe<History_Prepend_Input>;
  _set?: InputMaybe<History_Set_Input>;
  pk_columns: History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_History_ManyArgs = {
  updates: Array<History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvoicesArgs = {
  _append?: InputMaybe<Invoices_Append_Input>;
  _delete_at_path?: InputMaybe<Invoices_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Invoices_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Invoices_Delete_Key_Input>;
  _inc?: InputMaybe<Invoices_Inc_Input>;
  _prepend?: InputMaybe<Invoices_Prepend_Input>;
  _set?: InputMaybe<Invoices_Set_Input>;
  where: Invoices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invoices_By_PkArgs = {
  _append?: InputMaybe<Invoices_Append_Input>;
  _delete_at_path?: InputMaybe<Invoices_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Invoices_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Invoices_Delete_Key_Input>;
  _inc?: InputMaybe<Invoices_Inc_Input>;
  _prepend?: InputMaybe<Invoices_Prepend_Input>;
  _set?: InputMaybe<Invoices_Set_Input>;
  pk_columns: Invoices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invoices_ManyArgs = {
  updates: Array<Invoices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ItemsArgs = {
  _append?: InputMaybe<Items_Append_Input>;
  _delete_at_path?: InputMaybe<Items_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Items_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Items_Delete_Key_Input>;
  _inc?: InputMaybe<Items_Inc_Input>;
  _prepend?: InputMaybe<Items_Prepend_Input>;
  _set?: InputMaybe<Items_Set_Input>;
  where: Items_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Items_By_PkArgs = {
  _append?: InputMaybe<Items_Append_Input>;
  _delete_at_path?: InputMaybe<Items_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Items_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Items_Delete_Key_Input>;
  _inc?: InputMaybe<Items_Inc_Input>;
  _prepend?: InputMaybe<Items_Prepend_Input>;
  _set?: InputMaybe<Items_Set_Input>;
  pk_columns: Items_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Items_ManyArgs = {
  updates: Array<Items_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LogsArgs = {
  _append?: InputMaybe<Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Logs_Delete_Key_Input>;
  _inc?: InputMaybe<Logs_Inc_Input>;
  _prepend?: InputMaybe<Logs_Prepend_Input>;
  _set?: InputMaybe<Logs_Set_Input>;
  where: Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Logs_By_PkArgs = {
  _append?: InputMaybe<Logs_Append_Input>;
  _delete_at_path?: InputMaybe<Logs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Logs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Logs_Delete_Key_Input>;
  _inc?: InputMaybe<Logs_Inc_Input>;
  _prepend?: InputMaybe<Logs_Prepend_Input>;
  _set?: InputMaybe<Logs_Set_Input>;
  pk_columns: Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Logs_ManyArgs = {
  updates: Array<Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MatchingItemsBuySpecsArgs = {
  _inc?: InputMaybe<MatchingItemsBuySpecs_Inc_Input>;
  _set?: InputMaybe<MatchingItemsBuySpecs_Set_Input>;
  where: MatchingItemsBuySpecs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_MatchingItemsBuySpecs_By_PkArgs = {
  _inc?: InputMaybe<MatchingItemsBuySpecs_Inc_Input>;
  _set?: InputMaybe<MatchingItemsBuySpecs_Set_Input>;
  pk_columns: MatchingItemsBuySpecs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_MatchingItemsBuySpecs_ManyArgs = {
  updates: Array<MatchingItemsBuySpecs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationsArgs = {
  _inc?: InputMaybe<Notifications_Inc_Input>;
  _set?: InputMaybe<Notifications_Set_Input>;
  where: Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_By_PkArgs = {
  _inc?: InputMaybe<Notifications_Inc_Input>;
  _set?: InputMaybe<Notifications_Set_Input>;
  pk_columns: Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notifications_ManyArgs = {
  updates: Array<Notifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OfficesArgs = {
  _inc?: InputMaybe<Offices_Inc_Input>;
  _set?: InputMaybe<Offices_Set_Input>;
  where: Offices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Offices_By_PkArgs = {
  _inc?: InputMaybe<Offices_Inc_Input>;
  _set?: InputMaybe<Offices_Set_Input>;
  pk_columns: Offices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Offices_ManyArgs = {
  updates: Array<Offices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReleasesArgs = {
  _inc?: InputMaybe<Releases_Inc_Input>;
  _set?: InputMaybe<Releases_Set_Input>;
  where: Releases_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Releases_By_PkArgs = {
  _inc?: InputMaybe<Releases_Inc_Input>;
  _set?: InputMaybe<Releases_Set_Input>;
  pk_columns: Releases_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Releases_ManyArgs = {
  updates: Array<Releases_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RemindersArgs = {
  _inc?: InputMaybe<Reminders_Inc_Input>;
  _set?: InputMaybe<Reminders_Set_Input>;
  where: Reminders_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reminders_By_PkArgs = {
  _inc?: InputMaybe<Reminders_Inc_Input>;
  _set?: InputMaybe<Reminders_Set_Input>;
  pk_columns: Reminders_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reminders_ManyArgs = {
  updates: Array<Reminders_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SampleLabelsArgs = {
  _append?: InputMaybe<SampleLabels_Append_Input>;
  _delete_at_path?: InputMaybe<SampleLabels_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<SampleLabels_Delete_Elem_Input>;
  _delete_key?: InputMaybe<SampleLabels_Delete_Key_Input>;
  _inc?: InputMaybe<SampleLabels_Inc_Input>;
  _prepend?: InputMaybe<SampleLabels_Prepend_Input>;
  _set?: InputMaybe<SampleLabels_Set_Input>;
  where: SampleLabels_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SampleLabels_By_PkArgs = {
  _append?: InputMaybe<SampleLabels_Append_Input>;
  _delete_at_path?: InputMaybe<SampleLabels_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<SampleLabels_Delete_Elem_Input>;
  _delete_key?: InputMaybe<SampleLabels_Delete_Key_Input>;
  _inc?: InputMaybe<SampleLabels_Inc_Input>;
  _prepend?: InputMaybe<SampleLabels_Prepend_Input>;
  _set?: InputMaybe<SampleLabels_Set_Input>;
  pk_columns: SampleLabels_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SampleLabels_ManyArgs = {
  updates: Array<SampleLabels_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SampleShipmentRequestsArgs = {
  _append?: InputMaybe<SampleShipmentRequests_Append_Input>;
  _delete_at_path?: InputMaybe<SampleShipmentRequests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<SampleShipmentRequests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<SampleShipmentRequests_Delete_Key_Input>;
  _inc?: InputMaybe<SampleShipmentRequests_Inc_Input>;
  _prepend?: InputMaybe<SampleShipmentRequests_Prepend_Input>;
  _set?: InputMaybe<SampleShipmentRequests_Set_Input>;
  where: SampleShipmentRequests_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SampleShipmentRequests_By_PkArgs = {
  _append?: InputMaybe<SampleShipmentRequests_Append_Input>;
  _delete_at_path?: InputMaybe<SampleShipmentRequests_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<SampleShipmentRequests_Delete_Elem_Input>;
  _delete_key?: InputMaybe<SampleShipmentRequests_Delete_Key_Input>;
  _inc?: InputMaybe<SampleShipmentRequests_Inc_Input>;
  _prepend?: InputMaybe<SampleShipmentRequests_Prepend_Input>;
  _set?: InputMaybe<SampleShipmentRequests_Set_Input>;
  pk_columns: SampleShipmentRequests_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SampleShipmentRequests_ManyArgs = {
  updates: Array<SampleShipmentRequests_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SampleShipmentsArgs = {
  _inc?: InputMaybe<SampleShipments_Inc_Input>;
  _set?: InputMaybe<SampleShipments_Set_Input>;
  where: SampleShipments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_SampleShipments_By_PkArgs = {
  _inc?: InputMaybe<SampleShipments_Inc_Input>;
  _set?: InputMaybe<SampleShipments_Set_Input>;
  pk_columns: SampleShipments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_SampleShipments_ManyArgs = {
  updates: Array<SampleShipments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SamplesArgs = {
  _append?: InputMaybe<Samples_Append_Input>;
  _delete_at_path?: InputMaybe<Samples_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Samples_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Samples_Delete_Key_Input>;
  _inc?: InputMaybe<Samples_Inc_Input>;
  _prepend?: InputMaybe<Samples_Prepend_Input>;
  _set?: InputMaybe<Samples_Set_Input>;
  where: Samples_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Samples_By_PkArgs = {
  _append?: InputMaybe<Samples_Append_Input>;
  _delete_at_path?: InputMaybe<Samples_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Samples_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Samples_Delete_Key_Input>;
  _inc?: InputMaybe<Samples_Inc_Input>;
  _prepend?: InputMaybe<Samples_Prepend_Input>;
  _set?: InputMaybe<Samples_Set_Input>;
  pk_columns: Samples_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Samples_ManyArgs = {
  updates: Array<Samples_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ShipmentFulfillmentsArgs = {
  _append?: InputMaybe<ShipmentFulfillments_Append_Input>;
  _delete_at_path?: InputMaybe<ShipmentFulfillments_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ShipmentFulfillments_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ShipmentFulfillments_Delete_Key_Input>;
  _inc?: InputMaybe<ShipmentFulfillments_Inc_Input>;
  _prepend?: InputMaybe<ShipmentFulfillments_Prepend_Input>;
  _set?: InputMaybe<ShipmentFulfillments_Set_Input>;
  where: ShipmentFulfillments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ShipmentFulfillments_By_PkArgs = {
  _append?: InputMaybe<ShipmentFulfillments_Append_Input>;
  _delete_at_path?: InputMaybe<ShipmentFulfillments_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<ShipmentFulfillments_Delete_Elem_Input>;
  _delete_key?: InputMaybe<ShipmentFulfillments_Delete_Key_Input>;
  _inc?: InputMaybe<ShipmentFulfillments_Inc_Input>;
  _prepend?: InputMaybe<ShipmentFulfillments_Prepend_Input>;
  _set?: InputMaybe<ShipmentFulfillments_Set_Input>;
  pk_columns: ShipmentFulfillments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ShipmentFulfillments_ManyArgs = {
  updates: Array<ShipmentFulfillments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TrackingsArgs = {
  _append?: InputMaybe<Trackings_Append_Input>;
  _delete_at_path?: InputMaybe<Trackings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trackings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trackings_Delete_Key_Input>;
  _inc?: InputMaybe<Trackings_Inc_Input>;
  _prepend?: InputMaybe<Trackings_Prepend_Input>;
  _set?: InputMaybe<Trackings_Set_Input>;
  where: Trackings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trackings_By_PkArgs = {
  _append?: InputMaybe<Trackings_Append_Input>;
  _delete_at_path?: InputMaybe<Trackings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Trackings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Trackings_Delete_Key_Input>;
  _inc?: InputMaybe<Trackings_Inc_Input>;
  _prepend?: InputMaybe<Trackings_Prepend_Input>;
  _set?: InputMaybe<Trackings_Set_Input>;
  pk_columns: Trackings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trackings_ManyArgs = {
  updates: Array<Trackings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _inc?: InputMaybe<Users_Inc_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UsersBonusArgs = {
  _inc?: InputMaybe<UsersBonus_Inc_Input>;
  _set?: InputMaybe<UsersBonus_Set_Input>;
  where: UsersBonus_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UsersBonus_By_PkArgs = {
  _inc?: InputMaybe<UsersBonus_Inc_Input>;
  _set?: InputMaybe<UsersBonus_Set_Input>;
  pk_columns: UsersBonus_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UsersBonus_ManyArgs = {
  updates: Array<UsersBonus_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersCostsArgs = {
  _inc?: InputMaybe<UsersCosts_Inc_Input>;
  _set?: InputMaybe<UsersCosts_Set_Input>;
  where: UsersCosts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_UsersCosts_By_PkArgs = {
  _inc?: InputMaybe<UsersCosts_Inc_Input>;
  _set?: InputMaybe<UsersCosts_Set_Input>;
  pk_columns: UsersCosts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_UsersCosts_ManyArgs = {
  updates: Array<UsersCosts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _inc?: InputMaybe<Users_Inc_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ValidationsContractsArgs = {
  _inc?: InputMaybe<ValidationsContracts_Inc_Input>;
  _set?: InputMaybe<ValidationsContracts_Set_Input>;
  where: ValidationsContracts_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_ValidationsContracts_By_PkArgs = {
  _inc?: InputMaybe<ValidationsContracts_Inc_Input>;
  _set?: InputMaybe<ValidationsContracts_Set_Input>;
  pk_columns: ValidationsContracts_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_ValidationsContracts_ManyArgs = {
  updates: Array<ValidationsContracts_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VarietalsArgs = {
  _inc?: InputMaybe<Varietals_Inc_Input>;
  _set?: InputMaybe<Varietals_Set_Input>;
  where: Varietals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Varietals_By_PkArgs = {
  _inc?: InputMaybe<Varietals_Inc_Input>;
  _set?: InputMaybe<Varietals_Set_Input>;
  pk_columns: Varietals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Varietals_ManyArgs = {
  updates: Array<Varietals_Updates>;
};

/** columns and relationships of "notifications" */
export type Notifications = {
  __typename?: 'notifications';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  assignedTo: Scalars['String'];
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['String'];
  /** An object relationship */
  history: History;
  historyId: Scalars['Int'];
  id: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  viewedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "notifications" */
export type Notifications_Aggregate = {
  __typename?: 'notifications_aggregate';
  aggregate?: Maybe<Notifications_Aggregate_Fields>;
  nodes: Array<Notifications>;
};

/** aggregate fields of "notifications" */
export type Notifications_Aggregate_Fields = {
  __typename?: 'notifications_aggregate_fields';
  avg?: Maybe<Notifications_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Notifications_Max_Fields>;
  min?: Maybe<Notifications_Min_Fields>;
  stddev?: Maybe<Notifications_Stddev_Fields>;
  stddev_pop?: Maybe<Notifications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notifications_Stddev_Samp_Fields>;
  sum?: Maybe<Notifications_Sum_Fields>;
  var_pop?: Maybe<Notifications_Var_Pop_Fields>;
  var_samp?: Maybe<Notifications_Var_Samp_Fields>;
  variance?: Maybe<Notifications_Variance_Fields>;
};


/** aggregate fields of "notifications" */
export type Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Notifications_Avg_Fields = {
  __typename?: 'notifications_avg_fields';
  historyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export type Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Notifications_Bool_Exp>>;
  _not?: InputMaybe<Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Notifications_Bool_Exp>>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  assignedTo?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  history?: InputMaybe<History_Bool_Exp>;
  historyId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  viewedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "notifications" */
export enum Notifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationsPkey = 'notifications_pkey'
}

/** input type for incrementing numeric columns in table "notifications" */
export type Notifications_Inc_Input = {
  historyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "notifications" */
export type Notifications_Insert_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  assignedTo?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['String']>;
  history?: InputMaybe<History_Obj_Rel_Insert_Input>;
  historyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  viewedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Notifications_Max_Fields = {
  __typename?: 'notifications_max_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  assignedTo?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['String']>;
  historyId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  viewedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Notifications_Min_Fields = {
  __typename?: 'notifications_min_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  assignedTo?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['String']>;
  historyId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  viewedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "notifications" */
export type Notifications_Mutation_Response = {
  __typename?: 'notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notifications>;
};

/** on_conflict condition type for table "notifications" */
export type Notifications_On_Conflict = {
  constraint: Notifications_Constraint;
  update_columns?: Array<Notifications_Update_Column>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "notifications". */
export type Notifications_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  assignedTo?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  history?: InputMaybe<History_Order_By>;
  historyId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  viewedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notifications */
export type Notifications_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "notifications" */
export enum Notifications_Select_Column {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  AssignedTo = 'assignedTo',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  HistoryId = 'historyId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ViewedAt = 'viewedAt'
}

/** input type for updating data in table "notifications" */
export type Notifications_Set_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  assignedTo?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Notifications_Stddev_Fields = {
  __typename?: 'notifications_stddev_fields';
  historyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Notifications_Stddev_Pop_Fields = {
  __typename?: 'notifications_stddev_pop_fields';
  historyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Notifications_Stddev_Samp_Fields = {
  __typename?: 'notifications_stddev_samp_fields';
  historyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "notifications" */
export type Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notifications_Stream_Cursor_Value_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  assignedTo?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['String']>;
  historyId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Notifications_Sum_Fields = {
  __typename?: 'notifications_sum_fields';
  historyId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "notifications" */
export enum Notifications_Update_Column {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  AssignedTo = 'assignedTo',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  HistoryId = 'historyId',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ViewedAt = 'viewedAt'
}

export type Notifications_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notifications_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notifications_Set_Input>;
  where: Notifications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Notifications_Var_Pop_Fields = {
  __typename?: 'notifications_var_pop_fields';
  historyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Notifications_Var_Samp_Fields = {
  __typename?: 'notifications_var_samp_fields';
  historyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Notifications_Variance_Fields = {
  __typename?: 'notifications_variance_fields';
  historyId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "offices" */
export type Offices = {
  __typename?: 'offices';
  address?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  locale: Scalars['String'];
  name: Scalars['String'];
};

/** aggregated selection of "offices" */
export type Offices_Aggregate = {
  __typename?: 'offices_aggregate';
  aggregate?: Maybe<Offices_Aggregate_Fields>;
  nodes: Array<Offices>;
};

/** aggregate fields of "offices" */
export type Offices_Aggregate_Fields = {
  __typename?: 'offices_aggregate_fields';
  avg?: Maybe<Offices_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Offices_Max_Fields>;
  min?: Maybe<Offices_Min_Fields>;
  stddev?: Maybe<Offices_Stddev_Fields>;
  stddev_pop?: Maybe<Offices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Offices_Stddev_Samp_Fields>;
  sum?: Maybe<Offices_Sum_Fields>;
  var_pop?: Maybe<Offices_Var_Pop_Fields>;
  var_samp?: Maybe<Offices_Var_Samp_Fields>;
  variance?: Maybe<Offices_Variance_Fields>;
};


/** aggregate fields of "offices" */
export type Offices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Offices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Offices_Avg_Fields = {
  __typename?: 'offices_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "offices". All fields are combined with a logical 'AND'. */
export type Offices_Bool_Exp = {
  _and?: InputMaybe<Array<Offices_Bool_Exp>>;
  _not?: InputMaybe<Offices_Bool_Exp>;
  _or?: InputMaybe<Array<Offices_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  locale?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "offices" */
export enum Offices_Constraint {
  /** unique or primary key constraint on columns "name" */
  OfficesNameKey = 'offices_name_key',
  /** unique or primary key constraint on columns "id" */
  OfficesPkey = 'offices_pkey'
}

/** input type for incrementing numeric columns in table "offices" */
export type Offices_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "offices" */
export type Offices_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Offices_Max_Fields = {
  __typename?: 'offices_max_fields';
  address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Offices_Min_Fields = {
  __typename?: 'offices_min_fields';
  address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "offices" */
export type Offices_Mutation_Response = {
  __typename?: 'offices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Offices>;
};

/** input type for inserting object relation for remote table "offices" */
export type Offices_Obj_Rel_Insert_Input = {
  data: Offices_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Offices_On_Conflict>;
};

/** on_conflict condition type for table "offices" */
export type Offices_On_Conflict = {
  constraint: Offices_Constraint;
  update_columns?: Array<Offices_Update_Column>;
  where?: InputMaybe<Offices_Bool_Exp>;
};

/** Ordering options when selecting data from "offices". */
export type Offices_Order_By = {
  address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locale?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: offices */
export type Offices_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "offices" */
export enum Offices_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Id = 'id',
  /** column name */
  Locale = 'locale',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "offices" */
export type Offices_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Offices_Stddev_Fields = {
  __typename?: 'offices_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Offices_Stddev_Pop_Fields = {
  __typename?: 'offices_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Offices_Stddev_Samp_Fields = {
  __typename?: 'offices_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "offices" */
export type Offices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Offices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Offices_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Offices_Sum_Fields = {
  __typename?: 'offices_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "offices" */
export enum Offices_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Id = 'id',
  /** column name */
  Locale = 'locale',
  /** column name */
  Name = 'name'
}

export type Offices_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Offices_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Offices_Set_Input>;
  where: Offices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Offices_Var_Pop_Fields = {
  __typename?: 'offices_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Offices_Var_Samp_Fields = {
  __typename?: 'offices_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Offices_Variance_Fields = {
  __typename?: 'offices_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "addresses" */
  addresses: Array<Addresses>;
  /** fetch aggregated fields from the table: "addresses" */
  addresses_aggregate: Addresses_Aggregate;
  /** fetch data from the table: "addresses" using primary key columns */
  addresses_by_pk?: Maybe<Addresses>;
  /** fetch data from the table: "addresses_without_company" */
  addresses_without_company: Array<Addresses_Without_Company>;
  /** fetch aggregated fields from the table: "addresses_without_company" */
  addresses_without_company_aggregate: Addresses_Without_Company_Aggregate;
  /** fetch data from the table: "agreementTerms" */
  agreementTerms: Array<AgreementTerms>;
  /** fetch aggregated fields from the table: "agreementTerms" */
  agreementTerms_aggregate: AgreementTerms_Aggregate;
  /** fetch data from the table: "agreementTerms" using primary key columns */
  agreementTerms_by_pk?: Maybe<AgreementTerms>;
  /** fetch data from the table: "agreements" */
  agreements: Array<Agreements>;
  /** fetch aggregated fields from the table: "agreements" */
  agreements_aggregate: Agreements_Aggregate;
  /** fetch data from the table: "agreements" using primary key columns */
  agreements_by_pk?: Maybe<Agreements>;
  /** fetch data from the table: "appellations" */
  appellations: Array<Appellations>;
  /** fetch aggregated fields from the table: "appellations" */
  appellations_aggregate: Appellations_Aggregate;
  /** fetch data from the table: "appellations" using primary key columns */
  appellations_by_pk?: Maybe<Appellations>;
  /** fetch data from the table: "authorizedDomains" */
  authorizedDomains: Array<AuthorizedDomains>;
  /** fetch aggregated fields from the table: "authorizedDomains" */
  authorizedDomains_aggregate: AuthorizedDomains_Aggregate;
  /** fetch data from the table: "authorizedDomains" using primary key columns */
  authorizedDomains_by_pk?: Maybe<AuthorizedDomains>;
  /** fetch data from the table: "buySpecs" */
  buySpecs: Array<BuySpecs>;
  /** fetch aggregated fields from the table: "buySpecs" */
  buySpecs_aggregate: BuySpecs_Aggregate;
  /** fetch data from the table: "buySpecs" using primary key columns */
  buySpecs_by_pk?: Maybe<BuySpecs>;
  /** fetch data from the table: "companies" */
  companies: Array<Companies>;
  /** fetch aggregated fields from the table: "companies" */
  companies_aggregate: Companies_Aggregate;
  /** fetch data from the table: "companies" using primary key columns */
  companies_by_pk?: Maybe<Companies>;
  /** fetch data from the table: "companyAddress" */
  companyAddress: Array<CompanyAddress>;
  /** fetch aggregated fields from the table: "companyAddress" */
  companyAddress_aggregate: CompanyAddress_Aggregate;
  /** fetch data from the table: "companyAddress" using primary key columns */
  companyAddress_by_pk?: Maybe<CompanyAddress>;
  /** fetch data from the table: "contacts" */
  contacts: Array<Contacts>;
  /** fetch aggregated fields from the table: "contacts" */
  contacts_aggregate: Contacts_Aggregate;
  /** fetch data from the table: "contacts" using primary key columns */
  contacts_by_pk?: Maybe<Contacts>;
  /** fetch data from the table: "contacts_without_company" */
  contacts_without_company: Array<Contacts_Without_Company>;
  /** fetch aggregated fields from the table: "contacts_without_company" */
  contacts_without_company_aggregate: Contacts_Without_Company_Aggregate;
  /** fetch data from the table: "contracts" */
  contracts: Array<Contracts>;
  /** fetch aggregated fields from the table: "contracts" */
  contracts_aggregate: Contracts_Aggregate;
  /** fetch data from the table: "contracts" using primary key columns */
  contracts_by_pk?: Maybe<Contracts>;
  /** fetch data from the table: "currenciesConversions" */
  currenciesConversions: Array<CurrenciesConversions>;
  /** fetch aggregated fields from the table: "currenciesConversions" */
  currenciesConversions_aggregate: CurrenciesConversions_Aggregate;
  /** fetch data from the table: "currenciesConversions" using primary key columns */
  currenciesConversions_by_pk?: Maybe<CurrenciesConversions>;
  /** fetch data from the table: "history" */
  history: Array<History>;
  /** fetch aggregated fields from the table: "history" */
  history_aggregate: History_Aggregate;
  /** fetch data from the table: "history" using primary key columns */
  history_by_pk?: Maybe<History>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoices_by_pk?: Maybe<Invoices>;
  /** fetch data from the table: "items" */
  items: Array<Items>;
  /** fetch aggregated fields from the table: "items" */
  items_aggregate: Items_Aggregate;
  /** fetch data from the table: "items" using primary key columns */
  items_by_pk?: Maybe<Items>;
  /** fetch data from the table: "logs" */
  logs: Array<Logs>;
  /** fetch aggregated fields from the table: "logs" */
  logs_aggregate: Logs_Aggregate;
  /** fetch data from the table: "logs" using primary key columns */
  logs_by_pk?: Maybe<Logs>;
  /** An array relationship */
  matchingItemsBuySpecs: Array<MatchingItemsBuySpecs>;
  /** An aggregate relationship */
  matchingItemsBuySpecs_aggregate: MatchingItemsBuySpecs_Aggregate;
  /** fetch data from the table: "matchingItemsBuySpecs" using primary key columns */
  matchingItemsBuySpecs_by_pk?: Maybe<MatchingItemsBuySpecs>;
  /** fetch data from the table: "notifications" */
  notifications: Array<Notifications>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table: "offices" */
  offices: Array<Offices>;
  /** fetch aggregated fields from the table: "offices" */
  offices_aggregate: Offices_Aggregate;
  /** fetch data from the table: "offices" using primary key columns */
  offices_by_pk?: Maybe<Offices>;
  /** fetch data from the table: "releases" */
  releases: Array<Releases>;
  /** fetch aggregated fields from the table: "releases" */
  releases_aggregate: Releases_Aggregate;
  /** fetch data from the table: "releases" using primary key columns */
  releases_by_pk?: Maybe<Releases>;
  /** fetch data from the table: "reminders" */
  reminders: Array<Reminders>;
  /** fetch aggregated fields from the table: "reminders" */
  reminders_aggregate: Reminders_Aggregate;
  /** fetch data from the table: "reminders" using primary key columns */
  reminders_by_pk?: Maybe<Reminders>;
  /** fetch data from the table: "sampleLabels" */
  sampleLabels: Array<SampleLabels>;
  /** fetch aggregated fields from the table: "sampleLabels" */
  sampleLabels_aggregate: SampleLabels_Aggregate;
  /** fetch data from the table: "sampleLabels" using primary key columns */
  sampleLabels_by_pk?: Maybe<SampleLabels>;
  /** An array relationship */
  sampleShipmentRequests: Array<SampleShipmentRequests>;
  /** An aggregate relationship */
  sampleShipmentRequests_aggregate: SampleShipmentRequests_Aggregate;
  /** fetch data from the table: "sampleShipmentRequests" using primary key columns */
  sampleShipmentRequests_by_pk?: Maybe<SampleShipmentRequests>;
  /** fetch data from the table: "sampleShipments" */
  sampleShipments: Array<SampleShipments>;
  /** fetch aggregated fields from the table: "sampleShipments" */
  sampleShipments_aggregate: SampleShipments_Aggregate;
  /** fetch data from the table: "sampleShipments" using primary key columns */
  sampleShipments_by_pk?: Maybe<SampleShipments>;
  /** An array relationship */
  samples: Array<Samples>;
  /** An aggregate relationship */
  samples_aggregate: Samples_Aggregate;
  /** fetch data from the table: "samples" using primary key columns */
  samples_by_pk?: Maybe<Samples>;
  /** An array relationship */
  shipmentFulfillments: Array<ShipmentFulfillments>;
  /** An aggregate relationship */
  shipmentFulfillments_aggregate: ShipmentFulfillments_Aggregate;
  /** fetch data from the table: "shipmentFulfillments" using primary key columns */
  shipmentFulfillments_by_pk?: Maybe<ShipmentFulfillments>;
  /** fetch data from the table: "trackings" */
  trackings: Array<Trackings>;
  /** fetch aggregated fields from the table: "trackings" */
  trackings_aggregate: Trackings_Aggregate;
  /** fetch data from the table: "trackings" using primary key columns */
  trackings_by_pk?: Maybe<Trackings>;
  /** An array relationship */
  users: Array<Users>;
  /** An array relationship */
  usersBonus: Array<UsersBonus>;
  /** An aggregate relationship */
  usersBonus_aggregate: UsersBonus_Aggregate;
  /** fetch data from the table: "usersBonus" using primary key columns */
  usersBonus_by_pk?: Maybe<UsersBonus>;
  /** An array relationship */
  usersCosts: Array<UsersCosts>;
  /** An aggregate relationship */
  usersCosts_aggregate: UsersCosts_Aggregate;
  /** fetch data from the table: "usersCosts" using primary key columns */
  usersCosts_by_pk?: Maybe<UsersCosts>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** An array relationship */
  validationsContracts: Array<ValidationsContracts>;
  /** An aggregate relationship */
  validationsContracts_aggregate: ValidationsContracts_Aggregate;
  /** fetch data from the table: "validationsContracts" using primary key columns */
  validationsContracts_by_pk?: Maybe<ValidationsContracts>;
  /** fetch data from the table: "varietals" */
  varietals: Array<Varietals>;
  /** fetch aggregated fields from the table: "varietals" */
  varietals_aggregate: Varietals_Aggregate;
  /** fetch data from the table: "varietals" using primary key columns */
  varietals_by_pk?: Maybe<Varietals>;
};


export type Query_RootAddressesArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Query_RootAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Query_RootAddresses_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAddresses_Without_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Without_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Without_Company_Order_By>>;
  where?: InputMaybe<Addresses_Without_Company_Bool_Exp>;
};


export type Query_RootAddresses_Without_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Without_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Without_Company_Order_By>>;
  where?: InputMaybe<Addresses_Without_Company_Bool_Exp>;
};


export type Query_RootAgreementTermsArgs = {
  distinct_on?: InputMaybe<Array<AgreementTerms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgreementTerms_Order_By>>;
  where?: InputMaybe<AgreementTerms_Bool_Exp>;
};


export type Query_RootAgreementTerms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AgreementTerms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgreementTerms_Order_By>>;
  where?: InputMaybe<AgreementTerms_Bool_Exp>;
};


export type Query_RootAgreementTerms_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAgreementsArgs = {
  distinct_on?: InputMaybe<Array<Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreements_Order_By>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


export type Query_RootAgreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreements_Order_By>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


export type Query_RootAgreements_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAppellationsArgs = {
  distinct_on?: InputMaybe<Array<Appellations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appellations_Order_By>>;
  where?: InputMaybe<Appellations_Bool_Exp>;
};


export type Query_RootAppellations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appellations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appellations_Order_By>>;
  where?: InputMaybe<Appellations_Bool_Exp>;
};


export type Query_RootAppellations_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootAuthorizedDomainsArgs = {
  distinct_on?: InputMaybe<Array<AuthorizedDomains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthorizedDomains_Order_By>>;
  where?: InputMaybe<AuthorizedDomains_Bool_Exp>;
};


export type Query_RootAuthorizedDomains_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthorizedDomains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthorizedDomains_Order_By>>;
  where?: InputMaybe<AuthorizedDomains_Bool_Exp>;
};


export type Query_RootAuthorizedDomains_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootBuySpecsArgs = {
  distinct_on?: InputMaybe<Array<BuySpecs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BuySpecs_Order_By>>;
  where?: InputMaybe<BuySpecs_Bool_Exp>;
};


export type Query_RootBuySpecs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuySpecs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BuySpecs_Order_By>>;
  where?: InputMaybe<BuySpecs_Bool_Exp>;
};


export type Query_RootBuySpecs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Companies_Order_By>>;
  where?: InputMaybe<Companies_Bool_Exp>;
};


export type Query_RootCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Companies_Order_By>>;
  where?: InputMaybe<Companies_Bool_Exp>;
};


export type Query_RootCompanies_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCompanyAddressArgs = {
  distinct_on?: InputMaybe<Array<CompanyAddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyAddress_Order_By>>;
  where?: InputMaybe<CompanyAddress_Bool_Exp>;
};


export type Query_RootCompanyAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyAddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyAddress_Order_By>>;
  where?: InputMaybe<CompanyAddress_Bool_Exp>;
};


export type Query_RootCompanyAddress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootContactsArgs = {
  distinct_on?: InputMaybe<Array<Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contacts_Order_By>>;
  where?: InputMaybe<Contacts_Bool_Exp>;
};


export type Query_RootContacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contacts_Order_By>>;
  where?: InputMaybe<Contacts_Bool_Exp>;
};


export type Query_RootContacts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootContacts_Without_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Contacts_Without_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contacts_Without_Company_Order_By>>;
  where?: InputMaybe<Contacts_Without_Company_Bool_Exp>;
};


export type Query_RootContacts_Without_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contacts_Without_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contacts_Without_Company_Order_By>>;
  where?: InputMaybe<Contacts_Without_Company_Bool_Exp>;
};


export type Query_RootContractsArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contracts_Order_By>>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};


export type Query_RootContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contracts_Order_By>>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};


export type Query_RootContracts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCurrenciesConversionsArgs = {
  distinct_on?: InputMaybe<Array<CurrenciesConversions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CurrenciesConversions_Order_By>>;
  where?: InputMaybe<CurrenciesConversions_Bool_Exp>;
};


export type Query_RootCurrenciesConversions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CurrenciesConversions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CurrenciesConversions_Order_By>>;
  where?: InputMaybe<CurrenciesConversions_Bool_Exp>;
};


export type Query_RootCurrenciesConversions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootHistoryArgs = {
  distinct_on?: InputMaybe<Array<History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<History_Order_By>>;
  where?: InputMaybe<History_Bool_Exp>;
};


export type Query_RootHistory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<History_Order_By>>;
  where?: InputMaybe<History_Bool_Exp>;
};


export type Query_RootHistory_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Query_RootInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Query_RootInvoices_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootItemsArgs = {
  distinct_on?: InputMaybe<Array<Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Items_Order_By>>;
  where?: InputMaybe<Items_Bool_Exp>;
};


export type Query_RootItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Items_Order_By>>;
  where?: InputMaybe<Items_Bool_Exp>;
};


export type Query_RootItems_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootLogsArgs = {
  distinct_on?: InputMaybe<Array<Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Logs_Order_By>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


export type Query_RootLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Logs_Order_By>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


export type Query_RootLogs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootMatchingItemsBuySpecsArgs = {
  distinct_on?: InputMaybe<Array<MatchingItemsBuySpecs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MatchingItemsBuySpecs_Order_By>>;
  where?: InputMaybe<MatchingItemsBuySpecs_Bool_Exp>;
};


export type Query_RootMatchingItemsBuySpecs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MatchingItemsBuySpecs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MatchingItemsBuySpecs_Order_By>>;
  where?: InputMaybe<MatchingItemsBuySpecs_Bool_Exp>;
};


export type Query_RootMatchingItemsBuySpecs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Query_RootNotifications_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootOfficesArgs = {
  distinct_on?: InputMaybe<Array<Offices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offices_Order_By>>;
  where?: InputMaybe<Offices_Bool_Exp>;
};


export type Query_RootOffices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offices_Order_By>>;
  where?: InputMaybe<Offices_Bool_Exp>;
};


export type Query_RootOffices_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootReleasesArgs = {
  distinct_on?: InputMaybe<Array<Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Releases_Order_By>>;
  where?: InputMaybe<Releases_Bool_Exp>;
};


export type Query_RootReleases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Releases_Order_By>>;
  where?: InputMaybe<Releases_Bool_Exp>;
};


export type Query_RootReleases_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootRemindersArgs = {
  distinct_on?: InputMaybe<Array<Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reminders_Order_By>>;
  where?: InputMaybe<Reminders_Bool_Exp>;
};


export type Query_RootReminders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reminders_Order_By>>;
  where?: InputMaybe<Reminders_Bool_Exp>;
};


export type Query_RootReminders_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSampleLabelsArgs = {
  distinct_on?: InputMaybe<Array<SampleLabels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleLabels_Order_By>>;
  where?: InputMaybe<SampleLabels_Bool_Exp>;
};


export type Query_RootSampleLabels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SampleLabels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleLabels_Order_By>>;
  where?: InputMaybe<SampleLabels_Bool_Exp>;
};


export type Query_RootSampleLabels_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSampleShipmentRequestsArgs = {
  distinct_on?: InputMaybe<Array<SampleShipmentRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleShipmentRequests_Order_By>>;
  where?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
};


export type Query_RootSampleShipmentRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SampleShipmentRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleShipmentRequests_Order_By>>;
  where?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
};


export type Query_RootSampleShipmentRequests_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSampleShipmentsArgs = {
  distinct_on?: InputMaybe<Array<SampleShipments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleShipments_Order_By>>;
  where?: InputMaybe<SampleShipments_Bool_Exp>;
};


export type Query_RootSampleShipments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SampleShipments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleShipments_Order_By>>;
  where?: InputMaybe<SampleShipments_Bool_Exp>;
};


export type Query_RootSampleShipments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootSamplesArgs = {
  distinct_on?: InputMaybe<Array<Samples_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Samples_Order_By>>;
  where?: InputMaybe<Samples_Bool_Exp>;
};


export type Query_RootSamples_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Samples_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Samples_Order_By>>;
  where?: InputMaybe<Samples_Bool_Exp>;
};


export type Query_RootSamples_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootShipmentFulfillmentsArgs = {
  distinct_on?: InputMaybe<Array<ShipmentFulfillments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShipmentFulfillments_Order_By>>;
  where?: InputMaybe<ShipmentFulfillments_Bool_Exp>;
};


export type Query_RootShipmentFulfillments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ShipmentFulfillments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShipmentFulfillments_Order_By>>;
  where?: InputMaybe<ShipmentFulfillments_Bool_Exp>;
};


export type Query_RootShipmentFulfillments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootTrackingsArgs = {
  distinct_on?: InputMaybe<Array<Trackings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trackings_Order_By>>;
  where?: InputMaybe<Trackings_Bool_Exp>;
};


export type Query_RootTrackings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trackings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trackings_Order_By>>;
  where?: InputMaybe<Trackings_Bool_Exp>;
};


export type Query_RootTrackings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsersBonusArgs = {
  distinct_on?: InputMaybe<Array<UsersBonus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersBonus_Order_By>>;
  where?: InputMaybe<UsersBonus_Bool_Exp>;
};


export type Query_RootUsersBonus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersBonus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersBonus_Order_By>>;
  where?: InputMaybe<UsersBonus_Bool_Exp>;
};


export type Query_RootUsersBonus_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUsersCostsArgs = {
  distinct_on?: InputMaybe<Array<UsersCosts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersCosts_Order_By>>;
  where?: InputMaybe<UsersCosts_Bool_Exp>;
};


export type Query_RootUsersCosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersCosts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersCosts_Order_By>>;
  where?: InputMaybe<UsersCosts_Bool_Exp>;
};


export type Query_RootUsersCosts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootValidationsContractsArgs = {
  distinct_on?: InputMaybe<Array<ValidationsContracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationsContracts_Order_By>>;
  where?: InputMaybe<ValidationsContracts_Bool_Exp>;
};


export type Query_RootValidationsContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationsContracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationsContracts_Order_By>>;
  where?: InputMaybe<ValidationsContracts_Bool_Exp>;
};


export type Query_RootValidationsContracts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootVarietalsArgs = {
  distinct_on?: InputMaybe<Array<Varietals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Varietals_Order_By>>;
  where?: InputMaybe<Varietals_Bool_Exp>;
};


export type Query_RootVarietals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Varietals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Varietals_Order_By>>;
  where?: InputMaybe<Varietals_Bool_Exp>;
};


export type Query_RootVarietals_By_PkArgs = {
  id: Scalars['Int'];
};

/** Table for notifying our users of releases */
export type Releases = {
  __typename?: 'releases';
  createdAt: Scalars['timestamptz'];
  date: Scalars['timestamptz'];
  description: Scalars['String'];
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  /** Could be 'feature' | 'bugfix' | 'update' */
  tag?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "releases" */
export type Releases_Aggregate = {
  __typename?: 'releases_aggregate';
  aggregate?: Maybe<Releases_Aggregate_Fields>;
  nodes: Array<Releases>;
};

/** aggregate fields of "releases" */
export type Releases_Aggregate_Fields = {
  __typename?: 'releases_aggregate_fields';
  avg?: Maybe<Releases_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Releases_Max_Fields>;
  min?: Maybe<Releases_Min_Fields>;
  stddev?: Maybe<Releases_Stddev_Fields>;
  stddev_pop?: Maybe<Releases_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Releases_Stddev_Samp_Fields>;
  sum?: Maybe<Releases_Sum_Fields>;
  var_pop?: Maybe<Releases_Var_Pop_Fields>;
  var_samp?: Maybe<Releases_Var_Samp_Fields>;
  variance?: Maybe<Releases_Variance_Fields>;
};


/** aggregate fields of "releases" */
export type Releases_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Releases_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Releases_Avg_Fields = {
  __typename?: 'releases_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "releases". All fields are combined with a logical 'AND'. */
export type Releases_Bool_Exp = {
  _and?: InputMaybe<Array<Releases_Bool_Exp>>;
  _not?: InputMaybe<Releases_Bool_Exp>;
  _or?: InputMaybe<Array<Releases_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  imageUrl?: InputMaybe<String_Comparison_Exp>;
  link?: InputMaybe<String_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "releases" */
export enum Releases_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReleasesPkey = 'releases_pkey'
}

/** input type for incrementing numeric columns in table "releases" */
export type Releases_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "releases" */
export type Releases_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  /** Could be 'feature' | 'bugfix' | 'update' */
  tag?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Releases_Max_Fields = {
  __typename?: 'releases_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  /** Could be 'feature' | 'bugfix' | 'update' */
  tag?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Releases_Min_Fields = {
  __typename?: 'releases_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  date?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  /** Could be 'feature' | 'bugfix' | 'update' */
  tag?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "releases" */
export type Releases_Mutation_Response = {
  __typename?: 'releases_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Releases>;
};

/** on_conflict condition type for table "releases" */
export type Releases_On_Conflict = {
  constraint: Releases_Constraint;
  update_columns?: Array<Releases_Update_Column>;
  where?: InputMaybe<Releases_Bool_Exp>;
};

/** Ordering options when selecting data from "releases". */
export type Releases_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imageUrl?: InputMaybe<Order_By>;
  link?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: releases */
export type Releases_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "releases" */
export enum Releases_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Date = 'date',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'imageUrl',
  /** column name */
  Link = 'link',
  /** column name */
  Tag = 'tag',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "releases" */
export type Releases_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  /** Could be 'feature' | 'bugfix' | 'update' */
  tag?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Releases_Stddev_Fields = {
  __typename?: 'releases_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Releases_Stddev_Pop_Fields = {
  __typename?: 'releases_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Releases_Stddev_Samp_Fields = {
  __typename?: 'releases_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "releases" */
export type Releases_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Releases_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Releases_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  /** Could be 'feature' | 'bugfix' | 'update' */
  tag?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Releases_Sum_Fields = {
  __typename?: 'releases_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "releases" */
export enum Releases_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Date = 'date',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'imageUrl',
  /** column name */
  Link = 'link',
  /** column name */
  Tag = 'tag',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Releases_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Releases_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Releases_Set_Input>;
  where: Releases_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Releases_Var_Pop_Fields = {
  __typename?: 'releases_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Releases_Var_Samp_Fields = {
  __typename?: 'releases_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Releases_Variance_Fields = {
  __typename?: 'releases_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "reminders" */
export type Reminders = {
  __typename?: 'reminders';
  assignedTo: Scalars['String'];
  /** An object relationship */
  assignedUser: Users;
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['String'];
  /** An object relationship */
  creator: Users;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  objectId?: Maybe<Scalars['Int']>;
  startDate: Scalars['timestamptz'];
  table?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  viewedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "reminders" */
export type Reminders_Aggregate = {
  __typename?: 'reminders_aggregate';
  aggregate?: Maybe<Reminders_Aggregate_Fields>;
  nodes: Array<Reminders>;
};

/** aggregate fields of "reminders" */
export type Reminders_Aggregate_Fields = {
  __typename?: 'reminders_aggregate_fields';
  avg?: Maybe<Reminders_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Reminders_Max_Fields>;
  min?: Maybe<Reminders_Min_Fields>;
  stddev?: Maybe<Reminders_Stddev_Fields>;
  stddev_pop?: Maybe<Reminders_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reminders_Stddev_Samp_Fields>;
  sum?: Maybe<Reminders_Sum_Fields>;
  var_pop?: Maybe<Reminders_Var_Pop_Fields>;
  var_samp?: Maybe<Reminders_Var_Samp_Fields>;
  variance?: Maybe<Reminders_Variance_Fields>;
};


/** aggregate fields of "reminders" */
export type Reminders_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reminders_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Reminders_Avg_Fields = {
  __typename?: 'reminders_avg_fields';
  id?: Maybe<Scalars['Float']>;
  objectId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "reminders". All fields are combined with a logical 'AND'. */
export type Reminders_Bool_Exp = {
  _and?: InputMaybe<Array<Reminders_Bool_Exp>>;
  _not?: InputMaybe<Reminders_Bool_Exp>;
  _or?: InputMaybe<Array<Reminders_Bool_Exp>>;
  assignedTo?: InputMaybe<String_Comparison_Exp>;
  assignedUser?: InputMaybe<Users_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  objectId?: InputMaybe<Int_Comparison_Exp>;
  startDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  table?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  viewedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "reminders" */
export enum Reminders_Constraint {
  /** unique or primary key constraint on columns "id" */
  RemindersPkey = 'reminders_pkey'
}

/** input type for incrementing numeric columns in table "reminders" */
export type Reminders_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  objectId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "reminders" */
export type Reminders_Insert_Input = {
  assignedTo?: InputMaybe<Scalars['String']>;
  assignedUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  objectId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  table?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Reminders_Max_Fields = {
  __typename?: 'reminders_max_fields';
  assignedTo?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  objectId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  table?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  viewedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Reminders_Min_Fields = {
  __typename?: 'reminders_min_fields';
  assignedTo?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  objectId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['timestamptz']>;
  table?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  viewedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "reminders" */
export type Reminders_Mutation_Response = {
  __typename?: 'reminders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Reminders>;
};

/** on_conflict condition type for table "reminders" */
export type Reminders_On_Conflict = {
  constraint: Reminders_Constraint;
  update_columns?: Array<Reminders_Update_Column>;
  where?: InputMaybe<Reminders_Bool_Exp>;
};

/** Ordering options when selecting data from "reminders". */
export type Reminders_Order_By = {
  assignedTo?: InputMaybe<Order_By>;
  assignedUser?: InputMaybe<Users_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  objectId?: InputMaybe<Order_By>;
  startDate?: InputMaybe<Order_By>;
  table?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  viewedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reminders */
export type Reminders_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "reminders" */
export enum Reminders_Select_Column {
  /** column name */
  AssignedTo = 'assignedTo',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'objectId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Table = 'table',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ViewedAt = 'viewedAt'
}

/** input type for updating data in table "reminders" */
export type Reminders_Set_Input = {
  assignedTo?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  objectId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  table?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Reminders_Stddev_Fields = {
  __typename?: 'reminders_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  objectId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Reminders_Stddev_Pop_Fields = {
  __typename?: 'reminders_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  objectId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Reminders_Stddev_Samp_Fields = {
  __typename?: 'reminders_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  objectId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "reminders" */
export type Reminders_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reminders_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reminders_Stream_Cursor_Value_Input = {
  assignedTo?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  objectId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['timestamptz']>;
  table?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  viewedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Reminders_Sum_Fields = {
  __typename?: 'reminders_sum_fields';
  id?: Maybe<Scalars['Int']>;
  objectId?: Maybe<Scalars['Int']>;
};

/** update columns of table "reminders" */
export enum Reminders_Update_Column {
  /** column name */
  AssignedTo = 'assignedTo',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ObjectId = 'objectId',
  /** column name */
  StartDate = 'startDate',
  /** column name */
  Table = 'table',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  ViewedAt = 'viewedAt'
}

export type Reminders_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reminders_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reminders_Set_Input>;
  where: Reminders_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reminders_Var_Pop_Fields = {
  __typename?: 'reminders_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  objectId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Reminders_Var_Samp_Fields = {
  __typename?: 'reminders_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  objectId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Reminders_Variance_Fields = {
  __typename?: 'reminders_variance_fields';
  id?: Maybe<Scalars['Float']>;
  objectId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sampleLabels" */
export type SampleLabels = {
  __typename?: 'sampleLabels';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  fields: Scalars['jsonb'];
  id: Scalars['Int'];
  model?: Maybe<Scalars['jsonb']>;
  officeId: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "sampleLabels" */
export type SampleLabelsFieldsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "sampleLabels" */
export type SampleLabelsModelArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "sampleLabels" */
export type SampleLabels_Aggregate = {
  __typename?: 'sampleLabels_aggregate';
  aggregate?: Maybe<SampleLabels_Aggregate_Fields>;
  nodes: Array<SampleLabels>;
};

/** aggregate fields of "sampleLabels" */
export type SampleLabels_Aggregate_Fields = {
  __typename?: 'sampleLabels_aggregate_fields';
  avg?: Maybe<SampleLabels_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<SampleLabels_Max_Fields>;
  min?: Maybe<SampleLabels_Min_Fields>;
  stddev?: Maybe<SampleLabels_Stddev_Fields>;
  stddev_pop?: Maybe<SampleLabels_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SampleLabels_Stddev_Samp_Fields>;
  sum?: Maybe<SampleLabels_Sum_Fields>;
  var_pop?: Maybe<SampleLabels_Var_Pop_Fields>;
  var_samp?: Maybe<SampleLabels_Var_Samp_Fields>;
  variance?: Maybe<SampleLabels_Variance_Fields>;
};


/** aggregate fields of "sampleLabels" */
export type SampleLabels_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SampleLabels_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SampleLabels_Append_Input = {
  fields?: InputMaybe<Scalars['jsonb']>;
  model?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type SampleLabels_Avg_Fields = {
  __typename?: 'sampleLabels_avg_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sampleLabels". All fields are combined with a logical 'AND'. */
export type SampleLabels_Bool_Exp = {
  _and?: InputMaybe<Array<SampleLabels_Bool_Exp>>;
  _not?: InputMaybe<SampleLabels_Bool_Exp>;
  _or?: InputMaybe<Array<SampleLabels_Bool_Exp>>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  fields?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  model?: InputMaybe<Jsonb_Comparison_Exp>;
  officeId?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sampleLabels" */
export enum SampleLabels_Constraint {
  /** unique or primary key constraint on columns "id" */
  SampleLabelsPkey = 'sampleLabels_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SampleLabels_Delete_At_Path_Input = {
  fields?: InputMaybe<Array<Scalars['String']>>;
  model?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SampleLabels_Delete_Elem_Input = {
  fields?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SampleLabels_Delete_Key_Input = {
  fields?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "sampleLabels" */
export type SampleLabels_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  officeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "sampleLabels" */
export type SampleLabels_Insert_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fields?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['jsonb']>;
  officeId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type SampleLabels_Max_Fields = {
  __typename?: 'sampleLabels_max_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  officeId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type SampleLabels_Min_Fields = {
  __typename?: 'sampleLabels_min_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  officeId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "sampleLabels" */
export type SampleLabels_Mutation_Response = {
  __typename?: 'sampleLabels_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SampleLabels>;
};

/** on_conflict condition type for table "sampleLabels" */
export type SampleLabels_On_Conflict = {
  constraint: SampleLabels_Constraint;
  update_columns?: Array<SampleLabels_Update_Column>;
  where?: InputMaybe<SampleLabels_Bool_Exp>;
};

/** Ordering options when selecting data from "sampleLabels". */
export type SampleLabels_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  fields?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sampleLabels */
export type SampleLabels_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SampleLabels_Prepend_Input = {
  fields?: InputMaybe<Scalars['jsonb']>;
  model?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "sampleLabels" */
export enum SampleLabels_Select_Column {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Fields = 'fields',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "sampleLabels" */
export type SampleLabels_Set_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fields?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['jsonb']>;
  officeId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type SampleLabels_Stddev_Fields = {
  __typename?: 'sampleLabels_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SampleLabels_Stddev_Pop_Fields = {
  __typename?: 'sampleLabels_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SampleLabels_Stddev_Samp_Fields = {
  __typename?: 'sampleLabels_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sampleLabels" */
export type SampleLabels_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SampleLabels_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SampleLabels_Stream_Cursor_Value_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  fields?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['jsonb']>;
  officeId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type SampleLabels_Sum_Fields = {
  __typename?: 'sampleLabels_sum_fields';
  id?: Maybe<Scalars['Int']>;
  officeId?: Maybe<Scalars['Int']>;
};

/** update columns of table "sampleLabels" */
export enum SampleLabels_Update_Column {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Fields = 'fields',
  /** column name */
  Id = 'id',
  /** column name */
  Model = 'model',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type SampleLabels_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SampleLabels_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SampleLabels_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SampleLabels_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SampleLabels_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SampleLabels_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SampleLabels_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SampleLabels_Set_Input>;
  where: SampleLabels_Bool_Exp;
};

/** aggregate var_pop on columns */
export type SampleLabels_Var_Pop_Fields = {
  __typename?: 'sampleLabels_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SampleLabels_Var_Samp_Fields = {
  __typename?: 'sampleLabels_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SampleLabels_Variance_Fields = {
  __typename?: 'sampleLabels_variance_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sampleShipmentRequests" */
export type SampleShipmentRequests = {
  __typename?: 'sampleShipmentRequests';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  buySpec: BuySpecs;
  buySpecId: Scalars['Int'];
  comments?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamp'];
  createdBy: Scalars['String'];
  deadline?: Maybe<Scalars['date']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  feedback?: Maybe<Scalars['String']>;
  files?: Maybe<Scalars['jsonb']>;
  id: Scalars['Int'];
  /** An object relationship */
  item: Items;
  itemId: Scalars['Int'];
  numberOfSamples: Scalars['Int'];
  requestedBy?: Maybe<Scalars['String']>;
  /** An object relationship */
  requestedByUser?: Maybe<Users>;
  /** An object relationship */
  sampleShipment?: Maybe<SampleShipments>;
  sampleShipmentId?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  updatedAt: Scalars['timestamp'];
};


/** columns and relationships of "sampleShipmentRequests" */
export type SampleShipmentRequestsFilesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "sampleShipmentRequests" */
export type SampleShipmentRequests_Aggregate = {
  __typename?: 'sampleShipmentRequests_aggregate';
  aggregate?: Maybe<SampleShipmentRequests_Aggregate_Fields>;
  nodes: Array<SampleShipmentRequests>;
};

export type SampleShipmentRequests_Aggregate_Bool_Exp = {
  count?: InputMaybe<SampleShipmentRequests_Aggregate_Bool_Exp_Count>;
};

export type SampleShipmentRequests_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<SampleShipmentRequests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sampleShipmentRequests" */
export type SampleShipmentRequests_Aggregate_Fields = {
  __typename?: 'sampleShipmentRequests_aggregate_fields';
  avg?: Maybe<SampleShipmentRequests_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<SampleShipmentRequests_Max_Fields>;
  min?: Maybe<SampleShipmentRequests_Min_Fields>;
  stddev?: Maybe<SampleShipmentRequests_Stddev_Fields>;
  stddev_pop?: Maybe<SampleShipmentRequests_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SampleShipmentRequests_Stddev_Samp_Fields>;
  sum?: Maybe<SampleShipmentRequests_Sum_Fields>;
  var_pop?: Maybe<SampleShipmentRequests_Var_Pop_Fields>;
  var_samp?: Maybe<SampleShipmentRequests_Var_Samp_Fields>;
  variance?: Maybe<SampleShipmentRequests_Variance_Fields>;
};


/** aggregate fields of "sampleShipmentRequests" */
export type SampleShipmentRequests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SampleShipmentRequests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sampleShipmentRequests" */
export type SampleShipmentRequests_Aggregate_Order_By = {
  avg?: InputMaybe<SampleShipmentRequests_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SampleShipmentRequests_Max_Order_By>;
  min?: InputMaybe<SampleShipmentRequests_Min_Order_By>;
  stddev?: InputMaybe<SampleShipmentRequests_Stddev_Order_By>;
  stddev_pop?: InputMaybe<SampleShipmentRequests_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<SampleShipmentRequests_Stddev_Samp_Order_By>;
  sum?: InputMaybe<SampleShipmentRequests_Sum_Order_By>;
  var_pop?: InputMaybe<SampleShipmentRequests_Var_Pop_Order_By>;
  var_samp?: InputMaybe<SampleShipmentRequests_Var_Samp_Order_By>;
  variance?: InputMaybe<SampleShipmentRequests_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SampleShipmentRequests_Append_Input = {
  files?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "sampleShipmentRequests" */
export type SampleShipmentRequests_Arr_Rel_Insert_Input = {
  data: Array<SampleShipmentRequests_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SampleShipmentRequests_On_Conflict>;
};

/** aggregate avg on columns */
export type SampleShipmentRequests_Avg_Fields = {
  __typename?: 'sampleShipmentRequests_avg_fields';
  buySpecId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  numberOfSamples?: Maybe<Scalars['Float']>;
  sampleShipmentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sampleShipmentRequests" */
export type SampleShipmentRequests_Avg_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  numberOfSamples?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sampleShipmentRequests". All fields are combined with a logical 'AND'. */
export type SampleShipmentRequests_Bool_Exp = {
  _and?: InputMaybe<Array<SampleShipmentRequests_Bool_Exp>>;
  _not?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
  _or?: InputMaybe<Array<SampleShipmentRequests_Bool_Exp>>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  buySpec?: InputMaybe<BuySpecs_Bool_Exp>;
  buySpecId?: InputMaybe<Int_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  deadline?: InputMaybe<Date_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  feedback?: InputMaybe<String_Comparison_Exp>;
  files?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  item?: InputMaybe<Items_Bool_Exp>;
  itemId?: InputMaybe<Int_Comparison_Exp>;
  numberOfSamples?: InputMaybe<Int_Comparison_Exp>;
  requestedBy?: InputMaybe<String_Comparison_Exp>;
  requestedByUser?: InputMaybe<Users_Bool_Exp>;
  sampleShipment?: InputMaybe<SampleShipments_Bool_Exp>;
  sampleShipmentId?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "sampleShipmentRequests" */
export enum SampleShipmentRequests_Constraint {
  /** unique or primary key constraint on columns "id" */
  SampleShipmentRequestsPkey = 'sampleShipmentRequests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SampleShipmentRequests_Delete_At_Path_Input = {
  files?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SampleShipmentRequests_Delete_Elem_Input = {
  files?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SampleShipmentRequests_Delete_Key_Input = {
  files?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "sampleShipmentRequests" */
export type SampleShipmentRequests_Inc_Input = {
  buySpecId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['Int']>;
  numberOfSamples?: InputMaybe<Scalars['Int']>;
  sampleShipmentId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "sampleShipmentRequests" */
export type SampleShipmentRequests_Insert_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  buySpec?: InputMaybe<BuySpecs_Obj_Rel_Insert_Input>;
  buySpecId?: InputMaybe<Scalars['Int']>;
  comments?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['date']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  feedback?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  item?: InputMaybe<Items_Obj_Rel_Insert_Input>;
  itemId?: InputMaybe<Scalars['Int']>;
  numberOfSamples?: InputMaybe<Scalars['Int']>;
  requestedBy?: InputMaybe<Scalars['String']>;
  requestedByUser?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  sampleShipment?: InputMaybe<SampleShipments_Obj_Rel_Insert_Input>;
  sampleShipmentId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type SampleShipmentRequests_Max_Fields = {
  __typename?: 'sampleShipmentRequests_max_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  buySpecId?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['String']>;
  deadline?: Maybe<Scalars['date']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['Int']>;
  numberOfSamples?: Maybe<Scalars['Int']>;
  requestedBy?: Maybe<Scalars['String']>;
  sampleShipmentId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "sampleShipmentRequests" */
export type SampleShipmentRequests_Max_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  buySpecId?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  feedback?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  numberOfSamples?: InputMaybe<Order_By>;
  requestedBy?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type SampleShipmentRequests_Min_Fields = {
  __typename?: 'sampleShipmentRequests_min_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  buySpecId?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  createdBy?: Maybe<Scalars['String']>;
  deadline?: Maybe<Scalars['date']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['Int']>;
  numberOfSamples?: Maybe<Scalars['Int']>;
  requestedBy?: Maybe<Scalars['String']>;
  sampleShipmentId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "sampleShipmentRequests" */
export type SampleShipmentRequests_Min_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  buySpecId?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  feedback?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  numberOfSamples?: InputMaybe<Order_By>;
  requestedBy?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sampleShipmentRequests" */
export type SampleShipmentRequests_Mutation_Response = {
  __typename?: 'sampleShipmentRequests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SampleShipmentRequests>;
};

/** on_conflict condition type for table "sampleShipmentRequests" */
export type SampleShipmentRequests_On_Conflict = {
  constraint: SampleShipmentRequests_Constraint;
  update_columns?: Array<SampleShipmentRequests_Update_Column>;
  where?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
};

/** Ordering options when selecting data from "sampleShipmentRequests". */
export type SampleShipmentRequests_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  buySpec?: InputMaybe<BuySpecs_Order_By>;
  buySpecId?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deadline?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  feedback?: InputMaybe<Order_By>;
  files?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  item?: InputMaybe<Items_Order_By>;
  itemId?: InputMaybe<Order_By>;
  numberOfSamples?: InputMaybe<Order_By>;
  requestedBy?: InputMaybe<Order_By>;
  requestedByUser?: InputMaybe<Users_Order_By>;
  sampleShipment?: InputMaybe<SampleShipments_Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sampleShipmentRequests */
export type SampleShipmentRequests_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SampleShipmentRequests_Prepend_Input = {
  files?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "sampleShipmentRequests" */
export enum SampleShipmentRequests_Select_Column {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BuySpecId = 'buySpecId',
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Deadline = 'deadline',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  Files = 'files',
  /** column name */
  Id = 'id',
  /** column name */
  ItemId = 'itemId',
  /** column name */
  NumberOfSamples = 'numberOfSamples',
  /** column name */
  RequestedBy = 'requestedBy',
  /** column name */
  SampleShipmentId = 'sampleShipmentId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "sampleShipmentRequests" */
export type SampleShipmentRequests_Set_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  buySpecId?: InputMaybe<Scalars['Int']>;
  comments?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['date']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  feedback?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['Int']>;
  numberOfSamples?: InputMaybe<Scalars['Int']>;
  requestedBy?: InputMaybe<Scalars['String']>;
  sampleShipmentId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type SampleShipmentRequests_Stddev_Fields = {
  __typename?: 'sampleShipmentRequests_stddev_fields';
  buySpecId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  numberOfSamples?: Maybe<Scalars['Float']>;
  sampleShipmentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sampleShipmentRequests" */
export type SampleShipmentRequests_Stddev_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  numberOfSamples?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type SampleShipmentRequests_Stddev_Pop_Fields = {
  __typename?: 'sampleShipmentRequests_stddev_pop_fields';
  buySpecId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  numberOfSamples?: Maybe<Scalars['Float']>;
  sampleShipmentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sampleShipmentRequests" */
export type SampleShipmentRequests_Stddev_Pop_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  numberOfSamples?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type SampleShipmentRequests_Stddev_Samp_Fields = {
  __typename?: 'sampleShipmentRequests_stddev_samp_fields';
  buySpecId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  numberOfSamples?: Maybe<Scalars['Float']>;
  sampleShipmentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sampleShipmentRequests" */
export type SampleShipmentRequests_Stddev_Samp_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  numberOfSamples?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sampleShipmentRequests" */
export type SampleShipmentRequests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SampleShipmentRequests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SampleShipmentRequests_Stream_Cursor_Value_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  buySpecId?: InputMaybe<Scalars['Int']>;
  comments?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['date']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  feedback?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['Int']>;
  numberOfSamples?: InputMaybe<Scalars['Int']>;
  requestedBy?: InputMaybe<Scalars['String']>;
  sampleShipmentId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate sum on columns */
export type SampleShipmentRequests_Sum_Fields = {
  __typename?: 'sampleShipmentRequests_sum_fields';
  buySpecId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['Int']>;
  numberOfSamples?: Maybe<Scalars['Int']>;
  sampleShipmentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "sampleShipmentRequests" */
export type SampleShipmentRequests_Sum_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  numberOfSamples?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** update columns of table "sampleShipmentRequests" */
export enum SampleShipmentRequests_Update_Column {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BuySpecId = 'buySpecId',
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Deadline = 'deadline',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Feedback = 'feedback',
  /** column name */
  Files = 'files',
  /** column name */
  Id = 'id',
  /** column name */
  ItemId = 'itemId',
  /** column name */
  NumberOfSamples = 'numberOfSamples',
  /** column name */
  RequestedBy = 'requestedBy',
  /** column name */
  SampleShipmentId = 'sampleShipmentId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type SampleShipmentRequests_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SampleShipmentRequests_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SampleShipmentRequests_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SampleShipmentRequests_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SampleShipmentRequests_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SampleShipmentRequests_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SampleShipmentRequests_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SampleShipmentRequests_Set_Input>;
  where: SampleShipmentRequests_Bool_Exp;
};

/** aggregate var_pop on columns */
export type SampleShipmentRequests_Var_Pop_Fields = {
  __typename?: 'sampleShipmentRequests_var_pop_fields';
  buySpecId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  numberOfSamples?: Maybe<Scalars['Float']>;
  sampleShipmentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sampleShipmentRequests" */
export type SampleShipmentRequests_Var_Pop_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  numberOfSamples?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type SampleShipmentRequests_Var_Samp_Fields = {
  __typename?: 'sampleShipmentRequests_var_samp_fields';
  buySpecId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  numberOfSamples?: Maybe<Scalars['Float']>;
  sampleShipmentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sampleShipmentRequests" */
export type SampleShipmentRequests_Var_Samp_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  numberOfSamples?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type SampleShipmentRequests_Variance_Fields = {
  __typename?: 'sampleShipmentRequests_variance_fields';
  buySpecId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  numberOfSamples?: Maybe<Scalars['Float']>;
  sampleShipmentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sampleShipmentRequests" */
export type SampleShipmentRequests_Variance_Order_By = {
  buySpecId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  numberOfSamples?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** columns and relationships of "sampleShipments" */
export type SampleShipments = {
  __typename?: 'sampleShipments';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId: Scalars['String'];
  carrier?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  deliveryDate?: Maybe<Scalars['timestamptz']>;
  deliveryMethod?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isHardcodedCarrier: Scalars['Boolean'];
  /** An object relationship */
  office?: Maybe<Offices>;
  officeId?: Maybe<Scalars['Int']>;
  pickupDate?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  recipientAddress?: Maybe<Addresses>;
  recipientAddressId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  recipientCompany: Companies;
  recipientCompanyId: Scalars['Int'];
  /** An object relationship */
  recipientContact?: Maybe<Contacts>;
  recipientContactId?: Maybe<Scalars['Int']>;
  /** An array relationship */
  sampleShipmentRequests: Array<SampleShipmentRequests>;
  /** An aggregate relationship */
  sampleShipmentRequests_aggregate: SampleShipmentRequests_Aggregate;
  /** An object relationship */
  senderAddress?: Maybe<Addresses>;
  senderAddressId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  senderCompany?: Maybe<Companies>;
  senderCompanyId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  senderContact?: Maybe<Contacts>;
  senderContactId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  trackingId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "sampleShipments" */
export type SampleShipmentsSampleShipmentRequestsArgs = {
  distinct_on?: InputMaybe<Array<SampleShipmentRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleShipmentRequests_Order_By>>;
  where?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
};


/** columns and relationships of "sampleShipments" */
export type SampleShipmentsSampleShipmentRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SampleShipmentRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleShipmentRequests_Order_By>>;
  where?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
};

/** aggregated selection of "sampleShipments" */
export type SampleShipments_Aggregate = {
  __typename?: 'sampleShipments_aggregate';
  aggregate?: Maybe<SampleShipments_Aggregate_Fields>;
  nodes: Array<SampleShipments>;
};

/** aggregate fields of "sampleShipments" */
export type SampleShipments_Aggregate_Fields = {
  __typename?: 'sampleShipments_aggregate_fields';
  avg?: Maybe<SampleShipments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<SampleShipments_Max_Fields>;
  min?: Maybe<SampleShipments_Min_Fields>;
  stddev?: Maybe<SampleShipments_Stddev_Fields>;
  stddev_pop?: Maybe<SampleShipments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SampleShipments_Stddev_Samp_Fields>;
  sum?: Maybe<SampleShipments_Sum_Fields>;
  var_pop?: Maybe<SampleShipments_Var_Pop_Fields>;
  var_samp?: Maybe<SampleShipments_Var_Samp_Fields>;
  variance?: Maybe<SampleShipments_Variance_Fields>;
};


/** aggregate fields of "sampleShipments" */
export type SampleShipments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SampleShipments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SampleShipments_Avg_Fields = {
  __typename?: 'sampleShipments_avg_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  recipientAddressId?: Maybe<Scalars['Float']>;
  recipientCompanyId?: Maybe<Scalars['Float']>;
  recipientContactId?: Maybe<Scalars['Float']>;
  senderAddressId?: Maybe<Scalars['Float']>;
  senderCompanyId?: Maybe<Scalars['Float']>;
  senderContactId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sampleShipments". All fields are combined with a logical 'AND'. */
export type SampleShipments_Bool_Exp = {
  _and?: InputMaybe<Array<SampleShipments_Bool_Exp>>;
  _not?: InputMaybe<SampleShipments_Bool_Exp>;
  _or?: InputMaybe<Array<SampleShipments_Bool_Exp>>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  brokerId?: InputMaybe<String_Comparison_Exp>;
  carrier?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  deliveryDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  deliveryMethod?: InputMaybe<String_Comparison_Exp>;
  details?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  isHardcodedCarrier?: InputMaybe<Boolean_Comparison_Exp>;
  office?: InputMaybe<Offices_Bool_Exp>;
  officeId?: InputMaybe<Int_Comparison_Exp>;
  pickupDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  recipientAddress?: InputMaybe<Addresses_Bool_Exp>;
  recipientAddressId?: InputMaybe<Int_Comparison_Exp>;
  recipientCompany?: InputMaybe<Companies_Bool_Exp>;
  recipientCompanyId?: InputMaybe<Int_Comparison_Exp>;
  recipientContact?: InputMaybe<Contacts_Bool_Exp>;
  recipientContactId?: InputMaybe<Int_Comparison_Exp>;
  sampleShipmentRequests?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
  sampleShipmentRequests_aggregate?: InputMaybe<SampleShipmentRequests_Aggregate_Bool_Exp>;
  senderAddress?: InputMaybe<Addresses_Bool_Exp>;
  senderAddressId?: InputMaybe<Int_Comparison_Exp>;
  senderCompany?: InputMaybe<Companies_Bool_Exp>;
  senderCompanyId?: InputMaybe<Int_Comparison_Exp>;
  senderContact?: InputMaybe<Contacts_Bool_Exp>;
  senderContactId?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trackingId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "sampleShipments" */
export enum SampleShipments_Constraint {
  /** unique or primary key constraint on columns "id" */
  SampleShipmentsPkey = 'sampleShipments_pkey'
}

/** input type for incrementing numeric columns in table "sampleShipments" */
export type SampleShipments_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  officeId?: InputMaybe<Scalars['Int']>;
  recipientAddressId?: InputMaybe<Scalars['Int']>;
  recipientCompanyId?: InputMaybe<Scalars['Int']>;
  recipientContactId?: InputMaybe<Scalars['Int']>;
  senderAddressId?: InputMaybe<Scalars['Int']>;
  senderCompanyId?: InputMaybe<Scalars['Int']>;
  senderContactId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "sampleShipments" */
export type SampleShipments_Insert_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  brokerId?: InputMaybe<Scalars['String']>;
  carrier?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  deliveryDate?: InputMaybe<Scalars['timestamptz']>;
  deliveryMethod?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isHardcodedCarrier?: InputMaybe<Scalars['Boolean']>;
  office?: InputMaybe<Offices_Obj_Rel_Insert_Input>;
  officeId?: InputMaybe<Scalars['Int']>;
  pickupDate?: InputMaybe<Scalars['timestamptz']>;
  recipientAddress?: InputMaybe<Addresses_Obj_Rel_Insert_Input>;
  recipientAddressId?: InputMaybe<Scalars['Int']>;
  recipientCompany?: InputMaybe<Companies_Obj_Rel_Insert_Input>;
  recipientCompanyId?: InputMaybe<Scalars['Int']>;
  recipientContact?: InputMaybe<Contacts_Obj_Rel_Insert_Input>;
  recipientContactId?: InputMaybe<Scalars['Int']>;
  sampleShipmentRequests?: InputMaybe<SampleShipmentRequests_Arr_Rel_Insert_Input>;
  senderAddress?: InputMaybe<Addresses_Obj_Rel_Insert_Input>;
  senderAddressId?: InputMaybe<Scalars['Int']>;
  senderCompany?: InputMaybe<Companies_Obj_Rel_Insert_Input>;
  senderCompanyId?: InputMaybe<Scalars['Int']>;
  senderContact?: InputMaybe<Contacts_Obj_Rel_Insert_Input>;
  senderContactId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  trackingId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type SampleShipments_Max_Fields = {
  __typename?: 'sampleShipments_max_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId?: Maybe<Scalars['String']>;
  carrier?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  deliveryDate?: Maybe<Scalars['timestamptz']>;
  deliveryMethod?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  officeId?: Maybe<Scalars['Int']>;
  pickupDate?: Maybe<Scalars['timestamptz']>;
  recipientAddressId?: Maybe<Scalars['Int']>;
  recipientCompanyId?: Maybe<Scalars['Int']>;
  recipientContactId?: Maybe<Scalars['Int']>;
  senderAddressId?: Maybe<Scalars['Int']>;
  senderCompanyId?: Maybe<Scalars['Int']>;
  senderContactId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  trackingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type SampleShipments_Min_Fields = {
  __typename?: 'sampleShipments_min_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  brokerId?: Maybe<Scalars['String']>;
  carrier?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  deliveryDate?: Maybe<Scalars['timestamptz']>;
  deliveryMethod?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  officeId?: Maybe<Scalars['Int']>;
  pickupDate?: Maybe<Scalars['timestamptz']>;
  recipientAddressId?: Maybe<Scalars['Int']>;
  recipientCompanyId?: Maybe<Scalars['Int']>;
  recipientContactId?: Maybe<Scalars['Int']>;
  senderAddressId?: Maybe<Scalars['Int']>;
  senderCompanyId?: Maybe<Scalars['Int']>;
  senderContactId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  trackingId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "sampleShipments" */
export type SampleShipments_Mutation_Response = {
  __typename?: 'sampleShipments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SampleShipments>;
};

/** input type for inserting object relation for remote table "sampleShipments" */
export type SampleShipments_Obj_Rel_Insert_Input = {
  data: SampleShipments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<SampleShipments_On_Conflict>;
};

/** on_conflict condition type for table "sampleShipments" */
export type SampleShipments_On_Conflict = {
  constraint: SampleShipments_Constraint;
  update_columns?: Array<SampleShipments_Update_Column>;
  where?: InputMaybe<SampleShipments_Bool_Exp>;
};

/** Ordering options when selecting data from "sampleShipments". */
export type SampleShipments_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  brokerId?: InputMaybe<Order_By>;
  carrier?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  deliveryDate?: InputMaybe<Order_By>;
  deliveryMethod?: InputMaybe<Order_By>;
  details?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isHardcodedCarrier?: InputMaybe<Order_By>;
  office?: InputMaybe<Offices_Order_By>;
  officeId?: InputMaybe<Order_By>;
  pickupDate?: InputMaybe<Order_By>;
  recipientAddress?: InputMaybe<Addresses_Order_By>;
  recipientAddressId?: InputMaybe<Order_By>;
  recipientCompany?: InputMaybe<Companies_Order_By>;
  recipientCompanyId?: InputMaybe<Order_By>;
  recipientContact?: InputMaybe<Contacts_Order_By>;
  recipientContactId?: InputMaybe<Order_By>;
  sampleShipmentRequests_aggregate?: InputMaybe<SampleShipmentRequests_Aggregate_Order_By>;
  senderAddress?: InputMaybe<Addresses_Order_By>;
  senderAddressId?: InputMaybe<Order_By>;
  senderCompany?: InputMaybe<Companies_Order_By>;
  senderCompanyId?: InputMaybe<Order_By>;
  senderContact?: InputMaybe<Contacts_Order_By>;
  senderContactId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trackingId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sampleShipments */
export type SampleShipments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "sampleShipments" */
export enum SampleShipments_Select_Column {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BrokerId = 'brokerId',
  /** column name */
  Carrier = 'carrier',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DeliveryDate = 'deliveryDate',
  /** column name */
  DeliveryMethod = 'deliveryMethod',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id',
  /** column name */
  IsHardcodedCarrier = 'isHardcodedCarrier',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  PickupDate = 'pickupDate',
  /** column name */
  RecipientAddressId = 'recipientAddressId',
  /** column name */
  RecipientCompanyId = 'recipientCompanyId',
  /** column name */
  RecipientContactId = 'recipientContactId',
  /** column name */
  SenderAddressId = 'senderAddressId',
  /** column name */
  SenderCompanyId = 'senderCompanyId',
  /** column name */
  SenderContactId = 'senderContactId',
  /** column name */
  Status = 'status',
  /** column name */
  TrackingId = 'trackingId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "sampleShipments" */
export type SampleShipments_Set_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  brokerId?: InputMaybe<Scalars['String']>;
  carrier?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  deliveryDate?: InputMaybe<Scalars['timestamptz']>;
  deliveryMethod?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isHardcodedCarrier?: InputMaybe<Scalars['Boolean']>;
  officeId?: InputMaybe<Scalars['Int']>;
  pickupDate?: InputMaybe<Scalars['timestamptz']>;
  recipientAddressId?: InputMaybe<Scalars['Int']>;
  recipientCompanyId?: InputMaybe<Scalars['Int']>;
  recipientContactId?: InputMaybe<Scalars['Int']>;
  senderAddressId?: InputMaybe<Scalars['Int']>;
  senderCompanyId?: InputMaybe<Scalars['Int']>;
  senderContactId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  trackingId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type SampleShipments_Stddev_Fields = {
  __typename?: 'sampleShipments_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  recipientAddressId?: Maybe<Scalars['Float']>;
  recipientCompanyId?: Maybe<Scalars['Float']>;
  recipientContactId?: Maybe<Scalars['Float']>;
  senderAddressId?: Maybe<Scalars['Float']>;
  senderCompanyId?: Maybe<Scalars['Float']>;
  senderContactId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SampleShipments_Stddev_Pop_Fields = {
  __typename?: 'sampleShipments_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  recipientAddressId?: Maybe<Scalars['Float']>;
  recipientCompanyId?: Maybe<Scalars['Float']>;
  recipientContactId?: Maybe<Scalars['Float']>;
  senderAddressId?: Maybe<Scalars['Float']>;
  senderCompanyId?: Maybe<Scalars['Float']>;
  senderContactId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SampleShipments_Stddev_Samp_Fields = {
  __typename?: 'sampleShipments_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  recipientAddressId?: Maybe<Scalars['Float']>;
  recipientCompanyId?: Maybe<Scalars['Float']>;
  recipientContactId?: Maybe<Scalars['Float']>;
  senderAddressId?: Maybe<Scalars['Float']>;
  senderCompanyId?: Maybe<Scalars['Float']>;
  senderContactId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sampleShipments" */
export type SampleShipments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SampleShipments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SampleShipments_Stream_Cursor_Value_Input = {
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  brokerId?: InputMaybe<Scalars['String']>;
  carrier?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  deliveryDate?: InputMaybe<Scalars['timestamptz']>;
  deliveryMethod?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isHardcodedCarrier?: InputMaybe<Scalars['Boolean']>;
  officeId?: InputMaybe<Scalars['Int']>;
  pickupDate?: InputMaybe<Scalars['timestamptz']>;
  recipientAddressId?: InputMaybe<Scalars['Int']>;
  recipientCompanyId?: InputMaybe<Scalars['Int']>;
  recipientContactId?: InputMaybe<Scalars['Int']>;
  senderAddressId?: InputMaybe<Scalars['Int']>;
  senderCompanyId?: InputMaybe<Scalars['Int']>;
  senderContactId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  trackingId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type SampleShipments_Sum_Fields = {
  __typename?: 'sampleShipments_sum_fields';
  id?: Maybe<Scalars['Int']>;
  officeId?: Maybe<Scalars['Int']>;
  recipientAddressId?: Maybe<Scalars['Int']>;
  recipientCompanyId?: Maybe<Scalars['Int']>;
  recipientContactId?: Maybe<Scalars['Int']>;
  senderAddressId?: Maybe<Scalars['Int']>;
  senderCompanyId?: Maybe<Scalars['Int']>;
  senderContactId?: Maybe<Scalars['Int']>;
};

/** update columns of table "sampleShipments" */
export enum SampleShipments_Update_Column {
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  BrokerId = 'brokerId',
  /** column name */
  Carrier = 'carrier',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  DeliveryDate = 'deliveryDate',
  /** column name */
  DeliveryMethod = 'deliveryMethod',
  /** column name */
  Details = 'details',
  /** column name */
  Id = 'id',
  /** column name */
  IsHardcodedCarrier = 'isHardcodedCarrier',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  PickupDate = 'pickupDate',
  /** column name */
  RecipientAddressId = 'recipientAddressId',
  /** column name */
  RecipientCompanyId = 'recipientCompanyId',
  /** column name */
  RecipientContactId = 'recipientContactId',
  /** column name */
  SenderAddressId = 'senderAddressId',
  /** column name */
  SenderCompanyId = 'senderCompanyId',
  /** column name */
  SenderContactId = 'senderContactId',
  /** column name */
  Status = 'status',
  /** column name */
  TrackingId = 'trackingId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type SampleShipments_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SampleShipments_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SampleShipments_Set_Input>;
  where: SampleShipments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type SampleShipments_Var_Pop_Fields = {
  __typename?: 'sampleShipments_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  recipientAddressId?: Maybe<Scalars['Float']>;
  recipientCompanyId?: Maybe<Scalars['Float']>;
  recipientContactId?: Maybe<Scalars['Float']>;
  senderAddressId?: Maybe<Scalars['Float']>;
  senderCompanyId?: Maybe<Scalars['Float']>;
  senderContactId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SampleShipments_Var_Samp_Fields = {
  __typename?: 'sampleShipments_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  recipientAddressId?: Maybe<Scalars['Float']>;
  recipientCompanyId?: Maybe<Scalars['Float']>;
  recipientContactId?: Maybe<Scalars['Float']>;
  senderAddressId?: Maybe<Scalars['Float']>;
  senderCompanyId?: Maybe<Scalars['Float']>;
  senderContactId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SampleShipments_Variance_Fields = {
  __typename?: 'sampleShipments_variance_fields';
  id?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  recipientAddressId?: Maybe<Scalars['Float']>;
  recipientCompanyId?: Maybe<Scalars['Float']>;
  recipientContactId?: Maybe<Scalars['Float']>;
  senderAddressId?: Maybe<Scalars['Float']>;
  senderCompanyId?: Maybe<Scalars['Float']>;
  senderContactId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "samples" */
export type Samples = {
  __typename?: 'samples';
  analysisCertificates?: Maybe<Scalars['jsonb']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  commodityType: Scalars['String'];
  compositionCertificates?: Maybe<Scalars['jsonb']>;
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  /** An object relationship */
  item: Items;
  itemId: Scalars['Int'];
  officeId?: Maybe<Scalars['Int']>;
  ref?: Maybe<Scalars['String']>;
  reminderForExpiration?: Maybe<Scalars['timestamptz']>;
  samplePictures?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  sampleShipment?: Maybe<SampleShipments>;
  sampleShipmentId?: Maybe<Scalars['Int']>;
  sampledBy?: Maybe<Scalars['String']>;
  samplingDate?: Maybe<Scalars['timestamptz']>;
  shelf?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "samples" */
export type SamplesAnalysisCertificatesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "samples" */
export type SamplesCompositionCertificatesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "samples" */
export type SamplesSamplePicturesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "samples" */
export type Samples_Aggregate = {
  __typename?: 'samples_aggregate';
  aggregate?: Maybe<Samples_Aggregate_Fields>;
  nodes: Array<Samples>;
};

export type Samples_Aggregate_Bool_Exp = {
  count?: InputMaybe<Samples_Aggregate_Bool_Exp_Count>;
};

export type Samples_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Samples_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Samples_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "samples" */
export type Samples_Aggregate_Fields = {
  __typename?: 'samples_aggregate_fields';
  avg?: Maybe<Samples_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Samples_Max_Fields>;
  min?: Maybe<Samples_Min_Fields>;
  stddev?: Maybe<Samples_Stddev_Fields>;
  stddev_pop?: Maybe<Samples_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Samples_Stddev_Samp_Fields>;
  sum?: Maybe<Samples_Sum_Fields>;
  var_pop?: Maybe<Samples_Var_Pop_Fields>;
  var_samp?: Maybe<Samples_Var_Samp_Fields>;
  variance?: Maybe<Samples_Variance_Fields>;
};


/** aggregate fields of "samples" */
export type Samples_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Samples_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "samples" */
export type Samples_Aggregate_Order_By = {
  avg?: InputMaybe<Samples_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Samples_Max_Order_By>;
  min?: InputMaybe<Samples_Min_Order_By>;
  stddev?: InputMaybe<Samples_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Samples_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Samples_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Samples_Sum_Order_By>;
  var_pop?: InputMaybe<Samples_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Samples_Var_Samp_Order_By>;
  variance?: InputMaybe<Samples_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Samples_Append_Input = {
  analysisCertificates?: InputMaybe<Scalars['jsonb']>;
  compositionCertificates?: InputMaybe<Scalars['jsonb']>;
  samplePictures?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "samples" */
export type Samples_Arr_Rel_Insert_Input = {
  data: Array<Samples_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Samples_On_Conflict>;
};

/** aggregate avg on columns */
export type Samples_Avg_Fields = {
  __typename?: 'samples_avg_fields';
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  sampleShipmentId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "samples" */
export type Samples_Avg_Order_By = {
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "samples". All fields are combined with a logical 'AND'. */
export type Samples_Bool_Exp = {
  _and?: InputMaybe<Array<Samples_Bool_Exp>>;
  _not?: InputMaybe<Samples_Bool_Exp>;
  _or?: InputMaybe<Array<Samples_Bool_Exp>>;
  analysisCertificates?: InputMaybe<Jsonb_Comparison_Exp>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  commodityType?: InputMaybe<String_Comparison_Exp>;
  compositionCertificates?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  item?: InputMaybe<Items_Bool_Exp>;
  itemId?: InputMaybe<Int_Comparison_Exp>;
  officeId?: InputMaybe<Int_Comparison_Exp>;
  ref?: InputMaybe<String_Comparison_Exp>;
  reminderForExpiration?: InputMaybe<Timestamptz_Comparison_Exp>;
  samplePictures?: InputMaybe<Jsonb_Comparison_Exp>;
  sampleShipment?: InputMaybe<SampleShipments_Bool_Exp>;
  sampleShipmentId?: InputMaybe<Int_Comparison_Exp>;
  sampledBy?: InputMaybe<String_Comparison_Exp>;
  samplingDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  shelf?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "samples" */
export enum Samples_Constraint {
  /** unique or primary key constraint on columns "id" */
  SamplesPkey = 'samples_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Samples_Delete_At_Path_Input = {
  analysisCertificates?: InputMaybe<Array<Scalars['String']>>;
  compositionCertificates?: InputMaybe<Array<Scalars['String']>>;
  samplePictures?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Samples_Delete_Elem_Input = {
  analysisCertificates?: InputMaybe<Scalars['Int']>;
  compositionCertificates?: InputMaybe<Scalars['Int']>;
  samplePictures?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Samples_Delete_Key_Input = {
  analysisCertificates?: InputMaybe<Scalars['String']>;
  compositionCertificates?: InputMaybe<Scalars['String']>;
  samplePictures?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "samples" */
export type Samples_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['Int']>;
  officeId?: InputMaybe<Scalars['Int']>;
  sampleShipmentId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "samples" */
export type Samples_Insert_Input = {
  analysisCertificates?: InputMaybe<Scalars['jsonb']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  commodityType?: InputMaybe<Scalars['String']>;
  compositionCertificates?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  item?: InputMaybe<Items_Obj_Rel_Insert_Input>;
  itemId?: InputMaybe<Scalars['Int']>;
  officeId?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Scalars['String']>;
  reminderForExpiration?: InputMaybe<Scalars['timestamptz']>;
  samplePictures?: InputMaybe<Scalars['jsonb']>;
  sampleShipment?: InputMaybe<SampleShipments_Obj_Rel_Insert_Input>;
  sampleShipmentId?: InputMaybe<Scalars['Int']>;
  sampledBy?: InputMaybe<Scalars['String']>;
  samplingDate?: InputMaybe<Scalars['timestamptz']>;
  shelf?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Samples_Max_Fields = {
  __typename?: 'samples_max_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  commodityType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['Int']>;
  officeId?: Maybe<Scalars['Int']>;
  ref?: Maybe<Scalars['String']>;
  reminderForExpiration?: Maybe<Scalars['timestamptz']>;
  sampleShipmentId?: Maybe<Scalars['Int']>;
  sampledBy?: Maybe<Scalars['String']>;
  samplingDate?: Maybe<Scalars['timestamptz']>;
  shelf?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "samples" */
export type Samples_Max_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  commodityType?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  ref?: InputMaybe<Order_By>;
  reminderForExpiration?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
  sampledBy?: InputMaybe<Order_By>;
  samplingDate?: InputMaybe<Order_By>;
  shelf?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Samples_Min_Fields = {
  __typename?: 'samples_min_fields';
  archivedAt?: Maybe<Scalars['timestamptz']>;
  commodityType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['Int']>;
  officeId?: Maybe<Scalars['Int']>;
  ref?: Maybe<Scalars['String']>;
  reminderForExpiration?: Maybe<Scalars['timestamptz']>;
  sampleShipmentId?: Maybe<Scalars['Int']>;
  sampledBy?: Maybe<Scalars['String']>;
  samplingDate?: Maybe<Scalars['timestamptz']>;
  shelf?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "samples" */
export type Samples_Min_Order_By = {
  archivedAt?: InputMaybe<Order_By>;
  commodityType?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  ref?: InputMaybe<Order_By>;
  reminderForExpiration?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
  sampledBy?: InputMaybe<Order_By>;
  samplingDate?: InputMaybe<Order_By>;
  shelf?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "samples" */
export type Samples_Mutation_Response = {
  __typename?: 'samples_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Samples>;
};

/** on_conflict condition type for table "samples" */
export type Samples_On_Conflict = {
  constraint: Samples_Constraint;
  update_columns?: Array<Samples_Update_Column>;
  where?: InputMaybe<Samples_Bool_Exp>;
};

/** Ordering options when selecting data from "samples". */
export type Samples_Order_By = {
  analysisCertificates?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  commodityType?: InputMaybe<Order_By>;
  compositionCertificates?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  item?: InputMaybe<Items_Order_By>;
  itemId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  ref?: InputMaybe<Order_By>;
  reminderForExpiration?: InputMaybe<Order_By>;
  samplePictures?: InputMaybe<Order_By>;
  sampleShipment?: InputMaybe<SampleShipments_Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
  sampledBy?: InputMaybe<Order_By>;
  samplingDate?: InputMaybe<Order_By>;
  shelf?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: samples */
export type Samples_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Samples_Prepend_Input = {
  analysisCertificates?: InputMaybe<Scalars['jsonb']>;
  compositionCertificates?: InputMaybe<Scalars['jsonb']>;
  samplePictures?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "samples" */
export enum Samples_Select_Column {
  /** column name */
  AnalysisCertificates = 'analysisCertificates',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  CommodityType = 'commodityType',
  /** column name */
  CompositionCertificates = 'compositionCertificates',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  ItemId = 'itemId',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  Ref = 'ref',
  /** column name */
  ReminderForExpiration = 'reminderForExpiration',
  /** column name */
  SamplePictures = 'samplePictures',
  /** column name */
  SampleShipmentId = 'sampleShipmentId',
  /** column name */
  SampledBy = 'sampledBy',
  /** column name */
  SamplingDate = 'samplingDate',
  /** column name */
  Shelf = 'shelf',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "samples" */
export type Samples_Set_Input = {
  analysisCertificates?: InputMaybe<Scalars['jsonb']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  commodityType?: InputMaybe<Scalars['String']>;
  compositionCertificates?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['Int']>;
  officeId?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Scalars['String']>;
  reminderForExpiration?: InputMaybe<Scalars['timestamptz']>;
  samplePictures?: InputMaybe<Scalars['jsonb']>;
  sampleShipmentId?: InputMaybe<Scalars['Int']>;
  sampledBy?: InputMaybe<Scalars['String']>;
  samplingDate?: InputMaybe<Scalars['timestamptz']>;
  shelf?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Samples_Stddev_Fields = {
  __typename?: 'samples_stddev_fields';
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  sampleShipmentId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "samples" */
export type Samples_Stddev_Order_By = {
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Samples_Stddev_Pop_Fields = {
  __typename?: 'samples_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  sampleShipmentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "samples" */
export type Samples_Stddev_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Samples_Stddev_Samp_Fields = {
  __typename?: 'samples_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  sampleShipmentId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "samples" */
export type Samples_Stddev_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "samples" */
export type Samples_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Samples_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Samples_Stream_Cursor_Value_Input = {
  analysisCertificates?: InputMaybe<Scalars['jsonb']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  commodityType?: InputMaybe<Scalars['String']>;
  compositionCertificates?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['Int']>;
  officeId?: InputMaybe<Scalars['Int']>;
  ref?: InputMaybe<Scalars['String']>;
  reminderForExpiration?: InputMaybe<Scalars['timestamptz']>;
  samplePictures?: InputMaybe<Scalars['jsonb']>;
  sampleShipmentId?: InputMaybe<Scalars['Int']>;
  sampledBy?: InputMaybe<Scalars['String']>;
  samplingDate?: InputMaybe<Scalars['timestamptz']>;
  shelf?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Samples_Sum_Fields = {
  __typename?: 'samples_sum_fields';
  id?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['Int']>;
  officeId?: Maybe<Scalars['Int']>;
  sampleShipmentId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "samples" */
export type Samples_Sum_Order_By = {
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** update columns of table "samples" */
export enum Samples_Update_Column {
  /** column name */
  AnalysisCertificates = 'analysisCertificates',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  CommodityType = 'commodityType',
  /** column name */
  CompositionCertificates = 'compositionCertificates',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Id = 'id',
  /** column name */
  ItemId = 'itemId',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  Ref = 'ref',
  /** column name */
  ReminderForExpiration = 'reminderForExpiration',
  /** column name */
  SamplePictures = 'samplePictures',
  /** column name */
  SampleShipmentId = 'sampleShipmentId',
  /** column name */
  SampledBy = 'sampledBy',
  /** column name */
  SamplingDate = 'samplingDate',
  /** column name */
  Shelf = 'shelf',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Samples_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Samples_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Samples_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Samples_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Samples_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Samples_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Samples_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Samples_Set_Input>;
  where: Samples_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Samples_Var_Pop_Fields = {
  __typename?: 'samples_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  sampleShipmentId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "samples" */
export type Samples_Var_Pop_Order_By = {
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Samples_Var_Samp_Fields = {
  __typename?: 'samples_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  sampleShipmentId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "samples" */
export type Samples_Var_Samp_Order_By = {
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Samples_Variance_Fields = {
  __typename?: 'samples_variance_fields';
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
  sampleShipmentId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "samples" */
export type Samples_Variance_Order_By = {
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  sampleShipmentId?: InputMaybe<Order_By>;
};

/** columns and relationships of "shipmentFulfillments" */
export type ShipmentFulfillments = {
  __typename?: 'shipmentFulfillments';
  /** An object relationship */
  agreement: Agreements;
  agreementId: Scalars['Int'];
  archivedAt?: Maybe<Scalars['timestamptz']>;
  comments?: Maybe<Scalars['String']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  files?: Maybe<Scalars['jsonb']>;
  id: Scalars['Int'];
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  /** An object relationship */
  item: Items;
  itemId: Scalars['Int'];
  quantity?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  uom?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "shipmentFulfillments" */
export type ShipmentFulfillmentsFilesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "shipmentFulfillments" */
export type ShipmentFulfillmentsInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "shipmentFulfillments" */
export type ShipmentFulfillmentsInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};

/** aggregated selection of "shipmentFulfillments" */
export type ShipmentFulfillments_Aggregate = {
  __typename?: 'shipmentFulfillments_aggregate';
  aggregate?: Maybe<ShipmentFulfillments_Aggregate_Fields>;
  nodes: Array<ShipmentFulfillments>;
};

export type ShipmentFulfillments_Aggregate_Bool_Exp = {
  count?: InputMaybe<ShipmentFulfillments_Aggregate_Bool_Exp_Count>;
};

export type ShipmentFulfillments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ShipmentFulfillments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ShipmentFulfillments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "shipmentFulfillments" */
export type ShipmentFulfillments_Aggregate_Fields = {
  __typename?: 'shipmentFulfillments_aggregate_fields';
  avg?: Maybe<ShipmentFulfillments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ShipmentFulfillments_Max_Fields>;
  min?: Maybe<ShipmentFulfillments_Min_Fields>;
  stddev?: Maybe<ShipmentFulfillments_Stddev_Fields>;
  stddev_pop?: Maybe<ShipmentFulfillments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ShipmentFulfillments_Stddev_Samp_Fields>;
  sum?: Maybe<ShipmentFulfillments_Sum_Fields>;
  var_pop?: Maybe<ShipmentFulfillments_Var_Pop_Fields>;
  var_samp?: Maybe<ShipmentFulfillments_Var_Samp_Fields>;
  variance?: Maybe<ShipmentFulfillments_Variance_Fields>;
};


/** aggregate fields of "shipmentFulfillments" */
export type ShipmentFulfillments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ShipmentFulfillments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "shipmentFulfillments" */
export type ShipmentFulfillments_Aggregate_Order_By = {
  avg?: InputMaybe<ShipmentFulfillments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ShipmentFulfillments_Max_Order_By>;
  min?: InputMaybe<ShipmentFulfillments_Min_Order_By>;
  stddev?: InputMaybe<ShipmentFulfillments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ShipmentFulfillments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ShipmentFulfillments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ShipmentFulfillments_Sum_Order_By>;
  var_pop?: InputMaybe<ShipmentFulfillments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ShipmentFulfillments_Var_Samp_Order_By>;
  variance?: InputMaybe<ShipmentFulfillments_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ShipmentFulfillments_Append_Input = {
  files?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "shipmentFulfillments" */
export type ShipmentFulfillments_Arr_Rel_Insert_Input = {
  data: Array<ShipmentFulfillments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ShipmentFulfillments_On_Conflict>;
};

/** aggregate avg on columns */
export type ShipmentFulfillments_Avg_Fields = {
  __typename?: 'shipmentFulfillments_avg_fields';
  agreementId?: Maybe<Scalars['Float']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "shipmentFulfillments" */
export type ShipmentFulfillments_Avg_Order_By = {
  agreementId?: InputMaybe<Order_By>;
  commissionAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "shipmentFulfillments". All fields are combined with a logical 'AND'. */
export type ShipmentFulfillments_Bool_Exp = {
  _and?: InputMaybe<Array<ShipmentFulfillments_Bool_Exp>>;
  _not?: InputMaybe<ShipmentFulfillments_Bool_Exp>;
  _or?: InputMaybe<Array<ShipmentFulfillments_Bool_Exp>>;
  agreement?: InputMaybe<Agreements_Bool_Exp>;
  agreementId?: InputMaybe<Int_Comparison_Exp>;
  archivedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  commissionAmount?: InputMaybe<Float_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  files?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  invoices?: InputMaybe<Invoices_Bool_Exp>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Bool_Exp>;
  item?: InputMaybe<Items_Bool_Exp>;
  itemId?: InputMaybe<Int_Comparison_Exp>;
  quantity?: InputMaybe<Float_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  uom?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "shipmentFulfillments" */
export enum ShipmentFulfillments_Constraint {
  /** unique or primary key constraint on columns "id" */
  ShipmentFulfillmentsPkey = 'shipmentFulfillments_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ShipmentFulfillments_Delete_At_Path_Input = {
  files?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ShipmentFulfillments_Delete_Elem_Input = {
  files?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ShipmentFulfillments_Delete_Key_Input = {
  files?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "shipmentFulfillments" */
export type ShipmentFulfillments_Inc_Input = {
  agreementId?: InputMaybe<Scalars['Int']>;
  commissionAmount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Float']>;
};

/** input type for inserting data into table "shipmentFulfillments" */
export type ShipmentFulfillments_Insert_Input = {
  agreement?: InputMaybe<Agreements_Obj_Rel_Insert_Input>;
  agreementId?: InputMaybe<Scalars['Int']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  comments?: InputMaybe<Scalars['String']>;
  commissionAmount?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  invoices?: InputMaybe<Invoices_Arr_Rel_Insert_Input>;
  item?: InputMaybe<Items_Obj_Rel_Insert_Input>;
  itemId?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  uom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ShipmentFulfillments_Max_Fields = {
  __typename?: 'shipmentFulfillments_max_fields';
  agreementId?: Maybe<Scalars['Int']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  comments?: Maybe<Scalars['String']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  uom?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "shipmentFulfillments" */
export type ShipmentFulfillments_Max_Order_By = {
  agreementId?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  commissionAmount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uom?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ShipmentFulfillments_Min_Fields = {
  __typename?: 'shipmentFulfillments_min_fields';
  agreementId?: Maybe<Scalars['Int']>;
  archivedAt?: Maybe<Scalars['timestamptz']>;
  comments?: Maybe<Scalars['String']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['timestamptz']>;
  deletedAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  uom?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "shipmentFulfillments" */
export type ShipmentFulfillments_Min_Order_By = {
  agreementId?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  commissionAmount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uom?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "shipmentFulfillments" */
export type ShipmentFulfillments_Mutation_Response = {
  __typename?: 'shipmentFulfillments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ShipmentFulfillments>;
};

/** input type for inserting object relation for remote table "shipmentFulfillments" */
export type ShipmentFulfillments_Obj_Rel_Insert_Input = {
  data: ShipmentFulfillments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<ShipmentFulfillments_On_Conflict>;
};

/** on_conflict condition type for table "shipmentFulfillments" */
export type ShipmentFulfillments_On_Conflict = {
  constraint: ShipmentFulfillments_Constraint;
  update_columns?: Array<ShipmentFulfillments_Update_Column>;
  where?: InputMaybe<ShipmentFulfillments_Bool_Exp>;
};

/** Ordering options when selecting data from "shipmentFulfillments". */
export type ShipmentFulfillments_Order_By = {
  agreement?: InputMaybe<Agreements_Order_By>;
  agreementId?: InputMaybe<Order_By>;
  archivedAt?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  commissionAmount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  deletedAt?: InputMaybe<Order_By>;
  files?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Order_By>;
  item?: InputMaybe<Items_Order_By>;
  itemId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  uom?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: shipmentFulfillments */
export type ShipmentFulfillments_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ShipmentFulfillments_Prepend_Input = {
  files?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "shipmentFulfillments" */
export enum ShipmentFulfillments_Select_Column {
  /** column name */
  AgreementId = 'agreementId',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  Comments = 'comments',
  /** column name */
  CommissionAmount = 'commissionAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Currency = 'currency',
  /** column name */
  Date = 'date',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Files = 'files',
  /** column name */
  Id = 'id',
  /** column name */
  ItemId = 'itemId',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Status = 'status',
  /** column name */
  Uom = 'uom',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "shipmentFulfillments" */
export type ShipmentFulfillments_Set_Input = {
  agreementId?: InputMaybe<Scalars['Int']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  comments?: InputMaybe<Scalars['String']>;
  commissionAmount?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  uom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ShipmentFulfillments_Stddev_Fields = {
  __typename?: 'shipmentFulfillments_stddev_fields';
  agreementId?: Maybe<Scalars['Float']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "shipmentFulfillments" */
export type ShipmentFulfillments_Stddev_Order_By = {
  agreementId?: InputMaybe<Order_By>;
  commissionAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ShipmentFulfillments_Stddev_Pop_Fields = {
  __typename?: 'shipmentFulfillments_stddev_pop_fields';
  agreementId?: Maybe<Scalars['Float']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "shipmentFulfillments" */
export type ShipmentFulfillments_Stddev_Pop_Order_By = {
  agreementId?: InputMaybe<Order_By>;
  commissionAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ShipmentFulfillments_Stddev_Samp_Fields = {
  __typename?: 'shipmentFulfillments_stddev_samp_fields';
  agreementId?: Maybe<Scalars['Float']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "shipmentFulfillments" */
export type ShipmentFulfillments_Stddev_Samp_Order_By = {
  agreementId?: InputMaybe<Order_By>;
  commissionAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "shipmentFulfillments" */
export type ShipmentFulfillments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ShipmentFulfillments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ShipmentFulfillments_Stream_Cursor_Value_Input = {
  agreementId?: InputMaybe<Scalars['Int']>;
  archivedAt?: InputMaybe<Scalars['timestamptz']>;
  comments?: InputMaybe<Scalars['String']>;
  commissionAmount?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['timestamptz']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']>;
  files?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['Int']>;
  itemId?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  uom?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ShipmentFulfillments_Sum_Fields = {
  __typename?: 'shipmentFulfillments_sum_fields';
  agreementId?: Maybe<Scalars['Int']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by sum() on columns of table "shipmentFulfillments" */
export type ShipmentFulfillments_Sum_Order_By = {
  agreementId?: InputMaybe<Order_By>;
  commissionAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** update columns of table "shipmentFulfillments" */
export enum ShipmentFulfillments_Update_Column {
  /** column name */
  AgreementId = 'agreementId',
  /** column name */
  ArchivedAt = 'archivedAt',
  /** column name */
  Comments = 'comments',
  /** column name */
  CommissionAmount = 'commissionAmount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Currency = 'currency',
  /** column name */
  Date = 'date',
  /** column name */
  DeletedAt = 'deletedAt',
  /** column name */
  Files = 'files',
  /** column name */
  Id = 'id',
  /** column name */
  ItemId = 'itemId',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Status = 'status',
  /** column name */
  Uom = 'uom',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ShipmentFulfillments_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ShipmentFulfillments_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ShipmentFulfillments_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ShipmentFulfillments_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ShipmentFulfillments_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ShipmentFulfillments_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ShipmentFulfillments_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ShipmentFulfillments_Set_Input>;
  where: ShipmentFulfillments_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ShipmentFulfillments_Var_Pop_Fields = {
  __typename?: 'shipmentFulfillments_var_pop_fields';
  agreementId?: Maybe<Scalars['Float']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "shipmentFulfillments" */
export type ShipmentFulfillments_Var_Pop_Order_By = {
  agreementId?: InputMaybe<Order_By>;
  commissionAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ShipmentFulfillments_Var_Samp_Fields = {
  __typename?: 'shipmentFulfillments_var_samp_fields';
  agreementId?: Maybe<Scalars['Float']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "shipmentFulfillments" */
export type ShipmentFulfillments_Var_Samp_Order_By = {
  agreementId?: InputMaybe<Order_By>;
  commissionAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ShipmentFulfillments_Variance_Fields = {
  __typename?: 'shipmentFulfillments_variance_fields';
  agreementId?: Maybe<Scalars['Float']>;
  commissionAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  itemId?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "shipmentFulfillments" */
export type ShipmentFulfillments_Variance_Order_By = {
  agreementId?: InputMaybe<Order_By>;
  commissionAmount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemId?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "addresses" */
  addresses: Array<Addresses>;
  /** fetch aggregated fields from the table: "addresses" */
  addresses_aggregate: Addresses_Aggregate;
  /** fetch data from the table: "addresses" using primary key columns */
  addresses_by_pk?: Maybe<Addresses>;
  /** fetch data from the table in a streaming manner: "addresses" */
  addresses_stream: Array<Addresses>;
  /** fetch data from the table: "addresses_without_company" */
  addresses_without_company: Array<Addresses_Without_Company>;
  /** fetch aggregated fields from the table: "addresses_without_company" */
  addresses_without_company_aggregate: Addresses_Without_Company_Aggregate;
  /** fetch data from the table in a streaming manner: "addresses_without_company" */
  addresses_without_company_stream: Array<Addresses_Without_Company>;
  /** fetch data from the table: "agreementTerms" */
  agreementTerms: Array<AgreementTerms>;
  /** fetch aggregated fields from the table: "agreementTerms" */
  agreementTerms_aggregate: AgreementTerms_Aggregate;
  /** fetch data from the table: "agreementTerms" using primary key columns */
  agreementTerms_by_pk?: Maybe<AgreementTerms>;
  /** fetch data from the table in a streaming manner: "agreementTerms" */
  agreementTerms_stream: Array<AgreementTerms>;
  /** fetch data from the table: "agreements" */
  agreements: Array<Agreements>;
  /** fetch aggregated fields from the table: "agreements" */
  agreements_aggregate: Agreements_Aggregate;
  /** fetch data from the table: "agreements" using primary key columns */
  agreements_by_pk?: Maybe<Agreements>;
  /** fetch data from the table in a streaming manner: "agreements" */
  agreements_stream: Array<Agreements>;
  /** fetch data from the table: "appellations" */
  appellations: Array<Appellations>;
  /** fetch aggregated fields from the table: "appellations" */
  appellations_aggregate: Appellations_Aggregate;
  /** fetch data from the table: "appellations" using primary key columns */
  appellations_by_pk?: Maybe<Appellations>;
  /** fetch data from the table in a streaming manner: "appellations" */
  appellations_stream: Array<Appellations>;
  /** fetch data from the table: "authorizedDomains" */
  authorizedDomains: Array<AuthorizedDomains>;
  /** fetch aggregated fields from the table: "authorizedDomains" */
  authorizedDomains_aggregate: AuthorizedDomains_Aggregate;
  /** fetch data from the table: "authorizedDomains" using primary key columns */
  authorizedDomains_by_pk?: Maybe<AuthorizedDomains>;
  /** fetch data from the table in a streaming manner: "authorizedDomains" */
  authorizedDomains_stream: Array<AuthorizedDomains>;
  /** fetch data from the table: "buySpecs" */
  buySpecs: Array<BuySpecs>;
  /** fetch aggregated fields from the table: "buySpecs" */
  buySpecs_aggregate: BuySpecs_Aggregate;
  /** fetch data from the table: "buySpecs" using primary key columns */
  buySpecs_by_pk?: Maybe<BuySpecs>;
  /** fetch data from the table in a streaming manner: "buySpecs" */
  buySpecs_stream: Array<BuySpecs>;
  /** fetch data from the table: "companies" */
  companies: Array<Companies>;
  /** fetch aggregated fields from the table: "companies" */
  companies_aggregate: Companies_Aggregate;
  /** fetch data from the table: "companies" using primary key columns */
  companies_by_pk?: Maybe<Companies>;
  /** fetch data from the table in a streaming manner: "companies" */
  companies_stream: Array<Companies>;
  /** fetch data from the table: "companyAddress" */
  companyAddress: Array<CompanyAddress>;
  /** fetch aggregated fields from the table: "companyAddress" */
  companyAddress_aggregate: CompanyAddress_Aggregate;
  /** fetch data from the table: "companyAddress" using primary key columns */
  companyAddress_by_pk?: Maybe<CompanyAddress>;
  /** fetch data from the table in a streaming manner: "companyAddress" */
  companyAddress_stream: Array<CompanyAddress>;
  /** fetch data from the table: "contacts" */
  contacts: Array<Contacts>;
  /** fetch aggregated fields from the table: "contacts" */
  contacts_aggregate: Contacts_Aggregate;
  /** fetch data from the table: "contacts" using primary key columns */
  contacts_by_pk?: Maybe<Contacts>;
  /** fetch data from the table in a streaming manner: "contacts" */
  contacts_stream: Array<Contacts>;
  /** fetch data from the table: "contacts_without_company" */
  contacts_without_company: Array<Contacts_Without_Company>;
  /** fetch aggregated fields from the table: "contacts_without_company" */
  contacts_without_company_aggregate: Contacts_Without_Company_Aggregate;
  /** fetch data from the table in a streaming manner: "contacts_without_company" */
  contacts_without_company_stream: Array<Contacts_Without_Company>;
  /** fetch data from the table: "contracts" */
  contracts: Array<Contracts>;
  /** fetch aggregated fields from the table: "contracts" */
  contracts_aggregate: Contracts_Aggregate;
  /** fetch data from the table: "contracts" using primary key columns */
  contracts_by_pk?: Maybe<Contracts>;
  /** fetch data from the table in a streaming manner: "contracts" */
  contracts_stream: Array<Contracts>;
  /** fetch data from the table: "currenciesConversions" */
  currenciesConversions: Array<CurrenciesConversions>;
  /** fetch aggregated fields from the table: "currenciesConversions" */
  currenciesConversions_aggregate: CurrenciesConversions_Aggregate;
  /** fetch data from the table: "currenciesConversions" using primary key columns */
  currenciesConversions_by_pk?: Maybe<CurrenciesConversions>;
  /** fetch data from the table in a streaming manner: "currenciesConversions" */
  currenciesConversions_stream: Array<CurrenciesConversions>;
  /** fetch data from the table: "history" */
  history: Array<History>;
  /** fetch aggregated fields from the table: "history" */
  history_aggregate: History_Aggregate;
  /** fetch data from the table: "history" using primary key columns */
  history_by_pk?: Maybe<History>;
  /** fetch data from the table in a streaming manner: "history" */
  history_stream: Array<History>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoices_by_pk?: Maybe<Invoices>;
  /** fetch data from the table in a streaming manner: "invoices" */
  invoices_stream: Array<Invoices>;
  /** fetch data from the table: "items" */
  items: Array<Items>;
  /** fetch aggregated fields from the table: "items" */
  items_aggregate: Items_Aggregate;
  /** fetch data from the table: "items" using primary key columns */
  items_by_pk?: Maybe<Items>;
  /** fetch data from the table in a streaming manner: "items" */
  items_stream: Array<Items>;
  /** fetch data from the table: "logs" */
  logs: Array<Logs>;
  /** fetch aggregated fields from the table: "logs" */
  logs_aggregate: Logs_Aggregate;
  /** fetch data from the table: "logs" using primary key columns */
  logs_by_pk?: Maybe<Logs>;
  /** fetch data from the table in a streaming manner: "logs" */
  logs_stream: Array<Logs>;
  /** An array relationship */
  matchingItemsBuySpecs: Array<MatchingItemsBuySpecs>;
  /** An aggregate relationship */
  matchingItemsBuySpecs_aggregate: MatchingItemsBuySpecs_Aggregate;
  /** fetch data from the table: "matchingItemsBuySpecs" using primary key columns */
  matchingItemsBuySpecs_by_pk?: Maybe<MatchingItemsBuySpecs>;
  /** fetch data from the table in a streaming manner: "matchingItemsBuySpecs" */
  matchingItemsBuySpecs_stream: Array<MatchingItemsBuySpecs>;
  /** fetch data from the table: "notifications" */
  notifications: Array<Notifications>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: Notifications_Aggregate;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: Maybe<Notifications>;
  /** fetch data from the table in a streaming manner: "notifications" */
  notifications_stream: Array<Notifications>;
  /** fetch data from the table: "offices" */
  offices: Array<Offices>;
  /** fetch aggregated fields from the table: "offices" */
  offices_aggregate: Offices_Aggregate;
  /** fetch data from the table: "offices" using primary key columns */
  offices_by_pk?: Maybe<Offices>;
  /** fetch data from the table in a streaming manner: "offices" */
  offices_stream: Array<Offices>;
  /** fetch data from the table: "releases" */
  releases: Array<Releases>;
  /** fetch aggregated fields from the table: "releases" */
  releases_aggregate: Releases_Aggregate;
  /** fetch data from the table: "releases" using primary key columns */
  releases_by_pk?: Maybe<Releases>;
  /** fetch data from the table in a streaming manner: "releases" */
  releases_stream: Array<Releases>;
  /** fetch data from the table: "reminders" */
  reminders: Array<Reminders>;
  /** fetch aggregated fields from the table: "reminders" */
  reminders_aggregate: Reminders_Aggregate;
  /** fetch data from the table: "reminders" using primary key columns */
  reminders_by_pk?: Maybe<Reminders>;
  /** fetch data from the table in a streaming manner: "reminders" */
  reminders_stream: Array<Reminders>;
  /** fetch data from the table: "sampleLabels" */
  sampleLabels: Array<SampleLabels>;
  /** fetch aggregated fields from the table: "sampleLabels" */
  sampleLabels_aggregate: SampleLabels_Aggregate;
  /** fetch data from the table: "sampleLabels" using primary key columns */
  sampleLabels_by_pk?: Maybe<SampleLabels>;
  /** fetch data from the table in a streaming manner: "sampleLabels" */
  sampleLabels_stream: Array<SampleLabels>;
  /** An array relationship */
  sampleShipmentRequests: Array<SampleShipmentRequests>;
  /** An aggregate relationship */
  sampleShipmentRequests_aggregate: SampleShipmentRequests_Aggregate;
  /** fetch data from the table: "sampleShipmentRequests" using primary key columns */
  sampleShipmentRequests_by_pk?: Maybe<SampleShipmentRequests>;
  /** fetch data from the table in a streaming manner: "sampleShipmentRequests" */
  sampleShipmentRequests_stream: Array<SampleShipmentRequests>;
  /** fetch data from the table: "sampleShipments" */
  sampleShipments: Array<SampleShipments>;
  /** fetch aggregated fields from the table: "sampleShipments" */
  sampleShipments_aggregate: SampleShipments_Aggregate;
  /** fetch data from the table: "sampleShipments" using primary key columns */
  sampleShipments_by_pk?: Maybe<SampleShipments>;
  /** fetch data from the table in a streaming manner: "sampleShipments" */
  sampleShipments_stream: Array<SampleShipments>;
  /** An array relationship */
  samples: Array<Samples>;
  /** An aggregate relationship */
  samples_aggregate: Samples_Aggregate;
  /** fetch data from the table: "samples" using primary key columns */
  samples_by_pk?: Maybe<Samples>;
  /** fetch data from the table in a streaming manner: "samples" */
  samples_stream: Array<Samples>;
  /** An array relationship */
  shipmentFulfillments: Array<ShipmentFulfillments>;
  /** An aggregate relationship */
  shipmentFulfillments_aggregate: ShipmentFulfillments_Aggregate;
  /** fetch data from the table: "shipmentFulfillments" using primary key columns */
  shipmentFulfillments_by_pk?: Maybe<ShipmentFulfillments>;
  /** fetch data from the table in a streaming manner: "shipmentFulfillments" */
  shipmentFulfillments_stream: Array<ShipmentFulfillments>;
  /** fetch data from the table: "trackings" */
  trackings: Array<Trackings>;
  /** fetch aggregated fields from the table: "trackings" */
  trackings_aggregate: Trackings_Aggregate;
  /** fetch data from the table: "trackings" using primary key columns */
  trackings_by_pk?: Maybe<Trackings>;
  /** fetch data from the table in a streaming manner: "trackings" */
  trackings_stream: Array<Trackings>;
  /** An array relationship */
  users: Array<Users>;
  /** An array relationship */
  usersBonus: Array<UsersBonus>;
  /** An aggregate relationship */
  usersBonus_aggregate: UsersBonus_Aggregate;
  /** fetch data from the table: "usersBonus" using primary key columns */
  usersBonus_by_pk?: Maybe<UsersBonus>;
  /** fetch data from the table in a streaming manner: "usersBonus" */
  usersBonus_stream: Array<UsersBonus>;
  /** An array relationship */
  usersCosts: Array<UsersCosts>;
  /** An aggregate relationship */
  usersCosts_aggregate: UsersCosts_Aggregate;
  /** fetch data from the table: "usersCosts" using primary key columns */
  usersCosts_by_pk?: Maybe<UsersCosts>;
  /** fetch data from the table in a streaming manner: "usersCosts" */
  usersCosts_stream: Array<UsersCosts>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** An array relationship */
  validationsContracts: Array<ValidationsContracts>;
  /** An aggregate relationship */
  validationsContracts_aggregate: ValidationsContracts_Aggregate;
  /** fetch data from the table: "validationsContracts" using primary key columns */
  validationsContracts_by_pk?: Maybe<ValidationsContracts>;
  /** fetch data from the table in a streaming manner: "validationsContracts" */
  validationsContracts_stream: Array<ValidationsContracts>;
  /** fetch data from the table: "varietals" */
  varietals: Array<Varietals>;
  /** fetch aggregated fields from the table: "varietals" */
  varietals_aggregate: Varietals_Aggregate;
  /** fetch data from the table: "varietals" using primary key columns */
  varietals_by_pk?: Maybe<Varietals>;
  /** fetch data from the table in a streaming manner: "varietals" */
  varietals_stream: Array<Varietals>;
};


export type Subscription_RootAddressesArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAddresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Order_By>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAddresses_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAddresses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Addresses_Stream_Cursor_Input>>;
  where?: InputMaybe<Addresses_Bool_Exp>;
};


export type Subscription_RootAddresses_Without_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Without_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Without_Company_Order_By>>;
  where?: InputMaybe<Addresses_Without_Company_Bool_Exp>;
};


export type Subscription_RootAddresses_Without_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Addresses_Without_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Addresses_Without_Company_Order_By>>;
  where?: InputMaybe<Addresses_Without_Company_Bool_Exp>;
};


export type Subscription_RootAddresses_Without_Company_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Addresses_Without_Company_Stream_Cursor_Input>>;
  where?: InputMaybe<Addresses_Without_Company_Bool_Exp>;
};


export type Subscription_RootAgreementTermsArgs = {
  distinct_on?: InputMaybe<Array<AgreementTerms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgreementTerms_Order_By>>;
  where?: InputMaybe<AgreementTerms_Bool_Exp>;
};


export type Subscription_RootAgreementTerms_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AgreementTerms_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AgreementTerms_Order_By>>;
  where?: InputMaybe<AgreementTerms_Bool_Exp>;
};


export type Subscription_RootAgreementTerms_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgreementTerms_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AgreementTerms_Stream_Cursor_Input>>;
  where?: InputMaybe<AgreementTerms_Bool_Exp>;
};


export type Subscription_RootAgreementsArgs = {
  distinct_on?: InputMaybe<Array<Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreements_Order_By>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


export type Subscription_RootAgreements_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Agreements_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Agreements_Order_By>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


export type Subscription_RootAgreements_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAgreements_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Agreements_Stream_Cursor_Input>>;
  where?: InputMaybe<Agreements_Bool_Exp>;
};


export type Subscription_RootAppellationsArgs = {
  distinct_on?: InputMaybe<Array<Appellations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appellations_Order_By>>;
  where?: InputMaybe<Appellations_Bool_Exp>;
};


export type Subscription_RootAppellations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Appellations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Appellations_Order_By>>;
  where?: InputMaybe<Appellations_Bool_Exp>;
};


export type Subscription_RootAppellations_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAppellations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Appellations_Stream_Cursor_Input>>;
  where?: InputMaybe<Appellations_Bool_Exp>;
};


export type Subscription_RootAuthorizedDomainsArgs = {
  distinct_on?: InputMaybe<Array<AuthorizedDomains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthorizedDomains_Order_By>>;
  where?: InputMaybe<AuthorizedDomains_Bool_Exp>;
};


export type Subscription_RootAuthorizedDomains_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthorizedDomains_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthorizedDomains_Order_By>>;
  where?: InputMaybe<AuthorizedDomains_Bool_Exp>;
};


export type Subscription_RootAuthorizedDomains_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootAuthorizedDomains_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthorizedDomains_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthorizedDomains_Bool_Exp>;
};


export type Subscription_RootBuySpecsArgs = {
  distinct_on?: InputMaybe<Array<BuySpecs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BuySpecs_Order_By>>;
  where?: InputMaybe<BuySpecs_Bool_Exp>;
};


export type Subscription_RootBuySpecs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<BuySpecs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<BuySpecs_Order_By>>;
  where?: InputMaybe<BuySpecs_Bool_Exp>;
};


export type Subscription_RootBuySpecs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootBuySpecs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<BuySpecs_Stream_Cursor_Input>>;
  where?: InputMaybe<BuySpecs_Bool_Exp>;
};


export type Subscription_RootCompaniesArgs = {
  distinct_on?: InputMaybe<Array<Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Companies_Order_By>>;
  where?: InputMaybe<Companies_Bool_Exp>;
};


export type Subscription_RootCompanies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Companies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Companies_Order_By>>;
  where?: InputMaybe<Companies_Bool_Exp>;
};


export type Subscription_RootCompanies_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompanies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Companies_Stream_Cursor_Input>>;
  where?: InputMaybe<Companies_Bool_Exp>;
};


export type Subscription_RootCompanyAddressArgs = {
  distinct_on?: InputMaybe<Array<CompanyAddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyAddress_Order_By>>;
  where?: InputMaybe<CompanyAddress_Bool_Exp>;
};


export type Subscription_RootCompanyAddress_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CompanyAddress_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CompanyAddress_Order_By>>;
  where?: InputMaybe<CompanyAddress_Bool_Exp>;
};


export type Subscription_RootCompanyAddress_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCompanyAddress_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CompanyAddress_Stream_Cursor_Input>>;
  where?: InputMaybe<CompanyAddress_Bool_Exp>;
};


export type Subscription_RootContactsArgs = {
  distinct_on?: InputMaybe<Array<Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contacts_Order_By>>;
  where?: InputMaybe<Contacts_Bool_Exp>;
};


export type Subscription_RootContacts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contacts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contacts_Order_By>>;
  where?: InputMaybe<Contacts_Bool_Exp>;
};


export type Subscription_RootContacts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootContacts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Contacts_Stream_Cursor_Input>>;
  where?: InputMaybe<Contacts_Bool_Exp>;
};


export type Subscription_RootContacts_Without_CompanyArgs = {
  distinct_on?: InputMaybe<Array<Contacts_Without_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contacts_Without_Company_Order_By>>;
  where?: InputMaybe<Contacts_Without_Company_Bool_Exp>;
};


export type Subscription_RootContacts_Without_Company_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contacts_Without_Company_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contacts_Without_Company_Order_By>>;
  where?: InputMaybe<Contacts_Without_Company_Bool_Exp>;
};


export type Subscription_RootContacts_Without_Company_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Contacts_Without_Company_Stream_Cursor_Input>>;
  where?: InputMaybe<Contacts_Without_Company_Bool_Exp>;
};


export type Subscription_RootContractsArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contracts_Order_By>>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};


export type Subscription_RootContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Contracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Contracts_Order_By>>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};


export type Subscription_RootContracts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootContracts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Contracts_Stream_Cursor_Input>>;
  where?: InputMaybe<Contracts_Bool_Exp>;
};


export type Subscription_RootCurrenciesConversionsArgs = {
  distinct_on?: InputMaybe<Array<CurrenciesConversions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CurrenciesConversions_Order_By>>;
  where?: InputMaybe<CurrenciesConversions_Bool_Exp>;
};


export type Subscription_RootCurrenciesConversions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<CurrenciesConversions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CurrenciesConversions_Order_By>>;
  where?: InputMaybe<CurrenciesConversions_Bool_Exp>;
};


export type Subscription_RootCurrenciesConversions_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCurrenciesConversions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CurrenciesConversions_Stream_Cursor_Input>>;
  where?: InputMaybe<CurrenciesConversions_Bool_Exp>;
};


export type Subscription_RootHistoryArgs = {
  distinct_on?: InputMaybe<Array<History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<History_Order_By>>;
  where?: InputMaybe<History_Bool_Exp>;
};


export type Subscription_RootHistory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<History_Order_By>>;
  where?: InputMaybe<History_Bool_Exp>;
};


export type Subscription_RootHistory_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootHistory_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<History_Stream_Cursor_Input>>;
  where?: InputMaybe<History_Bool_Exp>;
};


export type Subscription_RootInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Subscription_RootInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Subscription_RootInvoices_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootInvoices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Invoices_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Subscription_RootItemsArgs = {
  distinct_on?: InputMaybe<Array<Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Items_Order_By>>;
  where?: InputMaybe<Items_Bool_Exp>;
};


export type Subscription_RootItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Items_Order_By>>;
  where?: InputMaybe<Items_Bool_Exp>;
};


export type Subscription_RootItems_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootItems_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Items_Stream_Cursor_Input>>;
  where?: InputMaybe<Items_Bool_Exp>;
};


export type Subscription_RootLogsArgs = {
  distinct_on?: InputMaybe<Array<Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Logs_Order_By>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


export type Subscription_RootLogs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Logs_Order_By>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


export type Subscription_RootLogs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootLogs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Logs_Bool_Exp>;
};


export type Subscription_RootMatchingItemsBuySpecsArgs = {
  distinct_on?: InputMaybe<Array<MatchingItemsBuySpecs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MatchingItemsBuySpecs_Order_By>>;
  where?: InputMaybe<MatchingItemsBuySpecs_Bool_Exp>;
};


export type Subscription_RootMatchingItemsBuySpecs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<MatchingItemsBuySpecs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MatchingItemsBuySpecs_Order_By>>;
  where?: InputMaybe<MatchingItemsBuySpecs_Bool_Exp>;
};


export type Subscription_RootMatchingItemsBuySpecs_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootMatchingItemsBuySpecs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MatchingItemsBuySpecs_Stream_Cursor_Input>>;
  where?: InputMaybe<MatchingItemsBuySpecs_Bool_Exp>;
};


export type Subscription_RootNotificationsArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notifications_Order_By>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootNotifications_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootNotifications_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Notifications_Bool_Exp>;
};


export type Subscription_RootOfficesArgs = {
  distinct_on?: InputMaybe<Array<Offices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offices_Order_By>>;
  where?: InputMaybe<Offices_Bool_Exp>;
};


export type Subscription_RootOffices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Offices_Order_By>>;
  where?: InputMaybe<Offices_Bool_Exp>;
};


export type Subscription_RootOffices_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootOffices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Offices_Stream_Cursor_Input>>;
  where?: InputMaybe<Offices_Bool_Exp>;
};


export type Subscription_RootReleasesArgs = {
  distinct_on?: InputMaybe<Array<Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Releases_Order_By>>;
  where?: InputMaybe<Releases_Bool_Exp>;
};


export type Subscription_RootReleases_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Releases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Releases_Order_By>>;
  where?: InputMaybe<Releases_Bool_Exp>;
};


export type Subscription_RootReleases_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootReleases_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Releases_Stream_Cursor_Input>>;
  where?: InputMaybe<Releases_Bool_Exp>;
};


export type Subscription_RootRemindersArgs = {
  distinct_on?: InputMaybe<Array<Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reminders_Order_By>>;
  where?: InputMaybe<Reminders_Bool_Exp>;
};


export type Subscription_RootReminders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reminders_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Reminders_Order_By>>;
  where?: InputMaybe<Reminders_Bool_Exp>;
};


export type Subscription_RootReminders_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootReminders_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Reminders_Stream_Cursor_Input>>;
  where?: InputMaybe<Reminders_Bool_Exp>;
};


export type Subscription_RootSampleLabelsArgs = {
  distinct_on?: InputMaybe<Array<SampleLabels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleLabels_Order_By>>;
  where?: InputMaybe<SampleLabels_Bool_Exp>;
};


export type Subscription_RootSampleLabels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SampleLabels_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleLabels_Order_By>>;
  where?: InputMaybe<SampleLabels_Bool_Exp>;
};


export type Subscription_RootSampleLabels_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSampleLabels_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SampleLabels_Stream_Cursor_Input>>;
  where?: InputMaybe<SampleLabels_Bool_Exp>;
};


export type Subscription_RootSampleShipmentRequestsArgs = {
  distinct_on?: InputMaybe<Array<SampleShipmentRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleShipmentRequests_Order_By>>;
  where?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
};


export type Subscription_RootSampleShipmentRequests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SampleShipmentRequests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleShipmentRequests_Order_By>>;
  where?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
};


export type Subscription_RootSampleShipmentRequests_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSampleShipmentRequests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SampleShipmentRequests_Stream_Cursor_Input>>;
  where?: InputMaybe<SampleShipmentRequests_Bool_Exp>;
};


export type Subscription_RootSampleShipmentsArgs = {
  distinct_on?: InputMaybe<Array<SampleShipments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleShipments_Order_By>>;
  where?: InputMaybe<SampleShipments_Bool_Exp>;
};


export type Subscription_RootSampleShipments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SampleShipments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SampleShipments_Order_By>>;
  where?: InputMaybe<SampleShipments_Bool_Exp>;
};


export type Subscription_RootSampleShipments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSampleShipments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SampleShipments_Stream_Cursor_Input>>;
  where?: InputMaybe<SampleShipments_Bool_Exp>;
};


export type Subscription_RootSamplesArgs = {
  distinct_on?: InputMaybe<Array<Samples_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Samples_Order_By>>;
  where?: InputMaybe<Samples_Bool_Exp>;
};


export type Subscription_RootSamples_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Samples_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Samples_Order_By>>;
  where?: InputMaybe<Samples_Bool_Exp>;
};


export type Subscription_RootSamples_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootSamples_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Samples_Stream_Cursor_Input>>;
  where?: InputMaybe<Samples_Bool_Exp>;
};


export type Subscription_RootShipmentFulfillmentsArgs = {
  distinct_on?: InputMaybe<Array<ShipmentFulfillments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShipmentFulfillments_Order_By>>;
  where?: InputMaybe<ShipmentFulfillments_Bool_Exp>;
};


export type Subscription_RootShipmentFulfillments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ShipmentFulfillments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ShipmentFulfillments_Order_By>>;
  where?: InputMaybe<ShipmentFulfillments_Bool_Exp>;
};


export type Subscription_RootShipmentFulfillments_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootShipmentFulfillments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ShipmentFulfillments_Stream_Cursor_Input>>;
  where?: InputMaybe<ShipmentFulfillments_Bool_Exp>;
};


export type Subscription_RootTrackingsArgs = {
  distinct_on?: InputMaybe<Array<Trackings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trackings_Order_By>>;
  where?: InputMaybe<Trackings_Bool_Exp>;
};


export type Subscription_RootTrackings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trackings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trackings_Order_By>>;
  where?: InputMaybe<Trackings_Bool_Exp>;
};


export type Subscription_RootTrackings_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootTrackings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trackings_Stream_Cursor_Input>>;
  where?: InputMaybe<Trackings_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsersBonusArgs = {
  distinct_on?: InputMaybe<Array<UsersBonus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersBonus_Order_By>>;
  where?: InputMaybe<UsersBonus_Bool_Exp>;
};


export type Subscription_RootUsersBonus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersBonus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersBonus_Order_By>>;
  where?: InputMaybe<UsersBonus_Bool_Exp>;
};


export type Subscription_RootUsersBonus_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUsersBonus_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UsersBonus_Stream_Cursor_Input>>;
  where?: InputMaybe<UsersBonus_Bool_Exp>;
};


export type Subscription_RootUsersCostsArgs = {
  distinct_on?: InputMaybe<Array<UsersCosts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersCosts_Order_By>>;
  where?: InputMaybe<UsersCosts_Bool_Exp>;
};


export type Subscription_RootUsersCosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersCosts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersCosts_Order_By>>;
  where?: InputMaybe<UsersCosts_Bool_Exp>;
};


export type Subscription_RootUsersCosts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootUsersCosts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UsersCosts_Stream_Cursor_Input>>;
  where?: InputMaybe<UsersCosts_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootValidationsContractsArgs = {
  distinct_on?: InputMaybe<Array<ValidationsContracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationsContracts_Order_By>>;
  where?: InputMaybe<ValidationsContracts_Bool_Exp>;
};


export type Subscription_RootValidationsContracts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ValidationsContracts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ValidationsContracts_Order_By>>;
  where?: InputMaybe<ValidationsContracts_Bool_Exp>;
};


export type Subscription_RootValidationsContracts_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootValidationsContracts_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ValidationsContracts_Stream_Cursor_Input>>;
  where?: InputMaybe<ValidationsContracts_Bool_Exp>;
};


export type Subscription_RootVarietalsArgs = {
  distinct_on?: InputMaybe<Array<Varietals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Varietals_Order_By>>;
  where?: InputMaybe<Varietals_Bool_Exp>;
};


export type Subscription_RootVarietals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Varietals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Varietals_Order_By>>;
  where?: InputMaybe<Varietals_Bool_Exp>;
};


export type Subscription_RootVarietals_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootVarietals_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Varietals_Stream_Cursor_Input>>;
  where?: InputMaybe<Varietals_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "trackings" */
export type Trackings = {
  __typename?: 'trackings';
  aftershipId: Scalars['String'];
  deliveryDate?: Maybe<Scalars['timestamptz']>;
  id: Scalars['Int'];
  pickupDate?: Maybe<Scalars['timestamptz']>;
  res?: Maybe<Scalars['jsonb']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trackingNumber: Scalars['String'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "trackings" */
export type TrackingsResArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "trackings" */
export type Trackings_Aggregate = {
  __typename?: 'trackings_aggregate';
  aggregate?: Maybe<Trackings_Aggregate_Fields>;
  nodes: Array<Trackings>;
};

/** aggregate fields of "trackings" */
export type Trackings_Aggregate_Fields = {
  __typename?: 'trackings_aggregate_fields';
  avg?: Maybe<Trackings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Trackings_Max_Fields>;
  min?: Maybe<Trackings_Min_Fields>;
  stddev?: Maybe<Trackings_Stddev_Fields>;
  stddev_pop?: Maybe<Trackings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Trackings_Stddev_Samp_Fields>;
  sum?: Maybe<Trackings_Sum_Fields>;
  var_pop?: Maybe<Trackings_Var_Pop_Fields>;
  var_samp?: Maybe<Trackings_Var_Samp_Fields>;
  variance?: Maybe<Trackings_Variance_Fields>;
};


/** aggregate fields of "trackings" */
export type Trackings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trackings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Trackings_Append_Input = {
  res?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Trackings_Avg_Fields = {
  __typename?: 'trackings_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "trackings". All fields are combined with a logical 'AND'. */
export type Trackings_Bool_Exp = {
  _and?: InputMaybe<Array<Trackings_Bool_Exp>>;
  _not?: InputMaybe<Trackings_Bool_Exp>;
  _or?: InputMaybe<Array<Trackings_Bool_Exp>>;
  aftershipId?: InputMaybe<String_Comparison_Exp>;
  deliveryDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  pickupDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  res?: InputMaybe<Jsonb_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  trackingNumber?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "trackings" */
export enum Trackings_Constraint {
  /** unique or primary key constraint on columns "aftershipId" */
  TrackingsAftershipIdKey = 'trackings_aftershipId_key',
  /** unique or primary key constraint on columns "id" */
  TrackingsPkey = 'trackings_pkey',
  /** unique or primary key constraint on columns "trackingNumber" */
  TrackingsTrackingIdKey = 'trackings_trackingId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Trackings_Delete_At_Path_Input = {
  res?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Trackings_Delete_Elem_Input = {
  res?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Trackings_Delete_Key_Input = {
  res?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "trackings" */
export type Trackings_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "trackings" */
export type Trackings_Insert_Input = {
  aftershipId?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  pickupDate?: InputMaybe<Scalars['timestamptz']>;
  res?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Trackings_Max_Fields = {
  __typename?: 'trackings_max_fields';
  aftershipId?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  pickupDate?: Maybe<Scalars['timestamptz']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Trackings_Min_Fields = {
  __typename?: 'trackings_min_fields';
  aftershipId?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['Int']>;
  pickupDate?: Maybe<Scalars['timestamptz']>;
  slug?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "trackings" */
export type Trackings_Mutation_Response = {
  __typename?: 'trackings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trackings>;
};

/** on_conflict condition type for table "trackings" */
export type Trackings_On_Conflict = {
  constraint: Trackings_Constraint;
  update_columns?: Array<Trackings_Update_Column>;
  where?: InputMaybe<Trackings_Bool_Exp>;
};

/** Ordering options when selecting data from "trackings". */
export type Trackings_Order_By = {
  aftershipId?: InputMaybe<Order_By>;
  deliveryDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  pickupDate?: InputMaybe<Order_By>;
  res?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  trackingNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trackings */
export type Trackings_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Trackings_Prepend_Input = {
  res?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "trackings" */
export enum Trackings_Select_Column {
  /** column name */
  AftershipId = 'aftershipId',
  /** column name */
  DeliveryDate = 'deliveryDate',
  /** column name */
  Id = 'id',
  /** column name */
  PickupDate = 'pickupDate',
  /** column name */
  Res = 'res',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  TrackingNumber = 'trackingNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "trackings" */
export type Trackings_Set_Input = {
  aftershipId?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  pickupDate?: InputMaybe<Scalars['timestamptz']>;
  res?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Trackings_Stddev_Fields = {
  __typename?: 'trackings_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Trackings_Stddev_Pop_Fields = {
  __typename?: 'trackings_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Trackings_Stddev_Samp_Fields = {
  __typename?: 'trackings_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "trackings" */
export type Trackings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trackings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trackings_Stream_Cursor_Value_Input = {
  aftershipId?: InputMaybe<Scalars['String']>;
  deliveryDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['Int']>;
  pickupDate?: InputMaybe<Scalars['timestamptz']>;
  res?: InputMaybe<Scalars['jsonb']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  trackingNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Trackings_Sum_Fields = {
  __typename?: 'trackings_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "trackings" */
export enum Trackings_Update_Column {
  /** column name */
  AftershipId = 'aftershipId',
  /** column name */
  DeliveryDate = 'deliveryDate',
  /** column name */
  Id = 'id',
  /** column name */
  PickupDate = 'pickupDate',
  /** column name */
  Res = 'res',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  TrackingNumber = 'trackingNumber',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Trackings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Trackings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Trackings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Trackings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Trackings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Trackings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Trackings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trackings_Set_Input>;
  where: Trackings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Trackings_Var_Pop_Fields = {
  __typename?: 'trackings_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Trackings_Var_Samp_Fields = {
  __typename?: 'trackings_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Trackings_Variance_Fields = {
  __typename?: 'trackings_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  authorizedDomainId?: Maybe<Scalars['Int']>;
  /** An object relationship */
  contact?: Maybe<Contacts>;
  contactId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  firstname: Scalars['String'];
  id: Scalars['String'];
  isAdmin: Scalars['Boolean'];
  isManager: Scalars['Boolean'];
  language: Scalars['String'];
  lastReleasesViewDate?: Maybe<Scalars['timestamptz']>;
  lastname: Scalars['String'];
  officeId?: Maybe<Scalars['Int']>;
  role: Scalars['String'];
  savedColumns: Scalars['jsonb'];
  savedFormFields: Scalars['jsonb'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  usersBonus: Array<UsersBonus>;
  /** An aggregate relationship */
  usersBonus_aggregate: UsersBonus_Aggregate;
  /** An array relationship */
  usersCosts: Array<UsersCosts>;
  /** An aggregate relationship */
  usersCosts_aggregate: UsersCosts_Aggregate;
};


/** columns and relationships of "users" */
export type UsersSavedColumnsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersSavedFormFieldsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersUsersBonusArgs = {
  distinct_on?: InputMaybe<Array<UsersBonus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersBonus_Order_By>>;
  where?: InputMaybe<UsersBonus_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsersBonus_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersBonus_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersBonus_Order_By>>;
  where?: InputMaybe<UsersBonus_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsersCostsArgs = {
  distinct_on?: InputMaybe<Array<UsersCosts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersCosts_Order_By>>;
  where?: InputMaybe<UsersCosts_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsersCosts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersCosts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersCosts_Order_By>>;
  where?: InputMaybe<UsersCosts_Bool_Exp>;
};

/** columns and relationships of "usersBonus" */
export type UsersBonus = {
  __typename?: 'usersBonus';
  amount: Scalars['Float'];
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  id: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  usersId: Scalars['String'];
  year: Scalars['Int'];
};

/** aggregated selection of "usersBonus" */
export type UsersBonus_Aggregate = {
  __typename?: 'usersBonus_aggregate';
  aggregate?: Maybe<UsersBonus_Aggregate_Fields>;
  nodes: Array<UsersBonus>;
};

export type UsersBonus_Aggregate_Bool_Exp = {
  count?: InputMaybe<UsersBonus_Aggregate_Bool_Exp_Count>;
};

export type UsersBonus_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UsersBonus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UsersBonus_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "usersBonus" */
export type UsersBonus_Aggregate_Fields = {
  __typename?: 'usersBonus_aggregate_fields';
  avg?: Maybe<UsersBonus_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<UsersBonus_Max_Fields>;
  min?: Maybe<UsersBonus_Min_Fields>;
  stddev?: Maybe<UsersBonus_Stddev_Fields>;
  stddev_pop?: Maybe<UsersBonus_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UsersBonus_Stddev_Samp_Fields>;
  sum?: Maybe<UsersBonus_Sum_Fields>;
  var_pop?: Maybe<UsersBonus_Var_Pop_Fields>;
  var_samp?: Maybe<UsersBonus_Var_Samp_Fields>;
  variance?: Maybe<UsersBonus_Variance_Fields>;
};


/** aggregate fields of "usersBonus" */
export type UsersBonus_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UsersBonus_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "usersBonus" */
export type UsersBonus_Aggregate_Order_By = {
  avg?: InputMaybe<UsersBonus_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsersBonus_Max_Order_By>;
  min?: InputMaybe<UsersBonus_Min_Order_By>;
  stddev?: InputMaybe<UsersBonus_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsersBonus_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsersBonus_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsersBonus_Sum_Order_By>;
  var_pop?: InputMaybe<UsersBonus_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsersBonus_Var_Samp_Order_By>;
  variance?: InputMaybe<UsersBonus_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "usersBonus" */
export type UsersBonus_Arr_Rel_Insert_Input = {
  data: Array<UsersBonus_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UsersBonus_On_Conflict>;
};

/** aggregate avg on columns */
export type UsersBonus_Avg_Fields = {
  __typename?: 'usersBonus_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "usersBonus" */
export type UsersBonus_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "usersBonus". All fields are combined with a logical 'AND'. */
export type UsersBonus_Bool_Exp = {
  _and?: InputMaybe<Array<UsersBonus_Bool_Exp>>;
  _not?: InputMaybe<UsersBonus_Bool_Exp>;
  _or?: InputMaybe<Array<UsersBonus_Bool_Exp>>;
  amount?: InputMaybe<Float_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  usersId?: InputMaybe<String_Comparison_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "usersBonus" */
export enum UsersBonus_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersBonusPkey = 'usersBonus_pkey',
  /** unique or primary key constraint on columns "year", "usersId" */
  UsersBonusUsersIdYearKey = 'usersBonus_usersId_year_key'
}

/** input type for incrementing numeric columns in table "usersBonus" */
export type UsersBonus_Inc_Input = {
  amount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "usersBonus" */
export type UsersBonus_Insert_Input = {
  amount?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  usersId?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type UsersBonus_Max_Fields = {
  __typename?: 'usersBonus_max_fields';
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  usersId?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "usersBonus" */
export type UsersBonus_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  usersId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UsersBonus_Min_Fields = {
  __typename?: 'usersBonus_min_fields';
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  usersId?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "usersBonus" */
export type UsersBonus_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  usersId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "usersBonus" */
export type UsersBonus_Mutation_Response = {
  __typename?: 'usersBonus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UsersBonus>;
};

/** on_conflict condition type for table "usersBonus" */
export type UsersBonus_On_Conflict = {
  constraint: UsersBonus_Constraint;
  update_columns?: Array<UsersBonus_Update_Column>;
  where?: InputMaybe<UsersBonus_Bool_Exp>;
};

/** Ordering options when selecting data from "usersBonus". */
export type UsersBonus_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  usersId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** primary key columns input for table: usersBonus */
export type UsersBonus_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "usersBonus" */
export enum UsersBonus_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsersId = 'usersId',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "usersBonus" */
export type UsersBonus_Set_Input = {
  amount?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usersId?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type UsersBonus_Stddev_Fields = {
  __typename?: 'usersBonus_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "usersBonus" */
export type UsersBonus_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UsersBonus_Stddev_Pop_Fields = {
  __typename?: 'usersBonus_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "usersBonus" */
export type UsersBonus_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UsersBonus_Stddev_Samp_Fields = {
  __typename?: 'usersBonus_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "usersBonus" */
export type UsersBonus_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "usersBonus" */
export type UsersBonus_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UsersBonus_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersBonus_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usersId?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type UsersBonus_Sum_Fields = {
  __typename?: 'usersBonus_sum_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "usersBonus" */
export type UsersBonus_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** update columns of table "usersBonus" */
export enum UsersBonus_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsersId = 'usersId',
  /** column name */
  Year = 'year'
}

export type UsersBonus_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UsersBonus_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersBonus_Set_Input>;
  where: UsersBonus_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UsersBonus_Var_Pop_Fields = {
  __typename?: 'usersBonus_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "usersBonus" */
export type UsersBonus_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UsersBonus_Var_Samp_Fields = {
  __typename?: 'usersBonus_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "usersBonus" */
export type UsersBonus_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UsersBonus_Variance_Fields = {
  __typename?: 'usersBonus_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "usersBonus" */
export type UsersBonus_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** columns and relationships of "usersCosts" */
export type UsersCosts = {
  __typename?: 'usersCosts';
  amount: Scalars['Float'];
  createdAt: Scalars['timestamptz'];
  currency: Scalars['String'];
  id: Scalars['Int'];
  month: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  usersId: Scalars['String'];
  year: Scalars['Int'];
};

/** aggregated selection of "usersCosts" */
export type UsersCosts_Aggregate = {
  __typename?: 'usersCosts_aggregate';
  aggregate?: Maybe<UsersCosts_Aggregate_Fields>;
  nodes: Array<UsersCosts>;
};

export type UsersCosts_Aggregate_Bool_Exp = {
  count?: InputMaybe<UsersCosts_Aggregate_Bool_Exp_Count>;
};

export type UsersCosts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UsersCosts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UsersCosts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "usersCosts" */
export type UsersCosts_Aggregate_Fields = {
  __typename?: 'usersCosts_aggregate_fields';
  avg?: Maybe<UsersCosts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<UsersCosts_Max_Fields>;
  min?: Maybe<UsersCosts_Min_Fields>;
  stddev?: Maybe<UsersCosts_Stddev_Fields>;
  stddev_pop?: Maybe<UsersCosts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UsersCosts_Stddev_Samp_Fields>;
  sum?: Maybe<UsersCosts_Sum_Fields>;
  var_pop?: Maybe<UsersCosts_Var_Pop_Fields>;
  var_samp?: Maybe<UsersCosts_Var_Samp_Fields>;
  variance?: Maybe<UsersCosts_Variance_Fields>;
};


/** aggregate fields of "usersCosts" */
export type UsersCosts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UsersCosts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "usersCosts" */
export type UsersCosts_Aggregate_Order_By = {
  avg?: InputMaybe<UsersCosts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsersCosts_Max_Order_By>;
  min?: InputMaybe<UsersCosts_Min_Order_By>;
  stddev?: InputMaybe<UsersCosts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsersCosts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsersCosts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsersCosts_Sum_Order_By>;
  var_pop?: InputMaybe<UsersCosts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsersCosts_Var_Samp_Order_By>;
  variance?: InputMaybe<UsersCosts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "usersCosts" */
export type UsersCosts_Arr_Rel_Insert_Input = {
  data: Array<UsersCosts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UsersCosts_On_Conflict>;
};

/** aggregate avg on columns */
export type UsersCosts_Avg_Fields = {
  __typename?: 'usersCosts_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "usersCosts" */
export type UsersCosts_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "usersCosts". All fields are combined with a logical 'AND'. */
export type UsersCosts_Bool_Exp = {
  _and?: InputMaybe<Array<UsersCosts_Bool_Exp>>;
  _not?: InputMaybe<UsersCosts_Bool_Exp>;
  _or?: InputMaybe<Array<UsersCosts_Bool_Exp>>;
  amount?: InputMaybe<Float_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  month?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  usersId?: InputMaybe<String_Comparison_Exp>;
  year?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "usersCosts" */
export enum UsersCosts_Constraint {
  /** unique or primary key constraint on columns "year", "month", "usersId" */
  UsersCostsMonthYearUsersIdKey = 'usersCosts_month_year_usersId_key',
  /** unique or primary key constraint on columns "id" */
  UsersCostsPkey = 'usersCosts_pkey'
}

/** input type for incrementing numeric columns in table "usersCosts" */
export type UsersCosts_Inc_Input = {
  amount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "usersCosts" */
export type UsersCosts_Insert_Input = {
  amount?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  usersId?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type UsersCosts_Max_Fields = {
  __typename?: 'usersCosts_max_fields';
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  usersId?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "usersCosts" */
export type UsersCosts_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  usersId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UsersCosts_Min_Fields = {
  __typename?: 'usersCosts_min_fields';
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  usersId?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "usersCosts" */
export type UsersCosts_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  usersId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "usersCosts" */
export type UsersCosts_Mutation_Response = {
  __typename?: 'usersCosts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UsersCosts>;
};

/** on_conflict condition type for table "usersCosts" */
export type UsersCosts_On_Conflict = {
  constraint: UsersCosts_Constraint;
  update_columns?: Array<UsersCosts_Update_Column>;
  where?: InputMaybe<UsersCosts_Bool_Exp>;
};

/** Ordering options when selecting data from "usersCosts". */
export type UsersCosts_Order_By = {
  amount?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  usersId?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** primary key columns input for table: usersCosts */
export type UsersCosts_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "usersCosts" */
export enum UsersCosts_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  Month = 'month',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsersId = 'usersId',
  /** column name */
  Year = 'year'
}

/** input type for updating data in table "usersCosts" */
export type UsersCosts_Set_Input = {
  amount?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usersId?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type UsersCosts_Stddev_Fields = {
  __typename?: 'usersCosts_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "usersCosts" */
export type UsersCosts_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UsersCosts_Stddev_Pop_Fields = {
  __typename?: 'usersCosts_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "usersCosts" */
export type UsersCosts_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UsersCosts_Stddev_Samp_Fields = {
  __typename?: 'usersCosts_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "usersCosts" */
export type UsersCosts_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "usersCosts" */
export type UsersCosts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UsersCosts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersCosts_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['Float']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usersId?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type UsersCosts_Sum_Fields = {
  __typename?: 'usersCosts_sum_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "usersCosts" */
export type UsersCosts_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** update columns of table "usersCosts" */
export enum UsersCosts_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  Month = 'month',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsersId = 'usersId',
  /** column name */
  Year = 'year'
}

export type UsersCosts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UsersCosts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersCosts_Set_Input>;
  where: UsersCosts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UsersCosts_Var_Pop_Fields = {
  __typename?: 'usersCosts_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "usersCosts" */
export type UsersCosts_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UsersCosts_Var_Samp_Fields = {
  __typename?: 'usersCosts_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "usersCosts" */
export type UsersCosts_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UsersCosts_Variance_Fields = {
  __typename?: 'usersCosts_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "usersCosts" */
export type UsersCosts_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  month?: InputMaybe<Order_By>;
  year?: InputMaybe<Order_By>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
  stddev?: InputMaybe<Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  savedColumns?: InputMaybe<Scalars['jsonb']>;
  savedFormFields?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  authorizedDomainId?: Maybe<Scalars['Float']>;
  contactId?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "users" */
export type Users_Avg_Order_By = {
  authorizedDomainId?: InputMaybe<Order_By>;
  contactId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  authorizedDomainId?: InputMaybe<Int_Comparison_Exp>;
  contact?: InputMaybe<Contacts_Bool_Exp>;
  contactId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  firstname?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  isAdmin?: InputMaybe<Boolean_Comparison_Exp>;
  isManager?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  lastReleasesViewDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  lastname?: InputMaybe<String_Comparison_Exp>;
  officeId?: InputMaybe<Int_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  savedColumns?: InputMaybe<Jsonb_Comparison_Exp>;
  savedFormFields?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  usersBonus?: InputMaybe<UsersBonus_Bool_Exp>;
  usersBonus_aggregate?: InputMaybe<UsersBonus_Aggregate_Bool_Exp>;
  usersCosts?: InputMaybe<UsersCosts_Bool_Exp>;
  usersCosts_aggregate?: InputMaybe<UsersCosts_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserPkey = 'user_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  savedColumns?: InputMaybe<Array<Scalars['String']>>;
  savedFormFields?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  savedColumns?: InputMaybe<Scalars['Int']>;
  savedFormFields?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  savedColumns?: InputMaybe<Scalars['String']>;
  savedFormFields?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  authorizedDomainId?: InputMaybe<Scalars['Int']>;
  contactId?: InputMaybe<Scalars['Int']>;
  officeId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  authorizedDomainId?: InputMaybe<Scalars['Int']>;
  contact?: InputMaybe<Contacts_Obj_Rel_Insert_Input>;
  contactId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  firstname?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isManager?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  lastReleasesViewDate?: InputMaybe<Scalars['timestamptz']>;
  lastname?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['String']>;
  savedColumns?: InputMaybe<Scalars['jsonb']>;
  savedFormFields?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usersBonus?: InputMaybe<UsersBonus_Arr_Rel_Insert_Input>;
  usersCosts?: InputMaybe<UsersCosts_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  authorizedDomainId?: Maybe<Scalars['Int']>;
  contactId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  firstname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  lastReleasesViewDate?: Maybe<Scalars['timestamptz']>;
  lastname?: Maybe<Scalars['String']>;
  officeId?: Maybe<Scalars['Int']>;
  role?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  authorizedDomainId?: InputMaybe<Order_By>;
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  firstname?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lastReleasesViewDate?: InputMaybe<Order_By>;
  lastname?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  authorizedDomainId?: Maybe<Scalars['Int']>;
  contactId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  firstname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  lastReleasesViewDate?: Maybe<Scalars['timestamptz']>;
  lastname?: Maybe<Scalars['String']>;
  officeId?: Maybe<Scalars['Int']>;
  role?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  authorizedDomainId?: InputMaybe<Order_By>;
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  firstname?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lastReleasesViewDate?: InputMaybe<Order_By>;
  lastname?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  authorizedDomainId?: InputMaybe<Order_By>;
  contact?: InputMaybe<Contacts_Order_By>;
  contactId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  firstname?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isAdmin?: InputMaybe<Order_By>;
  isManager?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lastReleasesViewDate?: InputMaybe<Order_By>;
  lastname?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  savedColumns?: InputMaybe<Order_By>;
  savedFormFields?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  usersBonus_aggregate?: InputMaybe<UsersBonus_Aggregate_Order_By>;
  usersCosts_aggregate?: InputMaybe<UsersCosts_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  savedColumns?: InputMaybe<Scalars['jsonb']>;
  savedFormFields?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  AuthorizedDomainId = 'authorizedDomainId',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Firstname = 'firstname',
  /** column name */
  Id = 'id',
  /** column name */
  IsAdmin = 'isAdmin',
  /** column name */
  IsManager = 'isManager',
  /** column name */
  Language = 'language',
  /** column name */
  LastReleasesViewDate = 'lastReleasesViewDate',
  /** column name */
  Lastname = 'lastname',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  Role = 'role',
  /** column name */
  SavedColumns = 'savedColumns',
  /** column name */
  SavedFormFields = 'savedFormFields',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAdmin = 'isAdmin',
  /** column name */
  IsManager = 'isManager'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAdmin = 'isAdmin',
  /** column name */
  IsManager = 'isManager'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  authorizedDomainId?: InputMaybe<Scalars['Int']>;
  contactId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  firstname?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isManager?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  lastReleasesViewDate?: InputMaybe<Scalars['timestamptz']>;
  lastname?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['String']>;
  savedColumns?: InputMaybe<Scalars['jsonb']>;
  savedFormFields?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  authorizedDomainId?: Maybe<Scalars['Float']>;
  contactId?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "users" */
export type Users_Stddev_Order_By = {
  authorizedDomainId?: InputMaybe<Order_By>;
  contactId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  authorizedDomainId?: Maybe<Scalars['Float']>;
  contactId?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "users" */
export type Users_Stddev_Pop_Order_By = {
  authorizedDomainId?: InputMaybe<Order_By>;
  contactId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  authorizedDomainId?: Maybe<Scalars['Float']>;
  contactId?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "users" */
export type Users_Stddev_Samp_Order_By = {
  authorizedDomainId?: InputMaybe<Order_By>;
  contactId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  authorizedDomainId?: InputMaybe<Scalars['Int']>;
  contactId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  firstname?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  isManager?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  lastReleasesViewDate?: InputMaybe<Scalars['timestamptz']>;
  lastname?: InputMaybe<Scalars['String']>;
  officeId?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['String']>;
  savedColumns?: InputMaybe<Scalars['jsonb']>;
  savedFormFields?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  authorizedDomainId?: Maybe<Scalars['Int']>;
  contactId?: Maybe<Scalars['Int']>;
  officeId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "users" */
export type Users_Sum_Order_By = {
  authorizedDomainId?: InputMaybe<Order_By>;
  contactId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  AuthorizedDomainId = 'authorizedDomainId',
  /** column name */
  ContactId = 'contactId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Firstname = 'firstname',
  /** column name */
  Id = 'id',
  /** column name */
  IsAdmin = 'isAdmin',
  /** column name */
  IsManager = 'isManager',
  /** column name */
  Language = 'language',
  /** column name */
  LastReleasesViewDate = 'lastReleasesViewDate',
  /** column name */
  Lastname = 'lastname',
  /** column name */
  OfficeId = 'officeId',
  /** column name */
  Role = 'role',
  /** column name */
  SavedColumns = 'savedColumns',
  /** column name */
  SavedFormFields = 'savedFormFields',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  authorizedDomainId?: Maybe<Scalars['Float']>;
  contactId?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "users" */
export type Users_Var_Pop_Order_By = {
  authorizedDomainId?: InputMaybe<Order_By>;
  contactId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  authorizedDomainId?: Maybe<Scalars['Float']>;
  contactId?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "users" */
export type Users_Var_Samp_Order_By = {
  authorizedDomainId?: InputMaybe<Order_By>;
  contactId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  authorizedDomainId?: Maybe<Scalars['Float']>;
  contactId?: Maybe<Scalars['Float']>;
  officeId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "users" */
export type Users_Variance_Order_By = {
  authorizedDomainId?: InputMaybe<Order_By>;
  contactId?: InputMaybe<Order_By>;
  officeId?: InputMaybe<Order_By>;
};

/** columns and relationships of "validationsContracts" */
export type ValidationsContracts = {
  __typename?: 'validationsContracts';
  comments?: Maybe<Scalars['String']>;
  /** An object relationship */
  company: Companies;
  companyId: Scalars['Int'];
  /** An object relationship */
  contract: Contracts;
  contractId: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['String'];
  id: Scalars['Int'];
  /** An object relationship */
  signatoryContact: Contacts;
  signatoryContactId: Scalars['Int'];
  signature?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "validationsContracts" */
export type ValidationsContracts_Aggregate = {
  __typename?: 'validationsContracts_aggregate';
  aggregate?: Maybe<ValidationsContracts_Aggregate_Fields>;
  nodes: Array<ValidationsContracts>;
};

export type ValidationsContracts_Aggregate_Bool_Exp = {
  count?: InputMaybe<ValidationsContracts_Aggregate_Bool_Exp_Count>;
};

export type ValidationsContracts_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ValidationsContracts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ValidationsContracts_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "validationsContracts" */
export type ValidationsContracts_Aggregate_Fields = {
  __typename?: 'validationsContracts_aggregate_fields';
  avg?: Maybe<ValidationsContracts_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ValidationsContracts_Max_Fields>;
  min?: Maybe<ValidationsContracts_Min_Fields>;
  stddev?: Maybe<ValidationsContracts_Stddev_Fields>;
  stddev_pop?: Maybe<ValidationsContracts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ValidationsContracts_Stddev_Samp_Fields>;
  sum?: Maybe<ValidationsContracts_Sum_Fields>;
  var_pop?: Maybe<ValidationsContracts_Var_Pop_Fields>;
  var_samp?: Maybe<ValidationsContracts_Var_Samp_Fields>;
  variance?: Maybe<ValidationsContracts_Variance_Fields>;
};


/** aggregate fields of "validationsContracts" */
export type ValidationsContracts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ValidationsContracts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "validationsContracts" */
export type ValidationsContracts_Aggregate_Order_By = {
  avg?: InputMaybe<ValidationsContracts_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ValidationsContracts_Max_Order_By>;
  min?: InputMaybe<ValidationsContracts_Min_Order_By>;
  stddev?: InputMaybe<ValidationsContracts_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ValidationsContracts_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ValidationsContracts_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ValidationsContracts_Sum_Order_By>;
  var_pop?: InputMaybe<ValidationsContracts_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ValidationsContracts_Var_Samp_Order_By>;
  variance?: InputMaybe<ValidationsContracts_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "validationsContracts" */
export type ValidationsContracts_Arr_Rel_Insert_Input = {
  data: Array<ValidationsContracts_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ValidationsContracts_On_Conflict>;
};

/** aggregate avg on columns */
export type ValidationsContracts_Avg_Fields = {
  __typename?: 'validationsContracts_avg_fields';
  companyId?: Maybe<Scalars['Float']>;
  contractId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  signatoryContactId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "validationsContracts" */
export type ValidationsContracts_Avg_Order_By = {
  companyId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signatoryContactId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "validationsContracts". All fields are combined with a logical 'AND'. */
export type ValidationsContracts_Bool_Exp = {
  _and?: InputMaybe<Array<ValidationsContracts_Bool_Exp>>;
  _not?: InputMaybe<ValidationsContracts_Bool_Exp>;
  _or?: InputMaybe<Array<ValidationsContracts_Bool_Exp>>;
  comments?: InputMaybe<String_Comparison_Exp>;
  company?: InputMaybe<Companies_Bool_Exp>;
  companyId?: InputMaybe<Int_Comparison_Exp>;
  contract?: InputMaybe<Contracts_Bool_Exp>;
  contractId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  signatoryContact?: InputMaybe<Contacts_Bool_Exp>;
  signatoryContactId?: InputMaybe<Int_Comparison_Exp>;
  signature?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "validationsContracts" */
export enum ValidationsContracts_Constraint {
  /** unique or primary key constraint on columns "contractId", "companyId" */
  ValidationsContractsCompanyIdContractIdKey = 'validationsContracts_companyId_contractId_key',
  /** unique or primary key constraint on columns "id" */
  ValidationsContractsPkey = 'validationsContracts_pkey'
}

/** input type for incrementing numeric columns in table "validationsContracts" */
export type ValidationsContracts_Inc_Input = {
  companyId?: InputMaybe<Scalars['Int']>;
  contractId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  signatoryContactId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "validationsContracts" */
export type ValidationsContracts_Insert_Input = {
  comments?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Companies_Obj_Rel_Insert_Input>;
  companyId?: InputMaybe<Scalars['Int']>;
  contract?: InputMaybe<Contracts_Obj_Rel_Insert_Input>;
  contractId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  signatoryContact?: InputMaybe<Contacts_Obj_Rel_Insert_Input>;
  signatoryContactId?: InputMaybe<Scalars['Int']>;
  signature?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type ValidationsContracts_Max_Fields = {
  __typename?: 'validationsContracts_max_fields';
  comments?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  contractId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  signatoryContactId?: Maybe<Scalars['Int']>;
  signature?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "validationsContracts" */
export type ValidationsContracts_Max_Order_By = {
  comments?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signatoryContactId?: InputMaybe<Order_By>;
  signature?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ValidationsContracts_Min_Fields = {
  __typename?: 'validationsContracts_min_fields';
  comments?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Int']>;
  contractId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  signatoryContactId?: Maybe<Scalars['Int']>;
  signature?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "validationsContracts" */
export type ValidationsContracts_Min_Order_By = {
  comments?: InputMaybe<Order_By>;
  companyId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signatoryContactId?: InputMaybe<Order_By>;
  signature?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "validationsContracts" */
export type ValidationsContracts_Mutation_Response = {
  __typename?: 'validationsContracts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ValidationsContracts>;
};

/** on_conflict condition type for table "validationsContracts" */
export type ValidationsContracts_On_Conflict = {
  constraint: ValidationsContracts_Constraint;
  update_columns?: Array<ValidationsContracts_Update_Column>;
  where?: InputMaybe<ValidationsContracts_Bool_Exp>;
};

/** Ordering options when selecting data from "validationsContracts". */
export type ValidationsContracts_Order_By = {
  comments?: InputMaybe<Order_By>;
  company?: InputMaybe<Companies_Order_By>;
  companyId?: InputMaybe<Order_By>;
  contract?: InputMaybe<Contracts_Order_By>;
  contractId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signatoryContact?: InputMaybe<Contacts_Order_By>;
  signatoryContactId?: InputMaybe<Order_By>;
  signature?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: validationsContracts */
export type ValidationsContracts_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "validationsContracts" */
export enum ValidationsContracts_Select_Column {
  /** column name */
  Comments = 'comments',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  ContractId = 'contractId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  SignatoryContactId = 'signatoryContactId',
  /** column name */
  Signature = 'signature',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "validationsContracts" */
export type ValidationsContracts_Set_Input = {
  comments?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  contractId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  signatoryContactId?: InputMaybe<Scalars['Int']>;
  signature?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type ValidationsContracts_Stddev_Fields = {
  __typename?: 'validationsContracts_stddev_fields';
  companyId?: Maybe<Scalars['Float']>;
  contractId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  signatoryContactId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "validationsContracts" */
export type ValidationsContracts_Stddev_Order_By = {
  companyId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signatoryContactId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ValidationsContracts_Stddev_Pop_Fields = {
  __typename?: 'validationsContracts_stddev_pop_fields';
  companyId?: Maybe<Scalars['Float']>;
  contractId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  signatoryContactId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "validationsContracts" */
export type ValidationsContracts_Stddev_Pop_Order_By = {
  companyId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signatoryContactId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ValidationsContracts_Stddev_Samp_Fields = {
  __typename?: 'validationsContracts_stddev_samp_fields';
  companyId?: Maybe<Scalars['Float']>;
  contractId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  signatoryContactId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "validationsContracts" */
export type ValidationsContracts_Stddev_Samp_Order_By = {
  companyId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signatoryContactId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "validationsContracts" */
export type ValidationsContracts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ValidationsContracts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ValidationsContracts_Stream_Cursor_Value_Input = {
  comments?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Int']>;
  contractId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  signatoryContactId?: InputMaybe<Scalars['Int']>;
  signature?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type ValidationsContracts_Sum_Fields = {
  __typename?: 'validationsContracts_sum_fields';
  companyId?: Maybe<Scalars['Int']>;
  contractId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  signatoryContactId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "validationsContracts" */
export type ValidationsContracts_Sum_Order_By = {
  companyId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signatoryContactId?: InputMaybe<Order_By>;
};

/** update columns of table "validationsContracts" */
export enum ValidationsContracts_Update_Column {
  /** column name */
  Comments = 'comments',
  /** column name */
  CompanyId = 'companyId',
  /** column name */
  ContractId = 'contractId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Id = 'id',
  /** column name */
  SignatoryContactId = 'signatoryContactId',
  /** column name */
  Signature = 'signature',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ValidationsContracts_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ValidationsContracts_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ValidationsContracts_Set_Input>;
  where: ValidationsContracts_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ValidationsContracts_Var_Pop_Fields = {
  __typename?: 'validationsContracts_var_pop_fields';
  companyId?: Maybe<Scalars['Float']>;
  contractId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  signatoryContactId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "validationsContracts" */
export type ValidationsContracts_Var_Pop_Order_By = {
  companyId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signatoryContactId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ValidationsContracts_Var_Samp_Fields = {
  __typename?: 'validationsContracts_var_samp_fields';
  companyId?: Maybe<Scalars['Float']>;
  contractId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  signatoryContactId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "validationsContracts" */
export type ValidationsContracts_Var_Samp_Order_By = {
  companyId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signatoryContactId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ValidationsContracts_Variance_Fields = {
  __typename?: 'validationsContracts_variance_fields';
  companyId?: Maybe<Scalars['Float']>;
  contractId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  signatoryContactId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "validationsContracts" */
export type ValidationsContracts_Variance_Order_By = {
  companyId?: InputMaybe<Order_By>;
  contractId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  signatoryContactId?: InputMaybe<Order_By>;
};

/** columns and relationships of "varietals" */
export type Varietals = {
  __typename?: 'varietals';
  createdAt: Scalars['timestamptz'];
  createdBy?: Maybe<Scalars['String']>;
  embedding?: Maybe<Scalars['vector']>;
  generic?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  subGeneric?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  varietal?: Maybe<Scalars['String']>;
  vectorText?: Maybe<Scalars['String']>;
};

/** aggregated selection of "varietals" */
export type Varietals_Aggregate = {
  __typename?: 'varietals_aggregate';
  aggregate?: Maybe<Varietals_Aggregate_Fields>;
  nodes: Array<Varietals>;
};

/** aggregate fields of "varietals" */
export type Varietals_Aggregate_Fields = {
  __typename?: 'varietals_aggregate_fields';
  avg?: Maybe<Varietals_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Varietals_Max_Fields>;
  min?: Maybe<Varietals_Min_Fields>;
  stddev?: Maybe<Varietals_Stddev_Fields>;
  stddev_pop?: Maybe<Varietals_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Varietals_Stddev_Samp_Fields>;
  sum?: Maybe<Varietals_Sum_Fields>;
  var_pop?: Maybe<Varietals_Var_Pop_Fields>;
  var_samp?: Maybe<Varietals_Var_Samp_Fields>;
  variance?: Maybe<Varietals_Variance_Fields>;
};


/** aggregate fields of "varietals" */
export type Varietals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Varietals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Varietals_Avg_Fields = {
  __typename?: 'varietals_avg_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "varietals". All fields are combined with a logical 'AND'. */
export type Varietals_Bool_Exp = {
  _and?: InputMaybe<Array<Varietals_Bool_Exp>>;
  _not?: InputMaybe<Varietals_Bool_Exp>;
  _or?: InputMaybe<Array<Varietals_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<String_Comparison_Exp>;
  embedding?: InputMaybe<Vector_Comparison_Exp>;
  generic?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  subGeneric?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  varietal?: InputMaybe<String_Comparison_Exp>;
  vectorText?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "varietals" */
export enum Varietals_Constraint {
  /** unique or primary key constraint on columns "id" */
  VarietalsPkey = 'varietals_pkey'
}

/** input type for incrementing numeric columns in table "varietals" */
export type Varietals_Inc_Input = {
  id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "varietals" */
export type Varietals_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  embedding?: InputMaybe<Scalars['vector']>;
  generic?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  subGeneric?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  varietal?: InputMaybe<Scalars['String']>;
  vectorText?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Varietals_Max_Fields = {
  __typename?: 'varietals_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  generic?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  subGeneric?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  varietal?: Maybe<Scalars['String']>;
  vectorText?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Varietals_Min_Fields = {
  __typename?: 'varietals_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['String']>;
  generic?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  subGeneric?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  varietal?: Maybe<Scalars['String']>;
  vectorText?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "varietals" */
export type Varietals_Mutation_Response = {
  __typename?: 'varietals_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Varietals>;
};

/** on_conflict condition type for table "varietals" */
export type Varietals_On_Conflict = {
  constraint: Varietals_Constraint;
  update_columns?: Array<Varietals_Update_Column>;
  where?: InputMaybe<Varietals_Bool_Exp>;
};

/** Ordering options when selecting data from "varietals". */
export type Varietals_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  embedding?: InputMaybe<Order_By>;
  generic?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  subGeneric?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  varietal?: InputMaybe<Order_By>;
  vectorText?: InputMaybe<Order_By>;
};

/** primary key columns input for table: varietals */
export type Varietals_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "varietals" */
export enum Varietals_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Generic = 'generic',
  /** column name */
  Id = 'id',
  /** column name */
  SubGeneric = 'subGeneric',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Varietal = 'varietal',
  /** column name */
  VectorText = 'vectorText'
}

/** input type for updating data in table "varietals" */
export type Varietals_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  embedding?: InputMaybe<Scalars['vector']>;
  generic?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  subGeneric?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  varietal?: InputMaybe<Scalars['String']>;
  vectorText?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Varietals_Stddev_Fields = {
  __typename?: 'varietals_stddev_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Varietals_Stddev_Pop_Fields = {
  __typename?: 'varietals_stddev_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Varietals_Stddev_Samp_Fields = {
  __typename?: 'varietals_stddev_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "varietals" */
export type Varietals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Varietals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Varietals_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['String']>;
  embedding?: InputMaybe<Scalars['vector']>;
  generic?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  subGeneric?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  varietal?: InputMaybe<Scalars['String']>;
  vectorText?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Varietals_Sum_Fields = {
  __typename?: 'varietals_sum_fields';
  id?: Maybe<Scalars['Int']>;
};

/** update columns of table "varietals" */
export enum Varietals_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  Embedding = 'embedding',
  /** column name */
  Generic = 'generic',
  /** column name */
  Id = 'id',
  /** column name */
  SubGeneric = 'subGeneric',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Varietal = 'varietal',
  /** column name */
  VectorText = 'vectorText'
}

export type Varietals_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Varietals_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Varietals_Set_Input>;
  where: Varietals_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Varietals_Var_Pop_Fields = {
  __typename?: 'varietals_var_pop_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Varietals_Var_Samp_Fields = {
  __typename?: 'varietals_var_samp_fields';
  id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Varietals_Variance_Fields = {
  __typename?: 'varietals_variance_fields';
  id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "vector". All fields are combined with logical 'AND'. */
export type Vector_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['vector']>;
  _gt?: InputMaybe<Scalars['vector']>;
  _gte?: InputMaybe<Scalars['vector']>;
  _in?: InputMaybe<Array<Scalars['vector']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['vector']>;
  _lte?: InputMaybe<Scalars['vector']>;
  _neq?: InputMaybe<Scalars['vector']>;
  _nin?: InputMaybe<Array<Scalars['vector']>>;
};

export type GetAdressesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdressesQuery = { __typename?: 'query_root', addresses: Array<{ __typename?: 'addresses', archivedAt?: any | null, city?: string | null, country?: string | null, createdAt?: any | null, createdBy: string, deletedAt?: any | null, id: number, name: string, storageCompany?: string | null, state?: string | null, street1?: string | null, street2?: string | null, streetNumber?: string | null, updatedAt?: any | null, zipcode?: string | null, comments?: string | null, files?: any | null, excise?: string | null, bondedWarehouse?: string | null }> };

export type GetAgreementTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementTermsQuery = { __typename?: 'query_root', agreementTerms: Array<{ __typename?: 'agreementTerms', content?: string | null, createdAt: any, id: number, title: string, type: string, updatedAt: any, createdBy: string, deletedAt?: any | null }> };

export type GetAgreementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementsQuery = { __typename?: 'query_root', agreements: Array<{ __typename?: 'agreements', thirdPartyContractRef?: string | null, commodityType: string, buyerCompanyId?: number | null, archivedAt?: any | null, buyerCiattiCommission?: number | null, buyerContactId?: number | null, buyerContractRef?: string | null, buyerOfficeId?: number | null, buyerSpecsId?: any | null, buyerUserId?: string | null, comments?: string | null, commisionFees?: number | null, commissionBuyer?: number | null, commissionCostBase?: number | null, commissionCurrency?: string | null, commissionFeesPerUom?: number | null, commissionFlatFees?: number | null, commissionPercentage?: number | null, commissionQuantityBase?: number | null, commissionSeller?: number | null, commissionThirdParty?: number | null, commissionTotalFees?: number | null, commissionType?: string | null, commissionUom?: string | null, contractRevision?: string | null, legacyContractStatus?: string | null, contractUserId?: string | null, createdAt: any, createdBy: string, deletedAt?: any | null, endDate?: any | null, files?: any | null, id: number, incoterms?: string | null, itemsId: any, thirdPartyCompanyId?: number | null, thirdPartyContactId?: number | null, place?: string | null, reminders?: any | null, sellerCiattiCommission?: number | null, sellerCompanyId?: number | null, sellerContactId?: number | null, sellerContractRef?: string | null, sellerOfficeId?: number | null, sellerUserId?: string | null, startDate?: any | null, terms?: string | null, termsAddContract?: string | null, termsCommission?: string | null, termsPayment?: string | null, termsShipping?: string | null, thirdPartyCommission?: number | null, title?: string | null, totalCost?: number | null, updatedAt: any, evergreenContract?: boolean | null, usdaGcr?: boolean | null, contractOfficeId?: number | null, costArray?: any | null, signaturesRequired?: any | null, buyerDeliveryAddressId?: number | null, currency?: string | null, evergreenDates?: any | null, termsAddContractViewer?: any | null, termsShippingViewer?: any | null, termsViewer?: any | null, termsPaymentViewer?: any | null, termsCommissionViewer?: any | null, buyerBondedWarehouse?: string | null, buyerEori?: string | null, buyerExcise?: string | null, buyerUserName?: string | null, buyerVat?: string | null, sellerBondedWarehouse?: string | null, sellerEori?: string | null, sellerExcise?: string | null, sellerFda?: string | null, sellerUserName?: string | null, sellerVat?: string | null, buyerBillingAddressId?: number | null, salesOrderNetsuite?: string | null, sellerBillingAddressId?: number | null, sellerDeliveryAddressId?: number | null, sellerCvi?: string | null, buyerCvi?: string | null, fulfillmentsStatus?: string | null, contractStatus?: string | null, additionalInformations?: string | null, evergreenAgreementId?: number | null, isMultiYearContract?: boolean | null }> };

export type GetAgreementsWithStartDateQueryVariables = Exact<{
  startDate: Scalars['timestamptz'];
}>;


export type GetAgreementsWithStartDateQuery = { __typename?: 'query_root', agreements: Array<{ __typename?: 'agreements', thirdPartyContractRef?: string | null, commodityType: string, buyerCompanyId?: number | null, archivedAt?: any | null, buyerCiattiCommission?: number | null, buyerContactId?: number | null, buyerContractRef?: string | null, buyerOfficeId?: number | null, buyerSpecsId?: any | null, buyerUserId?: string | null, comments?: string | null, commisionFees?: number | null, commissionBuyer?: number | null, commissionCostBase?: number | null, commissionCurrency?: string | null, commissionFeesPerUom?: number | null, commissionFlatFees?: number | null, commissionPercentage?: number | null, commissionQuantityBase?: number | null, commissionSeller?: number | null, commissionThirdParty?: number | null, commissionTotalFees?: number | null, commissionType?: string | null, commissionUom?: string | null, contractRevision?: string | null, legacyContractStatus?: string | null, contractUserId?: string | null, createdAt: any, createdBy: string, deletedAt?: any | null, endDate?: any | null, files?: any | null, id: number, incoterms?: string | null, itemsId: any, thirdPartyCompanyId?: number | null, thirdPartyContactId?: number | null, place?: string | null, reminders?: any | null, sellerCiattiCommission?: number | null, sellerCompanyId?: number | null, sellerContactId?: number | null, sellerContractRef?: string | null, sellerOfficeId?: number | null, sellerUserId?: string | null, startDate?: any | null, terms?: string | null, termsAddContract?: string | null, termsCommission?: string | null, termsPayment?: string | null, termsShipping?: string | null, thirdPartyCommission?: number | null, title?: string | null, totalCost?: number | null, updatedAt: any, evergreenContract?: boolean | null, usdaGcr?: boolean | null, contractOfficeId?: number | null, costArray?: any | null, signaturesRequired?: any | null, buyerDeliveryAddressId?: number | null, currency?: string | null, evergreenDates?: any | null, termsAddContractViewer?: any | null, termsShippingViewer?: any | null, termsViewer?: any | null, termsPaymentViewer?: any | null, termsCommissionViewer?: any | null, buyerBondedWarehouse?: string | null, buyerEori?: string | null, buyerExcise?: string | null, buyerUserName?: string | null, buyerVat?: string | null, sellerBondedWarehouse?: string | null, sellerEori?: string | null, sellerExcise?: string | null, sellerFda?: string | null, sellerUserName?: string | null, sellerVat?: string | null, buyerBillingAddressId?: number | null, salesOrderNetsuite?: string | null, sellerBillingAddressId?: number | null, sellerDeliveryAddressId?: number | null, sellerCvi?: string | null, buyerCvi?: string | null, fulfillmentsStatus?: string | null, contractStatus?: string | null, additionalInformations?: string | null, evergreenAgreementId?: number | null, isMultiYearContract?: boolean | null }> };

export type GetAgreementsWithShipmentFulfillmentsAndInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgreementsWithShipmentFulfillmentsAndInvoicesQuery = { __typename?: 'query_root', agreements: Array<{ __typename?: 'agreements', isMultiYearContract?: boolean | null, thirdPartyContractRef?: string | null, commodityType: string, buyerCompanyId?: number | null, archivedAt?: any | null, buyerCiattiCommission?: number | null, buyerContactId?: number | null, buyerContractRef?: string | null, buyerOfficeId?: number | null, buyerSpecsId?: any | null, buyerUserId?: string | null, comments?: string | null, commisionFees?: number | null, commissionBuyer?: number | null, commissionCostBase?: number | null, commissionCurrency?: string | null, commissionFeesPerUom?: number | null, commissionFlatFees?: number | null, commissionPercentage?: number | null, commissionQuantityBase?: number | null, commissionSeller?: number | null, commissionThirdParty?: number | null, commissionTotalFees?: number | null, commissionType?: string | null, commissionUom?: string | null, contractRevision?: string | null, legacyContractStatus?: string | null, contractUserId?: string | null, createdAt: any, createdBy: string, deletedAt?: any | null, endDate?: any | null, files?: any | null, id: number, incoterms?: string | null, itemsId: any, thirdPartyCompanyId?: number | null, thirdPartyContactId?: number | null, place?: string | null, reminders?: any | null, sellerCiattiCommission?: number | null, sellerCompanyId?: number | null, sellerContactId?: number | null, sellerContractRef?: string | null, sellerOfficeId?: number | null, sellerUserId?: string | null, startDate?: any | null, terms?: string | null, termsAddContract?: string | null, termsCommission?: string | null, termsPayment?: string | null, termsShipping?: string | null, thirdPartyCommission?: number | null, title?: string | null, totalCost?: number | null, updatedAt: any, evergreenContract?: boolean | null, usdaGcr?: boolean | null, contractOfficeId?: number | null, costArray?: any | null, signaturesRequired?: any | null, buyerDeliveryAddressId?: number | null, currency?: string | null, evergreenDates?: any | null, termsAddContractViewer?: any | null, termsShippingViewer?: any | null, termsViewer?: any | null, termsPaymentViewer?: any | null, termsCommissionViewer?: any | null, buyerBondedWarehouse?: string | null, buyerEori?: string | null, buyerExcise?: string | null, buyerUserName?: string | null, buyerVat?: string | null, sellerBondedWarehouse?: string | null, sellerEori?: string | null, sellerExcise?: string | null, sellerFda?: string | null, sellerUserName?: string | null, sellerVat?: string | null, buyerBillingAddressId?: number | null, salesOrderNetsuite?: string | null, sellerBillingAddressId?: number | null, sellerDeliveryAddressId?: number | null, sellerCvi?: string | null, buyerCvi?: string | null, evergreenAgreementId?: number | null, fulfillmentsStatus?: string | null, contractStatus?: string | null, invoices: Array<{ __typename?: 'invoices', buyerPoRef?: string | null, supplierInvoice?: string | null, paymentDate?: any | null, USDconversion?: number | null, amount?: number | null, archivedAt?: any | null, brokerId?: string | null, comments?: string | null, companyId?: number | null, createdAt: any, createdBy: string, currency?: string | null, deletedAt?: any | null, dueDate?: any | null, externalId?: string | null, files?: any | null, id: number, officeId?: number | null, quickbookId?: number | null, shipmentFulfillmentId?: number | null, status?: string | null, updatedAt: any }>, shipmentFulfillments: Array<{ __typename?: 'shipmentFulfillments', archivedAt?: any | null, comments?: string | null, commissionAmount?: number | null, createdAt: any, createdBy: string, currency?: string | null, date?: any | null, deletedAt?: any | null, files?: any | null, id: number, itemId: number, quantity?: number | null, status?: string | null, uom?: string | null, updatedAt: any }> }> };

export type GetAppellationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppellationsQuery = { __typename?: 'query_root', appellations: Array<{ __typename?: 'appellations', id: number, country?: string | null, state?: string | null, region?: string | null, subRegion?: string | null, appellation?: string | null, district?: string | null, county?: string | null, subAppellation?: string | null }> };

export type GetAppellationsWithVectorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppellationsWithVectorQuery = { __typename?: 'query_root', appellations: Array<{ __typename?: 'appellations', id: number, country?: string | null, state?: string | null, region?: string | null, subRegion?: string | null, appellation?: string | null, district?: string | null, county?: string | null, subAppellation?: string | null, embedding?: any | null, vectorText?: string | null }> };

export type GetAuthorizedDomainByNameQueryVariables = Exact<{
  domain: Scalars['String'];
}>;


export type GetAuthorizedDomainByNameQuery = { __typename?: 'query_root', authorizedDomains: Array<{ __typename?: 'authorizedDomains', id: number, domain: string }> };

export type GetAuthorizedDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthorizedDomainsQuery = { __typename?: 'query_root', authorizedDomains: Array<{ __typename?: 'authorizedDomains', id: number, domain: string, deletedAt?: any | null }> };

export type GetBuySpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBuySpecsQuery = { __typename?: 'query_root', buySpecs: Array<{ __typename?: 'buySpecs', alcohol?: number | null, archivedAt?: any | null, askPrice?: number | null, buyerAddressId?: number | null, buyerCompanyId: number, buyerContactId?: number | null, certifications?: any | null, comments?: string | null, commodityType: string, country?: string | null, county?: string | null, createdAt: any, createdBy?: string | null, currency?: string | null, deadline?: any | null, deletedAt?: any | null, district?: string | null, files?: any | null, generic?: string | null, id: number, officeId?: number | null, qualities?: any | null, quantityNeeded?: number | null, region?: string | null, state?: string | null, subAppellation?: string | null, subGeneric?: string | null, subRegion?: string | null, uom?: string | null, updatedAt: any, varietals?: any | null, vintages?: any | null, brokerId?: string | null, appellations?: any | null, isOpportunistic: boolean, commissionAmount?: number | null, commissionPercentage: number, status?: string | null, harvestMethod?: string | null }> };

export type GetCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompaniesQuery = { __typename?: 'query_root', companies: Array<{ __typename?: 'companies', brokerId?: string | null, category?: string | null, certifications: any, createdAt?: any | null, createdBy: string, cvi?: string | null, email?: string | null, excise?: string | null, id: number, name: string, officialId?: string | null, phone?: string | null, updatedAt?: any | null, vat?: string | null, archivedAt?: any | null, deletedAt?: any | null, comments?: string | null, files?: any | null, officeId?: number | null, country?: string | null, fda?: string | null, eori?: string | null, scoring?: string | null, parentCompany?: string | null, targetObjectiveCurrency?: string | null, targetObjective?: number | null }> };

export type GetCompaniesWithVectorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompaniesWithVectorQuery = { __typename?: 'query_root', companies: Array<{ __typename?: 'companies', brokerId?: string | null, category?: string | null, certifications: any, createdAt?: any | null, createdBy: string, cvi?: string | null, email?: string | null, excise?: string | null, id: number, name: string, officialId?: string | null, phone?: string | null, updatedAt?: any | null, vat?: string | null, archivedAt?: any | null, deletedAt?: any | null, comments?: string | null, files?: any | null, officeId?: number | null, country?: string | null, fda?: string | null, eori?: string | null, scoring?: string | null, parentCompany?: string | null, targetObjectiveCurrency?: string | null, targetObjective?: number | null, embedding?: any | null, vectorText?: string | null }> };

export type GetCompanyAdressesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyAdressesQuery = { __typename?: 'query_root', companyAddress: Array<{ __typename?: 'companyAddress', addressId: number, companyId: number, id: number }> };

export type GetContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactsQuery = { __typename?: 'query_root', contacts: Array<{ __typename?: 'contacts', addressId?: number | null, altEmail?: string | null, altPhone?: string | null, archivedAt?: any | null, brokerId?: string | null, categories?: any | null, companyId?: number | null, createdAt: any, createdBy: string, deletedAt?: any | null, email?: string | null, updatedAt: any, phone?: string | null, officePhone?: string | null, mobile?: string | null, lastname: string, jobTitle?: string | null, id: number, fax?: string | null, firstname: string, comments?: string | null, files?: any | null }> };

export type GetContactsWithVectorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactsWithVectorQuery = { __typename?: 'query_root', contacts: Array<{ __typename?: 'contacts', addressId?: number | null, altEmail?: string | null, altPhone?: string | null, archivedAt?: any | null, brokerId?: string | null, categories?: any | null, companyId?: number | null, createdAt: any, createdBy: string, deletedAt?: any | null, email?: string | null, updatedAt: any, phone?: string | null, officePhone?: string | null, mobile?: string | null, lastname: string, jobTitle?: string | null, id: number, fax?: string | null, firstname: string, comments?: string | null, files?: any | null, embedding?: any | null, vectorText?: string | null }> };

export type GetContactsForGeneratingVectorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactsForGeneratingVectorQuery = { __typename?: 'query_root', contacts: Array<{ __typename?: 'contacts', addressId?: number | null, altEmail?: string | null, altPhone?: string | null, archivedAt?: any | null, brokerId?: string | null, categories?: any | null, companyId?: number | null, createdAt: any, createdBy: string, deletedAt?: any | null, email?: string | null, updatedAt: any, phone?: string | null, officePhone?: string | null, mobile?: string | null, lastname: string, jobTitle?: string | null, id: number, fax?: string | null, firstname: string, comments?: string | null, files?: any | null, company?: { __typename?: 'companies', name: string, id: number } | null }> };

export type GetContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractsQuery = { __typename?: 'query_root', contracts: Array<{ __typename?: 'contracts', agreementId: number, createdAt: any, createdBy: string, fileUrl: string, id: number, updatedAt: any, version?: string | null, format: string, fileUrlWithSignatures?: string | null, validationsContracts: Array<{ __typename?: 'validationsContracts', companyId: number, comments?: string | null, createdAt: any, createdBy: string, id: number, status: string, updatedAt: any, signatoryContactId: number, signature?: string | null }> }> };

export type GetExtendedContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExtendedContractsQuery = { __typename?: 'query_root', contracts: Array<{ __typename?: 'contracts', agreementId: number, createdAt: any, createdBy: string, fileUrl: string, id: number, updatedAt: any, version?: string | null, fileUrlWithSignatures?: string | null, format: string, validationsContracts: Array<{ __typename?: 'validationsContracts', companyId: number, comments?: string | null, createdAt: any, createdBy: string, id: number, status: string, updatedAt: any, signatoryContactId: number, signature?: string | null, company: { __typename?: 'companies', name: string }, signatoryContact: { __typename?: 'contacts', firstname: string, lastname: string } }> }> };

export type GetCurrenciesConversionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrenciesConversionsQuery = { __typename?: 'query_root', currenciesConversions: Array<{ __typename?: 'currenciesConversions', date: any, currencies: any }> };

export type GetHistoryForObjectQueryVariables = Exact<{
  id: Scalars['Int'];
  table: Scalars['String'];
}>;


export type GetHistoryForObjectQuery = { __typename?: 'query_root', history: Array<{ __typename?: 'history', createdAt: any, createdBy: string, data: any, id: number, objectId: number, operation: string, table: string }> };

export type GetEntitiesUpdatedQueryVariables = Exact<{
  table: Scalars['String'];
  objectsId: Array<Scalars['Int']> | Scalars['Int'];
  startDate: Scalars['timestamptz'];
  endDate: Scalars['timestamptz'];
}>;


export type GetEntitiesUpdatedQuery = { __typename?: 'query_root', history: Array<{ __typename?: 'history', createdAt: any, objectId: number }> };

export type GetHistoryByUserQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetHistoryByUserQuery = { __typename?: 'query_root', history: Array<{ __typename?: 'history', objectId: number, operation: string, table: string, createdAt: any, id: number }> };

export type GetInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvoicesQuery = { __typename?: 'query_root', invoices: Array<{ __typename?: 'invoices', agreementId?: number | null, amount?: number | null, archivedAt?: any | null, brokerId?: string | null, comments?: string | null, companyId?: number | null, createdAt: any, createdBy: string, currency?: string | null, files?: any | null, id: number, officeId?: number | null, shipmentFulfillmentId?: number | null, status?: string | null, updatedAt: any, deletedAt?: any | null, quickbookId?: number | null, buyerPoRef?: string | null, supplierInvoice?: string | null, paymentDate?: any | null }> };

export type GetItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetItemsQuery = { __typename?: 'query_root', items: Array<{ __typename?: 'items', alcohol?: number | null, brokerId?: string | null, certifications: any, comments?: string | null, conditioning?: string | null, country?: string | null, county?: string | null, createdAt: any, createdBy: string, currency?: string | null, district?: string | null, exportIncoterms?: string | null, exportIncotermsType?: string | null, files?: any | null, generic?: string | null, harvestMethod?: string | null, id: number, localPrice?: number | null, lotNo?: string | null, officeId?: number | null, isOpportunistic?: boolean | null, qualities: any, quantity?: number | null, region?: string | null, state?: string | null, storageLocationId?: number | null, subGeneric?: string | null, vintages: any, varietals: any, updatedAt: any, uom?: string | null, tankNo?: string | null, supplierContactId?: number | null, supplierCompanyId: number, subRegion?: string | null, deletedAt?: any | null, archivedAt?: any | null, commodityType: string, appellations: any, subAppellation?: string | null, additionalInformations?: string | null, netsuiteId?: string | null }> };

export type GetItemsWithStartDateQueryVariables = Exact<{
  startDate: Scalars['timestamptz'];
}>;


export type GetItemsWithStartDateQuery = { __typename?: 'query_root', items: Array<{ __typename?: 'items', alcohol?: number | null, brokerId?: string | null, certifications: any, comments?: string | null, conditioning?: string | null, country?: string | null, county?: string | null, createdAt: any, createdBy: string, currency?: string | null, district?: string | null, exportIncoterms?: string | null, exportIncotermsType?: string | null, files?: any | null, generic?: string | null, harvestMethod?: string | null, id: number, localPrice?: number | null, lotNo?: string | null, officeId?: number | null, isOpportunistic?: boolean | null, qualities: any, quantity?: number | null, region?: string | null, state?: string | null, storageLocationId?: number | null, subGeneric?: string | null, vintages: any, varietals: any, updatedAt: any, uom?: string | null, tankNo?: string | null, supplierContactId?: number | null, supplierCompanyId: number, subRegion?: string | null, deletedAt?: any | null, archivedAt?: any | null, commodityType: string, appellations: any, subAppellation?: string | null, additionalInformations?: string | null, netsuiteId?: string | null }> };

export type GetLogsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLogsQuery = { __typename?: 'query_root', logs: Array<{ __typename?: 'logs', action?: string | null, createdAt: any, createdBy: string, id: number, payload?: any | null, url: string }> };

export type GetMatchingItemsBuySpecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMatchingItemsBuySpecsQuery = { __typename?: 'query_root', matchingItemsBuySpecs: Array<{ __typename?: 'matchingItemsBuySpecs', archivedAt?: any | null, buySpecId: number, createdAt?: any | null, createdBy: string, deletedAt?: any | null, updatedAt?: any | null, itemId: number, id: number }> };

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = { __typename?: 'query_root', notifications: Array<{ __typename?: 'notifications', assignedTo: string, createdAt: any, createdBy: string, historyId: number, id: number, updatedAt: any, viewedAt?: any | null, archivedAt?: any | null, history: { __typename?: 'history', operation: string, table: string, objectId: number }, user: { __typename?: 'users', firstname: string, lastname: string } }> };

export type GetOfficesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOfficesQuery = { __typename?: 'query_root', offices: Array<{ __typename?: 'offices', name: string, id: number, address?: string | null, locale: string }> };

export type GetReleasesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReleasesQuery = { __typename?: 'query_root', releases: Array<{ __typename?: 'releases', createdAt: any, updatedAt: any, title: string, link?: string | null, imageUrl?: string | null, id: number, description: string, date: any, tag?: string | null }> };

export type GetRemindersByOfficeIdQueryVariables = Exact<{
  officeId: Scalars['Int'];
}>;


export type GetRemindersByOfficeIdQuery = { __typename?: 'query_root', reminders: Array<{ __typename?: 'reminders', assignedTo: string, deletedAt?: any | null, createdAt: any, createdBy: string, description?: string | null, id: number, startDate: any, title: string, updatedAt: any, viewedAt?: any | null, table?: string | null, objectId?: number | null }> };

export type GetRemindersByObjectIdQueryVariables = Exact<{
  objectId: Scalars['Int'];
  table: Scalars['String'];
}>;


export type GetRemindersByObjectIdQuery = { __typename?: 'query_root', reminders: Array<{ __typename?: 'reminders', assignedTo: string, deletedAt?: any | null, createdAt: any, createdBy: string, description?: string | null, id: number, startDate: any, objectId?: number | null, table?: string | null, title: string, updatedAt: any, viewedAt?: any | null }> };

export type GetSampleLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSampleLabelsQuery = { __typename?: 'query_root', sampleLabels: Array<{ __typename?: 'sampleLabels', archivedAt?: any | null, createdAt: any, createdBy: string, fields: any, model?: any | null, deletedAt?: any | null, id: number, officeId: number, updatedAt: any }> };

export type GetSampleShipmentRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSampleShipmentRequestsQuery = { __typename?: 'query_root', sampleShipmentRequests: Array<{ __typename?: 'sampleShipmentRequests', archivedAt?: any | null, buySpecId: number, comments?: string | null, createdAt: any, createdBy: string, deadline?: any | null, deletedAt?: any | null, files?: any | null, id: number, itemId: number, numberOfSamples: number, updatedAt: any, sampleShipmentId?: number | null, type: string, requestedBy?: string | null, feedback?: string | null }> };

export type GetSampleShipmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSampleShipmentsQuery = { __typename?: 'query_root', sampleShipments: Array<{ __typename?: 'sampleShipments', archivedAt?: any | null, brokerId: string, carrier?: string | null, createdAt: any, createdBy: string, deletedAt?: any | null, details?: string | null, id: number, officeId?: number | null, pickupDate?: any | null, recipientAddressId?: number | null, recipientCompanyId: number, recipientContactId?: number | null, senderAddressId?: number | null, senderCompanyId?: number | null, senderContactId?: number | null, status?: string | null, trackingId?: string | null, updatedAt: any, deliveryMethod?: string | null, deliveryDate?: any | null, isHardcodedCarrier: boolean }> };

export type GetSampleShipmentExtendedQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetSampleShipmentExtendedQuery = { __typename?: 'query_root', sampleShipments: Array<{ __typename?: 'sampleShipments', archivedAt?: any | null, brokerId: string, carrier?: string | null, createdAt: any, isHardcodedCarrier: boolean, createdBy: string, deletedAt?: any | null, details?: string | null, deliveryMethod?: string | null, deliveryDate?: any | null, id: number, officeId?: number | null, pickupDate?: any | null, recipientAddressId?: number | null, recipientContactId?: number | null, recipientCompanyId: number, senderAddressId?: number | null, senderCompanyId?: number | null, senderContactId?: number | null, status?: string | null, trackingId?: string | null, updatedAt: any, office?: { __typename?: 'offices', id: number, name: string, address?: string | null } | null, senderCompany?: { __typename?: 'companies', name: string } | null, senderContact?: { __typename?: 'contacts', firstname: string, lastname: string } | null, senderAddress?: { __typename?: 'addresses', country?: string | null, city?: string | null, street1?: string | null, street2?: string | null, state?: string | null, streetNumber?: string | null, zipcode?: string | null } | null, recipientAddress?: { __typename?: 'addresses', country?: string | null, city?: string | null, street1?: string | null, street2?: string | null, state?: string | null, streetNumber?: string | null, zipcode?: string | null } | null, recipientCompany: { __typename?: 'companies', name: string }, recipientContact?: { __typename?: 'contacts', firstname: string, lastname: string } | null, sampleShipmentRequests: Array<{ __typename?: 'sampleShipmentRequests', itemId: number, numberOfSamples: number, item: { __typename?: 'items', id: number, alcohol?: number | null, appellations: any, archivedAt?: any | null, brokerId?: string | null, localPrice?: number | null, currency?: string | null, certifications: any, comments?: string | null, additionalInformations?: string | null, uom?: string | null, lotNo?: string | null, exportIncoterms?: string | null, exportIncotermsType?: string | null, commodityType: string, conditioning?: string | null, quantity?: number | null, tankNo?: string | null, vintages: any, varietals: any, supplierCompany: { __typename?: 'companies', name: string } } }> }> };

export type UpdateSampleShipmentsByTrackingIdStatusMutationVariables = Exact<{
  trackingId: Scalars['String'];
  partialObject: SampleShipments_Set_Input;
}>;


export type UpdateSampleShipmentsByTrackingIdStatusMutation = { __typename?: 'mutation_root', update_sampleShipments?: { __typename?: 'sampleShipments_mutation_response', affected_rows: number } | null };

export type GetSamplesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSamplesQuery = { __typename?: 'query_root', samples: Array<{ __typename?: 'samples', analysisCertificates?: any | null, compositionCertificates?: any | null, createdAt: any, createdBy: string, id: number, itemId: number, updatedAt: any, shelf?: string | null, sampledBy?: string | null, samplePictures?: any | null, reminderForExpiration?: any | null, officeId?: number | null, samplingDate?: any | null, commodityType: string, sampleShipmentId?: number | null, archivedAt?: any | null, deletedAt?: any | null, ref?: string | null }> };

export type GetShipmentFulfillmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShipmentFulfillmentsQuery = { __typename?: 'query_root', shipmentFulfillments: Array<{ __typename?: 'shipmentFulfillments', agreementId: number, archivedAt?: any | null, createdAt: any, createdBy: string, date?: any | null, deletedAt?: any | null, id: number, itemId: number, quantity?: number | null, status?: string | null, updatedAt: any, uom?: string | null, comments?: string | null, files?: any | null, currency?: string | null, commissionAmount?: number | null }> };

export type GetTrackingsByTrackingNumberQueryVariables = Exact<{
  trackingNumber: Scalars['String'];
}>;


export type GetTrackingsByTrackingNumberQuery = { __typename?: 'query_root', trackings: Array<{ __typename?: 'trackings', aftershipId: string, id: number, res?: any | null, slug?: string | null, trackingNumber: string, status?: string | null }> };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserByIdQuery = { __typename?: 'query_root', users_by_pk?: { __typename?: 'users', firstname: string, language: string, lastname: string, id: string, isManager: boolean, isAdmin: boolean, officeId?: number | null, savedFormFields: any, savedColumns: any, role: string, contactId?: number | null, lastReleasesViewDate?: any | null, contact?: { __typename?: 'contacts', companyId?: number | null, company?: { __typename?: 'companies', officeId?: number | null, brokerId?: string | null, name: string } | null } | null } | null };

export type InsertUserOneMutationVariables = Exact<{
  user: Users_Insert_Input;
}>;


export type InsertUserOneMutation = { __typename?: 'mutation_root', insert_users_one?: { __typename?: 'users', firstname: string, language: string, lastname: string, id: string, savedFormFields: any, savedColumns: any, role: string } | null };

export type UpdateUserByPkMutationVariables = Exact<{
  id: Scalars['String'];
  partialUser: Users_Set_Input;
}>;


export type UpdateUserByPkMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: string } | null };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', firstname: string, id: string, lastname: string, isManager: boolean, isAdmin: boolean, officeId?: number | null, role: string }> };

export type GetUsersBonusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersBonusQuery = { __typename?: 'query_root', usersBonus: Array<{ __typename?: 'usersBonus', amount: number, currency: string, createdAt: any, id: number, updatedAt: any, usersId: string, year: number }> };

export type GetUsersCostsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersCostsQuery = { __typename?: 'query_root', usersCosts: Array<{ __typename?: 'usersCosts', amount: number, createdAt: any, currency: string, id: number, month: number, updatedAt: any, usersId: string, year: number }> };

export type GetValidationsContractsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetValidationsContractsQuery = { __typename?: 'query_root', validationsContracts: Array<{ __typename?: 'validationsContracts', companyId: number, contractId: number, id: number, comments?: string | null, createdBy: string, status: string, createdAt: any, updatedAt: any, signatoryContactId: number, signature?: string | null }> };

export type GetVarietalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVarietalsQuery = { __typename?: 'query_root', varietals: Array<{ __typename?: 'varietals', id: number, generic?: string | null, subGeneric?: string | null, varietal?: string | null }> };

export type GetVarietalsWithVectorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVarietalsWithVectorQuery = { __typename?: 'query_root', varietals: Array<{ __typename?: 'varietals', id: number, generic?: string | null, subGeneric?: string | null, varietal?: string | null, embedding?: any | null, vectorText?: string | null }> };



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  Boolean_comparison_exp: Boolean_Comparison_Exp;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  Float_comparison_exp: Float_Comparison_Exp;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  Int_comparison_exp: Int_Comparison_Exp;
  String: ResolverTypeWrapper<Scalars['String']>;
  String_comparison_exp: String_Comparison_Exp;
  addresses: ResolverTypeWrapper<Addresses>;
  addresses_aggregate: ResolverTypeWrapper<Addresses_Aggregate>;
  addresses_aggregate_fields: ResolverTypeWrapper<Addresses_Aggregate_Fields>;
  addresses_append_input: Addresses_Append_Input;
  addresses_avg_fields: ResolverTypeWrapper<Addresses_Avg_Fields>;
  addresses_bool_exp: Addresses_Bool_Exp;
  addresses_constraint: Addresses_Constraint;
  addresses_delete_at_path_input: Addresses_Delete_At_Path_Input;
  addresses_delete_elem_input: Addresses_Delete_Elem_Input;
  addresses_delete_key_input: Addresses_Delete_Key_Input;
  addresses_inc_input: Addresses_Inc_Input;
  addresses_insert_input: Addresses_Insert_Input;
  addresses_max_fields: ResolverTypeWrapper<Addresses_Max_Fields>;
  addresses_min_fields: ResolverTypeWrapper<Addresses_Min_Fields>;
  addresses_mutation_response: ResolverTypeWrapper<Addresses_Mutation_Response>;
  addresses_obj_rel_insert_input: Addresses_Obj_Rel_Insert_Input;
  addresses_on_conflict: Addresses_On_Conflict;
  addresses_order_by: Addresses_Order_By;
  addresses_pk_columns_input: Addresses_Pk_Columns_Input;
  addresses_prepend_input: Addresses_Prepend_Input;
  addresses_select_column: Addresses_Select_Column;
  addresses_set_input: Addresses_Set_Input;
  addresses_stddev_fields: ResolverTypeWrapper<Addresses_Stddev_Fields>;
  addresses_stddev_pop_fields: ResolverTypeWrapper<Addresses_Stddev_Pop_Fields>;
  addresses_stddev_samp_fields: ResolverTypeWrapper<Addresses_Stddev_Samp_Fields>;
  addresses_stream_cursor_input: Addresses_Stream_Cursor_Input;
  addresses_stream_cursor_value_input: Addresses_Stream_Cursor_Value_Input;
  addresses_sum_fields: ResolverTypeWrapper<Addresses_Sum_Fields>;
  addresses_update_column: Addresses_Update_Column;
  addresses_updates: Addresses_Updates;
  addresses_var_pop_fields: ResolverTypeWrapper<Addresses_Var_Pop_Fields>;
  addresses_var_samp_fields: ResolverTypeWrapper<Addresses_Var_Samp_Fields>;
  addresses_variance_fields: ResolverTypeWrapper<Addresses_Variance_Fields>;
  addresses_without_company: ResolverTypeWrapper<Addresses_Without_Company>;
  addresses_without_company_aggregate: ResolverTypeWrapper<Addresses_Without_Company_Aggregate>;
  addresses_without_company_aggregate_fields: ResolverTypeWrapper<Addresses_Without_Company_Aggregate_Fields>;
  addresses_without_company_avg_fields: ResolverTypeWrapper<Addresses_Without_Company_Avg_Fields>;
  addresses_without_company_bool_exp: Addresses_Without_Company_Bool_Exp;
  addresses_without_company_max_fields: ResolverTypeWrapper<Addresses_Without_Company_Max_Fields>;
  addresses_without_company_min_fields: ResolverTypeWrapper<Addresses_Without_Company_Min_Fields>;
  addresses_without_company_order_by: Addresses_Without_Company_Order_By;
  addresses_without_company_select_column: Addresses_Without_Company_Select_Column;
  addresses_without_company_stddev_fields: ResolverTypeWrapper<Addresses_Without_Company_Stddev_Fields>;
  addresses_without_company_stddev_pop_fields: ResolverTypeWrapper<Addresses_Without_Company_Stddev_Pop_Fields>;
  addresses_without_company_stddev_samp_fields: ResolverTypeWrapper<Addresses_Without_Company_Stddev_Samp_Fields>;
  addresses_without_company_stream_cursor_input: Addresses_Without_Company_Stream_Cursor_Input;
  addresses_without_company_stream_cursor_value_input: Addresses_Without_Company_Stream_Cursor_Value_Input;
  addresses_without_company_sum_fields: ResolverTypeWrapper<Addresses_Without_Company_Sum_Fields>;
  addresses_without_company_var_pop_fields: ResolverTypeWrapper<Addresses_Without_Company_Var_Pop_Fields>;
  addresses_without_company_var_samp_fields: ResolverTypeWrapper<Addresses_Without_Company_Var_Samp_Fields>;
  addresses_without_company_variance_fields: ResolverTypeWrapper<Addresses_Without_Company_Variance_Fields>;
  agreementTerms: ResolverTypeWrapper<AgreementTerms>;
  agreementTerms_aggregate: ResolverTypeWrapper<AgreementTerms_Aggregate>;
  agreementTerms_aggregate_fields: ResolverTypeWrapper<AgreementTerms_Aggregate_Fields>;
  agreementTerms_avg_fields: ResolverTypeWrapper<AgreementTerms_Avg_Fields>;
  agreementTerms_bool_exp: AgreementTerms_Bool_Exp;
  agreementTerms_constraint: AgreementTerms_Constraint;
  agreementTerms_inc_input: AgreementTerms_Inc_Input;
  agreementTerms_insert_input: AgreementTerms_Insert_Input;
  agreementTerms_max_fields: ResolverTypeWrapper<AgreementTerms_Max_Fields>;
  agreementTerms_min_fields: ResolverTypeWrapper<AgreementTerms_Min_Fields>;
  agreementTerms_mutation_response: ResolverTypeWrapper<AgreementTerms_Mutation_Response>;
  agreementTerms_on_conflict: AgreementTerms_On_Conflict;
  agreementTerms_order_by: AgreementTerms_Order_By;
  agreementTerms_pk_columns_input: AgreementTerms_Pk_Columns_Input;
  agreementTerms_select_column: AgreementTerms_Select_Column;
  agreementTerms_set_input: AgreementTerms_Set_Input;
  agreementTerms_stddev_fields: ResolverTypeWrapper<AgreementTerms_Stddev_Fields>;
  agreementTerms_stddev_pop_fields: ResolverTypeWrapper<AgreementTerms_Stddev_Pop_Fields>;
  agreementTerms_stddev_samp_fields: ResolverTypeWrapper<AgreementTerms_Stddev_Samp_Fields>;
  agreementTerms_stream_cursor_input: AgreementTerms_Stream_Cursor_Input;
  agreementTerms_stream_cursor_value_input: AgreementTerms_Stream_Cursor_Value_Input;
  agreementTerms_sum_fields: ResolverTypeWrapper<AgreementTerms_Sum_Fields>;
  agreementTerms_update_column: AgreementTerms_Update_Column;
  agreementTerms_updates: AgreementTerms_Updates;
  agreementTerms_var_pop_fields: ResolverTypeWrapper<AgreementTerms_Var_Pop_Fields>;
  agreementTerms_var_samp_fields: ResolverTypeWrapper<AgreementTerms_Var_Samp_Fields>;
  agreementTerms_variance_fields: ResolverTypeWrapper<AgreementTerms_Variance_Fields>;
  agreements: ResolverTypeWrapper<Agreements>;
  agreements_aggregate: ResolverTypeWrapper<Agreements_Aggregate>;
  agreements_aggregate_bool_exp: Agreements_Aggregate_Bool_Exp;
  agreements_aggregate_bool_exp_bool_and: Agreements_Aggregate_Bool_Exp_Bool_And;
  agreements_aggregate_bool_exp_bool_or: Agreements_Aggregate_Bool_Exp_Bool_Or;
  agreements_aggregate_bool_exp_count: Agreements_Aggregate_Bool_Exp_Count;
  agreements_aggregate_fields: ResolverTypeWrapper<Agreements_Aggregate_Fields>;
  agreements_aggregate_order_by: Agreements_Aggregate_Order_By;
  agreements_append_input: Agreements_Append_Input;
  agreements_arr_rel_insert_input: Agreements_Arr_Rel_Insert_Input;
  agreements_avg_fields: ResolverTypeWrapper<Agreements_Avg_Fields>;
  agreements_avg_order_by: Agreements_Avg_Order_By;
  agreements_bool_exp: Agreements_Bool_Exp;
  agreements_constraint: Agreements_Constraint;
  agreements_delete_at_path_input: Agreements_Delete_At_Path_Input;
  agreements_delete_elem_input: Agreements_Delete_Elem_Input;
  agreements_delete_key_input: Agreements_Delete_Key_Input;
  agreements_inc_input: Agreements_Inc_Input;
  agreements_insert_input: Agreements_Insert_Input;
  agreements_max_fields: ResolverTypeWrapper<Agreements_Max_Fields>;
  agreements_max_order_by: Agreements_Max_Order_By;
  agreements_min_fields: ResolverTypeWrapper<Agreements_Min_Fields>;
  agreements_min_order_by: Agreements_Min_Order_By;
  agreements_mutation_response: ResolverTypeWrapper<Agreements_Mutation_Response>;
  agreements_obj_rel_insert_input: Agreements_Obj_Rel_Insert_Input;
  agreements_on_conflict: Agreements_On_Conflict;
  agreements_order_by: Agreements_Order_By;
  agreements_pk_columns_input: Agreements_Pk_Columns_Input;
  agreements_prepend_input: Agreements_Prepend_Input;
  agreements_select_column: Agreements_Select_Column;
  agreements_select_column_agreements_aggregate_bool_exp_bool_and_arguments_columns: Agreements_Select_Column_Agreements_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  agreements_select_column_agreements_aggregate_bool_exp_bool_or_arguments_columns: Agreements_Select_Column_Agreements_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  agreements_set_input: Agreements_Set_Input;
  agreements_stddev_fields: ResolverTypeWrapper<Agreements_Stddev_Fields>;
  agreements_stddev_order_by: Agreements_Stddev_Order_By;
  agreements_stddev_pop_fields: ResolverTypeWrapper<Agreements_Stddev_Pop_Fields>;
  agreements_stddev_pop_order_by: Agreements_Stddev_Pop_Order_By;
  agreements_stddev_samp_fields: ResolverTypeWrapper<Agreements_Stddev_Samp_Fields>;
  agreements_stddev_samp_order_by: Agreements_Stddev_Samp_Order_By;
  agreements_stream_cursor_input: Agreements_Stream_Cursor_Input;
  agreements_stream_cursor_value_input: Agreements_Stream_Cursor_Value_Input;
  agreements_sum_fields: ResolverTypeWrapper<Agreements_Sum_Fields>;
  agreements_sum_order_by: Agreements_Sum_Order_By;
  agreements_update_column: Agreements_Update_Column;
  agreements_updates: Agreements_Updates;
  agreements_var_pop_fields: ResolverTypeWrapper<Agreements_Var_Pop_Fields>;
  agreements_var_pop_order_by: Agreements_Var_Pop_Order_By;
  agreements_var_samp_fields: ResolverTypeWrapper<Agreements_Var_Samp_Fields>;
  agreements_var_samp_order_by: Agreements_Var_Samp_Order_By;
  agreements_variance_fields: ResolverTypeWrapper<Agreements_Variance_Fields>;
  agreements_variance_order_by: Agreements_Variance_Order_By;
  appellations: ResolverTypeWrapper<Appellations>;
  appellations_aggregate: ResolverTypeWrapper<Appellations_Aggregate>;
  appellations_aggregate_fields: ResolverTypeWrapper<Appellations_Aggregate_Fields>;
  appellations_avg_fields: ResolverTypeWrapper<Appellations_Avg_Fields>;
  appellations_bool_exp: Appellations_Bool_Exp;
  appellations_constraint: Appellations_Constraint;
  appellations_inc_input: Appellations_Inc_Input;
  appellations_insert_input: Appellations_Insert_Input;
  appellations_max_fields: ResolverTypeWrapper<Appellations_Max_Fields>;
  appellations_min_fields: ResolverTypeWrapper<Appellations_Min_Fields>;
  appellations_mutation_response: ResolverTypeWrapper<Appellations_Mutation_Response>;
  appellations_on_conflict: Appellations_On_Conflict;
  appellations_order_by: Appellations_Order_By;
  appellations_pk_columns_input: Appellations_Pk_Columns_Input;
  appellations_select_column: Appellations_Select_Column;
  appellations_set_input: Appellations_Set_Input;
  appellations_stddev_fields: ResolverTypeWrapper<Appellations_Stddev_Fields>;
  appellations_stddev_pop_fields: ResolverTypeWrapper<Appellations_Stddev_Pop_Fields>;
  appellations_stddev_samp_fields: ResolverTypeWrapper<Appellations_Stddev_Samp_Fields>;
  appellations_stream_cursor_input: Appellations_Stream_Cursor_Input;
  appellations_stream_cursor_value_input: Appellations_Stream_Cursor_Value_Input;
  appellations_sum_fields: ResolverTypeWrapper<Appellations_Sum_Fields>;
  appellations_update_column: Appellations_Update_Column;
  appellations_updates: Appellations_Updates;
  appellations_var_pop_fields: ResolverTypeWrapper<Appellations_Var_Pop_Fields>;
  appellations_var_samp_fields: ResolverTypeWrapper<Appellations_Var_Samp_Fields>;
  appellations_variance_fields: ResolverTypeWrapper<Appellations_Variance_Fields>;
  authorizedDomains: ResolverTypeWrapper<AuthorizedDomains>;
  authorizedDomains_aggregate: ResolverTypeWrapper<AuthorizedDomains_Aggregate>;
  authorizedDomains_aggregate_fields: ResolverTypeWrapper<AuthorizedDomains_Aggregate_Fields>;
  authorizedDomains_avg_fields: ResolverTypeWrapper<AuthorizedDomains_Avg_Fields>;
  authorizedDomains_bool_exp: AuthorizedDomains_Bool_Exp;
  authorizedDomains_constraint: AuthorizedDomains_Constraint;
  authorizedDomains_inc_input: AuthorizedDomains_Inc_Input;
  authorizedDomains_insert_input: AuthorizedDomains_Insert_Input;
  authorizedDomains_max_fields: ResolverTypeWrapper<AuthorizedDomains_Max_Fields>;
  authorizedDomains_min_fields: ResolverTypeWrapper<AuthorizedDomains_Min_Fields>;
  authorizedDomains_mutation_response: ResolverTypeWrapper<AuthorizedDomains_Mutation_Response>;
  authorizedDomains_on_conflict: AuthorizedDomains_On_Conflict;
  authorizedDomains_order_by: AuthorizedDomains_Order_By;
  authorizedDomains_pk_columns_input: AuthorizedDomains_Pk_Columns_Input;
  authorizedDomains_select_column: AuthorizedDomains_Select_Column;
  authorizedDomains_set_input: AuthorizedDomains_Set_Input;
  authorizedDomains_stddev_fields: ResolverTypeWrapper<AuthorizedDomains_Stddev_Fields>;
  authorizedDomains_stddev_pop_fields: ResolverTypeWrapper<AuthorizedDomains_Stddev_Pop_Fields>;
  authorizedDomains_stddev_samp_fields: ResolverTypeWrapper<AuthorizedDomains_Stddev_Samp_Fields>;
  authorizedDomains_stream_cursor_input: AuthorizedDomains_Stream_Cursor_Input;
  authorizedDomains_stream_cursor_value_input: AuthorizedDomains_Stream_Cursor_Value_Input;
  authorizedDomains_sum_fields: ResolverTypeWrapper<AuthorizedDomains_Sum_Fields>;
  authorizedDomains_update_column: AuthorizedDomains_Update_Column;
  authorizedDomains_updates: AuthorizedDomains_Updates;
  authorizedDomains_var_pop_fields: ResolverTypeWrapper<AuthorizedDomains_Var_Pop_Fields>;
  authorizedDomains_var_samp_fields: ResolverTypeWrapper<AuthorizedDomains_Var_Samp_Fields>;
  authorizedDomains_variance_fields: ResolverTypeWrapper<AuthorizedDomains_Variance_Fields>;
  buySpecs: ResolverTypeWrapper<BuySpecs>;
  buySpecs_aggregate: ResolverTypeWrapper<BuySpecs_Aggregate>;
  buySpecs_aggregate_fields: ResolverTypeWrapper<BuySpecs_Aggregate_Fields>;
  buySpecs_append_input: BuySpecs_Append_Input;
  buySpecs_avg_fields: ResolverTypeWrapper<BuySpecs_Avg_Fields>;
  buySpecs_bool_exp: BuySpecs_Bool_Exp;
  buySpecs_constraint: BuySpecs_Constraint;
  buySpecs_delete_at_path_input: BuySpecs_Delete_At_Path_Input;
  buySpecs_delete_elem_input: BuySpecs_Delete_Elem_Input;
  buySpecs_delete_key_input: BuySpecs_Delete_Key_Input;
  buySpecs_inc_input: BuySpecs_Inc_Input;
  buySpecs_insert_input: BuySpecs_Insert_Input;
  buySpecs_max_fields: ResolverTypeWrapper<BuySpecs_Max_Fields>;
  buySpecs_min_fields: ResolverTypeWrapper<BuySpecs_Min_Fields>;
  buySpecs_mutation_response: ResolverTypeWrapper<BuySpecs_Mutation_Response>;
  buySpecs_obj_rel_insert_input: BuySpecs_Obj_Rel_Insert_Input;
  buySpecs_on_conflict: BuySpecs_On_Conflict;
  buySpecs_order_by: BuySpecs_Order_By;
  buySpecs_pk_columns_input: BuySpecs_Pk_Columns_Input;
  buySpecs_prepend_input: BuySpecs_Prepend_Input;
  buySpecs_select_column: BuySpecs_Select_Column;
  buySpecs_set_input: BuySpecs_Set_Input;
  buySpecs_stddev_fields: ResolverTypeWrapper<BuySpecs_Stddev_Fields>;
  buySpecs_stddev_pop_fields: ResolverTypeWrapper<BuySpecs_Stddev_Pop_Fields>;
  buySpecs_stddev_samp_fields: ResolverTypeWrapper<BuySpecs_Stddev_Samp_Fields>;
  buySpecs_stream_cursor_input: BuySpecs_Stream_Cursor_Input;
  buySpecs_stream_cursor_value_input: BuySpecs_Stream_Cursor_Value_Input;
  buySpecs_sum_fields: ResolverTypeWrapper<BuySpecs_Sum_Fields>;
  buySpecs_update_column: BuySpecs_Update_Column;
  buySpecs_updates: BuySpecs_Updates;
  buySpecs_var_pop_fields: ResolverTypeWrapper<BuySpecs_Var_Pop_Fields>;
  buySpecs_var_samp_fields: ResolverTypeWrapper<BuySpecs_Var_Samp_Fields>;
  buySpecs_variance_fields: ResolverTypeWrapper<BuySpecs_Variance_Fields>;
  companies: ResolverTypeWrapper<Companies>;
  companies_aggregate: ResolverTypeWrapper<Companies_Aggregate>;
  companies_aggregate_fields: ResolverTypeWrapper<Companies_Aggregate_Fields>;
  companies_append_input: Companies_Append_Input;
  companies_avg_fields: ResolverTypeWrapper<Companies_Avg_Fields>;
  companies_bool_exp: Companies_Bool_Exp;
  companies_constraint: Companies_Constraint;
  companies_delete_at_path_input: Companies_Delete_At_Path_Input;
  companies_delete_elem_input: Companies_Delete_Elem_Input;
  companies_delete_key_input: Companies_Delete_Key_Input;
  companies_inc_input: Companies_Inc_Input;
  companies_insert_input: Companies_Insert_Input;
  companies_max_fields: ResolverTypeWrapper<Companies_Max_Fields>;
  companies_min_fields: ResolverTypeWrapper<Companies_Min_Fields>;
  companies_mutation_response: ResolverTypeWrapper<Companies_Mutation_Response>;
  companies_obj_rel_insert_input: Companies_Obj_Rel_Insert_Input;
  companies_on_conflict: Companies_On_Conflict;
  companies_order_by: Companies_Order_By;
  companies_pk_columns_input: Companies_Pk_Columns_Input;
  companies_prepend_input: Companies_Prepend_Input;
  companies_select_column: Companies_Select_Column;
  companies_set_input: Companies_Set_Input;
  companies_stddev_fields: ResolverTypeWrapper<Companies_Stddev_Fields>;
  companies_stddev_pop_fields: ResolverTypeWrapper<Companies_Stddev_Pop_Fields>;
  companies_stddev_samp_fields: ResolverTypeWrapper<Companies_Stddev_Samp_Fields>;
  companies_stream_cursor_input: Companies_Stream_Cursor_Input;
  companies_stream_cursor_value_input: Companies_Stream_Cursor_Value_Input;
  companies_sum_fields: ResolverTypeWrapper<Companies_Sum_Fields>;
  companies_update_column: Companies_Update_Column;
  companies_updates: Companies_Updates;
  companies_var_pop_fields: ResolverTypeWrapper<Companies_Var_Pop_Fields>;
  companies_var_samp_fields: ResolverTypeWrapper<Companies_Var_Samp_Fields>;
  companies_variance_fields: ResolverTypeWrapper<Companies_Variance_Fields>;
  companyAddress: ResolverTypeWrapper<CompanyAddress>;
  companyAddress_aggregate: ResolverTypeWrapper<CompanyAddress_Aggregate>;
  companyAddress_aggregate_bool_exp: CompanyAddress_Aggregate_Bool_Exp;
  companyAddress_aggregate_bool_exp_count: CompanyAddress_Aggregate_Bool_Exp_Count;
  companyAddress_aggregate_fields: ResolverTypeWrapper<CompanyAddress_Aggregate_Fields>;
  companyAddress_aggregate_order_by: CompanyAddress_Aggregate_Order_By;
  companyAddress_arr_rel_insert_input: CompanyAddress_Arr_Rel_Insert_Input;
  companyAddress_avg_fields: ResolverTypeWrapper<CompanyAddress_Avg_Fields>;
  companyAddress_avg_order_by: CompanyAddress_Avg_Order_By;
  companyAddress_bool_exp: CompanyAddress_Bool_Exp;
  companyAddress_constraint: CompanyAddress_Constraint;
  companyAddress_inc_input: CompanyAddress_Inc_Input;
  companyAddress_insert_input: CompanyAddress_Insert_Input;
  companyAddress_max_fields: ResolverTypeWrapper<CompanyAddress_Max_Fields>;
  companyAddress_max_order_by: CompanyAddress_Max_Order_By;
  companyAddress_min_fields: ResolverTypeWrapper<CompanyAddress_Min_Fields>;
  companyAddress_min_order_by: CompanyAddress_Min_Order_By;
  companyAddress_mutation_response: ResolverTypeWrapper<CompanyAddress_Mutation_Response>;
  companyAddress_on_conflict: CompanyAddress_On_Conflict;
  companyAddress_order_by: CompanyAddress_Order_By;
  companyAddress_pk_columns_input: CompanyAddress_Pk_Columns_Input;
  companyAddress_select_column: CompanyAddress_Select_Column;
  companyAddress_set_input: CompanyAddress_Set_Input;
  companyAddress_stddev_fields: ResolverTypeWrapper<CompanyAddress_Stddev_Fields>;
  companyAddress_stddev_order_by: CompanyAddress_Stddev_Order_By;
  companyAddress_stddev_pop_fields: ResolverTypeWrapper<CompanyAddress_Stddev_Pop_Fields>;
  companyAddress_stddev_pop_order_by: CompanyAddress_Stddev_Pop_Order_By;
  companyAddress_stddev_samp_fields: ResolverTypeWrapper<CompanyAddress_Stddev_Samp_Fields>;
  companyAddress_stddev_samp_order_by: CompanyAddress_Stddev_Samp_Order_By;
  companyAddress_stream_cursor_input: CompanyAddress_Stream_Cursor_Input;
  companyAddress_stream_cursor_value_input: CompanyAddress_Stream_Cursor_Value_Input;
  companyAddress_sum_fields: ResolverTypeWrapper<CompanyAddress_Sum_Fields>;
  companyAddress_sum_order_by: CompanyAddress_Sum_Order_By;
  companyAddress_update_column: CompanyAddress_Update_Column;
  companyAddress_updates: CompanyAddress_Updates;
  companyAddress_var_pop_fields: ResolverTypeWrapper<CompanyAddress_Var_Pop_Fields>;
  companyAddress_var_pop_order_by: CompanyAddress_Var_Pop_Order_By;
  companyAddress_var_samp_fields: ResolverTypeWrapper<CompanyAddress_Var_Samp_Fields>;
  companyAddress_var_samp_order_by: CompanyAddress_Var_Samp_Order_By;
  companyAddress_variance_fields: ResolverTypeWrapper<CompanyAddress_Variance_Fields>;
  companyAddress_variance_order_by: CompanyAddress_Variance_Order_By;
  contacts: ResolverTypeWrapper<Contacts>;
  contacts_aggregate: ResolverTypeWrapper<Contacts_Aggregate>;
  contacts_aggregate_fields: ResolverTypeWrapper<Contacts_Aggregate_Fields>;
  contacts_append_input: Contacts_Append_Input;
  contacts_avg_fields: ResolverTypeWrapper<Contacts_Avg_Fields>;
  contacts_bool_exp: Contacts_Bool_Exp;
  contacts_constraint: Contacts_Constraint;
  contacts_delete_at_path_input: Contacts_Delete_At_Path_Input;
  contacts_delete_elem_input: Contacts_Delete_Elem_Input;
  contacts_delete_key_input: Contacts_Delete_Key_Input;
  contacts_inc_input: Contacts_Inc_Input;
  contacts_insert_input: Contacts_Insert_Input;
  contacts_max_fields: ResolverTypeWrapper<Contacts_Max_Fields>;
  contacts_min_fields: ResolverTypeWrapper<Contacts_Min_Fields>;
  contacts_mutation_response: ResolverTypeWrapper<Contacts_Mutation_Response>;
  contacts_obj_rel_insert_input: Contacts_Obj_Rel_Insert_Input;
  contacts_on_conflict: Contacts_On_Conflict;
  contacts_order_by: Contacts_Order_By;
  contacts_pk_columns_input: Contacts_Pk_Columns_Input;
  contacts_prepend_input: Contacts_Prepend_Input;
  contacts_select_column: Contacts_Select_Column;
  contacts_set_input: Contacts_Set_Input;
  contacts_stddev_fields: ResolverTypeWrapper<Contacts_Stddev_Fields>;
  contacts_stddev_pop_fields: ResolverTypeWrapper<Contacts_Stddev_Pop_Fields>;
  contacts_stddev_samp_fields: ResolverTypeWrapper<Contacts_Stddev_Samp_Fields>;
  contacts_stream_cursor_input: Contacts_Stream_Cursor_Input;
  contacts_stream_cursor_value_input: Contacts_Stream_Cursor_Value_Input;
  contacts_sum_fields: ResolverTypeWrapper<Contacts_Sum_Fields>;
  contacts_update_column: Contacts_Update_Column;
  contacts_updates: Contacts_Updates;
  contacts_var_pop_fields: ResolverTypeWrapper<Contacts_Var_Pop_Fields>;
  contacts_var_samp_fields: ResolverTypeWrapper<Contacts_Var_Samp_Fields>;
  contacts_variance_fields: ResolverTypeWrapper<Contacts_Variance_Fields>;
  contacts_without_company: ResolverTypeWrapper<Contacts_Without_Company>;
  contacts_without_company_aggregate: ResolverTypeWrapper<Contacts_Without_Company_Aggregate>;
  contacts_without_company_aggregate_fields: ResolverTypeWrapper<Contacts_Without_Company_Aggregate_Fields>;
  contacts_without_company_avg_fields: ResolverTypeWrapper<Contacts_Without_Company_Avg_Fields>;
  contacts_without_company_bool_exp: Contacts_Without_Company_Bool_Exp;
  contacts_without_company_max_fields: ResolverTypeWrapper<Contacts_Without_Company_Max_Fields>;
  contacts_without_company_min_fields: ResolverTypeWrapper<Contacts_Without_Company_Min_Fields>;
  contacts_without_company_order_by: Contacts_Without_Company_Order_By;
  contacts_without_company_select_column: Contacts_Without_Company_Select_Column;
  contacts_without_company_stddev_fields: ResolverTypeWrapper<Contacts_Without_Company_Stddev_Fields>;
  contacts_without_company_stddev_pop_fields: ResolverTypeWrapper<Contacts_Without_Company_Stddev_Pop_Fields>;
  contacts_without_company_stddev_samp_fields: ResolverTypeWrapper<Contacts_Without_Company_Stddev_Samp_Fields>;
  contacts_without_company_stream_cursor_input: Contacts_Without_Company_Stream_Cursor_Input;
  contacts_without_company_stream_cursor_value_input: Contacts_Without_Company_Stream_Cursor_Value_Input;
  contacts_without_company_sum_fields: ResolverTypeWrapper<Contacts_Without_Company_Sum_Fields>;
  contacts_without_company_var_pop_fields: ResolverTypeWrapper<Contacts_Without_Company_Var_Pop_Fields>;
  contacts_without_company_var_samp_fields: ResolverTypeWrapper<Contacts_Without_Company_Var_Samp_Fields>;
  contacts_without_company_variance_fields: ResolverTypeWrapper<Contacts_Without_Company_Variance_Fields>;
  contracts: ResolverTypeWrapper<Contracts>;
  contracts_aggregate: ResolverTypeWrapper<Contracts_Aggregate>;
  contracts_aggregate_fields: ResolverTypeWrapper<Contracts_Aggregate_Fields>;
  contracts_avg_fields: ResolverTypeWrapper<Contracts_Avg_Fields>;
  contracts_bool_exp: Contracts_Bool_Exp;
  contracts_constraint: Contracts_Constraint;
  contracts_inc_input: Contracts_Inc_Input;
  contracts_insert_input: Contracts_Insert_Input;
  contracts_max_fields: ResolverTypeWrapper<Contracts_Max_Fields>;
  contracts_min_fields: ResolverTypeWrapper<Contracts_Min_Fields>;
  contracts_mutation_response: ResolverTypeWrapper<Contracts_Mutation_Response>;
  contracts_obj_rel_insert_input: Contracts_Obj_Rel_Insert_Input;
  contracts_on_conflict: Contracts_On_Conflict;
  contracts_order_by: Contracts_Order_By;
  contracts_pk_columns_input: Contracts_Pk_Columns_Input;
  contracts_select_column: Contracts_Select_Column;
  contracts_set_input: Contracts_Set_Input;
  contracts_stddev_fields: ResolverTypeWrapper<Contracts_Stddev_Fields>;
  contracts_stddev_pop_fields: ResolverTypeWrapper<Contracts_Stddev_Pop_Fields>;
  contracts_stddev_samp_fields: ResolverTypeWrapper<Contracts_Stddev_Samp_Fields>;
  contracts_stream_cursor_input: Contracts_Stream_Cursor_Input;
  contracts_stream_cursor_value_input: Contracts_Stream_Cursor_Value_Input;
  contracts_sum_fields: ResolverTypeWrapper<Contracts_Sum_Fields>;
  contracts_update_column: Contracts_Update_Column;
  contracts_updates: Contracts_Updates;
  contracts_var_pop_fields: ResolverTypeWrapper<Contracts_Var_Pop_Fields>;
  contracts_var_samp_fields: ResolverTypeWrapper<Contracts_Var_Samp_Fields>;
  contracts_variance_fields: ResolverTypeWrapper<Contracts_Variance_Fields>;
  currenciesConversions: ResolverTypeWrapper<CurrenciesConversions>;
  currenciesConversions_aggregate: ResolverTypeWrapper<CurrenciesConversions_Aggregate>;
  currenciesConversions_aggregate_fields: ResolverTypeWrapper<CurrenciesConversions_Aggregate_Fields>;
  currenciesConversions_append_input: CurrenciesConversions_Append_Input;
  currenciesConversions_avg_fields: ResolverTypeWrapper<CurrenciesConversions_Avg_Fields>;
  currenciesConversions_bool_exp: CurrenciesConversions_Bool_Exp;
  currenciesConversions_constraint: CurrenciesConversions_Constraint;
  currenciesConversions_delete_at_path_input: CurrenciesConversions_Delete_At_Path_Input;
  currenciesConversions_delete_elem_input: CurrenciesConversions_Delete_Elem_Input;
  currenciesConversions_delete_key_input: CurrenciesConversions_Delete_Key_Input;
  currenciesConversions_inc_input: CurrenciesConversions_Inc_Input;
  currenciesConversions_insert_input: CurrenciesConversions_Insert_Input;
  currenciesConversions_max_fields: ResolverTypeWrapper<CurrenciesConversions_Max_Fields>;
  currenciesConversions_min_fields: ResolverTypeWrapper<CurrenciesConversions_Min_Fields>;
  currenciesConversions_mutation_response: ResolverTypeWrapper<CurrenciesConversions_Mutation_Response>;
  currenciesConversions_on_conflict: CurrenciesConversions_On_Conflict;
  currenciesConversions_order_by: CurrenciesConversions_Order_By;
  currenciesConversions_pk_columns_input: CurrenciesConversions_Pk_Columns_Input;
  currenciesConversions_prepend_input: CurrenciesConversions_Prepend_Input;
  currenciesConversions_select_column: CurrenciesConversions_Select_Column;
  currenciesConversions_set_input: CurrenciesConversions_Set_Input;
  currenciesConversions_stddev_fields: ResolverTypeWrapper<CurrenciesConversions_Stddev_Fields>;
  currenciesConversions_stddev_pop_fields: ResolverTypeWrapper<CurrenciesConversions_Stddev_Pop_Fields>;
  currenciesConversions_stddev_samp_fields: ResolverTypeWrapper<CurrenciesConversions_Stddev_Samp_Fields>;
  currenciesConversions_stream_cursor_input: CurrenciesConversions_Stream_Cursor_Input;
  currenciesConversions_stream_cursor_value_input: CurrenciesConversions_Stream_Cursor_Value_Input;
  currenciesConversions_sum_fields: ResolverTypeWrapper<CurrenciesConversions_Sum_Fields>;
  currenciesConversions_update_column: CurrenciesConversions_Update_Column;
  currenciesConversions_updates: CurrenciesConversions_Updates;
  currenciesConversions_var_pop_fields: ResolverTypeWrapper<CurrenciesConversions_Var_Pop_Fields>;
  currenciesConversions_var_samp_fields: ResolverTypeWrapper<CurrenciesConversions_Var_Samp_Fields>;
  currenciesConversions_variance_fields: ResolverTypeWrapper<CurrenciesConversions_Variance_Fields>;
  cursor_ordering: Cursor_Ordering;
  date: ResolverTypeWrapper<Scalars['date']>;
  date_comparison_exp: Date_Comparison_Exp;
  history: ResolverTypeWrapper<History>;
  history_aggregate: ResolverTypeWrapper<History_Aggregate>;
  history_aggregate_fields: ResolverTypeWrapper<History_Aggregate_Fields>;
  history_append_input: History_Append_Input;
  history_avg_fields: ResolverTypeWrapper<History_Avg_Fields>;
  history_bool_exp: History_Bool_Exp;
  history_constraint: History_Constraint;
  history_delete_at_path_input: History_Delete_At_Path_Input;
  history_delete_elem_input: History_Delete_Elem_Input;
  history_delete_key_input: History_Delete_Key_Input;
  history_inc_input: History_Inc_Input;
  history_insert_input: History_Insert_Input;
  history_max_fields: ResolverTypeWrapper<History_Max_Fields>;
  history_min_fields: ResolverTypeWrapper<History_Min_Fields>;
  history_mutation_response: ResolverTypeWrapper<History_Mutation_Response>;
  history_obj_rel_insert_input: History_Obj_Rel_Insert_Input;
  history_on_conflict: History_On_Conflict;
  history_order_by: History_Order_By;
  history_pk_columns_input: History_Pk_Columns_Input;
  history_prepend_input: History_Prepend_Input;
  history_select_column: History_Select_Column;
  history_set_input: History_Set_Input;
  history_stddev_fields: ResolverTypeWrapper<History_Stddev_Fields>;
  history_stddev_pop_fields: ResolverTypeWrapper<History_Stddev_Pop_Fields>;
  history_stddev_samp_fields: ResolverTypeWrapper<History_Stddev_Samp_Fields>;
  history_stream_cursor_input: History_Stream_Cursor_Input;
  history_stream_cursor_value_input: History_Stream_Cursor_Value_Input;
  history_sum_fields: ResolverTypeWrapper<History_Sum_Fields>;
  history_update_column: History_Update_Column;
  history_updates: History_Updates;
  history_var_pop_fields: ResolverTypeWrapper<History_Var_Pop_Fields>;
  history_var_samp_fields: ResolverTypeWrapper<History_Var_Samp_Fields>;
  history_variance_fields: ResolverTypeWrapper<History_Variance_Fields>;
  invoices: ResolverTypeWrapper<Invoices>;
  invoices_aggregate: ResolverTypeWrapper<Invoices_Aggregate>;
  invoices_aggregate_bool_exp: Invoices_Aggregate_Bool_Exp;
  invoices_aggregate_bool_exp_count: Invoices_Aggregate_Bool_Exp_Count;
  invoices_aggregate_fields: ResolverTypeWrapper<Invoices_Aggregate_Fields>;
  invoices_aggregate_order_by: Invoices_Aggregate_Order_By;
  invoices_append_input: Invoices_Append_Input;
  invoices_arr_rel_insert_input: Invoices_Arr_Rel_Insert_Input;
  invoices_avg_fields: ResolverTypeWrapper<Invoices_Avg_Fields>;
  invoices_avg_order_by: Invoices_Avg_Order_By;
  invoices_bool_exp: Invoices_Bool_Exp;
  invoices_constraint: Invoices_Constraint;
  invoices_delete_at_path_input: Invoices_Delete_At_Path_Input;
  invoices_delete_elem_input: Invoices_Delete_Elem_Input;
  invoices_delete_key_input: Invoices_Delete_Key_Input;
  invoices_inc_input: Invoices_Inc_Input;
  invoices_insert_input: Invoices_Insert_Input;
  invoices_max_fields: ResolverTypeWrapper<Invoices_Max_Fields>;
  invoices_max_order_by: Invoices_Max_Order_By;
  invoices_min_fields: ResolverTypeWrapper<Invoices_Min_Fields>;
  invoices_min_order_by: Invoices_Min_Order_By;
  invoices_mutation_response: ResolverTypeWrapper<Invoices_Mutation_Response>;
  invoices_on_conflict: Invoices_On_Conflict;
  invoices_order_by: Invoices_Order_By;
  invoices_pk_columns_input: Invoices_Pk_Columns_Input;
  invoices_prepend_input: Invoices_Prepend_Input;
  invoices_select_column: Invoices_Select_Column;
  invoices_set_input: Invoices_Set_Input;
  invoices_stddev_fields: ResolverTypeWrapper<Invoices_Stddev_Fields>;
  invoices_stddev_order_by: Invoices_Stddev_Order_By;
  invoices_stddev_pop_fields: ResolverTypeWrapper<Invoices_Stddev_Pop_Fields>;
  invoices_stddev_pop_order_by: Invoices_Stddev_Pop_Order_By;
  invoices_stddev_samp_fields: ResolverTypeWrapper<Invoices_Stddev_Samp_Fields>;
  invoices_stddev_samp_order_by: Invoices_Stddev_Samp_Order_By;
  invoices_stream_cursor_input: Invoices_Stream_Cursor_Input;
  invoices_stream_cursor_value_input: Invoices_Stream_Cursor_Value_Input;
  invoices_sum_fields: ResolverTypeWrapper<Invoices_Sum_Fields>;
  invoices_sum_order_by: Invoices_Sum_Order_By;
  invoices_update_column: Invoices_Update_Column;
  invoices_updates: Invoices_Updates;
  invoices_var_pop_fields: ResolverTypeWrapper<Invoices_Var_Pop_Fields>;
  invoices_var_pop_order_by: Invoices_Var_Pop_Order_By;
  invoices_var_samp_fields: ResolverTypeWrapper<Invoices_Var_Samp_Fields>;
  invoices_var_samp_order_by: Invoices_Var_Samp_Order_By;
  invoices_variance_fields: ResolverTypeWrapper<Invoices_Variance_Fields>;
  invoices_variance_order_by: Invoices_Variance_Order_By;
  items: ResolverTypeWrapper<Items>;
  items_aggregate: ResolverTypeWrapper<Items_Aggregate>;
  items_aggregate_fields: ResolverTypeWrapper<Items_Aggregate_Fields>;
  items_append_input: Items_Append_Input;
  items_avg_fields: ResolverTypeWrapper<Items_Avg_Fields>;
  items_bool_exp: Items_Bool_Exp;
  items_constraint: Items_Constraint;
  items_delete_at_path_input: Items_Delete_At_Path_Input;
  items_delete_elem_input: Items_Delete_Elem_Input;
  items_delete_key_input: Items_Delete_Key_Input;
  items_inc_input: Items_Inc_Input;
  items_insert_input: Items_Insert_Input;
  items_max_fields: ResolverTypeWrapper<Items_Max_Fields>;
  items_min_fields: ResolverTypeWrapper<Items_Min_Fields>;
  items_mutation_response: ResolverTypeWrapper<Items_Mutation_Response>;
  items_obj_rel_insert_input: Items_Obj_Rel_Insert_Input;
  items_on_conflict: Items_On_Conflict;
  items_order_by: Items_Order_By;
  items_pk_columns_input: Items_Pk_Columns_Input;
  items_prepend_input: Items_Prepend_Input;
  items_select_column: Items_Select_Column;
  items_set_input: Items_Set_Input;
  items_stddev_fields: ResolverTypeWrapper<Items_Stddev_Fields>;
  items_stddev_pop_fields: ResolverTypeWrapper<Items_Stddev_Pop_Fields>;
  items_stddev_samp_fields: ResolverTypeWrapper<Items_Stddev_Samp_Fields>;
  items_stream_cursor_input: Items_Stream_Cursor_Input;
  items_stream_cursor_value_input: Items_Stream_Cursor_Value_Input;
  items_sum_fields: ResolverTypeWrapper<Items_Sum_Fields>;
  items_update_column: Items_Update_Column;
  items_updates: Items_Updates;
  items_var_pop_fields: ResolverTypeWrapper<Items_Var_Pop_Fields>;
  items_var_samp_fields: ResolverTypeWrapper<Items_Var_Samp_Fields>;
  items_variance_fields: ResolverTypeWrapper<Items_Variance_Fields>;
  jsonb: ResolverTypeWrapper<Scalars['jsonb']>;
  jsonb_cast_exp: Jsonb_Cast_Exp;
  jsonb_comparison_exp: Jsonb_Comparison_Exp;
  logs: ResolverTypeWrapper<Logs>;
  logs_aggregate: ResolverTypeWrapper<Logs_Aggregate>;
  logs_aggregate_fields: ResolverTypeWrapper<Logs_Aggregate_Fields>;
  logs_append_input: Logs_Append_Input;
  logs_avg_fields: ResolverTypeWrapper<Logs_Avg_Fields>;
  logs_bool_exp: Logs_Bool_Exp;
  logs_constraint: Logs_Constraint;
  logs_delete_at_path_input: Logs_Delete_At_Path_Input;
  logs_delete_elem_input: Logs_Delete_Elem_Input;
  logs_delete_key_input: Logs_Delete_Key_Input;
  logs_inc_input: Logs_Inc_Input;
  logs_insert_input: Logs_Insert_Input;
  logs_max_fields: ResolverTypeWrapper<Logs_Max_Fields>;
  logs_min_fields: ResolverTypeWrapper<Logs_Min_Fields>;
  logs_mutation_response: ResolverTypeWrapper<Logs_Mutation_Response>;
  logs_on_conflict: Logs_On_Conflict;
  logs_order_by: Logs_Order_By;
  logs_pk_columns_input: Logs_Pk_Columns_Input;
  logs_prepend_input: Logs_Prepend_Input;
  logs_select_column: Logs_Select_Column;
  logs_set_input: Logs_Set_Input;
  logs_stddev_fields: ResolverTypeWrapper<Logs_Stddev_Fields>;
  logs_stddev_pop_fields: ResolverTypeWrapper<Logs_Stddev_Pop_Fields>;
  logs_stddev_samp_fields: ResolverTypeWrapper<Logs_Stddev_Samp_Fields>;
  logs_stream_cursor_input: Logs_Stream_Cursor_Input;
  logs_stream_cursor_value_input: Logs_Stream_Cursor_Value_Input;
  logs_sum_fields: ResolverTypeWrapper<Logs_Sum_Fields>;
  logs_update_column: Logs_Update_Column;
  logs_updates: Logs_Updates;
  logs_var_pop_fields: ResolverTypeWrapper<Logs_Var_Pop_Fields>;
  logs_var_samp_fields: ResolverTypeWrapper<Logs_Var_Samp_Fields>;
  logs_variance_fields: ResolverTypeWrapper<Logs_Variance_Fields>;
  matchingItemsBuySpecs: ResolverTypeWrapper<MatchingItemsBuySpecs>;
  matchingItemsBuySpecs_aggregate: ResolverTypeWrapper<MatchingItemsBuySpecs_Aggregate>;
  matchingItemsBuySpecs_aggregate_bool_exp: MatchingItemsBuySpecs_Aggregate_Bool_Exp;
  matchingItemsBuySpecs_aggregate_bool_exp_count: MatchingItemsBuySpecs_Aggregate_Bool_Exp_Count;
  matchingItemsBuySpecs_aggregate_fields: ResolverTypeWrapper<MatchingItemsBuySpecs_Aggregate_Fields>;
  matchingItemsBuySpecs_aggregate_order_by: MatchingItemsBuySpecs_Aggregate_Order_By;
  matchingItemsBuySpecs_arr_rel_insert_input: MatchingItemsBuySpecs_Arr_Rel_Insert_Input;
  matchingItemsBuySpecs_avg_fields: ResolverTypeWrapper<MatchingItemsBuySpecs_Avg_Fields>;
  matchingItemsBuySpecs_avg_order_by: MatchingItemsBuySpecs_Avg_Order_By;
  matchingItemsBuySpecs_bool_exp: MatchingItemsBuySpecs_Bool_Exp;
  matchingItemsBuySpecs_constraint: MatchingItemsBuySpecs_Constraint;
  matchingItemsBuySpecs_inc_input: MatchingItemsBuySpecs_Inc_Input;
  matchingItemsBuySpecs_insert_input: MatchingItemsBuySpecs_Insert_Input;
  matchingItemsBuySpecs_max_fields: ResolverTypeWrapper<MatchingItemsBuySpecs_Max_Fields>;
  matchingItemsBuySpecs_max_order_by: MatchingItemsBuySpecs_Max_Order_By;
  matchingItemsBuySpecs_min_fields: ResolverTypeWrapper<MatchingItemsBuySpecs_Min_Fields>;
  matchingItemsBuySpecs_min_order_by: MatchingItemsBuySpecs_Min_Order_By;
  matchingItemsBuySpecs_mutation_response: ResolverTypeWrapper<MatchingItemsBuySpecs_Mutation_Response>;
  matchingItemsBuySpecs_on_conflict: MatchingItemsBuySpecs_On_Conflict;
  matchingItemsBuySpecs_order_by: MatchingItemsBuySpecs_Order_By;
  matchingItemsBuySpecs_pk_columns_input: MatchingItemsBuySpecs_Pk_Columns_Input;
  matchingItemsBuySpecs_select_column: MatchingItemsBuySpecs_Select_Column;
  matchingItemsBuySpecs_set_input: MatchingItemsBuySpecs_Set_Input;
  matchingItemsBuySpecs_stddev_fields: ResolverTypeWrapper<MatchingItemsBuySpecs_Stddev_Fields>;
  matchingItemsBuySpecs_stddev_order_by: MatchingItemsBuySpecs_Stddev_Order_By;
  matchingItemsBuySpecs_stddev_pop_fields: ResolverTypeWrapper<MatchingItemsBuySpecs_Stddev_Pop_Fields>;
  matchingItemsBuySpecs_stddev_pop_order_by: MatchingItemsBuySpecs_Stddev_Pop_Order_By;
  matchingItemsBuySpecs_stddev_samp_fields: ResolverTypeWrapper<MatchingItemsBuySpecs_Stddev_Samp_Fields>;
  matchingItemsBuySpecs_stddev_samp_order_by: MatchingItemsBuySpecs_Stddev_Samp_Order_By;
  matchingItemsBuySpecs_stream_cursor_input: MatchingItemsBuySpecs_Stream_Cursor_Input;
  matchingItemsBuySpecs_stream_cursor_value_input: MatchingItemsBuySpecs_Stream_Cursor_Value_Input;
  matchingItemsBuySpecs_sum_fields: ResolverTypeWrapper<MatchingItemsBuySpecs_Sum_Fields>;
  matchingItemsBuySpecs_sum_order_by: MatchingItemsBuySpecs_Sum_Order_By;
  matchingItemsBuySpecs_update_column: MatchingItemsBuySpecs_Update_Column;
  matchingItemsBuySpecs_updates: MatchingItemsBuySpecs_Updates;
  matchingItemsBuySpecs_var_pop_fields: ResolverTypeWrapper<MatchingItemsBuySpecs_Var_Pop_Fields>;
  matchingItemsBuySpecs_var_pop_order_by: MatchingItemsBuySpecs_Var_Pop_Order_By;
  matchingItemsBuySpecs_var_samp_fields: ResolverTypeWrapper<MatchingItemsBuySpecs_Var_Samp_Fields>;
  matchingItemsBuySpecs_var_samp_order_by: MatchingItemsBuySpecs_Var_Samp_Order_By;
  matchingItemsBuySpecs_variance_fields: ResolverTypeWrapper<MatchingItemsBuySpecs_Variance_Fields>;
  matchingItemsBuySpecs_variance_order_by: MatchingItemsBuySpecs_Variance_Order_By;
  mutation_root: ResolverTypeWrapper<{}>;
  notifications: ResolverTypeWrapper<Notifications>;
  notifications_aggregate: ResolverTypeWrapper<Notifications_Aggregate>;
  notifications_aggregate_fields: ResolverTypeWrapper<Notifications_Aggregate_Fields>;
  notifications_avg_fields: ResolverTypeWrapper<Notifications_Avg_Fields>;
  notifications_bool_exp: Notifications_Bool_Exp;
  notifications_constraint: Notifications_Constraint;
  notifications_inc_input: Notifications_Inc_Input;
  notifications_insert_input: Notifications_Insert_Input;
  notifications_max_fields: ResolverTypeWrapper<Notifications_Max_Fields>;
  notifications_min_fields: ResolverTypeWrapper<Notifications_Min_Fields>;
  notifications_mutation_response: ResolverTypeWrapper<Notifications_Mutation_Response>;
  notifications_on_conflict: Notifications_On_Conflict;
  notifications_order_by: Notifications_Order_By;
  notifications_pk_columns_input: Notifications_Pk_Columns_Input;
  notifications_select_column: Notifications_Select_Column;
  notifications_set_input: Notifications_Set_Input;
  notifications_stddev_fields: ResolverTypeWrapper<Notifications_Stddev_Fields>;
  notifications_stddev_pop_fields: ResolverTypeWrapper<Notifications_Stddev_Pop_Fields>;
  notifications_stddev_samp_fields: ResolverTypeWrapper<Notifications_Stddev_Samp_Fields>;
  notifications_stream_cursor_input: Notifications_Stream_Cursor_Input;
  notifications_stream_cursor_value_input: Notifications_Stream_Cursor_Value_Input;
  notifications_sum_fields: ResolverTypeWrapper<Notifications_Sum_Fields>;
  notifications_update_column: Notifications_Update_Column;
  notifications_updates: Notifications_Updates;
  notifications_var_pop_fields: ResolverTypeWrapper<Notifications_Var_Pop_Fields>;
  notifications_var_samp_fields: ResolverTypeWrapper<Notifications_Var_Samp_Fields>;
  notifications_variance_fields: ResolverTypeWrapper<Notifications_Variance_Fields>;
  offices: ResolverTypeWrapper<Offices>;
  offices_aggregate: ResolverTypeWrapper<Offices_Aggregate>;
  offices_aggregate_fields: ResolverTypeWrapper<Offices_Aggregate_Fields>;
  offices_avg_fields: ResolverTypeWrapper<Offices_Avg_Fields>;
  offices_bool_exp: Offices_Bool_Exp;
  offices_constraint: Offices_Constraint;
  offices_inc_input: Offices_Inc_Input;
  offices_insert_input: Offices_Insert_Input;
  offices_max_fields: ResolverTypeWrapper<Offices_Max_Fields>;
  offices_min_fields: ResolverTypeWrapper<Offices_Min_Fields>;
  offices_mutation_response: ResolverTypeWrapper<Offices_Mutation_Response>;
  offices_obj_rel_insert_input: Offices_Obj_Rel_Insert_Input;
  offices_on_conflict: Offices_On_Conflict;
  offices_order_by: Offices_Order_By;
  offices_pk_columns_input: Offices_Pk_Columns_Input;
  offices_select_column: Offices_Select_Column;
  offices_set_input: Offices_Set_Input;
  offices_stddev_fields: ResolverTypeWrapper<Offices_Stddev_Fields>;
  offices_stddev_pop_fields: ResolverTypeWrapper<Offices_Stddev_Pop_Fields>;
  offices_stddev_samp_fields: ResolverTypeWrapper<Offices_Stddev_Samp_Fields>;
  offices_stream_cursor_input: Offices_Stream_Cursor_Input;
  offices_stream_cursor_value_input: Offices_Stream_Cursor_Value_Input;
  offices_sum_fields: ResolverTypeWrapper<Offices_Sum_Fields>;
  offices_update_column: Offices_Update_Column;
  offices_updates: Offices_Updates;
  offices_var_pop_fields: ResolverTypeWrapper<Offices_Var_Pop_Fields>;
  offices_var_samp_fields: ResolverTypeWrapper<Offices_Var_Samp_Fields>;
  offices_variance_fields: ResolverTypeWrapper<Offices_Variance_Fields>;
  order_by: Order_By;
  query_root: ResolverTypeWrapper<{}>;
  releases: ResolverTypeWrapper<Releases>;
  releases_aggregate: ResolverTypeWrapper<Releases_Aggregate>;
  releases_aggregate_fields: ResolverTypeWrapper<Releases_Aggregate_Fields>;
  releases_avg_fields: ResolverTypeWrapper<Releases_Avg_Fields>;
  releases_bool_exp: Releases_Bool_Exp;
  releases_constraint: Releases_Constraint;
  releases_inc_input: Releases_Inc_Input;
  releases_insert_input: Releases_Insert_Input;
  releases_max_fields: ResolverTypeWrapper<Releases_Max_Fields>;
  releases_min_fields: ResolverTypeWrapper<Releases_Min_Fields>;
  releases_mutation_response: ResolverTypeWrapper<Releases_Mutation_Response>;
  releases_on_conflict: Releases_On_Conflict;
  releases_order_by: Releases_Order_By;
  releases_pk_columns_input: Releases_Pk_Columns_Input;
  releases_select_column: Releases_Select_Column;
  releases_set_input: Releases_Set_Input;
  releases_stddev_fields: ResolverTypeWrapper<Releases_Stddev_Fields>;
  releases_stddev_pop_fields: ResolverTypeWrapper<Releases_Stddev_Pop_Fields>;
  releases_stddev_samp_fields: ResolverTypeWrapper<Releases_Stddev_Samp_Fields>;
  releases_stream_cursor_input: Releases_Stream_Cursor_Input;
  releases_stream_cursor_value_input: Releases_Stream_Cursor_Value_Input;
  releases_sum_fields: ResolverTypeWrapper<Releases_Sum_Fields>;
  releases_update_column: Releases_Update_Column;
  releases_updates: Releases_Updates;
  releases_var_pop_fields: ResolverTypeWrapper<Releases_Var_Pop_Fields>;
  releases_var_samp_fields: ResolverTypeWrapper<Releases_Var_Samp_Fields>;
  releases_variance_fields: ResolverTypeWrapper<Releases_Variance_Fields>;
  reminders: ResolverTypeWrapper<Reminders>;
  reminders_aggregate: ResolverTypeWrapper<Reminders_Aggregate>;
  reminders_aggregate_fields: ResolverTypeWrapper<Reminders_Aggregate_Fields>;
  reminders_avg_fields: ResolverTypeWrapper<Reminders_Avg_Fields>;
  reminders_bool_exp: Reminders_Bool_Exp;
  reminders_constraint: Reminders_Constraint;
  reminders_inc_input: Reminders_Inc_Input;
  reminders_insert_input: Reminders_Insert_Input;
  reminders_max_fields: ResolverTypeWrapper<Reminders_Max_Fields>;
  reminders_min_fields: ResolverTypeWrapper<Reminders_Min_Fields>;
  reminders_mutation_response: ResolverTypeWrapper<Reminders_Mutation_Response>;
  reminders_on_conflict: Reminders_On_Conflict;
  reminders_order_by: Reminders_Order_By;
  reminders_pk_columns_input: Reminders_Pk_Columns_Input;
  reminders_select_column: Reminders_Select_Column;
  reminders_set_input: Reminders_Set_Input;
  reminders_stddev_fields: ResolverTypeWrapper<Reminders_Stddev_Fields>;
  reminders_stddev_pop_fields: ResolverTypeWrapper<Reminders_Stddev_Pop_Fields>;
  reminders_stddev_samp_fields: ResolverTypeWrapper<Reminders_Stddev_Samp_Fields>;
  reminders_stream_cursor_input: Reminders_Stream_Cursor_Input;
  reminders_stream_cursor_value_input: Reminders_Stream_Cursor_Value_Input;
  reminders_sum_fields: ResolverTypeWrapper<Reminders_Sum_Fields>;
  reminders_update_column: Reminders_Update_Column;
  reminders_updates: Reminders_Updates;
  reminders_var_pop_fields: ResolverTypeWrapper<Reminders_Var_Pop_Fields>;
  reminders_var_samp_fields: ResolverTypeWrapper<Reminders_Var_Samp_Fields>;
  reminders_variance_fields: ResolverTypeWrapper<Reminders_Variance_Fields>;
  sampleLabels: ResolverTypeWrapper<SampleLabels>;
  sampleLabels_aggregate: ResolverTypeWrapper<SampleLabels_Aggregate>;
  sampleLabels_aggregate_fields: ResolverTypeWrapper<SampleLabels_Aggregate_Fields>;
  sampleLabels_append_input: SampleLabels_Append_Input;
  sampleLabels_avg_fields: ResolverTypeWrapper<SampleLabels_Avg_Fields>;
  sampleLabels_bool_exp: SampleLabels_Bool_Exp;
  sampleLabels_constraint: SampleLabels_Constraint;
  sampleLabels_delete_at_path_input: SampleLabels_Delete_At_Path_Input;
  sampleLabels_delete_elem_input: SampleLabels_Delete_Elem_Input;
  sampleLabels_delete_key_input: SampleLabels_Delete_Key_Input;
  sampleLabels_inc_input: SampleLabels_Inc_Input;
  sampleLabels_insert_input: SampleLabels_Insert_Input;
  sampleLabels_max_fields: ResolverTypeWrapper<SampleLabels_Max_Fields>;
  sampleLabels_min_fields: ResolverTypeWrapper<SampleLabels_Min_Fields>;
  sampleLabels_mutation_response: ResolverTypeWrapper<SampleLabels_Mutation_Response>;
  sampleLabels_on_conflict: SampleLabels_On_Conflict;
  sampleLabels_order_by: SampleLabels_Order_By;
  sampleLabels_pk_columns_input: SampleLabels_Pk_Columns_Input;
  sampleLabels_prepend_input: SampleLabels_Prepend_Input;
  sampleLabels_select_column: SampleLabels_Select_Column;
  sampleLabels_set_input: SampleLabels_Set_Input;
  sampleLabels_stddev_fields: ResolverTypeWrapper<SampleLabels_Stddev_Fields>;
  sampleLabels_stddev_pop_fields: ResolverTypeWrapper<SampleLabels_Stddev_Pop_Fields>;
  sampleLabels_stddev_samp_fields: ResolverTypeWrapper<SampleLabels_Stddev_Samp_Fields>;
  sampleLabels_stream_cursor_input: SampleLabels_Stream_Cursor_Input;
  sampleLabels_stream_cursor_value_input: SampleLabels_Stream_Cursor_Value_Input;
  sampleLabels_sum_fields: ResolverTypeWrapper<SampleLabels_Sum_Fields>;
  sampleLabels_update_column: SampleLabels_Update_Column;
  sampleLabels_updates: SampleLabels_Updates;
  sampleLabels_var_pop_fields: ResolverTypeWrapper<SampleLabels_Var_Pop_Fields>;
  sampleLabels_var_samp_fields: ResolverTypeWrapper<SampleLabels_Var_Samp_Fields>;
  sampleLabels_variance_fields: ResolverTypeWrapper<SampleLabels_Variance_Fields>;
  sampleShipmentRequests: ResolverTypeWrapper<SampleShipmentRequests>;
  sampleShipmentRequests_aggregate: ResolverTypeWrapper<SampleShipmentRequests_Aggregate>;
  sampleShipmentRequests_aggregate_bool_exp: SampleShipmentRequests_Aggregate_Bool_Exp;
  sampleShipmentRequests_aggregate_bool_exp_count: SampleShipmentRequests_Aggregate_Bool_Exp_Count;
  sampleShipmentRequests_aggregate_fields: ResolverTypeWrapper<SampleShipmentRequests_Aggregate_Fields>;
  sampleShipmentRequests_aggregate_order_by: SampleShipmentRequests_Aggregate_Order_By;
  sampleShipmentRequests_append_input: SampleShipmentRequests_Append_Input;
  sampleShipmentRequests_arr_rel_insert_input: SampleShipmentRequests_Arr_Rel_Insert_Input;
  sampleShipmentRequests_avg_fields: ResolverTypeWrapper<SampleShipmentRequests_Avg_Fields>;
  sampleShipmentRequests_avg_order_by: SampleShipmentRequests_Avg_Order_By;
  sampleShipmentRequests_bool_exp: SampleShipmentRequests_Bool_Exp;
  sampleShipmentRequests_constraint: SampleShipmentRequests_Constraint;
  sampleShipmentRequests_delete_at_path_input: SampleShipmentRequests_Delete_At_Path_Input;
  sampleShipmentRequests_delete_elem_input: SampleShipmentRequests_Delete_Elem_Input;
  sampleShipmentRequests_delete_key_input: SampleShipmentRequests_Delete_Key_Input;
  sampleShipmentRequests_inc_input: SampleShipmentRequests_Inc_Input;
  sampleShipmentRequests_insert_input: SampleShipmentRequests_Insert_Input;
  sampleShipmentRequests_max_fields: ResolverTypeWrapper<SampleShipmentRequests_Max_Fields>;
  sampleShipmentRequests_max_order_by: SampleShipmentRequests_Max_Order_By;
  sampleShipmentRequests_min_fields: ResolverTypeWrapper<SampleShipmentRequests_Min_Fields>;
  sampleShipmentRequests_min_order_by: SampleShipmentRequests_Min_Order_By;
  sampleShipmentRequests_mutation_response: ResolverTypeWrapper<SampleShipmentRequests_Mutation_Response>;
  sampleShipmentRequests_on_conflict: SampleShipmentRequests_On_Conflict;
  sampleShipmentRequests_order_by: SampleShipmentRequests_Order_By;
  sampleShipmentRequests_pk_columns_input: SampleShipmentRequests_Pk_Columns_Input;
  sampleShipmentRequests_prepend_input: SampleShipmentRequests_Prepend_Input;
  sampleShipmentRequests_select_column: SampleShipmentRequests_Select_Column;
  sampleShipmentRequests_set_input: SampleShipmentRequests_Set_Input;
  sampleShipmentRequests_stddev_fields: ResolverTypeWrapper<SampleShipmentRequests_Stddev_Fields>;
  sampleShipmentRequests_stddev_order_by: SampleShipmentRequests_Stddev_Order_By;
  sampleShipmentRequests_stddev_pop_fields: ResolverTypeWrapper<SampleShipmentRequests_Stddev_Pop_Fields>;
  sampleShipmentRequests_stddev_pop_order_by: SampleShipmentRequests_Stddev_Pop_Order_By;
  sampleShipmentRequests_stddev_samp_fields: ResolverTypeWrapper<SampleShipmentRequests_Stddev_Samp_Fields>;
  sampleShipmentRequests_stddev_samp_order_by: SampleShipmentRequests_Stddev_Samp_Order_By;
  sampleShipmentRequests_stream_cursor_input: SampleShipmentRequests_Stream_Cursor_Input;
  sampleShipmentRequests_stream_cursor_value_input: SampleShipmentRequests_Stream_Cursor_Value_Input;
  sampleShipmentRequests_sum_fields: ResolverTypeWrapper<SampleShipmentRequests_Sum_Fields>;
  sampleShipmentRequests_sum_order_by: SampleShipmentRequests_Sum_Order_By;
  sampleShipmentRequests_update_column: SampleShipmentRequests_Update_Column;
  sampleShipmentRequests_updates: SampleShipmentRequests_Updates;
  sampleShipmentRequests_var_pop_fields: ResolverTypeWrapper<SampleShipmentRequests_Var_Pop_Fields>;
  sampleShipmentRequests_var_pop_order_by: SampleShipmentRequests_Var_Pop_Order_By;
  sampleShipmentRequests_var_samp_fields: ResolverTypeWrapper<SampleShipmentRequests_Var_Samp_Fields>;
  sampleShipmentRequests_var_samp_order_by: SampleShipmentRequests_Var_Samp_Order_By;
  sampleShipmentRequests_variance_fields: ResolverTypeWrapper<SampleShipmentRequests_Variance_Fields>;
  sampleShipmentRequests_variance_order_by: SampleShipmentRequests_Variance_Order_By;
  sampleShipments: ResolverTypeWrapper<SampleShipments>;
  sampleShipments_aggregate: ResolverTypeWrapper<SampleShipments_Aggregate>;
  sampleShipments_aggregate_fields: ResolverTypeWrapper<SampleShipments_Aggregate_Fields>;
  sampleShipments_avg_fields: ResolverTypeWrapper<SampleShipments_Avg_Fields>;
  sampleShipments_bool_exp: SampleShipments_Bool_Exp;
  sampleShipments_constraint: SampleShipments_Constraint;
  sampleShipments_inc_input: SampleShipments_Inc_Input;
  sampleShipments_insert_input: SampleShipments_Insert_Input;
  sampleShipments_max_fields: ResolverTypeWrapper<SampleShipments_Max_Fields>;
  sampleShipments_min_fields: ResolverTypeWrapper<SampleShipments_Min_Fields>;
  sampleShipments_mutation_response: ResolverTypeWrapper<SampleShipments_Mutation_Response>;
  sampleShipments_obj_rel_insert_input: SampleShipments_Obj_Rel_Insert_Input;
  sampleShipments_on_conflict: SampleShipments_On_Conflict;
  sampleShipments_order_by: SampleShipments_Order_By;
  sampleShipments_pk_columns_input: SampleShipments_Pk_Columns_Input;
  sampleShipments_select_column: SampleShipments_Select_Column;
  sampleShipments_set_input: SampleShipments_Set_Input;
  sampleShipments_stddev_fields: ResolverTypeWrapper<SampleShipments_Stddev_Fields>;
  sampleShipments_stddev_pop_fields: ResolverTypeWrapper<SampleShipments_Stddev_Pop_Fields>;
  sampleShipments_stddev_samp_fields: ResolverTypeWrapper<SampleShipments_Stddev_Samp_Fields>;
  sampleShipments_stream_cursor_input: SampleShipments_Stream_Cursor_Input;
  sampleShipments_stream_cursor_value_input: SampleShipments_Stream_Cursor_Value_Input;
  sampleShipments_sum_fields: ResolverTypeWrapper<SampleShipments_Sum_Fields>;
  sampleShipments_update_column: SampleShipments_Update_Column;
  sampleShipments_updates: SampleShipments_Updates;
  sampleShipments_var_pop_fields: ResolverTypeWrapper<SampleShipments_Var_Pop_Fields>;
  sampleShipments_var_samp_fields: ResolverTypeWrapper<SampleShipments_Var_Samp_Fields>;
  sampleShipments_variance_fields: ResolverTypeWrapper<SampleShipments_Variance_Fields>;
  samples: ResolverTypeWrapper<Samples>;
  samples_aggregate: ResolverTypeWrapper<Samples_Aggregate>;
  samples_aggregate_bool_exp: Samples_Aggregate_Bool_Exp;
  samples_aggregate_bool_exp_count: Samples_Aggregate_Bool_Exp_Count;
  samples_aggregate_fields: ResolverTypeWrapper<Samples_Aggregate_Fields>;
  samples_aggregate_order_by: Samples_Aggregate_Order_By;
  samples_append_input: Samples_Append_Input;
  samples_arr_rel_insert_input: Samples_Arr_Rel_Insert_Input;
  samples_avg_fields: ResolverTypeWrapper<Samples_Avg_Fields>;
  samples_avg_order_by: Samples_Avg_Order_By;
  samples_bool_exp: Samples_Bool_Exp;
  samples_constraint: Samples_Constraint;
  samples_delete_at_path_input: Samples_Delete_At_Path_Input;
  samples_delete_elem_input: Samples_Delete_Elem_Input;
  samples_delete_key_input: Samples_Delete_Key_Input;
  samples_inc_input: Samples_Inc_Input;
  samples_insert_input: Samples_Insert_Input;
  samples_max_fields: ResolverTypeWrapper<Samples_Max_Fields>;
  samples_max_order_by: Samples_Max_Order_By;
  samples_min_fields: ResolverTypeWrapper<Samples_Min_Fields>;
  samples_min_order_by: Samples_Min_Order_By;
  samples_mutation_response: ResolverTypeWrapper<Samples_Mutation_Response>;
  samples_on_conflict: Samples_On_Conflict;
  samples_order_by: Samples_Order_By;
  samples_pk_columns_input: Samples_Pk_Columns_Input;
  samples_prepend_input: Samples_Prepend_Input;
  samples_select_column: Samples_Select_Column;
  samples_set_input: Samples_Set_Input;
  samples_stddev_fields: ResolverTypeWrapper<Samples_Stddev_Fields>;
  samples_stddev_order_by: Samples_Stddev_Order_By;
  samples_stddev_pop_fields: ResolverTypeWrapper<Samples_Stddev_Pop_Fields>;
  samples_stddev_pop_order_by: Samples_Stddev_Pop_Order_By;
  samples_stddev_samp_fields: ResolverTypeWrapper<Samples_Stddev_Samp_Fields>;
  samples_stddev_samp_order_by: Samples_Stddev_Samp_Order_By;
  samples_stream_cursor_input: Samples_Stream_Cursor_Input;
  samples_stream_cursor_value_input: Samples_Stream_Cursor_Value_Input;
  samples_sum_fields: ResolverTypeWrapper<Samples_Sum_Fields>;
  samples_sum_order_by: Samples_Sum_Order_By;
  samples_update_column: Samples_Update_Column;
  samples_updates: Samples_Updates;
  samples_var_pop_fields: ResolverTypeWrapper<Samples_Var_Pop_Fields>;
  samples_var_pop_order_by: Samples_Var_Pop_Order_By;
  samples_var_samp_fields: ResolverTypeWrapper<Samples_Var_Samp_Fields>;
  samples_var_samp_order_by: Samples_Var_Samp_Order_By;
  samples_variance_fields: ResolverTypeWrapper<Samples_Variance_Fields>;
  samples_variance_order_by: Samples_Variance_Order_By;
  shipmentFulfillments: ResolverTypeWrapper<ShipmentFulfillments>;
  shipmentFulfillments_aggregate: ResolverTypeWrapper<ShipmentFulfillments_Aggregate>;
  shipmentFulfillments_aggregate_bool_exp: ShipmentFulfillments_Aggregate_Bool_Exp;
  shipmentFulfillments_aggregate_bool_exp_count: ShipmentFulfillments_Aggregate_Bool_Exp_Count;
  shipmentFulfillments_aggregate_fields: ResolverTypeWrapper<ShipmentFulfillments_Aggregate_Fields>;
  shipmentFulfillments_aggregate_order_by: ShipmentFulfillments_Aggregate_Order_By;
  shipmentFulfillments_append_input: ShipmentFulfillments_Append_Input;
  shipmentFulfillments_arr_rel_insert_input: ShipmentFulfillments_Arr_Rel_Insert_Input;
  shipmentFulfillments_avg_fields: ResolverTypeWrapper<ShipmentFulfillments_Avg_Fields>;
  shipmentFulfillments_avg_order_by: ShipmentFulfillments_Avg_Order_By;
  shipmentFulfillments_bool_exp: ShipmentFulfillments_Bool_Exp;
  shipmentFulfillments_constraint: ShipmentFulfillments_Constraint;
  shipmentFulfillments_delete_at_path_input: ShipmentFulfillments_Delete_At_Path_Input;
  shipmentFulfillments_delete_elem_input: ShipmentFulfillments_Delete_Elem_Input;
  shipmentFulfillments_delete_key_input: ShipmentFulfillments_Delete_Key_Input;
  shipmentFulfillments_inc_input: ShipmentFulfillments_Inc_Input;
  shipmentFulfillments_insert_input: ShipmentFulfillments_Insert_Input;
  shipmentFulfillments_max_fields: ResolverTypeWrapper<ShipmentFulfillments_Max_Fields>;
  shipmentFulfillments_max_order_by: ShipmentFulfillments_Max_Order_By;
  shipmentFulfillments_min_fields: ResolverTypeWrapper<ShipmentFulfillments_Min_Fields>;
  shipmentFulfillments_min_order_by: ShipmentFulfillments_Min_Order_By;
  shipmentFulfillments_mutation_response: ResolverTypeWrapper<ShipmentFulfillments_Mutation_Response>;
  shipmentFulfillments_obj_rel_insert_input: ShipmentFulfillments_Obj_Rel_Insert_Input;
  shipmentFulfillments_on_conflict: ShipmentFulfillments_On_Conflict;
  shipmentFulfillments_order_by: ShipmentFulfillments_Order_By;
  shipmentFulfillments_pk_columns_input: ShipmentFulfillments_Pk_Columns_Input;
  shipmentFulfillments_prepend_input: ShipmentFulfillments_Prepend_Input;
  shipmentFulfillments_select_column: ShipmentFulfillments_Select_Column;
  shipmentFulfillments_set_input: ShipmentFulfillments_Set_Input;
  shipmentFulfillments_stddev_fields: ResolverTypeWrapper<ShipmentFulfillments_Stddev_Fields>;
  shipmentFulfillments_stddev_order_by: ShipmentFulfillments_Stddev_Order_By;
  shipmentFulfillments_stddev_pop_fields: ResolverTypeWrapper<ShipmentFulfillments_Stddev_Pop_Fields>;
  shipmentFulfillments_stddev_pop_order_by: ShipmentFulfillments_Stddev_Pop_Order_By;
  shipmentFulfillments_stddev_samp_fields: ResolverTypeWrapper<ShipmentFulfillments_Stddev_Samp_Fields>;
  shipmentFulfillments_stddev_samp_order_by: ShipmentFulfillments_Stddev_Samp_Order_By;
  shipmentFulfillments_stream_cursor_input: ShipmentFulfillments_Stream_Cursor_Input;
  shipmentFulfillments_stream_cursor_value_input: ShipmentFulfillments_Stream_Cursor_Value_Input;
  shipmentFulfillments_sum_fields: ResolverTypeWrapper<ShipmentFulfillments_Sum_Fields>;
  shipmentFulfillments_sum_order_by: ShipmentFulfillments_Sum_Order_By;
  shipmentFulfillments_update_column: ShipmentFulfillments_Update_Column;
  shipmentFulfillments_updates: ShipmentFulfillments_Updates;
  shipmentFulfillments_var_pop_fields: ResolverTypeWrapper<ShipmentFulfillments_Var_Pop_Fields>;
  shipmentFulfillments_var_pop_order_by: ShipmentFulfillments_Var_Pop_Order_By;
  shipmentFulfillments_var_samp_fields: ResolverTypeWrapper<ShipmentFulfillments_Var_Samp_Fields>;
  shipmentFulfillments_var_samp_order_by: ShipmentFulfillments_Var_Samp_Order_By;
  shipmentFulfillments_variance_fields: ResolverTypeWrapper<ShipmentFulfillments_Variance_Fields>;
  shipmentFulfillments_variance_order_by: ShipmentFulfillments_Variance_Order_By;
  subscription_root: ResolverTypeWrapper<{}>;
  timestamp: ResolverTypeWrapper<Scalars['timestamp']>;
  timestamp_comparison_exp: Timestamp_Comparison_Exp;
  timestamptz: ResolverTypeWrapper<Scalars['timestamptz']>;
  timestamptz_comparison_exp: Timestamptz_Comparison_Exp;
  trackings: ResolverTypeWrapper<Trackings>;
  trackings_aggregate: ResolverTypeWrapper<Trackings_Aggregate>;
  trackings_aggregate_fields: ResolverTypeWrapper<Trackings_Aggregate_Fields>;
  trackings_append_input: Trackings_Append_Input;
  trackings_avg_fields: ResolverTypeWrapper<Trackings_Avg_Fields>;
  trackings_bool_exp: Trackings_Bool_Exp;
  trackings_constraint: Trackings_Constraint;
  trackings_delete_at_path_input: Trackings_Delete_At_Path_Input;
  trackings_delete_elem_input: Trackings_Delete_Elem_Input;
  trackings_delete_key_input: Trackings_Delete_Key_Input;
  trackings_inc_input: Trackings_Inc_Input;
  trackings_insert_input: Trackings_Insert_Input;
  trackings_max_fields: ResolverTypeWrapper<Trackings_Max_Fields>;
  trackings_min_fields: ResolverTypeWrapper<Trackings_Min_Fields>;
  trackings_mutation_response: ResolverTypeWrapper<Trackings_Mutation_Response>;
  trackings_on_conflict: Trackings_On_Conflict;
  trackings_order_by: Trackings_Order_By;
  trackings_pk_columns_input: Trackings_Pk_Columns_Input;
  trackings_prepend_input: Trackings_Prepend_Input;
  trackings_select_column: Trackings_Select_Column;
  trackings_set_input: Trackings_Set_Input;
  trackings_stddev_fields: ResolverTypeWrapper<Trackings_Stddev_Fields>;
  trackings_stddev_pop_fields: ResolverTypeWrapper<Trackings_Stddev_Pop_Fields>;
  trackings_stddev_samp_fields: ResolverTypeWrapper<Trackings_Stddev_Samp_Fields>;
  trackings_stream_cursor_input: Trackings_Stream_Cursor_Input;
  trackings_stream_cursor_value_input: Trackings_Stream_Cursor_Value_Input;
  trackings_sum_fields: ResolverTypeWrapper<Trackings_Sum_Fields>;
  trackings_update_column: Trackings_Update_Column;
  trackings_updates: Trackings_Updates;
  trackings_var_pop_fields: ResolverTypeWrapper<Trackings_Var_Pop_Fields>;
  trackings_var_samp_fields: ResolverTypeWrapper<Trackings_Var_Samp_Fields>;
  trackings_variance_fields: ResolverTypeWrapper<Trackings_Variance_Fields>;
  users: ResolverTypeWrapper<Users>;
  usersBonus: ResolverTypeWrapper<UsersBonus>;
  usersBonus_aggregate: ResolverTypeWrapper<UsersBonus_Aggregate>;
  usersBonus_aggregate_bool_exp: UsersBonus_Aggregate_Bool_Exp;
  usersBonus_aggregate_bool_exp_count: UsersBonus_Aggregate_Bool_Exp_Count;
  usersBonus_aggregate_fields: ResolverTypeWrapper<UsersBonus_Aggregate_Fields>;
  usersBonus_aggregate_order_by: UsersBonus_Aggregate_Order_By;
  usersBonus_arr_rel_insert_input: UsersBonus_Arr_Rel_Insert_Input;
  usersBonus_avg_fields: ResolverTypeWrapper<UsersBonus_Avg_Fields>;
  usersBonus_avg_order_by: UsersBonus_Avg_Order_By;
  usersBonus_bool_exp: UsersBonus_Bool_Exp;
  usersBonus_constraint: UsersBonus_Constraint;
  usersBonus_inc_input: UsersBonus_Inc_Input;
  usersBonus_insert_input: UsersBonus_Insert_Input;
  usersBonus_max_fields: ResolverTypeWrapper<UsersBonus_Max_Fields>;
  usersBonus_max_order_by: UsersBonus_Max_Order_By;
  usersBonus_min_fields: ResolverTypeWrapper<UsersBonus_Min_Fields>;
  usersBonus_min_order_by: UsersBonus_Min_Order_By;
  usersBonus_mutation_response: ResolverTypeWrapper<UsersBonus_Mutation_Response>;
  usersBonus_on_conflict: UsersBonus_On_Conflict;
  usersBonus_order_by: UsersBonus_Order_By;
  usersBonus_pk_columns_input: UsersBonus_Pk_Columns_Input;
  usersBonus_select_column: UsersBonus_Select_Column;
  usersBonus_set_input: UsersBonus_Set_Input;
  usersBonus_stddev_fields: ResolverTypeWrapper<UsersBonus_Stddev_Fields>;
  usersBonus_stddev_order_by: UsersBonus_Stddev_Order_By;
  usersBonus_stddev_pop_fields: ResolverTypeWrapper<UsersBonus_Stddev_Pop_Fields>;
  usersBonus_stddev_pop_order_by: UsersBonus_Stddev_Pop_Order_By;
  usersBonus_stddev_samp_fields: ResolverTypeWrapper<UsersBonus_Stddev_Samp_Fields>;
  usersBonus_stddev_samp_order_by: UsersBonus_Stddev_Samp_Order_By;
  usersBonus_stream_cursor_input: UsersBonus_Stream_Cursor_Input;
  usersBonus_stream_cursor_value_input: UsersBonus_Stream_Cursor_Value_Input;
  usersBonus_sum_fields: ResolverTypeWrapper<UsersBonus_Sum_Fields>;
  usersBonus_sum_order_by: UsersBonus_Sum_Order_By;
  usersBonus_update_column: UsersBonus_Update_Column;
  usersBonus_updates: UsersBonus_Updates;
  usersBonus_var_pop_fields: ResolverTypeWrapper<UsersBonus_Var_Pop_Fields>;
  usersBonus_var_pop_order_by: UsersBonus_Var_Pop_Order_By;
  usersBonus_var_samp_fields: ResolverTypeWrapper<UsersBonus_Var_Samp_Fields>;
  usersBonus_var_samp_order_by: UsersBonus_Var_Samp_Order_By;
  usersBonus_variance_fields: ResolverTypeWrapper<UsersBonus_Variance_Fields>;
  usersBonus_variance_order_by: UsersBonus_Variance_Order_By;
  usersCosts: ResolverTypeWrapper<UsersCosts>;
  usersCosts_aggregate: ResolverTypeWrapper<UsersCosts_Aggregate>;
  usersCosts_aggregate_bool_exp: UsersCosts_Aggregate_Bool_Exp;
  usersCosts_aggregate_bool_exp_count: UsersCosts_Aggregate_Bool_Exp_Count;
  usersCosts_aggregate_fields: ResolverTypeWrapper<UsersCosts_Aggregate_Fields>;
  usersCosts_aggregate_order_by: UsersCosts_Aggregate_Order_By;
  usersCosts_arr_rel_insert_input: UsersCosts_Arr_Rel_Insert_Input;
  usersCosts_avg_fields: ResolverTypeWrapper<UsersCosts_Avg_Fields>;
  usersCosts_avg_order_by: UsersCosts_Avg_Order_By;
  usersCosts_bool_exp: UsersCosts_Bool_Exp;
  usersCosts_constraint: UsersCosts_Constraint;
  usersCosts_inc_input: UsersCosts_Inc_Input;
  usersCosts_insert_input: UsersCosts_Insert_Input;
  usersCosts_max_fields: ResolverTypeWrapper<UsersCosts_Max_Fields>;
  usersCosts_max_order_by: UsersCosts_Max_Order_By;
  usersCosts_min_fields: ResolverTypeWrapper<UsersCosts_Min_Fields>;
  usersCosts_min_order_by: UsersCosts_Min_Order_By;
  usersCosts_mutation_response: ResolverTypeWrapper<UsersCosts_Mutation_Response>;
  usersCosts_on_conflict: UsersCosts_On_Conflict;
  usersCosts_order_by: UsersCosts_Order_By;
  usersCosts_pk_columns_input: UsersCosts_Pk_Columns_Input;
  usersCosts_select_column: UsersCosts_Select_Column;
  usersCosts_set_input: UsersCosts_Set_Input;
  usersCosts_stddev_fields: ResolverTypeWrapper<UsersCosts_Stddev_Fields>;
  usersCosts_stddev_order_by: UsersCosts_Stddev_Order_By;
  usersCosts_stddev_pop_fields: ResolverTypeWrapper<UsersCosts_Stddev_Pop_Fields>;
  usersCosts_stddev_pop_order_by: UsersCosts_Stddev_Pop_Order_By;
  usersCosts_stddev_samp_fields: ResolverTypeWrapper<UsersCosts_Stddev_Samp_Fields>;
  usersCosts_stddev_samp_order_by: UsersCosts_Stddev_Samp_Order_By;
  usersCosts_stream_cursor_input: UsersCosts_Stream_Cursor_Input;
  usersCosts_stream_cursor_value_input: UsersCosts_Stream_Cursor_Value_Input;
  usersCosts_sum_fields: ResolverTypeWrapper<UsersCosts_Sum_Fields>;
  usersCosts_sum_order_by: UsersCosts_Sum_Order_By;
  usersCosts_update_column: UsersCosts_Update_Column;
  usersCosts_updates: UsersCosts_Updates;
  usersCosts_var_pop_fields: ResolverTypeWrapper<UsersCosts_Var_Pop_Fields>;
  usersCosts_var_pop_order_by: UsersCosts_Var_Pop_Order_By;
  usersCosts_var_samp_fields: ResolverTypeWrapper<UsersCosts_Var_Samp_Fields>;
  usersCosts_var_samp_order_by: UsersCosts_Var_Samp_Order_By;
  usersCosts_variance_fields: ResolverTypeWrapper<UsersCosts_Variance_Fields>;
  usersCosts_variance_order_by: UsersCosts_Variance_Order_By;
  users_aggregate: ResolverTypeWrapper<Users_Aggregate>;
  users_aggregate_bool_exp: Users_Aggregate_Bool_Exp;
  users_aggregate_bool_exp_bool_and: Users_Aggregate_Bool_Exp_Bool_And;
  users_aggregate_bool_exp_bool_or: Users_Aggregate_Bool_Exp_Bool_Or;
  users_aggregate_bool_exp_count: Users_Aggregate_Bool_Exp_Count;
  users_aggregate_fields: ResolverTypeWrapper<Users_Aggregate_Fields>;
  users_aggregate_order_by: Users_Aggregate_Order_By;
  users_append_input: Users_Append_Input;
  users_arr_rel_insert_input: Users_Arr_Rel_Insert_Input;
  users_avg_fields: ResolverTypeWrapper<Users_Avg_Fields>;
  users_avg_order_by: Users_Avg_Order_By;
  users_bool_exp: Users_Bool_Exp;
  users_constraint: Users_Constraint;
  users_delete_at_path_input: Users_Delete_At_Path_Input;
  users_delete_elem_input: Users_Delete_Elem_Input;
  users_delete_key_input: Users_Delete_Key_Input;
  users_inc_input: Users_Inc_Input;
  users_insert_input: Users_Insert_Input;
  users_max_fields: ResolverTypeWrapper<Users_Max_Fields>;
  users_max_order_by: Users_Max_Order_By;
  users_min_fields: ResolverTypeWrapper<Users_Min_Fields>;
  users_min_order_by: Users_Min_Order_By;
  users_mutation_response: ResolverTypeWrapper<Users_Mutation_Response>;
  users_obj_rel_insert_input: Users_Obj_Rel_Insert_Input;
  users_on_conflict: Users_On_Conflict;
  users_order_by: Users_Order_By;
  users_pk_columns_input: Users_Pk_Columns_Input;
  users_prepend_input: Users_Prepend_Input;
  users_select_column: Users_Select_Column;
  users_select_column_users_aggregate_bool_exp_bool_and_arguments_columns: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  users_select_column_users_aggregate_bool_exp_bool_or_arguments_columns: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  users_set_input: Users_Set_Input;
  users_stddev_fields: ResolverTypeWrapper<Users_Stddev_Fields>;
  users_stddev_order_by: Users_Stddev_Order_By;
  users_stddev_pop_fields: ResolverTypeWrapper<Users_Stddev_Pop_Fields>;
  users_stddev_pop_order_by: Users_Stddev_Pop_Order_By;
  users_stddev_samp_fields: ResolverTypeWrapper<Users_Stddev_Samp_Fields>;
  users_stddev_samp_order_by: Users_Stddev_Samp_Order_By;
  users_stream_cursor_input: Users_Stream_Cursor_Input;
  users_stream_cursor_value_input: Users_Stream_Cursor_Value_Input;
  users_sum_fields: ResolverTypeWrapper<Users_Sum_Fields>;
  users_sum_order_by: Users_Sum_Order_By;
  users_update_column: Users_Update_Column;
  users_updates: Users_Updates;
  users_var_pop_fields: ResolverTypeWrapper<Users_Var_Pop_Fields>;
  users_var_pop_order_by: Users_Var_Pop_Order_By;
  users_var_samp_fields: ResolverTypeWrapper<Users_Var_Samp_Fields>;
  users_var_samp_order_by: Users_Var_Samp_Order_By;
  users_variance_fields: ResolverTypeWrapper<Users_Variance_Fields>;
  users_variance_order_by: Users_Variance_Order_By;
  validationsContracts: ResolverTypeWrapper<ValidationsContracts>;
  validationsContracts_aggregate: ResolverTypeWrapper<ValidationsContracts_Aggregate>;
  validationsContracts_aggregate_bool_exp: ValidationsContracts_Aggregate_Bool_Exp;
  validationsContracts_aggregate_bool_exp_count: ValidationsContracts_Aggregate_Bool_Exp_Count;
  validationsContracts_aggregate_fields: ResolverTypeWrapper<ValidationsContracts_Aggregate_Fields>;
  validationsContracts_aggregate_order_by: ValidationsContracts_Aggregate_Order_By;
  validationsContracts_arr_rel_insert_input: ValidationsContracts_Arr_Rel_Insert_Input;
  validationsContracts_avg_fields: ResolverTypeWrapper<ValidationsContracts_Avg_Fields>;
  validationsContracts_avg_order_by: ValidationsContracts_Avg_Order_By;
  validationsContracts_bool_exp: ValidationsContracts_Bool_Exp;
  validationsContracts_constraint: ValidationsContracts_Constraint;
  validationsContracts_inc_input: ValidationsContracts_Inc_Input;
  validationsContracts_insert_input: ValidationsContracts_Insert_Input;
  validationsContracts_max_fields: ResolverTypeWrapper<ValidationsContracts_Max_Fields>;
  validationsContracts_max_order_by: ValidationsContracts_Max_Order_By;
  validationsContracts_min_fields: ResolverTypeWrapper<ValidationsContracts_Min_Fields>;
  validationsContracts_min_order_by: ValidationsContracts_Min_Order_By;
  validationsContracts_mutation_response: ResolverTypeWrapper<ValidationsContracts_Mutation_Response>;
  validationsContracts_on_conflict: ValidationsContracts_On_Conflict;
  validationsContracts_order_by: ValidationsContracts_Order_By;
  validationsContracts_pk_columns_input: ValidationsContracts_Pk_Columns_Input;
  validationsContracts_select_column: ValidationsContracts_Select_Column;
  validationsContracts_set_input: ValidationsContracts_Set_Input;
  validationsContracts_stddev_fields: ResolverTypeWrapper<ValidationsContracts_Stddev_Fields>;
  validationsContracts_stddev_order_by: ValidationsContracts_Stddev_Order_By;
  validationsContracts_stddev_pop_fields: ResolverTypeWrapper<ValidationsContracts_Stddev_Pop_Fields>;
  validationsContracts_stddev_pop_order_by: ValidationsContracts_Stddev_Pop_Order_By;
  validationsContracts_stddev_samp_fields: ResolverTypeWrapper<ValidationsContracts_Stddev_Samp_Fields>;
  validationsContracts_stddev_samp_order_by: ValidationsContracts_Stddev_Samp_Order_By;
  validationsContracts_stream_cursor_input: ValidationsContracts_Stream_Cursor_Input;
  validationsContracts_stream_cursor_value_input: ValidationsContracts_Stream_Cursor_Value_Input;
  validationsContracts_sum_fields: ResolverTypeWrapper<ValidationsContracts_Sum_Fields>;
  validationsContracts_sum_order_by: ValidationsContracts_Sum_Order_By;
  validationsContracts_update_column: ValidationsContracts_Update_Column;
  validationsContracts_updates: ValidationsContracts_Updates;
  validationsContracts_var_pop_fields: ResolverTypeWrapper<ValidationsContracts_Var_Pop_Fields>;
  validationsContracts_var_pop_order_by: ValidationsContracts_Var_Pop_Order_By;
  validationsContracts_var_samp_fields: ResolverTypeWrapper<ValidationsContracts_Var_Samp_Fields>;
  validationsContracts_var_samp_order_by: ValidationsContracts_Var_Samp_Order_By;
  validationsContracts_variance_fields: ResolverTypeWrapper<ValidationsContracts_Variance_Fields>;
  validationsContracts_variance_order_by: ValidationsContracts_Variance_Order_By;
  varietals: ResolverTypeWrapper<Varietals>;
  varietals_aggregate: ResolverTypeWrapper<Varietals_Aggregate>;
  varietals_aggregate_fields: ResolverTypeWrapper<Varietals_Aggregate_Fields>;
  varietals_avg_fields: ResolverTypeWrapper<Varietals_Avg_Fields>;
  varietals_bool_exp: Varietals_Bool_Exp;
  varietals_constraint: Varietals_Constraint;
  varietals_inc_input: Varietals_Inc_Input;
  varietals_insert_input: Varietals_Insert_Input;
  varietals_max_fields: ResolverTypeWrapper<Varietals_Max_Fields>;
  varietals_min_fields: ResolverTypeWrapper<Varietals_Min_Fields>;
  varietals_mutation_response: ResolverTypeWrapper<Varietals_Mutation_Response>;
  varietals_on_conflict: Varietals_On_Conflict;
  varietals_order_by: Varietals_Order_By;
  varietals_pk_columns_input: Varietals_Pk_Columns_Input;
  varietals_select_column: Varietals_Select_Column;
  varietals_set_input: Varietals_Set_Input;
  varietals_stddev_fields: ResolverTypeWrapper<Varietals_Stddev_Fields>;
  varietals_stddev_pop_fields: ResolverTypeWrapper<Varietals_Stddev_Pop_Fields>;
  varietals_stddev_samp_fields: ResolverTypeWrapper<Varietals_Stddev_Samp_Fields>;
  varietals_stream_cursor_input: Varietals_Stream_Cursor_Input;
  varietals_stream_cursor_value_input: Varietals_Stream_Cursor_Value_Input;
  varietals_sum_fields: ResolverTypeWrapper<Varietals_Sum_Fields>;
  varietals_update_column: Varietals_Update_Column;
  varietals_updates: Varietals_Updates;
  varietals_var_pop_fields: ResolverTypeWrapper<Varietals_Var_Pop_Fields>;
  varietals_var_samp_fields: ResolverTypeWrapper<Varietals_Var_Samp_Fields>;
  varietals_variance_fields: ResolverTypeWrapper<Varietals_Variance_Fields>;
  vector: ResolverTypeWrapper<Scalars['vector']>;
  vector_comparison_exp: Vector_Comparison_Exp;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Boolean: Scalars['Boolean'];
  Boolean_comparison_exp: Boolean_Comparison_Exp;
  Float: Scalars['Float'];
  Float_comparison_exp: Float_Comparison_Exp;
  Int: Scalars['Int'];
  Int_comparison_exp: Int_Comparison_Exp;
  String: Scalars['String'];
  String_comparison_exp: String_Comparison_Exp;
  addresses: Addresses;
  addresses_aggregate: Addresses_Aggregate;
  addresses_aggregate_fields: Addresses_Aggregate_Fields;
  addresses_append_input: Addresses_Append_Input;
  addresses_avg_fields: Addresses_Avg_Fields;
  addresses_bool_exp: Addresses_Bool_Exp;
  addresses_delete_at_path_input: Addresses_Delete_At_Path_Input;
  addresses_delete_elem_input: Addresses_Delete_Elem_Input;
  addresses_delete_key_input: Addresses_Delete_Key_Input;
  addresses_inc_input: Addresses_Inc_Input;
  addresses_insert_input: Addresses_Insert_Input;
  addresses_max_fields: Addresses_Max_Fields;
  addresses_min_fields: Addresses_Min_Fields;
  addresses_mutation_response: Addresses_Mutation_Response;
  addresses_obj_rel_insert_input: Addresses_Obj_Rel_Insert_Input;
  addresses_on_conflict: Addresses_On_Conflict;
  addresses_order_by: Addresses_Order_By;
  addresses_pk_columns_input: Addresses_Pk_Columns_Input;
  addresses_prepend_input: Addresses_Prepend_Input;
  addresses_set_input: Addresses_Set_Input;
  addresses_stddev_fields: Addresses_Stddev_Fields;
  addresses_stddev_pop_fields: Addresses_Stddev_Pop_Fields;
  addresses_stddev_samp_fields: Addresses_Stddev_Samp_Fields;
  addresses_stream_cursor_input: Addresses_Stream_Cursor_Input;
  addresses_stream_cursor_value_input: Addresses_Stream_Cursor_Value_Input;
  addresses_sum_fields: Addresses_Sum_Fields;
  addresses_updates: Addresses_Updates;
  addresses_var_pop_fields: Addresses_Var_Pop_Fields;
  addresses_var_samp_fields: Addresses_Var_Samp_Fields;
  addresses_variance_fields: Addresses_Variance_Fields;
  addresses_without_company: Addresses_Without_Company;
  addresses_without_company_aggregate: Addresses_Without_Company_Aggregate;
  addresses_without_company_aggregate_fields: Addresses_Without_Company_Aggregate_Fields;
  addresses_without_company_avg_fields: Addresses_Without_Company_Avg_Fields;
  addresses_without_company_bool_exp: Addresses_Without_Company_Bool_Exp;
  addresses_without_company_max_fields: Addresses_Without_Company_Max_Fields;
  addresses_without_company_min_fields: Addresses_Without_Company_Min_Fields;
  addresses_without_company_order_by: Addresses_Without_Company_Order_By;
  addresses_without_company_stddev_fields: Addresses_Without_Company_Stddev_Fields;
  addresses_without_company_stddev_pop_fields: Addresses_Without_Company_Stddev_Pop_Fields;
  addresses_without_company_stddev_samp_fields: Addresses_Without_Company_Stddev_Samp_Fields;
  addresses_without_company_stream_cursor_input: Addresses_Without_Company_Stream_Cursor_Input;
  addresses_without_company_stream_cursor_value_input: Addresses_Without_Company_Stream_Cursor_Value_Input;
  addresses_without_company_sum_fields: Addresses_Without_Company_Sum_Fields;
  addresses_without_company_var_pop_fields: Addresses_Without_Company_Var_Pop_Fields;
  addresses_without_company_var_samp_fields: Addresses_Without_Company_Var_Samp_Fields;
  addresses_without_company_variance_fields: Addresses_Without_Company_Variance_Fields;
  agreementTerms: AgreementTerms;
  agreementTerms_aggregate: AgreementTerms_Aggregate;
  agreementTerms_aggregate_fields: AgreementTerms_Aggregate_Fields;
  agreementTerms_avg_fields: AgreementTerms_Avg_Fields;
  agreementTerms_bool_exp: AgreementTerms_Bool_Exp;
  agreementTerms_inc_input: AgreementTerms_Inc_Input;
  agreementTerms_insert_input: AgreementTerms_Insert_Input;
  agreementTerms_max_fields: AgreementTerms_Max_Fields;
  agreementTerms_min_fields: AgreementTerms_Min_Fields;
  agreementTerms_mutation_response: AgreementTerms_Mutation_Response;
  agreementTerms_on_conflict: AgreementTerms_On_Conflict;
  agreementTerms_order_by: AgreementTerms_Order_By;
  agreementTerms_pk_columns_input: AgreementTerms_Pk_Columns_Input;
  agreementTerms_set_input: AgreementTerms_Set_Input;
  agreementTerms_stddev_fields: AgreementTerms_Stddev_Fields;
  agreementTerms_stddev_pop_fields: AgreementTerms_Stddev_Pop_Fields;
  agreementTerms_stddev_samp_fields: AgreementTerms_Stddev_Samp_Fields;
  agreementTerms_stream_cursor_input: AgreementTerms_Stream_Cursor_Input;
  agreementTerms_stream_cursor_value_input: AgreementTerms_Stream_Cursor_Value_Input;
  agreementTerms_sum_fields: AgreementTerms_Sum_Fields;
  agreementTerms_updates: AgreementTerms_Updates;
  agreementTerms_var_pop_fields: AgreementTerms_Var_Pop_Fields;
  agreementTerms_var_samp_fields: AgreementTerms_Var_Samp_Fields;
  agreementTerms_variance_fields: AgreementTerms_Variance_Fields;
  agreements: Agreements;
  agreements_aggregate: Agreements_Aggregate;
  agreements_aggregate_bool_exp: Agreements_Aggregate_Bool_Exp;
  agreements_aggregate_bool_exp_bool_and: Agreements_Aggregate_Bool_Exp_Bool_And;
  agreements_aggregate_bool_exp_bool_or: Agreements_Aggregate_Bool_Exp_Bool_Or;
  agreements_aggregate_bool_exp_count: Agreements_Aggregate_Bool_Exp_Count;
  agreements_aggregate_fields: Agreements_Aggregate_Fields;
  agreements_aggregate_order_by: Agreements_Aggregate_Order_By;
  agreements_append_input: Agreements_Append_Input;
  agreements_arr_rel_insert_input: Agreements_Arr_Rel_Insert_Input;
  agreements_avg_fields: Agreements_Avg_Fields;
  agreements_avg_order_by: Agreements_Avg_Order_By;
  agreements_bool_exp: Agreements_Bool_Exp;
  agreements_delete_at_path_input: Agreements_Delete_At_Path_Input;
  agreements_delete_elem_input: Agreements_Delete_Elem_Input;
  agreements_delete_key_input: Agreements_Delete_Key_Input;
  agreements_inc_input: Agreements_Inc_Input;
  agreements_insert_input: Agreements_Insert_Input;
  agreements_max_fields: Agreements_Max_Fields;
  agreements_max_order_by: Agreements_Max_Order_By;
  agreements_min_fields: Agreements_Min_Fields;
  agreements_min_order_by: Agreements_Min_Order_By;
  agreements_mutation_response: Agreements_Mutation_Response;
  agreements_obj_rel_insert_input: Agreements_Obj_Rel_Insert_Input;
  agreements_on_conflict: Agreements_On_Conflict;
  agreements_order_by: Agreements_Order_By;
  agreements_pk_columns_input: Agreements_Pk_Columns_Input;
  agreements_prepend_input: Agreements_Prepend_Input;
  agreements_set_input: Agreements_Set_Input;
  agreements_stddev_fields: Agreements_Stddev_Fields;
  agreements_stddev_order_by: Agreements_Stddev_Order_By;
  agreements_stddev_pop_fields: Agreements_Stddev_Pop_Fields;
  agreements_stddev_pop_order_by: Agreements_Stddev_Pop_Order_By;
  agreements_stddev_samp_fields: Agreements_Stddev_Samp_Fields;
  agreements_stddev_samp_order_by: Agreements_Stddev_Samp_Order_By;
  agreements_stream_cursor_input: Agreements_Stream_Cursor_Input;
  agreements_stream_cursor_value_input: Agreements_Stream_Cursor_Value_Input;
  agreements_sum_fields: Agreements_Sum_Fields;
  agreements_sum_order_by: Agreements_Sum_Order_By;
  agreements_updates: Agreements_Updates;
  agreements_var_pop_fields: Agreements_Var_Pop_Fields;
  agreements_var_pop_order_by: Agreements_Var_Pop_Order_By;
  agreements_var_samp_fields: Agreements_Var_Samp_Fields;
  agreements_var_samp_order_by: Agreements_Var_Samp_Order_By;
  agreements_variance_fields: Agreements_Variance_Fields;
  agreements_variance_order_by: Agreements_Variance_Order_By;
  appellations: Appellations;
  appellations_aggregate: Appellations_Aggregate;
  appellations_aggregate_fields: Appellations_Aggregate_Fields;
  appellations_avg_fields: Appellations_Avg_Fields;
  appellations_bool_exp: Appellations_Bool_Exp;
  appellations_inc_input: Appellations_Inc_Input;
  appellations_insert_input: Appellations_Insert_Input;
  appellations_max_fields: Appellations_Max_Fields;
  appellations_min_fields: Appellations_Min_Fields;
  appellations_mutation_response: Appellations_Mutation_Response;
  appellations_on_conflict: Appellations_On_Conflict;
  appellations_order_by: Appellations_Order_By;
  appellations_pk_columns_input: Appellations_Pk_Columns_Input;
  appellations_set_input: Appellations_Set_Input;
  appellations_stddev_fields: Appellations_Stddev_Fields;
  appellations_stddev_pop_fields: Appellations_Stddev_Pop_Fields;
  appellations_stddev_samp_fields: Appellations_Stddev_Samp_Fields;
  appellations_stream_cursor_input: Appellations_Stream_Cursor_Input;
  appellations_stream_cursor_value_input: Appellations_Stream_Cursor_Value_Input;
  appellations_sum_fields: Appellations_Sum_Fields;
  appellations_updates: Appellations_Updates;
  appellations_var_pop_fields: Appellations_Var_Pop_Fields;
  appellations_var_samp_fields: Appellations_Var_Samp_Fields;
  appellations_variance_fields: Appellations_Variance_Fields;
  authorizedDomains: AuthorizedDomains;
  authorizedDomains_aggregate: AuthorizedDomains_Aggregate;
  authorizedDomains_aggregate_fields: AuthorizedDomains_Aggregate_Fields;
  authorizedDomains_avg_fields: AuthorizedDomains_Avg_Fields;
  authorizedDomains_bool_exp: AuthorizedDomains_Bool_Exp;
  authorizedDomains_inc_input: AuthorizedDomains_Inc_Input;
  authorizedDomains_insert_input: AuthorizedDomains_Insert_Input;
  authorizedDomains_max_fields: AuthorizedDomains_Max_Fields;
  authorizedDomains_min_fields: AuthorizedDomains_Min_Fields;
  authorizedDomains_mutation_response: AuthorizedDomains_Mutation_Response;
  authorizedDomains_on_conflict: AuthorizedDomains_On_Conflict;
  authorizedDomains_order_by: AuthorizedDomains_Order_By;
  authorizedDomains_pk_columns_input: AuthorizedDomains_Pk_Columns_Input;
  authorizedDomains_set_input: AuthorizedDomains_Set_Input;
  authorizedDomains_stddev_fields: AuthorizedDomains_Stddev_Fields;
  authorizedDomains_stddev_pop_fields: AuthorizedDomains_Stddev_Pop_Fields;
  authorizedDomains_stddev_samp_fields: AuthorizedDomains_Stddev_Samp_Fields;
  authorizedDomains_stream_cursor_input: AuthorizedDomains_Stream_Cursor_Input;
  authorizedDomains_stream_cursor_value_input: AuthorizedDomains_Stream_Cursor_Value_Input;
  authorizedDomains_sum_fields: AuthorizedDomains_Sum_Fields;
  authorizedDomains_updates: AuthorizedDomains_Updates;
  authorizedDomains_var_pop_fields: AuthorizedDomains_Var_Pop_Fields;
  authorizedDomains_var_samp_fields: AuthorizedDomains_Var_Samp_Fields;
  authorizedDomains_variance_fields: AuthorizedDomains_Variance_Fields;
  buySpecs: BuySpecs;
  buySpecs_aggregate: BuySpecs_Aggregate;
  buySpecs_aggregate_fields: BuySpecs_Aggregate_Fields;
  buySpecs_append_input: BuySpecs_Append_Input;
  buySpecs_avg_fields: BuySpecs_Avg_Fields;
  buySpecs_bool_exp: BuySpecs_Bool_Exp;
  buySpecs_delete_at_path_input: BuySpecs_Delete_At_Path_Input;
  buySpecs_delete_elem_input: BuySpecs_Delete_Elem_Input;
  buySpecs_delete_key_input: BuySpecs_Delete_Key_Input;
  buySpecs_inc_input: BuySpecs_Inc_Input;
  buySpecs_insert_input: BuySpecs_Insert_Input;
  buySpecs_max_fields: BuySpecs_Max_Fields;
  buySpecs_min_fields: BuySpecs_Min_Fields;
  buySpecs_mutation_response: BuySpecs_Mutation_Response;
  buySpecs_obj_rel_insert_input: BuySpecs_Obj_Rel_Insert_Input;
  buySpecs_on_conflict: BuySpecs_On_Conflict;
  buySpecs_order_by: BuySpecs_Order_By;
  buySpecs_pk_columns_input: BuySpecs_Pk_Columns_Input;
  buySpecs_prepend_input: BuySpecs_Prepend_Input;
  buySpecs_set_input: BuySpecs_Set_Input;
  buySpecs_stddev_fields: BuySpecs_Stddev_Fields;
  buySpecs_stddev_pop_fields: BuySpecs_Stddev_Pop_Fields;
  buySpecs_stddev_samp_fields: BuySpecs_Stddev_Samp_Fields;
  buySpecs_stream_cursor_input: BuySpecs_Stream_Cursor_Input;
  buySpecs_stream_cursor_value_input: BuySpecs_Stream_Cursor_Value_Input;
  buySpecs_sum_fields: BuySpecs_Sum_Fields;
  buySpecs_updates: BuySpecs_Updates;
  buySpecs_var_pop_fields: BuySpecs_Var_Pop_Fields;
  buySpecs_var_samp_fields: BuySpecs_Var_Samp_Fields;
  buySpecs_variance_fields: BuySpecs_Variance_Fields;
  companies: Companies;
  companies_aggregate: Companies_Aggregate;
  companies_aggregate_fields: Companies_Aggregate_Fields;
  companies_append_input: Companies_Append_Input;
  companies_avg_fields: Companies_Avg_Fields;
  companies_bool_exp: Companies_Bool_Exp;
  companies_delete_at_path_input: Companies_Delete_At_Path_Input;
  companies_delete_elem_input: Companies_Delete_Elem_Input;
  companies_delete_key_input: Companies_Delete_Key_Input;
  companies_inc_input: Companies_Inc_Input;
  companies_insert_input: Companies_Insert_Input;
  companies_max_fields: Companies_Max_Fields;
  companies_min_fields: Companies_Min_Fields;
  companies_mutation_response: Companies_Mutation_Response;
  companies_obj_rel_insert_input: Companies_Obj_Rel_Insert_Input;
  companies_on_conflict: Companies_On_Conflict;
  companies_order_by: Companies_Order_By;
  companies_pk_columns_input: Companies_Pk_Columns_Input;
  companies_prepend_input: Companies_Prepend_Input;
  companies_set_input: Companies_Set_Input;
  companies_stddev_fields: Companies_Stddev_Fields;
  companies_stddev_pop_fields: Companies_Stddev_Pop_Fields;
  companies_stddev_samp_fields: Companies_Stddev_Samp_Fields;
  companies_stream_cursor_input: Companies_Stream_Cursor_Input;
  companies_stream_cursor_value_input: Companies_Stream_Cursor_Value_Input;
  companies_sum_fields: Companies_Sum_Fields;
  companies_updates: Companies_Updates;
  companies_var_pop_fields: Companies_Var_Pop_Fields;
  companies_var_samp_fields: Companies_Var_Samp_Fields;
  companies_variance_fields: Companies_Variance_Fields;
  companyAddress: CompanyAddress;
  companyAddress_aggregate: CompanyAddress_Aggregate;
  companyAddress_aggregate_bool_exp: CompanyAddress_Aggregate_Bool_Exp;
  companyAddress_aggregate_bool_exp_count: CompanyAddress_Aggregate_Bool_Exp_Count;
  companyAddress_aggregate_fields: CompanyAddress_Aggregate_Fields;
  companyAddress_aggregate_order_by: CompanyAddress_Aggregate_Order_By;
  companyAddress_arr_rel_insert_input: CompanyAddress_Arr_Rel_Insert_Input;
  companyAddress_avg_fields: CompanyAddress_Avg_Fields;
  companyAddress_avg_order_by: CompanyAddress_Avg_Order_By;
  companyAddress_bool_exp: CompanyAddress_Bool_Exp;
  companyAddress_inc_input: CompanyAddress_Inc_Input;
  companyAddress_insert_input: CompanyAddress_Insert_Input;
  companyAddress_max_fields: CompanyAddress_Max_Fields;
  companyAddress_max_order_by: CompanyAddress_Max_Order_By;
  companyAddress_min_fields: CompanyAddress_Min_Fields;
  companyAddress_min_order_by: CompanyAddress_Min_Order_By;
  companyAddress_mutation_response: CompanyAddress_Mutation_Response;
  companyAddress_on_conflict: CompanyAddress_On_Conflict;
  companyAddress_order_by: CompanyAddress_Order_By;
  companyAddress_pk_columns_input: CompanyAddress_Pk_Columns_Input;
  companyAddress_set_input: CompanyAddress_Set_Input;
  companyAddress_stddev_fields: CompanyAddress_Stddev_Fields;
  companyAddress_stddev_order_by: CompanyAddress_Stddev_Order_By;
  companyAddress_stddev_pop_fields: CompanyAddress_Stddev_Pop_Fields;
  companyAddress_stddev_pop_order_by: CompanyAddress_Stddev_Pop_Order_By;
  companyAddress_stddev_samp_fields: CompanyAddress_Stddev_Samp_Fields;
  companyAddress_stddev_samp_order_by: CompanyAddress_Stddev_Samp_Order_By;
  companyAddress_stream_cursor_input: CompanyAddress_Stream_Cursor_Input;
  companyAddress_stream_cursor_value_input: CompanyAddress_Stream_Cursor_Value_Input;
  companyAddress_sum_fields: CompanyAddress_Sum_Fields;
  companyAddress_sum_order_by: CompanyAddress_Sum_Order_By;
  companyAddress_updates: CompanyAddress_Updates;
  companyAddress_var_pop_fields: CompanyAddress_Var_Pop_Fields;
  companyAddress_var_pop_order_by: CompanyAddress_Var_Pop_Order_By;
  companyAddress_var_samp_fields: CompanyAddress_Var_Samp_Fields;
  companyAddress_var_samp_order_by: CompanyAddress_Var_Samp_Order_By;
  companyAddress_variance_fields: CompanyAddress_Variance_Fields;
  companyAddress_variance_order_by: CompanyAddress_Variance_Order_By;
  contacts: Contacts;
  contacts_aggregate: Contacts_Aggregate;
  contacts_aggregate_fields: Contacts_Aggregate_Fields;
  contacts_append_input: Contacts_Append_Input;
  contacts_avg_fields: Contacts_Avg_Fields;
  contacts_bool_exp: Contacts_Bool_Exp;
  contacts_delete_at_path_input: Contacts_Delete_At_Path_Input;
  contacts_delete_elem_input: Contacts_Delete_Elem_Input;
  contacts_delete_key_input: Contacts_Delete_Key_Input;
  contacts_inc_input: Contacts_Inc_Input;
  contacts_insert_input: Contacts_Insert_Input;
  contacts_max_fields: Contacts_Max_Fields;
  contacts_min_fields: Contacts_Min_Fields;
  contacts_mutation_response: Contacts_Mutation_Response;
  contacts_obj_rel_insert_input: Contacts_Obj_Rel_Insert_Input;
  contacts_on_conflict: Contacts_On_Conflict;
  contacts_order_by: Contacts_Order_By;
  contacts_pk_columns_input: Contacts_Pk_Columns_Input;
  contacts_prepend_input: Contacts_Prepend_Input;
  contacts_set_input: Contacts_Set_Input;
  contacts_stddev_fields: Contacts_Stddev_Fields;
  contacts_stddev_pop_fields: Contacts_Stddev_Pop_Fields;
  contacts_stddev_samp_fields: Contacts_Stddev_Samp_Fields;
  contacts_stream_cursor_input: Contacts_Stream_Cursor_Input;
  contacts_stream_cursor_value_input: Contacts_Stream_Cursor_Value_Input;
  contacts_sum_fields: Contacts_Sum_Fields;
  contacts_updates: Contacts_Updates;
  contacts_var_pop_fields: Contacts_Var_Pop_Fields;
  contacts_var_samp_fields: Contacts_Var_Samp_Fields;
  contacts_variance_fields: Contacts_Variance_Fields;
  contacts_without_company: Contacts_Without_Company;
  contacts_without_company_aggregate: Contacts_Without_Company_Aggregate;
  contacts_without_company_aggregate_fields: Contacts_Without_Company_Aggregate_Fields;
  contacts_without_company_avg_fields: Contacts_Without_Company_Avg_Fields;
  contacts_without_company_bool_exp: Contacts_Without_Company_Bool_Exp;
  contacts_without_company_max_fields: Contacts_Without_Company_Max_Fields;
  contacts_without_company_min_fields: Contacts_Without_Company_Min_Fields;
  contacts_without_company_order_by: Contacts_Without_Company_Order_By;
  contacts_without_company_stddev_fields: Contacts_Without_Company_Stddev_Fields;
  contacts_without_company_stddev_pop_fields: Contacts_Without_Company_Stddev_Pop_Fields;
  contacts_without_company_stddev_samp_fields: Contacts_Without_Company_Stddev_Samp_Fields;
  contacts_without_company_stream_cursor_input: Contacts_Without_Company_Stream_Cursor_Input;
  contacts_without_company_stream_cursor_value_input: Contacts_Without_Company_Stream_Cursor_Value_Input;
  contacts_without_company_sum_fields: Contacts_Without_Company_Sum_Fields;
  contacts_without_company_var_pop_fields: Contacts_Without_Company_Var_Pop_Fields;
  contacts_without_company_var_samp_fields: Contacts_Without_Company_Var_Samp_Fields;
  contacts_without_company_variance_fields: Contacts_Without_Company_Variance_Fields;
  contracts: Contracts;
  contracts_aggregate: Contracts_Aggregate;
  contracts_aggregate_fields: Contracts_Aggregate_Fields;
  contracts_avg_fields: Contracts_Avg_Fields;
  contracts_bool_exp: Contracts_Bool_Exp;
  contracts_inc_input: Contracts_Inc_Input;
  contracts_insert_input: Contracts_Insert_Input;
  contracts_max_fields: Contracts_Max_Fields;
  contracts_min_fields: Contracts_Min_Fields;
  contracts_mutation_response: Contracts_Mutation_Response;
  contracts_obj_rel_insert_input: Contracts_Obj_Rel_Insert_Input;
  contracts_on_conflict: Contracts_On_Conflict;
  contracts_order_by: Contracts_Order_By;
  contracts_pk_columns_input: Contracts_Pk_Columns_Input;
  contracts_set_input: Contracts_Set_Input;
  contracts_stddev_fields: Contracts_Stddev_Fields;
  contracts_stddev_pop_fields: Contracts_Stddev_Pop_Fields;
  contracts_stddev_samp_fields: Contracts_Stddev_Samp_Fields;
  contracts_stream_cursor_input: Contracts_Stream_Cursor_Input;
  contracts_stream_cursor_value_input: Contracts_Stream_Cursor_Value_Input;
  contracts_sum_fields: Contracts_Sum_Fields;
  contracts_updates: Contracts_Updates;
  contracts_var_pop_fields: Contracts_Var_Pop_Fields;
  contracts_var_samp_fields: Contracts_Var_Samp_Fields;
  contracts_variance_fields: Contracts_Variance_Fields;
  currenciesConversions: CurrenciesConversions;
  currenciesConversions_aggregate: CurrenciesConversions_Aggregate;
  currenciesConversions_aggregate_fields: CurrenciesConversions_Aggregate_Fields;
  currenciesConversions_append_input: CurrenciesConversions_Append_Input;
  currenciesConversions_avg_fields: CurrenciesConversions_Avg_Fields;
  currenciesConversions_bool_exp: CurrenciesConversions_Bool_Exp;
  currenciesConversions_delete_at_path_input: CurrenciesConversions_Delete_At_Path_Input;
  currenciesConversions_delete_elem_input: CurrenciesConversions_Delete_Elem_Input;
  currenciesConversions_delete_key_input: CurrenciesConversions_Delete_Key_Input;
  currenciesConversions_inc_input: CurrenciesConversions_Inc_Input;
  currenciesConversions_insert_input: CurrenciesConversions_Insert_Input;
  currenciesConversions_max_fields: CurrenciesConversions_Max_Fields;
  currenciesConversions_min_fields: CurrenciesConversions_Min_Fields;
  currenciesConversions_mutation_response: CurrenciesConversions_Mutation_Response;
  currenciesConversions_on_conflict: CurrenciesConversions_On_Conflict;
  currenciesConversions_order_by: CurrenciesConversions_Order_By;
  currenciesConversions_pk_columns_input: CurrenciesConversions_Pk_Columns_Input;
  currenciesConversions_prepend_input: CurrenciesConversions_Prepend_Input;
  currenciesConversions_set_input: CurrenciesConversions_Set_Input;
  currenciesConversions_stddev_fields: CurrenciesConversions_Stddev_Fields;
  currenciesConversions_stddev_pop_fields: CurrenciesConversions_Stddev_Pop_Fields;
  currenciesConversions_stddev_samp_fields: CurrenciesConversions_Stddev_Samp_Fields;
  currenciesConversions_stream_cursor_input: CurrenciesConversions_Stream_Cursor_Input;
  currenciesConversions_stream_cursor_value_input: CurrenciesConversions_Stream_Cursor_Value_Input;
  currenciesConversions_sum_fields: CurrenciesConversions_Sum_Fields;
  currenciesConversions_updates: CurrenciesConversions_Updates;
  currenciesConversions_var_pop_fields: CurrenciesConversions_Var_Pop_Fields;
  currenciesConversions_var_samp_fields: CurrenciesConversions_Var_Samp_Fields;
  currenciesConversions_variance_fields: CurrenciesConversions_Variance_Fields;
  date: Scalars['date'];
  date_comparison_exp: Date_Comparison_Exp;
  history: History;
  history_aggregate: History_Aggregate;
  history_aggregate_fields: History_Aggregate_Fields;
  history_append_input: History_Append_Input;
  history_avg_fields: History_Avg_Fields;
  history_bool_exp: History_Bool_Exp;
  history_delete_at_path_input: History_Delete_At_Path_Input;
  history_delete_elem_input: History_Delete_Elem_Input;
  history_delete_key_input: History_Delete_Key_Input;
  history_inc_input: History_Inc_Input;
  history_insert_input: History_Insert_Input;
  history_max_fields: History_Max_Fields;
  history_min_fields: History_Min_Fields;
  history_mutation_response: History_Mutation_Response;
  history_obj_rel_insert_input: History_Obj_Rel_Insert_Input;
  history_on_conflict: History_On_Conflict;
  history_order_by: History_Order_By;
  history_pk_columns_input: History_Pk_Columns_Input;
  history_prepend_input: History_Prepend_Input;
  history_set_input: History_Set_Input;
  history_stddev_fields: History_Stddev_Fields;
  history_stddev_pop_fields: History_Stddev_Pop_Fields;
  history_stddev_samp_fields: History_Stddev_Samp_Fields;
  history_stream_cursor_input: History_Stream_Cursor_Input;
  history_stream_cursor_value_input: History_Stream_Cursor_Value_Input;
  history_sum_fields: History_Sum_Fields;
  history_updates: History_Updates;
  history_var_pop_fields: History_Var_Pop_Fields;
  history_var_samp_fields: History_Var_Samp_Fields;
  history_variance_fields: History_Variance_Fields;
  invoices: Invoices;
  invoices_aggregate: Invoices_Aggregate;
  invoices_aggregate_bool_exp: Invoices_Aggregate_Bool_Exp;
  invoices_aggregate_bool_exp_count: Invoices_Aggregate_Bool_Exp_Count;
  invoices_aggregate_fields: Invoices_Aggregate_Fields;
  invoices_aggregate_order_by: Invoices_Aggregate_Order_By;
  invoices_append_input: Invoices_Append_Input;
  invoices_arr_rel_insert_input: Invoices_Arr_Rel_Insert_Input;
  invoices_avg_fields: Invoices_Avg_Fields;
  invoices_avg_order_by: Invoices_Avg_Order_By;
  invoices_bool_exp: Invoices_Bool_Exp;
  invoices_delete_at_path_input: Invoices_Delete_At_Path_Input;
  invoices_delete_elem_input: Invoices_Delete_Elem_Input;
  invoices_delete_key_input: Invoices_Delete_Key_Input;
  invoices_inc_input: Invoices_Inc_Input;
  invoices_insert_input: Invoices_Insert_Input;
  invoices_max_fields: Invoices_Max_Fields;
  invoices_max_order_by: Invoices_Max_Order_By;
  invoices_min_fields: Invoices_Min_Fields;
  invoices_min_order_by: Invoices_Min_Order_By;
  invoices_mutation_response: Invoices_Mutation_Response;
  invoices_on_conflict: Invoices_On_Conflict;
  invoices_order_by: Invoices_Order_By;
  invoices_pk_columns_input: Invoices_Pk_Columns_Input;
  invoices_prepend_input: Invoices_Prepend_Input;
  invoices_set_input: Invoices_Set_Input;
  invoices_stddev_fields: Invoices_Stddev_Fields;
  invoices_stddev_order_by: Invoices_Stddev_Order_By;
  invoices_stddev_pop_fields: Invoices_Stddev_Pop_Fields;
  invoices_stddev_pop_order_by: Invoices_Stddev_Pop_Order_By;
  invoices_stddev_samp_fields: Invoices_Stddev_Samp_Fields;
  invoices_stddev_samp_order_by: Invoices_Stddev_Samp_Order_By;
  invoices_stream_cursor_input: Invoices_Stream_Cursor_Input;
  invoices_stream_cursor_value_input: Invoices_Stream_Cursor_Value_Input;
  invoices_sum_fields: Invoices_Sum_Fields;
  invoices_sum_order_by: Invoices_Sum_Order_By;
  invoices_updates: Invoices_Updates;
  invoices_var_pop_fields: Invoices_Var_Pop_Fields;
  invoices_var_pop_order_by: Invoices_Var_Pop_Order_By;
  invoices_var_samp_fields: Invoices_Var_Samp_Fields;
  invoices_var_samp_order_by: Invoices_Var_Samp_Order_By;
  invoices_variance_fields: Invoices_Variance_Fields;
  invoices_variance_order_by: Invoices_Variance_Order_By;
  items: Items;
  items_aggregate: Items_Aggregate;
  items_aggregate_fields: Items_Aggregate_Fields;
  items_append_input: Items_Append_Input;
  items_avg_fields: Items_Avg_Fields;
  items_bool_exp: Items_Bool_Exp;
  items_delete_at_path_input: Items_Delete_At_Path_Input;
  items_delete_elem_input: Items_Delete_Elem_Input;
  items_delete_key_input: Items_Delete_Key_Input;
  items_inc_input: Items_Inc_Input;
  items_insert_input: Items_Insert_Input;
  items_max_fields: Items_Max_Fields;
  items_min_fields: Items_Min_Fields;
  items_mutation_response: Items_Mutation_Response;
  items_obj_rel_insert_input: Items_Obj_Rel_Insert_Input;
  items_on_conflict: Items_On_Conflict;
  items_order_by: Items_Order_By;
  items_pk_columns_input: Items_Pk_Columns_Input;
  items_prepend_input: Items_Prepend_Input;
  items_set_input: Items_Set_Input;
  items_stddev_fields: Items_Stddev_Fields;
  items_stddev_pop_fields: Items_Stddev_Pop_Fields;
  items_stddev_samp_fields: Items_Stddev_Samp_Fields;
  items_stream_cursor_input: Items_Stream_Cursor_Input;
  items_stream_cursor_value_input: Items_Stream_Cursor_Value_Input;
  items_sum_fields: Items_Sum_Fields;
  items_updates: Items_Updates;
  items_var_pop_fields: Items_Var_Pop_Fields;
  items_var_samp_fields: Items_Var_Samp_Fields;
  items_variance_fields: Items_Variance_Fields;
  jsonb: Scalars['jsonb'];
  jsonb_cast_exp: Jsonb_Cast_Exp;
  jsonb_comparison_exp: Jsonb_Comparison_Exp;
  logs: Logs;
  logs_aggregate: Logs_Aggregate;
  logs_aggregate_fields: Logs_Aggregate_Fields;
  logs_append_input: Logs_Append_Input;
  logs_avg_fields: Logs_Avg_Fields;
  logs_bool_exp: Logs_Bool_Exp;
  logs_delete_at_path_input: Logs_Delete_At_Path_Input;
  logs_delete_elem_input: Logs_Delete_Elem_Input;
  logs_delete_key_input: Logs_Delete_Key_Input;
  logs_inc_input: Logs_Inc_Input;
  logs_insert_input: Logs_Insert_Input;
  logs_max_fields: Logs_Max_Fields;
  logs_min_fields: Logs_Min_Fields;
  logs_mutation_response: Logs_Mutation_Response;
  logs_on_conflict: Logs_On_Conflict;
  logs_order_by: Logs_Order_By;
  logs_pk_columns_input: Logs_Pk_Columns_Input;
  logs_prepend_input: Logs_Prepend_Input;
  logs_set_input: Logs_Set_Input;
  logs_stddev_fields: Logs_Stddev_Fields;
  logs_stddev_pop_fields: Logs_Stddev_Pop_Fields;
  logs_stddev_samp_fields: Logs_Stddev_Samp_Fields;
  logs_stream_cursor_input: Logs_Stream_Cursor_Input;
  logs_stream_cursor_value_input: Logs_Stream_Cursor_Value_Input;
  logs_sum_fields: Logs_Sum_Fields;
  logs_updates: Logs_Updates;
  logs_var_pop_fields: Logs_Var_Pop_Fields;
  logs_var_samp_fields: Logs_Var_Samp_Fields;
  logs_variance_fields: Logs_Variance_Fields;
  matchingItemsBuySpecs: MatchingItemsBuySpecs;
  matchingItemsBuySpecs_aggregate: MatchingItemsBuySpecs_Aggregate;
  matchingItemsBuySpecs_aggregate_bool_exp: MatchingItemsBuySpecs_Aggregate_Bool_Exp;
  matchingItemsBuySpecs_aggregate_bool_exp_count: MatchingItemsBuySpecs_Aggregate_Bool_Exp_Count;
  matchingItemsBuySpecs_aggregate_fields: MatchingItemsBuySpecs_Aggregate_Fields;
  matchingItemsBuySpecs_aggregate_order_by: MatchingItemsBuySpecs_Aggregate_Order_By;
  matchingItemsBuySpecs_arr_rel_insert_input: MatchingItemsBuySpecs_Arr_Rel_Insert_Input;
  matchingItemsBuySpecs_avg_fields: MatchingItemsBuySpecs_Avg_Fields;
  matchingItemsBuySpecs_avg_order_by: MatchingItemsBuySpecs_Avg_Order_By;
  matchingItemsBuySpecs_bool_exp: MatchingItemsBuySpecs_Bool_Exp;
  matchingItemsBuySpecs_inc_input: MatchingItemsBuySpecs_Inc_Input;
  matchingItemsBuySpecs_insert_input: MatchingItemsBuySpecs_Insert_Input;
  matchingItemsBuySpecs_max_fields: MatchingItemsBuySpecs_Max_Fields;
  matchingItemsBuySpecs_max_order_by: MatchingItemsBuySpecs_Max_Order_By;
  matchingItemsBuySpecs_min_fields: MatchingItemsBuySpecs_Min_Fields;
  matchingItemsBuySpecs_min_order_by: MatchingItemsBuySpecs_Min_Order_By;
  matchingItemsBuySpecs_mutation_response: MatchingItemsBuySpecs_Mutation_Response;
  matchingItemsBuySpecs_on_conflict: MatchingItemsBuySpecs_On_Conflict;
  matchingItemsBuySpecs_order_by: MatchingItemsBuySpecs_Order_By;
  matchingItemsBuySpecs_pk_columns_input: MatchingItemsBuySpecs_Pk_Columns_Input;
  matchingItemsBuySpecs_set_input: MatchingItemsBuySpecs_Set_Input;
  matchingItemsBuySpecs_stddev_fields: MatchingItemsBuySpecs_Stddev_Fields;
  matchingItemsBuySpecs_stddev_order_by: MatchingItemsBuySpecs_Stddev_Order_By;
  matchingItemsBuySpecs_stddev_pop_fields: MatchingItemsBuySpecs_Stddev_Pop_Fields;
  matchingItemsBuySpecs_stddev_pop_order_by: MatchingItemsBuySpecs_Stddev_Pop_Order_By;
  matchingItemsBuySpecs_stddev_samp_fields: MatchingItemsBuySpecs_Stddev_Samp_Fields;
  matchingItemsBuySpecs_stddev_samp_order_by: MatchingItemsBuySpecs_Stddev_Samp_Order_By;
  matchingItemsBuySpecs_stream_cursor_input: MatchingItemsBuySpecs_Stream_Cursor_Input;
  matchingItemsBuySpecs_stream_cursor_value_input: MatchingItemsBuySpecs_Stream_Cursor_Value_Input;
  matchingItemsBuySpecs_sum_fields: MatchingItemsBuySpecs_Sum_Fields;
  matchingItemsBuySpecs_sum_order_by: MatchingItemsBuySpecs_Sum_Order_By;
  matchingItemsBuySpecs_updates: MatchingItemsBuySpecs_Updates;
  matchingItemsBuySpecs_var_pop_fields: MatchingItemsBuySpecs_Var_Pop_Fields;
  matchingItemsBuySpecs_var_pop_order_by: MatchingItemsBuySpecs_Var_Pop_Order_By;
  matchingItemsBuySpecs_var_samp_fields: MatchingItemsBuySpecs_Var_Samp_Fields;
  matchingItemsBuySpecs_var_samp_order_by: MatchingItemsBuySpecs_Var_Samp_Order_By;
  matchingItemsBuySpecs_variance_fields: MatchingItemsBuySpecs_Variance_Fields;
  matchingItemsBuySpecs_variance_order_by: MatchingItemsBuySpecs_Variance_Order_By;
  mutation_root: {};
  notifications: Notifications;
  notifications_aggregate: Notifications_Aggregate;
  notifications_aggregate_fields: Notifications_Aggregate_Fields;
  notifications_avg_fields: Notifications_Avg_Fields;
  notifications_bool_exp: Notifications_Bool_Exp;
  notifications_inc_input: Notifications_Inc_Input;
  notifications_insert_input: Notifications_Insert_Input;
  notifications_max_fields: Notifications_Max_Fields;
  notifications_min_fields: Notifications_Min_Fields;
  notifications_mutation_response: Notifications_Mutation_Response;
  notifications_on_conflict: Notifications_On_Conflict;
  notifications_order_by: Notifications_Order_By;
  notifications_pk_columns_input: Notifications_Pk_Columns_Input;
  notifications_set_input: Notifications_Set_Input;
  notifications_stddev_fields: Notifications_Stddev_Fields;
  notifications_stddev_pop_fields: Notifications_Stddev_Pop_Fields;
  notifications_stddev_samp_fields: Notifications_Stddev_Samp_Fields;
  notifications_stream_cursor_input: Notifications_Stream_Cursor_Input;
  notifications_stream_cursor_value_input: Notifications_Stream_Cursor_Value_Input;
  notifications_sum_fields: Notifications_Sum_Fields;
  notifications_updates: Notifications_Updates;
  notifications_var_pop_fields: Notifications_Var_Pop_Fields;
  notifications_var_samp_fields: Notifications_Var_Samp_Fields;
  notifications_variance_fields: Notifications_Variance_Fields;
  offices: Offices;
  offices_aggregate: Offices_Aggregate;
  offices_aggregate_fields: Offices_Aggregate_Fields;
  offices_avg_fields: Offices_Avg_Fields;
  offices_bool_exp: Offices_Bool_Exp;
  offices_inc_input: Offices_Inc_Input;
  offices_insert_input: Offices_Insert_Input;
  offices_max_fields: Offices_Max_Fields;
  offices_min_fields: Offices_Min_Fields;
  offices_mutation_response: Offices_Mutation_Response;
  offices_obj_rel_insert_input: Offices_Obj_Rel_Insert_Input;
  offices_on_conflict: Offices_On_Conflict;
  offices_order_by: Offices_Order_By;
  offices_pk_columns_input: Offices_Pk_Columns_Input;
  offices_set_input: Offices_Set_Input;
  offices_stddev_fields: Offices_Stddev_Fields;
  offices_stddev_pop_fields: Offices_Stddev_Pop_Fields;
  offices_stddev_samp_fields: Offices_Stddev_Samp_Fields;
  offices_stream_cursor_input: Offices_Stream_Cursor_Input;
  offices_stream_cursor_value_input: Offices_Stream_Cursor_Value_Input;
  offices_sum_fields: Offices_Sum_Fields;
  offices_updates: Offices_Updates;
  offices_var_pop_fields: Offices_Var_Pop_Fields;
  offices_var_samp_fields: Offices_Var_Samp_Fields;
  offices_variance_fields: Offices_Variance_Fields;
  query_root: {};
  releases: Releases;
  releases_aggregate: Releases_Aggregate;
  releases_aggregate_fields: Releases_Aggregate_Fields;
  releases_avg_fields: Releases_Avg_Fields;
  releases_bool_exp: Releases_Bool_Exp;
  releases_inc_input: Releases_Inc_Input;
  releases_insert_input: Releases_Insert_Input;
  releases_max_fields: Releases_Max_Fields;
  releases_min_fields: Releases_Min_Fields;
  releases_mutation_response: Releases_Mutation_Response;
  releases_on_conflict: Releases_On_Conflict;
  releases_order_by: Releases_Order_By;
  releases_pk_columns_input: Releases_Pk_Columns_Input;
  releases_set_input: Releases_Set_Input;
  releases_stddev_fields: Releases_Stddev_Fields;
  releases_stddev_pop_fields: Releases_Stddev_Pop_Fields;
  releases_stddev_samp_fields: Releases_Stddev_Samp_Fields;
  releases_stream_cursor_input: Releases_Stream_Cursor_Input;
  releases_stream_cursor_value_input: Releases_Stream_Cursor_Value_Input;
  releases_sum_fields: Releases_Sum_Fields;
  releases_updates: Releases_Updates;
  releases_var_pop_fields: Releases_Var_Pop_Fields;
  releases_var_samp_fields: Releases_Var_Samp_Fields;
  releases_variance_fields: Releases_Variance_Fields;
  reminders: Reminders;
  reminders_aggregate: Reminders_Aggregate;
  reminders_aggregate_fields: Reminders_Aggregate_Fields;
  reminders_avg_fields: Reminders_Avg_Fields;
  reminders_bool_exp: Reminders_Bool_Exp;
  reminders_inc_input: Reminders_Inc_Input;
  reminders_insert_input: Reminders_Insert_Input;
  reminders_max_fields: Reminders_Max_Fields;
  reminders_min_fields: Reminders_Min_Fields;
  reminders_mutation_response: Reminders_Mutation_Response;
  reminders_on_conflict: Reminders_On_Conflict;
  reminders_order_by: Reminders_Order_By;
  reminders_pk_columns_input: Reminders_Pk_Columns_Input;
  reminders_set_input: Reminders_Set_Input;
  reminders_stddev_fields: Reminders_Stddev_Fields;
  reminders_stddev_pop_fields: Reminders_Stddev_Pop_Fields;
  reminders_stddev_samp_fields: Reminders_Stddev_Samp_Fields;
  reminders_stream_cursor_input: Reminders_Stream_Cursor_Input;
  reminders_stream_cursor_value_input: Reminders_Stream_Cursor_Value_Input;
  reminders_sum_fields: Reminders_Sum_Fields;
  reminders_updates: Reminders_Updates;
  reminders_var_pop_fields: Reminders_Var_Pop_Fields;
  reminders_var_samp_fields: Reminders_Var_Samp_Fields;
  reminders_variance_fields: Reminders_Variance_Fields;
  sampleLabels: SampleLabels;
  sampleLabels_aggregate: SampleLabels_Aggregate;
  sampleLabels_aggregate_fields: SampleLabels_Aggregate_Fields;
  sampleLabels_append_input: SampleLabels_Append_Input;
  sampleLabels_avg_fields: SampleLabels_Avg_Fields;
  sampleLabels_bool_exp: SampleLabels_Bool_Exp;
  sampleLabels_delete_at_path_input: SampleLabels_Delete_At_Path_Input;
  sampleLabels_delete_elem_input: SampleLabels_Delete_Elem_Input;
  sampleLabels_delete_key_input: SampleLabels_Delete_Key_Input;
  sampleLabels_inc_input: SampleLabels_Inc_Input;
  sampleLabels_insert_input: SampleLabels_Insert_Input;
  sampleLabels_max_fields: SampleLabels_Max_Fields;
  sampleLabels_min_fields: SampleLabels_Min_Fields;
  sampleLabels_mutation_response: SampleLabels_Mutation_Response;
  sampleLabels_on_conflict: SampleLabels_On_Conflict;
  sampleLabels_order_by: SampleLabels_Order_By;
  sampleLabels_pk_columns_input: SampleLabels_Pk_Columns_Input;
  sampleLabels_prepend_input: SampleLabels_Prepend_Input;
  sampleLabels_set_input: SampleLabels_Set_Input;
  sampleLabels_stddev_fields: SampleLabels_Stddev_Fields;
  sampleLabels_stddev_pop_fields: SampleLabels_Stddev_Pop_Fields;
  sampleLabels_stddev_samp_fields: SampleLabels_Stddev_Samp_Fields;
  sampleLabels_stream_cursor_input: SampleLabels_Stream_Cursor_Input;
  sampleLabels_stream_cursor_value_input: SampleLabels_Stream_Cursor_Value_Input;
  sampleLabels_sum_fields: SampleLabels_Sum_Fields;
  sampleLabels_updates: SampleLabels_Updates;
  sampleLabels_var_pop_fields: SampleLabels_Var_Pop_Fields;
  sampleLabels_var_samp_fields: SampleLabels_Var_Samp_Fields;
  sampleLabels_variance_fields: SampleLabels_Variance_Fields;
  sampleShipmentRequests: SampleShipmentRequests;
  sampleShipmentRequests_aggregate: SampleShipmentRequests_Aggregate;
  sampleShipmentRequests_aggregate_bool_exp: SampleShipmentRequests_Aggregate_Bool_Exp;
  sampleShipmentRequests_aggregate_bool_exp_count: SampleShipmentRequests_Aggregate_Bool_Exp_Count;
  sampleShipmentRequests_aggregate_fields: SampleShipmentRequests_Aggregate_Fields;
  sampleShipmentRequests_aggregate_order_by: SampleShipmentRequests_Aggregate_Order_By;
  sampleShipmentRequests_append_input: SampleShipmentRequests_Append_Input;
  sampleShipmentRequests_arr_rel_insert_input: SampleShipmentRequests_Arr_Rel_Insert_Input;
  sampleShipmentRequests_avg_fields: SampleShipmentRequests_Avg_Fields;
  sampleShipmentRequests_avg_order_by: SampleShipmentRequests_Avg_Order_By;
  sampleShipmentRequests_bool_exp: SampleShipmentRequests_Bool_Exp;
  sampleShipmentRequests_delete_at_path_input: SampleShipmentRequests_Delete_At_Path_Input;
  sampleShipmentRequests_delete_elem_input: SampleShipmentRequests_Delete_Elem_Input;
  sampleShipmentRequests_delete_key_input: SampleShipmentRequests_Delete_Key_Input;
  sampleShipmentRequests_inc_input: SampleShipmentRequests_Inc_Input;
  sampleShipmentRequests_insert_input: SampleShipmentRequests_Insert_Input;
  sampleShipmentRequests_max_fields: SampleShipmentRequests_Max_Fields;
  sampleShipmentRequests_max_order_by: SampleShipmentRequests_Max_Order_By;
  sampleShipmentRequests_min_fields: SampleShipmentRequests_Min_Fields;
  sampleShipmentRequests_min_order_by: SampleShipmentRequests_Min_Order_By;
  sampleShipmentRequests_mutation_response: SampleShipmentRequests_Mutation_Response;
  sampleShipmentRequests_on_conflict: SampleShipmentRequests_On_Conflict;
  sampleShipmentRequests_order_by: SampleShipmentRequests_Order_By;
  sampleShipmentRequests_pk_columns_input: SampleShipmentRequests_Pk_Columns_Input;
  sampleShipmentRequests_prepend_input: SampleShipmentRequests_Prepend_Input;
  sampleShipmentRequests_set_input: SampleShipmentRequests_Set_Input;
  sampleShipmentRequests_stddev_fields: SampleShipmentRequests_Stddev_Fields;
  sampleShipmentRequests_stddev_order_by: SampleShipmentRequests_Stddev_Order_By;
  sampleShipmentRequests_stddev_pop_fields: SampleShipmentRequests_Stddev_Pop_Fields;
  sampleShipmentRequests_stddev_pop_order_by: SampleShipmentRequests_Stddev_Pop_Order_By;
  sampleShipmentRequests_stddev_samp_fields: SampleShipmentRequests_Stddev_Samp_Fields;
  sampleShipmentRequests_stddev_samp_order_by: SampleShipmentRequests_Stddev_Samp_Order_By;
  sampleShipmentRequests_stream_cursor_input: SampleShipmentRequests_Stream_Cursor_Input;
  sampleShipmentRequests_stream_cursor_value_input: SampleShipmentRequests_Stream_Cursor_Value_Input;
  sampleShipmentRequests_sum_fields: SampleShipmentRequests_Sum_Fields;
  sampleShipmentRequests_sum_order_by: SampleShipmentRequests_Sum_Order_By;
  sampleShipmentRequests_updates: SampleShipmentRequests_Updates;
  sampleShipmentRequests_var_pop_fields: SampleShipmentRequests_Var_Pop_Fields;
  sampleShipmentRequests_var_pop_order_by: SampleShipmentRequests_Var_Pop_Order_By;
  sampleShipmentRequests_var_samp_fields: SampleShipmentRequests_Var_Samp_Fields;
  sampleShipmentRequests_var_samp_order_by: SampleShipmentRequests_Var_Samp_Order_By;
  sampleShipmentRequests_variance_fields: SampleShipmentRequests_Variance_Fields;
  sampleShipmentRequests_variance_order_by: SampleShipmentRequests_Variance_Order_By;
  sampleShipments: SampleShipments;
  sampleShipments_aggregate: SampleShipments_Aggregate;
  sampleShipments_aggregate_fields: SampleShipments_Aggregate_Fields;
  sampleShipments_avg_fields: SampleShipments_Avg_Fields;
  sampleShipments_bool_exp: SampleShipments_Bool_Exp;
  sampleShipments_inc_input: SampleShipments_Inc_Input;
  sampleShipments_insert_input: SampleShipments_Insert_Input;
  sampleShipments_max_fields: SampleShipments_Max_Fields;
  sampleShipments_min_fields: SampleShipments_Min_Fields;
  sampleShipments_mutation_response: SampleShipments_Mutation_Response;
  sampleShipments_obj_rel_insert_input: SampleShipments_Obj_Rel_Insert_Input;
  sampleShipments_on_conflict: SampleShipments_On_Conflict;
  sampleShipments_order_by: SampleShipments_Order_By;
  sampleShipments_pk_columns_input: SampleShipments_Pk_Columns_Input;
  sampleShipments_set_input: SampleShipments_Set_Input;
  sampleShipments_stddev_fields: SampleShipments_Stddev_Fields;
  sampleShipments_stddev_pop_fields: SampleShipments_Stddev_Pop_Fields;
  sampleShipments_stddev_samp_fields: SampleShipments_Stddev_Samp_Fields;
  sampleShipments_stream_cursor_input: SampleShipments_Stream_Cursor_Input;
  sampleShipments_stream_cursor_value_input: SampleShipments_Stream_Cursor_Value_Input;
  sampleShipments_sum_fields: SampleShipments_Sum_Fields;
  sampleShipments_updates: SampleShipments_Updates;
  sampleShipments_var_pop_fields: SampleShipments_Var_Pop_Fields;
  sampleShipments_var_samp_fields: SampleShipments_Var_Samp_Fields;
  sampleShipments_variance_fields: SampleShipments_Variance_Fields;
  samples: Samples;
  samples_aggregate: Samples_Aggregate;
  samples_aggregate_bool_exp: Samples_Aggregate_Bool_Exp;
  samples_aggregate_bool_exp_count: Samples_Aggregate_Bool_Exp_Count;
  samples_aggregate_fields: Samples_Aggregate_Fields;
  samples_aggregate_order_by: Samples_Aggregate_Order_By;
  samples_append_input: Samples_Append_Input;
  samples_arr_rel_insert_input: Samples_Arr_Rel_Insert_Input;
  samples_avg_fields: Samples_Avg_Fields;
  samples_avg_order_by: Samples_Avg_Order_By;
  samples_bool_exp: Samples_Bool_Exp;
  samples_delete_at_path_input: Samples_Delete_At_Path_Input;
  samples_delete_elem_input: Samples_Delete_Elem_Input;
  samples_delete_key_input: Samples_Delete_Key_Input;
  samples_inc_input: Samples_Inc_Input;
  samples_insert_input: Samples_Insert_Input;
  samples_max_fields: Samples_Max_Fields;
  samples_max_order_by: Samples_Max_Order_By;
  samples_min_fields: Samples_Min_Fields;
  samples_min_order_by: Samples_Min_Order_By;
  samples_mutation_response: Samples_Mutation_Response;
  samples_on_conflict: Samples_On_Conflict;
  samples_order_by: Samples_Order_By;
  samples_pk_columns_input: Samples_Pk_Columns_Input;
  samples_prepend_input: Samples_Prepend_Input;
  samples_set_input: Samples_Set_Input;
  samples_stddev_fields: Samples_Stddev_Fields;
  samples_stddev_order_by: Samples_Stddev_Order_By;
  samples_stddev_pop_fields: Samples_Stddev_Pop_Fields;
  samples_stddev_pop_order_by: Samples_Stddev_Pop_Order_By;
  samples_stddev_samp_fields: Samples_Stddev_Samp_Fields;
  samples_stddev_samp_order_by: Samples_Stddev_Samp_Order_By;
  samples_stream_cursor_input: Samples_Stream_Cursor_Input;
  samples_stream_cursor_value_input: Samples_Stream_Cursor_Value_Input;
  samples_sum_fields: Samples_Sum_Fields;
  samples_sum_order_by: Samples_Sum_Order_By;
  samples_updates: Samples_Updates;
  samples_var_pop_fields: Samples_Var_Pop_Fields;
  samples_var_pop_order_by: Samples_Var_Pop_Order_By;
  samples_var_samp_fields: Samples_Var_Samp_Fields;
  samples_var_samp_order_by: Samples_Var_Samp_Order_By;
  samples_variance_fields: Samples_Variance_Fields;
  samples_variance_order_by: Samples_Variance_Order_By;
  shipmentFulfillments: ShipmentFulfillments;
  shipmentFulfillments_aggregate: ShipmentFulfillments_Aggregate;
  shipmentFulfillments_aggregate_bool_exp: ShipmentFulfillments_Aggregate_Bool_Exp;
  shipmentFulfillments_aggregate_bool_exp_count: ShipmentFulfillments_Aggregate_Bool_Exp_Count;
  shipmentFulfillments_aggregate_fields: ShipmentFulfillments_Aggregate_Fields;
  shipmentFulfillments_aggregate_order_by: ShipmentFulfillments_Aggregate_Order_By;
  shipmentFulfillments_append_input: ShipmentFulfillments_Append_Input;
  shipmentFulfillments_arr_rel_insert_input: ShipmentFulfillments_Arr_Rel_Insert_Input;
  shipmentFulfillments_avg_fields: ShipmentFulfillments_Avg_Fields;
  shipmentFulfillments_avg_order_by: ShipmentFulfillments_Avg_Order_By;
  shipmentFulfillments_bool_exp: ShipmentFulfillments_Bool_Exp;
  shipmentFulfillments_delete_at_path_input: ShipmentFulfillments_Delete_At_Path_Input;
  shipmentFulfillments_delete_elem_input: ShipmentFulfillments_Delete_Elem_Input;
  shipmentFulfillments_delete_key_input: ShipmentFulfillments_Delete_Key_Input;
  shipmentFulfillments_inc_input: ShipmentFulfillments_Inc_Input;
  shipmentFulfillments_insert_input: ShipmentFulfillments_Insert_Input;
  shipmentFulfillments_max_fields: ShipmentFulfillments_Max_Fields;
  shipmentFulfillments_max_order_by: ShipmentFulfillments_Max_Order_By;
  shipmentFulfillments_min_fields: ShipmentFulfillments_Min_Fields;
  shipmentFulfillments_min_order_by: ShipmentFulfillments_Min_Order_By;
  shipmentFulfillments_mutation_response: ShipmentFulfillments_Mutation_Response;
  shipmentFulfillments_obj_rel_insert_input: ShipmentFulfillments_Obj_Rel_Insert_Input;
  shipmentFulfillments_on_conflict: ShipmentFulfillments_On_Conflict;
  shipmentFulfillments_order_by: ShipmentFulfillments_Order_By;
  shipmentFulfillments_pk_columns_input: ShipmentFulfillments_Pk_Columns_Input;
  shipmentFulfillments_prepend_input: ShipmentFulfillments_Prepend_Input;
  shipmentFulfillments_set_input: ShipmentFulfillments_Set_Input;
  shipmentFulfillments_stddev_fields: ShipmentFulfillments_Stddev_Fields;
  shipmentFulfillments_stddev_order_by: ShipmentFulfillments_Stddev_Order_By;
  shipmentFulfillments_stddev_pop_fields: ShipmentFulfillments_Stddev_Pop_Fields;
  shipmentFulfillments_stddev_pop_order_by: ShipmentFulfillments_Stddev_Pop_Order_By;
  shipmentFulfillments_stddev_samp_fields: ShipmentFulfillments_Stddev_Samp_Fields;
  shipmentFulfillments_stddev_samp_order_by: ShipmentFulfillments_Stddev_Samp_Order_By;
  shipmentFulfillments_stream_cursor_input: ShipmentFulfillments_Stream_Cursor_Input;
  shipmentFulfillments_stream_cursor_value_input: ShipmentFulfillments_Stream_Cursor_Value_Input;
  shipmentFulfillments_sum_fields: ShipmentFulfillments_Sum_Fields;
  shipmentFulfillments_sum_order_by: ShipmentFulfillments_Sum_Order_By;
  shipmentFulfillments_updates: ShipmentFulfillments_Updates;
  shipmentFulfillments_var_pop_fields: ShipmentFulfillments_Var_Pop_Fields;
  shipmentFulfillments_var_pop_order_by: ShipmentFulfillments_Var_Pop_Order_By;
  shipmentFulfillments_var_samp_fields: ShipmentFulfillments_Var_Samp_Fields;
  shipmentFulfillments_var_samp_order_by: ShipmentFulfillments_Var_Samp_Order_By;
  shipmentFulfillments_variance_fields: ShipmentFulfillments_Variance_Fields;
  shipmentFulfillments_variance_order_by: ShipmentFulfillments_Variance_Order_By;
  subscription_root: {};
  timestamp: Scalars['timestamp'];
  timestamp_comparison_exp: Timestamp_Comparison_Exp;
  timestamptz: Scalars['timestamptz'];
  timestamptz_comparison_exp: Timestamptz_Comparison_Exp;
  trackings: Trackings;
  trackings_aggregate: Trackings_Aggregate;
  trackings_aggregate_fields: Trackings_Aggregate_Fields;
  trackings_append_input: Trackings_Append_Input;
  trackings_avg_fields: Trackings_Avg_Fields;
  trackings_bool_exp: Trackings_Bool_Exp;
  trackings_delete_at_path_input: Trackings_Delete_At_Path_Input;
  trackings_delete_elem_input: Trackings_Delete_Elem_Input;
  trackings_delete_key_input: Trackings_Delete_Key_Input;
  trackings_inc_input: Trackings_Inc_Input;
  trackings_insert_input: Trackings_Insert_Input;
  trackings_max_fields: Trackings_Max_Fields;
  trackings_min_fields: Trackings_Min_Fields;
  trackings_mutation_response: Trackings_Mutation_Response;
  trackings_on_conflict: Trackings_On_Conflict;
  trackings_order_by: Trackings_Order_By;
  trackings_pk_columns_input: Trackings_Pk_Columns_Input;
  trackings_prepend_input: Trackings_Prepend_Input;
  trackings_set_input: Trackings_Set_Input;
  trackings_stddev_fields: Trackings_Stddev_Fields;
  trackings_stddev_pop_fields: Trackings_Stddev_Pop_Fields;
  trackings_stddev_samp_fields: Trackings_Stddev_Samp_Fields;
  trackings_stream_cursor_input: Trackings_Stream_Cursor_Input;
  trackings_stream_cursor_value_input: Trackings_Stream_Cursor_Value_Input;
  trackings_sum_fields: Trackings_Sum_Fields;
  trackings_updates: Trackings_Updates;
  trackings_var_pop_fields: Trackings_Var_Pop_Fields;
  trackings_var_samp_fields: Trackings_Var_Samp_Fields;
  trackings_variance_fields: Trackings_Variance_Fields;
  users: Users;
  usersBonus: UsersBonus;
  usersBonus_aggregate: UsersBonus_Aggregate;
  usersBonus_aggregate_bool_exp: UsersBonus_Aggregate_Bool_Exp;
  usersBonus_aggregate_bool_exp_count: UsersBonus_Aggregate_Bool_Exp_Count;
  usersBonus_aggregate_fields: UsersBonus_Aggregate_Fields;
  usersBonus_aggregate_order_by: UsersBonus_Aggregate_Order_By;
  usersBonus_arr_rel_insert_input: UsersBonus_Arr_Rel_Insert_Input;
  usersBonus_avg_fields: UsersBonus_Avg_Fields;
  usersBonus_avg_order_by: UsersBonus_Avg_Order_By;
  usersBonus_bool_exp: UsersBonus_Bool_Exp;
  usersBonus_inc_input: UsersBonus_Inc_Input;
  usersBonus_insert_input: UsersBonus_Insert_Input;
  usersBonus_max_fields: UsersBonus_Max_Fields;
  usersBonus_max_order_by: UsersBonus_Max_Order_By;
  usersBonus_min_fields: UsersBonus_Min_Fields;
  usersBonus_min_order_by: UsersBonus_Min_Order_By;
  usersBonus_mutation_response: UsersBonus_Mutation_Response;
  usersBonus_on_conflict: UsersBonus_On_Conflict;
  usersBonus_order_by: UsersBonus_Order_By;
  usersBonus_pk_columns_input: UsersBonus_Pk_Columns_Input;
  usersBonus_set_input: UsersBonus_Set_Input;
  usersBonus_stddev_fields: UsersBonus_Stddev_Fields;
  usersBonus_stddev_order_by: UsersBonus_Stddev_Order_By;
  usersBonus_stddev_pop_fields: UsersBonus_Stddev_Pop_Fields;
  usersBonus_stddev_pop_order_by: UsersBonus_Stddev_Pop_Order_By;
  usersBonus_stddev_samp_fields: UsersBonus_Stddev_Samp_Fields;
  usersBonus_stddev_samp_order_by: UsersBonus_Stddev_Samp_Order_By;
  usersBonus_stream_cursor_input: UsersBonus_Stream_Cursor_Input;
  usersBonus_stream_cursor_value_input: UsersBonus_Stream_Cursor_Value_Input;
  usersBonus_sum_fields: UsersBonus_Sum_Fields;
  usersBonus_sum_order_by: UsersBonus_Sum_Order_By;
  usersBonus_updates: UsersBonus_Updates;
  usersBonus_var_pop_fields: UsersBonus_Var_Pop_Fields;
  usersBonus_var_pop_order_by: UsersBonus_Var_Pop_Order_By;
  usersBonus_var_samp_fields: UsersBonus_Var_Samp_Fields;
  usersBonus_var_samp_order_by: UsersBonus_Var_Samp_Order_By;
  usersBonus_variance_fields: UsersBonus_Variance_Fields;
  usersBonus_variance_order_by: UsersBonus_Variance_Order_By;
  usersCosts: UsersCosts;
  usersCosts_aggregate: UsersCosts_Aggregate;
  usersCosts_aggregate_bool_exp: UsersCosts_Aggregate_Bool_Exp;
  usersCosts_aggregate_bool_exp_count: UsersCosts_Aggregate_Bool_Exp_Count;
  usersCosts_aggregate_fields: UsersCosts_Aggregate_Fields;
  usersCosts_aggregate_order_by: UsersCosts_Aggregate_Order_By;
  usersCosts_arr_rel_insert_input: UsersCosts_Arr_Rel_Insert_Input;
  usersCosts_avg_fields: UsersCosts_Avg_Fields;
  usersCosts_avg_order_by: UsersCosts_Avg_Order_By;
  usersCosts_bool_exp: UsersCosts_Bool_Exp;
  usersCosts_inc_input: UsersCosts_Inc_Input;
  usersCosts_insert_input: UsersCosts_Insert_Input;
  usersCosts_max_fields: UsersCosts_Max_Fields;
  usersCosts_max_order_by: UsersCosts_Max_Order_By;
  usersCosts_min_fields: UsersCosts_Min_Fields;
  usersCosts_min_order_by: UsersCosts_Min_Order_By;
  usersCosts_mutation_response: UsersCosts_Mutation_Response;
  usersCosts_on_conflict: UsersCosts_On_Conflict;
  usersCosts_order_by: UsersCosts_Order_By;
  usersCosts_pk_columns_input: UsersCosts_Pk_Columns_Input;
  usersCosts_set_input: UsersCosts_Set_Input;
  usersCosts_stddev_fields: UsersCosts_Stddev_Fields;
  usersCosts_stddev_order_by: UsersCosts_Stddev_Order_By;
  usersCosts_stddev_pop_fields: UsersCosts_Stddev_Pop_Fields;
  usersCosts_stddev_pop_order_by: UsersCosts_Stddev_Pop_Order_By;
  usersCosts_stddev_samp_fields: UsersCosts_Stddev_Samp_Fields;
  usersCosts_stddev_samp_order_by: UsersCosts_Stddev_Samp_Order_By;
  usersCosts_stream_cursor_input: UsersCosts_Stream_Cursor_Input;
  usersCosts_stream_cursor_value_input: UsersCosts_Stream_Cursor_Value_Input;
  usersCosts_sum_fields: UsersCosts_Sum_Fields;
  usersCosts_sum_order_by: UsersCosts_Sum_Order_By;
  usersCosts_updates: UsersCosts_Updates;
  usersCosts_var_pop_fields: UsersCosts_Var_Pop_Fields;
  usersCosts_var_pop_order_by: UsersCosts_Var_Pop_Order_By;
  usersCosts_var_samp_fields: UsersCosts_Var_Samp_Fields;
  usersCosts_var_samp_order_by: UsersCosts_Var_Samp_Order_By;
  usersCosts_variance_fields: UsersCosts_Variance_Fields;
  usersCosts_variance_order_by: UsersCosts_Variance_Order_By;
  users_aggregate: Users_Aggregate;
  users_aggregate_bool_exp: Users_Aggregate_Bool_Exp;
  users_aggregate_bool_exp_bool_and: Users_Aggregate_Bool_Exp_Bool_And;
  users_aggregate_bool_exp_bool_or: Users_Aggregate_Bool_Exp_Bool_Or;
  users_aggregate_bool_exp_count: Users_Aggregate_Bool_Exp_Count;
  users_aggregate_fields: Users_Aggregate_Fields;
  users_aggregate_order_by: Users_Aggregate_Order_By;
  users_append_input: Users_Append_Input;
  users_arr_rel_insert_input: Users_Arr_Rel_Insert_Input;
  users_avg_fields: Users_Avg_Fields;
  users_avg_order_by: Users_Avg_Order_By;
  users_bool_exp: Users_Bool_Exp;
  users_delete_at_path_input: Users_Delete_At_Path_Input;
  users_delete_elem_input: Users_Delete_Elem_Input;
  users_delete_key_input: Users_Delete_Key_Input;
  users_inc_input: Users_Inc_Input;
  users_insert_input: Users_Insert_Input;
  users_max_fields: Users_Max_Fields;
  users_max_order_by: Users_Max_Order_By;
  users_min_fields: Users_Min_Fields;
  users_min_order_by: Users_Min_Order_By;
  users_mutation_response: Users_Mutation_Response;
  users_obj_rel_insert_input: Users_Obj_Rel_Insert_Input;
  users_on_conflict: Users_On_Conflict;
  users_order_by: Users_Order_By;
  users_pk_columns_input: Users_Pk_Columns_Input;
  users_prepend_input: Users_Prepend_Input;
  users_set_input: Users_Set_Input;
  users_stddev_fields: Users_Stddev_Fields;
  users_stddev_order_by: Users_Stddev_Order_By;
  users_stddev_pop_fields: Users_Stddev_Pop_Fields;
  users_stddev_pop_order_by: Users_Stddev_Pop_Order_By;
  users_stddev_samp_fields: Users_Stddev_Samp_Fields;
  users_stddev_samp_order_by: Users_Stddev_Samp_Order_By;
  users_stream_cursor_input: Users_Stream_Cursor_Input;
  users_stream_cursor_value_input: Users_Stream_Cursor_Value_Input;
  users_sum_fields: Users_Sum_Fields;
  users_sum_order_by: Users_Sum_Order_By;
  users_updates: Users_Updates;
  users_var_pop_fields: Users_Var_Pop_Fields;
  users_var_pop_order_by: Users_Var_Pop_Order_By;
  users_var_samp_fields: Users_Var_Samp_Fields;
  users_var_samp_order_by: Users_Var_Samp_Order_By;
  users_variance_fields: Users_Variance_Fields;
  users_variance_order_by: Users_Variance_Order_By;
  validationsContracts: ValidationsContracts;
  validationsContracts_aggregate: ValidationsContracts_Aggregate;
  validationsContracts_aggregate_bool_exp: ValidationsContracts_Aggregate_Bool_Exp;
  validationsContracts_aggregate_bool_exp_count: ValidationsContracts_Aggregate_Bool_Exp_Count;
  validationsContracts_aggregate_fields: ValidationsContracts_Aggregate_Fields;
  validationsContracts_aggregate_order_by: ValidationsContracts_Aggregate_Order_By;
  validationsContracts_arr_rel_insert_input: ValidationsContracts_Arr_Rel_Insert_Input;
  validationsContracts_avg_fields: ValidationsContracts_Avg_Fields;
  validationsContracts_avg_order_by: ValidationsContracts_Avg_Order_By;
  validationsContracts_bool_exp: ValidationsContracts_Bool_Exp;
  validationsContracts_inc_input: ValidationsContracts_Inc_Input;
  validationsContracts_insert_input: ValidationsContracts_Insert_Input;
  validationsContracts_max_fields: ValidationsContracts_Max_Fields;
  validationsContracts_max_order_by: ValidationsContracts_Max_Order_By;
  validationsContracts_min_fields: ValidationsContracts_Min_Fields;
  validationsContracts_min_order_by: ValidationsContracts_Min_Order_By;
  validationsContracts_mutation_response: ValidationsContracts_Mutation_Response;
  validationsContracts_on_conflict: ValidationsContracts_On_Conflict;
  validationsContracts_order_by: ValidationsContracts_Order_By;
  validationsContracts_pk_columns_input: ValidationsContracts_Pk_Columns_Input;
  validationsContracts_set_input: ValidationsContracts_Set_Input;
  validationsContracts_stddev_fields: ValidationsContracts_Stddev_Fields;
  validationsContracts_stddev_order_by: ValidationsContracts_Stddev_Order_By;
  validationsContracts_stddev_pop_fields: ValidationsContracts_Stddev_Pop_Fields;
  validationsContracts_stddev_pop_order_by: ValidationsContracts_Stddev_Pop_Order_By;
  validationsContracts_stddev_samp_fields: ValidationsContracts_Stddev_Samp_Fields;
  validationsContracts_stddev_samp_order_by: ValidationsContracts_Stddev_Samp_Order_By;
  validationsContracts_stream_cursor_input: ValidationsContracts_Stream_Cursor_Input;
  validationsContracts_stream_cursor_value_input: ValidationsContracts_Stream_Cursor_Value_Input;
  validationsContracts_sum_fields: ValidationsContracts_Sum_Fields;
  validationsContracts_sum_order_by: ValidationsContracts_Sum_Order_By;
  validationsContracts_updates: ValidationsContracts_Updates;
  validationsContracts_var_pop_fields: ValidationsContracts_Var_Pop_Fields;
  validationsContracts_var_pop_order_by: ValidationsContracts_Var_Pop_Order_By;
  validationsContracts_var_samp_fields: ValidationsContracts_Var_Samp_Fields;
  validationsContracts_var_samp_order_by: ValidationsContracts_Var_Samp_Order_By;
  validationsContracts_variance_fields: ValidationsContracts_Variance_Fields;
  validationsContracts_variance_order_by: ValidationsContracts_Variance_Order_By;
  varietals: Varietals;
  varietals_aggregate: Varietals_Aggregate;
  varietals_aggregate_fields: Varietals_Aggregate_Fields;
  varietals_avg_fields: Varietals_Avg_Fields;
  varietals_bool_exp: Varietals_Bool_Exp;
  varietals_inc_input: Varietals_Inc_Input;
  varietals_insert_input: Varietals_Insert_Input;
  varietals_max_fields: Varietals_Max_Fields;
  varietals_min_fields: Varietals_Min_Fields;
  varietals_mutation_response: Varietals_Mutation_Response;
  varietals_on_conflict: Varietals_On_Conflict;
  varietals_order_by: Varietals_Order_By;
  varietals_pk_columns_input: Varietals_Pk_Columns_Input;
  varietals_set_input: Varietals_Set_Input;
  varietals_stddev_fields: Varietals_Stddev_Fields;
  varietals_stddev_pop_fields: Varietals_Stddev_Pop_Fields;
  varietals_stddev_samp_fields: Varietals_Stddev_Samp_Fields;
  varietals_stream_cursor_input: Varietals_Stream_Cursor_Input;
  varietals_stream_cursor_value_input: Varietals_Stream_Cursor_Value_Input;
  varietals_sum_fields: Varietals_Sum_Fields;
  varietals_updates: Varietals_Updates;
  varietals_var_pop_fields: Varietals_Var_Pop_Fields;
  varietals_var_samp_fields: Varietals_Var_Samp_Fields;
  varietals_variance_fields: Varietals_Variance_Fields;
  vector: Scalars['vector'];
  vector_comparison_exp: Vector_Comparison_Exp;
};

export type CachedDirectiveArgs = {
  refresh?: Scalars['Boolean'];
  ttl?: Scalars['Int'];
};

export type CachedDirectiveResolver<Result, Parent, ContextType = any, Args = CachedDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AddressesResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses'] = ResolversParentTypes['addresses']> = {
  addressNetsuite?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  bondedWarehouse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyAddresses?: Resolver<Array<ResolversTypes['companyAddress']>, ParentType, ContextType, Partial<AddressesCompanyAddressesArgs>>;
  companyAddresses_aggregate?: Resolver<ResolversTypes['companyAddress_aggregate'], ParentType, ContextType, Partial<AddressesCompanyAddresses_AggregateArgs>>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  excise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<AddressesFilesArgs>>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storageCompany?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  zipcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_aggregate'] = ResolversParentTypes['addresses_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['addresses_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['addresses']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_aggregate_fields'] = ResolversParentTypes['addresses_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['addresses_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Addresses_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['addresses_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['addresses_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['addresses_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['addresses_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['addresses_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['addresses_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['addresses_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['addresses_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['addresses_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_avg_fields'] = ResolversParentTypes['addresses_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_max_fields'] = ResolversParentTypes['addresses_max_fields']> = {
  addressNetsuite?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  bondedWarehouse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  excise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storageCompany?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  zipcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_min_fields'] = ResolversParentTypes['addresses_min_fields']> = {
  addressNetsuite?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  bondedWarehouse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  excise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storageCompany?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  zipcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_mutation_response'] = ResolversParentTypes['addresses_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['addresses']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_stddev_fields'] = ResolversParentTypes['addresses_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_stddev_pop_fields'] = ResolversParentTypes['addresses_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_stddev_samp_fields'] = ResolversParentTypes['addresses_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_sum_fields'] = ResolversParentTypes['addresses_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_var_pop_fields'] = ResolversParentTypes['addresses_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_var_samp_fields'] = ResolversParentTypes['addresses_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_variance_fields'] = ResolversParentTypes['addresses_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Without_CompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_without_company'] = ResolversParentTypes['addresses_without_company']> = {
  addressNetsuite?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  bondedWarehouse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  excise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<Addresses_Without_CompanyFilesArgs>>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storageCompany?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  zipcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Without_Company_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_without_company_aggregate'] = ResolversParentTypes['addresses_without_company_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['addresses_without_company_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['addresses_without_company']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Without_Company_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_without_company_aggregate_fields'] = ResolversParentTypes['addresses_without_company_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['addresses_without_company_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Addresses_Without_Company_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['addresses_without_company_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['addresses_without_company_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['addresses_without_company_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['addresses_without_company_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['addresses_without_company_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['addresses_without_company_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['addresses_without_company_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['addresses_without_company_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['addresses_without_company_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Without_Company_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_without_company_avg_fields'] = ResolversParentTypes['addresses_without_company_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Without_Company_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_without_company_max_fields'] = ResolversParentTypes['addresses_without_company_max_fields']> = {
  addressNetsuite?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  bondedWarehouse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  excise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storageCompany?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  zipcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Without_Company_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_without_company_min_fields'] = ResolversParentTypes['addresses_without_company_min_fields']> = {
  addressNetsuite?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  bondedWarehouse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  excise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storageCompany?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streetNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  zipcode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Without_Company_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_without_company_stddev_fields'] = ResolversParentTypes['addresses_without_company_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Without_Company_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_without_company_stddev_pop_fields'] = ResolversParentTypes['addresses_without_company_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Without_Company_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_without_company_stddev_samp_fields'] = ResolversParentTypes['addresses_without_company_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Without_Company_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_without_company_sum_fields'] = ResolversParentTypes['addresses_without_company_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Without_Company_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_without_company_var_pop_fields'] = ResolversParentTypes['addresses_without_company_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Without_Company_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_without_company_var_samp_fields'] = ResolversParentTypes['addresses_without_company_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Addresses_Without_Company_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['addresses_without_company_variance_fields'] = ResolversParentTypes['addresses_without_company_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTermsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreementTerms'] = ResolversParentTypes['agreementTerms']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTerms_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreementTerms_aggregate'] = ResolversParentTypes['agreementTerms_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['agreementTerms_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['agreementTerms']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTerms_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreementTerms_aggregate_fields'] = ResolversParentTypes['agreementTerms_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['agreementTerms_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<AgreementTerms_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['agreementTerms_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['agreementTerms_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['agreementTerms_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['agreementTerms_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['agreementTerms_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['agreementTerms_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['agreementTerms_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['agreementTerms_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['agreementTerms_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTerms_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreementTerms_avg_fields'] = ResolversParentTypes['agreementTerms_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTerms_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreementTerms_max_fields'] = ResolversParentTypes['agreementTerms_max_fields']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTerms_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreementTerms_min_fields'] = ResolversParentTypes['agreementTerms_min_fields']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTerms_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreementTerms_mutation_response'] = ResolversParentTypes['agreementTerms_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['agreementTerms']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTerms_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreementTerms_stddev_fields'] = ResolversParentTypes['agreementTerms_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTerms_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreementTerms_stddev_pop_fields'] = ResolversParentTypes['agreementTerms_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTerms_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreementTerms_stddev_samp_fields'] = ResolversParentTypes['agreementTerms_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTerms_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreementTerms_sum_fields'] = ResolversParentTypes['agreementTerms_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTerms_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreementTerms_var_pop_fields'] = ResolversParentTypes['agreementTerms_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTerms_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreementTerms_var_samp_fields'] = ResolversParentTypes['agreementTerms_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementTerms_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreementTerms_variance_fields'] = ResolversParentTypes['agreementTerms_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreements'] = ResolversParentTypes['agreements']> = {
  additionalInformations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  buyerBillingAddress?: Resolver<Maybe<ResolversTypes['addresses']>, ParentType, ContextType>;
  buyerBillingAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerBondedWarehouse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompany?: Resolver<Maybe<ResolversTypes['companies']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerContact?: Resolver<Maybe<ResolversTypes['contacts']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerContractRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerCvi?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerDeliveryAddress?: Resolver<Maybe<ResolversTypes['addresses']>, ParentType, ContextType>;
  buyerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerEori?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerExcise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerFda?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerOffice?: Resolver<Maybe<ResolversTypes['offices']>, ParentType, ContextType>;
  buyerOfficeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerSpecsId?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<AgreementsBuyerSpecsIdArgs>>;
  buyerUser?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType>;
  buyerUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerUserName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerVat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commisionFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionBuyer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionCostBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commissionFeesPerUom?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFlatFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionQuantityBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionSeller?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionThirdParty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionTotalFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commissionUom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commodityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contractOffice?: Resolver<Maybe<ResolversTypes['offices']>, ParentType, ContextType>;
  contractOfficeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contractRevision?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractUser?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType>;
  contractUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  costArray?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<AgreementsCostArrayArgs>>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  evergreenAgreementId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  evergreenContract?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  evergreenDates?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<AgreementsEvergreenDatesArgs>>;
  files?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<AgreementsFilesArgs>>;
  fulfillmentsStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  incoterms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoices?: Resolver<Array<ResolversTypes['invoices']>, ParentType, ContextType, Partial<AgreementsInvoicesArgs>>;
  invoicesStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoices_aggregate?: Resolver<ResolversTypes['invoices_aggregate'], ParentType, ContextType, Partial<AgreementsInvoices_AggregateArgs>>;
  isMultiYearContract?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itemsId?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType, Partial<AgreementsItemsIdArgs>>;
  legacyContractStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  place?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantityOrdered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityShipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  reminders?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<AgreementsRemindersArgs>>;
  salesOrderNetsuite?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerBillingAddress?: Resolver<Maybe<ResolversTypes['addresses']>, ParentType, ContextType>;
  sellerBillingAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerBondedWarehouse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCompany?: Resolver<Maybe<ResolversTypes['companies']>, ParentType, ContextType>;
  sellerCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerContact?: Resolver<Maybe<ResolversTypes['contacts']>, ParentType, ContextType>;
  sellerContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerContractRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerCvi?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerDeliveryAddress?: Resolver<Maybe<ResolversTypes['addresses']>, ParentType, ContextType>;
  sellerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerEori?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerExcise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerFda?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerOffice?: Resolver<Maybe<ResolversTypes['offices']>, ParentType, ContextType>;
  sellerOfficeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerUser?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType>;
  sellerUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerUserName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerVat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shipmentFulfillments?: Resolver<Array<ResolversTypes['shipmentFulfillments']>, ParentType, ContextType, Partial<AgreementsShipmentFulfillmentsArgs>>;
  shipmentFulfillments_aggregate?: Resolver<ResolversTypes['shipmentFulfillments_aggregate'], ParentType, ContextType, Partial<AgreementsShipmentFulfillments_AggregateArgs>>;
  signaturesRequired?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<AgreementsSignaturesRequiredArgs>>;
  startDate?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  terms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsAddContract?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsAddContractViewer?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<AgreementsTermsAddContractViewerArgs>>;
  termsCommission?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsCommissionViewer?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<AgreementsTermsCommissionViewerArgs>>;
  termsPayment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsPaymentViewer?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<AgreementsTermsPaymentViewerArgs>>;
  termsShipping?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsShippingViewer?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<AgreementsTermsShippingViewerArgs>>;
  termsViewer?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<AgreementsTermsViewerArgs>>;
  thirdPartyCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCompany?: Resolver<Maybe<ResolversTypes['companies']>, ParentType, ContextType>;
  thirdPartyCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  thirdPartyContact?: Resolver<Maybe<ResolversTypes['contacts']>, ParentType, ContextType>;
  thirdPartyContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  thirdPartyContractRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  usdaGcr?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Agreements_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreements_aggregate'] = ResolversParentTypes['agreements_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['agreements_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['agreements']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Agreements_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreements_aggregate_fields'] = ResolversParentTypes['agreements_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['agreements_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Agreements_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['agreements_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['agreements_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['agreements_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['agreements_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['agreements_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['agreements_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['agreements_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['agreements_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['agreements_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Agreements_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreements_avg_fields'] = ResolversParentTypes['agreements_avg_fields']> = {
  buyerBillingAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commisionFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionBuyer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionCostBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFeesPerUom?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFlatFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionQuantityBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionSeller?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionThirdParty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionTotalFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contractOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  evergreenAgreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityOrdered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityShipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerBillingAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Agreements_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreements_max_fields'] = ResolversParentTypes['agreements_max_fields']> = {
  additionalInformations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  buyerBillingAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerBondedWarehouse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerContractRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerCvi?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerEori?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerExcise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerFda?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerOfficeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerUserName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerVat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commisionFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionBuyer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionCostBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commissionFeesPerUom?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFlatFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionQuantityBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionSeller?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionThirdParty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionTotalFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commissionUom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commodityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractOfficeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contractRevision?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  evergreenAgreementId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fulfillmentsStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  incoterms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoicesStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legacyContractStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  place?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantityOrdered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityShipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  salesOrderNetsuite?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerBillingAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerBondedWarehouse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerContractRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerCvi?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerEori?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerExcise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerFda?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerOfficeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerUserName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerVat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  terms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsAddContract?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsCommission?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsPayment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsShipping?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thirdPartyCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  thirdPartyContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  thirdPartyContractRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Agreements_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreements_min_fields'] = ResolversParentTypes['agreements_min_fields']> = {
  additionalInformations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  buyerBillingAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerBondedWarehouse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerContractRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerCvi?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerEori?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerExcise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerFda?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerOfficeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerUserName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerVat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commisionFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionBuyer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionCostBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commissionFeesPerUom?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFlatFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionQuantityBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionSeller?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionThirdParty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionTotalFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commissionUom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commodityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractOfficeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contractRevision?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contractUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  evergreenAgreementId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  fulfillmentsStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  incoterms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoicesStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legacyContractStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  place?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantityOrdered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityShipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  salesOrderNetsuite?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerBillingAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerBondedWarehouse?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerContractRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerCvi?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerEori?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerExcise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerFda?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerOfficeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerUserName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sellerVat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  terms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsAddContract?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsCommission?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsPayment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  termsShipping?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thirdPartyCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  thirdPartyContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  thirdPartyContractRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Agreements_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreements_mutation_response'] = ResolversParentTypes['agreements_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['agreements']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Agreements_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreements_stddev_fields'] = ResolversParentTypes['agreements_stddev_fields']> = {
  buyerBillingAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commisionFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionBuyer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionCostBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFeesPerUom?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFlatFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionQuantityBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionSeller?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionThirdParty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionTotalFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contractOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  evergreenAgreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityOrdered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityShipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerBillingAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Agreements_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreements_stddev_pop_fields'] = ResolversParentTypes['agreements_stddev_pop_fields']> = {
  buyerBillingAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commisionFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionBuyer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionCostBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFeesPerUom?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFlatFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionQuantityBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionSeller?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionThirdParty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionTotalFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contractOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  evergreenAgreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityOrdered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityShipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerBillingAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Agreements_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreements_stddev_samp_fields'] = ResolversParentTypes['agreements_stddev_samp_fields']> = {
  buyerBillingAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commisionFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionBuyer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionCostBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFeesPerUom?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFlatFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionQuantityBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionSeller?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionThirdParty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionTotalFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contractOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  evergreenAgreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityOrdered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityShipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerBillingAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Agreements_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreements_sum_fields'] = ResolversParentTypes['agreements_sum_fields']> = {
  buyerBillingAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerOfficeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  commisionFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionBuyer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionCostBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFeesPerUom?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFlatFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionQuantityBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionSeller?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionThirdParty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionTotalFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contractOfficeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  evergreenAgreementId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quantityOrdered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityShipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerBillingAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sellerOfficeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  thirdPartyCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  thirdPartyContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Agreements_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreements_var_pop_fields'] = ResolversParentTypes['agreements_var_pop_fields']> = {
  buyerBillingAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commisionFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionBuyer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionCostBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFeesPerUom?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFlatFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionQuantityBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionSeller?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionThirdParty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionTotalFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contractOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  evergreenAgreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityOrdered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityShipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerBillingAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Agreements_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreements_var_samp_fields'] = ResolversParentTypes['agreements_var_samp_fields']> = {
  buyerBillingAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commisionFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionBuyer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionCostBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFeesPerUom?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFlatFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionQuantityBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionSeller?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionThirdParty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionTotalFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contractOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  evergreenAgreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityOrdered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityShipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerBillingAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Agreements_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['agreements_variance_fields'] = ResolversParentTypes['agreements_variance_fields']> = {
  buyerBillingAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commisionFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionBuyer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionCostBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFeesPerUom?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionFlatFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionQuantityBase?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionSeller?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionThirdParty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionTotalFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contractOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  evergreenAgreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityOrdered?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityShipped?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerBillingAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCiattiCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerDeliveryAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sellerOfficeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCommission?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  thirdPartyContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppellationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['appellations'] = ResolversParentTypes['appellations']> = {
  appellation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  district?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  embedding?: Resolver<Maybe<ResolversTypes['vector']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subAppellation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  vectorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Appellations_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['appellations_aggregate'] = ResolversParentTypes['appellations_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['appellations_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['appellations']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Appellations_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['appellations_aggregate_fields'] = ResolversParentTypes['appellations_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['appellations_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Appellations_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['appellations_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['appellations_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['appellations_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['appellations_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['appellations_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['appellations_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['appellations_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['appellations_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['appellations_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Appellations_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['appellations_avg_fields'] = ResolversParentTypes['appellations_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Appellations_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['appellations_max_fields'] = ResolversParentTypes['appellations_max_fields']> = {
  appellation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  district?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subAppellation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  vectorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Appellations_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['appellations_min_fields'] = ResolversParentTypes['appellations_min_fields']> = {
  appellation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  district?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subAppellation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  vectorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Appellations_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['appellations_mutation_response'] = ResolversParentTypes['appellations_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['appellations']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Appellations_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['appellations_stddev_fields'] = ResolversParentTypes['appellations_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Appellations_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['appellations_stddev_pop_fields'] = ResolversParentTypes['appellations_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Appellations_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['appellations_stddev_samp_fields'] = ResolversParentTypes['appellations_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Appellations_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['appellations_sum_fields'] = ResolversParentTypes['appellations_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Appellations_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['appellations_var_pop_fields'] = ResolversParentTypes['appellations_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Appellations_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['appellations_var_samp_fields'] = ResolversParentTypes['appellations_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Appellations_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['appellations_variance_fields'] = ResolversParentTypes['appellations_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizedDomainsResolvers<ContextType = any, ParentType extends ResolversParentTypes['authorizedDomains'] = ResolversParentTypes['authorizedDomains']> = {
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  domain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizedDomains_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['authorizedDomains_aggregate'] = ResolversParentTypes['authorizedDomains_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['authorizedDomains_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['authorizedDomains']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizedDomains_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['authorizedDomains_aggregate_fields'] = ResolversParentTypes['authorizedDomains_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['authorizedDomains_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<AuthorizedDomains_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['authorizedDomains_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['authorizedDomains_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['authorizedDomains_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['authorizedDomains_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['authorizedDomains_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['authorizedDomains_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['authorizedDomains_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['authorizedDomains_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['authorizedDomains_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizedDomains_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['authorizedDomains_avg_fields'] = ResolversParentTypes['authorizedDomains_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizedDomains_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['authorizedDomains_max_fields'] = ResolversParentTypes['authorizedDomains_max_fields']> = {
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  domain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizedDomains_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['authorizedDomains_min_fields'] = ResolversParentTypes['authorizedDomains_min_fields']> = {
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  domain?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizedDomains_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['authorizedDomains_mutation_response'] = ResolversParentTypes['authorizedDomains_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['authorizedDomains']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizedDomains_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['authorizedDomains_stddev_fields'] = ResolversParentTypes['authorizedDomains_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizedDomains_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['authorizedDomains_stddev_pop_fields'] = ResolversParentTypes['authorizedDomains_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizedDomains_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['authorizedDomains_stddev_samp_fields'] = ResolversParentTypes['authorizedDomains_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizedDomains_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['authorizedDomains_sum_fields'] = ResolversParentTypes['authorizedDomains_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizedDomains_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['authorizedDomains_var_pop_fields'] = ResolversParentTypes['authorizedDomains_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizedDomains_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['authorizedDomains_var_samp_fields'] = ResolversParentTypes['authorizedDomains_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizedDomains_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['authorizedDomains_variance_fields'] = ResolversParentTypes['authorizedDomains_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuySpecsResolvers<ContextType = any, ParentType extends ResolversParentTypes['buySpecs'] = ResolversParentTypes['buySpecs']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  appellations?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<BuySpecsAppellationsArgs>>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  askPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  certifications?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<BuySpecsCertificationsArgs>>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  commodityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deadline?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  district?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<BuySpecsFilesArgs>>;
  generic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  harvestMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isOpportunistic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  matchingItemsBuySpecs?: Resolver<Array<ResolversTypes['matchingItemsBuySpecs']>, ParentType, ContextType, Partial<BuySpecsMatchingItemsBuySpecsArgs>>;
  matchingItemsBuySpecs_aggregate?: Resolver<ResolversTypes['matchingItemsBuySpecs_aggregate'], ParentType, ContextType, Partial<BuySpecsMatchingItemsBuySpecs_AggregateArgs>>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  qualities?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<BuySpecsQualitiesArgs>>;
  quantityNeeded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleShipmentRequests?: Resolver<Array<ResolversTypes['sampleShipmentRequests']>, ParentType, ContextType, Partial<BuySpecsSampleShipmentRequestsArgs>>;
  sampleShipmentRequests_aggregate?: Resolver<ResolversTypes['sampleShipmentRequests_aggregate'], ParentType, ContextType, Partial<BuySpecsSampleShipmentRequests_AggregateArgs>>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subAppellation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subGeneric?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  varietals?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<BuySpecsVarietalsArgs>>;
  vintages?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<BuySpecsVintagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuySpecs_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['buySpecs_aggregate'] = ResolversParentTypes['buySpecs_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['buySpecs_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['buySpecs']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuySpecs_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['buySpecs_aggregate_fields'] = ResolversParentTypes['buySpecs_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['buySpecs_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<BuySpecs_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['buySpecs_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['buySpecs_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['buySpecs_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['buySpecs_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['buySpecs_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['buySpecs_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['buySpecs_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['buySpecs_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['buySpecs_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuySpecs_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['buySpecs_avg_fields'] = ResolversParentTypes['buySpecs_avg_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  askPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityNeeded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuySpecs_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['buySpecs_max_fields'] = ResolversParentTypes['buySpecs_max_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  askPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commodityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deadline?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  district?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  generic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  harvestMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quantityNeeded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subAppellation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subGeneric?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuySpecs_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['buySpecs_min_fields'] = ResolversParentTypes['buySpecs_min_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  askPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commodityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deadline?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  district?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  generic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  harvestMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quantityNeeded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subAppellation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subGeneric?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuySpecs_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['buySpecs_mutation_response'] = ResolversParentTypes['buySpecs_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['buySpecs']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuySpecs_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['buySpecs_stddev_fields'] = ResolversParentTypes['buySpecs_stddev_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  askPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityNeeded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuySpecs_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['buySpecs_stddev_pop_fields'] = ResolversParentTypes['buySpecs_stddev_pop_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  askPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityNeeded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuySpecs_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['buySpecs_stddev_samp_fields'] = ResolversParentTypes['buySpecs_stddev_samp_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  askPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityNeeded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuySpecs_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['buySpecs_sum_fields'] = ResolversParentTypes['buySpecs_sum_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  askPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quantityNeeded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuySpecs_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['buySpecs_var_pop_fields'] = ResolversParentTypes['buySpecs_var_pop_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  askPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityNeeded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuySpecs_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['buySpecs_var_samp_fields'] = ResolversParentTypes['buySpecs_var_samp_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  askPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityNeeded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuySpecs_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['buySpecs_variance_fields'] = ResolversParentTypes['buySpecs_variance_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  askPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  buyerContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityNeeded?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompaniesResolvers<ContextType = any, ParentType extends ResolversParentTypes['companies'] = ResolversParentTypes['companies']> = {
  agreementsBuyerCompany?: Resolver<Array<ResolversTypes['agreements']>, ParentType, ContextType, Partial<CompaniesAgreementsBuyerCompanyArgs>>;
  agreementsBuyerCompany_aggregate?: Resolver<ResolversTypes['agreements_aggregate'], ParentType, ContextType, Partial<CompaniesAgreementsBuyerCompany_AggregateArgs>>;
  agreementsSellerCompany?: Resolver<Array<ResolversTypes['agreements']>, ParentType, ContextType, Partial<CompaniesAgreementsSellerCompanyArgs>>;
  agreementsSellerCompany_aggregate?: Resolver<ResolversTypes['agreements_aggregate'], ParentType, ContextType, Partial<CompaniesAgreementsSellerCompany_AggregateArgs>>;
  agreementsThirdPartyCompany?: Resolver<Array<ResolversTypes['agreements']>, ParentType, ContextType, Partial<CompaniesAgreementsThirdPartyCompanyArgs>>;
  agreementsThirdPartyCompany_aggregate?: Resolver<ResolversTypes['agreements_aggregate'], ParentType, ContextType, Partial<CompaniesAgreementsThirdPartyCompany_AggregateArgs>>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  broker?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brokerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certifications?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType, Partial<CompaniesCertificationsArgs>>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyAddresses?: Resolver<Array<ResolversTypes['companyAddress']>, ParentType, ContextType, Partial<CompaniesCompanyAddressesArgs>>;
  companyAddresses_aggregate?: Resolver<ResolversTypes['companyAddress_aggregate'], ParentType, ContextType, Partial<CompaniesCompanyAddresses_AggregateArgs>>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cvi?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  dun?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  embedding?: Resolver<Maybe<ResolversTypes['vector']>, ParentType, ContextType>;
  eori?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fda?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<CompaniesFilesArgs>>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officialId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentCompany?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scoring?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetObjective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  targetObjectiveCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  vat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vectorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Companies_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['companies_aggregate'] = ResolversParentTypes['companies_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['companies_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['companies']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Companies_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companies_aggregate_fields'] = ResolversParentTypes['companies_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['companies_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Companies_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['companies_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['companies_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['companies_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['companies_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['companies_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['companies_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['companies_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['companies_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['companies_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Companies_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companies_avg_fields'] = ResolversParentTypes['companies_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  targetObjective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Companies_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companies_max_fields'] = ResolversParentTypes['companies_max_fields']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brokerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cvi?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  dun?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eori?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fda?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officialId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentCompany?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scoring?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetObjective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  targetObjectiveCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  vat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vectorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Companies_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companies_min_fields'] = ResolversParentTypes['companies_min_fields']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  brokerName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cvi?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  dun?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eori?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excise?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fda?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officialId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentCompany?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scoring?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetObjective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  targetObjectiveCurrency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  vat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vectorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Companies_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['companies_mutation_response'] = ResolversParentTypes['companies_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['companies']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Companies_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companies_stddev_fields'] = ResolversParentTypes['companies_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  targetObjective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Companies_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companies_stddev_pop_fields'] = ResolversParentTypes['companies_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  targetObjective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Companies_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companies_stddev_samp_fields'] = ResolversParentTypes['companies_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  targetObjective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Companies_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companies_sum_fields'] = ResolversParentTypes['companies_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  targetObjective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Companies_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companies_var_pop_fields'] = ResolversParentTypes['companies_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  targetObjective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Companies_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companies_var_samp_fields'] = ResolversParentTypes['companies_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  targetObjective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Companies_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companies_variance_fields'] = ResolversParentTypes['companies_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  targetObjective?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['companyAddress'] = ResolversParentTypes['companyAddress']> = {
  address?: Resolver<ResolversTypes['addresses'], ParentType, ContextType>;
  addressId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  company?: Resolver<ResolversTypes['companies'], ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAddress_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['companyAddress_aggregate'] = ResolversParentTypes['companyAddress_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['companyAddress_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['companyAddress']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAddress_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companyAddress_aggregate_fields'] = ResolversParentTypes['companyAddress_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['companyAddress_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<CompanyAddress_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['companyAddress_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['companyAddress_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['companyAddress_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['companyAddress_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['companyAddress_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['companyAddress_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['companyAddress_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['companyAddress_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['companyAddress_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAddress_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companyAddress_avg_fields'] = ResolversParentTypes['companyAddress_avg_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAddress_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companyAddress_max_fields'] = ResolversParentTypes['companyAddress_max_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAddress_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companyAddress_min_fields'] = ResolversParentTypes['companyAddress_min_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAddress_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['companyAddress_mutation_response'] = ResolversParentTypes['companyAddress_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['companyAddress']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAddress_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companyAddress_stddev_fields'] = ResolversParentTypes['companyAddress_stddev_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAddress_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companyAddress_stddev_pop_fields'] = ResolversParentTypes['companyAddress_stddev_pop_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAddress_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companyAddress_stddev_samp_fields'] = ResolversParentTypes['companyAddress_stddev_samp_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAddress_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companyAddress_sum_fields'] = ResolversParentTypes['companyAddress_sum_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAddress_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companyAddress_var_pop_fields'] = ResolversParentTypes['companyAddress_var_pop_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAddress_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companyAddress_var_samp_fields'] = ResolversParentTypes['companyAddress_var_samp_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyAddress_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['companyAddress_variance_fields'] = ResolversParentTypes['companyAddress_variance_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContactsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts'] = ResolversParentTypes['contacts']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  altEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  altPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  broker?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<ContactsCategoriesArgs>>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['companies']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  embedding?: Resolver<Maybe<ResolversTypes['vector']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<ContactsFilesArgs>>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['users']>, ParentType, ContextType, Partial<ContactsUsersArgs>>;
  users_aggregate?: Resolver<ResolversTypes['users_aggregate'], ParentType, ContextType, Partial<ContactsUsers_AggregateArgs>>;
  vectorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_aggregate'] = ResolversParentTypes['contacts_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['contacts_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['contacts']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_aggregate_fields'] = ResolversParentTypes['contacts_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['contacts_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Contacts_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['contacts_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['contacts_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['contacts_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['contacts_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['contacts_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['contacts_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['contacts_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['contacts_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['contacts_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_avg_fields'] = ResolversParentTypes['contacts_avg_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_max_fields'] = ResolversParentTypes['contacts_max_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  altEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  altPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  vectorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_min_fields'] = ResolversParentTypes['contacts_min_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  altEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  altPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  vectorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_mutation_response'] = ResolversParentTypes['contacts_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['contacts']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_stddev_fields'] = ResolversParentTypes['contacts_stddev_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_stddev_pop_fields'] = ResolversParentTypes['contacts_stddev_pop_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_stddev_samp_fields'] = ResolversParentTypes['contacts_stddev_samp_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_sum_fields'] = ResolversParentTypes['contacts_sum_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_var_pop_fields'] = ResolversParentTypes['contacts_var_pop_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_var_samp_fields'] = ResolversParentTypes['contacts_var_samp_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_variance_fields'] = ResolversParentTypes['contacts_variance_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Without_CompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_without_company'] = ResolversParentTypes['contacts_without_company']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  altEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  altPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categories?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<Contacts_Without_CompanyCategoriesArgs>>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<Contacts_Without_CompanyFilesArgs>>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Without_Company_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_without_company_aggregate'] = ResolversParentTypes['contacts_without_company_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['contacts_without_company_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['contacts_without_company']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Without_Company_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_without_company_aggregate_fields'] = ResolversParentTypes['contacts_without_company_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['contacts_without_company_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Contacts_Without_Company_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['contacts_without_company_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['contacts_without_company_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['contacts_without_company_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['contacts_without_company_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['contacts_without_company_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['contacts_without_company_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['contacts_without_company_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['contacts_without_company_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['contacts_without_company_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Without_Company_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_without_company_avg_fields'] = ResolversParentTypes['contacts_without_company_avg_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Without_Company_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_without_company_max_fields'] = ResolversParentTypes['contacts_without_company_max_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  altEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  altPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Without_Company_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_without_company_min_fields'] = ResolversParentTypes['contacts_without_company_min_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  altEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  altPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fax?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  jobTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobile?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officePhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Without_Company_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_without_company_stddev_fields'] = ResolversParentTypes['contacts_without_company_stddev_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Without_Company_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_without_company_stddev_pop_fields'] = ResolversParentTypes['contacts_without_company_stddev_pop_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Without_Company_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_without_company_stddev_samp_fields'] = ResolversParentTypes['contacts_without_company_stddev_samp_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Without_Company_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_without_company_sum_fields'] = ResolversParentTypes['contacts_without_company_sum_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Without_Company_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_without_company_var_pop_fields'] = ResolversParentTypes['contacts_without_company_var_pop_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Without_Company_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_without_company_var_samp_fields'] = ResolversParentTypes['contacts_without_company_var_samp_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contacts_Without_Company_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contacts_without_company_variance_fields'] = ResolversParentTypes['contacts_without_company_variance_fields']> = {
  addressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContractsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contracts'] = ResolversParentTypes['contracts']> = {
  agreement?: Resolver<ResolversTypes['agreements'], ParentType, ContextType>;
  agreementId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fileUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fileUrlWithSignatures?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  format?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  validationsContracts?: Resolver<Array<ResolversTypes['validationsContracts']>, ParentType, ContextType, Partial<ContractsValidationsContractsArgs>>;
  validationsContracts_aggregate?: Resolver<ResolversTypes['validationsContracts_aggregate'], ParentType, ContextType, Partial<ContractsValidationsContracts_AggregateArgs>>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contracts_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['contracts_aggregate'] = ResolversParentTypes['contracts_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['contracts_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['contracts']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contracts_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contracts_aggregate_fields'] = ResolversParentTypes['contracts_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['contracts_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Contracts_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['contracts_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['contracts_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['contracts_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['contracts_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['contracts_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['contracts_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['contracts_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['contracts_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['contracts_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contracts_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contracts_avg_fields'] = ResolversParentTypes['contracts_avg_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contracts_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contracts_max_fields'] = ResolversParentTypes['contracts_max_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileUrlWithSignatures?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  format?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contracts_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contracts_min_fields'] = ResolversParentTypes['contracts_min_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fileUrlWithSignatures?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  format?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contracts_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['contracts_mutation_response'] = ResolversParentTypes['contracts_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['contracts']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contracts_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contracts_stddev_fields'] = ResolversParentTypes['contracts_stddev_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contracts_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contracts_stddev_pop_fields'] = ResolversParentTypes['contracts_stddev_pop_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contracts_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contracts_stddev_samp_fields'] = ResolversParentTypes['contracts_stddev_samp_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contracts_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contracts_sum_fields'] = ResolversParentTypes['contracts_sum_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contracts_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contracts_var_pop_fields'] = ResolversParentTypes['contracts_var_pop_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contracts_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contracts_var_samp_fields'] = ResolversParentTypes['contracts_var_samp_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Contracts_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['contracts_variance_fields'] = ResolversParentTypes['contracts_variance_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrenciesConversionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['currenciesConversions'] = ResolversParentTypes['currenciesConversions']> = {
  created_at?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  currencies?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType, Partial<CurrenciesConversionsCurrenciesArgs>>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['date'], ParentType, ContextType>;
  day?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  month?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrenciesConversions_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['currenciesConversions_aggregate'] = ResolversParentTypes['currenciesConversions_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['currenciesConversions_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['currenciesConversions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrenciesConversions_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['currenciesConversions_aggregate_fields'] = ResolversParentTypes['currenciesConversions_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['currenciesConversions_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<CurrenciesConversions_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['currenciesConversions_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['currenciesConversions_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['currenciesConversions_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['currenciesConversions_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['currenciesConversions_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['currenciesConversions_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['currenciesConversions_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['currenciesConversions_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['currenciesConversions_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrenciesConversions_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['currenciesConversions_avg_fields'] = ResolversParentTypes['currenciesConversions_avg_fields']> = {
  day?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrenciesConversions_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['currenciesConversions_max_fields'] = ResolversParentTypes['currenciesConversions_max_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  day?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrenciesConversions_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['currenciesConversions_min_fields'] = ResolversParentTypes['currenciesConversions_min_fields']> = {
  created_at?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  day?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrenciesConversions_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['currenciesConversions_mutation_response'] = ResolversParentTypes['currenciesConversions_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['currenciesConversions']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrenciesConversions_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['currenciesConversions_stddev_fields'] = ResolversParentTypes['currenciesConversions_stddev_fields']> = {
  day?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrenciesConversions_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['currenciesConversions_stddev_pop_fields'] = ResolversParentTypes['currenciesConversions_stddev_pop_fields']> = {
  day?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrenciesConversions_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['currenciesConversions_stddev_samp_fields'] = ResolversParentTypes['currenciesConversions_stddev_samp_fields']> = {
  day?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrenciesConversions_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['currenciesConversions_sum_fields'] = ResolversParentTypes['currenciesConversions_sum_fields']> = {
  day?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrenciesConversions_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['currenciesConversions_var_pop_fields'] = ResolversParentTypes['currenciesConversions_var_pop_fields']> = {
  day?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrenciesConversions_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['currenciesConversions_var_samp_fields'] = ResolversParentTypes['currenciesConversions_var_samp_fields']> = {
  day?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrenciesConversions_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['currenciesConversions_variance_fields'] = ResolversParentTypes['currenciesConversions_variance_fields']> = {
  day?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['date'], any> {
  name: 'date';
}

export type HistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['history'] = ResolversParentTypes['history']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  creator?: Resolver<ResolversTypes['users'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType, Partial<HistoryDataArgs>>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  objectId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  operation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  table?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type History_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['history_aggregate'] = ResolversParentTypes['history_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['history_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['history']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type History_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['history_aggregate_fields'] = ResolversParentTypes['history_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['history_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<History_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['history_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['history_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['history_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['history_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['history_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['history_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['history_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['history_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['history_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type History_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['history_avg_fields'] = ResolversParentTypes['history_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type History_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['history_max_fields'] = ResolversParentTypes['history_max_fields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  operation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  table?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type History_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['history_min_fields'] = ResolversParentTypes['history_min_fields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  operation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  table?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type History_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['history_mutation_response'] = ResolversParentTypes['history_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['history']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type History_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['history_stddev_fields'] = ResolversParentTypes['history_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type History_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['history_stddev_pop_fields'] = ResolversParentTypes['history_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type History_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['history_stddev_samp_fields'] = ResolversParentTypes['history_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type History_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['history_sum_fields'] = ResolversParentTypes['history_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type History_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['history_var_pop_fields'] = ResolversParentTypes['history_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type History_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['history_var_samp_fields'] = ResolversParentTypes['history_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type History_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['history_variance_fields'] = ResolversParentTypes['history_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvoicesResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoices'] = ResolversParentTypes['invoices']> = {
  USDconversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  agreement?: Resolver<Maybe<ResolversTypes['agreements']>, ParentType, ContextType>;
  agreementId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerPoRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['companies']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  dueDate?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<InvoicesFilesArgs>>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  invoiceDate?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  paymentDate?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  quickbookId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shipmentFulfillment?: Resolver<Maybe<ResolversTypes['shipmentFulfillments']>, ParentType, ContextType>;
  shipmentFulfillmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplierInvoice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoices_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoices_aggregate'] = ResolversParentTypes['invoices_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['invoices_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['invoices']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoices_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoices_aggregate_fields'] = ResolversParentTypes['invoices_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['invoices_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Invoices_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['invoices_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['invoices_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['invoices_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['invoices_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['invoices_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['invoices_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['invoices_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['invoices_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['invoices_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoices_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoices_avg_fields'] = ResolversParentTypes['invoices_avg_fields']> = {
  USDconversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quickbookId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  shipmentFulfillmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoices_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoices_max_fields'] = ResolversParentTypes['invoices_max_fields']> = {
  USDconversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  agreementId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerPoRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  dueDate?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  invoiceDate?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  paymentDate?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  quickbookId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shipmentFulfillmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplierInvoice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoices_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoices_min_fields'] = ResolversParentTypes['invoices_min_fields']> = {
  USDconversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  agreementId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buyerPoRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  dueDate?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  invoiceDate?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  paymentDate?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  quickbookId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shipmentFulfillmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplierInvoice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoices_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoices_mutation_response'] = ResolversParentTypes['invoices_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['invoices']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoices_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoices_stddev_fields'] = ResolversParentTypes['invoices_stddev_fields']> = {
  USDconversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quickbookId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  shipmentFulfillmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoices_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoices_stddev_pop_fields'] = ResolversParentTypes['invoices_stddev_pop_fields']> = {
  USDconversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quickbookId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  shipmentFulfillmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoices_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoices_stddev_samp_fields'] = ResolversParentTypes['invoices_stddev_samp_fields']> = {
  USDconversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quickbookId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  shipmentFulfillmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoices_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoices_sum_fields'] = ResolversParentTypes['invoices_sum_fields']> = {
  USDconversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  agreementId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quickbookId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  shipmentFulfillmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoices_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoices_var_pop_fields'] = ResolversParentTypes['invoices_var_pop_fields']> = {
  USDconversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quickbookId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  shipmentFulfillmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoices_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoices_var_samp_fields'] = ResolversParentTypes['invoices_var_samp_fields']> = {
  USDconversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quickbookId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  shipmentFulfillmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Invoices_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['invoices_variance_fields'] = ResolversParentTypes['invoices_variance_fields']> = {
  USDconversion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quickbookId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  shipmentFulfillmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ItemsResolvers<ContextType = any, ParentType extends ResolversParentTypes['items'] = ResolversParentTypes['items']> = {
  additionalInformations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  appellations?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType, Partial<ItemsAppellationsArgs>>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  certifications?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType, Partial<ItemsCertificationsArgs>>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commodityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  conditioning?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  district?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportIncoterms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportIncotermsType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<ItemsFilesArgs>>;
  generic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  harvestMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isOpportunistic?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  localPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lotNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matchingItemsBuySpecs?: Resolver<Array<ResolversTypes['matchingItemsBuySpecs']>, ParentType, ContextType, Partial<ItemsMatchingItemsBuySpecsArgs>>;
  matchingItemsBuySpecs_aggregate?: Resolver<ResolversTypes['matchingItemsBuySpecs_aggregate'], ParentType, ContextType, Partial<ItemsMatchingItemsBuySpecs_AggregateArgs>>;
  netsuiteId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  qualities?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType, Partial<ItemsQualitiesArgs>>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityAvailable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  queryEmbedding?: Resolver<Maybe<ResolversTypes['vector']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleShipmentRequests?: Resolver<Array<ResolversTypes['sampleShipmentRequests']>, ParentType, ContextType, Partial<ItemsSampleShipmentRequestsArgs>>;
  sampleShipmentRequests_aggregate?: Resolver<ResolversTypes['sampleShipmentRequests_aggregate'], ParentType, ContextType, Partial<ItemsSampleShipmentRequests_AggregateArgs>>;
  samples?: Resolver<Array<ResolversTypes['samples']>, ParentType, ContextType, Partial<ItemsSamplesArgs>>;
  samples_aggregate?: Resolver<ResolversTypes['samples_aggregate'], ParentType, ContextType, Partial<ItemsSamples_AggregateArgs>>;
  shipmentFulfillments?: Resolver<Array<ResolversTypes['shipmentFulfillments']>, ParentType, ContextType, Partial<ItemsShipmentFulfillmentsArgs>>;
  shipmentFulfillments_aggregate?: Resolver<ResolversTypes['shipmentFulfillments_aggregate'], ParentType, ContextType, Partial<ItemsShipmentFulfillments_AggregateArgs>>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storageLocationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subAppellation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subGeneric?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplierCompany?: Resolver<ResolversTypes['companies'], ParentType, ContextType>;
  supplierCompanyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  supplierContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tankNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  varietals?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType, Partial<ItemsVarietalsArgs>>;
  vintages?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType, Partial<ItemsVintagesArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Items_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['items_aggregate'] = ResolversParentTypes['items_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['items_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['items']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Items_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['items_aggregate_fields'] = ResolversParentTypes['items_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['items_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Items_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['items_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['items_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['items_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['items_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['items_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['items_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['items_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['items_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['items_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Items_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['items_avg_fields'] = ResolversParentTypes['items_avg_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  exportPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  localPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityAvailable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  storageLocationId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supplierCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supplierContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Items_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['items_max_fields'] = ResolversParentTypes['items_max_fields']> = {
  additionalInformations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commodityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conditioning?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  district?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportIncoterms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportIncotermsType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  generic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  harvestMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  localPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lotNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netsuiteId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityAvailable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storageLocationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subAppellation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subGeneric?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplierCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  supplierContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tankNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Items_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['items_min_fields'] = ResolversParentTypes['items_min_fields']> = {
  additionalInformations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commodityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conditioning?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  district?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportIncoterms?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportIncotermsType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exportPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  generic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  harvestMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  localPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lotNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  netsuiteId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityAvailable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storageLocationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subAppellation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subGeneric?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subRegion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  supplierCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  supplierContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tankNo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Items_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['items_mutation_response'] = ResolversParentTypes['items_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['items']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Items_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['items_stddev_fields'] = ResolversParentTypes['items_stddev_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  exportPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  localPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityAvailable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  storageLocationId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supplierCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supplierContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Items_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['items_stddev_pop_fields'] = ResolversParentTypes['items_stddev_pop_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  exportPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  localPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityAvailable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  storageLocationId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supplierCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supplierContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Items_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['items_stddev_samp_fields'] = ResolversParentTypes['items_stddev_samp_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  exportPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  localPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityAvailable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  storageLocationId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supplierCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supplierContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Items_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['items_sum_fields'] = ResolversParentTypes['items_sum_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  exportPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  localPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityAvailable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  storageLocationId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  supplierCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  supplierContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Items_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['items_var_pop_fields'] = ResolversParentTypes['items_var_pop_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  exportPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  localPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityAvailable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  storageLocationId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supplierCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supplierContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Items_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['items_var_samp_fields'] = ResolversParentTypes['items_var_samp_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  exportPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  localPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityAvailable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  storageLocationId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supplierCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supplierContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Items_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['items_variance_fields'] = ResolversParentTypes['items_variance_fields']> = {
  alcohol?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  exportPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  localPrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantityAvailable?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  storageLocationId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supplierCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  supplierContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonbScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['jsonb'], any> {
  name: 'jsonb';
}

export type LogsResolvers<ContextType = any, ParentType extends ResolversParentTypes['logs'] = ResolversParentTypes['logs']> = {
  action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  payload?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<LogsPayloadArgs>>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Logs_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['logs_aggregate'] = ResolversParentTypes['logs_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['logs_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['logs']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Logs_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['logs_aggregate_fields'] = ResolversParentTypes['logs_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['logs_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Logs_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['logs_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['logs_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['logs_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['logs_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['logs_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['logs_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['logs_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['logs_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['logs_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Logs_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['logs_avg_fields'] = ResolversParentTypes['logs_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Logs_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['logs_max_fields'] = ResolversParentTypes['logs_max_fields']> = {
  action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Logs_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['logs_min_fields'] = ResolversParentTypes['logs_min_fields']> = {
  action?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Logs_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['logs_mutation_response'] = ResolversParentTypes['logs_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['logs']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Logs_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['logs_stddev_fields'] = ResolversParentTypes['logs_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Logs_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['logs_stddev_pop_fields'] = ResolversParentTypes['logs_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Logs_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['logs_stddev_samp_fields'] = ResolversParentTypes['logs_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Logs_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['logs_sum_fields'] = ResolversParentTypes['logs_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Logs_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['logs_var_pop_fields'] = ResolversParentTypes['logs_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Logs_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['logs_var_samp_fields'] = ResolversParentTypes['logs_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Logs_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['logs_variance_fields'] = ResolversParentTypes['logs_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchingItemsBuySpecsResolvers<ContextType = any, ParentType extends ResolversParentTypes['matchingItemsBuySpecs'] = ResolversParentTypes['matchingItemsBuySpecs']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  buySpec?: Resolver<ResolversTypes['buySpecs'], ParentType, ContextType>;
  buySpecId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  item?: Resolver<ResolversTypes['items'], ParentType, ContextType>;
  itemId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchingItemsBuySpecs_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['matchingItemsBuySpecs_aggregate'] = ResolversParentTypes['matchingItemsBuySpecs_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['matchingItemsBuySpecs']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchingItemsBuySpecs_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['matchingItemsBuySpecs_aggregate_fields'] = ResolversParentTypes['matchingItemsBuySpecs_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<MatchingItemsBuySpecs_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchingItemsBuySpecs_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['matchingItemsBuySpecs_avg_fields'] = ResolversParentTypes['matchingItemsBuySpecs_avg_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchingItemsBuySpecs_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['matchingItemsBuySpecs_max_fields'] = ResolversParentTypes['matchingItemsBuySpecs_max_fields']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  buySpecId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchingItemsBuySpecs_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['matchingItemsBuySpecs_min_fields'] = ResolversParentTypes['matchingItemsBuySpecs_min_fields']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  buySpecId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchingItemsBuySpecs_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['matchingItemsBuySpecs_mutation_response'] = ResolversParentTypes['matchingItemsBuySpecs_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['matchingItemsBuySpecs']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchingItemsBuySpecs_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['matchingItemsBuySpecs_stddev_fields'] = ResolversParentTypes['matchingItemsBuySpecs_stddev_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchingItemsBuySpecs_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['matchingItemsBuySpecs_stddev_pop_fields'] = ResolversParentTypes['matchingItemsBuySpecs_stddev_pop_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchingItemsBuySpecs_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['matchingItemsBuySpecs_stddev_samp_fields'] = ResolversParentTypes['matchingItemsBuySpecs_stddev_samp_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchingItemsBuySpecs_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['matchingItemsBuySpecs_sum_fields'] = ResolversParentTypes['matchingItemsBuySpecs_sum_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchingItemsBuySpecs_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['matchingItemsBuySpecs_var_pop_fields'] = ResolversParentTypes['matchingItemsBuySpecs_var_pop_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchingItemsBuySpecs_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['matchingItemsBuySpecs_var_samp_fields'] = ResolversParentTypes['matchingItemsBuySpecs_var_samp_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MatchingItemsBuySpecs_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['matchingItemsBuySpecs_variance_fields'] = ResolversParentTypes['matchingItemsBuySpecs_variance_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Mutation_RootResolvers<ContextType = any, ParentType extends ResolversParentTypes['mutation_root'] = ResolversParentTypes['mutation_root']> = {
  delete_addresses?: Resolver<Maybe<ResolversTypes['addresses_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_AddressesArgs, 'where'>>;
  delete_addresses_by_pk?: Resolver<Maybe<ResolversTypes['addresses']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Addresses_By_PkArgs, 'id'>>;
  delete_agreementTerms?: Resolver<Maybe<ResolversTypes['agreementTerms_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_AgreementTermsArgs, 'where'>>;
  delete_agreementTerms_by_pk?: Resolver<Maybe<ResolversTypes['agreementTerms']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_AgreementTerms_By_PkArgs, 'id'>>;
  delete_agreements?: Resolver<Maybe<ResolversTypes['agreements_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_AgreementsArgs, 'where'>>;
  delete_agreements_by_pk?: Resolver<Maybe<ResolversTypes['agreements']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Agreements_By_PkArgs, 'id'>>;
  delete_appellations?: Resolver<Maybe<ResolversTypes['appellations_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_AppellationsArgs, 'where'>>;
  delete_appellations_by_pk?: Resolver<Maybe<ResolversTypes['appellations']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Appellations_By_PkArgs, 'id'>>;
  delete_authorizedDomains?: Resolver<Maybe<ResolversTypes['authorizedDomains_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_AuthorizedDomainsArgs, 'where'>>;
  delete_authorizedDomains_by_pk?: Resolver<Maybe<ResolversTypes['authorizedDomains']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_AuthorizedDomains_By_PkArgs, 'id'>>;
  delete_buySpecs?: Resolver<Maybe<ResolversTypes['buySpecs_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_BuySpecsArgs, 'where'>>;
  delete_buySpecs_by_pk?: Resolver<Maybe<ResolversTypes['buySpecs']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_BuySpecs_By_PkArgs, 'id'>>;
  delete_companies?: Resolver<Maybe<ResolversTypes['companies_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_CompaniesArgs, 'where'>>;
  delete_companies_by_pk?: Resolver<Maybe<ResolversTypes['companies']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Companies_By_PkArgs, 'id'>>;
  delete_companyAddress?: Resolver<Maybe<ResolversTypes['companyAddress_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_CompanyAddressArgs, 'where'>>;
  delete_companyAddress_by_pk?: Resolver<Maybe<ResolversTypes['companyAddress']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_CompanyAddress_By_PkArgs, 'id'>>;
  delete_contacts?: Resolver<Maybe<ResolversTypes['contacts_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ContactsArgs, 'where'>>;
  delete_contacts_by_pk?: Resolver<Maybe<ResolversTypes['contacts']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Contacts_By_PkArgs, 'id'>>;
  delete_contracts?: Resolver<Maybe<ResolversTypes['contracts_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ContractsArgs, 'where'>>;
  delete_contracts_by_pk?: Resolver<Maybe<ResolversTypes['contracts']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Contracts_By_PkArgs, 'id'>>;
  delete_currenciesConversions?: Resolver<Maybe<ResolversTypes['currenciesConversions_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_CurrenciesConversionsArgs, 'where'>>;
  delete_currenciesConversions_by_pk?: Resolver<Maybe<ResolversTypes['currenciesConversions']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_CurrenciesConversions_By_PkArgs, 'id'>>;
  delete_history?: Resolver<Maybe<ResolversTypes['history_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_HistoryArgs, 'where'>>;
  delete_history_by_pk?: Resolver<Maybe<ResolversTypes['history']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_History_By_PkArgs, 'id'>>;
  delete_invoices?: Resolver<Maybe<ResolversTypes['invoices_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_InvoicesArgs, 'where'>>;
  delete_invoices_by_pk?: Resolver<Maybe<ResolversTypes['invoices']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Invoices_By_PkArgs, 'id'>>;
  delete_items?: Resolver<Maybe<ResolversTypes['items_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ItemsArgs, 'where'>>;
  delete_items_by_pk?: Resolver<Maybe<ResolversTypes['items']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Items_By_PkArgs, 'id'>>;
  delete_logs?: Resolver<Maybe<ResolversTypes['logs_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_LogsArgs, 'where'>>;
  delete_logs_by_pk?: Resolver<Maybe<ResolversTypes['logs']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Logs_By_PkArgs, 'id'>>;
  delete_matchingItemsBuySpecs?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_MatchingItemsBuySpecsArgs, 'where'>>;
  delete_matchingItemsBuySpecs_by_pk?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_MatchingItemsBuySpecs_By_PkArgs, 'id'>>;
  delete_notifications?: Resolver<Maybe<ResolversTypes['notifications_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_NotificationsArgs, 'where'>>;
  delete_notifications_by_pk?: Resolver<Maybe<ResolversTypes['notifications']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Notifications_By_PkArgs, 'id'>>;
  delete_offices?: Resolver<Maybe<ResolversTypes['offices_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_OfficesArgs, 'where'>>;
  delete_offices_by_pk?: Resolver<Maybe<ResolversTypes['offices']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Offices_By_PkArgs, 'id'>>;
  delete_releases?: Resolver<Maybe<ResolversTypes['releases_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ReleasesArgs, 'where'>>;
  delete_releases_by_pk?: Resolver<Maybe<ResolversTypes['releases']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Releases_By_PkArgs, 'id'>>;
  delete_reminders?: Resolver<Maybe<ResolversTypes['reminders_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_RemindersArgs, 'where'>>;
  delete_reminders_by_pk?: Resolver<Maybe<ResolversTypes['reminders']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Reminders_By_PkArgs, 'id'>>;
  delete_sampleLabels?: Resolver<Maybe<ResolversTypes['sampleLabels_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_SampleLabelsArgs, 'where'>>;
  delete_sampleLabels_by_pk?: Resolver<Maybe<ResolversTypes['sampleLabels']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_SampleLabels_By_PkArgs, 'id'>>;
  delete_sampleShipmentRequests?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_SampleShipmentRequestsArgs, 'where'>>;
  delete_sampleShipmentRequests_by_pk?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_SampleShipmentRequests_By_PkArgs, 'id'>>;
  delete_sampleShipments?: Resolver<Maybe<ResolversTypes['sampleShipments_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_SampleShipmentsArgs, 'where'>>;
  delete_sampleShipments_by_pk?: Resolver<Maybe<ResolversTypes['sampleShipments']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_SampleShipments_By_PkArgs, 'id'>>;
  delete_samples?: Resolver<Maybe<ResolversTypes['samples_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_SamplesArgs, 'where'>>;
  delete_samples_by_pk?: Resolver<Maybe<ResolversTypes['samples']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Samples_By_PkArgs, 'id'>>;
  delete_shipmentFulfillments?: Resolver<Maybe<ResolversTypes['shipmentFulfillments_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ShipmentFulfillmentsArgs, 'where'>>;
  delete_shipmentFulfillments_by_pk?: Resolver<Maybe<ResolversTypes['shipmentFulfillments']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ShipmentFulfillments_By_PkArgs, 'id'>>;
  delete_trackings?: Resolver<Maybe<ResolversTypes['trackings_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_TrackingsArgs, 'where'>>;
  delete_trackings_by_pk?: Resolver<Maybe<ResolversTypes['trackings']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Trackings_By_PkArgs, 'id'>>;
  delete_users?: Resolver<Maybe<ResolversTypes['users_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_UsersArgs, 'where'>>;
  delete_usersBonus?: Resolver<Maybe<ResolversTypes['usersBonus_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_UsersBonusArgs, 'where'>>;
  delete_usersBonus_by_pk?: Resolver<Maybe<ResolversTypes['usersBonus']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_UsersBonus_By_PkArgs, 'id'>>;
  delete_usersCosts?: Resolver<Maybe<ResolversTypes['usersCosts_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_UsersCostsArgs, 'where'>>;
  delete_usersCosts_by_pk?: Resolver<Maybe<ResolversTypes['usersCosts']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_UsersCosts_By_PkArgs, 'id'>>;
  delete_users_by_pk?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Users_By_PkArgs, 'id'>>;
  delete_validationsContracts?: Resolver<Maybe<ResolversTypes['validationsContracts_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ValidationsContractsArgs, 'where'>>;
  delete_validationsContracts_by_pk?: Resolver<Maybe<ResolversTypes['validationsContracts']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_ValidationsContracts_By_PkArgs, 'id'>>;
  delete_varietals?: Resolver<Maybe<ResolversTypes['varietals_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_VarietalsArgs, 'where'>>;
  delete_varietals_by_pk?: Resolver<Maybe<ResolversTypes['varietals']>, ParentType, ContextType, RequireFields<Mutation_RootDelete_Varietals_By_PkArgs, 'id'>>;
  insert_addresses?: Resolver<Maybe<ResolversTypes['addresses_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_AddressesArgs, 'objects'>>;
  insert_addresses_one?: Resolver<Maybe<ResolversTypes['addresses']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Addresses_OneArgs, 'object'>>;
  insert_agreementTerms?: Resolver<Maybe<ResolversTypes['agreementTerms_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_AgreementTermsArgs, 'objects'>>;
  insert_agreementTerms_one?: Resolver<Maybe<ResolversTypes['agreementTerms']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_AgreementTerms_OneArgs, 'object'>>;
  insert_agreements?: Resolver<Maybe<ResolversTypes['agreements_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_AgreementsArgs, 'objects'>>;
  insert_agreements_one?: Resolver<Maybe<ResolversTypes['agreements']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Agreements_OneArgs, 'object'>>;
  insert_appellations?: Resolver<Maybe<ResolversTypes['appellations_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_AppellationsArgs, 'objects'>>;
  insert_appellations_one?: Resolver<Maybe<ResolversTypes['appellations']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Appellations_OneArgs, 'object'>>;
  insert_authorizedDomains?: Resolver<Maybe<ResolversTypes['authorizedDomains_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_AuthorizedDomainsArgs, 'objects'>>;
  insert_authorizedDomains_one?: Resolver<Maybe<ResolversTypes['authorizedDomains']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_AuthorizedDomains_OneArgs, 'object'>>;
  insert_buySpecs?: Resolver<Maybe<ResolversTypes['buySpecs_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_BuySpecsArgs, 'objects'>>;
  insert_buySpecs_one?: Resolver<Maybe<ResolversTypes['buySpecs']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_BuySpecs_OneArgs, 'object'>>;
  insert_companies?: Resolver<Maybe<ResolversTypes['companies_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_CompaniesArgs, 'objects'>>;
  insert_companies_one?: Resolver<Maybe<ResolversTypes['companies']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Companies_OneArgs, 'object'>>;
  insert_companyAddress?: Resolver<Maybe<ResolversTypes['companyAddress_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_CompanyAddressArgs, 'objects'>>;
  insert_companyAddress_one?: Resolver<Maybe<ResolversTypes['companyAddress']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_CompanyAddress_OneArgs, 'object'>>;
  insert_contacts?: Resolver<Maybe<ResolversTypes['contacts_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ContactsArgs, 'objects'>>;
  insert_contacts_one?: Resolver<Maybe<ResolversTypes['contacts']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Contacts_OneArgs, 'object'>>;
  insert_contracts?: Resolver<Maybe<ResolversTypes['contracts_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ContractsArgs, 'objects'>>;
  insert_contracts_one?: Resolver<Maybe<ResolversTypes['contracts']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Contracts_OneArgs, 'object'>>;
  insert_currenciesConversions?: Resolver<Maybe<ResolversTypes['currenciesConversions_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_CurrenciesConversionsArgs, 'objects'>>;
  insert_currenciesConversions_one?: Resolver<Maybe<ResolversTypes['currenciesConversions']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_CurrenciesConversions_OneArgs, 'object'>>;
  insert_history?: Resolver<Maybe<ResolversTypes['history_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_HistoryArgs, 'objects'>>;
  insert_history_one?: Resolver<Maybe<ResolversTypes['history']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_History_OneArgs, 'object'>>;
  insert_invoices?: Resolver<Maybe<ResolversTypes['invoices_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_InvoicesArgs, 'objects'>>;
  insert_invoices_one?: Resolver<Maybe<ResolversTypes['invoices']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Invoices_OneArgs, 'object'>>;
  insert_items?: Resolver<Maybe<ResolversTypes['items_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ItemsArgs, 'objects'>>;
  insert_items_one?: Resolver<Maybe<ResolversTypes['items']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Items_OneArgs, 'object'>>;
  insert_logs?: Resolver<Maybe<ResolversTypes['logs_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_LogsArgs, 'objects'>>;
  insert_logs_one?: Resolver<Maybe<ResolversTypes['logs']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Logs_OneArgs, 'object'>>;
  insert_matchingItemsBuySpecs?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_MatchingItemsBuySpecsArgs, 'objects'>>;
  insert_matchingItemsBuySpecs_one?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_MatchingItemsBuySpecs_OneArgs, 'object'>>;
  insert_notifications?: Resolver<Maybe<ResolversTypes['notifications_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_NotificationsArgs, 'objects'>>;
  insert_notifications_one?: Resolver<Maybe<ResolversTypes['notifications']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Notifications_OneArgs, 'object'>>;
  insert_offices?: Resolver<Maybe<ResolversTypes['offices_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_OfficesArgs, 'objects'>>;
  insert_offices_one?: Resolver<Maybe<ResolversTypes['offices']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Offices_OneArgs, 'object'>>;
  insert_releases?: Resolver<Maybe<ResolversTypes['releases_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ReleasesArgs, 'objects'>>;
  insert_releases_one?: Resolver<Maybe<ResolversTypes['releases']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Releases_OneArgs, 'object'>>;
  insert_reminders?: Resolver<Maybe<ResolversTypes['reminders_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_RemindersArgs, 'objects'>>;
  insert_reminders_one?: Resolver<Maybe<ResolversTypes['reminders']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Reminders_OneArgs, 'object'>>;
  insert_sampleLabels?: Resolver<Maybe<ResolversTypes['sampleLabels_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_SampleLabelsArgs, 'objects'>>;
  insert_sampleLabels_one?: Resolver<Maybe<ResolversTypes['sampleLabels']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_SampleLabels_OneArgs, 'object'>>;
  insert_sampleShipmentRequests?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_SampleShipmentRequestsArgs, 'objects'>>;
  insert_sampleShipmentRequests_one?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_SampleShipmentRequests_OneArgs, 'object'>>;
  insert_sampleShipments?: Resolver<Maybe<ResolversTypes['sampleShipments_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_SampleShipmentsArgs, 'objects'>>;
  insert_sampleShipments_one?: Resolver<Maybe<ResolversTypes['sampleShipments']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_SampleShipments_OneArgs, 'object'>>;
  insert_samples?: Resolver<Maybe<ResolversTypes['samples_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_SamplesArgs, 'objects'>>;
  insert_samples_one?: Resolver<Maybe<ResolversTypes['samples']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Samples_OneArgs, 'object'>>;
  insert_shipmentFulfillments?: Resolver<Maybe<ResolversTypes['shipmentFulfillments_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ShipmentFulfillmentsArgs, 'objects'>>;
  insert_shipmentFulfillments_one?: Resolver<Maybe<ResolversTypes['shipmentFulfillments']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ShipmentFulfillments_OneArgs, 'object'>>;
  insert_trackings?: Resolver<Maybe<ResolversTypes['trackings_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_TrackingsArgs, 'objects'>>;
  insert_trackings_one?: Resolver<Maybe<ResolversTypes['trackings']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Trackings_OneArgs, 'object'>>;
  insert_users?: Resolver<Maybe<ResolversTypes['users_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_UsersArgs, 'objects'>>;
  insert_usersBonus?: Resolver<Maybe<ResolversTypes['usersBonus_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_UsersBonusArgs, 'objects'>>;
  insert_usersBonus_one?: Resolver<Maybe<ResolversTypes['usersBonus']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_UsersBonus_OneArgs, 'object'>>;
  insert_usersCosts?: Resolver<Maybe<ResolversTypes['usersCosts_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_UsersCostsArgs, 'objects'>>;
  insert_usersCosts_one?: Resolver<Maybe<ResolversTypes['usersCosts']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_UsersCosts_OneArgs, 'object'>>;
  insert_users_one?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Users_OneArgs, 'object'>>;
  insert_validationsContracts?: Resolver<Maybe<ResolversTypes['validationsContracts_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ValidationsContractsArgs, 'objects'>>;
  insert_validationsContracts_one?: Resolver<Maybe<ResolversTypes['validationsContracts']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_ValidationsContracts_OneArgs, 'object'>>;
  insert_varietals?: Resolver<Maybe<ResolversTypes['varietals_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_VarietalsArgs, 'objects'>>;
  insert_varietals_one?: Resolver<Maybe<ResolversTypes['varietals']>, ParentType, ContextType, RequireFields<Mutation_RootInsert_Varietals_OneArgs, 'object'>>;
  update_addresses?: Resolver<Maybe<ResolversTypes['addresses_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_AddressesArgs, 'where'>>;
  update_addresses_by_pk?: Resolver<Maybe<ResolversTypes['addresses']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Addresses_By_PkArgs, 'pk_columns'>>;
  update_addresses_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['addresses_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Addresses_ManyArgs, 'updates'>>;
  update_agreementTerms?: Resolver<Maybe<ResolversTypes['agreementTerms_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_AgreementTermsArgs, 'where'>>;
  update_agreementTerms_by_pk?: Resolver<Maybe<ResolversTypes['agreementTerms']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_AgreementTerms_By_PkArgs, 'pk_columns'>>;
  update_agreementTerms_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['agreementTerms_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_AgreementTerms_ManyArgs, 'updates'>>;
  update_agreements?: Resolver<Maybe<ResolversTypes['agreements_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_AgreementsArgs, 'where'>>;
  update_agreements_by_pk?: Resolver<Maybe<ResolversTypes['agreements']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Agreements_By_PkArgs, 'pk_columns'>>;
  update_agreements_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['agreements_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Agreements_ManyArgs, 'updates'>>;
  update_appellations?: Resolver<Maybe<ResolversTypes['appellations_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_AppellationsArgs, 'where'>>;
  update_appellations_by_pk?: Resolver<Maybe<ResolversTypes['appellations']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Appellations_By_PkArgs, 'pk_columns'>>;
  update_appellations_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['appellations_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Appellations_ManyArgs, 'updates'>>;
  update_authorizedDomains?: Resolver<Maybe<ResolversTypes['authorizedDomains_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_AuthorizedDomainsArgs, 'where'>>;
  update_authorizedDomains_by_pk?: Resolver<Maybe<ResolversTypes['authorizedDomains']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_AuthorizedDomains_By_PkArgs, 'pk_columns'>>;
  update_authorizedDomains_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['authorizedDomains_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_AuthorizedDomains_ManyArgs, 'updates'>>;
  update_buySpecs?: Resolver<Maybe<ResolversTypes['buySpecs_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_BuySpecsArgs, 'where'>>;
  update_buySpecs_by_pk?: Resolver<Maybe<ResolversTypes['buySpecs']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_BuySpecs_By_PkArgs, 'pk_columns'>>;
  update_buySpecs_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['buySpecs_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_BuySpecs_ManyArgs, 'updates'>>;
  update_companies?: Resolver<Maybe<ResolversTypes['companies_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_CompaniesArgs, 'where'>>;
  update_companies_by_pk?: Resolver<Maybe<ResolversTypes['companies']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Companies_By_PkArgs, 'pk_columns'>>;
  update_companies_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['companies_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Companies_ManyArgs, 'updates'>>;
  update_companyAddress?: Resolver<Maybe<ResolversTypes['companyAddress_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_CompanyAddressArgs, 'where'>>;
  update_companyAddress_by_pk?: Resolver<Maybe<ResolversTypes['companyAddress']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_CompanyAddress_By_PkArgs, 'pk_columns'>>;
  update_companyAddress_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['companyAddress_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_CompanyAddress_ManyArgs, 'updates'>>;
  update_contacts?: Resolver<Maybe<ResolversTypes['contacts_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ContactsArgs, 'where'>>;
  update_contacts_by_pk?: Resolver<Maybe<ResolversTypes['contacts']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contacts_By_PkArgs, 'pk_columns'>>;
  update_contacts_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['contacts_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contacts_ManyArgs, 'updates'>>;
  update_contracts?: Resolver<Maybe<ResolversTypes['contracts_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ContractsArgs, 'where'>>;
  update_contracts_by_pk?: Resolver<Maybe<ResolversTypes['contracts']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contracts_By_PkArgs, 'pk_columns'>>;
  update_contracts_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['contracts_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Contracts_ManyArgs, 'updates'>>;
  update_currenciesConversions?: Resolver<Maybe<ResolversTypes['currenciesConversions_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_CurrenciesConversionsArgs, 'where'>>;
  update_currenciesConversions_by_pk?: Resolver<Maybe<ResolversTypes['currenciesConversions']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_CurrenciesConversions_By_PkArgs, 'pk_columns'>>;
  update_currenciesConversions_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['currenciesConversions_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_CurrenciesConversions_ManyArgs, 'updates'>>;
  update_history?: Resolver<Maybe<ResolversTypes['history_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_HistoryArgs, 'where'>>;
  update_history_by_pk?: Resolver<Maybe<ResolversTypes['history']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_History_By_PkArgs, 'pk_columns'>>;
  update_history_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['history_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_History_ManyArgs, 'updates'>>;
  update_invoices?: Resolver<Maybe<ResolversTypes['invoices_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_InvoicesArgs, 'where'>>;
  update_invoices_by_pk?: Resolver<Maybe<ResolversTypes['invoices']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Invoices_By_PkArgs, 'pk_columns'>>;
  update_invoices_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['invoices_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Invoices_ManyArgs, 'updates'>>;
  update_items?: Resolver<Maybe<ResolversTypes['items_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ItemsArgs, 'where'>>;
  update_items_by_pk?: Resolver<Maybe<ResolversTypes['items']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Items_By_PkArgs, 'pk_columns'>>;
  update_items_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['items_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Items_ManyArgs, 'updates'>>;
  update_logs?: Resolver<Maybe<ResolversTypes['logs_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_LogsArgs, 'where'>>;
  update_logs_by_pk?: Resolver<Maybe<ResolversTypes['logs']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Logs_By_PkArgs, 'pk_columns'>>;
  update_logs_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['logs_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Logs_ManyArgs, 'updates'>>;
  update_matchingItemsBuySpecs?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_MatchingItemsBuySpecsArgs, 'where'>>;
  update_matchingItemsBuySpecs_by_pk?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_MatchingItemsBuySpecs_By_PkArgs, 'pk_columns'>>;
  update_matchingItemsBuySpecs_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['matchingItemsBuySpecs_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_MatchingItemsBuySpecs_ManyArgs, 'updates'>>;
  update_notifications?: Resolver<Maybe<ResolversTypes['notifications_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_NotificationsArgs, 'where'>>;
  update_notifications_by_pk?: Resolver<Maybe<ResolversTypes['notifications']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Notifications_By_PkArgs, 'pk_columns'>>;
  update_notifications_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['notifications_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Notifications_ManyArgs, 'updates'>>;
  update_offices?: Resolver<Maybe<ResolversTypes['offices_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_OfficesArgs, 'where'>>;
  update_offices_by_pk?: Resolver<Maybe<ResolversTypes['offices']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Offices_By_PkArgs, 'pk_columns'>>;
  update_offices_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['offices_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Offices_ManyArgs, 'updates'>>;
  update_releases?: Resolver<Maybe<ResolversTypes['releases_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ReleasesArgs, 'where'>>;
  update_releases_by_pk?: Resolver<Maybe<ResolversTypes['releases']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Releases_By_PkArgs, 'pk_columns'>>;
  update_releases_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['releases_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Releases_ManyArgs, 'updates'>>;
  update_reminders?: Resolver<Maybe<ResolversTypes['reminders_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_RemindersArgs, 'where'>>;
  update_reminders_by_pk?: Resolver<Maybe<ResolversTypes['reminders']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Reminders_By_PkArgs, 'pk_columns'>>;
  update_reminders_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['reminders_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Reminders_ManyArgs, 'updates'>>;
  update_sampleLabels?: Resolver<Maybe<ResolversTypes['sampleLabels_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_SampleLabelsArgs, 'where'>>;
  update_sampleLabels_by_pk?: Resolver<Maybe<ResolversTypes['sampleLabels']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_SampleLabels_By_PkArgs, 'pk_columns'>>;
  update_sampleLabels_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['sampleLabels_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_SampleLabels_ManyArgs, 'updates'>>;
  update_sampleShipmentRequests?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_SampleShipmentRequestsArgs, 'where'>>;
  update_sampleShipmentRequests_by_pk?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_SampleShipmentRequests_By_PkArgs, 'pk_columns'>>;
  update_sampleShipmentRequests_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['sampleShipmentRequests_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_SampleShipmentRequests_ManyArgs, 'updates'>>;
  update_sampleShipments?: Resolver<Maybe<ResolversTypes['sampleShipments_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_SampleShipmentsArgs, 'where'>>;
  update_sampleShipments_by_pk?: Resolver<Maybe<ResolversTypes['sampleShipments']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_SampleShipments_By_PkArgs, 'pk_columns'>>;
  update_sampleShipments_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['sampleShipments_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_SampleShipments_ManyArgs, 'updates'>>;
  update_samples?: Resolver<Maybe<ResolversTypes['samples_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_SamplesArgs, 'where'>>;
  update_samples_by_pk?: Resolver<Maybe<ResolversTypes['samples']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Samples_By_PkArgs, 'pk_columns'>>;
  update_samples_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['samples_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Samples_ManyArgs, 'updates'>>;
  update_shipmentFulfillments?: Resolver<Maybe<ResolversTypes['shipmentFulfillments_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ShipmentFulfillmentsArgs, 'where'>>;
  update_shipmentFulfillments_by_pk?: Resolver<Maybe<ResolversTypes['shipmentFulfillments']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ShipmentFulfillments_By_PkArgs, 'pk_columns'>>;
  update_shipmentFulfillments_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['shipmentFulfillments_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ShipmentFulfillments_ManyArgs, 'updates'>>;
  update_trackings?: Resolver<Maybe<ResolversTypes['trackings_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_TrackingsArgs, 'where'>>;
  update_trackings_by_pk?: Resolver<Maybe<ResolversTypes['trackings']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Trackings_By_PkArgs, 'pk_columns'>>;
  update_trackings_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['trackings_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Trackings_ManyArgs, 'updates'>>;
  update_users?: Resolver<Maybe<ResolversTypes['users_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_UsersArgs, 'where'>>;
  update_usersBonus?: Resolver<Maybe<ResolversTypes['usersBonus_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_UsersBonusArgs, 'where'>>;
  update_usersBonus_by_pk?: Resolver<Maybe<ResolversTypes['usersBonus']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_UsersBonus_By_PkArgs, 'pk_columns'>>;
  update_usersBonus_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['usersBonus_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_UsersBonus_ManyArgs, 'updates'>>;
  update_usersCosts?: Resolver<Maybe<ResolversTypes['usersCosts_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_UsersCostsArgs, 'where'>>;
  update_usersCosts_by_pk?: Resolver<Maybe<ResolversTypes['usersCosts']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_UsersCosts_By_PkArgs, 'pk_columns'>>;
  update_usersCosts_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['usersCosts_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_UsersCosts_ManyArgs, 'updates'>>;
  update_users_by_pk?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Users_By_PkArgs, 'pk_columns'>>;
  update_users_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['users_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Users_ManyArgs, 'updates'>>;
  update_validationsContracts?: Resolver<Maybe<ResolversTypes['validationsContracts_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ValidationsContractsArgs, 'where'>>;
  update_validationsContracts_by_pk?: Resolver<Maybe<ResolversTypes['validationsContracts']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ValidationsContracts_By_PkArgs, 'pk_columns'>>;
  update_validationsContracts_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['validationsContracts_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_ValidationsContracts_ManyArgs, 'updates'>>;
  update_varietals?: Resolver<Maybe<ResolversTypes['varietals_mutation_response']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_VarietalsArgs, 'where'>>;
  update_varietals_by_pk?: Resolver<Maybe<ResolversTypes['varietals']>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Varietals_By_PkArgs, 'pk_columns'>>;
  update_varietals_many?: Resolver<Maybe<Array<Maybe<ResolversTypes['varietals_mutation_response']>>>, ParentType, ContextType, RequireFields<Mutation_RootUpdate_Varietals_ManyArgs, 'updates'>>;
};

export type NotificationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notifications'] = ResolversParentTypes['notifications']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  assignedTo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  history?: Resolver<ResolversTypes['history'], ParentType, ContextType>;
  historyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['users'], ParentType, ContextType>;
  viewedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notifications_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['notifications_aggregate'] = ResolversParentTypes['notifications_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['notifications_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['notifications']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notifications_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notifications_aggregate_fields'] = ResolversParentTypes['notifications_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['notifications_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Notifications_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['notifications_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['notifications_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['notifications_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['notifications_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['notifications_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['notifications_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['notifications_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['notifications_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['notifications_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notifications_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notifications_avg_fields'] = ResolversParentTypes['notifications_avg_fields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notifications_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notifications_max_fields'] = ResolversParentTypes['notifications_max_fields']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  assignedTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  historyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  viewedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notifications_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notifications_min_fields'] = ResolversParentTypes['notifications_min_fields']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  assignedTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  historyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  viewedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notifications_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['notifications_mutation_response'] = ResolversParentTypes['notifications_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['notifications']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notifications_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notifications_stddev_fields'] = ResolversParentTypes['notifications_stddev_fields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notifications_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notifications_stddev_pop_fields'] = ResolversParentTypes['notifications_stddev_pop_fields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notifications_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notifications_stddev_samp_fields'] = ResolversParentTypes['notifications_stddev_samp_fields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notifications_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notifications_sum_fields'] = ResolversParentTypes['notifications_sum_fields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notifications_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notifications_var_pop_fields'] = ResolversParentTypes['notifications_var_pop_fields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notifications_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notifications_var_samp_fields'] = ResolversParentTypes['notifications_var_samp_fields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Notifications_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['notifications_variance_fields'] = ResolversParentTypes['notifications_variance_fields']> = {
  historyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfficesResolvers<ContextType = any, ParentType extends ResolversParentTypes['offices'] = ResolversParentTypes['offices']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Offices_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['offices_aggregate'] = ResolversParentTypes['offices_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['offices_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['offices']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Offices_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['offices_aggregate_fields'] = ResolversParentTypes['offices_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['offices_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Offices_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['offices_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['offices_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['offices_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['offices_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['offices_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['offices_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['offices_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['offices_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['offices_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Offices_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['offices_avg_fields'] = ResolversParentTypes['offices_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Offices_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['offices_max_fields'] = ResolversParentTypes['offices_max_fields']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Offices_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['offices_min_fields'] = ResolversParentTypes['offices_min_fields']> = {
  address?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Offices_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['offices_mutation_response'] = ResolversParentTypes['offices_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['offices']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Offices_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['offices_stddev_fields'] = ResolversParentTypes['offices_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Offices_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['offices_stddev_pop_fields'] = ResolversParentTypes['offices_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Offices_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['offices_stddev_samp_fields'] = ResolversParentTypes['offices_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Offices_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['offices_sum_fields'] = ResolversParentTypes['offices_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Offices_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['offices_var_pop_fields'] = ResolversParentTypes['offices_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Offices_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['offices_var_samp_fields'] = ResolversParentTypes['offices_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Offices_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['offices_variance_fields'] = ResolversParentTypes['offices_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Query_RootResolvers<ContextType = any, ParentType extends ResolversParentTypes['query_root'] = ResolversParentTypes['query_root']> = {
  addresses?: Resolver<Array<ResolversTypes['addresses']>, ParentType, ContextType, Partial<Query_RootAddressesArgs>>;
  addresses_aggregate?: Resolver<ResolversTypes['addresses_aggregate'], ParentType, ContextType, Partial<Query_RootAddresses_AggregateArgs>>;
  addresses_by_pk?: Resolver<Maybe<ResolversTypes['addresses']>, ParentType, ContextType, RequireFields<Query_RootAddresses_By_PkArgs, 'id'>>;
  addresses_without_company?: Resolver<Array<ResolversTypes['addresses_without_company']>, ParentType, ContextType, Partial<Query_RootAddresses_Without_CompanyArgs>>;
  addresses_without_company_aggregate?: Resolver<ResolversTypes['addresses_without_company_aggregate'], ParentType, ContextType, Partial<Query_RootAddresses_Without_Company_AggregateArgs>>;
  agreementTerms?: Resolver<Array<ResolversTypes['agreementTerms']>, ParentType, ContextType, Partial<Query_RootAgreementTermsArgs>>;
  agreementTerms_aggregate?: Resolver<ResolversTypes['agreementTerms_aggregate'], ParentType, ContextType, Partial<Query_RootAgreementTerms_AggregateArgs>>;
  agreementTerms_by_pk?: Resolver<Maybe<ResolversTypes['agreementTerms']>, ParentType, ContextType, RequireFields<Query_RootAgreementTerms_By_PkArgs, 'id'>>;
  agreements?: Resolver<Array<ResolversTypes['agreements']>, ParentType, ContextType, Partial<Query_RootAgreementsArgs>>;
  agreements_aggregate?: Resolver<ResolversTypes['agreements_aggregate'], ParentType, ContextType, Partial<Query_RootAgreements_AggregateArgs>>;
  agreements_by_pk?: Resolver<Maybe<ResolversTypes['agreements']>, ParentType, ContextType, RequireFields<Query_RootAgreements_By_PkArgs, 'id'>>;
  appellations?: Resolver<Array<ResolversTypes['appellations']>, ParentType, ContextType, Partial<Query_RootAppellationsArgs>>;
  appellations_aggregate?: Resolver<ResolversTypes['appellations_aggregate'], ParentType, ContextType, Partial<Query_RootAppellations_AggregateArgs>>;
  appellations_by_pk?: Resolver<Maybe<ResolversTypes['appellations']>, ParentType, ContextType, RequireFields<Query_RootAppellations_By_PkArgs, 'id'>>;
  authorizedDomains?: Resolver<Array<ResolversTypes['authorizedDomains']>, ParentType, ContextType, Partial<Query_RootAuthorizedDomainsArgs>>;
  authorizedDomains_aggregate?: Resolver<ResolversTypes['authorizedDomains_aggregate'], ParentType, ContextType, Partial<Query_RootAuthorizedDomains_AggregateArgs>>;
  authorizedDomains_by_pk?: Resolver<Maybe<ResolversTypes['authorizedDomains']>, ParentType, ContextType, RequireFields<Query_RootAuthorizedDomains_By_PkArgs, 'id'>>;
  buySpecs?: Resolver<Array<ResolversTypes['buySpecs']>, ParentType, ContextType, Partial<Query_RootBuySpecsArgs>>;
  buySpecs_aggregate?: Resolver<ResolversTypes['buySpecs_aggregate'], ParentType, ContextType, Partial<Query_RootBuySpecs_AggregateArgs>>;
  buySpecs_by_pk?: Resolver<Maybe<ResolversTypes['buySpecs']>, ParentType, ContextType, RequireFields<Query_RootBuySpecs_By_PkArgs, 'id'>>;
  companies?: Resolver<Array<ResolversTypes['companies']>, ParentType, ContextType, Partial<Query_RootCompaniesArgs>>;
  companies_aggregate?: Resolver<ResolversTypes['companies_aggregate'], ParentType, ContextType, Partial<Query_RootCompanies_AggregateArgs>>;
  companies_by_pk?: Resolver<Maybe<ResolversTypes['companies']>, ParentType, ContextType, RequireFields<Query_RootCompanies_By_PkArgs, 'id'>>;
  companyAddress?: Resolver<Array<ResolversTypes['companyAddress']>, ParentType, ContextType, Partial<Query_RootCompanyAddressArgs>>;
  companyAddress_aggregate?: Resolver<ResolversTypes['companyAddress_aggregate'], ParentType, ContextType, Partial<Query_RootCompanyAddress_AggregateArgs>>;
  companyAddress_by_pk?: Resolver<Maybe<ResolversTypes['companyAddress']>, ParentType, ContextType, RequireFields<Query_RootCompanyAddress_By_PkArgs, 'id'>>;
  contacts?: Resolver<Array<ResolversTypes['contacts']>, ParentType, ContextType, Partial<Query_RootContactsArgs>>;
  contacts_aggregate?: Resolver<ResolversTypes['contacts_aggregate'], ParentType, ContextType, Partial<Query_RootContacts_AggregateArgs>>;
  contacts_by_pk?: Resolver<Maybe<ResolversTypes['contacts']>, ParentType, ContextType, RequireFields<Query_RootContacts_By_PkArgs, 'id'>>;
  contacts_without_company?: Resolver<Array<ResolversTypes['contacts_without_company']>, ParentType, ContextType, Partial<Query_RootContacts_Without_CompanyArgs>>;
  contacts_without_company_aggregate?: Resolver<ResolversTypes['contacts_without_company_aggregate'], ParentType, ContextType, Partial<Query_RootContacts_Without_Company_AggregateArgs>>;
  contracts?: Resolver<Array<ResolversTypes['contracts']>, ParentType, ContextType, Partial<Query_RootContractsArgs>>;
  contracts_aggregate?: Resolver<ResolversTypes['contracts_aggregate'], ParentType, ContextType, Partial<Query_RootContracts_AggregateArgs>>;
  contracts_by_pk?: Resolver<Maybe<ResolversTypes['contracts']>, ParentType, ContextType, RequireFields<Query_RootContracts_By_PkArgs, 'id'>>;
  currenciesConversions?: Resolver<Array<ResolversTypes['currenciesConversions']>, ParentType, ContextType, Partial<Query_RootCurrenciesConversionsArgs>>;
  currenciesConversions_aggregate?: Resolver<ResolversTypes['currenciesConversions_aggregate'], ParentType, ContextType, Partial<Query_RootCurrenciesConversions_AggregateArgs>>;
  currenciesConversions_by_pk?: Resolver<Maybe<ResolversTypes['currenciesConversions']>, ParentType, ContextType, RequireFields<Query_RootCurrenciesConversions_By_PkArgs, 'id'>>;
  history?: Resolver<Array<ResolversTypes['history']>, ParentType, ContextType, Partial<Query_RootHistoryArgs>>;
  history_aggregate?: Resolver<ResolversTypes['history_aggregate'], ParentType, ContextType, Partial<Query_RootHistory_AggregateArgs>>;
  history_by_pk?: Resolver<Maybe<ResolversTypes['history']>, ParentType, ContextType, RequireFields<Query_RootHistory_By_PkArgs, 'id'>>;
  invoices?: Resolver<Array<ResolversTypes['invoices']>, ParentType, ContextType, Partial<Query_RootInvoicesArgs>>;
  invoices_aggregate?: Resolver<ResolversTypes['invoices_aggregate'], ParentType, ContextType, Partial<Query_RootInvoices_AggregateArgs>>;
  invoices_by_pk?: Resolver<Maybe<ResolversTypes['invoices']>, ParentType, ContextType, RequireFields<Query_RootInvoices_By_PkArgs, 'id'>>;
  items?: Resolver<Array<ResolversTypes['items']>, ParentType, ContextType, Partial<Query_RootItemsArgs>>;
  items_aggregate?: Resolver<ResolversTypes['items_aggregate'], ParentType, ContextType, Partial<Query_RootItems_AggregateArgs>>;
  items_by_pk?: Resolver<Maybe<ResolversTypes['items']>, ParentType, ContextType, RequireFields<Query_RootItems_By_PkArgs, 'id'>>;
  logs?: Resolver<Array<ResolversTypes['logs']>, ParentType, ContextType, Partial<Query_RootLogsArgs>>;
  logs_aggregate?: Resolver<ResolversTypes['logs_aggregate'], ParentType, ContextType, Partial<Query_RootLogs_AggregateArgs>>;
  logs_by_pk?: Resolver<Maybe<ResolversTypes['logs']>, ParentType, ContextType, RequireFields<Query_RootLogs_By_PkArgs, 'id'>>;
  matchingItemsBuySpecs?: Resolver<Array<ResolversTypes['matchingItemsBuySpecs']>, ParentType, ContextType, Partial<Query_RootMatchingItemsBuySpecsArgs>>;
  matchingItemsBuySpecs_aggregate?: Resolver<ResolversTypes['matchingItemsBuySpecs_aggregate'], ParentType, ContextType, Partial<Query_RootMatchingItemsBuySpecs_AggregateArgs>>;
  matchingItemsBuySpecs_by_pk?: Resolver<Maybe<ResolversTypes['matchingItemsBuySpecs']>, ParentType, ContextType, RequireFields<Query_RootMatchingItemsBuySpecs_By_PkArgs, 'id'>>;
  notifications?: Resolver<Array<ResolversTypes['notifications']>, ParentType, ContextType, Partial<Query_RootNotificationsArgs>>;
  notifications_aggregate?: Resolver<ResolversTypes['notifications_aggregate'], ParentType, ContextType, Partial<Query_RootNotifications_AggregateArgs>>;
  notifications_by_pk?: Resolver<Maybe<ResolversTypes['notifications']>, ParentType, ContextType, RequireFields<Query_RootNotifications_By_PkArgs, 'id'>>;
  offices?: Resolver<Array<ResolversTypes['offices']>, ParentType, ContextType, Partial<Query_RootOfficesArgs>>;
  offices_aggregate?: Resolver<ResolversTypes['offices_aggregate'], ParentType, ContextType, Partial<Query_RootOffices_AggregateArgs>>;
  offices_by_pk?: Resolver<Maybe<ResolversTypes['offices']>, ParentType, ContextType, RequireFields<Query_RootOffices_By_PkArgs, 'id'>>;
  releases?: Resolver<Array<ResolversTypes['releases']>, ParentType, ContextType, Partial<Query_RootReleasesArgs>>;
  releases_aggregate?: Resolver<ResolversTypes['releases_aggregate'], ParentType, ContextType, Partial<Query_RootReleases_AggregateArgs>>;
  releases_by_pk?: Resolver<Maybe<ResolversTypes['releases']>, ParentType, ContextType, RequireFields<Query_RootReleases_By_PkArgs, 'id'>>;
  reminders?: Resolver<Array<ResolversTypes['reminders']>, ParentType, ContextType, Partial<Query_RootRemindersArgs>>;
  reminders_aggregate?: Resolver<ResolversTypes['reminders_aggregate'], ParentType, ContextType, Partial<Query_RootReminders_AggregateArgs>>;
  reminders_by_pk?: Resolver<Maybe<ResolversTypes['reminders']>, ParentType, ContextType, RequireFields<Query_RootReminders_By_PkArgs, 'id'>>;
  sampleLabels?: Resolver<Array<ResolversTypes['sampleLabels']>, ParentType, ContextType, Partial<Query_RootSampleLabelsArgs>>;
  sampleLabels_aggregate?: Resolver<ResolversTypes['sampleLabels_aggregate'], ParentType, ContextType, Partial<Query_RootSampleLabels_AggregateArgs>>;
  sampleLabels_by_pk?: Resolver<Maybe<ResolversTypes['sampleLabels']>, ParentType, ContextType, RequireFields<Query_RootSampleLabels_By_PkArgs, 'id'>>;
  sampleShipmentRequests?: Resolver<Array<ResolversTypes['sampleShipmentRequests']>, ParentType, ContextType, Partial<Query_RootSampleShipmentRequestsArgs>>;
  sampleShipmentRequests_aggregate?: Resolver<ResolversTypes['sampleShipmentRequests_aggregate'], ParentType, ContextType, Partial<Query_RootSampleShipmentRequests_AggregateArgs>>;
  sampleShipmentRequests_by_pk?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests']>, ParentType, ContextType, RequireFields<Query_RootSampleShipmentRequests_By_PkArgs, 'id'>>;
  sampleShipments?: Resolver<Array<ResolversTypes['sampleShipments']>, ParentType, ContextType, Partial<Query_RootSampleShipmentsArgs>>;
  sampleShipments_aggregate?: Resolver<ResolversTypes['sampleShipments_aggregate'], ParentType, ContextType, Partial<Query_RootSampleShipments_AggregateArgs>>;
  sampleShipments_by_pk?: Resolver<Maybe<ResolversTypes['sampleShipments']>, ParentType, ContextType, RequireFields<Query_RootSampleShipments_By_PkArgs, 'id'>>;
  samples?: Resolver<Array<ResolversTypes['samples']>, ParentType, ContextType, Partial<Query_RootSamplesArgs>>;
  samples_aggregate?: Resolver<ResolversTypes['samples_aggregate'], ParentType, ContextType, Partial<Query_RootSamples_AggregateArgs>>;
  samples_by_pk?: Resolver<Maybe<ResolversTypes['samples']>, ParentType, ContextType, RequireFields<Query_RootSamples_By_PkArgs, 'id'>>;
  shipmentFulfillments?: Resolver<Array<ResolversTypes['shipmentFulfillments']>, ParentType, ContextType, Partial<Query_RootShipmentFulfillmentsArgs>>;
  shipmentFulfillments_aggregate?: Resolver<ResolversTypes['shipmentFulfillments_aggregate'], ParentType, ContextType, Partial<Query_RootShipmentFulfillments_AggregateArgs>>;
  shipmentFulfillments_by_pk?: Resolver<Maybe<ResolversTypes['shipmentFulfillments']>, ParentType, ContextType, RequireFields<Query_RootShipmentFulfillments_By_PkArgs, 'id'>>;
  trackings?: Resolver<Array<ResolversTypes['trackings']>, ParentType, ContextType, Partial<Query_RootTrackingsArgs>>;
  trackings_aggregate?: Resolver<ResolversTypes['trackings_aggregate'], ParentType, ContextType, Partial<Query_RootTrackings_AggregateArgs>>;
  trackings_by_pk?: Resolver<Maybe<ResolversTypes['trackings']>, ParentType, ContextType, RequireFields<Query_RootTrackings_By_PkArgs, 'id'>>;
  users?: Resolver<Array<ResolversTypes['users']>, ParentType, ContextType, Partial<Query_RootUsersArgs>>;
  usersBonus?: Resolver<Array<ResolversTypes['usersBonus']>, ParentType, ContextType, Partial<Query_RootUsersBonusArgs>>;
  usersBonus_aggregate?: Resolver<ResolversTypes['usersBonus_aggregate'], ParentType, ContextType, Partial<Query_RootUsersBonus_AggregateArgs>>;
  usersBonus_by_pk?: Resolver<Maybe<ResolversTypes['usersBonus']>, ParentType, ContextType, RequireFields<Query_RootUsersBonus_By_PkArgs, 'id'>>;
  usersCosts?: Resolver<Array<ResolversTypes['usersCosts']>, ParentType, ContextType, Partial<Query_RootUsersCostsArgs>>;
  usersCosts_aggregate?: Resolver<ResolversTypes['usersCosts_aggregate'], ParentType, ContextType, Partial<Query_RootUsersCosts_AggregateArgs>>;
  usersCosts_by_pk?: Resolver<Maybe<ResolversTypes['usersCosts']>, ParentType, ContextType, RequireFields<Query_RootUsersCosts_By_PkArgs, 'id'>>;
  users_aggregate?: Resolver<ResolversTypes['users_aggregate'], ParentType, ContextType, Partial<Query_RootUsers_AggregateArgs>>;
  users_by_pk?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType, RequireFields<Query_RootUsers_By_PkArgs, 'id'>>;
  validationsContracts?: Resolver<Array<ResolversTypes['validationsContracts']>, ParentType, ContextType, Partial<Query_RootValidationsContractsArgs>>;
  validationsContracts_aggregate?: Resolver<ResolversTypes['validationsContracts_aggregate'], ParentType, ContextType, Partial<Query_RootValidationsContracts_AggregateArgs>>;
  validationsContracts_by_pk?: Resolver<Maybe<ResolversTypes['validationsContracts']>, ParentType, ContextType, RequireFields<Query_RootValidationsContracts_By_PkArgs, 'id'>>;
  varietals?: Resolver<Array<ResolversTypes['varietals']>, ParentType, ContextType, Partial<Query_RootVarietalsArgs>>;
  varietals_aggregate?: Resolver<ResolversTypes['varietals_aggregate'], ParentType, ContextType, Partial<Query_RootVarietals_AggregateArgs>>;
  varietals_by_pk?: Resolver<Maybe<ResolversTypes['varietals']>, ParentType, ContextType, RequireFields<Query_RootVarietals_By_PkArgs, 'id'>>;
};

export type ReleasesResolvers<ContextType = any, ParentType extends ResolversParentTypes['releases'] = ResolversParentTypes['releases']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Releases_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['releases_aggregate'] = ResolversParentTypes['releases_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['releases_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['releases']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Releases_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['releases_aggregate_fields'] = ResolversParentTypes['releases_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['releases_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Releases_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['releases_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['releases_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['releases_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['releases_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['releases_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['releases_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['releases_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['releases_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['releases_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Releases_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['releases_avg_fields'] = ResolversParentTypes['releases_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Releases_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['releases_max_fields'] = ResolversParentTypes['releases_max_fields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Releases_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['releases_min_fields'] = ResolversParentTypes['releases_min_fields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Releases_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['releases_mutation_response'] = ResolversParentTypes['releases_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['releases']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Releases_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['releases_stddev_fields'] = ResolversParentTypes['releases_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Releases_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['releases_stddev_pop_fields'] = ResolversParentTypes['releases_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Releases_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['releases_stddev_samp_fields'] = ResolversParentTypes['releases_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Releases_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['releases_sum_fields'] = ResolversParentTypes['releases_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Releases_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['releases_var_pop_fields'] = ResolversParentTypes['releases_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Releases_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['releases_var_samp_fields'] = ResolversParentTypes['releases_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Releases_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['releases_variance_fields'] = ResolversParentTypes['releases_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemindersResolvers<ContextType = any, ParentType extends ResolversParentTypes['reminders'] = ResolversParentTypes['reminders']> = {
  assignedTo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  assignedUser?: Resolver<ResolversTypes['users'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  creator?: Resolver<ResolversTypes['users'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  table?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  viewedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Reminders_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['reminders_aggregate'] = ResolversParentTypes['reminders_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['reminders_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['reminders']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Reminders_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['reminders_aggregate_fields'] = ResolversParentTypes['reminders_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['reminders_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Reminders_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['reminders_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['reminders_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['reminders_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['reminders_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['reminders_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['reminders_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['reminders_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['reminders_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['reminders_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Reminders_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['reminders_avg_fields'] = ResolversParentTypes['reminders_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Reminders_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['reminders_max_fields'] = ResolversParentTypes['reminders_max_fields']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  table?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  viewedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Reminders_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['reminders_min_fields'] = ResolversParentTypes['reminders_min_fields']> = {
  assignedTo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  table?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  viewedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Reminders_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['reminders_mutation_response'] = ResolversParentTypes['reminders_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['reminders']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Reminders_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['reminders_stddev_fields'] = ResolversParentTypes['reminders_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Reminders_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['reminders_stddev_pop_fields'] = ResolversParentTypes['reminders_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Reminders_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['reminders_stddev_samp_fields'] = ResolversParentTypes['reminders_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Reminders_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['reminders_sum_fields'] = ResolversParentTypes['reminders_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Reminders_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['reminders_var_pop_fields'] = ResolversParentTypes['reminders_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Reminders_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['reminders_var_samp_fields'] = ResolversParentTypes['reminders_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Reminders_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['reminders_variance_fields'] = ResolversParentTypes['reminders_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleLabelsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleLabels'] = ResolversParentTypes['sampleLabels']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  fields?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType, Partial<SampleLabelsFieldsArgs>>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<SampleLabelsModelArgs>>;
  officeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleLabels_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleLabels_aggregate'] = ResolversParentTypes['sampleLabels_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['sampleLabels_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['sampleLabels']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleLabels_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleLabels_aggregate_fields'] = ResolversParentTypes['sampleLabels_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['sampleLabels_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<SampleLabels_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['sampleLabels_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['sampleLabels_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['sampleLabels_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['sampleLabels_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['sampleLabels_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['sampleLabels_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['sampleLabels_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['sampleLabels_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['sampleLabels_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleLabels_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleLabels_avg_fields'] = ResolversParentTypes['sampleLabels_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleLabels_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleLabels_max_fields'] = ResolversParentTypes['sampleLabels_max_fields']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleLabels_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleLabels_min_fields'] = ResolversParentTypes['sampleLabels_min_fields']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleLabels_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleLabels_mutation_response'] = ResolversParentTypes['sampleLabels_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['sampleLabels']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleLabels_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleLabels_stddev_fields'] = ResolversParentTypes['sampleLabels_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleLabels_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleLabels_stddev_pop_fields'] = ResolversParentTypes['sampleLabels_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleLabels_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleLabels_stddev_samp_fields'] = ResolversParentTypes['sampleLabels_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleLabels_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleLabels_sum_fields'] = ResolversParentTypes['sampleLabels_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleLabels_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleLabels_var_pop_fields'] = ResolversParentTypes['sampleLabels_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleLabels_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleLabels_var_samp_fields'] = ResolversParentTypes['sampleLabels_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleLabels_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleLabels_variance_fields'] = ResolversParentTypes['sampleLabels_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipmentRequestsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipmentRequests'] = ResolversParentTypes['sampleShipmentRequests']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  buySpec?: Resolver<ResolversTypes['buySpecs'], ParentType, ContextType>;
  buySpecId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deadline?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  feedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<SampleShipmentRequestsFilesArgs>>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  item?: Resolver<ResolversTypes['items'], ParentType, ContextType>;
  itemId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  numberOfSamples?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  requestedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestedByUser?: Resolver<Maybe<ResolversTypes['users']>, ParentType, ContextType>;
  sampleShipment?: Resolver<Maybe<ResolversTypes['sampleShipments']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamp'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipmentRequests_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipmentRequests_aggregate'] = ResolversParentTypes['sampleShipmentRequests_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['sampleShipmentRequests']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipmentRequests_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipmentRequests_aggregate_fields'] = ResolversParentTypes['sampleShipmentRequests_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<SampleShipmentRequests_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['sampleShipmentRequests_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipmentRequests_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipmentRequests_avg_fields'] = ResolversParentTypes['sampleShipmentRequests_avg_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfSamples?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipmentRequests_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipmentRequests_max_fields'] = ResolversParentTypes['sampleShipmentRequests_max_fields']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  buySpecId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deadline?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  feedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfSamples?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  requestedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipmentRequests_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipmentRequests_min_fields'] = ResolversParentTypes['sampleShipmentRequests_min_fields']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  buySpecId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deadline?: Resolver<Maybe<ResolversTypes['date']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  feedback?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfSamples?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  requestedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamp']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipmentRequests_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipmentRequests_mutation_response'] = ResolversParentTypes['sampleShipmentRequests_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['sampleShipmentRequests']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipmentRequests_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipmentRequests_stddev_fields'] = ResolversParentTypes['sampleShipmentRequests_stddev_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfSamples?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipmentRequests_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipmentRequests_stddev_pop_fields'] = ResolversParentTypes['sampleShipmentRequests_stddev_pop_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfSamples?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipmentRequests_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipmentRequests_stddev_samp_fields'] = ResolversParentTypes['sampleShipmentRequests_stddev_samp_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfSamples?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipmentRequests_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipmentRequests_sum_fields'] = ResolversParentTypes['sampleShipmentRequests_sum_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  numberOfSamples?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipmentRequests_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipmentRequests_var_pop_fields'] = ResolversParentTypes['sampleShipmentRequests_var_pop_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfSamples?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipmentRequests_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipmentRequests_var_samp_fields'] = ResolversParentTypes['sampleShipmentRequests_var_samp_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfSamples?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipmentRequests_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipmentRequests_variance_fields'] = ResolversParentTypes['sampleShipmentRequests_variance_fields']> = {
  buySpecId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfSamples?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipmentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipments'] = ResolversParentTypes['sampleShipments']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carrier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deliveryMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isHardcodedCarrier?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  office?: Resolver<Maybe<ResolversTypes['offices']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pickupDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  recipientAddress?: Resolver<Maybe<ResolversTypes['addresses']>, ParentType, ContextType>;
  recipientAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recipientCompany?: Resolver<ResolversTypes['companies'], ParentType, ContextType>;
  recipientCompanyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recipientContact?: Resolver<Maybe<ResolversTypes['contacts']>, ParentType, ContextType>;
  recipientContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sampleShipmentRequests?: Resolver<Array<ResolversTypes['sampleShipmentRequests']>, ParentType, ContextType, Partial<SampleShipmentsSampleShipmentRequestsArgs>>;
  sampleShipmentRequests_aggregate?: Resolver<ResolversTypes['sampleShipmentRequests_aggregate'], ParentType, ContextType, Partial<SampleShipmentsSampleShipmentRequests_AggregateArgs>>;
  senderAddress?: Resolver<Maybe<ResolversTypes['addresses']>, ParentType, ContextType>;
  senderAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  senderCompany?: Resolver<Maybe<ResolversTypes['companies']>, ParentType, ContextType>;
  senderCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  senderContact?: Resolver<Maybe<ResolversTypes['contacts']>, ParentType, ContextType>;
  senderContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trackingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipments_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipments_aggregate'] = ResolversParentTypes['sampleShipments_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['sampleShipments_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['sampleShipments']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipments_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipments_aggregate_fields'] = ResolversParentTypes['sampleShipments_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['sampleShipments_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<SampleShipments_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['sampleShipments_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['sampleShipments_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['sampleShipments_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['sampleShipments_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['sampleShipments_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['sampleShipments_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['sampleShipments_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['sampleShipments_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['sampleShipments_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipments_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipments_avg_fields'] = ResolversParentTypes['sampleShipments_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipments_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipments_max_fields'] = ResolversParentTypes['sampleShipments_max_fields']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carrier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deliveryMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pickupDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  recipientAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recipientCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recipientContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  senderAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  senderCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  senderContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trackingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipments_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipments_min_fields'] = ResolversParentTypes['sampleShipments_min_fields']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  brokerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carrier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deliveryMethod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  details?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pickupDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  recipientAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recipientCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recipientContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  senderAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  senderCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  senderContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trackingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipments_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipments_mutation_response'] = ResolversParentTypes['sampleShipments_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['sampleShipments']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipments_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipments_stddev_fields'] = ResolversParentTypes['sampleShipments_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipments_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipments_stddev_pop_fields'] = ResolversParentTypes['sampleShipments_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipments_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipments_stddev_samp_fields'] = ResolversParentTypes['sampleShipments_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipments_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipments_sum_fields'] = ResolversParentTypes['sampleShipments_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recipientAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recipientCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  recipientContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  senderAddressId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  senderCompanyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  senderContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipments_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipments_var_pop_fields'] = ResolversParentTypes['sampleShipments_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipments_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipments_var_samp_fields'] = ResolversParentTypes['sampleShipments_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleShipments_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['sampleShipments_variance_fields'] = ResolversParentTypes['sampleShipments_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recipientContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderAddressId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderCompanyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  senderContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SamplesResolvers<ContextType = any, ParentType extends ResolversParentTypes['samples'] = ResolversParentTypes['samples']> = {
  analysisCertificates?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<SamplesAnalysisCertificatesArgs>>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  commodityType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  compositionCertificates?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<SamplesCompositionCertificatesArgs>>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  item?: Resolver<ResolversTypes['items'], ParentType, ContextType>;
  itemId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ref?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reminderForExpiration?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  samplePictures?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<SamplesSamplePicturesArgs>>;
  sampleShipment?: Resolver<Maybe<ResolversTypes['sampleShipments']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sampledBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  samplingDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  shelf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Samples_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['samples_aggregate'] = ResolversParentTypes['samples_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['samples_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['samples']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Samples_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['samples_aggregate_fields'] = ResolversParentTypes['samples_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['samples_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Samples_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['samples_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['samples_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['samples_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['samples_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['samples_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['samples_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['samples_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['samples_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['samples_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Samples_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['samples_avg_fields'] = ResolversParentTypes['samples_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Samples_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['samples_max_fields'] = ResolversParentTypes['samples_max_fields']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  commodityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ref?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reminderForExpiration?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sampledBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  samplingDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  shelf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Samples_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['samples_min_fields'] = ResolversParentTypes['samples_min_fields']> = {
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  commodityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ref?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reminderForExpiration?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sampledBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  samplingDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  shelf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Samples_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['samples_mutation_response'] = ResolversParentTypes['samples_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['samples']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Samples_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['samples_stddev_fields'] = ResolversParentTypes['samples_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Samples_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['samples_stddev_pop_fields'] = ResolversParentTypes['samples_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Samples_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['samples_stddev_samp_fields'] = ResolversParentTypes['samples_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Samples_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['samples_sum_fields'] = ResolversParentTypes['samples_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Samples_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['samples_var_pop_fields'] = ResolversParentTypes['samples_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Samples_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['samples_var_samp_fields'] = ResolversParentTypes['samples_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Samples_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['samples_variance_fields'] = ResolversParentTypes['samples_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  sampleShipmentId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShipmentFulfillmentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['shipmentFulfillments'] = ResolversParentTypes['shipmentFulfillments']> = {
  agreement?: Resolver<ResolversTypes['agreements'], ParentType, ContextType>;
  agreementId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  files?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<ShipmentFulfillmentsFilesArgs>>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  invoices?: Resolver<Array<ResolversTypes['invoices']>, ParentType, ContextType, Partial<ShipmentFulfillmentsInvoicesArgs>>;
  invoices_aggregate?: Resolver<ResolversTypes['invoices_aggregate'], ParentType, ContextType, Partial<ShipmentFulfillmentsInvoices_AggregateArgs>>;
  item?: Resolver<ResolversTypes['items'], ParentType, ContextType>;
  itemId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShipmentFulfillments_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['shipmentFulfillments_aggregate'] = ResolversParentTypes['shipmentFulfillments_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['shipmentFulfillments_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['shipmentFulfillments']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShipmentFulfillments_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['shipmentFulfillments_aggregate_fields'] = ResolversParentTypes['shipmentFulfillments_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['shipmentFulfillments_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<ShipmentFulfillments_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['shipmentFulfillments_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['shipmentFulfillments_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['shipmentFulfillments_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['shipmentFulfillments_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['shipmentFulfillments_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['shipmentFulfillments_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['shipmentFulfillments_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['shipmentFulfillments_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['shipmentFulfillments_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShipmentFulfillments_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['shipmentFulfillments_avg_fields'] = ResolversParentTypes['shipmentFulfillments_avg_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShipmentFulfillments_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['shipmentFulfillments_max_fields'] = ResolversParentTypes['shipmentFulfillments_max_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShipmentFulfillments_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['shipmentFulfillments_min_fields'] = ResolversParentTypes['shipmentFulfillments_min_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  archivedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uom?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShipmentFulfillments_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['shipmentFulfillments_mutation_response'] = ResolversParentTypes['shipmentFulfillments_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['shipmentFulfillments']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShipmentFulfillments_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['shipmentFulfillments_stddev_fields'] = ResolversParentTypes['shipmentFulfillments_stddev_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShipmentFulfillments_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['shipmentFulfillments_stddev_pop_fields'] = ResolversParentTypes['shipmentFulfillments_stddev_pop_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShipmentFulfillments_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['shipmentFulfillments_stddev_samp_fields'] = ResolversParentTypes['shipmentFulfillments_stddev_samp_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShipmentFulfillments_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['shipmentFulfillments_sum_fields'] = ResolversParentTypes['shipmentFulfillments_sum_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShipmentFulfillments_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['shipmentFulfillments_var_pop_fields'] = ResolversParentTypes['shipmentFulfillments_var_pop_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShipmentFulfillments_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['shipmentFulfillments_var_samp_fields'] = ResolversParentTypes['shipmentFulfillments_var_samp_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShipmentFulfillments_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['shipmentFulfillments_variance_fields'] = ResolversParentTypes['shipmentFulfillments_variance_fields']> = {
  agreementId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  itemId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  quantity?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Subscription_RootResolvers<ContextType = any, ParentType extends ResolversParentTypes['subscription_root'] = ResolversParentTypes['subscription_root']> = {
  addresses?: SubscriptionResolver<Array<ResolversTypes['addresses']>, "addresses", ParentType, ContextType, Partial<Subscription_RootAddressesArgs>>;
  addresses_aggregate?: SubscriptionResolver<ResolversTypes['addresses_aggregate'], "addresses_aggregate", ParentType, ContextType, Partial<Subscription_RootAddresses_AggregateArgs>>;
  addresses_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['addresses']>, "addresses_by_pk", ParentType, ContextType, RequireFields<Subscription_RootAddresses_By_PkArgs, 'id'>>;
  addresses_stream?: SubscriptionResolver<Array<ResolversTypes['addresses']>, "addresses_stream", ParentType, ContextType, RequireFields<Subscription_RootAddresses_StreamArgs, 'batch_size' | 'cursor'>>;
  addresses_without_company?: SubscriptionResolver<Array<ResolversTypes['addresses_without_company']>, "addresses_without_company", ParentType, ContextType, Partial<Subscription_RootAddresses_Without_CompanyArgs>>;
  addresses_without_company_aggregate?: SubscriptionResolver<ResolversTypes['addresses_without_company_aggregate'], "addresses_without_company_aggregate", ParentType, ContextType, Partial<Subscription_RootAddresses_Without_Company_AggregateArgs>>;
  addresses_without_company_stream?: SubscriptionResolver<Array<ResolversTypes['addresses_without_company']>, "addresses_without_company_stream", ParentType, ContextType, RequireFields<Subscription_RootAddresses_Without_Company_StreamArgs, 'batch_size' | 'cursor'>>;
  agreementTerms?: SubscriptionResolver<Array<ResolversTypes['agreementTerms']>, "agreementTerms", ParentType, ContextType, Partial<Subscription_RootAgreementTermsArgs>>;
  agreementTerms_aggregate?: SubscriptionResolver<ResolversTypes['agreementTerms_aggregate'], "agreementTerms_aggregate", ParentType, ContextType, Partial<Subscription_RootAgreementTerms_AggregateArgs>>;
  agreementTerms_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['agreementTerms']>, "agreementTerms_by_pk", ParentType, ContextType, RequireFields<Subscription_RootAgreementTerms_By_PkArgs, 'id'>>;
  agreementTerms_stream?: SubscriptionResolver<Array<ResolversTypes['agreementTerms']>, "agreementTerms_stream", ParentType, ContextType, RequireFields<Subscription_RootAgreementTerms_StreamArgs, 'batch_size' | 'cursor'>>;
  agreements?: SubscriptionResolver<Array<ResolversTypes['agreements']>, "agreements", ParentType, ContextType, Partial<Subscription_RootAgreementsArgs>>;
  agreements_aggregate?: SubscriptionResolver<ResolversTypes['agreements_aggregate'], "agreements_aggregate", ParentType, ContextType, Partial<Subscription_RootAgreements_AggregateArgs>>;
  agreements_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['agreements']>, "agreements_by_pk", ParentType, ContextType, RequireFields<Subscription_RootAgreements_By_PkArgs, 'id'>>;
  agreements_stream?: SubscriptionResolver<Array<ResolversTypes['agreements']>, "agreements_stream", ParentType, ContextType, RequireFields<Subscription_RootAgreements_StreamArgs, 'batch_size' | 'cursor'>>;
  appellations?: SubscriptionResolver<Array<ResolversTypes['appellations']>, "appellations", ParentType, ContextType, Partial<Subscription_RootAppellationsArgs>>;
  appellations_aggregate?: SubscriptionResolver<ResolversTypes['appellations_aggregate'], "appellations_aggregate", ParentType, ContextType, Partial<Subscription_RootAppellations_AggregateArgs>>;
  appellations_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['appellations']>, "appellations_by_pk", ParentType, ContextType, RequireFields<Subscription_RootAppellations_By_PkArgs, 'id'>>;
  appellations_stream?: SubscriptionResolver<Array<ResolversTypes['appellations']>, "appellations_stream", ParentType, ContextType, RequireFields<Subscription_RootAppellations_StreamArgs, 'batch_size' | 'cursor'>>;
  authorizedDomains?: SubscriptionResolver<Array<ResolversTypes['authorizedDomains']>, "authorizedDomains", ParentType, ContextType, Partial<Subscription_RootAuthorizedDomainsArgs>>;
  authorizedDomains_aggregate?: SubscriptionResolver<ResolversTypes['authorizedDomains_aggregate'], "authorizedDomains_aggregate", ParentType, ContextType, Partial<Subscription_RootAuthorizedDomains_AggregateArgs>>;
  authorizedDomains_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['authorizedDomains']>, "authorizedDomains_by_pk", ParentType, ContextType, RequireFields<Subscription_RootAuthorizedDomains_By_PkArgs, 'id'>>;
  authorizedDomains_stream?: SubscriptionResolver<Array<ResolversTypes['authorizedDomains']>, "authorizedDomains_stream", ParentType, ContextType, RequireFields<Subscription_RootAuthorizedDomains_StreamArgs, 'batch_size' | 'cursor'>>;
  buySpecs?: SubscriptionResolver<Array<ResolversTypes['buySpecs']>, "buySpecs", ParentType, ContextType, Partial<Subscription_RootBuySpecsArgs>>;
  buySpecs_aggregate?: SubscriptionResolver<ResolversTypes['buySpecs_aggregate'], "buySpecs_aggregate", ParentType, ContextType, Partial<Subscription_RootBuySpecs_AggregateArgs>>;
  buySpecs_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['buySpecs']>, "buySpecs_by_pk", ParentType, ContextType, RequireFields<Subscription_RootBuySpecs_By_PkArgs, 'id'>>;
  buySpecs_stream?: SubscriptionResolver<Array<ResolversTypes['buySpecs']>, "buySpecs_stream", ParentType, ContextType, RequireFields<Subscription_RootBuySpecs_StreamArgs, 'batch_size' | 'cursor'>>;
  companies?: SubscriptionResolver<Array<ResolversTypes['companies']>, "companies", ParentType, ContextType, Partial<Subscription_RootCompaniesArgs>>;
  companies_aggregate?: SubscriptionResolver<ResolversTypes['companies_aggregate'], "companies_aggregate", ParentType, ContextType, Partial<Subscription_RootCompanies_AggregateArgs>>;
  companies_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['companies']>, "companies_by_pk", ParentType, ContextType, RequireFields<Subscription_RootCompanies_By_PkArgs, 'id'>>;
  companies_stream?: SubscriptionResolver<Array<ResolversTypes['companies']>, "companies_stream", ParentType, ContextType, RequireFields<Subscription_RootCompanies_StreamArgs, 'batch_size' | 'cursor'>>;
  companyAddress?: SubscriptionResolver<Array<ResolversTypes['companyAddress']>, "companyAddress", ParentType, ContextType, Partial<Subscription_RootCompanyAddressArgs>>;
  companyAddress_aggregate?: SubscriptionResolver<ResolversTypes['companyAddress_aggregate'], "companyAddress_aggregate", ParentType, ContextType, Partial<Subscription_RootCompanyAddress_AggregateArgs>>;
  companyAddress_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['companyAddress']>, "companyAddress_by_pk", ParentType, ContextType, RequireFields<Subscription_RootCompanyAddress_By_PkArgs, 'id'>>;
  companyAddress_stream?: SubscriptionResolver<Array<ResolversTypes['companyAddress']>, "companyAddress_stream", ParentType, ContextType, RequireFields<Subscription_RootCompanyAddress_StreamArgs, 'batch_size' | 'cursor'>>;
  contacts?: SubscriptionResolver<Array<ResolversTypes['contacts']>, "contacts", ParentType, ContextType, Partial<Subscription_RootContactsArgs>>;
  contacts_aggregate?: SubscriptionResolver<ResolversTypes['contacts_aggregate'], "contacts_aggregate", ParentType, ContextType, Partial<Subscription_RootContacts_AggregateArgs>>;
  contacts_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['contacts']>, "contacts_by_pk", ParentType, ContextType, RequireFields<Subscription_RootContacts_By_PkArgs, 'id'>>;
  contacts_stream?: SubscriptionResolver<Array<ResolversTypes['contacts']>, "contacts_stream", ParentType, ContextType, RequireFields<Subscription_RootContacts_StreamArgs, 'batch_size' | 'cursor'>>;
  contacts_without_company?: SubscriptionResolver<Array<ResolversTypes['contacts_without_company']>, "contacts_without_company", ParentType, ContextType, Partial<Subscription_RootContacts_Without_CompanyArgs>>;
  contacts_without_company_aggregate?: SubscriptionResolver<ResolversTypes['contacts_without_company_aggregate'], "contacts_without_company_aggregate", ParentType, ContextType, Partial<Subscription_RootContacts_Without_Company_AggregateArgs>>;
  contacts_without_company_stream?: SubscriptionResolver<Array<ResolversTypes['contacts_without_company']>, "contacts_without_company_stream", ParentType, ContextType, RequireFields<Subscription_RootContacts_Without_Company_StreamArgs, 'batch_size' | 'cursor'>>;
  contracts?: SubscriptionResolver<Array<ResolversTypes['contracts']>, "contracts", ParentType, ContextType, Partial<Subscription_RootContractsArgs>>;
  contracts_aggregate?: SubscriptionResolver<ResolversTypes['contracts_aggregate'], "contracts_aggregate", ParentType, ContextType, Partial<Subscription_RootContracts_AggregateArgs>>;
  contracts_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['contracts']>, "contracts_by_pk", ParentType, ContextType, RequireFields<Subscription_RootContracts_By_PkArgs, 'id'>>;
  contracts_stream?: SubscriptionResolver<Array<ResolversTypes['contracts']>, "contracts_stream", ParentType, ContextType, RequireFields<Subscription_RootContracts_StreamArgs, 'batch_size' | 'cursor'>>;
  currenciesConversions?: SubscriptionResolver<Array<ResolversTypes['currenciesConversions']>, "currenciesConversions", ParentType, ContextType, Partial<Subscription_RootCurrenciesConversionsArgs>>;
  currenciesConversions_aggregate?: SubscriptionResolver<ResolversTypes['currenciesConversions_aggregate'], "currenciesConversions_aggregate", ParentType, ContextType, Partial<Subscription_RootCurrenciesConversions_AggregateArgs>>;
  currenciesConversions_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['currenciesConversions']>, "currenciesConversions_by_pk", ParentType, ContextType, RequireFields<Subscription_RootCurrenciesConversions_By_PkArgs, 'id'>>;
  currenciesConversions_stream?: SubscriptionResolver<Array<ResolversTypes['currenciesConversions']>, "currenciesConversions_stream", ParentType, ContextType, RequireFields<Subscription_RootCurrenciesConversions_StreamArgs, 'batch_size' | 'cursor'>>;
  history?: SubscriptionResolver<Array<ResolversTypes['history']>, "history", ParentType, ContextType, Partial<Subscription_RootHistoryArgs>>;
  history_aggregate?: SubscriptionResolver<ResolversTypes['history_aggregate'], "history_aggregate", ParentType, ContextType, Partial<Subscription_RootHistory_AggregateArgs>>;
  history_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['history']>, "history_by_pk", ParentType, ContextType, RequireFields<Subscription_RootHistory_By_PkArgs, 'id'>>;
  history_stream?: SubscriptionResolver<Array<ResolversTypes['history']>, "history_stream", ParentType, ContextType, RequireFields<Subscription_RootHistory_StreamArgs, 'batch_size' | 'cursor'>>;
  invoices?: SubscriptionResolver<Array<ResolversTypes['invoices']>, "invoices", ParentType, ContextType, Partial<Subscription_RootInvoicesArgs>>;
  invoices_aggregate?: SubscriptionResolver<ResolversTypes['invoices_aggregate'], "invoices_aggregate", ParentType, ContextType, Partial<Subscription_RootInvoices_AggregateArgs>>;
  invoices_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['invoices']>, "invoices_by_pk", ParentType, ContextType, RequireFields<Subscription_RootInvoices_By_PkArgs, 'id'>>;
  invoices_stream?: SubscriptionResolver<Array<ResolversTypes['invoices']>, "invoices_stream", ParentType, ContextType, RequireFields<Subscription_RootInvoices_StreamArgs, 'batch_size' | 'cursor'>>;
  items?: SubscriptionResolver<Array<ResolversTypes['items']>, "items", ParentType, ContextType, Partial<Subscription_RootItemsArgs>>;
  items_aggregate?: SubscriptionResolver<ResolversTypes['items_aggregate'], "items_aggregate", ParentType, ContextType, Partial<Subscription_RootItems_AggregateArgs>>;
  items_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['items']>, "items_by_pk", ParentType, ContextType, RequireFields<Subscription_RootItems_By_PkArgs, 'id'>>;
  items_stream?: SubscriptionResolver<Array<ResolversTypes['items']>, "items_stream", ParentType, ContextType, RequireFields<Subscription_RootItems_StreamArgs, 'batch_size' | 'cursor'>>;
  logs?: SubscriptionResolver<Array<ResolversTypes['logs']>, "logs", ParentType, ContextType, Partial<Subscription_RootLogsArgs>>;
  logs_aggregate?: SubscriptionResolver<ResolversTypes['logs_aggregate'], "logs_aggregate", ParentType, ContextType, Partial<Subscription_RootLogs_AggregateArgs>>;
  logs_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['logs']>, "logs_by_pk", ParentType, ContextType, RequireFields<Subscription_RootLogs_By_PkArgs, 'id'>>;
  logs_stream?: SubscriptionResolver<Array<ResolversTypes['logs']>, "logs_stream", ParentType, ContextType, RequireFields<Subscription_RootLogs_StreamArgs, 'batch_size' | 'cursor'>>;
  matchingItemsBuySpecs?: SubscriptionResolver<Array<ResolversTypes['matchingItemsBuySpecs']>, "matchingItemsBuySpecs", ParentType, ContextType, Partial<Subscription_RootMatchingItemsBuySpecsArgs>>;
  matchingItemsBuySpecs_aggregate?: SubscriptionResolver<ResolversTypes['matchingItemsBuySpecs_aggregate'], "matchingItemsBuySpecs_aggregate", ParentType, ContextType, Partial<Subscription_RootMatchingItemsBuySpecs_AggregateArgs>>;
  matchingItemsBuySpecs_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['matchingItemsBuySpecs']>, "matchingItemsBuySpecs_by_pk", ParentType, ContextType, RequireFields<Subscription_RootMatchingItemsBuySpecs_By_PkArgs, 'id'>>;
  matchingItemsBuySpecs_stream?: SubscriptionResolver<Array<ResolversTypes['matchingItemsBuySpecs']>, "matchingItemsBuySpecs_stream", ParentType, ContextType, RequireFields<Subscription_RootMatchingItemsBuySpecs_StreamArgs, 'batch_size' | 'cursor'>>;
  notifications?: SubscriptionResolver<Array<ResolversTypes['notifications']>, "notifications", ParentType, ContextType, Partial<Subscription_RootNotificationsArgs>>;
  notifications_aggregate?: SubscriptionResolver<ResolversTypes['notifications_aggregate'], "notifications_aggregate", ParentType, ContextType, Partial<Subscription_RootNotifications_AggregateArgs>>;
  notifications_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['notifications']>, "notifications_by_pk", ParentType, ContextType, RequireFields<Subscription_RootNotifications_By_PkArgs, 'id'>>;
  notifications_stream?: SubscriptionResolver<Array<ResolversTypes['notifications']>, "notifications_stream", ParentType, ContextType, RequireFields<Subscription_RootNotifications_StreamArgs, 'batch_size' | 'cursor'>>;
  offices?: SubscriptionResolver<Array<ResolversTypes['offices']>, "offices", ParentType, ContextType, Partial<Subscription_RootOfficesArgs>>;
  offices_aggregate?: SubscriptionResolver<ResolversTypes['offices_aggregate'], "offices_aggregate", ParentType, ContextType, Partial<Subscription_RootOffices_AggregateArgs>>;
  offices_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['offices']>, "offices_by_pk", ParentType, ContextType, RequireFields<Subscription_RootOffices_By_PkArgs, 'id'>>;
  offices_stream?: SubscriptionResolver<Array<ResolversTypes['offices']>, "offices_stream", ParentType, ContextType, RequireFields<Subscription_RootOffices_StreamArgs, 'batch_size' | 'cursor'>>;
  releases?: SubscriptionResolver<Array<ResolversTypes['releases']>, "releases", ParentType, ContextType, Partial<Subscription_RootReleasesArgs>>;
  releases_aggregate?: SubscriptionResolver<ResolversTypes['releases_aggregate'], "releases_aggregate", ParentType, ContextType, Partial<Subscription_RootReleases_AggregateArgs>>;
  releases_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['releases']>, "releases_by_pk", ParentType, ContextType, RequireFields<Subscription_RootReleases_By_PkArgs, 'id'>>;
  releases_stream?: SubscriptionResolver<Array<ResolversTypes['releases']>, "releases_stream", ParentType, ContextType, RequireFields<Subscription_RootReleases_StreamArgs, 'batch_size' | 'cursor'>>;
  reminders?: SubscriptionResolver<Array<ResolversTypes['reminders']>, "reminders", ParentType, ContextType, Partial<Subscription_RootRemindersArgs>>;
  reminders_aggregate?: SubscriptionResolver<ResolversTypes['reminders_aggregate'], "reminders_aggregate", ParentType, ContextType, Partial<Subscription_RootReminders_AggregateArgs>>;
  reminders_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['reminders']>, "reminders_by_pk", ParentType, ContextType, RequireFields<Subscription_RootReminders_By_PkArgs, 'id'>>;
  reminders_stream?: SubscriptionResolver<Array<ResolversTypes['reminders']>, "reminders_stream", ParentType, ContextType, RequireFields<Subscription_RootReminders_StreamArgs, 'batch_size' | 'cursor'>>;
  sampleLabels?: SubscriptionResolver<Array<ResolversTypes['sampleLabels']>, "sampleLabels", ParentType, ContextType, Partial<Subscription_RootSampleLabelsArgs>>;
  sampleLabels_aggregate?: SubscriptionResolver<ResolversTypes['sampleLabels_aggregate'], "sampleLabels_aggregate", ParentType, ContextType, Partial<Subscription_RootSampleLabels_AggregateArgs>>;
  sampleLabels_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['sampleLabels']>, "sampleLabels_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSampleLabels_By_PkArgs, 'id'>>;
  sampleLabels_stream?: SubscriptionResolver<Array<ResolversTypes['sampleLabels']>, "sampleLabels_stream", ParentType, ContextType, RequireFields<Subscription_RootSampleLabels_StreamArgs, 'batch_size' | 'cursor'>>;
  sampleShipmentRequests?: SubscriptionResolver<Array<ResolversTypes['sampleShipmentRequests']>, "sampleShipmentRequests", ParentType, ContextType, Partial<Subscription_RootSampleShipmentRequestsArgs>>;
  sampleShipmentRequests_aggregate?: SubscriptionResolver<ResolversTypes['sampleShipmentRequests_aggregate'], "sampleShipmentRequests_aggregate", ParentType, ContextType, Partial<Subscription_RootSampleShipmentRequests_AggregateArgs>>;
  sampleShipmentRequests_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['sampleShipmentRequests']>, "sampleShipmentRequests_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSampleShipmentRequests_By_PkArgs, 'id'>>;
  sampleShipmentRequests_stream?: SubscriptionResolver<Array<ResolversTypes['sampleShipmentRequests']>, "sampleShipmentRequests_stream", ParentType, ContextType, RequireFields<Subscription_RootSampleShipmentRequests_StreamArgs, 'batch_size' | 'cursor'>>;
  sampleShipments?: SubscriptionResolver<Array<ResolversTypes['sampleShipments']>, "sampleShipments", ParentType, ContextType, Partial<Subscription_RootSampleShipmentsArgs>>;
  sampleShipments_aggregate?: SubscriptionResolver<ResolversTypes['sampleShipments_aggregate'], "sampleShipments_aggregate", ParentType, ContextType, Partial<Subscription_RootSampleShipments_AggregateArgs>>;
  sampleShipments_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['sampleShipments']>, "sampleShipments_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSampleShipments_By_PkArgs, 'id'>>;
  sampleShipments_stream?: SubscriptionResolver<Array<ResolversTypes['sampleShipments']>, "sampleShipments_stream", ParentType, ContextType, RequireFields<Subscription_RootSampleShipments_StreamArgs, 'batch_size' | 'cursor'>>;
  samples?: SubscriptionResolver<Array<ResolversTypes['samples']>, "samples", ParentType, ContextType, Partial<Subscription_RootSamplesArgs>>;
  samples_aggregate?: SubscriptionResolver<ResolversTypes['samples_aggregate'], "samples_aggregate", ParentType, ContextType, Partial<Subscription_RootSamples_AggregateArgs>>;
  samples_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['samples']>, "samples_by_pk", ParentType, ContextType, RequireFields<Subscription_RootSamples_By_PkArgs, 'id'>>;
  samples_stream?: SubscriptionResolver<Array<ResolversTypes['samples']>, "samples_stream", ParentType, ContextType, RequireFields<Subscription_RootSamples_StreamArgs, 'batch_size' | 'cursor'>>;
  shipmentFulfillments?: SubscriptionResolver<Array<ResolversTypes['shipmentFulfillments']>, "shipmentFulfillments", ParentType, ContextType, Partial<Subscription_RootShipmentFulfillmentsArgs>>;
  shipmentFulfillments_aggregate?: SubscriptionResolver<ResolversTypes['shipmentFulfillments_aggregate'], "shipmentFulfillments_aggregate", ParentType, ContextType, Partial<Subscription_RootShipmentFulfillments_AggregateArgs>>;
  shipmentFulfillments_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['shipmentFulfillments']>, "shipmentFulfillments_by_pk", ParentType, ContextType, RequireFields<Subscription_RootShipmentFulfillments_By_PkArgs, 'id'>>;
  shipmentFulfillments_stream?: SubscriptionResolver<Array<ResolversTypes['shipmentFulfillments']>, "shipmentFulfillments_stream", ParentType, ContextType, RequireFields<Subscription_RootShipmentFulfillments_StreamArgs, 'batch_size' | 'cursor'>>;
  trackings?: SubscriptionResolver<Array<ResolversTypes['trackings']>, "trackings", ParentType, ContextType, Partial<Subscription_RootTrackingsArgs>>;
  trackings_aggregate?: SubscriptionResolver<ResolversTypes['trackings_aggregate'], "trackings_aggregate", ParentType, ContextType, Partial<Subscription_RootTrackings_AggregateArgs>>;
  trackings_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['trackings']>, "trackings_by_pk", ParentType, ContextType, RequireFields<Subscription_RootTrackings_By_PkArgs, 'id'>>;
  trackings_stream?: SubscriptionResolver<Array<ResolversTypes['trackings']>, "trackings_stream", ParentType, ContextType, RequireFields<Subscription_RootTrackings_StreamArgs, 'batch_size' | 'cursor'>>;
  users?: SubscriptionResolver<Array<ResolversTypes['users']>, "users", ParentType, ContextType, Partial<Subscription_RootUsersArgs>>;
  usersBonus?: SubscriptionResolver<Array<ResolversTypes['usersBonus']>, "usersBonus", ParentType, ContextType, Partial<Subscription_RootUsersBonusArgs>>;
  usersBonus_aggregate?: SubscriptionResolver<ResolversTypes['usersBonus_aggregate'], "usersBonus_aggregate", ParentType, ContextType, Partial<Subscription_RootUsersBonus_AggregateArgs>>;
  usersBonus_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['usersBonus']>, "usersBonus_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUsersBonus_By_PkArgs, 'id'>>;
  usersBonus_stream?: SubscriptionResolver<Array<ResolversTypes['usersBonus']>, "usersBonus_stream", ParentType, ContextType, RequireFields<Subscription_RootUsersBonus_StreamArgs, 'batch_size' | 'cursor'>>;
  usersCosts?: SubscriptionResolver<Array<ResolversTypes['usersCosts']>, "usersCosts", ParentType, ContextType, Partial<Subscription_RootUsersCostsArgs>>;
  usersCosts_aggregate?: SubscriptionResolver<ResolversTypes['usersCosts_aggregate'], "usersCosts_aggregate", ParentType, ContextType, Partial<Subscription_RootUsersCosts_AggregateArgs>>;
  usersCosts_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['usersCosts']>, "usersCosts_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUsersCosts_By_PkArgs, 'id'>>;
  usersCosts_stream?: SubscriptionResolver<Array<ResolversTypes['usersCosts']>, "usersCosts_stream", ParentType, ContextType, RequireFields<Subscription_RootUsersCosts_StreamArgs, 'batch_size' | 'cursor'>>;
  users_aggregate?: SubscriptionResolver<ResolversTypes['users_aggregate'], "users_aggregate", ParentType, ContextType, Partial<Subscription_RootUsers_AggregateArgs>>;
  users_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['users']>, "users_by_pk", ParentType, ContextType, RequireFields<Subscription_RootUsers_By_PkArgs, 'id'>>;
  users_stream?: SubscriptionResolver<Array<ResolversTypes['users']>, "users_stream", ParentType, ContextType, RequireFields<Subscription_RootUsers_StreamArgs, 'batch_size' | 'cursor'>>;
  validationsContracts?: SubscriptionResolver<Array<ResolversTypes['validationsContracts']>, "validationsContracts", ParentType, ContextType, Partial<Subscription_RootValidationsContractsArgs>>;
  validationsContracts_aggregate?: SubscriptionResolver<ResolversTypes['validationsContracts_aggregate'], "validationsContracts_aggregate", ParentType, ContextType, Partial<Subscription_RootValidationsContracts_AggregateArgs>>;
  validationsContracts_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['validationsContracts']>, "validationsContracts_by_pk", ParentType, ContextType, RequireFields<Subscription_RootValidationsContracts_By_PkArgs, 'id'>>;
  validationsContracts_stream?: SubscriptionResolver<Array<ResolversTypes['validationsContracts']>, "validationsContracts_stream", ParentType, ContextType, RequireFields<Subscription_RootValidationsContracts_StreamArgs, 'batch_size' | 'cursor'>>;
  varietals?: SubscriptionResolver<Array<ResolversTypes['varietals']>, "varietals", ParentType, ContextType, Partial<Subscription_RootVarietalsArgs>>;
  varietals_aggregate?: SubscriptionResolver<ResolversTypes['varietals_aggregate'], "varietals_aggregate", ParentType, ContextType, Partial<Subscription_RootVarietals_AggregateArgs>>;
  varietals_by_pk?: SubscriptionResolver<Maybe<ResolversTypes['varietals']>, "varietals_by_pk", ParentType, ContextType, RequireFields<Subscription_RootVarietals_By_PkArgs, 'id'>>;
  varietals_stream?: SubscriptionResolver<Array<ResolversTypes['varietals']>, "varietals_stream", ParentType, ContextType, RequireFields<Subscription_RootVarietals_StreamArgs, 'batch_size' | 'cursor'>>;
};

export interface TimestampScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['timestamp'], any> {
  name: 'timestamp';
}

export interface TimestamptzScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['timestamptz'], any> {
  name: 'timestamptz';
}

export type TrackingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['trackings'] = ResolversParentTypes['trackings']> = {
  aftershipId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pickupDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  res?: Resolver<Maybe<ResolversTypes['jsonb']>, ParentType, ContextType, Partial<TrackingsResArgs>>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trackingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Trackings_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['trackings_aggregate'] = ResolversParentTypes['trackings_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['trackings_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['trackings']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Trackings_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['trackings_aggregate_fields'] = ResolversParentTypes['trackings_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['trackings_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Trackings_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['trackings_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['trackings_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['trackings_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['trackings_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['trackings_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['trackings_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['trackings_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['trackings_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['trackings_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Trackings_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['trackings_avg_fields'] = ResolversParentTypes['trackings_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Trackings_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['trackings_max_fields'] = ResolversParentTypes['trackings_max_fields']> = {
  aftershipId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pickupDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trackingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Trackings_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['trackings_min_fields'] = ResolversParentTypes['trackings_min_fields']> = {
  aftershipId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pickupDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  trackingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Trackings_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['trackings_mutation_response'] = ResolversParentTypes['trackings_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['trackings']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Trackings_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['trackings_stddev_fields'] = ResolversParentTypes['trackings_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Trackings_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['trackings_stddev_pop_fields'] = ResolversParentTypes['trackings_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Trackings_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['trackings_stddev_samp_fields'] = ResolversParentTypes['trackings_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Trackings_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['trackings_sum_fields'] = ResolversParentTypes['trackings_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Trackings_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['trackings_var_pop_fields'] = ResolversParentTypes['trackings_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Trackings_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['trackings_var_samp_fields'] = ResolversParentTypes['trackings_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Trackings_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['trackings_variance_fields'] = ResolversParentTypes['trackings_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersResolvers<ContextType = any, ParentType extends ResolversParentTypes['users'] = ResolversParentTypes['users']> = {
  authorizedDomainId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contact?: Resolver<Maybe<ResolversTypes['contacts']>, ParentType, ContextType>;
  contactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  firstname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isManager?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  language?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastReleasesViewDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  lastname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  savedColumns?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType, Partial<UsersSavedColumnsArgs>>;
  savedFormFields?: Resolver<ResolversTypes['jsonb'], ParentType, ContextType, Partial<UsersSavedFormFieldsArgs>>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  usersBonus?: Resolver<Array<ResolversTypes['usersBonus']>, ParentType, ContextType, Partial<UsersUsersBonusArgs>>;
  usersBonus_aggregate?: Resolver<ResolversTypes['usersBonus_aggregate'], ParentType, ContextType, Partial<UsersUsersBonus_AggregateArgs>>;
  usersCosts?: Resolver<Array<ResolversTypes['usersCosts']>, ParentType, ContextType, Partial<UsersUsersCostsArgs>>;
  usersCosts_aggregate?: Resolver<ResolversTypes['usersCosts_aggregate'], ParentType, ContextType, Partial<UsersUsersCosts_AggregateArgs>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersBonusResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersBonus'] = ResolversParentTypes['usersBonus']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['users'], ParentType, ContextType>;
  usersId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersBonus_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersBonus_aggregate'] = ResolversParentTypes['usersBonus_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['usersBonus_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['usersBonus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersBonus_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersBonus_aggregate_fields'] = ResolversParentTypes['usersBonus_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['usersBonus_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<UsersBonus_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['usersBonus_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['usersBonus_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['usersBonus_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['usersBonus_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['usersBonus_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['usersBonus_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['usersBonus_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['usersBonus_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['usersBonus_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersBonus_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersBonus_avg_fields'] = ResolversParentTypes['usersBonus_avg_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersBonus_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersBonus_max_fields'] = ResolversParentTypes['usersBonus_max_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  usersId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersBonus_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersBonus_min_fields'] = ResolversParentTypes['usersBonus_min_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  usersId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersBonus_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersBonus_mutation_response'] = ResolversParentTypes['usersBonus_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['usersBonus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersBonus_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersBonus_stddev_fields'] = ResolversParentTypes['usersBonus_stddev_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersBonus_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersBonus_stddev_pop_fields'] = ResolversParentTypes['usersBonus_stddev_pop_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersBonus_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersBonus_stddev_samp_fields'] = ResolversParentTypes['usersBonus_stddev_samp_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersBonus_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersBonus_sum_fields'] = ResolversParentTypes['usersBonus_sum_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersBonus_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersBonus_var_pop_fields'] = ResolversParentTypes['usersBonus_var_pop_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersBonus_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersBonus_var_samp_fields'] = ResolversParentTypes['usersBonus_var_samp_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersBonus_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersBonus_variance_fields'] = ResolversParentTypes['usersBonus_variance_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersCostsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersCosts'] = ResolversParentTypes['usersCosts']> = {
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  month?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['users'], ParentType, ContextType>;
  usersId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersCosts_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersCosts_aggregate'] = ResolversParentTypes['usersCosts_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['usersCosts_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['usersCosts']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersCosts_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersCosts_aggregate_fields'] = ResolversParentTypes['usersCosts_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['usersCosts_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<UsersCosts_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['usersCosts_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['usersCosts_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['usersCosts_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['usersCosts_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['usersCosts_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['usersCosts_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['usersCosts_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['usersCosts_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['usersCosts_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersCosts_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersCosts_avg_fields'] = ResolversParentTypes['usersCosts_avg_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersCosts_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersCosts_max_fields'] = ResolversParentTypes['usersCosts_max_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  usersId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersCosts_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersCosts_min_fields'] = ResolversParentTypes['usersCosts_min_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  usersId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersCosts_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersCosts_mutation_response'] = ResolversParentTypes['usersCosts_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['usersCosts']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersCosts_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersCosts_stddev_fields'] = ResolversParentTypes['usersCosts_stddev_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersCosts_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersCosts_stddev_pop_fields'] = ResolversParentTypes['usersCosts_stddev_pop_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersCosts_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersCosts_stddev_samp_fields'] = ResolversParentTypes['usersCosts_stddev_samp_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersCosts_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersCosts_sum_fields'] = ResolversParentTypes['usersCosts_sum_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersCosts_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersCosts_var_pop_fields'] = ResolversParentTypes['usersCosts_var_pop_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersCosts_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersCosts_var_samp_fields'] = ResolversParentTypes['usersCosts_var_samp_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsersCosts_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['usersCosts_variance_fields'] = ResolversParentTypes['usersCosts_variance_fields']> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  month?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  year?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_aggregate'] = ResolversParentTypes['users_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['users_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['users']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_aggregate_fields'] = ResolversParentTypes['users_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['users_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Users_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['users_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['users_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['users_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['users_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['users_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['users_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['users_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['users_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['users_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_avg_fields'] = ResolversParentTypes['users_avg_fields']> = {
  authorizedDomainId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_max_fields'] = ResolversParentTypes['users_max_fields']> = {
  authorizedDomainId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  language?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastReleasesViewDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_min_fields'] = ResolversParentTypes['users_min_fields']> = {
  authorizedDomainId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  firstname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  language?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastReleasesViewDate?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  lastname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_mutation_response'] = ResolversParentTypes['users_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['users']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_stddev_fields'] = ResolversParentTypes['users_stddev_fields']> = {
  authorizedDomainId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_stddev_pop_fields'] = ResolversParentTypes['users_stddev_pop_fields']> = {
  authorizedDomainId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_stddev_samp_fields'] = ResolversParentTypes['users_stddev_samp_fields']> = {
  authorizedDomainId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_sum_fields'] = ResolversParentTypes['users_sum_fields']> = {
  authorizedDomainId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_var_pop_fields'] = ResolversParentTypes['users_var_pop_fields']> = {
  authorizedDomainId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_var_samp_fields'] = ResolversParentTypes['users_var_samp_fields']> = {
  authorizedDomainId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Users_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['users_variance_fields'] = ResolversParentTypes['users_variance_fields']> = {
  authorizedDomainId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  officeId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationsContractsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationsContracts'] = ResolversParentTypes['validationsContracts']> = {
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<ResolversTypes['companies'], ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  contract?: Resolver<ResolversTypes['contracts'], ParentType, ContextType>;
  contractId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  signatoryContact?: Resolver<ResolversTypes['contacts'], ParentType, ContextType>;
  signatoryContactId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationsContracts_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationsContracts_aggregate'] = ResolversParentTypes['validationsContracts_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['validationsContracts_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['validationsContracts']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationsContracts_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationsContracts_aggregate_fields'] = ResolversParentTypes['validationsContracts_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['validationsContracts_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<ValidationsContracts_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['validationsContracts_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['validationsContracts_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['validationsContracts_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['validationsContracts_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['validationsContracts_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['validationsContracts_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['validationsContracts_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['validationsContracts_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['validationsContracts_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationsContracts_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationsContracts_avg_fields'] = ResolversParentTypes['validationsContracts_avg_fields']> = {
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contractId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  signatoryContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationsContracts_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationsContracts_max_fields'] = ResolversParentTypes['validationsContracts_max_fields']> = {
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contractId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  signatoryContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationsContracts_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationsContracts_min_fields'] = ResolversParentTypes['validationsContracts_min_fields']> = {
  comments?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contractId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  signatoryContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationsContracts_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationsContracts_mutation_response'] = ResolversParentTypes['validationsContracts_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['validationsContracts']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationsContracts_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationsContracts_stddev_fields'] = ResolversParentTypes['validationsContracts_stddev_fields']> = {
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contractId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  signatoryContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationsContracts_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationsContracts_stddev_pop_fields'] = ResolversParentTypes['validationsContracts_stddev_pop_fields']> = {
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contractId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  signatoryContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationsContracts_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationsContracts_stddev_samp_fields'] = ResolversParentTypes['validationsContracts_stddev_samp_fields']> = {
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contractId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  signatoryContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationsContracts_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationsContracts_sum_fields'] = ResolversParentTypes['validationsContracts_sum_fields']> = {
  companyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  contractId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  signatoryContactId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationsContracts_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationsContracts_var_pop_fields'] = ResolversParentTypes['validationsContracts_var_pop_fields']> = {
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contractId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  signatoryContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationsContracts_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationsContracts_var_samp_fields'] = ResolversParentTypes['validationsContracts_var_samp_fields']> = {
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contractId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  signatoryContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidationsContracts_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['validationsContracts_variance_fields'] = ResolversParentTypes['validationsContracts_variance_fields']> = {
  companyId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  contractId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  signatoryContactId?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VarietalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['varietals'] = ResolversParentTypes['varietals']> = {
  createdAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  embedding?: Resolver<Maybe<ResolversTypes['vector']>, ParentType, ContextType>;
  generic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subGeneric?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['timestamptz'], ParentType, ContextType>;
  varietal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vectorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Varietals_AggregateResolvers<ContextType = any, ParentType extends ResolversParentTypes['varietals_aggregate'] = ResolversParentTypes['varietals_aggregate']> = {
  aggregate?: Resolver<Maybe<ResolversTypes['varietals_aggregate_fields']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['varietals']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Varietals_Aggregate_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['varietals_aggregate_fields'] = ResolversParentTypes['varietals_aggregate_fields']> = {
  avg?: Resolver<Maybe<ResolversTypes['varietals_avg_fields']>, ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType, Partial<Varietals_Aggregate_FieldsCountArgs>>;
  max?: Resolver<Maybe<ResolversTypes['varietals_max_fields']>, ParentType, ContextType>;
  min?: Resolver<Maybe<ResolversTypes['varietals_min_fields']>, ParentType, ContextType>;
  stddev?: Resolver<Maybe<ResolversTypes['varietals_stddev_fields']>, ParentType, ContextType>;
  stddev_pop?: Resolver<Maybe<ResolversTypes['varietals_stddev_pop_fields']>, ParentType, ContextType>;
  stddev_samp?: Resolver<Maybe<ResolversTypes['varietals_stddev_samp_fields']>, ParentType, ContextType>;
  sum?: Resolver<Maybe<ResolversTypes['varietals_sum_fields']>, ParentType, ContextType>;
  var_pop?: Resolver<Maybe<ResolversTypes['varietals_var_pop_fields']>, ParentType, ContextType>;
  var_samp?: Resolver<Maybe<ResolversTypes['varietals_var_samp_fields']>, ParentType, ContextType>;
  variance?: Resolver<Maybe<ResolversTypes['varietals_variance_fields']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Varietals_Avg_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['varietals_avg_fields'] = ResolversParentTypes['varietals_avg_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Varietals_Max_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['varietals_max_fields'] = ResolversParentTypes['varietals_max_fields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  generic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subGeneric?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  varietal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vectorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Varietals_Min_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['varietals_min_fields'] = ResolversParentTypes['varietals_min_fields']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  generic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subGeneric?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['timestamptz']>, ParentType, ContextType>;
  varietal?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vectorText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Varietals_Mutation_ResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['varietals_mutation_response'] = ResolversParentTypes['varietals_mutation_response']> = {
  affected_rows?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returning?: Resolver<Array<ResolversTypes['varietals']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Varietals_Stddev_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['varietals_stddev_fields'] = ResolversParentTypes['varietals_stddev_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Varietals_Stddev_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['varietals_stddev_pop_fields'] = ResolversParentTypes['varietals_stddev_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Varietals_Stddev_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['varietals_stddev_samp_fields'] = ResolversParentTypes['varietals_stddev_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Varietals_Sum_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['varietals_sum_fields'] = ResolversParentTypes['varietals_sum_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Varietals_Var_Pop_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['varietals_var_pop_fields'] = ResolversParentTypes['varietals_var_pop_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Varietals_Var_Samp_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['varietals_var_samp_fields'] = ResolversParentTypes['varietals_var_samp_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Varietals_Variance_FieldsResolvers<ContextType = any, ParentType extends ResolversParentTypes['varietals_variance_fields'] = ResolversParentTypes['varietals_variance_fields']> = {
  id?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface VectorScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['vector'], any> {
  name: 'vector';
}

export type Resolvers<ContextType = any> = {
  addresses?: AddressesResolvers<ContextType>;
  addresses_aggregate?: Addresses_AggregateResolvers<ContextType>;
  addresses_aggregate_fields?: Addresses_Aggregate_FieldsResolvers<ContextType>;
  addresses_avg_fields?: Addresses_Avg_FieldsResolvers<ContextType>;
  addresses_max_fields?: Addresses_Max_FieldsResolvers<ContextType>;
  addresses_min_fields?: Addresses_Min_FieldsResolvers<ContextType>;
  addresses_mutation_response?: Addresses_Mutation_ResponseResolvers<ContextType>;
  addresses_stddev_fields?: Addresses_Stddev_FieldsResolvers<ContextType>;
  addresses_stddev_pop_fields?: Addresses_Stddev_Pop_FieldsResolvers<ContextType>;
  addresses_stddev_samp_fields?: Addresses_Stddev_Samp_FieldsResolvers<ContextType>;
  addresses_sum_fields?: Addresses_Sum_FieldsResolvers<ContextType>;
  addresses_var_pop_fields?: Addresses_Var_Pop_FieldsResolvers<ContextType>;
  addresses_var_samp_fields?: Addresses_Var_Samp_FieldsResolvers<ContextType>;
  addresses_variance_fields?: Addresses_Variance_FieldsResolvers<ContextType>;
  addresses_without_company?: Addresses_Without_CompanyResolvers<ContextType>;
  addresses_without_company_aggregate?: Addresses_Without_Company_AggregateResolvers<ContextType>;
  addresses_without_company_aggregate_fields?: Addresses_Without_Company_Aggregate_FieldsResolvers<ContextType>;
  addresses_without_company_avg_fields?: Addresses_Without_Company_Avg_FieldsResolvers<ContextType>;
  addresses_without_company_max_fields?: Addresses_Without_Company_Max_FieldsResolvers<ContextType>;
  addresses_without_company_min_fields?: Addresses_Without_Company_Min_FieldsResolvers<ContextType>;
  addresses_without_company_stddev_fields?: Addresses_Without_Company_Stddev_FieldsResolvers<ContextType>;
  addresses_without_company_stddev_pop_fields?: Addresses_Without_Company_Stddev_Pop_FieldsResolvers<ContextType>;
  addresses_without_company_stddev_samp_fields?: Addresses_Without_Company_Stddev_Samp_FieldsResolvers<ContextType>;
  addresses_without_company_sum_fields?: Addresses_Without_Company_Sum_FieldsResolvers<ContextType>;
  addresses_without_company_var_pop_fields?: Addresses_Without_Company_Var_Pop_FieldsResolvers<ContextType>;
  addresses_without_company_var_samp_fields?: Addresses_Without_Company_Var_Samp_FieldsResolvers<ContextType>;
  addresses_without_company_variance_fields?: Addresses_Without_Company_Variance_FieldsResolvers<ContextType>;
  agreementTerms?: AgreementTermsResolvers<ContextType>;
  agreementTerms_aggregate?: AgreementTerms_AggregateResolvers<ContextType>;
  agreementTerms_aggregate_fields?: AgreementTerms_Aggregate_FieldsResolvers<ContextType>;
  agreementTerms_avg_fields?: AgreementTerms_Avg_FieldsResolvers<ContextType>;
  agreementTerms_max_fields?: AgreementTerms_Max_FieldsResolvers<ContextType>;
  agreementTerms_min_fields?: AgreementTerms_Min_FieldsResolvers<ContextType>;
  agreementTerms_mutation_response?: AgreementTerms_Mutation_ResponseResolvers<ContextType>;
  agreementTerms_stddev_fields?: AgreementTerms_Stddev_FieldsResolvers<ContextType>;
  agreementTerms_stddev_pop_fields?: AgreementTerms_Stddev_Pop_FieldsResolvers<ContextType>;
  agreementTerms_stddev_samp_fields?: AgreementTerms_Stddev_Samp_FieldsResolvers<ContextType>;
  agreementTerms_sum_fields?: AgreementTerms_Sum_FieldsResolvers<ContextType>;
  agreementTerms_var_pop_fields?: AgreementTerms_Var_Pop_FieldsResolvers<ContextType>;
  agreementTerms_var_samp_fields?: AgreementTerms_Var_Samp_FieldsResolvers<ContextType>;
  agreementTerms_variance_fields?: AgreementTerms_Variance_FieldsResolvers<ContextType>;
  agreements?: AgreementsResolvers<ContextType>;
  agreements_aggregate?: Agreements_AggregateResolvers<ContextType>;
  agreements_aggregate_fields?: Agreements_Aggregate_FieldsResolvers<ContextType>;
  agreements_avg_fields?: Agreements_Avg_FieldsResolvers<ContextType>;
  agreements_max_fields?: Agreements_Max_FieldsResolvers<ContextType>;
  agreements_min_fields?: Agreements_Min_FieldsResolvers<ContextType>;
  agreements_mutation_response?: Agreements_Mutation_ResponseResolvers<ContextType>;
  agreements_stddev_fields?: Agreements_Stddev_FieldsResolvers<ContextType>;
  agreements_stddev_pop_fields?: Agreements_Stddev_Pop_FieldsResolvers<ContextType>;
  agreements_stddev_samp_fields?: Agreements_Stddev_Samp_FieldsResolvers<ContextType>;
  agreements_sum_fields?: Agreements_Sum_FieldsResolvers<ContextType>;
  agreements_var_pop_fields?: Agreements_Var_Pop_FieldsResolvers<ContextType>;
  agreements_var_samp_fields?: Agreements_Var_Samp_FieldsResolvers<ContextType>;
  agreements_variance_fields?: Agreements_Variance_FieldsResolvers<ContextType>;
  appellations?: AppellationsResolvers<ContextType>;
  appellations_aggregate?: Appellations_AggregateResolvers<ContextType>;
  appellations_aggregate_fields?: Appellations_Aggregate_FieldsResolvers<ContextType>;
  appellations_avg_fields?: Appellations_Avg_FieldsResolvers<ContextType>;
  appellations_max_fields?: Appellations_Max_FieldsResolvers<ContextType>;
  appellations_min_fields?: Appellations_Min_FieldsResolvers<ContextType>;
  appellations_mutation_response?: Appellations_Mutation_ResponseResolvers<ContextType>;
  appellations_stddev_fields?: Appellations_Stddev_FieldsResolvers<ContextType>;
  appellations_stddev_pop_fields?: Appellations_Stddev_Pop_FieldsResolvers<ContextType>;
  appellations_stddev_samp_fields?: Appellations_Stddev_Samp_FieldsResolvers<ContextType>;
  appellations_sum_fields?: Appellations_Sum_FieldsResolvers<ContextType>;
  appellations_var_pop_fields?: Appellations_Var_Pop_FieldsResolvers<ContextType>;
  appellations_var_samp_fields?: Appellations_Var_Samp_FieldsResolvers<ContextType>;
  appellations_variance_fields?: Appellations_Variance_FieldsResolvers<ContextType>;
  authorizedDomains?: AuthorizedDomainsResolvers<ContextType>;
  authorizedDomains_aggregate?: AuthorizedDomains_AggregateResolvers<ContextType>;
  authorizedDomains_aggregate_fields?: AuthorizedDomains_Aggregate_FieldsResolvers<ContextType>;
  authorizedDomains_avg_fields?: AuthorizedDomains_Avg_FieldsResolvers<ContextType>;
  authorizedDomains_max_fields?: AuthorizedDomains_Max_FieldsResolvers<ContextType>;
  authorizedDomains_min_fields?: AuthorizedDomains_Min_FieldsResolvers<ContextType>;
  authorizedDomains_mutation_response?: AuthorizedDomains_Mutation_ResponseResolvers<ContextType>;
  authorizedDomains_stddev_fields?: AuthorizedDomains_Stddev_FieldsResolvers<ContextType>;
  authorizedDomains_stddev_pop_fields?: AuthorizedDomains_Stddev_Pop_FieldsResolvers<ContextType>;
  authorizedDomains_stddev_samp_fields?: AuthorizedDomains_Stddev_Samp_FieldsResolvers<ContextType>;
  authorizedDomains_sum_fields?: AuthorizedDomains_Sum_FieldsResolvers<ContextType>;
  authorizedDomains_var_pop_fields?: AuthorizedDomains_Var_Pop_FieldsResolvers<ContextType>;
  authorizedDomains_var_samp_fields?: AuthorizedDomains_Var_Samp_FieldsResolvers<ContextType>;
  authorizedDomains_variance_fields?: AuthorizedDomains_Variance_FieldsResolvers<ContextType>;
  buySpecs?: BuySpecsResolvers<ContextType>;
  buySpecs_aggregate?: BuySpecs_AggregateResolvers<ContextType>;
  buySpecs_aggregate_fields?: BuySpecs_Aggregate_FieldsResolvers<ContextType>;
  buySpecs_avg_fields?: BuySpecs_Avg_FieldsResolvers<ContextType>;
  buySpecs_max_fields?: BuySpecs_Max_FieldsResolvers<ContextType>;
  buySpecs_min_fields?: BuySpecs_Min_FieldsResolvers<ContextType>;
  buySpecs_mutation_response?: BuySpecs_Mutation_ResponseResolvers<ContextType>;
  buySpecs_stddev_fields?: BuySpecs_Stddev_FieldsResolvers<ContextType>;
  buySpecs_stddev_pop_fields?: BuySpecs_Stddev_Pop_FieldsResolvers<ContextType>;
  buySpecs_stddev_samp_fields?: BuySpecs_Stddev_Samp_FieldsResolvers<ContextType>;
  buySpecs_sum_fields?: BuySpecs_Sum_FieldsResolvers<ContextType>;
  buySpecs_var_pop_fields?: BuySpecs_Var_Pop_FieldsResolvers<ContextType>;
  buySpecs_var_samp_fields?: BuySpecs_Var_Samp_FieldsResolvers<ContextType>;
  buySpecs_variance_fields?: BuySpecs_Variance_FieldsResolvers<ContextType>;
  companies?: CompaniesResolvers<ContextType>;
  companies_aggregate?: Companies_AggregateResolvers<ContextType>;
  companies_aggregate_fields?: Companies_Aggregate_FieldsResolvers<ContextType>;
  companies_avg_fields?: Companies_Avg_FieldsResolvers<ContextType>;
  companies_max_fields?: Companies_Max_FieldsResolvers<ContextType>;
  companies_min_fields?: Companies_Min_FieldsResolvers<ContextType>;
  companies_mutation_response?: Companies_Mutation_ResponseResolvers<ContextType>;
  companies_stddev_fields?: Companies_Stddev_FieldsResolvers<ContextType>;
  companies_stddev_pop_fields?: Companies_Stddev_Pop_FieldsResolvers<ContextType>;
  companies_stddev_samp_fields?: Companies_Stddev_Samp_FieldsResolvers<ContextType>;
  companies_sum_fields?: Companies_Sum_FieldsResolvers<ContextType>;
  companies_var_pop_fields?: Companies_Var_Pop_FieldsResolvers<ContextType>;
  companies_var_samp_fields?: Companies_Var_Samp_FieldsResolvers<ContextType>;
  companies_variance_fields?: Companies_Variance_FieldsResolvers<ContextType>;
  companyAddress?: CompanyAddressResolvers<ContextType>;
  companyAddress_aggregate?: CompanyAddress_AggregateResolvers<ContextType>;
  companyAddress_aggregate_fields?: CompanyAddress_Aggregate_FieldsResolvers<ContextType>;
  companyAddress_avg_fields?: CompanyAddress_Avg_FieldsResolvers<ContextType>;
  companyAddress_max_fields?: CompanyAddress_Max_FieldsResolvers<ContextType>;
  companyAddress_min_fields?: CompanyAddress_Min_FieldsResolvers<ContextType>;
  companyAddress_mutation_response?: CompanyAddress_Mutation_ResponseResolvers<ContextType>;
  companyAddress_stddev_fields?: CompanyAddress_Stddev_FieldsResolvers<ContextType>;
  companyAddress_stddev_pop_fields?: CompanyAddress_Stddev_Pop_FieldsResolvers<ContextType>;
  companyAddress_stddev_samp_fields?: CompanyAddress_Stddev_Samp_FieldsResolvers<ContextType>;
  companyAddress_sum_fields?: CompanyAddress_Sum_FieldsResolvers<ContextType>;
  companyAddress_var_pop_fields?: CompanyAddress_Var_Pop_FieldsResolvers<ContextType>;
  companyAddress_var_samp_fields?: CompanyAddress_Var_Samp_FieldsResolvers<ContextType>;
  companyAddress_variance_fields?: CompanyAddress_Variance_FieldsResolvers<ContextType>;
  contacts?: ContactsResolvers<ContextType>;
  contacts_aggregate?: Contacts_AggregateResolvers<ContextType>;
  contacts_aggregate_fields?: Contacts_Aggregate_FieldsResolvers<ContextType>;
  contacts_avg_fields?: Contacts_Avg_FieldsResolvers<ContextType>;
  contacts_max_fields?: Contacts_Max_FieldsResolvers<ContextType>;
  contacts_min_fields?: Contacts_Min_FieldsResolvers<ContextType>;
  contacts_mutation_response?: Contacts_Mutation_ResponseResolvers<ContextType>;
  contacts_stddev_fields?: Contacts_Stddev_FieldsResolvers<ContextType>;
  contacts_stddev_pop_fields?: Contacts_Stddev_Pop_FieldsResolvers<ContextType>;
  contacts_stddev_samp_fields?: Contacts_Stddev_Samp_FieldsResolvers<ContextType>;
  contacts_sum_fields?: Contacts_Sum_FieldsResolvers<ContextType>;
  contacts_var_pop_fields?: Contacts_Var_Pop_FieldsResolvers<ContextType>;
  contacts_var_samp_fields?: Contacts_Var_Samp_FieldsResolvers<ContextType>;
  contacts_variance_fields?: Contacts_Variance_FieldsResolvers<ContextType>;
  contacts_without_company?: Contacts_Without_CompanyResolvers<ContextType>;
  contacts_without_company_aggregate?: Contacts_Without_Company_AggregateResolvers<ContextType>;
  contacts_without_company_aggregate_fields?: Contacts_Without_Company_Aggregate_FieldsResolvers<ContextType>;
  contacts_without_company_avg_fields?: Contacts_Without_Company_Avg_FieldsResolvers<ContextType>;
  contacts_without_company_max_fields?: Contacts_Without_Company_Max_FieldsResolvers<ContextType>;
  contacts_without_company_min_fields?: Contacts_Without_Company_Min_FieldsResolvers<ContextType>;
  contacts_without_company_stddev_fields?: Contacts_Without_Company_Stddev_FieldsResolvers<ContextType>;
  contacts_without_company_stddev_pop_fields?: Contacts_Without_Company_Stddev_Pop_FieldsResolvers<ContextType>;
  contacts_without_company_stddev_samp_fields?: Contacts_Without_Company_Stddev_Samp_FieldsResolvers<ContextType>;
  contacts_without_company_sum_fields?: Contacts_Without_Company_Sum_FieldsResolvers<ContextType>;
  contacts_without_company_var_pop_fields?: Contacts_Without_Company_Var_Pop_FieldsResolvers<ContextType>;
  contacts_without_company_var_samp_fields?: Contacts_Without_Company_Var_Samp_FieldsResolvers<ContextType>;
  contacts_without_company_variance_fields?: Contacts_Without_Company_Variance_FieldsResolvers<ContextType>;
  contracts?: ContractsResolvers<ContextType>;
  contracts_aggregate?: Contracts_AggregateResolvers<ContextType>;
  contracts_aggregate_fields?: Contracts_Aggregate_FieldsResolvers<ContextType>;
  contracts_avg_fields?: Contracts_Avg_FieldsResolvers<ContextType>;
  contracts_max_fields?: Contracts_Max_FieldsResolvers<ContextType>;
  contracts_min_fields?: Contracts_Min_FieldsResolvers<ContextType>;
  contracts_mutation_response?: Contracts_Mutation_ResponseResolvers<ContextType>;
  contracts_stddev_fields?: Contracts_Stddev_FieldsResolvers<ContextType>;
  contracts_stddev_pop_fields?: Contracts_Stddev_Pop_FieldsResolvers<ContextType>;
  contracts_stddev_samp_fields?: Contracts_Stddev_Samp_FieldsResolvers<ContextType>;
  contracts_sum_fields?: Contracts_Sum_FieldsResolvers<ContextType>;
  contracts_var_pop_fields?: Contracts_Var_Pop_FieldsResolvers<ContextType>;
  contracts_var_samp_fields?: Contracts_Var_Samp_FieldsResolvers<ContextType>;
  contracts_variance_fields?: Contracts_Variance_FieldsResolvers<ContextType>;
  currenciesConversions?: CurrenciesConversionsResolvers<ContextType>;
  currenciesConversions_aggregate?: CurrenciesConversions_AggregateResolvers<ContextType>;
  currenciesConversions_aggregate_fields?: CurrenciesConversions_Aggregate_FieldsResolvers<ContextType>;
  currenciesConversions_avg_fields?: CurrenciesConversions_Avg_FieldsResolvers<ContextType>;
  currenciesConversions_max_fields?: CurrenciesConversions_Max_FieldsResolvers<ContextType>;
  currenciesConversions_min_fields?: CurrenciesConversions_Min_FieldsResolvers<ContextType>;
  currenciesConversions_mutation_response?: CurrenciesConversions_Mutation_ResponseResolvers<ContextType>;
  currenciesConversions_stddev_fields?: CurrenciesConversions_Stddev_FieldsResolvers<ContextType>;
  currenciesConversions_stddev_pop_fields?: CurrenciesConversions_Stddev_Pop_FieldsResolvers<ContextType>;
  currenciesConversions_stddev_samp_fields?: CurrenciesConversions_Stddev_Samp_FieldsResolvers<ContextType>;
  currenciesConversions_sum_fields?: CurrenciesConversions_Sum_FieldsResolvers<ContextType>;
  currenciesConversions_var_pop_fields?: CurrenciesConversions_Var_Pop_FieldsResolvers<ContextType>;
  currenciesConversions_var_samp_fields?: CurrenciesConversions_Var_Samp_FieldsResolvers<ContextType>;
  currenciesConversions_variance_fields?: CurrenciesConversions_Variance_FieldsResolvers<ContextType>;
  date?: GraphQLScalarType;
  history?: HistoryResolvers<ContextType>;
  history_aggregate?: History_AggregateResolvers<ContextType>;
  history_aggregate_fields?: History_Aggregate_FieldsResolvers<ContextType>;
  history_avg_fields?: History_Avg_FieldsResolvers<ContextType>;
  history_max_fields?: History_Max_FieldsResolvers<ContextType>;
  history_min_fields?: History_Min_FieldsResolvers<ContextType>;
  history_mutation_response?: History_Mutation_ResponseResolvers<ContextType>;
  history_stddev_fields?: History_Stddev_FieldsResolvers<ContextType>;
  history_stddev_pop_fields?: History_Stddev_Pop_FieldsResolvers<ContextType>;
  history_stddev_samp_fields?: History_Stddev_Samp_FieldsResolvers<ContextType>;
  history_sum_fields?: History_Sum_FieldsResolvers<ContextType>;
  history_var_pop_fields?: History_Var_Pop_FieldsResolvers<ContextType>;
  history_var_samp_fields?: History_Var_Samp_FieldsResolvers<ContextType>;
  history_variance_fields?: History_Variance_FieldsResolvers<ContextType>;
  invoices?: InvoicesResolvers<ContextType>;
  invoices_aggregate?: Invoices_AggregateResolvers<ContextType>;
  invoices_aggregate_fields?: Invoices_Aggregate_FieldsResolvers<ContextType>;
  invoices_avg_fields?: Invoices_Avg_FieldsResolvers<ContextType>;
  invoices_max_fields?: Invoices_Max_FieldsResolvers<ContextType>;
  invoices_min_fields?: Invoices_Min_FieldsResolvers<ContextType>;
  invoices_mutation_response?: Invoices_Mutation_ResponseResolvers<ContextType>;
  invoices_stddev_fields?: Invoices_Stddev_FieldsResolvers<ContextType>;
  invoices_stddev_pop_fields?: Invoices_Stddev_Pop_FieldsResolvers<ContextType>;
  invoices_stddev_samp_fields?: Invoices_Stddev_Samp_FieldsResolvers<ContextType>;
  invoices_sum_fields?: Invoices_Sum_FieldsResolvers<ContextType>;
  invoices_var_pop_fields?: Invoices_Var_Pop_FieldsResolvers<ContextType>;
  invoices_var_samp_fields?: Invoices_Var_Samp_FieldsResolvers<ContextType>;
  invoices_variance_fields?: Invoices_Variance_FieldsResolvers<ContextType>;
  items?: ItemsResolvers<ContextType>;
  items_aggregate?: Items_AggregateResolvers<ContextType>;
  items_aggregate_fields?: Items_Aggregate_FieldsResolvers<ContextType>;
  items_avg_fields?: Items_Avg_FieldsResolvers<ContextType>;
  items_max_fields?: Items_Max_FieldsResolvers<ContextType>;
  items_min_fields?: Items_Min_FieldsResolvers<ContextType>;
  items_mutation_response?: Items_Mutation_ResponseResolvers<ContextType>;
  items_stddev_fields?: Items_Stddev_FieldsResolvers<ContextType>;
  items_stddev_pop_fields?: Items_Stddev_Pop_FieldsResolvers<ContextType>;
  items_stddev_samp_fields?: Items_Stddev_Samp_FieldsResolvers<ContextType>;
  items_sum_fields?: Items_Sum_FieldsResolvers<ContextType>;
  items_var_pop_fields?: Items_Var_Pop_FieldsResolvers<ContextType>;
  items_var_samp_fields?: Items_Var_Samp_FieldsResolvers<ContextType>;
  items_variance_fields?: Items_Variance_FieldsResolvers<ContextType>;
  jsonb?: GraphQLScalarType;
  logs?: LogsResolvers<ContextType>;
  logs_aggregate?: Logs_AggregateResolvers<ContextType>;
  logs_aggregate_fields?: Logs_Aggregate_FieldsResolvers<ContextType>;
  logs_avg_fields?: Logs_Avg_FieldsResolvers<ContextType>;
  logs_max_fields?: Logs_Max_FieldsResolvers<ContextType>;
  logs_min_fields?: Logs_Min_FieldsResolvers<ContextType>;
  logs_mutation_response?: Logs_Mutation_ResponseResolvers<ContextType>;
  logs_stddev_fields?: Logs_Stddev_FieldsResolvers<ContextType>;
  logs_stddev_pop_fields?: Logs_Stddev_Pop_FieldsResolvers<ContextType>;
  logs_stddev_samp_fields?: Logs_Stddev_Samp_FieldsResolvers<ContextType>;
  logs_sum_fields?: Logs_Sum_FieldsResolvers<ContextType>;
  logs_var_pop_fields?: Logs_Var_Pop_FieldsResolvers<ContextType>;
  logs_var_samp_fields?: Logs_Var_Samp_FieldsResolvers<ContextType>;
  logs_variance_fields?: Logs_Variance_FieldsResolvers<ContextType>;
  matchingItemsBuySpecs?: MatchingItemsBuySpecsResolvers<ContextType>;
  matchingItemsBuySpecs_aggregate?: MatchingItemsBuySpecs_AggregateResolvers<ContextType>;
  matchingItemsBuySpecs_aggregate_fields?: MatchingItemsBuySpecs_Aggregate_FieldsResolvers<ContextType>;
  matchingItemsBuySpecs_avg_fields?: MatchingItemsBuySpecs_Avg_FieldsResolvers<ContextType>;
  matchingItemsBuySpecs_max_fields?: MatchingItemsBuySpecs_Max_FieldsResolvers<ContextType>;
  matchingItemsBuySpecs_min_fields?: MatchingItemsBuySpecs_Min_FieldsResolvers<ContextType>;
  matchingItemsBuySpecs_mutation_response?: MatchingItemsBuySpecs_Mutation_ResponseResolvers<ContextType>;
  matchingItemsBuySpecs_stddev_fields?: MatchingItemsBuySpecs_Stddev_FieldsResolvers<ContextType>;
  matchingItemsBuySpecs_stddev_pop_fields?: MatchingItemsBuySpecs_Stddev_Pop_FieldsResolvers<ContextType>;
  matchingItemsBuySpecs_stddev_samp_fields?: MatchingItemsBuySpecs_Stddev_Samp_FieldsResolvers<ContextType>;
  matchingItemsBuySpecs_sum_fields?: MatchingItemsBuySpecs_Sum_FieldsResolvers<ContextType>;
  matchingItemsBuySpecs_var_pop_fields?: MatchingItemsBuySpecs_Var_Pop_FieldsResolvers<ContextType>;
  matchingItemsBuySpecs_var_samp_fields?: MatchingItemsBuySpecs_Var_Samp_FieldsResolvers<ContextType>;
  matchingItemsBuySpecs_variance_fields?: MatchingItemsBuySpecs_Variance_FieldsResolvers<ContextType>;
  mutation_root?: Mutation_RootResolvers<ContextType>;
  notifications?: NotificationsResolvers<ContextType>;
  notifications_aggregate?: Notifications_AggregateResolvers<ContextType>;
  notifications_aggregate_fields?: Notifications_Aggregate_FieldsResolvers<ContextType>;
  notifications_avg_fields?: Notifications_Avg_FieldsResolvers<ContextType>;
  notifications_max_fields?: Notifications_Max_FieldsResolvers<ContextType>;
  notifications_min_fields?: Notifications_Min_FieldsResolvers<ContextType>;
  notifications_mutation_response?: Notifications_Mutation_ResponseResolvers<ContextType>;
  notifications_stddev_fields?: Notifications_Stddev_FieldsResolvers<ContextType>;
  notifications_stddev_pop_fields?: Notifications_Stddev_Pop_FieldsResolvers<ContextType>;
  notifications_stddev_samp_fields?: Notifications_Stddev_Samp_FieldsResolvers<ContextType>;
  notifications_sum_fields?: Notifications_Sum_FieldsResolvers<ContextType>;
  notifications_var_pop_fields?: Notifications_Var_Pop_FieldsResolvers<ContextType>;
  notifications_var_samp_fields?: Notifications_Var_Samp_FieldsResolvers<ContextType>;
  notifications_variance_fields?: Notifications_Variance_FieldsResolvers<ContextType>;
  offices?: OfficesResolvers<ContextType>;
  offices_aggregate?: Offices_AggregateResolvers<ContextType>;
  offices_aggregate_fields?: Offices_Aggregate_FieldsResolvers<ContextType>;
  offices_avg_fields?: Offices_Avg_FieldsResolvers<ContextType>;
  offices_max_fields?: Offices_Max_FieldsResolvers<ContextType>;
  offices_min_fields?: Offices_Min_FieldsResolvers<ContextType>;
  offices_mutation_response?: Offices_Mutation_ResponseResolvers<ContextType>;
  offices_stddev_fields?: Offices_Stddev_FieldsResolvers<ContextType>;
  offices_stddev_pop_fields?: Offices_Stddev_Pop_FieldsResolvers<ContextType>;
  offices_stddev_samp_fields?: Offices_Stddev_Samp_FieldsResolvers<ContextType>;
  offices_sum_fields?: Offices_Sum_FieldsResolvers<ContextType>;
  offices_var_pop_fields?: Offices_Var_Pop_FieldsResolvers<ContextType>;
  offices_var_samp_fields?: Offices_Var_Samp_FieldsResolvers<ContextType>;
  offices_variance_fields?: Offices_Variance_FieldsResolvers<ContextType>;
  query_root?: Query_RootResolvers<ContextType>;
  releases?: ReleasesResolvers<ContextType>;
  releases_aggregate?: Releases_AggregateResolvers<ContextType>;
  releases_aggregate_fields?: Releases_Aggregate_FieldsResolvers<ContextType>;
  releases_avg_fields?: Releases_Avg_FieldsResolvers<ContextType>;
  releases_max_fields?: Releases_Max_FieldsResolvers<ContextType>;
  releases_min_fields?: Releases_Min_FieldsResolvers<ContextType>;
  releases_mutation_response?: Releases_Mutation_ResponseResolvers<ContextType>;
  releases_stddev_fields?: Releases_Stddev_FieldsResolvers<ContextType>;
  releases_stddev_pop_fields?: Releases_Stddev_Pop_FieldsResolvers<ContextType>;
  releases_stddev_samp_fields?: Releases_Stddev_Samp_FieldsResolvers<ContextType>;
  releases_sum_fields?: Releases_Sum_FieldsResolvers<ContextType>;
  releases_var_pop_fields?: Releases_Var_Pop_FieldsResolvers<ContextType>;
  releases_var_samp_fields?: Releases_Var_Samp_FieldsResolvers<ContextType>;
  releases_variance_fields?: Releases_Variance_FieldsResolvers<ContextType>;
  reminders?: RemindersResolvers<ContextType>;
  reminders_aggregate?: Reminders_AggregateResolvers<ContextType>;
  reminders_aggregate_fields?: Reminders_Aggregate_FieldsResolvers<ContextType>;
  reminders_avg_fields?: Reminders_Avg_FieldsResolvers<ContextType>;
  reminders_max_fields?: Reminders_Max_FieldsResolvers<ContextType>;
  reminders_min_fields?: Reminders_Min_FieldsResolvers<ContextType>;
  reminders_mutation_response?: Reminders_Mutation_ResponseResolvers<ContextType>;
  reminders_stddev_fields?: Reminders_Stddev_FieldsResolvers<ContextType>;
  reminders_stddev_pop_fields?: Reminders_Stddev_Pop_FieldsResolvers<ContextType>;
  reminders_stddev_samp_fields?: Reminders_Stddev_Samp_FieldsResolvers<ContextType>;
  reminders_sum_fields?: Reminders_Sum_FieldsResolvers<ContextType>;
  reminders_var_pop_fields?: Reminders_Var_Pop_FieldsResolvers<ContextType>;
  reminders_var_samp_fields?: Reminders_Var_Samp_FieldsResolvers<ContextType>;
  reminders_variance_fields?: Reminders_Variance_FieldsResolvers<ContextType>;
  sampleLabels?: SampleLabelsResolvers<ContextType>;
  sampleLabels_aggregate?: SampleLabels_AggregateResolvers<ContextType>;
  sampleLabels_aggregate_fields?: SampleLabels_Aggregate_FieldsResolvers<ContextType>;
  sampleLabels_avg_fields?: SampleLabels_Avg_FieldsResolvers<ContextType>;
  sampleLabels_max_fields?: SampleLabels_Max_FieldsResolvers<ContextType>;
  sampleLabels_min_fields?: SampleLabels_Min_FieldsResolvers<ContextType>;
  sampleLabels_mutation_response?: SampleLabels_Mutation_ResponseResolvers<ContextType>;
  sampleLabels_stddev_fields?: SampleLabels_Stddev_FieldsResolvers<ContextType>;
  sampleLabels_stddev_pop_fields?: SampleLabels_Stddev_Pop_FieldsResolvers<ContextType>;
  sampleLabels_stddev_samp_fields?: SampleLabels_Stddev_Samp_FieldsResolvers<ContextType>;
  sampleLabels_sum_fields?: SampleLabels_Sum_FieldsResolvers<ContextType>;
  sampleLabels_var_pop_fields?: SampleLabels_Var_Pop_FieldsResolvers<ContextType>;
  sampleLabels_var_samp_fields?: SampleLabels_Var_Samp_FieldsResolvers<ContextType>;
  sampleLabels_variance_fields?: SampleLabels_Variance_FieldsResolvers<ContextType>;
  sampleShipmentRequests?: SampleShipmentRequestsResolvers<ContextType>;
  sampleShipmentRequests_aggregate?: SampleShipmentRequests_AggregateResolvers<ContextType>;
  sampleShipmentRequests_aggregate_fields?: SampleShipmentRequests_Aggregate_FieldsResolvers<ContextType>;
  sampleShipmentRequests_avg_fields?: SampleShipmentRequests_Avg_FieldsResolvers<ContextType>;
  sampleShipmentRequests_max_fields?: SampleShipmentRequests_Max_FieldsResolvers<ContextType>;
  sampleShipmentRequests_min_fields?: SampleShipmentRequests_Min_FieldsResolvers<ContextType>;
  sampleShipmentRequests_mutation_response?: SampleShipmentRequests_Mutation_ResponseResolvers<ContextType>;
  sampleShipmentRequests_stddev_fields?: SampleShipmentRequests_Stddev_FieldsResolvers<ContextType>;
  sampleShipmentRequests_stddev_pop_fields?: SampleShipmentRequests_Stddev_Pop_FieldsResolvers<ContextType>;
  sampleShipmentRequests_stddev_samp_fields?: SampleShipmentRequests_Stddev_Samp_FieldsResolvers<ContextType>;
  sampleShipmentRequests_sum_fields?: SampleShipmentRequests_Sum_FieldsResolvers<ContextType>;
  sampleShipmentRequests_var_pop_fields?: SampleShipmentRequests_Var_Pop_FieldsResolvers<ContextType>;
  sampleShipmentRequests_var_samp_fields?: SampleShipmentRequests_Var_Samp_FieldsResolvers<ContextType>;
  sampleShipmentRequests_variance_fields?: SampleShipmentRequests_Variance_FieldsResolvers<ContextType>;
  sampleShipments?: SampleShipmentsResolvers<ContextType>;
  sampleShipments_aggregate?: SampleShipments_AggregateResolvers<ContextType>;
  sampleShipments_aggregate_fields?: SampleShipments_Aggregate_FieldsResolvers<ContextType>;
  sampleShipments_avg_fields?: SampleShipments_Avg_FieldsResolvers<ContextType>;
  sampleShipments_max_fields?: SampleShipments_Max_FieldsResolvers<ContextType>;
  sampleShipments_min_fields?: SampleShipments_Min_FieldsResolvers<ContextType>;
  sampleShipments_mutation_response?: SampleShipments_Mutation_ResponseResolvers<ContextType>;
  sampleShipments_stddev_fields?: SampleShipments_Stddev_FieldsResolvers<ContextType>;
  sampleShipments_stddev_pop_fields?: SampleShipments_Stddev_Pop_FieldsResolvers<ContextType>;
  sampleShipments_stddev_samp_fields?: SampleShipments_Stddev_Samp_FieldsResolvers<ContextType>;
  sampleShipments_sum_fields?: SampleShipments_Sum_FieldsResolvers<ContextType>;
  sampleShipments_var_pop_fields?: SampleShipments_Var_Pop_FieldsResolvers<ContextType>;
  sampleShipments_var_samp_fields?: SampleShipments_Var_Samp_FieldsResolvers<ContextType>;
  sampleShipments_variance_fields?: SampleShipments_Variance_FieldsResolvers<ContextType>;
  samples?: SamplesResolvers<ContextType>;
  samples_aggregate?: Samples_AggregateResolvers<ContextType>;
  samples_aggregate_fields?: Samples_Aggregate_FieldsResolvers<ContextType>;
  samples_avg_fields?: Samples_Avg_FieldsResolvers<ContextType>;
  samples_max_fields?: Samples_Max_FieldsResolvers<ContextType>;
  samples_min_fields?: Samples_Min_FieldsResolvers<ContextType>;
  samples_mutation_response?: Samples_Mutation_ResponseResolvers<ContextType>;
  samples_stddev_fields?: Samples_Stddev_FieldsResolvers<ContextType>;
  samples_stddev_pop_fields?: Samples_Stddev_Pop_FieldsResolvers<ContextType>;
  samples_stddev_samp_fields?: Samples_Stddev_Samp_FieldsResolvers<ContextType>;
  samples_sum_fields?: Samples_Sum_FieldsResolvers<ContextType>;
  samples_var_pop_fields?: Samples_Var_Pop_FieldsResolvers<ContextType>;
  samples_var_samp_fields?: Samples_Var_Samp_FieldsResolvers<ContextType>;
  samples_variance_fields?: Samples_Variance_FieldsResolvers<ContextType>;
  shipmentFulfillments?: ShipmentFulfillmentsResolvers<ContextType>;
  shipmentFulfillments_aggregate?: ShipmentFulfillments_AggregateResolvers<ContextType>;
  shipmentFulfillments_aggregate_fields?: ShipmentFulfillments_Aggregate_FieldsResolvers<ContextType>;
  shipmentFulfillments_avg_fields?: ShipmentFulfillments_Avg_FieldsResolvers<ContextType>;
  shipmentFulfillments_max_fields?: ShipmentFulfillments_Max_FieldsResolvers<ContextType>;
  shipmentFulfillments_min_fields?: ShipmentFulfillments_Min_FieldsResolvers<ContextType>;
  shipmentFulfillments_mutation_response?: ShipmentFulfillments_Mutation_ResponseResolvers<ContextType>;
  shipmentFulfillments_stddev_fields?: ShipmentFulfillments_Stddev_FieldsResolvers<ContextType>;
  shipmentFulfillments_stddev_pop_fields?: ShipmentFulfillments_Stddev_Pop_FieldsResolvers<ContextType>;
  shipmentFulfillments_stddev_samp_fields?: ShipmentFulfillments_Stddev_Samp_FieldsResolvers<ContextType>;
  shipmentFulfillments_sum_fields?: ShipmentFulfillments_Sum_FieldsResolvers<ContextType>;
  shipmentFulfillments_var_pop_fields?: ShipmentFulfillments_Var_Pop_FieldsResolvers<ContextType>;
  shipmentFulfillments_var_samp_fields?: ShipmentFulfillments_Var_Samp_FieldsResolvers<ContextType>;
  shipmentFulfillments_variance_fields?: ShipmentFulfillments_Variance_FieldsResolvers<ContextType>;
  subscription_root?: Subscription_RootResolvers<ContextType>;
  timestamp?: GraphQLScalarType;
  timestamptz?: GraphQLScalarType;
  trackings?: TrackingsResolvers<ContextType>;
  trackings_aggregate?: Trackings_AggregateResolvers<ContextType>;
  trackings_aggregate_fields?: Trackings_Aggregate_FieldsResolvers<ContextType>;
  trackings_avg_fields?: Trackings_Avg_FieldsResolvers<ContextType>;
  trackings_max_fields?: Trackings_Max_FieldsResolvers<ContextType>;
  trackings_min_fields?: Trackings_Min_FieldsResolvers<ContextType>;
  trackings_mutation_response?: Trackings_Mutation_ResponseResolvers<ContextType>;
  trackings_stddev_fields?: Trackings_Stddev_FieldsResolvers<ContextType>;
  trackings_stddev_pop_fields?: Trackings_Stddev_Pop_FieldsResolvers<ContextType>;
  trackings_stddev_samp_fields?: Trackings_Stddev_Samp_FieldsResolvers<ContextType>;
  trackings_sum_fields?: Trackings_Sum_FieldsResolvers<ContextType>;
  trackings_var_pop_fields?: Trackings_Var_Pop_FieldsResolvers<ContextType>;
  trackings_var_samp_fields?: Trackings_Var_Samp_FieldsResolvers<ContextType>;
  trackings_variance_fields?: Trackings_Variance_FieldsResolvers<ContextType>;
  users?: UsersResolvers<ContextType>;
  usersBonus?: UsersBonusResolvers<ContextType>;
  usersBonus_aggregate?: UsersBonus_AggregateResolvers<ContextType>;
  usersBonus_aggregate_fields?: UsersBonus_Aggregate_FieldsResolvers<ContextType>;
  usersBonus_avg_fields?: UsersBonus_Avg_FieldsResolvers<ContextType>;
  usersBonus_max_fields?: UsersBonus_Max_FieldsResolvers<ContextType>;
  usersBonus_min_fields?: UsersBonus_Min_FieldsResolvers<ContextType>;
  usersBonus_mutation_response?: UsersBonus_Mutation_ResponseResolvers<ContextType>;
  usersBonus_stddev_fields?: UsersBonus_Stddev_FieldsResolvers<ContextType>;
  usersBonus_stddev_pop_fields?: UsersBonus_Stddev_Pop_FieldsResolvers<ContextType>;
  usersBonus_stddev_samp_fields?: UsersBonus_Stddev_Samp_FieldsResolvers<ContextType>;
  usersBonus_sum_fields?: UsersBonus_Sum_FieldsResolvers<ContextType>;
  usersBonus_var_pop_fields?: UsersBonus_Var_Pop_FieldsResolvers<ContextType>;
  usersBonus_var_samp_fields?: UsersBonus_Var_Samp_FieldsResolvers<ContextType>;
  usersBonus_variance_fields?: UsersBonus_Variance_FieldsResolvers<ContextType>;
  usersCosts?: UsersCostsResolvers<ContextType>;
  usersCosts_aggregate?: UsersCosts_AggregateResolvers<ContextType>;
  usersCosts_aggregate_fields?: UsersCosts_Aggregate_FieldsResolvers<ContextType>;
  usersCosts_avg_fields?: UsersCosts_Avg_FieldsResolvers<ContextType>;
  usersCosts_max_fields?: UsersCosts_Max_FieldsResolvers<ContextType>;
  usersCosts_min_fields?: UsersCosts_Min_FieldsResolvers<ContextType>;
  usersCosts_mutation_response?: UsersCosts_Mutation_ResponseResolvers<ContextType>;
  usersCosts_stddev_fields?: UsersCosts_Stddev_FieldsResolvers<ContextType>;
  usersCosts_stddev_pop_fields?: UsersCosts_Stddev_Pop_FieldsResolvers<ContextType>;
  usersCosts_stddev_samp_fields?: UsersCosts_Stddev_Samp_FieldsResolvers<ContextType>;
  usersCosts_sum_fields?: UsersCosts_Sum_FieldsResolvers<ContextType>;
  usersCosts_var_pop_fields?: UsersCosts_Var_Pop_FieldsResolvers<ContextType>;
  usersCosts_var_samp_fields?: UsersCosts_Var_Samp_FieldsResolvers<ContextType>;
  usersCosts_variance_fields?: UsersCosts_Variance_FieldsResolvers<ContextType>;
  users_aggregate?: Users_AggregateResolvers<ContextType>;
  users_aggregate_fields?: Users_Aggregate_FieldsResolvers<ContextType>;
  users_avg_fields?: Users_Avg_FieldsResolvers<ContextType>;
  users_max_fields?: Users_Max_FieldsResolvers<ContextType>;
  users_min_fields?: Users_Min_FieldsResolvers<ContextType>;
  users_mutation_response?: Users_Mutation_ResponseResolvers<ContextType>;
  users_stddev_fields?: Users_Stddev_FieldsResolvers<ContextType>;
  users_stddev_pop_fields?: Users_Stddev_Pop_FieldsResolvers<ContextType>;
  users_stddev_samp_fields?: Users_Stddev_Samp_FieldsResolvers<ContextType>;
  users_sum_fields?: Users_Sum_FieldsResolvers<ContextType>;
  users_var_pop_fields?: Users_Var_Pop_FieldsResolvers<ContextType>;
  users_var_samp_fields?: Users_Var_Samp_FieldsResolvers<ContextType>;
  users_variance_fields?: Users_Variance_FieldsResolvers<ContextType>;
  validationsContracts?: ValidationsContractsResolvers<ContextType>;
  validationsContracts_aggregate?: ValidationsContracts_AggregateResolvers<ContextType>;
  validationsContracts_aggregate_fields?: ValidationsContracts_Aggregate_FieldsResolvers<ContextType>;
  validationsContracts_avg_fields?: ValidationsContracts_Avg_FieldsResolvers<ContextType>;
  validationsContracts_max_fields?: ValidationsContracts_Max_FieldsResolvers<ContextType>;
  validationsContracts_min_fields?: ValidationsContracts_Min_FieldsResolvers<ContextType>;
  validationsContracts_mutation_response?: ValidationsContracts_Mutation_ResponseResolvers<ContextType>;
  validationsContracts_stddev_fields?: ValidationsContracts_Stddev_FieldsResolvers<ContextType>;
  validationsContracts_stddev_pop_fields?: ValidationsContracts_Stddev_Pop_FieldsResolvers<ContextType>;
  validationsContracts_stddev_samp_fields?: ValidationsContracts_Stddev_Samp_FieldsResolvers<ContextType>;
  validationsContracts_sum_fields?: ValidationsContracts_Sum_FieldsResolvers<ContextType>;
  validationsContracts_var_pop_fields?: ValidationsContracts_Var_Pop_FieldsResolvers<ContextType>;
  validationsContracts_var_samp_fields?: ValidationsContracts_Var_Samp_FieldsResolvers<ContextType>;
  validationsContracts_variance_fields?: ValidationsContracts_Variance_FieldsResolvers<ContextType>;
  varietals?: VarietalsResolvers<ContextType>;
  varietals_aggregate?: Varietals_AggregateResolvers<ContextType>;
  varietals_aggregate_fields?: Varietals_Aggregate_FieldsResolvers<ContextType>;
  varietals_avg_fields?: Varietals_Avg_FieldsResolvers<ContextType>;
  varietals_max_fields?: Varietals_Max_FieldsResolvers<ContextType>;
  varietals_min_fields?: Varietals_Min_FieldsResolvers<ContextType>;
  varietals_mutation_response?: Varietals_Mutation_ResponseResolvers<ContextType>;
  varietals_stddev_fields?: Varietals_Stddev_FieldsResolvers<ContextType>;
  varietals_stddev_pop_fields?: Varietals_Stddev_Pop_FieldsResolvers<ContextType>;
  varietals_stddev_samp_fields?: Varietals_Stddev_Samp_FieldsResolvers<ContextType>;
  varietals_sum_fields?: Varietals_Sum_FieldsResolvers<ContextType>;
  varietals_var_pop_fields?: Varietals_Var_Pop_FieldsResolvers<ContextType>;
  varietals_var_samp_fields?: Varietals_Var_Samp_FieldsResolvers<ContextType>;
  varietals_variance_fields?: Varietals_Variance_FieldsResolvers<ContextType>;
  vector?: GraphQLScalarType;
};

export type DirectiveResolvers<ContextType = any> = {
  cached?: CachedDirectiveResolver<any, any, ContextType>;
};


export const GetAdressesDocument = gql`
    query GetAdresses {
  addresses {
    archivedAt
    city
    country
    createdAt
    createdBy
    deletedAt
    id
    name
    storageCompany
    state
    street1
    street2
    streetNumber
    updatedAt
    zipcode
    comments
    files
    excise
    bondedWarehouse
  }
}
    `;
export const GetAgreementTermsDocument = gql`
    query GetAgreementTerms {
  agreementTerms {
    content
    createdAt
    id
    title
    type
    updatedAt
    createdBy
    deletedAt
  }
}
    `;
export const GetAgreementsDocument = gql`
    query GetAgreements {
  agreements {
    thirdPartyContractRef
    commodityType
    buyerCompanyId
    archivedAt
    buyerCiattiCommission
    buyerContactId
    buyerContractRef
    buyerOfficeId
    buyerSpecsId
    buyerUserId
    comments
    commisionFees
    commissionBuyer
    commissionCostBase
    commissionCurrency
    commissionFeesPerUom
    commissionFlatFees
    commissionPercentage
    commissionQuantityBase
    commissionSeller
    commissionThirdParty
    commissionTotalFees
    commissionType
    commissionUom
    contractRevision
    legacyContractStatus
    contractUserId
    createdAt
    createdBy
    deletedAt
    endDate
    files
    id
    incoterms
    itemsId
    thirdPartyCompanyId
    thirdPartyContactId
    place
    reminders
    sellerCiattiCommission
    sellerCompanyId
    sellerContactId
    sellerContractRef
    sellerOfficeId
    sellerUserId
    startDate
    terms
    termsAddContract
    termsCommission
    termsPayment
    termsShipping
    thirdPartyCommission
    thirdPartyCompanyId
    title
    totalCost
    updatedAt
    evergreenContract
    usdaGcr
    contractOfficeId
    costArray
    signaturesRequired
    buyerDeliveryAddressId
    currency
    evergreenDates
    termsAddContractViewer
    termsShippingViewer
    termsViewer
    termsPaymentViewer
    termsCommissionViewer
    buyerBondedWarehouse
    buyerEori
    buyerExcise
    buyerUserName
    buyerVat
    sellerBondedWarehouse
    sellerEori
    sellerExcise
    sellerFda
    sellerUserName
    sellerVat
    buyerBillingAddressId
    salesOrderNetsuite
    sellerBillingAddressId
    sellerDeliveryAddressId
    sellerCvi
    buyerCvi
    fulfillmentsStatus
    contractStatus
    additionalInformations
    evergreenAgreementId
    isMultiYearContract
  }
}
    `;
export const GetAgreementsWithStartDateDocument = gql`
    query GetAgreementsWithStartDate($startDate: timestamptz!) {
  agreements(where: {createdAt: {_gt: $startDate}}) {
    thirdPartyContractRef
    commodityType
    buyerCompanyId
    archivedAt
    buyerCiattiCommission
    buyerContactId
    buyerContractRef
    buyerOfficeId
    buyerSpecsId
    buyerUserId
    comments
    commisionFees
    commissionBuyer
    commissionCostBase
    commissionCurrency
    commissionFeesPerUom
    commissionFlatFees
    commissionPercentage
    commissionQuantityBase
    commissionSeller
    commissionThirdParty
    commissionTotalFees
    commissionType
    commissionUom
    contractRevision
    legacyContractStatus
    contractUserId
    createdAt
    createdBy
    deletedAt
    endDate
    files
    id
    incoterms
    itemsId
    thirdPartyCompanyId
    thirdPartyContactId
    place
    reminders
    sellerCiattiCommission
    sellerCompanyId
    sellerContactId
    sellerContractRef
    sellerOfficeId
    sellerUserId
    startDate
    terms
    termsAddContract
    termsCommission
    termsPayment
    termsShipping
    thirdPartyCommission
    thirdPartyCompanyId
    title
    totalCost
    updatedAt
    evergreenContract
    usdaGcr
    contractOfficeId
    costArray
    signaturesRequired
    buyerDeliveryAddressId
    currency
    evergreenDates
    termsAddContractViewer
    termsShippingViewer
    termsViewer
    termsPaymentViewer
    termsCommissionViewer
    buyerBondedWarehouse
    buyerEori
    buyerExcise
    buyerUserName
    buyerVat
    sellerBondedWarehouse
    sellerEori
    sellerExcise
    sellerFda
    sellerUserName
    sellerVat
    buyerBillingAddressId
    salesOrderNetsuite
    sellerBillingAddressId
    sellerDeliveryAddressId
    sellerCvi
    buyerCvi
    fulfillmentsStatus
    contractStatus
    additionalInformations
    evergreenAgreementId
    isMultiYearContract
  }
}
    `;
export const GetAgreementsWithShipmentFulfillmentsAndInvoicesDocument = gql`
    query GetAgreementsWithShipmentFulfillmentsAndInvoices {
  agreements {
    isMultiYearContract
    thirdPartyContractRef
    commodityType
    buyerCompanyId
    archivedAt
    buyerCiattiCommission
    buyerContactId
    buyerContractRef
    buyerOfficeId
    buyerSpecsId
    buyerUserId
    comments
    commisionFees
    commissionBuyer
    commissionCostBase
    commissionCurrency
    commissionFeesPerUom
    commissionFlatFees
    commissionPercentage
    commissionQuantityBase
    commissionSeller
    commissionThirdParty
    commissionTotalFees
    commissionType
    commissionUom
    contractRevision
    legacyContractStatus
    contractUserId
    createdAt
    createdBy
    deletedAt
    endDate
    files
    id
    incoterms
    itemsId
    thirdPartyCompanyId
    thirdPartyContactId
    place
    reminders
    sellerCiattiCommission
    sellerCompanyId
    sellerContactId
    sellerContractRef
    sellerOfficeId
    sellerUserId
    startDate
    terms
    termsAddContract
    termsCommission
    termsPayment
    termsShipping
    thirdPartyCommission
    thirdPartyCompanyId
    title
    totalCost
    updatedAt
    evergreenContract
    usdaGcr
    contractOfficeId
    costArray
    signaturesRequired
    buyerDeliveryAddressId
    currency
    evergreenDates
    termsAddContractViewer
    termsShippingViewer
    termsViewer
    termsPaymentViewer
    termsCommissionViewer
    buyerBondedWarehouse
    buyerEori
    buyerExcise
    buyerUserName
    buyerVat
    sellerBondedWarehouse
    sellerEori
    sellerExcise
    sellerFda
    sellerUserName
    sellerVat
    buyerBillingAddressId
    salesOrderNetsuite
    sellerBillingAddressId
    sellerDeliveryAddressId
    sellerCvi
    buyerCvi
    evergreenAgreementId
    fulfillmentsStatus
    contractStatus
    invoices {
      buyerPoRef
      supplierInvoice
      paymentDate
      USDconversion
      amount
      archivedAt
      brokerId
      comments
      companyId
      createdAt
      createdBy
      currency
      deletedAt
      dueDate
      externalId
      files
      id
      officeId
      quickbookId
      shipmentFulfillmentId
      status
      updatedAt
    }
    shipmentFulfillments {
      archivedAt
      comments
      commissionAmount
      createdAt
      createdBy
      currency
      date
      deletedAt
      files
      id
      itemId
      quantity
      status
      uom
      updatedAt
    }
  }
}
    `;
export const GetAppellationsDocument = gql`
    query GetAppellations {
  appellations {
    id
    country
    state
    region
    subRegion
    appellation
    district
    county
    subAppellation
  }
}
    `;
export const GetAppellationsWithVectorDocument = gql`
    query GetAppellationsWithVector {
  appellations {
    id
    country
    state
    region
    subRegion
    appellation
    district
    county
    subAppellation
    embedding
    vectorText
  }
}
    `;
export const GetAuthorizedDomainByNameDocument = gql`
    query GetAuthorizedDomainByName($domain: String!) {
  authorizedDomains(where: {domain: {_eq: $domain}}) {
    id
    domain
  }
}
    `;
export const GetAuthorizedDomainsDocument = gql`
    query GetAuthorizedDomains {
  authorizedDomains {
    id
    domain
    deletedAt
  }
}
    `;
export const GetBuySpecsDocument = gql`
    query GetBuySpecs {
  buySpecs {
    alcohol
    archivedAt
    askPrice
    buyerAddressId
    buyerCompanyId
    buyerContactId
    certifications
    comments
    commodityType
    country
    county
    createdAt
    createdBy
    currency
    deadline
    deletedAt
    district
    files
    generic
    id
    officeId
    qualities
    quantityNeeded
    region
    state
    subAppellation
    subGeneric
    subRegion
    uom
    updatedAt
    varietals
    vintages
    brokerId
    appellations
    isOpportunistic
    commissionAmount
    commissionPercentage
    status
    harvestMethod
  }
}
    `;
export const GetCompaniesDocument = gql`
    query GetCompanies {
  companies {
    brokerId
    category
    certifications
    createdAt
    createdBy
    cvi
    email
    excise
    id
    name
    officialId
    phone
    updatedAt
    vat
    archivedAt
    deletedAt
    comments
    files
    officeId
    country
    fda
    eori
    scoring
    parentCompany
    targetObjectiveCurrency
    targetObjective
  }
}
    `;
export const GetCompaniesWithVectorDocument = gql`
    query GetCompaniesWithVector {
  companies {
    brokerId
    category
    certifications
    createdAt
    createdBy
    cvi
    email
    excise
    id
    name
    officialId
    phone
    updatedAt
    vat
    archivedAt
    deletedAt
    comments
    files
    officeId
    country
    fda
    eori
    scoring
    parentCompany
    targetObjectiveCurrency
    targetObjective
    embedding
    vectorText
  }
}
    `;
export const GetCompanyAdressesDocument = gql`
    query GetCompanyAdresses {
  companyAddress {
    addressId
    companyId
    id
  }
}
    `;
export const GetContactsDocument = gql`
    query GetContacts {
  contacts {
    addressId
    altEmail
    altPhone
    archivedAt
    brokerId
    categories
    companyId
    createdAt
    createdBy
    deletedAt
    email
    updatedAt
    phone
    officePhone
    mobile
    lastname
    jobTitle
    id
    fax
    firstname
    comments
    files
  }
}
    `;
export const GetContactsWithVectorDocument = gql`
    query GetContactsWithVector {
  contacts {
    addressId
    altEmail
    altPhone
    archivedAt
    brokerId
    categories
    companyId
    createdAt
    createdBy
    deletedAt
    email
    updatedAt
    phone
    officePhone
    mobile
    lastname
    jobTitle
    id
    fax
    firstname
    comments
    files
    embedding
    vectorText
  }
}
    `;
export const GetContactsForGeneratingVectorDocument = gql`
    query GetContactsForGeneratingVector {
  contacts {
    addressId
    altEmail
    altPhone
    archivedAt
    brokerId
    categories
    companyId
    createdAt
    createdBy
    deletedAt
    email
    updatedAt
    phone
    officePhone
    mobile
    lastname
    jobTitle
    id
    fax
    firstname
    comments
    files
    company {
      name
      id
    }
  }
}
    `;
export const GetContractsDocument = gql`
    query GetContracts {
  contracts {
    agreementId
    createdAt
    createdBy
    fileUrl
    id
    updatedAt
    version
    format
    fileUrlWithSignatures
    validationsContracts {
      companyId
      comments
      createdAt
      createdBy
      id
      status
      updatedAt
      signatoryContactId
      signature
    }
  }
}
    `;
export const GetExtendedContractsDocument = gql`
    query GetExtendedContracts {
  contracts {
    agreementId
    createdAt
    createdBy
    fileUrl
    id
    updatedAt
    version
    fileUrlWithSignatures
    format
    validationsContracts {
      companyId
      comments
      createdAt
      createdBy
      id
      status
      updatedAt
      signatoryContactId
      signature
      company {
        name
      }
      signatoryContact {
        firstname
        lastname
      }
    }
  }
}
    `;
export const GetCurrenciesConversionsDocument = gql`
    query GetCurrenciesConversions {
  currenciesConversions(order_by: {date: asc}) {
    date
    currencies
  }
}
    `;
export const GetHistoryForObjectDocument = gql`
    query GetHistoryForObject($id: Int!, $table: String!) {
  history(where: {objectId: {_eq: $id}, table: {_eq: $table}}) {
    createdAt
    createdBy
    data
    id
    objectId
    operation
    table
  }
}
    `;
export const GetEntitiesUpdatedDocument = gql`
    query GetEntitiesUpdated($table: String!, $objectsId: [Int!]!, $startDate: timestamptz!, $endDate: timestamptz!) {
  history(
    where: {table: {_eq: $table}, objectId: {_in: $objectsId}, createdAt: {_gt: $startDate, _lt: $endDate}, operation: {_eq: "UPDATE"}}
    distinct_on: objectId
  ) {
    createdAt
    objectId
  }
}
    `;
export const GetHistoryByUserDocument = gql`
    query GetHistoryByUser($userId: String!) {
  history(where: {createdBy: {_eq: $userId}}) {
    objectId
    operation
    table
    createdAt
    id
  }
}
    `;
export const GetInvoicesDocument = gql`
    query GetInvoices {
  invoices {
    agreementId
    amount
    archivedAt
    brokerId
    comments
    companyId
    createdAt
    createdBy
    currency
    files
    id
    officeId
    shipmentFulfillmentId
    status
    updatedAt
    deletedAt
    files
    archivedAt
    quickbookId
    buyerPoRef
    supplierInvoice
    paymentDate
  }
}
    `;
export const GetItemsDocument = gql`
    query GetItems {
  items {
    alcohol
    brokerId
    certifications
    comments
    conditioning
    country
    county
    createdAt
    createdBy
    currency
    district
    exportIncoterms
    exportIncotermsType
    files
    generic
    harvestMethod
    id
    localPrice
    lotNo
    officeId
    isOpportunistic
    qualities
    quantity
    region
    state
    storageLocationId
    subGeneric
    vintages
    varietals
    updatedAt
    uom
    tankNo
    supplierContactId
    supplierCompanyId
    subRegion
    deletedAt
    archivedAt
    commodityType
    appellations
    subAppellation
    additionalInformations
    netsuiteId
  }
}
    `;
export const GetItemsWithStartDateDocument = gql`
    query GetItemsWithStartDate($startDate: timestamptz!) {
  items(where: {createdAt: {_gt: $startDate}}) {
    alcohol
    brokerId
    certifications
    comments
    conditioning
    country
    county
    createdAt
    createdBy
    currency
    district
    exportIncoterms
    exportIncotermsType
    files
    generic
    harvestMethod
    id
    localPrice
    lotNo
    officeId
    isOpportunistic
    qualities
    quantity
    region
    state
    storageLocationId
    subGeneric
    vintages
    varietals
    updatedAt
    uom
    tankNo
    supplierContactId
    supplierCompanyId
    subRegion
    deletedAt
    archivedAt
    commodityType
    appellations
    subAppellation
    additionalInformations
    netsuiteId
  }
}
    `;
export const GetLogsDocument = gql`
    query GetLogs {
  logs {
    action
    createdAt
    createdBy
    id
    payload
    url
  }
}
    `;
export const GetMatchingItemsBuySpecsDocument = gql`
    query GetMatchingItemsBuySpecs {
  matchingItemsBuySpecs {
    archivedAt
    buySpecId
    createdAt
    createdBy
    deletedAt
    updatedAt
    itemId
    id
  }
}
    `;
export const GetNotificationsDocument = gql`
    query GetNotifications {
  notifications {
    assignedTo
    createdAt
    createdBy
    historyId
    id
    updatedAt
    viewedAt
    archivedAt
    history {
      operation
      table
      objectId
    }
    user {
      firstname
      lastname
    }
  }
}
    `;
export const GetOfficesDocument = gql`
    query GetOffices {
  offices {
    name
    id
    address
    locale
  }
}
    `;
export const GetReleasesDocument = gql`
    query GetReleases {
  releases(order_by: {date: desc}, limit: 30) {
    createdAt
    updatedAt
    title
    link
    imageUrl
    id
    description
    date
    tag
  }
}
    `;
export const GetRemindersByOfficeIdDocument = gql`
    query getRemindersByOfficeId($officeId: Int!) {
  reminders(where: {assignedUser: {officeId: {_eq: $officeId}}}) {
    assignedTo
    deletedAt
    createdAt
    createdBy
    description
    id
    startDate
    title
    updatedAt
    viewedAt
    table
    objectId
  }
}
    `;
export const GetRemindersByObjectIdDocument = gql`
    query GetRemindersByObjectId($objectId: Int!, $table: String!) {
  reminders(where: {objectId: {_eq: $objectId}, table: {_eq: $table}}) {
    assignedTo
    deletedAt
    createdAt
    createdBy
    description
    id
    startDate
    objectId
    table
    title
    updatedAt
    viewedAt
  }
}
    `;
export const GetSampleLabelsDocument = gql`
    query GetSampleLabels {
  sampleLabels {
    archivedAt
    createdAt
    createdBy
    fields
    model
    deletedAt
    id
    officeId
    updatedAt
  }
}
    `;
export const GetSampleShipmentRequestsDocument = gql`
    query GetSampleShipmentRequests {
  sampleShipmentRequests {
    archivedAt
    buySpecId
    comments
    createdAt
    createdBy
    deadline
    deletedAt
    files
    id
    itemId
    numberOfSamples
    updatedAt
    sampleShipmentId
    type
    requestedBy
    feedback
  }
}
    `;
export const GetSampleShipmentsDocument = gql`
    query GetSampleShipments {
  sampleShipments {
    archivedAt
    brokerId
    carrier
    createdAt
    createdBy
    deletedAt
    details
    id
    officeId
    pickupDate
    recipientAddressId
    recipientCompanyId
    recipientContactId
    senderAddressId
    senderCompanyId
    senderContactId
    status
    trackingId
    updatedAt
    deliveryMethod
    deliveryDate
    isHardcodedCarrier
  }
}
    `;
export const GetSampleShipmentExtendedDocument = gql`
    query GetSampleShipmentExtended($id: Int!) {
  sampleShipments(where: {id: {_eq: $id}}) {
    archivedAt
    brokerId
    carrier
    createdAt
    isHardcodedCarrier
    createdBy
    deletedAt
    details
    deliveryMethod
    deliveryDate
    id
    officeId
    office {
      id
      name
      address
    }
    pickupDate
    recipientAddressId
    recipientContactId
    recipientCompanyId
    senderAddressId
    senderCompanyId
    senderCompany {
      name
    }
    senderContactId
    senderContact {
      firstname
      lastname
    }
    status
    trackingId
    updatedAt
    senderAddress {
      country
      city
      street1
      street2
      state
      streetNumber
      zipcode
    }
    recipientAddress {
      country
      city
      street1
      street2
      state
      streetNumber
      zipcode
    }
    recipientCompany {
      name
    }
    recipientContact {
      firstname
      lastname
    }
    sampleShipmentRequests {
      itemId
      numberOfSamples
      item {
        id
        alcohol
        appellations
        archivedAt
        brokerId
        localPrice
        currency
        certifications
        comments
        additionalInformations
        uom
        lotNo
        exportIncoterms
        exportIncotermsType
        commodityType
        conditioning
        quantity
        tankNo
        vintages
        varietals
        supplierCompany {
          name
        }
      }
    }
  }
}
    `;
export const UpdateSampleShipmentsByTrackingIdStatusDocument = gql`
    mutation updateSampleShipmentsByTrackingIdStatus($trackingId: String!, $partialObject: sampleShipments_set_input!) {
  update_sampleShipments(
    where: {trackingId: {_eq: $trackingId}}
    _set: $partialObject
  ) {
    affected_rows
  }
}
    `;
export const GetSamplesDocument = gql`
    query GetSamples {
  samples {
    analysisCertificates
    compositionCertificates
    createdAt
    createdBy
    id
    itemId
    updatedAt
    shelf
    sampledBy
    samplePictures
    reminderForExpiration
    officeId
    samplingDate
    commodityType
    sampleShipmentId
    archivedAt
    deletedAt
    ref
  }
}
    `;
export const GetShipmentFulfillmentsDocument = gql`
    query GetShipmentFulfillments {
  shipmentFulfillments {
    agreementId
    archivedAt
    createdAt
    createdBy
    date
    deletedAt
    id
    itemId
    quantity
    status
    updatedAt
    uom
    comments
    files
    currency
    commissionAmount
  }
}
    `;
export const GetTrackingsByTrackingNumberDocument = gql`
    query GetTrackingsByTrackingNumber($trackingNumber: String!) {
  trackings(where: {trackingNumber: {_eq: $trackingNumber}}, limit: 1) {
    aftershipId
    id
    res
    slug
    trackingNumber
    status
  }
}
    `;
export const GetUserByIdDocument = gql`
    query getUserById($id: String!) {
  users_by_pk(id: $id) {
    firstname
    language
    lastname
    id
    isManager
    isAdmin
    officeId
    savedFormFields
    savedColumns
    role
    contactId
    lastReleasesViewDate
    contact {
      companyId
      company {
        officeId
        brokerId
        name
      }
    }
  }
}
    `;
export const InsertUserOneDocument = gql`
    mutation InsertUserOne($user: users_insert_input!) {
  insert_users_one(object: $user) {
    firstname
    language
    lastname
    id
    savedFormFields
    savedColumns
    role
  }
}
    `;
export const UpdateUserByPkDocument = gql`
    mutation UpdateUserByPk($id: String!, $partialUser: users_set_input!) {
  update_users_by_pk(pk_columns: {id: $id}, _set: $partialUser) {
    id
  }
}
    `;
export const GetUsersDocument = gql`
    query GetUsers {
  users {
    firstname
    id
    lastname
    isManager
    isAdmin
    officeId
    role
  }
}
    `;
export const GetUsersBonusDocument = gql`
    query GetUsersBonus {
  usersBonus {
    amount
    currency
    createdAt
    id
    updatedAt
    usersId
    year
  }
}
    `;
export const GetUsersCostsDocument = gql`
    query GetUsersCosts {
  usersCosts {
    amount
    createdAt
    currency
    id
    month
    updatedAt
    usersId
    year
  }
}
    `;
export const GetValidationsContractsDocument = gql`
    query GetValidationsContracts {
  validationsContracts {
    companyId
    contractId
    id
    comments
    createdBy
    status
    createdAt
    updatedAt
    signatoryContactId
    signature
  }
}
    `;
export const GetVarietalsDocument = gql`
    query GetVarietals {
  varietals {
    id
    generic
    subGeneric
    varietal
  }
}
    `;
export const GetVarietalsWithVectorDocument = gql`
    query GetVarietalsWithVector {
  varietals {
    id
    generic
    subGeneric
    varietal
    embedding
    vectorText
  }
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> | AsyncIterable<R>
export function getSdk<C, E>(requester: Requester<C, E>) {
  return {
    GetAdresses(variables?: GetAdressesQueryVariables, options?: C): Promise<GetAdressesQuery> {
      return requester<GetAdressesQuery, GetAdressesQueryVariables>(GetAdressesDocument, variables, options) as Promise<GetAdressesQuery>;
    },
    GetAgreementTerms(variables?: GetAgreementTermsQueryVariables, options?: C): Promise<GetAgreementTermsQuery> {
      return requester<GetAgreementTermsQuery, GetAgreementTermsQueryVariables>(GetAgreementTermsDocument, variables, options) as Promise<GetAgreementTermsQuery>;
    },
    GetAgreements(variables?: GetAgreementsQueryVariables, options?: C): Promise<GetAgreementsQuery> {
      return requester<GetAgreementsQuery, GetAgreementsQueryVariables>(GetAgreementsDocument, variables, options) as Promise<GetAgreementsQuery>;
    },
    GetAgreementsWithStartDate(variables: GetAgreementsWithStartDateQueryVariables, options?: C): Promise<GetAgreementsWithStartDateQuery> {
      return requester<GetAgreementsWithStartDateQuery, GetAgreementsWithStartDateQueryVariables>(GetAgreementsWithStartDateDocument, variables, options) as Promise<GetAgreementsWithStartDateQuery>;
    },
    GetAgreementsWithShipmentFulfillmentsAndInvoices(variables?: GetAgreementsWithShipmentFulfillmentsAndInvoicesQueryVariables, options?: C): Promise<GetAgreementsWithShipmentFulfillmentsAndInvoicesQuery> {
      return requester<GetAgreementsWithShipmentFulfillmentsAndInvoicesQuery, GetAgreementsWithShipmentFulfillmentsAndInvoicesQueryVariables>(GetAgreementsWithShipmentFulfillmentsAndInvoicesDocument, variables, options) as Promise<GetAgreementsWithShipmentFulfillmentsAndInvoicesQuery>;
    },
    GetAppellations(variables?: GetAppellationsQueryVariables, options?: C): Promise<GetAppellationsQuery> {
      return requester<GetAppellationsQuery, GetAppellationsQueryVariables>(GetAppellationsDocument, variables, options) as Promise<GetAppellationsQuery>;
    },
    GetAppellationsWithVector(variables?: GetAppellationsWithVectorQueryVariables, options?: C): Promise<GetAppellationsWithVectorQuery> {
      return requester<GetAppellationsWithVectorQuery, GetAppellationsWithVectorQueryVariables>(GetAppellationsWithVectorDocument, variables, options) as Promise<GetAppellationsWithVectorQuery>;
    },
    GetAuthorizedDomainByName(variables: GetAuthorizedDomainByNameQueryVariables, options?: C): Promise<GetAuthorizedDomainByNameQuery> {
      return requester<GetAuthorizedDomainByNameQuery, GetAuthorizedDomainByNameQueryVariables>(GetAuthorizedDomainByNameDocument, variables, options) as Promise<GetAuthorizedDomainByNameQuery>;
    },
    GetAuthorizedDomains(variables?: GetAuthorizedDomainsQueryVariables, options?: C): Promise<GetAuthorizedDomainsQuery> {
      return requester<GetAuthorizedDomainsQuery, GetAuthorizedDomainsQueryVariables>(GetAuthorizedDomainsDocument, variables, options) as Promise<GetAuthorizedDomainsQuery>;
    },
    GetBuySpecs(variables?: GetBuySpecsQueryVariables, options?: C): Promise<GetBuySpecsQuery> {
      return requester<GetBuySpecsQuery, GetBuySpecsQueryVariables>(GetBuySpecsDocument, variables, options) as Promise<GetBuySpecsQuery>;
    },
    GetCompanies(variables?: GetCompaniesQueryVariables, options?: C): Promise<GetCompaniesQuery> {
      return requester<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, variables, options) as Promise<GetCompaniesQuery>;
    },
    GetCompaniesWithVector(variables?: GetCompaniesWithVectorQueryVariables, options?: C): Promise<GetCompaniesWithVectorQuery> {
      return requester<GetCompaniesWithVectorQuery, GetCompaniesWithVectorQueryVariables>(GetCompaniesWithVectorDocument, variables, options) as Promise<GetCompaniesWithVectorQuery>;
    },
    GetCompanyAdresses(variables?: GetCompanyAdressesQueryVariables, options?: C): Promise<GetCompanyAdressesQuery> {
      return requester<GetCompanyAdressesQuery, GetCompanyAdressesQueryVariables>(GetCompanyAdressesDocument, variables, options) as Promise<GetCompanyAdressesQuery>;
    },
    GetContacts(variables?: GetContactsQueryVariables, options?: C): Promise<GetContactsQuery> {
      return requester<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, variables, options) as Promise<GetContactsQuery>;
    },
    GetContactsWithVector(variables?: GetContactsWithVectorQueryVariables, options?: C): Promise<GetContactsWithVectorQuery> {
      return requester<GetContactsWithVectorQuery, GetContactsWithVectorQueryVariables>(GetContactsWithVectorDocument, variables, options) as Promise<GetContactsWithVectorQuery>;
    },
    GetContactsForGeneratingVector(variables?: GetContactsForGeneratingVectorQueryVariables, options?: C): Promise<GetContactsForGeneratingVectorQuery> {
      return requester<GetContactsForGeneratingVectorQuery, GetContactsForGeneratingVectorQueryVariables>(GetContactsForGeneratingVectorDocument, variables, options) as Promise<GetContactsForGeneratingVectorQuery>;
    },
    GetContracts(variables?: GetContractsQueryVariables, options?: C): Promise<GetContractsQuery> {
      return requester<GetContractsQuery, GetContractsQueryVariables>(GetContractsDocument, variables, options) as Promise<GetContractsQuery>;
    },
    GetExtendedContracts(variables?: GetExtendedContractsQueryVariables, options?: C): Promise<GetExtendedContractsQuery> {
      return requester<GetExtendedContractsQuery, GetExtendedContractsQueryVariables>(GetExtendedContractsDocument, variables, options) as Promise<GetExtendedContractsQuery>;
    },
    GetCurrenciesConversions(variables?: GetCurrenciesConversionsQueryVariables, options?: C): Promise<GetCurrenciesConversionsQuery> {
      return requester<GetCurrenciesConversionsQuery, GetCurrenciesConversionsQueryVariables>(GetCurrenciesConversionsDocument, variables, options) as Promise<GetCurrenciesConversionsQuery>;
    },
    GetHistoryForObject(variables: GetHistoryForObjectQueryVariables, options?: C): Promise<GetHistoryForObjectQuery> {
      return requester<GetHistoryForObjectQuery, GetHistoryForObjectQueryVariables>(GetHistoryForObjectDocument, variables, options) as Promise<GetHistoryForObjectQuery>;
    },
    GetEntitiesUpdated(variables: GetEntitiesUpdatedQueryVariables, options?: C): Promise<GetEntitiesUpdatedQuery> {
      return requester<GetEntitiesUpdatedQuery, GetEntitiesUpdatedQueryVariables>(GetEntitiesUpdatedDocument, variables, options) as Promise<GetEntitiesUpdatedQuery>;
    },
    GetHistoryByUser(variables: GetHistoryByUserQueryVariables, options?: C): Promise<GetHistoryByUserQuery> {
      return requester<GetHistoryByUserQuery, GetHistoryByUserQueryVariables>(GetHistoryByUserDocument, variables, options) as Promise<GetHistoryByUserQuery>;
    },
    GetInvoices(variables?: GetInvoicesQueryVariables, options?: C): Promise<GetInvoicesQuery> {
      return requester<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, variables, options) as Promise<GetInvoicesQuery>;
    },
    GetItems(variables?: GetItemsQueryVariables, options?: C): Promise<GetItemsQuery> {
      return requester<GetItemsQuery, GetItemsQueryVariables>(GetItemsDocument, variables, options) as Promise<GetItemsQuery>;
    },
    GetItemsWithStartDate(variables: GetItemsWithStartDateQueryVariables, options?: C): Promise<GetItemsWithStartDateQuery> {
      return requester<GetItemsWithStartDateQuery, GetItemsWithStartDateQueryVariables>(GetItemsWithStartDateDocument, variables, options) as Promise<GetItemsWithStartDateQuery>;
    },
    GetLogs(variables?: GetLogsQueryVariables, options?: C): Promise<GetLogsQuery> {
      return requester<GetLogsQuery, GetLogsQueryVariables>(GetLogsDocument, variables, options) as Promise<GetLogsQuery>;
    },
    GetMatchingItemsBuySpecs(variables?: GetMatchingItemsBuySpecsQueryVariables, options?: C): Promise<GetMatchingItemsBuySpecsQuery> {
      return requester<GetMatchingItemsBuySpecsQuery, GetMatchingItemsBuySpecsQueryVariables>(GetMatchingItemsBuySpecsDocument, variables, options) as Promise<GetMatchingItemsBuySpecsQuery>;
    },
    GetNotifications(variables?: GetNotificationsQueryVariables, options?: C): Promise<GetNotificationsQuery> {
      return requester<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, variables, options) as Promise<GetNotificationsQuery>;
    },
    GetOffices(variables?: GetOfficesQueryVariables, options?: C): Promise<GetOfficesQuery> {
      return requester<GetOfficesQuery, GetOfficesQueryVariables>(GetOfficesDocument, variables, options) as Promise<GetOfficesQuery>;
    },
    GetReleases(variables?: GetReleasesQueryVariables, options?: C): Promise<GetReleasesQuery> {
      return requester<GetReleasesQuery, GetReleasesQueryVariables>(GetReleasesDocument, variables, options) as Promise<GetReleasesQuery>;
    },
    getRemindersByOfficeId(variables: GetRemindersByOfficeIdQueryVariables, options?: C): Promise<GetRemindersByOfficeIdQuery> {
      return requester<GetRemindersByOfficeIdQuery, GetRemindersByOfficeIdQueryVariables>(GetRemindersByOfficeIdDocument, variables, options) as Promise<GetRemindersByOfficeIdQuery>;
    },
    GetRemindersByObjectId(variables: GetRemindersByObjectIdQueryVariables, options?: C): Promise<GetRemindersByObjectIdQuery> {
      return requester<GetRemindersByObjectIdQuery, GetRemindersByObjectIdQueryVariables>(GetRemindersByObjectIdDocument, variables, options) as Promise<GetRemindersByObjectIdQuery>;
    },
    GetSampleLabels(variables?: GetSampleLabelsQueryVariables, options?: C): Promise<GetSampleLabelsQuery> {
      return requester<GetSampleLabelsQuery, GetSampleLabelsQueryVariables>(GetSampleLabelsDocument, variables, options) as Promise<GetSampleLabelsQuery>;
    },
    GetSampleShipmentRequests(variables?: GetSampleShipmentRequestsQueryVariables, options?: C): Promise<GetSampleShipmentRequestsQuery> {
      return requester<GetSampleShipmentRequestsQuery, GetSampleShipmentRequestsQueryVariables>(GetSampleShipmentRequestsDocument, variables, options) as Promise<GetSampleShipmentRequestsQuery>;
    },
    GetSampleShipments(variables?: GetSampleShipmentsQueryVariables, options?: C): Promise<GetSampleShipmentsQuery> {
      return requester<GetSampleShipmentsQuery, GetSampleShipmentsQueryVariables>(GetSampleShipmentsDocument, variables, options) as Promise<GetSampleShipmentsQuery>;
    },
    GetSampleShipmentExtended(variables: GetSampleShipmentExtendedQueryVariables, options?: C): Promise<GetSampleShipmentExtendedQuery> {
      return requester<GetSampleShipmentExtendedQuery, GetSampleShipmentExtendedQueryVariables>(GetSampleShipmentExtendedDocument, variables, options) as Promise<GetSampleShipmentExtendedQuery>;
    },
    updateSampleShipmentsByTrackingIdStatus(variables: UpdateSampleShipmentsByTrackingIdStatusMutationVariables, options?: C): Promise<UpdateSampleShipmentsByTrackingIdStatusMutation> {
      return requester<UpdateSampleShipmentsByTrackingIdStatusMutation, UpdateSampleShipmentsByTrackingIdStatusMutationVariables>(UpdateSampleShipmentsByTrackingIdStatusDocument, variables, options) as Promise<UpdateSampleShipmentsByTrackingIdStatusMutation>;
    },
    GetSamples(variables?: GetSamplesQueryVariables, options?: C): Promise<GetSamplesQuery> {
      return requester<GetSamplesQuery, GetSamplesQueryVariables>(GetSamplesDocument, variables, options) as Promise<GetSamplesQuery>;
    },
    GetShipmentFulfillments(variables?: GetShipmentFulfillmentsQueryVariables, options?: C): Promise<GetShipmentFulfillmentsQuery> {
      return requester<GetShipmentFulfillmentsQuery, GetShipmentFulfillmentsQueryVariables>(GetShipmentFulfillmentsDocument, variables, options) as Promise<GetShipmentFulfillmentsQuery>;
    },
    GetTrackingsByTrackingNumber(variables: GetTrackingsByTrackingNumberQueryVariables, options?: C): Promise<GetTrackingsByTrackingNumberQuery> {
      return requester<GetTrackingsByTrackingNumberQuery, GetTrackingsByTrackingNumberQueryVariables>(GetTrackingsByTrackingNumberDocument, variables, options) as Promise<GetTrackingsByTrackingNumberQuery>;
    },
    getUserById(variables: GetUserByIdQueryVariables, options?: C): Promise<GetUserByIdQuery> {
      return requester<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, variables, options) as Promise<GetUserByIdQuery>;
    },
    InsertUserOne(variables: InsertUserOneMutationVariables, options?: C): Promise<InsertUserOneMutation> {
      return requester<InsertUserOneMutation, InsertUserOneMutationVariables>(InsertUserOneDocument, variables, options) as Promise<InsertUserOneMutation>;
    },
    UpdateUserByPk(variables: UpdateUserByPkMutationVariables, options?: C): Promise<UpdateUserByPkMutation> {
      return requester<UpdateUserByPkMutation, UpdateUserByPkMutationVariables>(UpdateUserByPkDocument, variables, options) as Promise<UpdateUserByPkMutation>;
    },
    GetUsers(variables?: GetUsersQueryVariables, options?: C): Promise<GetUsersQuery> {
      return requester<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, variables, options) as Promise<GetUsersQuery>;
    },
    GetUsersBonus(variables?: GetUsersBonusQueryVariables, options?: C): Promise<GetUsersBonusQuery> {
      return requester<GetUsersBonusQuery, GetUsersBonusQueryVariables>(GetUsersBonusDocument, variables, options) as Promise<GetUsersBonusQuery>;
    },
    GetUsersCosts(variables?: GetUsersCostsQueryVariables, options?: C): Promise<GetUsersCostsQuery> {
      return requester<GetUsersCostsQuery, GetUsersCostsQueryVariables>(GetUsersCostsDocument, variables, options) as Promise<GetUsersCostsQuery>;
    },
    GetValidationsContracts(variables?: GetValidationsContractsQueryVariables, options?: C): Promise<GetValidationsContractsQuery> {
      return requester<GetValidationsContractsQuery, GetValidationsContractsQueryVariables>(GetValidationsContractsDocument, variables, options) as Promise<GetValidationsContractsQuery>;
    },
    GetVarietals(variables?: GetVarietalsQueryVariables, options?: C): Promise<GetVarietalsQuery> {
      return requester<GetVarietalsQuery, GetVarietalsQueryVariables>(GetVarietalsDocument, variables, options) as Promise<GetVarietalsQuery>;
    },
    GetVarietalsWithVector(variables?: GetVarietalsWithVectorQueryVariables, options?: C): Promise<GetVarietalsWithVectorQuery> {
      return requester<GetVarietalsWithVectorQuery, GetVarietalsWithVectorQueryVariables>(GetVarietalsWithVectorDocument, variables, options) as Promise<GetVarietalsWithVectorQuery>;
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;